/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 68);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(75);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createGlobalStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* unused harmony export isStyledComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyframes; });
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetConsumer */
/* unused harmony export StyleSheetContext */
/* unused harmony export StyleSheetManager */
/* unused harmony export ThemeConsumer */
/* unused harmony export ThemeContext */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_memoize_one__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_merge_anything__ = __webpack_require__(93);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_DECORATORS":"true;","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_SASS":"false;","REACT_APP_LESS":"false;","REACT_APP_STYLUS":"false;","REACT_APP_CSS_MODULES":"true;","REACT_APP_SASS_MODULES":"false;","REACT_APP_STYLUS_MODULES":"false;","REACT_APP_LESS_MODULES":"false;","REACT_APP_WEBPACK_DASHBOARD":"true;"}).REACT_APP_SC_ATTR || Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_DECORATORS":"true;","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_SASS":"false;","REACT_APP_LESS":"false;","REACT_APP_STYLUS":"false;","REACT_APP_CSS_MODULES":"true;","REACT_APP_SASS_MODULES":"false;","REACT_APP_STYLUS_MODULES":"false;","REACT_APP_LESS_MODULES":"false;","REACT_APP_WEBPACK_DASHBOARD":"true;"}).SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_DECORATORS":"true;","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_SASS":"false;","REACT_APP_LESS":"false;","REACT_APP_STYLUS":"false;","REACT_APP_CSS_MODULES":"true;","REACT_APP_SASS_MODULES":"false;","REACT_APP_STYLUS_MODULES":"false;","REACT_APP_LESS_MODULES":"false;","REACT_APP_WEBPACK_DASHBOARD":"true;"}).REACT_APP_SC_DISABLE_SPEEDY || Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_DECORATORS":"true;","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_SASS":"false;","REACT_APP_LESS":"false;","REACT_APP_STYLUS":"false;","REACT_APP_CSS_MODULES":"true;","REACT_APP_SASS_MODULES":"false;","REACT_APP_STYLUS_MODULES":"false;","REACT_APP_LESS_MODULES":"false;","REACT_APP_WEBPACK_DASHBOARD":"true;"}).SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = tag.ownerDocument.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = tag.ownerDocument.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var targetDocument = document;
  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;

  var el = targetDocument.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.4.1");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(targetDocument.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    // $FlowFixMe
    if (el.isConnected === false) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(targetDocument, id) {
  return targetDocument.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(el.ownerDocument, id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(el.ownerDocument, id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in __WEBPACK_IMPORTED_MODULE_3__emotion_unitless__["a" /* default */])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {
        // eslint-disable-next-line no-console
        console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
      }

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = "production" === 'production' && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[__WEBPACK_IMPORTED_MODULE_4_react_is__["ForwardRef"]] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      this.props.children
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_5_memoize_one__["a" /* default */])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? React.Children.only(children) : children
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".', '\n ' + new Error().stack)
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.props, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || Object(__WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__["a" /* default */])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? Object(__WEBPACK_IMPORTED_MODULE_8_merge_anything__["a" /* default */])(target.defaultProps, obj) : obj;
    }
  });

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {
          // eslint-disable-next-line no-console
          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + getComponentName(Component$$1) + '"');
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

/* harmony default export */ __webpack_exports__["c"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return untracked; });
/* unused harmony export IDerivationState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return spy; });
/* unused harmony export comparer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isObservableObject; });
/* unused harmony export isBoxedObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isObservableArray; });
/* unused harmony export ObservableMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isObservableMap; });
/* unused harmony export transaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return computed; });
/* unused harmony export isObservable */
/* unused harmony export isObservableProp */
/* unused harmony export isComputed */
/* unused harmony export isComputedProp */
/* unused harmony export extendObservable */
/* unused harmony export extendShallowObservable */
/* unused harmony export observe */
/* unused harmony export intercept */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return autorun; });
/* unused harmony export reaction */
/* unused harmony export when */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return action; });
/* unused harmony export isAction */
/* unused harmony export runInAction */
/* unused harmony export keys */
/* unused harmony export values */
/* unused harmony export entries */
/* unused harmony export set */
/* unused harmony export remove */
/* unused harmony export has */
/* unused harmony export get */
/* unused harmony export decorate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return configure; });
/* unused harmony export onBecomeObserved */
/* unused harmony export onBecomeUnobserved */
/* unused harmony export flow */
/* unused harmony export toJS */
/* unused harmony export trace */
/* unused harmony export getDependencyTree */
/* unused harmony export getObserverTree */
/* unused harmony export _resetGlobalState */
/* unused harmony export _getGlobalState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDebugName; });
/* unused harmony export getAtom */
/* unused harmony export _getAdministration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allowStateChanges; });
/* unused harmony export isArrayLike */
/* unused harmony export _isComputingDerivation */
/* unused harmony export onReactionError */
/* unused harmony export _interceptReads */
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

















function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance(target) {
    if (target.__mobxDidRunLazyInitializers === true)
        return;
    var decorators = target.__mobxDecorators;
    if (decorators) {
        addHiddenProp(target, "__mobxDidRunLazyInitializers", true);
        for (var key in decorators) {
            var d = decorators[key];
            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false)
                fail$1("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                var inheritedDecorators = target.__mobxDecorators;
                addHiddenProp(target, "__mobxDecorators", __assign({}, inheritedDecorators));
            }
            target.__mobxDecorators[prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
        (args.length === 4 && args[3] === true));
}

function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = __assign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(__assign({}, change, { spyReportEnd: true }));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
    });
}

function createAction(actionName, fn) {
    if (false) {
        invariant(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName)
            fail$1("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}

function dontReassignFields() {
    fail$1("production" !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {
                return fail$1("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        arg1[arg2] = createAction(arg1.name || arg2, arg3.value);
    }
    else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    // TODO: deprecate?
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {
        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName)
            fail$1("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys$$1 = Object.keys(a), key;
        length = keys$$1.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys$$1[length];
            if (!(has$$1(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isES6Map(a) || isObservableMap(a))
        return iteratorToArray(a.entries());
    return a;
}
function has$$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (false) {
        invariant(typeof view === "function", "Autorun expects a function as first argument");
        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed)
                        reaction.track(reactionRunner);
                });
            }
        }, opts.onError);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay ? function (f) { return setTimeout(f, opts.delay); } : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT; }
    if (typeof opts === "boolean") {
        opts = { fireImmediately: opts };
        deprecated("Using fireImmediately as argument is deprecated. Use '{ fireImmediately: true }' instead");
    }
    if (false) {
        invariant(typeof expression === "function", "First argument to reaction should be a function");
        invariant(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer.structural
        : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        var _this = this;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        if (false)
            return fail$1("missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set)
            this.setter = createAction(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer.structural
                    : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        if (options.keepAlive === true) {
            // dangerous: never exposed, so this cmputed value should not depend on observables
            // that live globally, or it will never get disposed! (nor anything attached to it)
            autorun(function () { return _this.get(); });
        }
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () { };
    ComputedValue.prototype.onBecomeObserved = function () { };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing)
            fail$1("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.length === 0) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "production" !== "production" &&
                "[ComputedValue '" + this
                    .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        clearObserving(this);
        this.value = undefined; // don't hold on to computed value!
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true)
            return;
        if (this.requiresReaction === true) {
            fail$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this
                .name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this
                .name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var UNCHANGED = {};
declareAtom();
var ObservableValue = /** @class */ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(Atom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

var ObservableObjectAdministration = /** @class */ (function () {
    function ObservableObjectAdministration(target, name, defaultEnhancer) {
        this.target = target;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.values = {};
    }
    ObservableObjectAdministration.prototype.read = function (owner, key) {
        if ("production" === "production" && this.target !== owner) {
            this.illegalAccess(owner, key);
            if (!this.values[key])
                return undefined;
        }
        return this.values[key].get();
    };
    ObservableObjectAdministration.prototype.write = function (owner, key, newValue) {
        var instance = this.target;
        if ("production" === "production" && instance !== owner) {
            this.illegalAccess(owner, key);
        }
        var observable = this.values[key];
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: instance,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values[key])
            return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldValue = this.values[key].get();
            if (this.keys)
                this.keys.remove(key);
            delete this.values[key];
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
        finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var _this = this;
        if (this.keys === undefined) {
            this.keys = new ObservableArray(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue; }), referenceEnhancer, "keys(" + this.name + ")", true);
        }
        return this.keys.slice();
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
    var adm = target.$mobx;
    if (adm)
        return adm;
    "production" !== "production" &&
        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    adm = new ObservableObjectAdministration(target, name, defaultEnhancer);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservableProperty(target, propName, newValue, enhancer) {
    var adm = asObservableObject(target);
    assertPropertyConfigurable(target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(target, propName, generateObservablePropConfig(propName));
    if (adm.keys)
        adm.keys.push(propName);
    notifyPropertyAddition(adm, target, propName, newValue);
}
function defineComputedProperty(target, // which objects holds the observable and provides `this` context?
propName, options) {
    var adm = asObservableObject(target);
    options.name = adm.name + "." + propName;
    options.context = target;
    adm.values[propName] = new ComputedValue(options);
    Object.defineProperty(target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.read(this, propName);
            },
            set: function (v) {
                this.$mobx.write(this, propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner.$mobx;
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner.$mobx;
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(this, propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(this, propName, v);
            }
        }));
}
function notifyPropertyAddition(adm, object, key, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: key,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(__assign({}, change, { name: adm.name, key: key }));
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

function createDecoratorForEnhancer(enhancer) {
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {
            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
        }
        var initialValue = descriptor
            ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value
            : undefined;
        defineObservableProperty(target, propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_DECORATORS":"true;","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_SASS":"false;","REACT_APP_LESS":"false;","REACT_APP_STYLUS":"false;","REACT_APP_CSS_MODULES":"true;","REACT_APP_SASS_MODULES":"false;","REACT_APP_STYLUS_MODULES":"false;","REACT_APP_LESS_MODULES":"false;","REACT_APP_WEBPACK_DASHBOARD":"true;"}) && "production" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (false)
            return fail$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function isObservable(value) {
    if (arguments.length !== 1)
        fail$1("production" !== "production" &&
            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string")
        return fail$1("production" !== "production" && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function _isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1)
        return fail$1("production" !== "production" &&
            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string")
        return fail$1("production" !== "production" &&
            "isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    var options = decoratorArgs[0] || {};
    defineComputedProperty(instance, propertyName, __assign({ get: get, set: set }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {
        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

function extendShallowObservable(target, properties, decorators) {
    deprecated("'extendShallowObservable' is deprecated, use 'extendObservable(target, props, { deep: false })' instead");
    return extendObservable(target, properties, decorators, shallowCreateObservableOptions);
}
function extendObservable(target, properties, decorators, options) {
    if (false) {
        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators)
            for (var key in decorators)
                if (!(key in properties))
                    fail$1("Trying to declare a decorator for unspecified property '" + key + "'");
    }
    options = asCreateObservableOptions(options);
    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    startBatch();
    try {
        for (var key in properties) {
            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
            if (false) {
                if (Object.getOwnPropertyDescriptor(target, key))
                    fail$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
                if (isComputed(descriptor.value))
                    fail$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
            }
            var decorator = decorators && key in decorators
                ? decorators[key]
                : descriptor.get ? computedDecorator : defaultDecorator;
            if (false)
                return fail$1("Not a valid decorator for '" + key + "', got: " + decorator);
            var resultDescriptor = decorator(target, key, descriptor, true);
            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
            )
                Object.defineProperty(target, key, resultDescriptor);
        }
    }
    finally {
        endBatch();
    }
    return target;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
var shallowCreateObservableOptions = {
    deep: false,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze(defaultCreateObservableOptions);
Object.freeze(shallowCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|defaultDecorator)$/.test(key))
        fail$1("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions;
    if (typeof thing === "string")
        return { name: thing, deep: true };
    if (false) {
        if (typeof thing !== "object")
            return fail$1("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false ? referenceEnhancer : deepEnhancer;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v)
        ? observable.object(v, arg2, arg3)
        : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail$1("production" !== "production" &&
        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        deprecated("observable.shallowBox", "observable.box(value, { deep: false })");
        return observable.box(value, { name: name, deep: false });
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return new ObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        deprecated("observable.shallowArray", "observable.array(values, { deep: false })");
        return observable.array(initialValues, { name: name, deep: false });
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        deprecated("observable.shallowMap", "observable.map(values, { deep: false })");
        return observable.map(initialValues, { name: name, deep: false });
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        return extendObservable({}, props, decorators, o);
    },
    shallowObject: function (props, name) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("shallowObject");
        deprecated("observable.shallowObject", "observable.object(values, {}, { deep: false })");
        return observable.object(props, {}, { name: name, deep: false });
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail$1(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, { name: name });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name });
    if (isES6Map(v))
        return observable.map(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v))
        return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v))
        return observable.map(v, { name: name, deep: false });
    return fail$1("production" !== "production" &&
        "The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false)
        throw "observable.struct should not be used with observable values";
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}

function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}

function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}
function makeIterable(iterator) {
    iterator[iteratorSymbol()] = self;
    return iterator;
}
function self() {
    return this;
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}

var ObservableMapMarker = {};
var ObservableMap = /** @class */ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer; }
        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        if (this._hasMap.has(key))
            return this._hasMap.get(key).get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
            this._hasMap.set(key, entry);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(__assign({}, change, { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + key, false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keys.push(key);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.name, key: key }));
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return this._keys[iteratorSymbol()]();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable({
            next: function () {
                return nextIndex < self._keys.length
                    ? { value: self.get(self._keys[nextIndex++]), done: false }
                    : { value: undefined, done: true };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable({
            next: function () {
                if (nextIndex < self._keys.length) {
                    var key = self._keys[nextIndex++];
                    return {
                        value: [key, self.get(key)],
                        done: false
                    };
                }
                return { done: true };
            }
        });
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this._keys.forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail$1("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this._keys.slice().forEach(function (key) { return _this.delete(key); });
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this._keys;
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var _this = this;
        var res = {};
        this._keys.forEach(function (key) { return (res["" + key] = _this.get(key)); });
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = new Map();
        this._keys.forEach(function (key) { return res.set(key, _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this._keys.map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        "production" !== "production" &&
            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
addHiddenFinalProp(ObservableMap.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Map");
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined)
                fail$1("production" !== "production" &&
                    "It is not possible to get index atoms from arrays");
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable)
                fail$1("production" !== "production" &&
                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property)
                return fail$1("production" !== "production" && "please specify a property");
            var observable = thing.$mobx.values[property];
            if (!observable)
                fail$1("production" !== "production" &&
                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail$1("production" !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    if (!thing)
        fail$1("Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing.$mobx)
        return thing.$mobx;
    fail$1("production" !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg2 === "string" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg2 === "string" ? arg3 : arg2;
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail$1("production" !== "production" && "Not an atom that can be (un)observed");
    atom[hook] = function () {
        orig.call(this);
        cb.call(this);
    };
    return function () {
        atom[hook] = orig;
    };
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var Atom;
var isAtom;
function declareAtom() {
    if (Atom)
        return;
    Atom = /** @class */ (function () {
        /**
         * Create a new atom. For debugging purposes it is recommended to give it a name.
         * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
         */
        function AtomImpl(name) {
            if (name === void 0) { name = "Atom@" + getNextId(); }
            this.name = name;
            this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
            this.isBeingObserved = false;
            this.observers = [];
            this.observersIndexes = {};
            this.diffValue = 0;
            this.lastAccessedBy = 0;
            this.lowestObserverState = IDerivationState.NOT_TRACKING;
        }
        AtomImpl.prototype.onBecomeUnobserved = function () {
            // noop
        };
        AtomImpl.prototype.onBecomeObserved = function () {
            /* noop */
        };
        /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
        AtomImpl.prototype.reportObserved = function () {
            return reportObserved(this);
        };
        /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
        AtomImpl.prototype.reportChanged = function () {
            startBatch();
            propagateChanged(this);
            endBatch();
        };
        AtomImpl.prototype.toString = function () {
            return this.name;
        };
        return AtomImpl;
    }());
    isAtom = createInstanceofPredicate("Atom", Atom);
}
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
    var atom = new Atom(name);
    onBecomeObserved(atom, onBecomeObservedHandler);
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /** @class */ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && this.values.length > 0)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems =
            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /** @class */ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.find fromIndex argument to find will not be supported anymore in the next major");
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        deprecated("observableArray.move is deprecated, use .slice() & .replace() instead");
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = __spread(oldItems.slice(0, toIndex), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    
    this.$mobx.atom.reportObserved();
    var self = this;
    var nextIndex = 0;
    return makeIterable({
        next: function () {
            return nextIndex < self.length
                ? { value: self[nextIndex++], done: false }
                : { done: true, value: undefined };
        }
    });
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
    addHiddenProp(ObservableArray.prototype, typeof Symbol !== "undefined" ? Symbol.toStringTag : "@@toStringTag", "Array");
}
// Internet Explorer on desktop doesn't support this.....
// So, let's don't do this to avoid different semantics
// See #1395
// addHiddenProp(
//     ObservableArray.prototype,
//     typeof Symbol !== "undefined" ? Symbol.isConcatSpreadable as any : "@@isConcatSpreadable",
//     {
//         enumerable: false,
//         configurable: true,
//         value: true
//     }
// )
/**
 * Wrap function from prototype
 */

[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}

var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail$1(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true)
        return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    if (false)
        fail$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map) {
    if (isPlainObject(map))
        return Object.keys(map);
    if (Array.isArray(map))
        return map.map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
    if (isES6Map(map) || isObservableMap(map))
        return iteratorToArray(map.keys());
    return fail$1("Cannot get keys from '" + map + "'");
}
// use Array.from in Mobx 5
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "disableErrorBoundaries",
    "runId"
];
var MobXGlobals = /** @class */ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var runInIsolationCalled = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!runInIsolationCalled) {
                fail$1("production" !== "production" &&
                    "There are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable.observers.length === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd(prevUntracked);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail$1("production" !== "production" &&
            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers$$1 || globalState.enforceActions === "strict"))
        fail$1("production" !== "production" &&
            (globalState.enforceActions
                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
                atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail$1("production" !== "production" &&
            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

var Reaction = /** @class */ (function () {
    function Reaction(name, onInvalidate, errorHandler) {
        if (name === void 0) { name = "Reaction@" + getNextId(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled()) {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        console.error(message, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer.$mobx.isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false)
        return fail$1("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj.$mobx.getKeys();
    }
    if (isObservableMap(obj)) {
        return obj._keys.slice();
    }
    return fail$1("production" !== "production" &&
        "'keys()' can only be used on observable objects and maps");
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail$1("production" !== "production" &&
        "'values()' can only be used on observable objects, arrays and maps");
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail$1("production" !== "production" &&
        "'entries()' can only be used on observable objects, arrays and maps");
}
function set(obj, key, value) {
    if (arguments.length === 2) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj.$mobx;
        var existingObservable = adm.values[key];
        if (existingObservable) {
            adm.write(obj, key, value);
        }
        else {
            defineObservableProperty(obj, key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap(obj)) {
        obj.set(key, value);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch();
    }
    else {
        return fail$1("production" !== "production" &&
            "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        
        obj.$mobx.remove(key);
    }
    else if (isObservableMap(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail$1("production" !== "production" &&
            "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has$1(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        adm.getKeys(); // make sure we get notified of key changes, but for performance, use the values map to look up existence
        return adm.values[key] instanceof ObservableValue;
    }
    else if (isObservableMap(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail$1("production" !== "production" &&
            "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get(obj, key) {
    if (!has$1(obj, key))
        return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    }
    else if (isObservableMap(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray(obj)) {
        return obj[key];
    }
    else {
        return fail$1("production" !== "production" &&
            "'get()' can only be used on observable objects, arrays and maps");
    }
}

function decorate(thing, decorators) {
    "production" !== "production" &&
        invariant(isPlainObject(decorators), "Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    for (var prop in decorators) {
        var decorator = decorators[prop];
        "production" !== "production" &&
            invariant(typeof decorator === "function", "Decorate: expected a decorator function for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = decorator(target, prop, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    }
    return thing;
}

function configure(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler;
    if (enforceActions !== undefined) {
        if (typeof enforceActions !== "boolean" && enforceActions !== "strict")
            return fail("Invalid configuration for 'enforceActions': " + enforceActions);
        globalState.enforceActions = enforceActions;
        globalState.allowStateChanges =
            enforceActions === true || enforceActions === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (typeof arrayBuffer === "number") {
        reserveArrayBuffer(arrayBuffer);
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

var generatorId = 0;
function flow(generator) {
    if (arguments.length !== 1)
        fail$1("production" && "Flow expects one 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var res = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        res.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res_1 = gen.return();
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res_1.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new Error("FLOW_CANCELLED"));
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return res;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!isObservable(source))
        return source;
    var detectCycles = options.detectCycles === true;
    if (detectCycles &&
        source !== null &&
        typeof source === "object" &&
        __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res[i] = toAdd[i];
        return res;
    }
    if (isObservableObject(source)) {
        var res = cache(__alreadySeen, source, {}, options);
        keys(source); // make sure we track the keys of the object
        for (var key in source) {
            res[key] = toJSHelper(source[key], options, __alreadySeen);
        }
        return res;
    }
    if (isObservableMap(source)) {
        if (options.exportMapsAsObjects === false) {
            var res_1 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_1.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_1;
        }
        else {
            var res_2 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_2[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_2;
        }
    }
    if (isObservableValue(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    return source;
}
function toJS(source, options) {
    if (!isObservable(source))
        return source;
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    var detectCycles = options.detectCycles === true;
    var __alreadySeen;
    if (detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail$1("production" !== "production" &&
                "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail$1("production" !== "production" &&
            "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail$1("production" !== "production" && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
}
catch (e) {
    var g = typeof window !== "undefined" ? window : global;
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}

(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        "production" !== "production") {
        console.warn("[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
// This line should come after all the imports as well, for the same reason
// as noted above. I will file a bug with rollupjs - @rossipedia
// Devtools support
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        }
    });
}
// TODO: remove in some future build
if (false) {
    var warnedAboutDefaultExport_1 = false;
    Object.defineProperty(module.exports, "default", {
        enumerable: false,
        get: function () {
            if (!warnedAboutDefaultExport_1) {
                warnedAboutDefaultExport_1 = true;
                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
            }
            return undefined;
        }
    });
    [
        "extras",
        "Atom",
        "BaseAtom",
        "asFlat",
        "asMap",
        "asReference",
        "asStructure",
        "autorunAsync",
        "createTranformer",
        "expr",
        "isModifierDescriptor",
        "isStrictModeEnabled",
        "map",
        "useStrict",
        "whyRun"
    ].forEach(function (prop) {
        Object.defineProperty(module.exports, prop, {
            enumerable: false,
            get: function () {
                fail$1("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
            },
            set: function () { }
        });
    });
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18), __webpack_require__(10)))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getMedia;
var media={optimal:'(min-width: 1700px)',compact:'(min-width: 901px) and (max-width: 1699px)',//max 1599?
mobile:'(max-width: 900px)',smallphone:'(max-width: 350px)'};function getMedia(){if(window.matchMedia(media.optimal).matches)return'optimal';else if(window.matchMedia(media.compact).matches)return'compact';else if(window.matchMedia(media.mobile).matches)return'mobile';}/* harmony default export */ __webpack_exports__["a"] = (media);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export propTypes */
/* unused harmony export PropTypes */
/* unused harmony export onError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observer; });
/* unused harmony export Observer */
/* unused harmony export renderReporter */
/* unused harmony export componentByNodeRegistery */
/* unused harmony export componentByNodeRegistry */
/* unused harmony export trackComponents */
/* unused harmony export useStaticRendering */
/* unused harmony export Provider */
/* unused harmony export inject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




// These functions can be stubbed out in specific environments
var unstable_batchedUpdates$1 = undefined;

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
    module.exports = factory();
}(commonjsGlobal, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();









var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var EventEmitter = function () {
    function EventEmitter() {
        classCallCheck(this, EventEmitter);
        this.listeners = [];
    }

    createClass(EventEmitter, [{
        key: "on",
        value: function on(cb) {
            var _this = this;

            this.listeners.push(cb);
            return function () {
                var index = _this.listeners.indexOf(cb);
                if (index !== -1) _this.listeners.splice(index, 1);
            };
        }
    }, {
        key: "emit",
        value: function emit(data) {
            this.listeners.forEach(function (fn) {
                return fn(data);
            });
        }
    }]);
    return EventEmitter;
}();

// Copied from React.PropTypes
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
            rest[_key - 6] = arguments[_key];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["n" /* untracked */])(function () {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else {
                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
            }
        });
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}

// Copied from React.PropTypes
function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") {
        return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") {
        return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
    }

    return false;
}

// Copied from React.PropTypes
function getPropType(propValue) {
    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
    if (Array.isArray(propValue)) {
        return "array";
    }
    if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
    }
    if (isSymbol(propType, propValue)) {
        return "symbol";
    }
    return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function getPreciseType(propValue) {
    var propType = getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) {
            return "date";
        } else if (propValue instanceof RegExp) {
            return "regexp";
        }
    }
    return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["n" /* untracked */])(function () {
            if (allowNativeType) {
                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker = void 0;
            switch (mobxType) {
                case "Array":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["i" /* isObservableArray */];
                    break;
                case "Object":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["k" /* isObservableObject */];
                    break;
                case "Map":
                    mobxChecker = __WEBPACK_IMPORTED_MODULE_0_mobx__["j" /* isObservableMap */];
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
            rest[_key2 - 5] = arguments[_key2];
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["n" /* untracked */])(function () {
            if (typeof typeChecker !== "function") {
                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            }
            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
            if (error instanceof Error) return error;
            var propValue = props[propName];
            for (var i = 0; i < propValue.length; i++) {
                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
                if (error instanceof Error) return error;
            }
            return null;
        });
    });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");



var propTypes = Object.freeze({
	observableArray: observableArray,
	observableArrayOf: observableArrayOf,
	observableMap: observableMap,
	observableObject: observableObject,
	arrayOrObservableArray: arrayOrObservableArray,
	arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render);
}

var injectorContextTypes = {
    mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);

var proxiedInjectorProps = {
    contextTypes: {
        get: function get$$1() {
            return injectorContextTypes;
        },
        set: function set$$1(_) {
            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
        },
        configurable: true,
        enumerable: false
    },
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }

    /**
     * Store Injection
     */
};function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp2;

    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
    if (injectNames) displayName += "-with-" + injectNames;

    var Injector = (_temp2 = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            var _ref;

            var _temp, _this, _ret;

            classCallCheck(this, Injector);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
                _this.wrappedInstance = instance;
            }, _temp), possibleConstructorReturn(_this, _ret);
        }

        createClass(Injector, [{
            key: "render",
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key2 in additionalProps) {
                    newProps[_key2] = additionalProps[_key2];
                }

                if (!isStateless(component)) {
                    newProps.ref = this.storeRef;
                }

                return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = displayName, _temp2);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === "function") {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // supress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
        };
    }
}

/**
 * dev tool support
 */
var isDevtoolsEnabled = false;

var isUsingStaticRendering = false;

var warnedAboutObserverInjectDeprecation = false;

// WeakMap<Node, Object>;
var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();

function findDOMNode$2(component) {
    if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
        try {
            return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
        } catch (e) {
            // findDOMNode will throw in react-test-renderer, see:
            // See https://github.com/mobxjs/mobx-react/issues/216
            // Is there a better heuristic?
            return null;
        }
    }
    return null;
}

function reportRendering(component) {
    var node = findDOMNode$2(component);
    if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);

    renderReporter.emit({
        event: "render",
        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
        totalTime: Date.now() - component.__$mobRenderStart,
        component: component,
        node: node
    });
}

function trackComponents() {
    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
}

function is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) {
        return x !== 0 || 1 / x === 1 / y;
    } else {
        return x !== x && y !== y;
    }
}

function makeComponentReactive(render) {
    var _this2 = this;

    if (isUsingStaticRendering === true) return render.call(this);

    function makePropertyObservableReference(propName) {
        var valueHolder = this[propName];
        var atom = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["g" /* createAtom */])("reactive " + propName);
        Object.defineProperty(this, propName, {
            configurable: true,
            enumerable: true,
            get: function get$$1() {
                atom.reportObserved();
                return valueHolder;
            },
            set: function set$$1(v) {
                if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
                    valueHolder = v;
                    skipRender = true;
                    atom.reportChanged();
                    skipRender = false;
                } else {
                    valueHolder = v;
                }
            }
        });
    }

    function reactiveRender() {
        var _this = this;

        isRenderingPending = false;
        var exception = undefined;
        var rendering = undefined;
        reaction.track(function () {
            if (isDevtoolsEnabled) {
                _this.__$mobRenderStart = Date.now();
            }
            try {
                rendering = Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["b" /* _allowStateChanges */])(false, baseRender);
            } catch (e) {
                exception = e;
            }
            if (isDevtoolsEnabled) {
                _this.__$mobRenderEnd = Date.now();
            }
        });
        if (exception) {
            errorsReporter.emit(exception);
            throw exception;
        }
        return rendering;
    }

    // Generate friendly name for debugging
    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;
    /**
     * If props are shallowly modified, react will render anyway,
     * so atom.reportChanged() should not result in yet another re-render
     */
    var skipRender = false;
    /**
     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
     * so detect these changes
     */
    var isForcingUpdate = false;

    // make this.props an observable reference, see #124
    makePropertyObservableReference.call(this, "props");
    // make state an observable reference
    makePropertyObservableReference.call(this, "state");

    // wire up reactive render
    var baseRender = render.bind(this);
    var isRenderingPending = false;

    var reaction = new __WEBPACK_IMPORTED_MODULE_0_mobx__["a" /* Reaction */](initialName + "#" + rootNodeID + ".render()", function () {
        if (!isRenderingPending) {
            // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
            // This unidiomatic React usage but React will correctly warn about this so we continue as usual
            // See #85 / Pull #44
            isRenderingPending = true;
            if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?
            if (_this2.__$mobxIsUnmounted !== true) {
                // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                // However, people also claim this migth happen during unit tests..
                var hasError = true;
                try {
                    isForcingUpdate = true;
                    if (!skipRender) __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.forceUpdate.call(_this2);
                    hasError = false;
                } finally {
                    isForcingUpdate = false;
                    if (hasError) reaction.dispose();
                }
            }
        }
    });
    reaction.reactComponent = this;
    reactiveRender.$mobx = reaction;
    this.render = reactiveRender;
    return reactiveRender.call(this);
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) return;
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
        if (isDevtoolsEnabled) {
            var node = findDOMNode$2(this);
            if (node && componentByNodeRegistry) {
                componentByNodeRegistry.delete(node);
            }
            renderReporter.emit({
                event: "destroy",
                component: this,
                node: node
            });
        }
    },

    componentDidMount: function componentDidMount() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    componentDidUpdate: function componentDidUpdate() {
        if (isDevtoolsEnabled) {
            reportRendering(this);
        }
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return !shallowEqual(this.props, nextProps);
    }

    /**
     * Observer function / decorator
     */
};function observer(arg1, arg2) {
    if (typeof arg1 === "string") {
        throw new Error("Store names should be provided as array");
    }
    if (Array.isArray(arg1)) {
        // TODO: remove in next major
        // component needs stores
        if (!warnedAboutObserverInjectDeprecation) {
            warnedAboutObserverInjectDeprecation = true;
            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
        }
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return observer(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(observer(arg2));
        }
    }
    var componentClass = arg1;

    if (componentClass.isMobxInjector === true) {
        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
    }
    if (componentClass.__proto__ === __WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]) {
        console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
    }

    // Stateless function component:
    // If it is function but doesn't seem to be a react class constructor,
    // wrap it to a react class automatically
    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_1_react__["Component"].isPrototypeOf(componentClass)) {
        var _class, _temp;

        var observerComponent = observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: "render",
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
        hoistNonReactStatics(observerComponent, componentClass);
        return observerComponent;
    }

    if (!componentClass) {
        throw new Error("Please pass a valid component to 'observer'");
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    var baseRender = target.render;
    target.render = function () {
        return makeComponentReactive.call(this, baseRender);
    };
    return componentClass;
}

function mixinLifecycleEvents(target) {
    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
        patch(target, funcName);
    });
    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    } else {
        // TODO: make throw in next major
        console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
    }
}

var Observer = observer(function (_ref) {
    var children = _ref.children,
        observerInject = _ref.inject,
        render = _ref.render;

    var component = children || render;
    if (typeof component === "undefined") {
        return null;
    }
    if (!observerInject) {
        return component();
    }
    // TODO: remove in next major
    console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
    var InjectComponent = inject(observerInject)(component);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InjectComponent, null);
});

Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
    }

    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
        return;
    }
    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
    render: ObserverPropsCheck,
    children: ObserverPropsCheck
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(nextProps, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component$$1;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName =
      typeof Component$$1.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var _class;
var _temp;

var specialReactKeys = { children: true, key: true, ref: true };

var Provider = (_temp = _class = function (_Component) {
    inherits(Provider, _Component);

    function Provider(props, context) {
        classCallCheck(this, Provider);

        var _this = possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).call(this, props, context));

        _this.state = props || {};
        return _this;
    }

    createClass(Provider, [{
        key: "render",
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
        }
    }, {
        key: "getChildContext",
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) for (var key in baseStores) {
                stores[key] = baseStores[key];
            }
            // add own stores
            for (var _key in this.state) {
                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
            }return {
                mobxStores: stores
            };
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (!nextProps) return null;
            if (!prevState) return nextProps;

            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(prevState).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
                if (!specialReactKeys[key] && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
            }return nextProps;
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.contextTypes = {
    mobxStores: objectOrObservableObject
}, _class.childContextTypes = {
    mobxStores: objectOrObservableObject.isRequired
}, _temp);

// TODO: kill in next major

polyfill(Provider);

if (!__WEBPACK_IMPORTED_MODULE_1_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_0_mobx__["m" /* spy */]) throw new Error("mobx-react requires mobx to be available");

if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* configure */])({ reactionScheduler: __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] });else if (typeof unstable_batchedUpdates$1 === "function") Object(__WEBPACK_IMPORTED_MODULE_0_mobx__["f" /* configure */])({ reactionScheduler: unstable_batchedUpdates$1 });

var onError = function onError(fn) {
    return errorsReporter.on(fn);
};

/* DevTool support */
// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
    var mobx$1 = { spy: __WEBPACK_IMPORTED_MODULE_0_mobx__["m" /* spy */], extras: { getDebugName: __WEBPACK_IMPORTED_MODULE_0_mobx__["h" /* getDebugName */] } };
    var mobxReact = {
        renderReporter: renderReporter,
        componentByNodeRegistry: componentByNodeRegistry,
        componentByNodeRegistery: componentByNodeRegistry,
        trackComponents: trackComponents
    };
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return featuredInds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indicators_notFoodInsecure_json__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__indicators_notFoodInsecure_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__indicators_notFoodInsecure_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__indicators_earlyPrenatalCare_json__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__indicators_earlyPrenatalCare_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__indicators_earlyPrenatalCare_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indicators_registeredToVote_json__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indicators_registeredToVote_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__indicators_registeredToVote_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicators_upToDateImmunizations_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__indicators_upToDateImmunizations_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__indicators_upToDateImmunizations_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__indicators_lowIncomeDental_json__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__indicators_lowIncomeDental_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__indicators_lowIncomeDental_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indicators_collegeCareerReady_json__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indicators_collegeCareerReady_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__indicators_collegeCareerReady_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__indicators_breastFeeding_json__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__indicators_breastFeeding_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__indicators_breastFeeding_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__indicators_mathStandards8_json__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__indicators_mathStandards8_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__indicators_mathStandards8_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indicators_collegeLevelMath_json__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indicators_collegeLevelMath_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__indicators_collegeLevelMath_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__indicators_familyLike_json__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__indicators_familyLike_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__indicators_familyLike_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__indicators_readToEveryday_json__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__indicators_readToEveryday_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__indicators_readToEveryday_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__indicators_childCareSlots_json__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__indicators_childCareSlots_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__indicators_childCareSlots_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__indicators_englishLearners_json__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__indicators_englishLearners_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__indicators_englishLearners_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__indicators_enrolled34_json__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__indicators_enrolled34_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__indicators_enrolled34_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__indicators_fosterYouthGraduation_json__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__indicators_fosterYouthGraduation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__indicators_fosterYouthGraduation_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__indicators_FRPMSchoolYear_json__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__indicators_FRPMSchoolYear_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__indicators_FRPMSchoolYear_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__indicators_FRPMSummer_json__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__indicators_FRPMSummer_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__indicators_FRPMSummer_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__indicators_FYTimelyDental_json__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__indicators_FYTimelyDental_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__indicators_FYTimelyDental_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__indicators_FYTimelyMedical_json__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__indicators_FYTimelyMedical_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__indicators_FYTimelyMedical_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__indicators_graduation_json__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__indicators_graduation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__indicators_graduation_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__indicators_healthInsurance_json__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__indicators_healthInsurance_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__indicators_healthInsurance_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__indicators_notAbsent_json__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__indicators_notAbsent_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__indicators_notAbsent_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__indicators_notLowBirthWeight_json__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__indicators_notLowBirthWeight_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__indicators_notLowBirthWeight_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__indicators_notObese_json__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__indicators_notObese_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__indicators_notObese_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__indicators_permanency_json__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__indicators_permanency_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__indicators_permanency_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__indicators_placementStability_json__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__indicators_placementStability_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__indicators_placementStability_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__indicators_readingStandards_json__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__indicators_readingStandards_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__indicators_readingStandards_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__indicators_suspension_json__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__indicators_suspension_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__indicators_suspension_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__indicators_connected__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__indicators_connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__indicators_connected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__indicators_difference__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__indicators_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__indicators_difference__);
// import * as welfare from './welfare/index.js'
// import * as education from './education/'
//formatting issues
//year rank discrepancy
// black/AA issue
//asterisked numbers and no ranks
//provisionally working:
var indicators={earlyPrenatalCare:__WEBPACK_IMPORTED_MODULE_1__indicators_earlyPrenatalCare_json___default.a,breastFeeding:__WEBPACK_IMPORTED_MODULE_6__indicators_breastFeeding_json___default.a,notLowBirthWeight:__WEBPACK_IMPORTED_MODULE_22__indicators_notLowBirthWeight_json___default.a,lowIncomeDental:__WEBPACK_IMPORTED_MODULE_4__indicators_lowIncomeDental_json___default.a,upToDateImmunizations:__WEBPACK_IMPORTED_MODULE_3__indicators_upToDateImmunizations_json___default.a,healthInsurance:__WEBPACK_IMPORTED_MODULE_20__indicators_healthInsurance_json___default.a,notFoodInsecure:__WEBPACK_IMPORTED_MODULE_0__indicators_notFoodInsecure_json___default.a,notObese:__WEBPACK_IMPORTED_MODULE_23__indicators_notObese_json___default.a,readToEveryday:__WEBPACK_IMPORTED_MODULE_10__indicators_readToEveryday_json___default.a,childCareSlots:__WEBPACK_IMPORTED_MODULE_11__indicators_childCareSlots_json___default.a,enrolled34:__WEBPACK_IMPORTED_MODULE_13__indicators_enrolled34_json___default.a,readingStandards:__WEBPACK_IMPORTED_MODULE_26__indicators_readingStandards_json___default.a,mathStandards8:__WEBPACK_IMPORTED_MODULE_7__indicators_mathStandards8_json___default.a,englishLearners:__WEBPACK_IMPORTED_MODULE_12__indicators_englishLearners_json___default.a,suspension:__WEBPACK_IMPORTED_MODULE_27__indicators_suspension_json___default.a,notAbsent:__WEBPACK_IMPORTED_MODULE_21__indicators_notAbsent_json___default.a,connected:__WEBPACK_IMPORTED_MODULE_28__indicators_connected___default.a,difference:__WEBPACK_IMPORTED_MODULE_29__indicators_difference___default.a,FRPMSchoolYear:__WEBPACK_IMPORTED_MODULE_15__indicators_FRPMSchoolYear_json___default.a,FRPMSummer:__WEBPACK_IMPORTED_MODULE_16__indicators_FRPMSummer_json___default.a,graduation:__WEBPACK_IMPORTED_MODULE_19__indicators_graduation_json___default.a,collegeCareerReady:__WEBPACK_IMPORTED_MODULE_5__indicators_collegeCareerReady_json___default.a,collegeLevelMath:__WEBPACK_IMPORTED_MODULE_8__indicators_collegeLevelMath_json___default.a,registeredToVote:__WEBPACK_IMPORTED_MODULE_2__indicators_registeredToVote_json___default.a,permanency:__WEBPACK_IMPORTED_MODULE_24__indicators_permanency_json___default.a,placementStability:__WEBPACK_IMPORTED_MODULE_25__indicators_placementStability_json___default.a,familyLike:__WEBPACK_IMPORTED_MODULE_9__indicators_familyLike_json___default.a,FYTimelyDental:__WEBPACK_IMPORTED_MODULE_17__indicators_FYTimelyDental_json___default.a,FYTimelyMedical:__WEBPACK_IMPORTED_MODULE_18__indicators_FYTimelyMedical_json___default.a,fosterYouthGraduation:__WEBPACK_IMPORTED_MODULE_14__indicators_fosterYouthGraduation_json___default.a};var featuredInds=['collegeLevelMath','earlyPrenatalCare','permanency','upToDateImmunizations','FYTimelyDental'];console.log(indicators);/* harmony default export */ __webpack_exports__["a"] = (indicators);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(77);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Toggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Tip; });
/* unused harmony export Search */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* unused harmony export Triangle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownToggle; });
/* unused harmony export Caret */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_makeHash__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_toLowerCase__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_class4,_desc2,_value2,_class5,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10;var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    display: inline-flex;\n'],['\n    position: relative;\n    display: inline-flex;\n']),_templateObject2=_taggedTemplateLiteral(['\n    cursor: pointer;\n    box-sizing: border-box;\n    height: 100%;\n    border: 1px solid ',';\n    \n    z-index: ','\n    &.negativeNoStroke{\n        @media ','{\n            height: 48px;\n        }\n        @media ','{\n            height: 44px;\n        }\n        display: flex; align-items: center;\n        border: 1px solid transparent;\n        &:not(:first-of-type){\n            border-left: 1px solid var(--offwhitebg);\n        }\n        z-index: 1;\n    }\n    font-size: ',';\n    letter-spacing: 0.5px;\n    @media ','{\n        padding: ',';    \n    }\n    @media ','{\n        padding: ',';    \n    }\n\n    color: ',';\n    background-color: ',';\n    \n    @media ','{\n        font-size: 12px;\n        padding: 8.5px 15px;\n    }\n    &.muted{\n        border: 1px solid ',';\n        color: ',';\n        background-color: white;\n        &::hover{\n            border: 1px solid ',';\n            color: ',';\n        }\n    }\n    white-space: nowrap;\n\n    &:not(:first-of-type){\n        transform: translateX(-','px);\n    }\n\n'],['\n    cursor: pointer;\n    box-sizing: border-box;\n    height: 100%;\n    border: 1px solid ',';\n    \n    z-index: ','\n    &.negativeNoStroke{\n        @media ','{\n            height: 48px;\n        }\n        @media ','{\n            height: 44px;\n        }\n        display: flex; align-items: center;\n        border: 1px solid transparent;\n        &:not(:first-of-type){\n            border-left: 1px solid var(--offwhitebg);\n        }\n        z-index: 1;\n    }\n    font-size: ',';\n    letter-spacing: 0.5px;\n    @media ','{\n        padding: ',';    \n    }\n    @media ','{\n        padding: ',';    \n    }\n\n    color: ',';\n    background-color: ',';\n    \n    @media ','{\n        font-size: 12px;\n        padding: 8.5px 15px;\n    }\n    &.muted{\n        border: 1px solid ',';\n        color: ',';\n        background-color: white;\n        &::hover{\n            border: 1px solid ',';\n            color: ',';\n        }\n    }\n    white-space: nowrap;\n\n    &:not(:first-of-type){\n        transform: translateX(-','px);\n    }\n\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: absolute;\n    display: none;\n    width: 100px;\n    bottom: 0;\n    box-sizing: border-box;\n    height: 100%;\n    background: var(--faintpeach);\n    // border: 1px solid var(--strokepeach);\n    transform-origin: 0% 100%;\n    transition: transform .2s;\n    z-index: 0;\n    &::after{\n        // content: \'\';\n        position: absolute;\n        height: 3px;\n        border-right: 1px solid var(--strokepeach);\n        right: -3px;\n        top: -2px;\n    }\n'],['\n    position: absolute;\n    display: none;\n    width: 100px;\n    bottom: 0;\n    box-sizing: border-box;\n    height: 100%;\n    background: var(--faintpeach);\n    // border: 1px solid var(--strokepeach);\n    transform-origin: 0% 100%;\n    transition: transform .2s;\n    z-index: 0;\n    &::after{\n        // content: \'\';\n        position: absolute;\n        height: 3px;\n        border-right: 1px solid var(--strokepeach);\n        right: -3px;\n        top: -2px;\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: translate(-50%, calc(50%));\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, calc(50% + 20px));\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: translate(-50%, calc(50%));\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, calc(50% + 20px));\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: translate(-50%, calc(-50% - 20px));\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, calc(-50% - 35px));\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: translate(-50%, calc(-50% - 20px));\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, calc(-50% - 35px));\n    }\n']),_templateObject6=_taggedTemplateLiteral(['\n    //display: ',';\n    position: absolute;\n    ',': ','px;\n    ',': ','px;\n    opacity: 0;\n    animation-fill-mode: forwards;\n    &.above{\n        &::before{ bottom: -21.5px;}\n        &::after{ bottom: -19px;}\n        //transform: translate(-50%, calc(-50% - 35px));\n        transform-origin: 50% 100%;\n        animation: ',' ',' forwards;\n\n    }\n    &.below{\n        &::before{ top: -21.5px; }\n        &::after{ top: -19px; }\n        //transform: translate(-50%, calc(50% + 20px));   \n        \n        animation: ',' ',' forwards;\n    }\n    z-index: 99;\n    padding: 15px 25px;\n    &::after{\n        left: calc(50% - 9.5px);\n        transform: translateX(','px);\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 9.5px solid transparent;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        transform: translateX(','px);\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 10.5px solid transparent;\n    }\n    &.default{\n        background: var(--normtext);\n        color: white;\n        outline: 1px solid var(--offwhitefg);\n        &.above{\n            &::after{ border-top: 9.5px var(--normtext) solid;  }\n            &::before{ border-top: 10.5px var(--offwhitefg) solid; margin-top: 1px;}\n        }\n        &.below{\n            &::after{ border-bottom: 9.5px var(--normtext) solid;  }\n            &::before{ border-bottom: 10.5px var(--offwhitefg) solid;  margin-top: -1px;}\n        }\n    }\n    &.actionable{\n        background: var(--offwhitefg);\n        border: 1px solid var(--bordergrey);\n        padding: 0;\n        &.above{\n            &::before { border-top: 10.5px var(--bordergrey) solid; }\n            &::after{ border-top: 9.5px var(--offwhitefg) solid; }\n        }\n        &.below{\n            &::before { border-bottom: 10.5px var(--bordergrey) solid; }\n            &::after{ border-bottom: 9.5px var(--offwhitefg) solid;  }\n        }\n    }\n    h1{ margin: 0; font-size: 24px;  font-weight: normal;}\n    h2{ margin: 0; font-size: 16px;   font-weight: normal;}\n    h3{ margin: 0; font-size: 13px; color: var(--fainttext); font-weight: normal;}\n\n'],['\n    //display: ',';\n    position: absolute;\n    ',': ','px;\n    ',': ','px;\n    opacity: 0;\n    animation-fill-mode: forwards;\n    &.above{\n        &::before{ bottom: -21.5px;}\n        &::after{ bottom: -19px;}\n        //transform: translate(-50%, calc(-50% - 35px));\n        transform-origin: 50% 100%;\n        animation: ',' ',' forwards;\n\n    }\n    &.below{\n        &::before{ top: -21.5px; }\n        &::after{ top: -19px; }\n        //transform: translate(-50%, calc(50% + 20px));   \n        \n        animation: ',' ',' forwards;\n    }\n    z-index: 99;\n    padding: 15px 25px;\n    &::after{\n        left: calc(50% - 9.5px);\n        transform: translateX(','px);\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 9.5px solid transparent;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        transform: translateX(','px);\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 10.5px solid transparent;\n    }\n    &.default{\n        background: var(--normtext);\n        color: white;\n        outline: 1px solid var(--offwhitefg);\n        &.above{\n            &::after{ border-top: 9.5px var(--normtext) solid;  }\n            &::before{ border-top: 10.5px var(--offwhitefg) solid; margin-top: 1px;}\n        }\n        &.below{\n            &::after{ border-bottom: 9.5px var(--normtext) solid;  }\n            &::before{ border-bottom: 10.5px var(--offwhitefg) solid;  margin-top: -1px;}\n        }\n    }\n    &.actionable{\n        background: var(--offwhitefg);\n        border: 1px solid var(--bordergrey);\n        padding: 0;\n        &.above{\n            &::before { border-top: 10.5px var(--bordergrey) solid; }\n            &::after{ border-top: 9.5px var(--offwhitefg) solid; }\n        }\n        &.below{\n            &::before { border-bottom: 10.5px var(--bordergrey) solid; }\n            &::after{ border-bottom: 9.5px var(--offwhitefg) solid;  }\n        }\n    }\n    h1{ margin: 0; font-size: 24px;  font-weight: normal;}\n    h2{ margin: 0; font-size: 16px;   font-weight: normal;}\n    h3{ margin: 0; font-size: 13px; color: var(--fainttext); font-weight: normal;}\n\n']),_templateObject7=_taggedTemplateLiteral(['\n    \n    position: relative;\n    padding-left: 15px;\n    display: flex;\n    align-items: center;\n'],['\n    \n    position: relative;\n    padding-left: 15px;\n    display: flex;\n    align-items: center;\n']),_templateObject8=_taggedTemplateLiteral(['\n    position: absolute;\n    left: 5px;\n    width: 15px; height: 15px;\n    mask-image: url(',');\n    background-color: var(--strokepeach);\n    // background-image: url(',');\n\n'],['\n    position: absolute;\n    left: 5px;\n    width: 15px; height: 15px;\n    mask-image: url(',');\n    background-color: var(--strokepeach);\n    // background-image: url(',');\n\n']),_templateObject9=_taggedTemplateLiteral(['\n    appearance: none;\n    background: transparent;\n    border: none;\n    outline: none;\n    padding: 6px 15px;\n    &::placeholder{\n        color: var(--strokepeach);\n    }\n'],['\n    appearance: none;\n    background: transparent;\n    border: none;\n    outline: none;\n    padding: 6px 15px;\n    &::placeholder{\n        color: var(--strokepeach);\n    }\n']),_templateObject10=_taggedTemplateLiteral(['\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    @media ','{\n        padding: 12px 25px;    \n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    cursor: pointer;\n    background: white;\n    color: var(--normtext);\n    border: 1px solid var(--fainttext);\n    &:hover{\n        color: var(--strokepeach);\n    }\n    &.default, &.compact{\n        background: white;\n        color: var(--normtext);\n        border: 1px solid var(--fainttext);\n        &:hover{\n            color: var(--strokepeach);\n        }\n    }\n\n    &.compact{\n        font-size: 13px;\n        padding: 10px 15px;\n        height: 33px;\n    }\n    &.dark{\n        background: var(--normtext);\n        color: white;\n        border: 1px solid var(--normtext);\n    }\n    &.negative{\n        background: black;\n        background: var(--offwhitebg);\n        border: 1px solid var(--offwhitebg);\n        color: white;\n        &:hover{\n            color: var(--peach);\n        }\n    }\n    &.negativeOnDark{\n        background: var(--offwhitebg);\n        color: white;\n        border: 1px solid var(--offwhitefg);\n        &:hover{\n            color: var(--peach);\n            border-color: var(--peach);\n\n        }\n    }\n    &.borderless{\n        border-color: transparent;\n    }\n'],['\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    @media ','{\n        padding: 12px 25px;    \n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    cursor: pointer;\n    background: white;\n    color: var(--normtext);\n    border: 1px solid var(--fainttext);\n    &:hover{\n        color: var(--strokepeach);\n    }\n    &.default, &.compact{\n        background: white;\n        color: var(--normtext);\n        border: 1px solid var(--fainttext);\n        &:hover{\n            color: var(--strokepeach);\n        }\n    }\n\n    &.compact{\n        font-size: 13px;\n        padding: 10px 15px;\n        height: 33px;\n    }\n    &.dark{\n        background: var(--normtext);\n        color: white;\n        border: 1px solid var(--normtext);\n    }\n    &.negative{\n        background: black;\n        background: var(--offwhitebg);\n        border: 1px solid var(--offwhitebg);\n        color: white;\n        &:hover{\n            color: var(--peach);\n        }\n    }\n    &.negativeOnDark{\n        background: var(--offwhitebg);\n        color: white;\n        border: 1px solid var(--offwhitefg);\n        &:hover{\n            color: var(--peach);\n            border-color: var(--peach);\n\n        }\n    }\n    &.borderless{\n        border-color: transparent;\n    }\n']),_templateObject11=_taggedTemplateLiteral(['\n\n    &::after, &::before{\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n    }\n    &::after{\n        left: calc(50% - 9.5px);\n        top: -19px;\n        border: 9.5px solid transparent;\n        border-bottom: 9.5px white solid;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        top: -21.5px;\n        border: 10.5px solid transparent;\n        border-bottom: 10.5px var(--bordergrey) solid;\n    }\n\n'],['\n\n    &::after, &::before{\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n    }\n    &::after{\n        left: calc(50% - 9.5px);\n        top: -19px;\n        border: 9.5px solid transparent;\n        border-bottom: 9.5px white solid;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        top: -21.5px;\n        border: 10.5px solid transparent;\n        border-bottom: 10.5px var(--bordergrey) solid;\n    }\n\n']),_templateObject12=_taggedTemplateLiteral(['\n    position: relative;\n    width: ','px;\n    @media ','{\n        height: 48px;\n    }\n    @media ','{\n        height: 44px;\n    }\n'],['\n    position: relative;\n    width: ','px;\n    @media ','{\n        height: 48px;\n    }\n    @media ','{\n        height: 44px;\n    }\n']),_templateObject13=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%;\n    left: -1px;\n    @media ','{\n        top: 48px;\n    }\n    @media ','{\n        top: 44px;\n    }\n    padding: 0; margin: 0;\n    opacity: 0;     \n    transform: translateY(-25px);\n    clip-path: polygon(0 -10px, 100% -10px, 100% 0, 0 0);\n    transition: opacity .25s, transform .25s, clip-path .25s;\n    pointer-events: none;\n    ','\n'],['\n    position: absolute;\n    width: 100%;\n    left: -1px;\n    @media ','{\n        top: 48px;\n    }\n    @media ','{\n        top: 44px;\n    }\n    padding: 0; margin: 0;\n    opacity: 0;     \n    transform: translateY(-25px);\n    clip-path: polygon(0 -10px, 100% -10px, 100% 0, 0 0);\n    transition: opacity .25s, transform .25s, clip-path .25s;\n    pointer-events: none;\n    ','\n']),_templateObject14=_taggedTemplateLiteral(['\n    &:not(:first-of-type){\n        border-top: 1px solid var(--bordergrey);\n        // border-bottom: 1px solid ',';\n    }\n    border: 1px solid var(--bordergrey);\n    ','\n    background: ',';\n    color: ',';\n    cursor: ','; \n    @media ','{\n        padding: 12px 25px;\n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    list-style-type: none;\n    margin-top: -1px;\n    &:hover{\n        color: ',';\n    }\n'],['\n    &:not(:first-of-type){\n        border-top: 1px solid var(--bordergrey);\n        // border-bottom: 1px solid ',';\n    }\n    border: 1px solid var(--bordergrey);\n    ','\n    background: ',';\n    color: ',';\n    cursor: ','; \n    @media ','{\n        padding: 12px 25px;\n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    list-style-type: none;\n    margin-top: -1px;\n    &:hover{\n        color: ',';\n    }\n']),_templateObject15=_taggedTemplateLiteral(['\n    display: inline-flex; \n    align-items: center;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    @media ','{\n        padding: 12px 25px;\n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    // border: 1px solid ',';\n    background: ',';\n    cursor: ','; \n    color: ',';\n    white-space: nowrap;\n\n    transform: translateX(','% );\n    transition: transform ','s;\n    &.first{\n        width: ','px;\n        margin-right: -20px;\n        z-index: 3;\n        background-color: transparent;\n        border-color: transparent;\n        color: ',';\n        font-weight: ',';\n        &::after{\n            content: \'Arace\';\n            color: rgba(0,0,0,0);\n            position: absolute;\n            top: calc(50% - 1px);\n            left: 20px;\n            padding: 0 5px;\n            z-index: 4;\n            bottom: 0;\n            margin: auto;\n            border-top: 2px solid var(--strokepeach);\n            transform: scaleX(',');\n            transition: transform .2s;\n            pointer-events: none;\n            transform-origin: ',';\n\n        }\n    }\n    &:not(.first){\n        justify-content: center;\n\n        outline: 1px solid var(--offwhitebg);\n        margin-left: ','px;\n        width: 93px;\n        z-index: ',';\n        // z-index: ',';\n        ','\n    }\n    &:hover{\n        color: ',';\n    }\n'],['\n    display: inline-flex; \n    align-items: center;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    @media ','{\n        padding: 12px 25px;\n    }\n    @media ','{\n        padding: 10px 21px;\n    }\n    // border: 1px solid ',';\n    background: ',';\n    cursor: ','; \n    color: ',';\n    white-space: nowrap;\n\n    transform: translateX(','% );\n    transition: transform ','s;\n    &.first{\n        width: ','px;\n        margin-right: -20px;\n        z-index: 3;\n        background-color: transparent;\n        border-color: transparent;\n        color: ',';\n        font-weight: ',';\n        &::after{\n            content: \'Arace\';\n            color: rgba(0,0,0,0);\n            position: absolute;\n            top: calc(50% - 1px);\n            left: 20px;\n            padding: 0 5px;\n            z-index: 4;\n            bottom: 0;\n            margin: auto;\n            border-top: 2px solid var(--strokepeach);\n            transform: scaleX(',');\n            transition: transform .2s;\n            pointer-events: none;\n            transform-origin: ',';\n\n        }\n    }\n    &:not(.first){\n        justify-content: center;\n\n        outline: 1px solid var(--offwhitebg);\n        margin-left: ','px;\n        width: 93px;\n        z-index: ',';\n        // z-index: ',';\n        ','\n    }\n    &:hover{\n        color: ',';\n    }\n']),_templateObject16=_taggedTemplateLiteral(['\n    position: absolute;\n\n    ','\n    outline: 1px solid var(--offwhitebg);\n    // border: ',';\n    width: ','px;\n    height: 100%;\n    z-index: 3;\n    background: ',';\n    \n    left: -1px;\n    transform-origin: 0% 50%;\n    // transition: transform .2s, outline-color ','2s;\n    transition: transform .2s, box-shadow .25s, background-color .25s;\n    // transition-delay: ','s;\n    transform: ',';\n        \n\n'],['\n    position: absolute;\n\n    ','\n    outline: 1px solid var(--offwhitebg);\n    // border: ',';\n    width: ','px;\n    height: 100%;\n    z-index: 3;\n    background: ',';\n    \n    left: -1px;\n    transform-origin: 0% 50%;\n    // transition: transform .2s, outline-color ','2s;\n    transition: transform .2s, box-shadow .25s, background-color .25s;\n    // transition-delay: ','s;\n    transform: ',';\n        \n\n']),_templateObject17=_taggedTemplateLiteral(['\n    cursor: pointer;\n    position: absolute;\n    opacity: ',';\n    transition: opacity .15s;\n    // transition-delay: ','s;\n    right: 0;\n    z-index: 5;\n    top: 3px; \n    bottom: 0; margin: auto;\n    height: 13px;\n    &::before{\n        margin-top: 2px;\n        content: \'\';\n        right: 18px;\n        width: 0px;\n        border: 7px solid transparent;\n        border-top-color: ',';\n        height: 0px;\n        position: absolute;\n    }\n    &::after{\n        margin-top: 2px;\n        content: \'\';\n        right: 18px;\n        width: 0px;\n        border: 7px solid transparent;\n        transform: scale(0.75);\n        transform-origin: 50% 20%;\n        border-top-color: white;\n        opacity: ',';\n        height: 0px;\n        position: absolute;\n\n        transition: opacity .25s, transform .25s;\n        ','\n        ','\n    }\n'],['\n    cursor: pointer;\n    position: absolute;\n    opacity: ',';\n    transition: opacity .15s;\n    // transition-delay: ','s;\n    right: 0;\n    z-index: 5;\n    top: 3px; \n    bottom: 0; margin: auto;\n    height: 13px;\n    &::before{\n        margin-top: 2px;\n        content: \'\';\n        right: 18px;\n        width: 0px;\n        border: 7px solid transparent;\n        border-top-color: ',';\n        height: 0px;\n        position: absolute;\n    }\n    &::after{\n        margin-top: 2px;\n        content: \'\';\n        right: 18px;\n        width: 0px;\n        border: 7px solid transparent;\n        transform: scale(0.75);\n        transform-origin: 50% 20%;\n        border-top-color: white;\n        opacity: ',';\n        height: 0px;\n        position: absolute;\n\n        transition: opacity .25s, transform .25s;\n        ','\n        ','\n    }\n']),_templateObject18=_taggedTemplateLiteral(['\n    // position: absolute;\n    z-index: 4; \n    right: 15px;\n    width: 15px; height: 15px;\n    margin-bottom: 0px;\n    margin-right: -5px;\n    margin-left: 8px;\n    flex-shrink: 0;\n    background: url(',') no-repeat;\n    &:hover{\n        opacity: 1;\n    }\n    opacity: 0.5;\n    transition: opacity .2s;\n'],['\n    // position: absolute;\n    z-index: 4; \n    right: 15px;\n    width: 15px; height: 15px;\n    margin-bottom: 0px;\n    margin-right: -5px;\n    margin-left: 8px;\n    flex-shrink: 0;\n    background: url(',') no-repeat;\n    &:hover{\n        opacity: 1;\n    }\n    opacity: 0.5;\n    transition: opacity .2s;\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ToggleBody=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var Option=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.selected?'var(--strokepeach)':'var(--bordergrey)';},function(props){return props.selected?1:0;},__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].compact,function(props){return props.size==='big'?'16px':'13px';},__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].optimal,function(props){return props.size==='big'?'12px 20px':'6px 15px';},__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].compact,function(props){return props.size==='big'?'10px 20px':'6px 15px';},function(props){return props.selected?'var(--strokepeach)':props.disabled?'var(--fainttext)':'var(--normtext)';},function(props){return props.selected?'var(--faintpeach)':props.disabled?'var(--disabledgrey)':'white';},__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].mobile,function(props){return props.selected?'var(--normtext)':'var(--bordergrey)';},function(props){return props.disabled?'var(--fainttext)':'var(--normtext)';},function(props){return props.selected?'var(--normtext)':'var(--bordergrey)';},function(props){return props.disabled?'var(--fainttext)':'var(--normtext)';},function(props){return props.index;});var Accent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3);var Toggle=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(Toggle,_React$Component);function Toggle(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Toggle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Toggle.__proto__||Object.getPrototypeOf(Toggle)).call.apply(_ref,[this].concat(args))),_this),_this.hash=Object(__WEBPACK_IMPORTED_MODULE_4__utilities_makeHash__["a" /* default */])(),_initDefineProp(_this,'accentWidth',_descriptor,_this),_initDefineProp(_this,'accentPosition',_descriptor2,_this),_initDefineProp(_this,'lastSelected',_descriptor3,_this),_initDefineProp(_this,'setLastSelected',_descriptor4,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Toggle,[{key:'render',// @action updateAccent = () => {
//     const node = findDOMNode(this['option'+this.props.selected])
//     this.accentPosition =  node.offsetLeft
//     this.accentWidth = node.offsetWidth
// }
// componentWillUpdate(){
//     this.setLastSelected()
// }
// componentDidMount(){
//     this.updateAccent()
// }
// componentDidUpdate(){
//     this.updateAccent()
// }
value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToggleBody,{style:this.props.style,size:this.props.size,className:this.props.className},this.props.options.map(function(option,i,arr){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option,{className:_this2.props.theme,firstLast:i===0?'first':i===arr.length-1?'last':'',index:i,size:_this2.props.size,key:_this2.hash+'option'+i,ref:function ref(option){return _this2['option'+i]=option;},onClick:!option.disabled?function(e){if(_this2.props.stopPropagation)e.stopPropagation();_this2.props.onClick(option.value);}:function(){return console.log('this option is disabled.');},selected:i===_this2.props.selected,disabled:option.disabled},option.label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Accent,{style:{transform:'translateX('+this.accentPosition+'px) scaleX('+this.accentWidth/100+')'// transition: `transform ${.25*Math.abs(this.lastSelected - this.props.selected)}s`
}}));}}]);return Toggle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'accentWidth',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 50;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'accentPosition',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'lastSelected',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'setLastSelected',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(){return _this3.lastSelected=_this3.props.selected;};}})),_class2))||_class;Toggle.defaultProps={selected:0};var Tooltip=function(_React$Component2){_inherits(Tooltip,_React$Component2);function Tooltip(){_classCallCheck(this,Tooltip);return _possibleConstructorReturn(this,(Tooltip.__proto__||Object.getPrototypeOf(Tooltip)).apply(this,arguments));}_createClass(Tooltip,[{key:'render',value:function render(){var _props=this.props,theme=_props.theme,direction=_props.direction,children=_props.children,restOfProps=_objectWithoutProperties(_props,['theme','direction','children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tip,Object.assign({},restOfProps,{className:[theme||'default',direction||'above'].join(' ')}),children);}}]);return Tooltip;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var fadeInBelow=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject4);var fadeInAbove=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject5);var Tip=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject6,function(props){return props.show?'block':'none';},function(props){return props.verticalAnchor||'top';},function(props){return props.pos.y;},function(props){return props.horizontalAnchor||'left';},function(props){return props.pos.x;},function(p){return p.customAnimation||fadeInAbove;},function(p){return p.duration||'.35s';},function(p){return p.customAnimation||fadeInBelow;},function(p){return p.duration||'.75s';},function(props){return props.caretOffset||0;},function(props){return props.caretOffset||0;});var SearchWrap=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7);var mag=__webpack_require__(145);var SearchIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject8,mag,mag);var SearchInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].input(_templateObject9);var Search=function Search(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchWrap,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchIcon,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchInput,{placeholder:props.placeholder,value:props.value,onChange:props.onChange}));};var Btn=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].mobile);var Button=function Button(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Btn,{style:props.style,className:props.disabled?'disabled':props.className||'default',onClick:!props.disabled?props.onClick:function(){}},props.label);};var Triangle=function Triangle(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Shpitz,null);};var Shpitz=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject11);var DropdownToggle=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class4=(_class5=function(_React$Component3){_inherits(DropdownToggle,_React$Component3);function DropdownToggle(){_classCallCheck(this,DropdownToggle);var _this5=_possibleConstructorReturn(this,(DropdownToggle.__proto__||Object.getPrototypeOf(DropdownToggle)).call(this));_initDefineProp(_this5,'dropdownOpen',_descriptor5,_this5);_initDefineProp(_this5,'setDropdown',_descriptor6,_this5);_initDefineProp(_this5,'hovered',_descriptor7,_this5);_initDefineProp(_this5,'hover',_descriptor8,_this5);_initDefineProp(_this5,'strikethrough',_descriptor9,_this5);_initDefineProp(_this5,'setStrikethrough',_descriptor10,_this5);_this5.handleOutside=function(e){if(!_this5.dropdown.current.contains(e.target)){// console.log('clicked outnside')
_this5.setDropdown(false);}};_this5.handleSelectionFromDropdown=function(val){var validSelect=_this5.props.select(val);if(validSelect)_this5.setDropdown(false);else{//sanity check tings?
console.log('sanity check race?');}};_this5.dropdown=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this5;}_createClass(DropdownToggle,[{key:'render',value:function render(){var _this6=this;// const {race} = this.props.store
var _props2=this.props,selected=_props2.selected,toggleMode=_props2.toggleMode,disabled=_props2.disabled,options=_props2.options,defaultWidth=_props2.defaultWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownToggleWrapper,{className:this.props.className,width:defaultWidth,disabled:disabled,onMouseEnter:function onMouseEnter(){_this6.hover(true);},onMouseLeave:function onMouseLeave(){_this6.hover(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Caret,{visible:!toggleMode,length:options.length,disabled:disabled,hovered:this.hovered&&!this.dropdownOpen&&!this.strikethrough,hasValue:selected,isOpen:this.dropdownOpen,onClick:this.props.openOther?this.props.openOther:!disabled?function(){_this6.setDropdown(!_this6.dropdownOpen);}:function(){}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FirstOptBorder,{length:options.length,defaultWidth:defaultWidth,toggleMode:toggleMode,selected:toggleMode&&!selected,hasValue:selected&&!toggleMode&&!this.dropdownOpen,disabled:disabled,dropdownOpen:this.dropdownOpen}),options.slice(0,1).map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TogOption,{strikethrough:_this6.strikethrough&&selected,defaultWidth:defaultWidth,className:'first',label:!toggleMode&&selected?Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(options,function(opt){return opt.value===selected;}).label:toggleMode||!selected?o.label:'wat',toggleMode:toggleMode,onClick:_this6.props.openOther?_this6.props.openOther:toggleMode?function(){_this6.props.select(o.value);}:!disabled?function(){_this6.setDropdown(!_this6.dropdownOpen);}:function(){},hasValue:selected&&!toggleMode&&!_this6.dropdownOpen,selected:toggleMode&&!selected,disabled:o.disabled||disabled,muted:disabled,hovered:_this6.hovered&&!toggleMode,dropdownOpen:_this6.dropdownOpen},!toggleMode&&selected?Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["find"])(options,function(opt){return opt.value===selected;}).label:toggleMode||!selected?o.label:'wat',selected&&!_this6.dropdownOpen&&!toggleMode&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuickClear,{onMouseEnter:function onMouseEnter(){_this6.setStrikethrough(true);},onMouseLeave:function onMouseLeave(){_this6.setStrikethrough(false);},onClick:selected?function(e){_this6.props.select(null);_this6.hover(false);_this6.setStrikethrough(false);e.stopPropagation();// e.nativeEvent.stopImmediatePropagation()
}:function(){}}));}),this.props.options.slice(1).map(function(o,i,arr){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TogOption,{length:arr.length,offset:i===0?true:false,reveal:toggleMode,index:i,onClick:function onClick(){_this6.props.select(o.value);},selected:!o.value?!selected:o.value===selected,disabled:o.disabled||disabled},o.label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownList,{ref:this.dropdown,open:this.dropdownOpen&&!this.props.toggleMode,close:function close(){return _this6.setDropdown(false);}},this.props.options.map(function(o,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownOption,{index:i// onClick = {()=>{this.props.select(o.value)}}
,onClick:function onClick(){_this6.handleSelectionFromDropdown(o.value);},disabled:o.disabled,selected:!o.value?!selected:o.value===selected},o.label);})));}}]);return DropdownToggle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor5=_applyDecoratedDescriptor(_class5.prototype,'dropdownOpen',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class5.prototype,'setDropdown',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(tf){if(tf)document.addEventListener('click',_this7.handleOutside);else document.removeEventListener('click',_this7.handleOutside);_this7.dropdownOpen=tf;if(_this7.props.setDropdownState)_this7.props.setDropdownState(tf);};}}),_descriptor7=_applyDecoratedDescriptor(_class5.prototype,'hovered',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor8=_applyDecoratedDescriptor(_class5.prototype,'hover',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(tf){_this8.hovered=tf;};}}),_descriptor9=_applyDecoratedDescriptor(_class5.prototype,'strikethrough',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class5.prototype,'setStrikethrough',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(tf){_this9.strikethrough=tf;};}})),_class5))||_class4;var DropdownToggleWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject12,function(props){return props.width;},__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].compact);var DropdownList=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].ul(_templateObject13,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].compact,function(props){return props.open?'\n        opacity: 1;\n        transform: translateY(0);\n        clip-path: polygon(0 -10px, 100% -10px, 100% 100%, 0 100%);\n        pointer-events: auto;\n    ':'';});var DropdownOption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].li(_templateObject14,function(p){return p.selected?'var(--strokepeach)':'transparent';},function(props){return props.selected?'\n        outline: 1px solid var(--strokepeach);\n        outline-offset: -1px;    \n    ':'';},function(p){return p.disabled?'var(--disabledgrey)':p.selected?'var(--faintpeach)':'white';},function(p){return p.disabled?'var(--fainttext)':p.selected?'var(--strokepeach)':'var(--normtext)';},function(p){return p.disabled?'auto':'pointer';},__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].compact,function(p){return!p.disabled?'var(--strokepeach)':'var(--fainttext)';});var TogOption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject15,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].compact,function(p){return p.selected?'var(--strokepeach)':'var(--offwhitebg)';},function(p){return p.disabled?'var(--disabledgrey)':p.selected?'var(--faintpeach)':'white';},function(p){return p.disabled?'auto':'pointer';},function(p){return p.dropdownOpen||p.muted||p.disabled?'var(--fainttext)':p.hovered&&!p.dropdownOpen||p.selected?'var(--strokepeach)':'var(--normtext)';},function(props){return props.reveal?(props.index+1)*100:0;},function(props){return .15*(props.index+1);},function(props){return props.defaultWidth;},function(p){return p.hovered&&p.muted?'var(--fainttext)':p.hasValue||p.hovered?'var(--strokepeach)':'';},function(p){return p.hasValue?500:400;},function(props){return props.strikethrough?1:0;},function(p){return p.hasValue?'100% 50%':'0% 50%';},function(props){return 25-props.index;},function(props){return 2-props.index;},function(props){return props.length-props.index+2;},function(props){return props.selected?'\n        // box-shadow: inset 0px 0px 0px 1px var(--strokepeach);\n        ':'';},function(p){return!p.disabled?'var(--strokepeach)':'var(--fainttext)';});var FirstOptBorder=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject16,function(props){return props.dropdownOpen?'\n        box-shadow: inset 0px 0px 0px 1.5px var(--peach);\n    ':'';},function(p){return p.selected||p.hasValue?'1px solid var(--strokepeach)':'1px solid transparent';},function(props){return props.defaultWidth;},function(p){return p.hasValue?'var(--faintpeach)':p.disabled?'var(--disabledgrey)':p.selected?'var(--faintpeach)':'white';},function(p){return p.hasValue?'.':'';},function(p){return p.toggleMode?0:p.length*.15+.15;},function(p){return!p.toggleMode?'scaleX(1)':'scaleX('+(p.defaultWidth-20)/p.defaultWidth+')';});DropdownToggle.defaultProps={selected:0,select:function select(id){console.log('selected',id);}};var Caret=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject17,function(props){return props.visible?1:0;},function(props){return props.visible?props.length*.15+.15:0;},function(props){return props.disabled?'var(--bordergrey)':props.hovered&&props.hasValue&&!props.disabled?'var(--strokepeach)':props.hasValue&&!props.isOpen?'var(--peach)':props.hovered||props.isOpen?'var(--strokepeach)':'var(--normtext)';},function(props){return props.disabled?0:1;},function(props){return props.hovered||props.isOpen?'\n            transform: scale(0.65);    \n        ':'';},function(props){return props.hasValue&&!props.isOpen?'\n            transform: scale(0);    \n        ':'';});var peachX=__webpack_require__(146);var QuickClear=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject18,peachX);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.10';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(38)(module)))

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelLower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalize; });
function firstLower(str){return str.charAt(0).toLowerCase()+str.substr(1);}function camelLower(str){return str.replace(/(?:^\w|[A-Z]|\b\w)/g,function(letter,index){return index===0?letter.toLowerCase():letter.toUpperCase();}).replace(/\s+/g,'');}function capitalize(str){return str.slice(0,1).toUpperCase()+str.substr(1);}/* unused harmony default export */ var _unused_webpack_default_export = (firstLower);

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function warnOnce(msg) {
  var hasWarned = false;
  return function () {
    if (!hasWarned) {
      console.warn(msg);
      hasWarned = true;
    }
  };
}


var statelessFunctionalComponentSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a stateless functional component as a child to <FlipMove>. Unfortunately, SFCs aren\'t supported, because Flip Move needs access to the backing instances via refs, and SFCs don\'t have a public instance that holds that info.\n\nPlease wrap your components in a native element (eg. <div>), or a non-functional component.\n');

var primitiveNodeSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a primitive (text or number) node as a child to <FlipMove>. Flip Move needs containers with unique keys to move children around.\n\nPlease wrap your value in a native element (eg. <span>), or a component.\n');

var invalidTypeForTimingProp = function invalidTypeForTimingProp(args
// prettier-ignore
) {
  return console.error('\n>> Error, via react-flip-move <<\n\nThe prop you provided for \'' + args.prop + '\' is invalid. It needs to be a positive integer, or a string that can be resolved to a number. The value you provided is \'' + args.value + '\'.\n\nAs a result,  the default value for this parameter will be used, which is \'' + args.defaultValue + '\'.\n');
};

var invalidEnterLeavePreset = function invalidEnterLeavePreset(args
// prettier-ignore
) {
  return console.error('\n>> Error, via react-flip-move <<\n\nThe enter/leave preset you provided is invalid. We don\'t currently have a \'' + args.value + ' preset.\'\n\nAcceptable values are ' + args.acceptableValues + '. The default value of \'' + args.defaultValue + '\' will be used.\n');
};

var parentNodePositionStatic = warnOnce('\n>> Warning, via react-flip-move <<\n\nWhen using "wrapperless" mode (by supplying \'typeName\' of \'null\'), strange things happen when the direct parent has the default "static" position.\n\nFlipMove has added \'position: relative\' to this node, to ensure Flip Move animates correctly.\n\nTo avoid seeing this warning, simply apply a non-static position to that parent node.\n');

var childIsDisabled = warnOnce('\n>> Warning, via react-flip-move <<\n\nOne or more of Flip Move\'s child elements have the html attribute \'disabled\' set to true.\n\nPlease note that this will cause animations to break in Internet Explorer 11 and below. Either remove the disabled attribute or set \'animation\' to false.\n');

var enterPresets = {
  elevator: {
    from: { transform: 'scale(0)', opacity: '0' },
    to: { transform: '', opacity: '' }
  },
  fade: {
    from: { opacity: '0' },
    to: { opacity: '' }
  },
  accordionVertical: {
    from: { transform: 'scaleY(0)', transformOrigin: 'center top' },
    to: { transform: '', transformOrigin: 'center top' }
  },
  accordionHorizontal: {
    from: { transform: 'scaleX(0)', transformOrigin: 'left center' },
    to: { transform: '', transformOrigin: 'left center' }
  },
  none: null
};
/**
 * React Flip Move | enterLeavePresets
 * (c) 2016-present Joshua Comeau
 *
 * This contains the master list of presets available for enter/leave animations,
 * along with the mapping between preset and styles.
 */


var leavePresets = {
  elevator: {
    from: { transform: 'scale(1)', opacity: '1' },
    to: { transform: 'scale(0)', opacity: '0' }
  },
  fade: {
    from: { opacity: '1' },
    to: { opacity: '0' }
  },
  accordionVertical: {
    from: { transform: 'scaleY(1)', transformOrigin: 'center top' },
    to: { transform: 'scaleY(0)', transformOrigin: 'center top' }
  },
  accordionHorizontal: {
    from: { transform: 'scaleX(1)', transformOrigin: 'left center' },
    to: { transform: 'scaleX(0)', transformOrigin: 'left center' }
  },
  none: null
};

// For now, appearPresets will be identical to enterPresets.
// Assigning a custom export in case we ever want to add appear-specific ones.
var appearPresets = enterPresets;

var defaultPreset = 'elevator';
var disablePreset = 'none';

var find = function find(predicate, arr) {
  for (var i = 0; i < arr.length; i++) {
    if (predicate(arr[i], i, arr)) {
      return arr[i];
    }
  }

  return undefined;
};


var every = function every(predicate, arr) {
  for (var i = 0; i < arr.length; i++) {
    if (!predicate(arr[i], i, arr)) {
      return false;
    }
  }
  return true;
};

// eslint-disable-next-line import/no-mutable-exports
var _isArray = function isArray(arr) {
  _isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
  return _isArray(arr);
};

var isElementAnSFC = function isElementAnSFC(element) {
  var isNativeDOMElement = typeof element.type === 'string';

  if (isNativeDOMElement) {
    return false;
  }

  return typeof element.type === 'function' && !element.type.prototype.isReactComponent;
};

function omit(obj) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (attrs.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

function arraysEqual(a, b) {
  var sameObject = a === b;
  if (sameObject) {
    return true;
  }

  var notBothArrays = !_isArray(a) || !_isArray(b);
  var differentLengths = a.length !== b.length;

  if (notBothArrays || differentLengths) {
    return false;
  }

  return every(function (element, index) {
    return element === b[index];
  }, a);
}

function memoizeString(fn) {
  var cache = {};

  return function (str) {
    if (!cache[str]) {
      cache[str] = fn(str);
    }
    return cache[str];
  };
}

var hyphenate = memoizeString(function (str) {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * React Flip Move | propConverter
 * (c) 2016-present Joshua Comeau
 *
 * Abstracted away a bunch of the messy business with props.
 *   - props flow types and defaultProps
 *   - Type conversion (We accept 'string' and 'number' values for duration,
 *     delay, and other fields, but we actually need them to be ints.)
 *   - Children conversion (we need the children to be an array. May not always
 *     be, if a single child is passed in.)
 *   - Resolving animation presets into their base CSS styles
 */
/* eslint-disable block-scoped-var */

// eslint-disable-next-line no-duplicate-imports


function propConverter(ComposedComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(FlipMovePropConverter, _Component);

    function FlipMovePropConverter() {
      classCallCheck(this, FlipMovePropConverter);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    // eslint-disable-next-line class-methods-use-this
    FlipMovePropConverter.prototype.checkChildren = function checkChildren(children) {
      // Skip all console warnings in production.
      // Bail early, to avoid unnecessary work.
      if (true) {
        return;
      }

      // same as React.Node, but without fragments, see https://github.com/facebook/flow/issues/4781


      // FlipMove does not support stateless functional components.
      // Check to see if any supplied components won't work.
      // If the child doesn't have a key, it means we aren't animating it.
      // It's allowed to be an SFC, since we ignore it.
      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
        // null, undefined, and booleans will be filtered out by Children.toArray
        if (child == null || typeof child === 'boolean') {
          return;
        }

        if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) !== 'object') {
          primitiveNodeSupplied();
          return;
        }

        if (isElementAnSFC(child) && child.key != null) {
          statelessFunctionalComponentSupplied();
        }
      });
    };

    FlipMovePropConverter.prototype.convertProps = function convertProps(props) {
      var workingProps = {
        // explicitly bypass the props that don't need conversion
        children: props.children,
        easing: props.easing,
        onStart: props.onStart,
        onFinish: props.onFinish,
        onStartAll: props.onStartAll,
        onFinishAll: props.onFinishAll,
        typeName: props.typeName,
        disableAllAnimations: props.disableAllAnimations,
        getPosition: props.getPosition,
        maintainContainerHeight: props.maintainContainerHeight,
        verticalAlignment: props.verticalAlignment,

        // Do string-to-int conversion for all timing-related props
        duration: this.convertTimingProp('duration'),
        delay: this.convertTimingProp('delay'),
        staggerDurationBy: this.convertTimingProp('staggerDurationBy'),
        staggerDelayBy: this.convertTimingProp('staggerDelayBy'),

        // Our enter/leave animations can be specified as boolean (default or
        // disabled), string (preset name), or object (actual animation values).
        // Let's standardize this so that they're always objects
        appearAnimation: this.convertAnimationProp(props.appearAnimation, appearPresets),
        enterAnimation: this.convertAnimationProp(props.enterAnimation, enterPresets),
        leaveAnimation: this.convertAnimationProp(props.leaveAnimation, leavePresets),

        delegated: {}
      };

      this.checkChildren(workingProps.children);

      // Gather any additional props;
      // they will be delegated to the ReactElement created.
      var primaryPropKeys = Object.keys(workingProps);
      var delegatedProps = omit(this.props, primaryPropKeys);

      // The FlipMove container element needs to have a non-static position.
      // We use `relative` by default, but it can be overridden by the user.
      // Now that we're delegating props, we need to merge this in.
      delegatedProps.style = _extends({
        position: 'relative'
      }, delegatedProps.style);

      workingProps.delegated = delegatedProps;

      return workingProps;
    };

    FlipMovePropConverter.prototype.convertTimingProp = function convertTimingProp(prop) {
      var rawValue = this.props[prop];

      var value = typeof rawValue === 'number' ? rawValue : parseInt(rawValue, 10);

      if (isNaN(value)) {
        var defaultValue = FlipMovePropConverter.defaultProps[prop];

        if (false) {
          invalidTypeForTimingProp({
            prop: prop,
            value: rawValue,
            defaultValue: defaultValue
          });
        }

        return defaultValue;
      }

      return value;
    };

    // eslint-disable-next-line class-methods-use-this


    FlipMovePropConverter.prototype.convertAnimationProp = function convertAnimationProp(animation, presets) {
      switch (typeof animation === 'undefined' ? 'undefined' : _typeof(animation)) {
        case 'boolean':
          {
            // If it's true, we want to use the default preset.
            // If it's false, we want to use the 'none' preset.
            return presets[animation ? defaultPreset : disablePreset];
          }

        case 'string':
          {
            var presetKeys = Object.keys(presets);

            if (presetKeys.indexOf(animation) === -1) {
              if (false) {
                invalidEnterLeavePreset({
                  value: animation,
                  acceptableValues: presetKeys.join(', '),
                  defaultValue: defaultPreset
                });
              }

              return presets[defaultPreset];
            }

            return presets[animation];
          }

        default:
          {
            return animation;
          }
      }
    };

    FlipMovePropConverter.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComposedComponent, this.convertProps(this.props));
    };

    return FlipMovePropConverter;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.defaultProps = {
    easing: 'ease-in-out',
    duration: 350,
    delay: 0,
    staggerDurationBy: 0,
    staggerDelayBy: 0,
    typeName: 'div',
    enterAnimation: defaultPreset,
    leaveAnimation: defaultPreset,
    disableAllAnimations: false,
    getPosition: function getPosition(node) {
      return node.getBoundingClientRect();
    },
    maintainContainerHeight: false,
    verticalAlignment: 'top'
  }, _temp;
}

/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 *
 * These methods read from and write to the DOM.
 * They almost always have side effects, and will hopefully become the
 * only spot in the codebase with impure functions.
 */
function applyStylesToDOMNode(_ref) {
  var domNode = _ref.domNode,
      styles = _ref.styles;

  // Can't just do an object merge because domNode.styles is no regular object.
  // Need to do it this way for the engine to fire its `set` listeners.
  Object.keys(styles).forEach(function (key) {
    domNode.style.setProperty(hyphenate(key), styles[key]);
  });
}

// Modified from Modernizr
function whichTransitionEvent() {
  var transitions = {
    transition: 'transitionend',
    '-o-transition': 'oTransitionEnd',
    '-moz-transition': 'transitionend',
    '-webkit-transition': 'webkitTransitionEnd'
  };

  // If we're running in a browserless environment (eg. SSR), it doesn't apply.
  // Return a placeholder string, for consistent type return.
  if (typeof document === 'undefined') return '';

  var el = document.createElement('fakeelement');

  var match = find(function (t) {
    return el.style.getPropertyValue(t) !== undefined;
  }, Object.keys(transitions));

  // If no `transition` is found, we must be running in a browser so ancient,
  // React itself won't run. Return an empty string, for consistent type return
  return match ? transitions[match] : '';
}

var getRelativeBoundingBox = function getRelativeBoundingBox(_ref2) {
  var childDomNode = _ref2.childDomNode,
      parentDomNode = _ref2.parentDomNode,
      getPosition = _ref2.getPosition;

  var parentBox = getPosition(parentDomNode);

  var _getPosition = getPosition(childDomNode),
      top = _getPosition.top,
      left = _getPosition.left,
      right = _getPosition.right,
      bottom = _getPosition.bottom,
      width = _getPosition.width,
      height = _getPosition.height;

  return {
    top: top - parentBox.top,
    left: left - parentBox.left,
    right: parentBox.right - right,
    bottom: parentBox.bottom - bottom,
    width: width,
    height: height
  };
};

/** getPositionDelta
 * This method returns the delta between two bounding boxes, to figure out
 * how many pixels on each axis the element has moved.
 *
 */
var getPositionDelta = function getPositionDelta(_ref3) {
  var childDomNode = _ref3.childDomNode,
      childBoundingBox = _ref3.childBoundingBox,
      parentBoundingBox = _ref3.parentBoundingBox,
      getPosition = _ref3.getPosition;

  // TEMP: A mystery bug is sometimes causing unnecessary boundingBoxes to
  var defaultBox = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: 0,
    width: 0
  };

  // Our old box is its last calculated position, derived on mount or at the
  // start of the previous animation.
  var oldRelativeBox = childBoundingBox || defaultBox;
  var parentBox = parentBoundingBox || defaultBox;

  // Our new box is the new final resting place: Where we expect it to wind up
  // after the animation. First we get the box in absolute terms (AKA relative
  // to the viewport), and then we calculate its relative box (relative to the
  // parent container)
  var newAbsoluteBox = getPosition(childDomNode);
  var newRelativeBox = {
    top: newAbsoluteBox.top - parentBox.top,
    left: newAbsoluteBox.left - parentBox.left
  };

  return [oldRelativeBox.left - newRelativeBox.left, oldRelativeBox.top - newRelativeBox.top];
};

/** removeNodeFromDOMFlow
 * This method does something very sneaky: it removes a DOM node from the
 * document flow, but without actually changing its on-screen position.
 *
 * It works by calculating where the node is, and then applying styles
 * so that it winds up being positioned absolutely, but in exactly the
 * same place.
 *
 * This is a vital part of the FLIP technique.
 */
var removeNodeFromDOMFlow = function removeNodeFromDOMFlow(childData, verticalAlignment) {
  var domNode = childData.domNode,
      boundingBox = childData.boundingBox;


  if (!domNode || !boundingBox) {
    return;
  }

  // For this to work, we have to offset any given `margin`.
  var computed = window.getComputedStyle(domNode);

  // We need to clean up margins, by converting and removing suffix:
  // eg. '21px' -> 21
  var marginAttrs = ['margin-top', 'margin-left', 'margin-right'];
  var margins = marginAttrs.reduce(function (acc, margin) {
    var _babelHelpers$extends;

    var propertyVal = computed.getPropertyValue(margin);

    return _extends({}, acc, (_babelHelpers$extends = {}, _babelHelpers$extends[margin] = Number(propertyVal.replace('px', '')), _babelHelpers$extends));
  }, {});

  // If we're bottom-aligned, we need to add the height of the child to its
  // top offset. This is because, when the container is bottom-aligned, its
  // height shrinks from the top, not the bottom. We're removing this node
  // from the flow, so the top is going to drop by its height.
  var topOffset = verticalAlignment === 'bottom' ? boundingBox.top - boundingBox.height : boundingBox.top;

  var styles = {
    position: 'absolute',
    top: topOffset - margins['margin-top'] + 'px',
    left: boundingBox.left - margins['margin-left'] + 'px',
    right: boundingBox.right - margins['margin-right'] + 'px'
  };

  applyStylesToDOMNode({ domNode: domNode, styles: styles });
};

/** updateHeightPlaceholder
 * An optional property to FlipMove is a `maintainContainerHeight` boolean.
 * This property creates a node that fills space, so that the parent
 * container doesn't collapse when its children are removed from the
 * document flow.
 */
var updateHeightPlaceholder = function updateHeightPlaceholder(_ref4) {
  var domNode = _ref4.domNode,
      parentData = _ref4.parentData,
      getPosition = _ref4.getPosition;

  var parentDomNode = parentData.domNode;
  var parentBoundingBox = parentData.boundingBox;

  if (!parentDomNode || !parentBoundingBox) {
    return;
  }

  // We need to find the height of the container *without* the placeholder.
  // Since it's possible that the placeholder might already be present,
  // we first set its height to 0.
  // This allows the container to collapse down to the size of just its
  // content (plus container padding or borders if any).
  applyStylesToDOMNode({ domNode: domNode, styles: { height: '0' } });

  // Find the distance by which the container would be collapsed by elements
  // leaving. We compare the freshly-available parent height with the original,
  // cached container height.
  var originalParentHeight = parentBoundingBox.height;
  var collapsedParentHeight = getPosition(parentDomNode).height;
  var reductionInHeight = originalParentHeight - collapsedParentHeight;

  // If the container has become shorter, update the padding element's
  // height to take up the difference. Otherwise set its height to zero,
  // so that it has no effect.
  var styles = {
    height: reductionInHeight > 0 ? reductionInHeight + 'px' : '0'
  };

  applyStylesToDOMNode({ domNode: domNode, styles: styles });
};

var getNativeNode = function getNativeNode(element) {
  // When running in a windowless environment, abort!
  if (typeof HTMLElement === 'undefined') {
    return null;
  }

  // `element` may already be a native node.
  if (element instanceof HTMLElement) {
    return element;
  }

  // While ReactDOM's `findDOMNode` is discouraged, it's the only
  // publicly-exposed way to find the underlying DOM node for
  // composite components.
  var foundNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(element);

  if (foundNode && foundNode.nodeType === Node.TEXT_NODE) {
    // Text nodes are not supported
    return null;
  }
  // eslint-disable-next-line flowtype/no-weak-types
  return foundNode;
};

var createTransitionString = function createTransitionString(index, props) {
  var delay = props.delay,
      duration = props.duration;
  var staggerDurationBy = props.staggerDurationBy,
      staggerDelayBy = props.staggerDelayBy,
      easing = props.easing;


  delay += index * staggerDelayBy;
  duration += index * staggerDurationBy;

  var cssProperties = ['transform', 'opacity'];

  return cssProperties.map(function (prop) {
    return prop + ' ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
  }).join(', ');
};

/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 *
 * For information on how this code is laid out, check out CODE_TOUR.md
 */

/* eslint-disable react/prop-types */

// eslint-disable-next-line no-duplicate-imports


var transitionEnd = whichTransitionEvent();
var noBrowserSupport = !transitionEnd;

function getKey(childData) {
  return childData.key || '';
}

function getElementChildren(children) {
  // Fix incomplete typing of Children.toArray
  // eslint-disable-next-line flowtype/no-weak-types
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(children);
}

var FlipMove$1 = function (_Component) {
  inherits(FlipMove, _Component);

  function FlipMove() {
    var _temp, _this, _ret;

    classCallCheck(this, FlipMove);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      children: getElementChildren(
      // `this.props` ought to always be defined at this point, but a report
      // was made about it not being defined in IE10.
      // TODO: Test in IE10, to see if there's an underlying cause that can
      // be addressed.
      _this.props ? _this.props.children : []).map(function (element) {
        return _extends({}, element, {
          element: element,
          appearing: true
        });
      })
    }, _this.childrenData = {}, _this.parentData = {
      domNode: null,
      boundingBox: null
    }, _this.heightPlaceholderData = {
      domNode: null
    }, _this.remainingAnimations = 0, _this.childrenToAnimate = [], _this.findDOMContainer = function () {
      // eslint-disable-next-line react/no-find-dom-node
      var domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(_this);
      var parentNode = domNode && domNode.parentNode;

      // This ought to be impossible, but handling it for Flow's sake.
      if (!parentNode || !(parentNode instanceof HTMLElement)) {
        return;
      }

      // If the parent node has static positioning, leave animations might look
      // really funky. Let's automatically apply `position: relative` in this
      // case, to prevent any quirkiness.
      if (window.getComputedStyle(parentNode).position === 'static') {
        parentNode.style.position = 'relative';
        parentNodePositionStatic();
      }

      _this.parentData.domNode = parentNode;
    }, _this.runAnimation = function () {
      var dynamicChildren = _this.state.children.filter(_this.doesChildNeedToBeAnimated);

      // Splitting DOM reads and writes to be peformed in batches
      var childrenInitialStyles = dynamicChildren.map(function (child) {
        return _this.computeInitialStyles(child);
      });
      dynamicChildren.forEach(function (child, index) {
        _this.remainingAnimations += 1;
        _this.childrenToAnimate.push(getKey(child));
        _this.animateChild(child, index, childrenInitialStyles[index]);
      });

      if (typeof _this.props.onStartAll === 'function') {
        _this.callChildrenHook(_this.props.onStartAll);
      }
    }, _this.doesChildNeedToBeAnimated = function (child) {
      // If the child doesn't have a key, it's an immovable child (one that we
      // do not want to do FLIP stuff to.)
      if (!getKey(child)) {
        return false;
      }

      var childData = _this.getChildData(getKey(child));
      var childDomNode = childData.domNode;
      var childBoundingBox = childData.boundingBox;
      var parentBoundingBox = _this.parentData.boundingBox;

      if (!childDomNode) {
        return false;
      }

      var _this$props = _this.props,
          appearAnimation = _this$props.appearAnimation,
          enterAnimation = _this$props.enterAnimation,
          leaveAnimation = _this$props.leaveAnimation,
          getPosition = _this$props.getPosition;


      var isAppearingWithAnimation = child.appearing && appearAnimation;
      var isEnteringWithAnimation = child.entering && enterAnimation;
      var isLeavingWithAnimation = child.leaving && leaveAnimation;

      if (isAppearingWithAnimation || isEnteringWithAnimation || isLeavingWithAnimation) {
        return true;
      }

      // If it isn't entering/leaving, we want to animate it if it's
      // on-screen position has changed.

      var _getPositionDelta = getPositionDelta({
        childDomNode: childDomNode,
        childBoundingBox: childBoundingBox,
        parentBoundingBox: parentBoundingBox,
        getPosition: getPosition
      }),
          dX = _getPositionDelta[0],
          dY = _getPositionDelta[1];

      return dX !== 0 || dY !== 0;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  // Copy props.children into state.
  // To understand why this is important (and not an anti-pattern), consider
  // how "leave" animations work. An item has "left" when the component
  // receives a new set of props that do NOT contain the item.
  // If we just render the props as-is, the item would instantly disappear.
  // We want to keep the item rendered for a little while, until its animation
  // can complete. Because we cannot mutate props, we make `state` the source
  // of truth.


  // FlipMove needs to know quite a bit about its children in order to do
  // its job. We store these as a property on the instance. We're not using
  // state, because we don't want changes to trigger re-renders, we just
  // need a place to keep the data for reference, when changes happen.
  // This field should not be accessed directly. Instead, use getChildData,
  // putChildData, etc...


  // Similarly, track the dom node and box of our parent element.


  // If `maintainContainerHeight` prop is set to true, we'll create a
  // placeholder element which occupies space so that the parent height
  // doesn't change when items are removed from the document flow (which
  // happens during leave animations)


  // Keep track of remaining animations so we know when to fire the
  // all-finished callback, and clean up after ourselves.
  // NOTE: we can't simply use childrenToAnimate.length to track remaining
  // animations, because we need to maintain the list of animating children,
  // to pass to the `onFinishAll` handler.


  FlipMove.prototype.componentDidMount = function componentDidMount() {
    // Because React 16 no longer requires wrapping elements, Flip Move can opt
    // to not wrap the children in an element. In that case, find the parent
    // element using `findDOMNode`.
    if (this.props.typeName === null) {
      this.findDOMContainer();
    }

    // Run our `appearAnimation` if it was requested, right after the
    // component mounts.
    var shouldTriggerFLIP = this.props.appearAnimation && !this.isAnimationDisabled(this.props);

    if (shouldTriggerFLIP) {
      this.prepForAnimation();
      this.runAnimation();
    }
  };

  FlipMove.prototype.componentDidUpdate = function componentDidUpdate(previousProps) {
    if (this.props.typeName === null) {
      this.findDOMContainer();
    }
    // If the children have been re-arranged, moved, or added/removed,
    // trigger the main FLIP animation.
    //
    // IMPORTANT: We need to make sure that the children have actually changed.
    // At the end of the transition, we clean up nodes that need to be removed.
    // We DON'T want this cleanup to trigger another update.

    var oldChildrenKeys = getElementChildren(this.props.children).map(function (d) {
      return d.key;
    });
    var nextChildrenKeys = getElementChildren(previousProps.children).map(function (d) {
      return d.key;
    });

    var shouldTriggerFLIP = !arraysEqual(oldChildrenKeys, nextChildrenKeys) && !this.isAnimationDisabled(this.props);

    if (shouldTriggerFLIP) {
      this.prepForAnimation();
      this.runAnimation();
    }
  };

  FlipMove.prototype.calculateNextSetOfChildren = function calculateNextSetOfChildren(nextChildren) {
    var _this2 = this;

    // We want to:
    //   - Mark all new children as `entering`
    //   - Pull in previous children that aren't in nextChildren, and mark them
    //     as `leaving`
    //   - Preserve the nextChildren list order, with leaving children in their
    //     appropriate places.
    //

    var updatedChildren = nextChildren.map(function (nextChild) {
      var child = _this2.findChildByKey(nextChild.key);

      // If the current child did exist, but it was in the midst of leaving,
      // we want to treat it as though it's entering
      var isEntering = !child || child.leaving;

      return _extends({}, nextChild, { element: nextChild, entering: isEntering });
    });

    // This is tricky. We want to keep the nextChildren's ordering, but with
    // any just-removed items maintaining their original position.
    // eg.
    //   this.state.children  = [ 1, 2, 3, 4 ]
    //   nextChildren         = [ 3, 1 ]
    //
    // In this example, we've removed the '2' & '4'
    // We want to end up with:  [ 2, 3, 1, 4 ]
    //
    // To accomplish that, we'll iterate through this.state.children. whenever
    // we find a match, we'll append our `leaving` flag to it, and insert it
    // into the nextChildren in its ORIGINAL position. Note that, as we keep
    // inserting old items into the new list, the "original" position will
    // keep incrementing.
    var numOfChildrenLeaving = 0;
    this.state.children.forEach(function (child, index) {
      var isLeaving = !find(function (_ref) {
        var key = _ref.key;
        return key === getKey(child);
      }, nextChildren);

      // If the child isn't leaving (or, if there is no leave animation),
      // we don't need to add it into the state children.
      if (!isLeaving || !_this2.props.leaveAnimation) return;

      var nextChild = _extends({}, child, { leaving: true });
      var nextChildIndex = index + numOfChildrenLeaving;

      updatedChildren.splice(nextChildIndex, 0, nextChild);
      numOfChildrenLeaving += 1;
    });

    return updatedChildren;
  };

  FlipMove.prototype.prepForAnimation = function prepForAnimation() {
    var _this3 = this;

    // Our animation prep consists of:
    // - remove children that are leaving from the DOM flow, so that the new
    //   layout can be accurately calculated,
    // - update the placeholder container height, if needed, to ensure that
    //   the parent's height doesn't collapse.

    var _props = this.props,
        leaveAnimation = _props.leaveAnimation,
        maintainContainerHeight = _props.maintainContainerHeight,
        getPosition = _props.getPosition;

    // we need to make all leaving nodes "invisible" to the layout calculations
    // that will take place in the next step (this.runAnimation).

    if (leaveAnimation) {
      var leavingChildren = this.state.children.filter(function (child) {
        return child.leaving;
      });

      leavingChildren.forEach(function (leavingChild) {
        var childData = _this3.getChildData(getKey(leavingChild));

        // Warn if child is disabled
        if (!_this3.isAnimationDisabled(_this3.props) && childData.domNode && childData.domNode.disabled) {
          childIsDisabled();
        }

        // We need to take the items out of the "flow" of the document, so that
        // its siblings can move to take its place.
        if (childData.boundingBox) {
          removeNodeFromDOMFlow(childData, _this3.props.verticalAlignment);
        }
      });

      if (maintainContainerHeight && this.heightPlaceholderData.domNode) {
        updateHeightPlaceholder({
          domNode: this.heightPlaceholderData.domNode,
          parentData: this.parentData,
          getPosition: getPosition
        });
      }
    }

    // For all children not in the middle of entering or leaving,
    // we need to reset the transition, so that the NEW shuffle starts from
    // the right place.
    this.state.children.forEach(function (child) {
      var _getChildData = _this3.getChildData(getKey(child)),
          domNode = _getChildData.domNode;

      // Ignore children that don't render DOM nodes (eg. by returning null)


      if (!domNode) {
        return;
      }

      if (!child.entering && !child.leaving) {
        applyStylesToDOMNode({
          domNode: domNode,
          styles: {
            transition: ''
          }
        });
      }
    });
  };

  // eslint-disable-next-line camelcase


  FlipMove.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    // When the component is handed new props, we need to figure out the
    // "resting" position of all currently-rendered DOM nodes.
    // We store that data in this.parent and this.children,
    // so it can be used later to work out the animation.
    this.updateBoundingBoxCaches();

    // Convert opaque children object to array.
    var nextChildren = getElementChildren(nextProps.children);

    // Next, we need to update our state, so that it contains our new set of
    // children. If animation is disabled or unsupported, this is easy;
    // we just copy our props into state.
    // Assuming that we can animate, though, we have to do some work.
    // Essentially, we want to keep just-deleted nodes in the DOM for a bit
    // longer, so that we can animate them away.
    this.setState({
      children: this.isAnimationDisabled(nextProps) ? nextChildren.map(function (element) {
        return _extends({}, element, { element: element });
      }) : this.calculateNextSetOfChildren(nextChildren)
    });
  };

  FlipMove.prototype.animateChild = function animateChild(child, index, childInitialStyles) {
    var _this4 = this;

    var _getChildData2 = this.getChildData(getKey(child)),
        domNode = _getChildData2.domNode;

    if (!domNode) {
      return;
    }

    // Apply the relevant style for this DOM node
    // This is the offset from its actual DOM position.
    // eg. if an item has been re-rendered 20px lower, we want to apply a
    // style of 'transform: translate(-20px)', so that it appears to be where
    // it started.
    // In FLIP terminology, this is the 'Invert' stage.
    applyStylesToDOMNode({
      domNode: domNode,
      styles: childInitialStyles
    });

    // Start by invoking the onStart callback for this child.
    if (this.props.onStart) this.props.onStart(child, domNode);

    // Next, animate the item from it's artificially-offset position to its
    // new, natural position.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        // NOTE, RE: the double-requestAnimationFrame:
        // Sadly, this is the most browser-compatible way to do this I've found.
        // Essentially we need to set the initial styles outside of any request
        // callbacks to avoid batching them. Then, a frame needs to pass with
        // the styles above rendered. Then, on the second frame, we can apply
        // our final styles to perform the animation.

        // Our first order of business is to "undo" the styles applied in the
        // previous frames, while also adding a `transition` property.
        // This way, the item will smoothly transition from its old position
        // to its new position.

        // eslint-disable-next-line flowtype/require-variable-type
        var styles = {
          transition: createTransitionString(index, _this4.props),
          transform: '',
          opacity: ''
        };

        if (child.appearing && _this4.props.appearAnimation) {
          styles = _extends({}, styles, _this4.props.appearAnimation.to);
        } else if (child.entering && _this4.props.enterAnimation) {
          styles = _extends({}, styles, _this4.props.enterAnimation.to);
        } else if (child.leaving && _this4.props.leaveAnimation) {
          styles = _extends({}, styles, _this4.props.leaveAnimation.to);
        }

        // In FLIP terminology, this is the 'Play' stage.
        applyStylesToDOMNode({ domNode: domNode, styles: styles });
      });
    });

    this.bindTransitionEndHandler(child);
  };

  FlipMove.prototype.bindTransitionEndHandler = function bindTransitionEndHandler(child) {
    var _this5 = this;

    var _getChildData3 = this.getChildData(getKey(child)),
        domNode = _getChildData3.domNode;

    if (!domNode) {
      return;
    }

    // The onFinish callback needs to be bound to the transitionEnd event.
    // We also need to unbind it when the transition completes, so this ugly
    // inline function is required (we need it here so it closes over
    // dependent variables `child` and `domNode`)
    var transitionEndHandler = function transitionEndHandler(ev) {
      // It's possible that this handler is fired not on our primary transition,
      // but on a nested transition (eg. a hover effect). Ignore these cases.
      if (ev.target !== domNode) return;

      // Remove the 'transition' inline style we added. This is cleanup.
      domNode.style.transition = '';

      // Trigger any applicable onFinish/onFinishAll hooks
      _this5.triggerFinishHooks(child, domNode);

      domNode.removeEventListener(transitionEnd, transitionEndHandler);

      if (child.leaving) {
        _this5.removeChildData(getKey(child));
      }
    };

    domNode.addEventListener(transitionEnd, transitionEndHandler);
  };

  FlipMove.prototype.triggerFinishHooks = function triggerFinishHooks(child, domNode) {
    var _this6 = this;

    if (this.props.onFinish) this.props.onFinish(child, domNode);

    // Reduce the number of children we need to animate by 1,
    // so that we can tell when all children have finished.
    this.remainingAnimations -= 1;

    if (this.remainingAnimations === 0) {
      // Remove any items from the DOM that have left, and reset `entering`.
      var nextChildren = this.state.children.filter(function (_ref2) {
        var leaving = _ref2.leaving;
        return !leaving;
      }).map(function (item) {
        return _extends({}, item, {
          // fix for Flow
          element: item.element,
          appearing: false,
          entering: false
        });
      });

      this.setState({ children: nextChildren }, function () {
        if (typeof _this6.props.onFinishAll === 'function') {
          _this6.callChildrenHook(_this6.props.onFinishAll);
        }

        // Reset our variables for the next iteration
        _this6.childrenToAnimate = [];
      });

      // If the placeholder was holding the container open while elements were
      // leaving, we we can now set its height to zero.
      if (this.heightPlaceholderData.domNode) {
        this.heightPlaceholderData.domNode.style.height = '0';
      }
    }
  };

  FlipMove.prototype.callChildrenHook = function callChildrenHook(hook) {
    var _this7 = this;

    var elements = [];
    var domNodes = [];

    this.childrenToAnimate.forEach(function (childKey) {
      // If this was an exit animation, the child may no longer exist.
      // If so, skip it.
      var child = _this7.findChildByKey(childKey);

      if (!child) {
        return;
      }

      elements.push(child);

      if (_this7.hasChildData(childKey)) {
        domNodes.push(_this7.getChildData(childKey).domNode);
      }
    });

    hook(elements, domNodes);
  };

  FlipMove.prototype.updateBoundingBoxCaches = function updateBoundingBoxCaches() {
    var _this8 = this;

    // This is the ONLY place that parentData and childrenData's
    // bounding boxes are updated. They will be calculated at other times
    // to be compared to this value, but it's important that the cache is
    // updated once per update.
    var parentDomNode = this.parentData.domNode;

    if (!parentDomNode) {
      return;
    }

    this.parentData.boundingBox = this.props.getPosition(parentDomNode);

    // Splitting DOM reads and writes to be peformed in batches
    var childrenBoundingBoxes = [];

    this.state.children.forEach(function (child) {
      var childKey = getKey(child);

      // It is possible that a child does not have a `key` property;
      // Ignore these children, they don't need to be moved.
      if (!childKey) {
        childrenBoundingBoxes.push(null);
        return;
      }

      // In very rare circumstances, for reasons unknown, the ref is never
      // populated for certain children. In this case, avoid doing this update.
      // see: https://github.com/joshwcomeau/react-flip-move/pull/91
      if (!_this8.hasChildData(childKey)) {
        childrenBoundingBoxes.push(null);
        return;
      }

      var childData = _this8.getChildData(childKey);

      // If the child element returns null, we need to avoid trying to
      // account for it
      if (!childData.domNode || !child) {
        childrenBoundingBoxes.push(null);
        return;
      }

      childrenBoundingBoxes.push(getRelativeBoundingBox({
        childDomNode: childData.domNode,
        parentDomNode: parentDomNode,
        getPosition: _this8.props.getPosition
      }));
    });

    this.state.children.forEach(function (child, index) {
      var childKey = getKey(child);

      var childBoundingBox = childrenBoundingBoxes[index];

      if (!childKey) {
        return;
      }

      _this8.setChildData(childKey, {
        boundingBox: childBoundingBox
      });
    });
  };

  FlipMove.prototype.computeInitialStyles = function computeInitialStyles(child) {
    if (child.appearing) {
      return this.props.appearAnimation ? this.props.appearAnimation.from : {};
    } else if (child.entering) {
      if (!this.props.enterAnimation) {
        return {};
      }
      // If this child was in the middle of leaving, it still has its
      // absolute positioning styles applied. We need to undo those.
      return _extends({
        position: '',
        top: '',
        left: '',
        right: '',
        bottom: ''
      }, this.props.enterAnimation.from);
    } else if (child.leaving) {
      return this.props.leaveAnimation ? this.props.leaveAnimation.from : {};
    }

    var childData = this.getChildData(getKey(child));
    var childDomNode = childData.domNode;
    var childBoundingBox = childData.boundingBox;
    var parentBoundingBox = this.parentData.boundingBox;

    if (!childDomNode) {
      return {};
    }

    var _getPositionDelta2 = getPositionDelta({
      childDomNode: childDomNode,
      childBoundingBox: childBoundingBox,
      parentBoundingBox: parentBoundingBox,
      getPosition: this.props.getPosition
    }),
        dX = _getPositionDelta2[0],
        dY = _getPositionDelta2[1];

    return {
      transform: 'translate(' + dX + 'px, ' + dY + 'px)'
    };
  };

  // eslint-disable-next-line class-methods-use-this


  FlipMove.prototype.isAnimationDisabled = function isAnimationDisabled(props) {
    // If the component is explicitly passed a `disableAllAnimations` flag,
    // we can skip this whole process. Similarly, if all of the numbers have
    // been set to 0, there is no point in trying to animate; doing so would
    // only cause a flicker (and the intent is probably to disable animations)
    // We can also skip this rigamarole if there's no browser support for it.
    return noBrowserSupport || props.disableAllAnimations || props.duration === 0 && props.delay === 0 && props.staggerDurationBy === 0 && props.staggerDelayBy === 0;
  };

  FlipMove.prototype.findChildByKey = function findChildByKey(key) {
    return find(function (child) {
      return getKey(child) === key;
    }, this.state.children);
  };

  FlipMove.prototype.hasChildData = function hasChildData(key) {
    // Object has some built-in properties on its prototype, such as toString.  hasOwnProperty makes
    // sure that key is present on childrenData itself, not on its prototype.
    return Object.prototype.hasOwnProperty.call(this.childrenData, key);
  };

  FlipMove.prototype.getChildData = function getChildData(key) {
    return this.hasChildData(key) ? this.childrenData[key] : {};
  };

  FlipMove.prototype.setChildData = function setChildData(key, data) {
    this.childrenData[key] = _extends({}, this.getChildData(key), data);
  };

  FlipMove.prototype.removeChildData = function removeChildData(key) {
    delete this.childrenData[key];
    this.setState(function (prevState) {
      return _extends({}, prevState, {
        children: prevState.children.filter(function (child) {
          return child.element.key !== key;
        })
      });
    });
  };

  FlipMove.prototype.createHeightPlaceholder = function createHeightPlaceholder() {
    var _this9 = this;

    var typeName = this.props.typeName;

    // If requested, create an invisible element at the end of the list.
    // Its height will be modified to prevent the container from collapsing
    // prematurely.

    var isContainerAList = typeName === 'ul' || typeName === 'ol';
    var placeholderType = isContainerAList ? 'li' : 'div';

    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(placeholderType, {
      key: 'height-placeholder',
      ref: function ref(domNode) {
        _this9.heightPlaceholderData.domNode = domNode;
      },
      style: { visibility: 'hidden', height: 0 }
    });
  };

  FlipMove.prototype.childrenWithRefs = function childrenWithRefs() {
    var _this10 = this;

    // We need to clone the provided children, capturing a reference to the
    // underlying DOM node. Flip Move needs to use the React escape hatches to
    // be able to do its calculations.
    return this.state.children.map(function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child.element, {
        ref: function ref(element) {
          // Stateless Functional Components are not supported by FlipMove,
          // because they don't have instances.
          if (!element) {
            return;
          }

          var domNode = getNativeNode(element);
          _this10.setChildData(getKey(child), { domNode: domNode });
        }
      });
    });
  };

  FlipMove.prototype.render = function render() {
    var _this11 = this;

    var _props2 = this.props,
        typeName = _props2.typeName,
        delegated = _props2.delegated,
        leaveAnimation = _props2.leaveAnimation,
        maintainContainerHeight = _props2.maintainContainerHeight;


    var children = this.childrenWithRefs();
    if (leaveAnimation && maintainContainerHeight) {
      children.push(this.createHeightPlaceholder());
    }

    if (!typeName) return children;

    var props = _extends({}, delegated, {
      children: children,
      ref: function ref(node) {
        _this11.parentData.domNode = node;
      }
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(typeName, props);
  };

  return FlipMove;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var enhancedFlipMove = /* #__PURE__ */propConverter(FlipMove$1);

/**
 * React Flip Move
 * (c) 2016-present Joshua Comeau
 */

/* harmony default export */ __webpack_exports__["a"] = (enhancedFlipMove);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {"california":{"population":"9261018","latinx":52,"white":27,"black":5,"asian":11,"other":5,"immigrantFamilies":4296455,"poverty":45,"homeless":204085},"alameda":{"population":"351696","latinx":32,"white":25,"black":10,"asian":26,"other":7,"immigrantFamilies":184734,"poverty":31,"homeless":3189},"alpine":{"population":"190","latinx":7,"white":61,"black":0,"asian":0,"other":32,"immigrantFamilies":15,"poverty":26,"homeless":14},"amador":{"population":"5642","latinx":22,"white":70,"black":1,"asian":1,"other":6,"immigrantFamilies":485,"poverty":40,"homeless":76},"butte":{"population":"46448","latinx":25,"white":60,"black":1,"asian":6,"other":8,"immigrantFamilies":7875,"poverty":47,"homeless":882},"calaveras":{"population":"7178","latinx":18,"white":74,"black":1,"asian":1,"other":6,"immigrantFamilies":547,"poverty":38,"homeless":156},"colusa":{"population":"6121","latinx":74,"white":22,"black":1,"asian":1,"other":2,"immigrantFamilies":3190,"poverty":55,"homeless":186},"contraCosta":{"population":"251554","latinx":35,"white":34,"black":9,"asian":14,"other":8,"immigrantFamilies":113739,"poverty":30,"homeless":1705},"delNorte":{"population":"5816","latinx":25,"white":52,"black":1,"asian":5,"other":17,"immigrantFamilies":710,"poverty":58,"homeless":97},"elDorado":{"population":"35745","latinx":22,"white":67,"black":1,"asian":4,"other":6,"immigrantFamilies":7485,"poverty":28,"homeless":605},"fresno":{"population":"282393","latinx":65,"white":18,"black":5,"asian":9,"other":3,"immigrantFamilies":116495,"poverty":63,"homeless":3308},"glenn":{"population":"7481","latinx":54,"white":40,"black":0,"asian":2,"other":4,"immigrantFamilies":3246,"poverty":58,"homeless":343},"humboldt":{"population":"28453","latinx":19,"white":61,"black":1,"asian":4,"other":15,"immigrantFamilies":3344,"poverty":53,"homeless":958},"imperial":{"population":"55371","latinx":90,"white":8,"black":1,"asian":1,"other":1,"immigrantFamilies":25382,"poverty":58,"homeless":1556},"inyo":{"population":"3870","latinx":41,"white":42,"black":0,"asian":1,"other":16,"immigrantFamilies":916,"poverty":39,"homeless":32},"kern":{"population":"256078","latinx":65,"white":24,"black":5,"asian":3,"other":3,"immigrantFamilies":106279,"poverty":60,"homeless":3534},"kings":{"population":"46215","latinx":69,"white":21,"black":4,"asian":3,"other":4,"immigrantFamilies":14646,"poverty":61,"homeless":612},"lake":{"population":"13632","latinx":33,"white":56,"black":1,"asian":1,"other":8,"immigrantFamilies":2682,"poverty":60,"homeless":395},"lassen":{"population":"5294","latinx":20,"white":69,"black":2,"asian":2,"other":8,"immigrantFamilies":453,"poverty":45,"homeless":22},"losAngeles":{"population":"2298592","latinx":61,"white":18,"black":7,"asian":10,"other":3,"immigrantFamilies":1285180,"poverty":51,"homeless":52965},"madera":{"population":"42250","latinx":74,"white":20,"black":2,"asian":1,"other":2,"immigrantFamilies":19582,"poverty":64,"homeless":836},"marin":{"population":"52222","latinx":25,"white":60,"black":2,"asian":5,"other":7,"immigrantFamilies":18720,"poverty":23,"homeless":712},"mariposa":{"population":"2834","latinx":17,"white":77,"black":0,"asian":1,"other":6,"immigrantFamilies":408,"poverty":41,"homeless":54},"mendocino":{"population":"19133","latinx":41,"white":47,"black":0,"asian":1,"other":10,"immigrantFamilies":5228,"poverty":58,"homeless":670},"merced":{"population":"80521","latinx":71,"white":18,"black":3,"asian":7,"other":2,"immigrantFamilies":40296,"poverty":66,"homeless":1240},"modoc":{"population":"1769","latinx":23,"white":70,"black":0,"asian":0,"other":7,"immigrantFamilies":259,"poverty":52,"homeless":0},"mono":{"population":"2836","latinx":49,"white":47,"black":0,"asian":0,"other":4,"immigrantFamilies":1184,"poverty":53,"homeless":11},"monterey":{"population":"116022","latinx":75,"white":17,"black":1,"asian":3,"other":3,"immigrantFamilies":67277,"poverty":55,"homeless":6764},"napa":{"population":"29273","latinx":52,"white":37,"black":1,"asian":7,"other":4,"immigrantFamilies":15217,"poverty":35,"homeless":307},"nevada":{"population":"16033","latinx":17,"white":76,"black":0,"asian":1,"other":5,"immigrantFamilies":2463,"poverty":36,"homeless":281},"orange":{"population":"724718","latinx":47,"white":30,"black":1,"asian":17,"other":5,"immigrantFamilies":378917,"poverty":37,"homeless":24194},"placer":{"population":"76338","latinx":21,"white":65,"black":1,"asian":6,"other":7,"immigrantFamilies":17792,"poverty":23,"homeless":1248},"plumas":{"population":"3175","latinx":16,"white":75,"black":1,"asian":0,"other":8,"immigrantFamilies":322,"poverty":37,"homeless":65},"riverside":{"population":"601945","latinx":61,"white":25,"black":6,"asian":5,"other":4,"immigrantFamilies":258218,"poverty":48,"homeless":15955},"sacramento":{"population":"363983","latinx":33,"white":33,"black":11,"asian":15,"other":8,"immigrantFamilies":137220,"poverty":47,"homeless":6185},"sanBenito":{"population":"14289","latinx":73,"white":23,"black":0,"asian":1,"other":2,"immigrantFamilies":5465,"poverty":40,"homeless":216},"sanBernardino":{"population":"581301","latinx":64,"white":19,"black":9,"asian":5,"other":3,"immigrantFamilies":224393,"poverty":53,"homeless":24391},"sanDiego":{"population":"804235","latinx":47,"white":33,"black":4,"asian":9,"other":6,"immigrantFamilies":313619,"poverty":41,"homeless":15353},"sanFrancisco":{"population":"132330","latinx":22,"white":36,"black":5,"asian":28,"other":9,"immigrantFamilies":60338,"poverty":28,"homeless":1937},"sanJoaquin":{"population":"201902","latinx":54,"white":20,"black":7,"asian":13,"other":6,"immigrantFamilies":88507,"poverty":50,"homeless":2494},"sanLuisObispo":{"population":"51974","latinx":38,"white":54,"black":1,"asian":3,"other":5,"immigrantFamilies":12621,"poverty":36,"homeless":2522},"sanMateo":{"population":"163129","latinx":33,"white":34,"black":2,"asian":24,"other":8,"immigrantFamilies":89924,"poverty":24,"homeless":1580},"santaBarbara":{"population":"103199","latinx":65,"white":27,"black":1,"asian":3,"other":4,"immigrantFamilies":47308,"poverty":47,"homeless":8692},"santaClara":{"population":"448977","latinx":36,"white":24,"black":2,"asian":32,"other":6,"immigrantFamilies":266742,"poverty":25,"homeless":2676},"santaCruz":{"population":"60678","latinx":53,"white":40,"black":1,"asian":2,"other":4,"immigrantFamilies":23451,"poverty":38,"homeless":3174},"shasta":{"population":"37648","latinx":15,"white":71,"black":1,"asian":3,"other":9,"immigrantFamilies":3452,"poverty":50,"homeless":410},"sierra":{"population":"469","latinx":12,"white":83,"black":0,"asian":0,"other":5,"immigrantFamilies":68,"poverty":29,"homeless":7},"siskiyou":{"population":"8574","latinx":19,"white":66,"black":1,"asian":1,"other":12,"immigrantFamilies":788,"poverty":59,"homeless":223},"solano":{"population":"101176","latinx":38,"white":28,"black":13,"asian":11,"other":10,"immigrantFamilies":34030,"poverty":39,"homeless":886},"sonoma":{"population":"98066","latinx":43,"white":47,"black":1,"asian":3,"other":6,"immigrantFamilies":38507,"poverty":38,"homeless":826},"stanislaus":{"population":"146558","latinx":60,"white":28,"black":3,"asian":5,"other":4,"immigrantFamilies":55464,"poverty":53,"homeless":1933},"sutter":{"population":"25070","latinx":43,"white":36,"black":2,"asian":13,"other":6,"immigrantFamilies":10267,"poverty":53,"homeless":227},"tehama":{"population":"15528","latinx":37,"white":56,"black":0,"asian":1,"other":5,"immigrantFamilies":2839,"poverty":61,"homeless":337},"trinity":{"population":"2150","latinx":13,"white":76,"black":0,"asian":0,"other":10,"immigrantFamilies":104,"poverty":50,"homeless":120},"tulare":{"population":"144290","latinx":77,"white":17,"black":1,"asian":2,"other":2,"immigrantFamilies":65042,"poverty":67,"homeless":2370},"tuolumne":{"population":"8567","latinx":19,"white":73,"black":1,"asian":1,"other":6,"immigrantFamilies":455,"poverty":41,"homeless":175},"ventura":{"population":"197155","latinx":58,"white":31,"black":1,"asian":5,"other":4,"immigrantFamilies":87878,"poverty":36,"homeless":3455},"yolo":{"population":"51447","latinx":46,"white":36,"black":3,"asian":9,"other":6,"immigrantFamilies":19615,"poverty":39,"homeless":662},"yuba":{"population":"21485","latinx":38,"white":44,"black":3,"asian":7,"other":8,"immigrantFamilies":5072,"poverty":55,"homeless":262}}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sprite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spritemanifest__ = __webpack_require__(147);
var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    fill: var(--',');\n    &:hover{\n        fill: var(--',');\n    }\n'],['\n    position: relative;\n    fill: var(--',');\n    &:hover{\n        fill: var(--',');\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n    width: 100%;\n    height: 100%;\n    /*transition: fill .25s;*/\n'],['\n    position: absolute;\n    top: 0; left: 0;\n    width: 100%;\n    height: 100%;\n    /*transition: fill .25s;*/\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: inline-flex;\n    /*outline: 1px solid red;*/\n    width: ','px; height: ','px;\n    overflow: hidden;\n'],['\n    display: inline-flex;\n    /*outline: 1px solid red;*/\n    width: ','px; height: ','px;\n    overflow: hidden;\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: auto;\n    height: 100%;\n    animation-duration: ','s;\n    animation-fill-mode: ',';\n    animation-timing-function: steps(',', end);\n    &.up{\n        /*animation: spriteForward .08s steps(5) forwards;*/\n        /*transform:translateX(','%);*/\n        animation-name: ',';\n       \n    }\n    &.down{\n        animation-name: ',';\n    }\n'],['\n    width: auto;\n    height: 100%;\n    animation-duration: ','s;\n    animation-fill-mode: ',';\n    animation-timing-function: steps(',', end);\n    &.up{\n        /*animation: spriteForward .08s steps(5) forwards;*/\n        /*transform:translateX(','%);*/\n        animation-name: ',';\n       \n    }\n    &.down{\n        animation-name: ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral(['',''],['','']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var icons={x:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'33.1,6.1 29.8,2.8 17.9,14.5 6,2.8 2.7,6.1 14.4,18 2.7,29.9 6,33.2 17.9,21.5 29.8,33.2 33.1,29.9 21.4,18 '}),x_thin:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'17.9,20.4 29.8,32.1 32,29.9 20.3,18 32,6.1 29.8,3.9 17.9,15.6 6,3.9 3.8,6.1 15.5,18 3.8,29.9 6,32.1 '}),chevright:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'22.8,18.4 10.6,30.6 11,30.6 13.2,30.6 25.4,18.4 13.1,5.4 10.6,5.4 '}),chevright_thin:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'11.5,4.2 12.7,4.2 25,18.4 12.8,31.8 10.6,31.8 11.5,31.8 23.7,18.4 '}),chevleft:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'25.4,5.4 22.9,5.4 10.6,18.4 22.8,30.6 25,30.6 25.4,30.6 13.2,18.4 '}),chevleft_thin:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',{points:'22.8,31.8 10.6,18.4 22.9,4.2 24.1,4.2 11.9,18.4 24.1,31.8 '}),chevup:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'30.6,24.8 30.6,21.5 17.6,9.2 5.4,21.4 5.4,24.8 17.6,12.6 '}),minigraph:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'5.2',y:'7.1',width:'2',height:'21.7'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'10.8',y:'8.6',width:'14.4',height:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'10.8',y:'25.5',width:'9.5',height:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'10.8',y:'17',width:'19',height:'2.1'})),searchzoom:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M32.5,29.2l-8.7-8.7c1.2-1.7,1.7-3.9,1.7-6c0.2-6-4.8-11-11-11c-6,0-11,5-11,11c0,6.2,5,11,11,11 c2.1,0,4.3-0.6,6-1.7l8.7,8.7L32.5,29.2z M14.5,21.5c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7C21.5,18.4,18.4,21.5,14.5,21.5z'}),reset:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M34.1,3H23.3v10.7h2.3V6.6c3.7,2.5,5.9,6.6,5.9,11.2c-0.1,3.7-1.6,7.1-4.2,9.6c-2.6,2.6-6,4-9.6,3.9 c-3.7-0.1-7.1-1.6-9.6-4.2c-2.6-2.6-4-6-3.9-9.5c0.1-6.4,4.7-12,11-13.3l0.5-0.1l-0.4-2.3L14.7,2C7.4,3.5,2,10,1.9,17.4 c-0.1,4.1,1.6,8.2,4.6,11.3c2.9,3,7,4.8,11.2,4.9h0.3c4.2,0,8.1-1.6,11-4.6c3-2.9,4.8-7,4.9-11.2c0-4.9-2.2-9.5-5.9-12.5h6.3V3z'}),ind:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'6',y:'7.3',width:'2',height:'21.7'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M11.5,8.8v3.5h14.4V8.8H11.5z M24.9,11.3H12.5V9.8h12.4V11.3z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M20,25.1v1.5h-7.5v-1.5H20 M21,24.1h-9.5v3.5H21V24.1L21,24.1z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M29.5,17.4v1.5h-17v-1.5H29.5 M30.5,16.4h-19v3.5h19V16.4L30.5,16.4z'})),check:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'29.5,7.5 14.9,24.7 8,17.1 4.6,17.1 14.9,28.5 31.4,9.2 '}),getstartedarrow:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'24.8,10 23.6,11 28.2,16.2 6,16.2 6,17.8 28.2,17.8 23.6,23 24.8,24 31.1,17 '}),document:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'25.7,29.8 8.3,29.8 8.3,8.2 16.6,8.2 16.6,8.9 9,8.9 9,29.1 25,29.1 25,17.2 25.7,17.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'22.2,6.2 22.2,6.9 26.4,6.9 16.1,17.3 16.6,17.8 27,7.5 27,11.8 27.7,11.8 27.7,6.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'25.8,29.8 8.4,29.9 8.2,8.2 16.6,8.2 16.6,8.9 9,9 9.1,29.1 25,29 25,17.2 25.7,17.2 '})),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M24.1,3.6c0,0.7-0.2,1.4-0.4,2c4.7,2.2,8,6.9,8,12.4c0,7.5-6.1,13.6-13.6,13.6S4.4,25.5,4.4,18 c0-5.6,3.4-10.4,8.3-12.5c-0.2-0.6-0.4-1.3-0.4-2c0,0,0,0,0,0C6.5,5.8,2.4,11.4,2.4,18c0,8.6,7,15.6,15.6,15.6s15.6-7,15.6-15.6 C33.6,11.5,29.7,6,24.1,3.6z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse',{cx:'18.1',cy:'3.6',rx:'2.2',ry:'2.1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M19.6,23.8c0-1.7-0.1-3.8-0.1-5.3v-4.4l0.1-4.5l-0.5-0.3l-5.1,2v1.2l2.7,0.3c0.1,1.3,0.1,2.3,0.1,4.2v1.6 c0,1.5,0,3.6-0.1,5.3l-2.5,0.5v1.2h2.5h2.9h2.3v-1.2L19.6,23.8z'})),strokefeedback:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'28.5,7.5 7.5,7.5 7.5,23.2 11.8,23.2 11.8,29.5 18.1,23.2 28.5,23.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:'18',y1:'19.4',x2:'18',y2:'18.4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{x1:'18',y1:'17.1',x2:'18',y2:'10.8'}))};var IconWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,function(props){return props.color;},function(props){return props.hoverColor||props.color;});var IconSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].svg(_templateObject2);var Icon=function Icon(props){var img=props.img,restOfProps=_objectWithoutProperties(props,['img']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconWrapper,restOfProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconSvg,{viewBox:'0 0 36 36',className:'icon-'+img},icons[img]));};var SpriteWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(IconWrapper)(_templateObject3,function(props){return props.width;},function(props){return props.height;});var SpriteSvg=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(IconSvg)(_templateObject4,function(props){return props.duration;},function(props){return props.fillMode||'forwards';},function(props){return props.numFrames-1;},function(props){return-100*((props.numFrames-1)/props.numFrames);},function(props){return computeAnim(0,-100*((props.numFrames-1)/props.numFrames));},function(props){return computeAnim(-100*((props.numFrames-1)/props.numFrames),0);});// const chevUp = keyframes`
//     from{ transform: translateX(0); }
//     to{ transform: translateX(-87.5%); }
// `
// const chevDown = keyframes`
//     from{ transform: translateX(-87.5%); }
//     to{ transform: translateX(0); }
// `
//     &.sprite-chevsprite{
//         &.up{
//             animation-name: ${chevUp};
//         }
//         &.down{
//             animation-name: ${chevDown};
//         }
//     }
var computeAnim=function computeAnim(from,goTo){var frames='\n        0%{\n            transform: translateX('+from+'%);\n        }\n        100%{\n            transform: translateX('+goTo+'%);\n        }\n    ';return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject5,frames);};var Sprite=function Sprite(props){var width=props.width,height=props.height,img=props.img,state=props.state,restOfProps=_objectWithoutProperties(props,['width','height','img','state']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpriteWrapper,Object.assign({width:width||25,height:height||25},restOfProps),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpriteSvg,{viewBox:__WEBPACK_IMPORTED_MODULE_2__spritemanifest__["a" /* default */][img].viewBox,className:['sprite-'+img,state].join(' '),numFrames:__WEBPACK_IMPORTED_MODULE_2__spritemanifest__["a" /* default */][img].frames,duration:props.duration||.35,fillMode:props.fillMode},__WEBPACK_IMPORTED_MODULE_2__spritemanifest__["a" /* default */][img].paths));};/* harmony default export */ __webpack_exports__["b"] = (Icon);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return counties; });
/* unused harmony export randomValuesForCountiesToTestHeatMap */
var counties=[{label:'Imperial',id:'imperial'},{label:'Los Angeles',id:'losAngeles'},{label:'San Diego',id:'sanDiego'},{label:'Orange',id:'orange'},{label:'Santa Barbara',id:'santaBarbara'},{label:'Riverside',id:'riverside'},{label:'Ventura',id:'ventura'},{label:'San Bernardino',id:'sanBernardino'},{label:'Kern',id:'kern'},{label:'Tulare',id:'tulare'},{label:'Inyo',id:'inyo'},{label:'Mono',id:'mono'},{label:'Alpine',id:'alpine'},{label:'San Luis Obispo',id:'sanLuisObispo'},{label:'Kings',id:'kings'},{label:'Monterey',id:'monterey'},{label:'San Benito',id:'sanBenito'},{label:'Santa Cruz',id:'santaCruz'},{label:'Santa Clara',id:'santaClara'},{label:'Fresno',id:'fresno'},{label:'Merced',id:'merced'},{label:'San Mateo',id:'sanMateo'},{label:'Madera',id:'madera'},{label:'Contra Costa',id:'contraCosta'},{label:'Mariposa',id:'mariposa'},{label:'Alameda',id:'alameda'},{label:'Stanislaus',id:'stanislaus'},{label:'Solano',id:'solano'},{label:'San Joaquin',id:'sanJoaquin'},{label:'Marin',id:'marin'},{label:'Tuolumne',id:'tuolumne'},{label:'Calaveras',id:'calaveras'},{label:'Amador',id:'amador'},{label:'Sacramento',id:'sacramento'},{label:'Sonoma',id:'sonoma'},{label:'Napa',id:'napa'},{label:'Yolo',id:'yolo'},{label:'El Dorado',id:'elDorado'},{label:'Sutter',id:'sutter'},{label:'Placer',id:'placer'},{label:'Colusa',id:'colusa'},{label:'Nevada',id:'nevada'},{label:'Lake',id:'lake'},{label:'Yuba',id:'yuba'},{label:'Sierra',id:'sierra'},{label:'Glenn',id:'glenn'},{label:'Mendocino',id:'mendocino'},{label:'Butte',id:'butte'},{label:'Plumas',id:'plumas'},{label:'Tehama',id:'tehama'},{label:'Lassen',id:'lassen'},{label:'Shasta',id:'shasta'},{label:'Trinity',id:'trinity'},{label:'Humboldt',id:'humboldt'},{label:'Modoc',id:'modoc'},{label:'Del Norte',id:'delNorte'},{label:'Siskiyou',id:'siskiyou'},{label:'San Francisco',id:'sanFrancisco'}];var randomValuesForCountiesToTestHeatMap={};counties.forEach(function(county){randomValuesForCountiesToTestHeatMap[county.id]=Math.random().toFixed(3);});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = {"imperial":"Imperial","losAngeles":"Los Angeles","sanDiego":"San Diego","orange":"Orange","santaBarbara":"Santa Barbara","riverside":"Riverside","ventura":"Ventura","sanBernardino":"San Bernardino","kern":"Kern","tulare":"Tulare","inyo":"Inyo","mono":"Mono","alpine":"Alpine","sanLuisObispo":"San Luis Obispo","kings":"Kings","monterey":"Monterey","sanBenito":"San Benito","santaCruz":"Santa Cruz","santaClara":"Santa Clara","fresno":"Fresno","merced":"Merced","sanMateo":"San Mateo","madera":"Madera","contraCosta":"Contra Costa","mariposa":"Mariposa","alameda":"Alameda","stanislaus":"Stanislaus","solano":"Solano","sanJoaquin":"San Joaquin","marin":"Marin","tuolumne":"Tuolumne","calaveras":"Calaveras","amador":"Amador","sacramento":"Sacramento","sonoma":"Sonoma","napa":"Napa","yolo":"Yolo","elDorado":"El Dorado","sutter":"Sutter","placer":"Placer","colusa":"Colusa","nevada":"Nevada","lake":"Lake","yuba":"Yuba","sierra":"Sierra","glenn":"Glenn","mendocino":"Mendocino","butte":"Butte","plumas":"Plumas","tehama":"Tehama","lassen":"Lassen","shasta":"Shasta","trinity":"Trinity","humboldt":"Humboldt","modoc":"Modoc","delNorte":"Del Norte","siskiyou":"Siskiyou","sanFrancisco":"San Francisco"}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExpandTest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_custom_scrollbars__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_custom_scrollbars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_custom_scrollbars__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    overflow: hidden;\n    animation-timing-function: step-end;\n    animation-fill-mode: both;\n    animation-duration: ','s;\n    transform-origin: 0% 0%;\n    /*border: 3px solid green;*/\n    width: ','px;\n    height: ','px;\n    animation-name: ',';\n\n    animation-delay: ',';\n    top: 0;\n    left: 0;\n    transition: background-color .35s;\n'],['\n    position: absolute;\n    overflow: hidden;\n    animation-timing-function: step-end;\n    animation-fill-mode: both;\n    animation-duration: ','s;\n    transform-origin: 0% 0%;\n    /*border: 3px solid green;*/\n    width: ','px;\n    height: ','px;\n    animation-name: ',';\n\n    animation-delay: ',';\n    top: 0;\n    left: 0;\n    transition: background-color .35s;\n']),_templateObject2=_taggedTemplateLiteral(['\n    transform-origin: 0% 0%;\n    animation-timing-function: step-end;\n    animation-fill-mode: both;\n    animation-duration: ','s;\n\n    animation-name: ',';\n    animation-delay: ',';\n    display: flex;\n    align-items: ',';\n    white-space: nowrap;\n'],['\n    transform-origin: 0% 0%;\n    animation-timing-function: step-end;\n    animation-fill-mode: both;\n    animation-duration: ','s;\n\n    animation-name: ',';\n    animation-delay: ',';\n    display: flex;\n    align-items: ',';\n    white-space: nowrap;\n']),_templateObject3=_taggedTemplateLiteral(['',''],['','']),_templateObject4=_taggedTemplateLiteral(['\n    /*position: relative; */\n    position: absolute;\n    width: ','px;\n    height: ','px;\n    border: 1px solid transparent;\n'],['\n    /*position: relative; */\n    position: absolute;\n    width: ','px;\n    height: ','px;\n    border: 1px solid transparent;\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    transition: transform ','s cubic-bezier(0.215, 0.61, 0.355, 1), border-color .25s;\n    transition-delay: ',';\n    transform-origin: 0% 0%;\n    z-index: 2;\n'],['\n    position: absolute;\n    transition: transform ','s cubic-bezier(0.215, 0.61, 0.355, 1), border-color .25s;\n    transition-delay: ',';\n    transform-origin: 0% 0%;\n    z-index: 2;\n']),_templateObject6=_taggedTemplateLiteral(['\n    width: 100%;\n    border-top: 1px solid ',';\n    top: 0;\n    transform: scaleX(',');\n'],['\n    width: 100%;\n    border-top: 1px solid ',';\n    top: 0;\n    transform: scaleX(',');\n']),_templateObject7=_taggedTemplateLiteral(['\n    border-bottom: 1px solid ',';\n    width: 100%;\n    top: 0;\n    transform: translateY(','px) scaleX(',');\n'],['\n    border-bottom: 1px solid ',';\n    width: 100%;\n    top: 0;\n    transform: translateY(','px) scaleX(',');\n']),_templateObject8=_taggedTemplateLiteral(['\n    border-left: 1px solid ',';\n    height: 100%;\n    left: 0;\n    transform: scaleY(',');\n'],['\n    border-left: 1px solid ',';\n    height: 100%;\n    left: 0;\n    transform: scaleY(',');\n']),_templateObject9=_taggedTemplateLiteral(['\n    border-right: 1px solid ',';\n    height: 100%;\n    left: 0;\n    transform: translateX(','px) scaleY(',');\n'],['\n    border-right: 1px solid ',';\n    height: 100%;\n    left: 0;\n    transform: translateX(','px) scaleY(',');\n']),_templateObject10=_taggedTemplateLiteral(['\n    z-index: 3;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    height: 0;\n    display: flex;\n    align-items: center;\n'],['\n    z-index: 3;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    height: 0;\n    display: flex;\n    align-items: center;\n']),_templateObject11=_taggedTemplateLiteral(['\n    z-index: 3;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    height: 0;\n    display: flex;\n    align-items: center;\n    transition: transform ','s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateY(','px);\n\n'],['\n    z-index: 3;\n    position: absolute;\n    width: 100%;\n    top: 0;\n    height: 0;\n    display: flex;\n    align-items: center;\n    transition: transform ','s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateY(','px);\n\n']),_templateObject12=_taggedTemplateLiteral(['\n    /*border: 1px solid red;*/\n    z-index: 1;\n    position: absolute;\n    left: 1px;\n    width: ','px;\n    height: 45px;\n    background: linear-gradient(var(--offwhitefg) 30%, rgba(252,253,255,0) 80%);\n    opacity: ',';\n    transition: opacity .25s;\n    /*border: 1px solid green;*/\n\n'],['\n    /*border: 1px solid red;*/\n    z-index: 1;\n    position: absolute;\n    left: 1px;\n    width: ','px;\n    height: 45px;\n    background: linear-gradient(var(--offwhitefg) 30%, rgba(252,253,255,0) 80%);\n    opacity: ',';\n    transition: opacity .25s;\n    /*border: 1px solid green;*/\n\n']),_templateObject13=_taggedTemplateLiteral(['\n    top: ','px;\n    height: 45px;\n    background: linear-gradient(to top, var(--offwhitefg) 30%, rgba(252,253,255,0) 80%);\n'],['\n    top: ','px;\n    height: 45px;\n    background: linear-gradient(to top, var(--offwhitefg) 30%, rgba(252,253,255,0) 80%);\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Box=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject,function(props){return props.duration;},function(props){return props.current.width;},function(props){return props.current.height;},function(props){return props.animFrames;},function(props){return props.delay;});var Content=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.duration;},function(props){return props.animFrames;},function(props){return props.delay;},function(props){return props.dontAlignContentsToCenter?'normal':'center';});var computeAnim=function computeAnim(goTo,startFrom,invert){var ratioX=goTo.width/startFrom.width;var ratioY=goTo.height/startFrom.height;var frames='';for(var step=0;step<101;step++){var easedStep=ease(step/100);var scaleX=void 0,scaleY=void 0;scaleX=ratioX+(1-ratioX)*easedStep;scaleY=ratioY+(1-ratioY)*easedStep;if(invert){scaleX=1/scaleX;scaleY=1/scaleY;}frames+=step+'% { \n                transform: scale('+scaleX.toFixed(5)+', '+scaleY.toFixed(5)+'); \n            } ';}return Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* keyframes */])(_templateObject3,frames);};function ease(k){return--k*k*k+1;}var ScrollbarWrap=function ScrollbarWrap(_ref){var withScroll=_ref.withScroll,wrap=_ref.wrap,children=_ref.children;return withScroll?wrap(children):children;};var ExpandTest=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(ExpandTest,_React$Component);function ExpandTest(props){_classCallCheck(this,ExpandTest);var _this=_possibleConstructorReturn(this,(ExpandTest.__proto__||Object.getPrototypeOf(ExpandTest)).call(this,props));_initDefineProp(_this,'default',_descriptor,_this);_initDefineProp(_this,'current',_descriptor2,_this);_initDefineProp(_this,'goTo',_descriptor3,_this);_initDefineProp(_this,'setDims',_descriptor4,_this);_this.forceScrollToTop=function(){//method to be called from outside to force scroll to top
Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.scrollbar.current).firstChild.scrollTop=0;};if(props.withScroll)_this.scrollbar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ExpandTest,[{key:'componentDidMount',value:function componentDidMount(){// const default = this.default
// const current = this.props.modes[this.props.currentMode]
// if(default.height !== current.height || default.width !== current.width){
//     
// }
}},{key:'componentWillUpdate',value:function componentWillUpdate(newProps){if(newProps.currentMode!==this.props.currentMode){console.log('setting mode to',newProps.currentMode,_extends({},this.props.modes[newProps.currentMode]));this.setDims('goTo',newProps.modes[newProps.currentMode]);if(this.props.withScroll){Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.scrollbar.current).firstChild.scrollTop=0;}}}},{key:'render',value:function render(){var _this2=this;var scaleX=this.goTo.width/this.default.width;var scaleY=this.goTo.height/this.default.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{className:this.props.className,'default':this.default},this.props.header&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,this.props.header),this.props.withScroll&&!this.props.noFade&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FadeCropper,{id:'fadecropper',width:Math.max.apply(Math,_toConsumableArray(Object.keys(this.props.modes).map(function(mode){return _this2.props.modes[mode].width;})))// a hack...
,show:this.props.currentMode.toLowerCase().includes('expanded')// width = {1000}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Box,{current:this.goTo,animFrames:computeAnim(this.current,this.goTo),onAnimationEnd:function onAnimationEnd(){_this2.setDims('current',_this2.goTo);},duration:this.props.duration,delay:this.props.delay,style:{backgroundColor:this.props.backgroundColor||'transparent'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollbarWrap,{withScroll:this.props.withScroll,wrap:function wrap(children){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_custom_scrollbars__["Scrollbars"],{id:'scrollbar',ref:_this2.scrollbar,style:{width:'100%',//expanded exception hack II
height:!_this2.props.currentMode.includes('expanded')&&_this2.props.withScroll?_this2.props.modes[_this2.props.currentMode].height:'100%'},renderTrackVertical:function renderTrackVertical(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},props,{style:_this2.props.hideScroll?{display:'none'}:{position:'absolute',width:'6px',right:'2px',bottom:'2px',top:'2px',borderRadius:'0px'},className:'track-vertical'}));},renderTrackHorizontal:function renderTrackHorizontal(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},props,{style:{display:'none'},className:'track-horizontal'}));},onScrollFrame:_this2.props.onScroll?function(e){return _this2.props.onScroll(e);}:function(){}},children);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{animFrames:computeAnim(this.current,this.goTo,true),duration:this.props.duration,delay:this.props.delay,dontAlignContentsToCenter:this.props.dontAlignContentsToCenter},this.props.children))),this.props.withScroll&&!this.props.noFade&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FadeCropperBottom,{width:Math.max.apply(Math,_toConsumableArray(Object.keys(this.props.modes).map(function(mode){return _this2.props.modes[mode].width;})))// width = {this.props.modes.expanded.width}
// expanded exception hack.III
,show:this.props.currentMode.toLowerCase().includes('expanded'),offset:this.goTo.height}),!this.props.noBorderTop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Top,{delay:this.props.delay,duration:this.props.duration,borderColor:this.props.borderColor,scale:scaleX,current:this.goTo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bottom,{delay:this.props.delay,duration:this.props.duration,borderColor:this.props.borderColor,scale:scaleX,current:this.goTo,offset:this.goTo.height}),!this.props.noSideBorders&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Left,{delay:this.props.delay,duration:this.props.duration,borderColor:this.props.borderColor,scale:scaleY,current:this.goTo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Right,{delay:this.props.delay,duration:this.props.duration,borderColor:this.props.borderColor,scale:scaleY,current:this.goTo,offset:this.goTo.width})),this.props.footer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer,{offset:this.goTo.height,duration:this.props.duration},this.props.footer));}}]);return ExpandTest;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'default',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return this.props.defaultAsString?this.props.modes[this.props.defaultAsString]:this.props.modes[Object.keys(this.props.modes)[0]];}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'current',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return this.props.modes[Object.keys(this.props.modes)[0]];}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'goTo',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return this.props.modes[this.props.currentMode];}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'setDims',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(which,dims){_this3[which].width=dims.width;_this3[which].height=dims.height;};}})),_class2))||_class;ExpandTest.defaultProps={duration:.35,delay:0};var Wrapper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.default.width+2;},function(props){return props.default.height+2;});var Bound=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject5,function(props){return props.duration;},function(props){return props.delay;});var Top=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(Bound)(_templateObject6,function(props){return props.borderColor||'var(--bordergrey)';},function(props){return props.scale;});var Bottom=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(Bound)(_templateObject7,function(props){return props.borderColor||'var(--bordergrey)';},function(props){return props.offset;},function(props){return props.scale;});var Left=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(Bound)(_templateObject8,function(props){return props.borderColor||'var(--bordergrey)';},function(props){return props.scale;});var Right=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(Bound)(_templateObject9,function(props){return props.borderColor||'var(--bordergrey)';},function(props){return props.offset;},function(props){return props.scale;});var Header=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject10);var Footer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject11,function(props){return props.duration;},function(props){return props.offset;});var FadeCropper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject12,function(props){return props.width;},function(props){return props.show?1:0;});var FadeCropperBottom=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(FadeCropper)(_templateObject13,function(props){return props.offset-45;});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(127);
var foreach = __webpack_require__(129);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function commaNumber(num){return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1,');}/* harmony default export */ __webpack_exports__["a"] = (commaNumber);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValid;
function isValid(val){return val===0||val&&val!=='*';}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(22);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(131);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Sources; });
/* unused harmony export IndicatorSourceInfo */
/* unused harmony export DemographicSourceInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileSources; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generic___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExpandBox__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_sourcesfinal__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_media__ = __webpack_require__(3);
var _class,_desc,_value,_class2,_descriptor,_descriptor2;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 70px;\n    z-index: ',';\n    pointer-events: ',';\n    opacity: ',';\n    transform: translateX(',');\n    transition: transform .4s cubic-bezier(0.215, 0.61, 0.355, 1), opacity ','s;\n    transition-delay: ','s;\n'],['\n    position: absolute;\n    top: 70px;\n    z-index: ',';\n    pointer-events: ',';\n    opacity: ',';\n    transform: translateX(',');\n    transition: transform .4s cubic-bezier(0.215, 0.61, 0.355, 1), opacity ','s;\n    transition-delay: ','s;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    right: 0;\n    top: 0;\n    border: 1px solid red; \n    width: 20px; height: 20px;\n'],['\n    position: absolute;\n    right: 0;\n    top: 0;\n    border: 1px solid red; \n    width: 20px; height: 20px;\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: absolute;\n    height: 100%;\n    width: ','px;\n    /*border: 1px solid var(--bordergrey);*/\n    @media ','{\n        width: 610px;\n        max-height: 602px;\n    }\n    @media ','{\n        width: 480px;\n        max-height: 470px;\n    }\n\n    white-space: normal;\n'],['\n    position: absolute;\n    height: 100%;\n    width: ','px;\n    /*border: 1px solid var(--bordergrey);*/\n    @media ','{\n        width: 610px;\n        max-height: 602px;\n    }\n    @media ','{\n        width: 480px;\n        max-height: 470px;\n    }\n\n    white-space: normal;\n']),_templateObject4=_taggedTemplateLiteral(['\n    padding: 35px;\n    @media ','{\n        padding: 20px;\n        // margin-top: 15px;\n        border: 1px solid var(--bordergrey);\n    }\n'],['\n    padding: 35px;\n    @media ','{\n        padding: 20px;\n        // margin-top: 15px;\n        border: 1px solid var(--bordergrey);\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    margin: 0 20px;\n    display: inline-flex;\n    padding: 0 15px;\n    align-items: center;\n    background: var(--offwhitefg);\n    z-index: 3;\n    height: 10px;\n    white-space: nowrap;\n'],['\n    position: absolute;\n    margin: 0 20px;\n    display: inline-flex;\n    padding: 0 15px;\n    align-items: center;\n    background: var(--offwhitefg);\n    z-index: 3;\n    height: 10px;\n    white-space: nowrap;\n']),_templateObject6=_taggedTemplateLiteral(['\n    /*display: flex;*/\n    padding-bottom: 25px;\n    border-bottom: 1px solid ',';\n    margin-bottom: ','px;\n    justify-content: space-between;\n    @media ','{\n        margin-bottom: 0;\n        border-bottom: 0px solid transparent;\n        padding-bottom: 0;\n        margin: 25px 0 35px 0;\n        padding: 20px;\n        border: 1px solid var(--bordergrey);\n    }\n'],['\n    /*display: flex;*/\n    padding-bottom: 25px;\n    border-bottom: 1px solid ',';\n    margin-bottom: ','px;\n    justify-content: space-between;\n    @media ','{\n        margin-bottom: 0;\n        border-bottom: 0px solid transparent;\n        padding-bottom: 0;\n        margin: 25px 0 35px 0;\n        padding: 20px;\n        border: 1px solid var(--bordergrey);\n    }\n']),_templateObject7=_taggedTemplateLiteral(['\n    z-index: 2;\n    position: absolute;\n    width: 100%;\n    height: 40px;\n    background: linear-gradient(var(--offwhitefg) 30%, rgba(252,253,255,0) 100%);\n\n\n'],['\n    z-index: 2;\n    position: absolute;\n    width: 100%;\n    height: 40px;\n    background: linear-gradient(var(--offwhitefg) 30%, rgba(252,253,255,0) 100%);\n\n\n']),_templateObject8=_taggedTemplateLiteral(['\n    position: relative;\n    \n    &:first-of-type{\n        margin-top: 0;\n    }\n    h1, h3, a, p{\n        margin-top: 15px;\n    }\n    h3, a{\n        font-size: 13px;\n        font-weight: bold;\n        /*letter-spacing: 0.3px;*/\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    h1{\n        font-size: 16px;\n        font-weight: normal;\n        margin: 0;\n        margin-top: 10px;\n    }\n    h3{\n        margin: 0;\n        padding: 0;\n        color: var(--fainttext);\n        text-transform: uppercase;\n        margin-bottom: 5px;\n    }\n    a{\n        display: block;\n        margin-top: 15px;\n        color: var(--strokepeach);\n    }\n    p{\n        margin: 0;\n    }\n    @media ','{\n        /*width: calc(50% - 15px);*/\n    }\n    @media ','{\n        /*width: calc(50% - 10px);*/\n        h1{ font-size: 13px; }\n    }\n    @media ','{\n        h1 {\n            margin-top: 0;\n            font-size: 14px; letter-spacing: 0.5px;\n        }\n        a {font-size: 12px; margin-top: 8px;}\n        h3 { \n            position: absolute;\n            top: -20px; left: -5px; \n            transform: translateY(-50%);\n            font-size: 12px;\n            padding: 0 15px;\n            background: var(--offwhitefg);\n        }\n\n    }\n\n'],['\n    position: relative;\n    \n    &:first-of-type{\n        margin-top: 0;\n    }\n    h1, h3, a, p{\n        margin-top: 15px;\n    }\n    h3, a{\n        font-size: 13px;\n        font-weight: bold;\n        /*letter-spacing: 0.3px;*/\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    h1{\n        font-size: 16px;\n        font-weight: normal;\n        margin: 0;\n        margin-top: 10px;\n    }\n    h3{\n        margin: 0;\n        padding: 0;\n        color: var(--fainttext);\n        text-transform: uppercase;\n        margin-bottom: 5px;\n    }\n    a{\n        display: block;\n        margin-top: 15px;\n        color: var(--strokepeach);\n    }\n    p{\n        margin: 0;\n    }\n    @media ','{\n        /*width: calc(50% - 15px);*/\n    }\n    @media ','{\n        /*width: calc(50% - 10px);*/\n        h1{ font-size: 13px; }\n    }\n    @media ','{\n        h1 {\n            margin-top: 0;\n            font-size: 14px; letter-spacing: 0.5px;\n        }\n        a {font-size: 12px; margin-top: 8px;}\n        h3 { \n            position: absolute;\n            top: -20px; left: -5px; \n            transform: translateY(-50%);\n            font-size: 12px;\n            padding: 0 15px;\n            background: var(--offwhitefg);\n        }\n\n    }\n\n']),_templateObject9=_taggedTemplateLiteral(['\n    /*font-size: 13px;*/\n    p{ \n        font-size: 13px; \n    }\n    margin-top: 15px;\n\n    @media ','{ \n        p{\n            font-size: 12px; \n        }\n        margin-top: 8px;\n\n    }\n'],['\n    /*font-size: 13px;*/\n    p{ \n        font-size: 13px; \n    }\n    margin-top: 15px;\n\n    @media ','{ \n        p{\n            font-size: 12px; \n        }\n        margin-top: 8px;\n\n    }\n']),_templateObject10=_taggedTemplateLiteral(['\n    margin-top: 10px;\n    color: var(--fainttext);\n    font-size: 13px;\n    @media ','{\n        display: none;\n    }\n'],['\n    margin-top: 10px;\n    color: var(--fainttext);\n    font-size: 13px;\n    @media ','{\n        display: none;\n    }\n']),_templateObject11=_taggedTemplateLiteral(['\n    text-decoration: none;\n'],['\n    text-decoration: none;\n']),_templateObject12=_taggedTemplateLiteral(['\n    \n'],['\n    \n']),_templateObject13=_taggedTemplateLiteral(['\n    \n\n'],['\n    \n\n']),_templateObject14=_taggedTemplateLiteral(['\n    width: 100%;\n    // height: 1000px;\n    // border: 1px solid red;\n    background: var(--offwhitefg);\n    margin-bottom: 100px;\n'],['\n    width: 100%;\n    // height: 1000px;\n    // border: 1px solid red;\n    background: var(--offwhitefg);\n    margin-bottom: 100px;\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Sources=function(_React$Component){_inherits(Sources,_React$Component);function Sources(){_classCallCheck(this,Sources);return _possibleConstructorReturn(this,(Sources.__proto__||Object.getPrototypeOf(Sources)).apply(this,arguments));}_createClass(Sources,[{key:'render',value:function render(){var expandWidth=this.props.screen==='optimal'?608:478;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{currentMode:this.props.expand?'expanded':'collapsed',modes:{collapsed:{width:expandWidth/2,height:this.props.screen==='optimal'?530:410},expanded:{width:expandWidth,height:this.props.screen==='optimal'?530:410}},expand:this.props.expand//keeping vestigial prop for wrapper transitions
,expandWidth:expandWidth,withScroll:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,'Indicator and demographics sources '),duration:.4,delay:this.props.expand?'.15s':0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AllSources,{width:expandWidth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Contents,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorSourceInfo,{indicator:this.props.indicator}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemographicSourceInfo,null))));}}]);return Sources;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var Wrapper=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6__ExpandBox__["a" /* default */])(_templateObject,function(props){return props.expand?30:5;},function(props){return props.expand?'auto':'none';},function(props){return props.expand?1:0;},function(props){return props.expand?0:props.expandWidth/2+'px';},function(props){return props.expand?.2:.35;},function(props){return props.expand?.15:0;});var X=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2);var AllSources=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.width;},__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].compact);var Contents=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].mobile);var Header=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject5);var Indicator=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject6,function(props){return props.last?'transparent':'var(--bordergrey)';},function(props){return props.last?0:25;},__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].mobile);var FadeCropper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject7);var SourceBlock=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].mobile);var NotesBlock=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(SourceBlock)(_templateObject9,__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].mobile);var IndicatorSourceInfo=function IndicatorSourceInfo(props){var indicator=props.indicator;var src=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_7__data_sourcesfinal__["a" /* default */],function(o){return o.indicator===indicator;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Indicator,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourceBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'indicator'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,src.source),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:src.url},src.url)),src.source2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourceBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,src.source),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:src.url2},src.url2)),src.notes&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotesBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,src.notes)),src.notes2&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotesBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,src.notes2)),src.notes3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotesBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,src.notes3)),src.notes4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotesBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,src.notes4)),src.redirect&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Redirect,{text:src.redirect,link:src.methoURL}));};var Redirect=function Redirect(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RedirectLink,{href:props.link},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RedirectSpan,null,props.text));};var RedirectSpan=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_9__utilities_media__["a" /* default */].mobile);var RedirectLink=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].a(_templateObject11);var DemographicSourceInfo=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component2){_inherits(DemographicSourceInfo,_React$Component2);function DemographicSourceInfo(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,DemographicSourceInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=DemographicSourceInfo.__proto__||Object.getPrototypeOf(DemographicSourceInfo)).call.apply(_ref,[this].concat(args))),_this2),_initDefineProp(_this2,'getSrc',_descriptor,_this2),_initDefineProp(_this2,'setSrc',_descriptor2,_this2),_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(DemographicSourceInfo,[{key:'render',value:function render(){var srcs={population:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_7__data_sourcesfinal__["a" /* default */],function(o){return o.indicator==='population';}),raceBreakdown:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_7__data_sourcesfinal__["a" /* default */],function(o){return o.indicator==='raceBreakdown';}),immigrantFamilies:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_7__data_sourcesfinal__["a" /* default */],function(o){return o.indicator==='immigrantFamilies';}),poverty:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_7__data_sourcesfinal__["a" /* default */],function(o){return o.indicator==='poverty';}),homelessness:Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_7__data_sourcesfinal__["a" /* default */],function(o){return o.indicator==='homelessness';})};var blockTitles={population:'Population count',raceBreakdown:'Race percentages',immigrantFamilies:'Number of children living with 1+ immigrant parents',poverty:'Percent of children living 2X below the Federal Poverty Level',homelessness:'Count of students experiencing homelessness'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoSources,null,Object.keys(srcs).map(function(src,i,arr){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Indicator,{key:'src'+i,last:i===arr.length-1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourceBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,blockTitles[src]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,srcs[src].source),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:srcs[src].url},srcs[src].url)),srcs[src].notes&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NotesBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,srcs[src].notes)),srcs[src].redirect&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Redirect,{text:srcs[src].redirect,link:srcs[src].methoURL}));}));}}]);return DemographicSourceInfo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'getSrc',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'population';}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'setSrc',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(val){_this3.getSrc=val;};}})),_class2))||_class;var DemoSources=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject12);var DemoBlock=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject13);var MobileSources=function MobileSources(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobSources,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorSourceInfo,{indicator:props.indicator}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemographicSourceInfo,null));};var MobSources=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject14);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(89)();
}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
/**
 * @license
 *
 * chroma.js - JavaScript library for color conversions
 * 
 * Copyright (c) 2011-2017, Gregor Aisch
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 * 
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 * 
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 * 
 * 3. The name Gregor Aisch may not be used to endorse or promote products
 *    derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
 * OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
 * EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */

(function() {
  var Color, DEG2RAD, LAB_CONSTANTS, PI, PITHIRD, RAD2DEG, TWOPI, _average_lrgb, _guess_formats, _guess_formats_sorted, _input, _interpolators, abs, atan2, bezier, blend, blend_f, brewer, burn, chroma, clip_rgb, cmyk2rgb, colors, cos, css2rgb, darken, dodge, each, floor, hcg2rgb, hex2rgb, hsi2rgb, hsl2css, hsl2rgb, hsv2rgb, interpolate, interpolate_hsx, interpolate_lab, interpolate_lrgb, interpolate_num, interpolate_rgb, lab2lch, lab2rgb, lab_xyz, lch2lab, lch2rgb, lighten, limit, log, luminance_x, m, max, multiply, normal, num2rgb, overlay, pow, rgb2cmyk, rgb2css, rgb2hcg, rgb2hex, rgb2hsi, rgb2hsl, rgb2hsv, rgb2lab, rgb2lch, rgb2luminance, rgb2num, rgb2temperature, rgb2xyz, rgb_xyz, rnd, root, round, screen, sin, sqrt, temperature2rgb, type, unpack, w3cx11, xyz_lab, xyz_rgb,
    slice = [].slice;

  type = (function() {

    /*
    for browser-safe type checking+
    ported from jQuery's $.type
     */
    var classToType, len, name, o, ref;
    classToType = {};
    ref = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ");
    for (o = 0, len = ref.length; o < len; o++) {
      name = ref[o];
      classToType["[object " + name + "]"] = name.toLowerCase();
    }
    return function(obj) {
      var strType;
      strType = Object.prototype.toString.call(obj);
      return classToType[strType] || "object";
    };
  })();

  limit = function(x, min, max) {
    if (min == null) {
      min = 0;
    }
    if (max == null) {
      max = 1;
    }
    if (x < min) {
      x = min;
    }
    if (x > max) {
      x = max;
    }
    return x;
  };

  unpack = function(args) {
    if (args.length >= 3) {
      return Array.prototype.slice.call(args);
    } else {
      return args[0];
    }
  };

  clip_rgb = function(rgb) {
    var i, o;
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for (i = o = 0; o < 3; i = ++o) {
      if (i < 3) {
        if (rgb[i] < 0 || rgb[i] > 255) {
          rgb._clipped = true;
        }
        if (rgb[i] < 0) {
          rgb[i] = 0;
        }
        if (rgb[i] > 255) {
          rgb[i] = 255;
        }
      } else if (i === 3) {
        if (rgb[i] < 0) {
          rgb[i] = 0;
        }
        if (rgb[i] > 1) {
          rgb[i] = 1;
        }
      }
    }
    if (!rgb._clipped) {
      delete rgb._unclipped;
    }
    return rgb;
  };

  PI = Math.PI, round = Math.round, cos = Math.cos, floor = Math.floor, pow = Math.pow, log = Math.log, sin = Math.sin, sqrt = Math.sqrt, atan2 = Math.atan2, max = Math.max, abs = Math.abs;

  TWOPI = PI * 2;

  PITHIRD = PI / 3;

  DEG2RAD = PI / 180;

  RAD2DEG = 180 / PI;

  chroma = function() {
    if (arguments[0] instanceof Color) {
      return arguments[0];
    }
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, arguments, function(){});
  };

  chroma["default"] = chroma;

  _interpolators = [];

  if ((typeof module !== "undefined" && module !== null) && (module.exports != null)) {
    module.exports = chroma;
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return chroma;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    root = typeof exports !== "undefined" && exports !== null ? exports : this;
    root.chroma = chroma;
  }

  chroma.version = '1.4.1';

  _input = {};

  _guess_formats = [];

  _guess_formats_sorted = false;

  Color = (function() {
    function Color() {
      var arg, args, chk, len, len1, me, mode, o, w;
      me = this;
      args = [];
      for (o = 0, len = arguments.length; o < len; o++) {
        arg = arguments[o];
        if (arg != null) {
          args.push(arg);
        }
      }
      if (args.length > 1) {
        mode = args[args.length - 1];
      }
      if (_input[mode] != null) {
        me._rgb = clip_rgb(_input[mode](unpack(args.slice(0, -1))));
      } else {
        if (!_guess_formats_sorted) {
          _guess_formats = _guess_formats.sort(function(a, b) {
            return b.p - a.p;
          });
          _guess_formats_sorted = true;
        }
        for (w = 0, len1 = _guess_formats.length; w < len1; w++) {
          chk = _guess_formats[w];
          mode = chk.test.apply(chk, args);
          if (mode) {
            break;
          }
        }
        if (mode) {
          me._rgb = clip_rgb(_input[mode].apply(_input, args));
        }
      }
      if (me._rgb == null) {
        console.warn('unknown format: ' + args);
      }
      if (me._rgb == null) {
        me._rgb = [0, 0, 0];
      }
      if (me._rgb.length === 3) {
        me._rgb.push(1);
      }
    }

    Color.prototype.toString = function() {
      return this.hex();
    };

    return Color;

  })();

  chroma._input = _input;


  /**
  	ColorBrewer colors for chroma.js
  
  	Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The 
  	Pennsylvania State University.
  
  	Licensed under the Apache License, Version 2.0 (the "License"); 
  	you may not use this file except in compliance with the License.
  	You may obtain a copy of the License at	
  	http://www.apache.org/licenses/LICENSE-2.0
  
  	Unless required by applicable law or agreed to in writing, software distributed
  	under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  	CONDITIONS OF ANY KIND, either express or implied. See the License for the
  	specific language governing permissions and limitations under the License.
  
      @preserve
   */

  chroma.brewer = brewer = {
    OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
    PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
    BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
    Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
    BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
    YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
    YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
    Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
    RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
    Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
    YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
    Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
    GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
    Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
    YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
    PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
    Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
    PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
    Viridis: ['#440154', '#482777', '#3f4a8a', '#31678e', '#26838f', '#1f9d8a', '#6cce5a', '#b6de2b', '#fee825'],
    Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
    RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
    RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
    PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
    PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
    RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
    BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
    RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
    PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],
    Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
    Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
    Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
    Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
    Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
    Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
    Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
    Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2']
  };

  (function() {
    var key, results;
    results = [];
    for (key in brewer) {
      results.push(brewer[key.toLowerCase()] = brewer[key]);
    }
    return results;
  })();


  /**
  	X11 color names
  
  	http://www.w3.org/TR/css3-color/#svg-color
   */

  w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflower: '#6495ed',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
  };

  chroma.colors = colors = w3cx11;

  lab2rgb = function() {
    var a, args, b, g, l, r, x, y, z;
    args = unpack(arguments);
    l = args[0], a = args[1], b = args[2];
    y = (l + 16) / 116;
    x = isNaN(a) ? y : y + a / 500;
    z = isNaN(b) ? y : y - b / 200;
    y = LAB_CONSTANTS.Yn * lab_xyz(y);
    x = LAB_CONSTANTS.Xn * lab_xyz(x);
    z = LAB_CONSTANTS.Zn * lab_xyz(z);
    r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);
    g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
    b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  xyz_rgb = function(r) {
    return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * pow(r, 1 / 2.4) - 0.055);
  };

  lab_xyz = function(t) {
    if (t > LAB_CONSTANTS.t1) {
      return t * t * t;
    } else {
      return LAB_CONSTANTS.t2 * (t - LAB_CONSTANTS.t0);
    }
  };

  LAB_CONSTANTS = {
    Kn: 18,
    Xn: 0.950470,
    Yn: 1,
    Zn: 1.088830,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452
  };

  rgb2lab = function() {
    var b, g, r, ref, ref1, x, y, z;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    ref1 = rgb2xyz(r, g, b), x = ref1[0], y = ref1[1], z = ref1[2];
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  };

  rgb_xyz = function(r) {
    if ((r /= 255) <= 0.04045) {
      return r / 12.92;
    } else {
      return pow((r + 0.055) / 1.055, 2.4);
    }
  };

  xyz_lab = function(t) {
    if (t > LAB_CONSTANTS.t3) {
      return pow(t, 1 / 3);
    } else {
      return t / LAB_CONSTANTS.t2 + LAB_CONSTANTS.t0;
    }
  };

  rgb2xyz = function() {
    var b, g, r, ref, x, y, z;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    r = rgb_xyz(r);
    g = rgb_xyz(g);
    b = rgb_xyz(b);
    x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / LAB_CONSTANTS.Xn);
    y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / LAB_CONSTANTS.Yn);
    z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / LAB_CONSTANTS.Zn);
    return [x, y, z];
  };

  chroma.lab = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['lab']), function(){});
  };

  _input.lab = lab2rgb;

  Color.prototype.lab = function() {
    return rgb2lab(this._rgb);
  };

  bezier = function(colors) {
    var I, I0, I1, c, lab0, lab1, lab2, lab3, ref, ref1, ref2;
    colors = (function() {
      var len, o, results;
      results = [];
      for (o = 0, len = colors.length; o < len; o++) {
        c = colors[o];
        results.push(chroma(c));
      }
      return results;
    })();
    if (colors.length === 2) {
      ref = (function() {
        var len, o, results;
        results = [];
        for (o = 0, len = colors.length; o < len; o++) {
          c = colors[o];
          results.push(c.lab());
        }
        return results;
      })(), lab0 = ref[0], lab1 = ref[1];
      I = function(t) {
        var i, lab;
        lab = (function() {
          var o, results;
          results = [];
          for (i = o = 0; o <= 2; i = ++o) {
            results.push(lab0[i] + t * (lab1[i] - lab0[i]));
          }
          return results;
        })();
        return chroma.lab.apply(chroma, lab);
      };
    } else if (colors.length === 3) {
      ref1 = (function() {
        var len, o, results;
        results = [];
        for (o = 0, len = colors.length; o < len; o++) {
          c = colors[o];
          results.push(c.lab());
        }
        return results;
      })(), lab0 = ref1[0], lab1 = ref1[1], lab2 = ref1[2];
      I = function(t) {
        var i, lab;
        lab = (function() {
          var o, results;
          results = [];
          for (i = o = 0; o <= 2; i = ++o) {
            results.push((1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
          }
          return results;
        })();
        return chroma.lab.apply(chroma, lab);
      };
    } else if (colors.length === 4) {
      ref2 = (function() {
        var len, o, results;
        results = [];
        for (o = 0, len = colors.length; o < len; o++) {
          c = colors[o];
          results.push(c.lab());
        }
        return results;
      })(), lab0 = ref2[0], lab1 = ref2[1], lab2 = ref2[2], lab3 = ref2[3];
      I = function(t) {
        var i, lab;
        lab = (function() {
          var o, results;
          results = [];
          for (i = o = 0; o <= 2; i = ++o) {
            results.push((1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
          }
          return results;
        })();
        return chroma.lab.apply(chroma, lab);
      };
    } else if (colors.length === 5) {
      I0 = bezier(colors.slice(0, 3));
      I1 = bezier(colors.slice(2, 5));
      I = function(t) {
        if (t < 0.5) {
          return I0(t * 2);
        } else {
          return I1((t - 0.5) * 2);
        }
      };
    }
    return I;
  };

  chroma.bezier = function(colors) {
    var f;
    f = bezier(colors);
    f.scale = function() {
      return chroma.scale(f);
    };
    return f;
  };

  chroma.cubehelix = function(start, rotations, hue, gamma, lightness) {
    var dh, dl, f;
    if (start == null) {
      start = 300;
    }
    if (rotations == null) {
      rotations = -1.5;
    }
    if (hue == null) {
      hue = 1;
    }
    if (gamma == null) {
      gamma = 1;
    }
    if (lightness == null) {
      lightness = [0, 1];
    }
    dh = 0;
    if (type(lightness) === 'array') {
      dl = lightness[1] - lightness[0];
    } else {
      dl = 0;
      lightness = [lightness, lightness];
    }
    f = function(fract) {
      var a, amp, b, cos_a, g, h, l, r, sin_a;
      a = TWOPI * ((start + 120) / 360 + rotations * fract);
      l = pow(lightness[0] + dl * fract, gamma);
      h = dh !== 0 ? hue[0] + fract * dh : hue;
      amp = h * l * (1 - l) / 2;
      cos_a = cos(a);
      sin_a = sin(a);
      r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
      g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
      b = l + amp * (+1.97294 * cos_a);
      return chroma(clip_rgb([r * 255, g * 255, b * 255, 1]));
    };
    f.start = function(s) {
      if (s == null) {
        return start;
      }
      start = s;
      return f;
    };
    f.rotations = function(r) {
      if (r == null) {
        return rotations;
      }
      rotations = r;
      return f;
    };
    f.gamma = function(g) {
      if (g == null) {
        return gamma;
      }
      gamma = g;
      return f;
    };
    f.hue = function(h) {
      if (h == null) {
        return hue;
      }
      hue = h;
      if (type(hue) === 'array') {
        dh = hue[1] - hue[0];
        if (dh === 0) {
          hue = hue[1];
        }
      } else {
        dh = 0;
      }
      return f;
    };
    f.lightness = function(h) {
      if (h == null) {
        return lightness;
      }
      if (type(h) === 'array') {
        lightness = h;
        dl = h[1] - h[0];
      } else {
        lightness = [h, h];
        dl = 0;
      }
      return f;
    };
    f.scale = function() {
      return chroma.scale(f);
    };
    f.hue(hue);
    return f;
  };

  chroma.random = function() {
    var code, digits, i, o;
    digits = '0123456789abcdef';
    code = '#';
    for (i = o = 0; o < 6; i = ++o) {
      code += digits.charAt(floor(Math.random() * 16));
    }
    return new Color(code);
  };

  _interpolators = [];

  interpolate = function(col1, col2, f, m) {
    var interpol, len, o, res;
    if (f == null) {
      f = 0.5;
    }
    if (m == null) {
      m = 'rgb';
    }

    /*
    interpolates between colors
    f = 0 --> me
    f = 1 --> col
     */
    if (type(col1) !== 'object') {
      col1 = chroma(col1);
    }
    if (type(col2) !== 'object') {
      col2 = chroma(col2);
    }
    for (o = 0, len = _interpolators.length; o < len; o++) {
      interpol = _interpolators[o];
      if (m === interpol[0]) {
        res = interpol[1](col1, col2, f, m);
        break;
      }
    }
    if (res == null) {
      throw "color mode " + m + " is not supported";
    }
    return res.alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
  };

  chroma.interpolate = interpolate;

  Color.prototype.interpolate = function(col2, f, m) {
    return interpolate(this, col2, f, m);
  };

  chroma.mix = interpolate;

  Color.prototype.mix = Color.prototype.interpolate;

  _input.rgb = function() {
    var k, ref, results, v;
    ref = unpack(arguments);
    results = [];
    for (k in ref) {
      v = ref[k];
      results.push(v);
    }
    return results;
  };

  chroma.rgb = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['rgb']), function(){});
  };

  Color.prototype.rgb = function(round) {
    if (round == null) {
      round = true;
    }
    if (round) {
      return this._rgb.map(Math.round).slice(0, 3);
    } else {
      return this._rgb.slice(0, 3);
    }
  };

  Color.prototype.rgba = function(round) {
    if (round == null) {
      round = true;
    }
    if (!round) {
      return this._rgb.slice(0);
    }
    return [Math.round(this._rgb[0]), Math.round(this._rgb[1]), Math.round(this._rgb[2]), this._rgb[3]];
  };

  _guess_formats.push({
    p: 3,
    test: function(n) {
      var a;
      a = unpack(arguments);
      if (type(a) === 'array' && a.length === 3) {
        return 'rgb';
      }
      if (a.length === 4 && type(a[3]) === "number" && a[3] >= 0 && a[3] <= 1) {
        return 'rgb';
      }
    }
  });

  _input.lrgb = _input.rgb;

  interpolate_lrgb = function(col1, col2, f, m) {
    var xyz0, xyz1;
    xyz0 = col1._rgb;
    xyz1 = col2._rgb;
    return new Color(sqrt(pow(xyz0[0], 2) * (1 - f) + pow(xyz1[0], 2) * f), sqrt(pow(xyz0[1], 2) * (1 - f) + pow(xyz1[1], 2) * f), sqrt(pow(xyz0[2], 2) * (1 - f) + pow(xyz1[2], 2) * f), m);
  };

  _average_lrgb = function(colors) {
    var col, f, len, o, rgb, xyz;
    f = 1 / colors.length;
    xyz = [0, 0, 0, 0];
    for (o = 0, len = colors.length; o < len; o++) {
      col = colors[o];
      rgb = col._rgb;
      xyz[0] += pow(rgb[0], 2) * f;
      xyz[1] += pow(rgb[1], 2) * f;
      xyz[2] += pow(rgb[2], 2) * f;
      xyz[3] += rgb[3] * f;
    }
    xyz[0] = sqrt(xyz[0]);
    xyz[1] = sqrt(xyz[1]);
    xyz[2] = sqrt(xyz[2]);
    if (xyz[3] > 1) {
      xyz[3] = 1;
    }
    return new Color(clip_rgb(xyz));
  };

  _interpolators.push(['lrgb', interpolate_lrgb]);

  chroma.average = function(colors, mode) {
    var A, alpha, c, cnt, dx, dy, first, i, l, len, o, xyz, xyz2;
    if (mode == null) {
      mode = 'rgb';
    }
    l = colors.length;
    colors = colors.map(function(c) {
      return chroma(c);
    });
    first = colors.splice(0, 1)[0];
    if (mode === 'lrgb') {
      return _average_lrgb(colors);
    }
    xyz = first.get(mode);
    cnt = [];
    dx = 0;
    dy = 0;
    for (i in xyz) {
      xyz[i] = xyz[i] || 0;
      cnt.push(isNaN(xyz[i]) ? 0 : 1);
      if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
        A = xyz[i] / 180 * PI;
        dx += cos(A);
        dy += sin(A);
      }
    }
    alpha = first.alpha();
    for (o = 0, len = colors.length; o < len; o++) {
      c = colors[o];
      xyz2 = c.get(mode);
      alpha += c.alpha();
      for (i in xyz) {
        if (!isNaN(xyz2[i])) {
          cnt[i] += 1;
          if (mode.charAt(i) === 'h') {
            A = xyz2[i] / 180 * PI;
            dx += cos(A);
            dy += sin(A);
          } else {
            xyz[i] += xyz2[i];
          }
        }
      }
    }
    for (i in xyz) {
      if (mode.charAt(i) === 'h') {
        A = atan2(dy / cnt[i], dx / cnt[i]) / PI * 180;
        while (A < 0) {
          A += 360;
        }
        while (A >= 360) {
          A -= 360;
        }
        xyz[i] = A;
      } else {
        xyz[i] = xyz[i] / cnt[i];
      }
    }
    return chroma(xyz, mode).alpha(alpha / l);
  };

  hex2rgb = function(hex) {
    var a, b, g, r, rgb, u;
    if (hex.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
      if (hex.length === 4 || hex.length === 7) {
        hex = hex.substr(1);
      }
      if (hex.length === 3) {
        hex = hex.split("");
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      u = parseInt(hex, 16);
      r = u >> 16;
      g = u >> 8 & 0xFF;
      b = u & 0xFF;
      return [r, g, b, 1];
    }
    if (hex.match(/^#?([A-Fa-f0-9]{8})$/)) {
      if (hex.length === 9) {
        hex = hex.substr(1);
      }
      u = parseInt(hex, 16);
      r = u >> 24 & 0xFF;
      g = u >> 16 & 0xFF;
      b = u >> 8 & 0xFF;
      a = round((u & 0xFF) / 0xFF * 100) / 100;
      return [r, g, b, a];
    }
    if ((_input.css != null) && (rgb = _input.css(hex))) {
      return rgb;
    }
    throw "unknown color: " + hex;
  };

  rgb2hex = function(channels, mode) {
    var a, b, g, hxa, r, str, u;
    if (mode == null) {
      mode = 'auto';
    }
    r = channels[0], g = channels[1], b = channels[2], a = channels[3];
    if (mode === 'auto') {
      mode = a < 1 ? 'rgba' : 'rgb';
    }
    r = Math.round(r);
    g = Math.round(g);
    b = Math.round(b);
    u = r << 16 | g << 8 | b;
    str = "000000" + u.toString(16);
    str = str.substr(str.length - 6);
    hxa = '0' + round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    return "#" + (function() {
      switch (mode.toLowerCase()) {
        case 'rgba':
          return str + hxa;
        case 'argb':
          return hxa + str;
        default:
          return str;
      }
    })();
  };

  _input.hex = function(h) {
    return hex2rgb(h);
  };

  chroma.hex = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hex']), function(){});
  };

  Color.prototype.hex = function(mode) {
    if (mode == null) {
      mode = 'auto';
    }
    return rgb2hex(this._rgb, mode);
  };

  _guess_formats.push({
    p: 4,
    test: function(n) {
      if (arguments.length === 1 && type(n) === "string") {
        return 'hex';
      }
    }
  });

  hsl2rgb = function() {
    var args, b, c, g, h, i, l, o, r, ref, s, t1, t2, t3;
    args = unpack(arguments);
    h = args[0], s = args[1], l = args[2];
    if (s === 0) {
      r = g = b = l * 255;
    } else {
      t3 = [0, 0, 0];
      c = [0, 0, 0];
      t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
      t1 = 2 * l - t2;
      h /= 360;
      t3[0] = h + 1 / 3;
      t3[1] = h;
      t3[2] = h - 1 / 3;
      for (i = o = 0; o <= 2; i = ++o) {
        if (t3[i] < 0) {
          t3[i] += 1;
        }
        if (t3[i] > 1) {
          t3[i] -= 1;
        }
        if (6 * t3[i] < 1) {
          c[i] = t1 + (t2 - t1) * 6 * t3[i];
        } else if (2 * t3[i] < 1) {
          c[i] = t2;
        } else if (3 * t3[i] < 2) {
          c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6;
        } else {
          c[i] = t1;
        }
      }
      ref = [round(c[0] * 255), round(c[1] * 255), round(c[2] * 255)], r = ref[0], g = ref[1], b = ref[2];
    }
    if (args.length > 3) {
      return [r, g, b, args[3]];
    } else {
      return [r, g, b];
    }
  };

  rgb2hsl = function(r, g, b) {
    var h, l, min, ref, s;
    if (r !== void 0 && r.length >= 3) {
      ref = r, r = ref[0], g = ref[1], b = ref[2];
    }
    r /= 255;
    g /= 255;
    b /= 255;
    min = Math.min(r, g, b);
    max = Math.max(r, g, b);
    l = (max + min) / 2;
    if (max === min) {
      s = 0;
      h = Number.NaN;
    } else {
      s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
    }
    if (r === max) {
      h = (g - b) / (max - min);
    } else if (g === max) {
      h = 2 + (b - r) / (max - min);
    } else if (b === max) {
      h = 4 + (r - g) / (max - min);
    }
    h *= 60;
    if (h < 0) {
      h += 360;
    }
    return [h, s, l];
  };

  chroma.hsl = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hsl']), function(){});
  };

  _input.hsl = hsl2rgb;

  Color.prototype.hsl = function() {
    return rgb2hsl(this._rgb);
  };

  hsv2rgb = function() {
    var args, b, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, s, t, v;
    args = unpack(arguments);
    h = args[0], s = args[1], v = args[2];
    v *= 255;
    if (s === 0) {
      r = g = b = v;
    } else {
      if (h === 360) {
        h = 0;
      }
      if (h > 360) {
        h -= 360;
      }
      if (h < 0) {
        h += 360;
      }
      h /= 60;
      i = floor(h);
      f = h - i;
      p = v * (1 - s);
      q = v * (1 - s * f);
      t = v * (1 - s * (1 - f));
      switch (i) {
        case 0:
          ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
          break;
        case 1:
          ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
          break;
        case 2:
          ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
          break;
        case 3:
          ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
          break;
        case 4:
          ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
          break;
        case 5:
          ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
      }
    }
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  rgb2hsv = function() {
    var b, delta, g, h, min, r, ref, s, v;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    min = Math.min(r, g, b);
    max = Math.max(r, g, b);
    delta = max - min;
    v = max / 255.0;
    if (max === 0) {
      h = Number.NaN;
      s = 0;
    } else {
      s = delta / max;
      if (r === max) {
        h = (g - b) / delta;
      }
      if (g === max) {
        h = 2 + (b - r) / delta;
      }
      if (b === max) {
        h = 4 + (r - g) / delta;
      }
      h *= 60;
      if (h < 0) {
        h += 360;
      }
    }
    return [h, s, v];
  };

  chroma.hsv = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hsv']), function(){});
  };

  _input.hsv = hsv2rgb;

  Color.prototype.hsv = function() {
    return rgb2hsv(this._rgb);
  };

  num2rgb = function(num) {
    var b, g, r;
    if (type(num) === "number" && num >= 0 && num <= 0xFFFFFF) {
      r = num >> 16;
      g = (num >> 8) & 0xFF;
      b = num & 0xFF;
      return [r, g, b, 1];
    }
    console.warn("unknown num color: " + num);
    return [0, 0, 0, 1];
  };

  rgb2num = function() {
    var b, g, r, ref;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    return (r << 16) + (g << 8) + b;
  };

  chroma.num = function(num) {
    return new Color(num, 'num');
  };

  Color.prototype.num = function(mode) {
    if (mode == null) {
      mode = 'rgb';
    }
    return rgb2num(this._rgb, mode);
  };

  _input.num = num2rgb;

  _guess_formats.push({
    p: 1,
    test: function(n) {
      if (arguments.length === 1 && type(n) === "number" && n >= 0 && n <= 0xFFFFFF) {
        return 'num';
      }
    }
  });

  hcg2rgb = function() {
    var _c, _g, args, b, c, f, g, h, i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t, v;
    args = unpack(arguments);
    h = args[0], c = args[1], _g = args[2];
    c = c / 100;
    g = g / 100 * 255;
    _c = c * 255;
    if (c === 0) {
      r = g = b = _g;
    } else {
      if (h === 360) {
        h = 0;
      }
      if (h > 360) {
        h -= 360;
      }
      if (h < 0) {
        h += 360;
      }
      h /= 60;
      i = floor(h);
      f = h - i;
      p = _g * (1 - c);
      q = p + _c * (1 - f);
      t = p + _c * f;
      v = p + _c;
      switch (i) {
        case 0:
          ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
          break;
        case 1:
          ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
          break;
        case 2:
          ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
          break;
        case 3:
          ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
          break;
        case 4:
          ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
          break;
        case 5:
          ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
      }
    }
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  rgb2hcg = function() {
    var _g, b, c, delta, g, h, min, r, ref;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    min = Math.min(r, g, b);
    max = Math.max(r, g, b);
    delta = max - min;
    c = delta * 100 / 255;
    _g = min / (255 - delta) * 100;
    if (delta === 0) {
      h = Number.NaN;
    } else {
      if (r === max) {
        h = (g - b) / delta;
      }
      if (g === max) {
        h = 2 + (b - r) / delta;
      }
      if (b === max) {
        h = 4 + (r - g) / delta;
      }
      h *= 60;
      if (h < 0) {
        h += 360;
      }
    }
    return [h, c, _g];
  };

  chroma.hcg = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hcg']), function(){});
  };

  _input.hcg = hcg2rgb;

  Color.prototype.hcg = function() {
    return rgb2hcg(this._rgb);
  };

  css2rgb = function(css) {
    var aa, ab, hsl, i, m, o, rgb, w;
    css = css.toLowerCase();
    if ((chroma.colors != null) && chroma.colors[css]) {
      return hex2rgb(chroma.colors[css]);
    }
    if (m = css.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
      rgb = m.slice(1, 4);
      for (i = o = 0; o <= 2; i = ++o) {
        rgb[i] = +rgb[i];
      }
      rgb[3] = 1;
    } else if (m = css.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) {
      rgb = m.slice(1, 5);
      for (i = w = 0; w <= 3; i = ++w) {
        rgb[i] = +rgb[i];
      }
    } else if (m = css.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
      rgb = m.slice(1, 4);
      for (i = aa = 0; aa <= 2; i = ++aa) {
        rgb[i] = round(rgb[i] * 2.55);
      }
      rgb[3] = 1;
    } else if (m = css.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
      rgb = m.slice(1, 5);
      for (i = ab = 0; ab <= 2; i = ++ab) {
        rgb[i] = round(rgb[i] * 2.55);
      }
      rgb[3] = +rgb[3];
    } else if (m = css.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
      hsl = m.slice(1, 4);
      hsl[1] *= 0.01;
      hsl[2] *= 0.01;
      rgb = hsl2rgb(hsl);
      rgb[3] = 1;
    } else if (m = css.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
      hsl = m.slice(1, 4);
      hsl[1] *= 0.01;
      hsl[2] *= 0.01;
      rgb = hsl2rgb(hsl);
      rgb[3] = +m[4];
    }
    return rgb;
  };

  rgb2css = function(rgba) {
    var mode;
    mode = rgba[3] < 1 ? 'rgba' : 'rgb';
    if (mode === 'rgb') {
      return mode + '(' + rgba.slice(0, 3).map(round).join(',') + ')';
    } else if (mode === 'rgba') {
      return mode + '(' + rgba.slice(0, 3).map(round).join(',') + ',' + rgba[3] + ')';
    } else {

    }
  };

  rnd = function(a) {
    return round(a * 100) / 100;
  };

  hsl2css = function(hsl, alpha) {
    var mode;
    mode = alpha < 1 ? 'hsla' : 'hsl';
    hsl[0] = rnd(hsl[0] || 0);
    hsl[1] = rnd(hsl[1] * 100) + '%';
    hsl[2] = rnd(hsl[2] * 100) + '%';
    if (mode === 'hsla') {
      hsl[3] = alpha;
    }
    return mode + '(' + hsl.join(',') + ')';
  };

  _input.css = function(h) {
    return css2rgb(h);
  };

  chroma.css = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['css']), function(){});
  };

  Color.prototype.css = function(mode) {
    if (mode == null) {
      mode = 'rgb';
    }
    if (mode.slice(0, 3) === 'rgb') {
      return rgb2css(this._rgb);
    } else if (mode.slice(0, 3) === 'hsl') {
      return hsl2css(this.hsl(), this.alpha());
    }
  };

  _input.named = function(name) {
    return hex2rgb(w3cx11[name]);
  };

  _guess_formats.push({
    p: 5,
    test: function(n) {
      if (arguments.length === 1 && (w3cx11[n] != null)) {
        return 'named';
      }
    }
  });

  Color.prototype.name = function(n) {
    var h, k;
    if (arguments.length) {
      if (w3cx11[n]) {
        this._rgb = hex2rgb(w3cx11[n]);
      }
      this._rgb[3] = 1;
      this;
    }
    h = this.hex('rgb');
    for (k in w3cx11) {
      if (h === w3cx11[k]) {
        return k;
      }
    }
    return h;
  };

  lch2lab = function() {

    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.
    
    A saturation multiplier was added by Gregor Aisch
     */
    var c, h, l, ref;
    ref = unpack(arguments), l = ref[0], c = ref[1], h = ref[2];
    h = h * DEG2RAD;
    return [l, cos(h) * c, sin(h) * c];
  };

  lch2rgb = function() {
    var L, a, args, b, c, g, h, l, r, ref, ref1;
    args = unpack(arguments);
    l = args[0], c = args[1], h = args[2];
    ref = lch2lab(l, c, h), L = ref[0], a = ref[1], b = ref[2];
    ref1 = lab2rgb(L, a, b), r = ref1[0], g = ref1[1], b = ref1[2];
    return [r, g, b, args.length > 3 ? args[3] : 1];
  };

  lab2lch = function() {
    var a, b, c, h, l, ref;
    ref = unpack(arguments), l = ref[0], a = ref[1], b = ref[2];
    c = sqrt(a * a + b * b);
    h = (atan2(b, a) * RAD2DEG + 360) % 360;
    if (round(c * 10000) === 0) {
      h = Number.NaN;
    }
    return [l, c, h];
  };

  rgb2lch = function() {
    var a, b, g, l, r, ref, ref1;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    ref1 = rgb2lab(r, g, b), l = ref1[0], a = ref1[1], b = ref1[2];
    return lab2lch(l, a, b);
  };

  chroma.lch = function() {
    var args;
    args = unpack(arguments);
    return new Color(args, 'lch');
  };

  chroma.hcl = function() {
    var args;
    args = unpack(arguments);
    return new Color(args, 'hcl');
  };

  _input.lch = lch2rgb;

  _input.hcl = function() {
    var c, h, l, ref;
    ref = unpack(arguments), h = ref[0], c = ref[1], l = ref[2];
    return lch2rgb([l, c, h]);
  };

  Color.prototype.lch = function() {
    return rgb2lch(this._rgb);
  };

  Color.prototype.hcl = function() {
    return rgb2lch(this._rgb).reverse();
  };

  rgb2cmyk = function(mode) {
    var b, c, f, g, k, m, r, ref, y;
    if (mode == null) {
      mode = 'rgb';
    }
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    r = r / 255;
    g = g / 255;
    b = b / 255;
    k = 1 - Math.max(r, Math.max(g, b));
    f = k < 1 ? 1 / (1 - k) : 0;
    c = (1 - r - k) * f;
    m = (1 - g - k) * f;
    y = (1 - b - k) * f;
    return [c, m, y, k];
  };

  cmyk2rgb = function() {
    var alpha, args, b, c, g, k, m, r, y;
    args = unpack(arguments);
    c = args[0], m = args[1], y = args[2], k = args[3];
    alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) {
      return [0, 0, 0, alpha];
    }
    r = c >= 1 ? 0 : 255 * (1 - c) * (1 - k);
    g = m >= 1 ? 0 : 255 * (1 - m) * (1 - k);
    b = y >= 1 ? 0 : 255 * (1 - y) * (1 - k);
    return [r, g, b, alpha];
  };

  _input.cmyk = function() {
    return cmyk2rgb(unpack(arguments));
  };

  chroma.cmyk = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['cmyk']), function(){});
  };

  Color.prototype.cmyk = function() {
    return rgb2cmyk(this._rgb);
  };

  _input.gl = function() {
    var i, k, o, rgb, v;
    rgb = (function() {
      var ref, results;
      ref = unpack(arguments);
      results = [];
      for (k in ref) {
        v = ref[k];
        results.push(v);
      }
      return results;
    }).apply(this, arguments);
    for (i = o = 0; o <= 2; i = ++o) {
      rgb[i] *= 255;
    }
    return rgb;
  };

  chroma.gl = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['gl']), function(){});
  };

  Color.prototype.gl = function() {
    var rgb;
    rgb = this._rgb;
    return [rgb[0] / 255, rgb[1] / 255, rgb[2] / 255, rgb[3]];
  };

  rgb2luminance = function(r, g, b) {
    var ref;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    r = luminance_x(r);
    g = luminance_x(g);
    b = luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  };

  luminance_x = function(x) {
    x /= 255;
    if (x <= 0.03928) {
      return x / 12.92;
    } else {
      return pow((x + 0.055) / 1.055, 2.4);
    }
  };

  interpolate_rgb = function(col1, col2, f, m) {
    var xyz0, xyz1;
    xyz0 = col1._rgb;
    xyz1 = col2._rgb;
    return new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
  };

  _interpolators.push(['rgb', interpolate_rgb]);

  Color.prototype.luminance = function(lum, mode) {
    var cur_lum, eps, max_iter, rgba, test;
    if (mode == null) {
      mode = 'rgb';
    }
    if (!arguments.length) {
      return rgb2luminance(this._rgb);
    }
    rgba = this._rgb;
    if (lum === 0) {
      rgba = [0, 0, 0, this._rgb[3]];
    } else if (lum === 1) {
      rgba = [255, 255, 255, this[3]];
    } else {
      cur_lum = rgb2luminance(this._rgb);
      eps = 1e-7;
      max_iter = 20;
      test = function(l, h) {
        var lm, m;
        m = l.interpolate(h, 0.5, mode);
        lm = m.luminance();
        if (Math.abs(lum - lm) < eps || !max_iter--) {
          return m;
        }
        if (lm > lum) {
          return test(l, m);
        }
        return test(m, h);
      };
      if (cur_lum > lum) {
        rgba = test(chroma('black'), this).rgba();
      } else {
        rgba = test(this, chroma('white')).rgba();
      }
    }
    return chroma(rgba).alpha(this.alpha());
  };

  temperature2rgb = function(kelvin) {
    var b, g, r, temp;
    temp = kelvin / 100;
    if (temp < 66) {
      r = 255;
      g = -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * log(g);
      b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * log(b);
    } else {
      r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * log(r);
      g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * log(g);
      b = 255;
    }
    return [r, g, b];
  };

  rgb2temperature = function() {
    var b, eps, g, maxTemp, minTemp, r, ref, rgb, temp;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    minTemp = 1000;
    maxTemp = 40000;
    eps = 0.4;
    while (maxTemp - minTemp > eps) {
      temp = (maxTemp + minTemp) * 0.5;
      rgb = temperature2rgb(temp);
      if ((rgb[2] / rgb[0]) >= (b / r)) {
        maxTemp = temp;
      } else {
        minTemp = temp;
      }
    }
    return round(temp);
  };

  chroma.temperature = chroma.kelvin = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['temperature']), function(){});
  };

  _input.temperature = _input.kelvin = _input.K = temperature2rgb;

  Color.prototype.temperature = function() {
    return rgb2temperature(this._rgb);
  };

  Color.prototype.kelvin = Color.prototype.temperature;

  chroma.contrast = function(a, b) {
    var l1, l2, ref, ref1;
    if ((ref = type(a)) === 'string' || ref === 'number') {
      a = new Color(a);
    }
    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
      b = new Color(b);
    }
    l1 = a.luminance();
    l2 = b.luminance();
    if (l1 > l2) {
      return (l1 + 0.05) / (l2 + 0.05);
    } else {
      return (l2 + 0.05) / (l1 + 0.05);
    }
  };

  chroma.distance = function(a, b, mode) {
    var d, i, l1, l2, ref, ref1, sum_sq;
    if (mode == null) {
      mode = 'lab';
    }
    if ((ref = type(a)) === 'string' || ref === 'number') {
      a = new Color(a);
    }
    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
      b = new Color(b);
    }
    l1 = a.get(mode);
    l2 = b.get(mode);
    sum_sq = 0;
    for (i in l1) {
      d = (l1[i] || 0) - (l2[i] || 0);
      sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
  };

  chroma.deltaE = function(a, b, L, C) {
    var L1, L2, a1, a2, b1, b2, c1, c2, c4, dH2, delA, delB, delC, delL, f, h1, ref, ref1, ref2, ref3, sc, sh, sl, t, v1, v2, v3;
    if (L == null) {
      L = 1;
    }
    if (C == null) {
      C = 1;
    }
    if ((ref = type(a)) === 'string' || ref === 'number') {
      a = new Color(a);
    }
    if ((ref1 = type(b)) === 'string' || ref1 === 'number') {
      b = new Color(b);
    }
    ref2 = a.lab(), L1 = ref2[0], a1 = ref2[1], b1 = ref2[2];
    ref3 = b.lab(), L2 = ref3[0], a2 = ref3[1], b2 = ref3[2];
    c1 = sqrt(a1 * a1 + b1 * b1);
    c2 = sqrt(a2 * a2 + b2 * b2);
    sl = L1 < 16.0 ? 0.511 : (0.040975 * L1) / (1.0 + 0.01765 * L1);
    sc = (0.0638 * c1) / (1.0 + 0.0131 * c1) + 0.638;
    h1 = c1 < 0.000001 ? 0.0 : (atan2(b1, a1) * 180.0) / PI;
    while (h1 < 0) {
      h1 += 360;
    }
    while (h1 >= 360) {
      h1 -= 360;
    }
    t = (h1 >= 164.0) && (h1 <= 345.0) ? 0.56 + abs(0.2 * cos((PI * (h1 + 168.0)) / 180.0)) : 0.36 + abs(0.4 * cos((PI * (h1 + 35.0)) / 180.0));
    c4 = c1 * c1 * c1 * c1;
    f = sqrt(c4 / (c4 + 1900.0));
    sh = sc * (f * t + 1.0 - f);
    delL = L1 - L2;
    delC = c1 - c2;
    delA = a1 - a2;
    delB = b1 - b2;
    dH2 = delA * delA + delB * delB - delC * delC;
    v1 = delL / (L * sl);
    v2 = delC / (C * sc);
    v3 = sh;
    return sqrt(v1 * v1 + v2 * v2 + (dH2 / (v3 * v3)));
  };

  Color.prototype.get = function(modechan) {
    var channel, i, me, mode, ref, src;
    me = this;
    ref = modechan.split('.'), mode = ref[0], channel = ref[1];
    src = me[mode]();
    if (channel) {
      i = mode.indexOf(channel);
      if (i > -1) {
        return src[i];
      } else {
        return console.warn('unknown channel ' + channel + ' in mode ' + mode);
      }
    } else {
      return src;
    }
  };

  Color.prototype.set = function(modechan, value) {
    var channel, i, me, mode, ref, src;
    me = this;
    ref = modechan.split('.'), mode = ref[0], channel = ref[1];
    if (channel) {
      src = me[mode]();
      i = mode.indexOf(channel);
      if (i > -1) {
        if (type(value) === 'string') {
          switch (value.charAt(0)) {
            case '+':
              src[i] += +value;
              break;
            case '-':
              src[i] += +value;
              break;
            case '*':
              src[i] *= +(value.substr(1));
              break;
            case '/':
              src[i] /= +(value.substr(1));
              break;
            default:
              src[i] = +value;
          }
        } else {
          src[i] = value;
        }
      } else {
        console.warn('unknown channel ' + channel + ' in mode ' + mode);
      }
    } else {
      src = value;
    }
    return chroma(src, mode).alpha(me.alpha());
  };

  Color.prototype.clipped = function() {
    return this._rgb._clipped || false;
  };

  Color.prototype.alpha = function(a) {
    if (arguments.length) {
      return chroma.rgb([this._rgb[0], this._rgb[1], this._rgb[2], a]);
    }
    return this._rgb[3];
  };

  Color.prototype.darken = function(amount) {
    var lab, me;
    if (amount == null) {
      amount = 1;
    }
    me = this;
    lab = me.lab();
    lab[0] -= LAB_CONSTANTS.Kn * amount;
    return chroma.lab(lab).alpha(me.alpha());
  };

  Color.prototype.brighten = function(amount) {
    if (amount == null) {
      amount = 1;
    }
    return this.darken(-amount);
  };

  Color.prototype.darker = Color.prototype.darken;

  Color.prototype.brighter = Color.prototype.brighten;

  Color.prototype.saturate = function(amount) {
    var lch, me;
    if (amount == null) {
      amount = 1;
    }
    me = this;
    lch = me.lch();
    lch[1] += amount * LAB_CONSTANTS.Kn;
    if (lch[1] < 0) {
      lch[1] = 0;
    }
    return chroma.lch(lch).alpha(me.alpha());
  };

  Color.prototype.desaturate = function(amount) {
    if (amount == null) {
      amount = 1;
    }
    return this.saturate(-amount);
  };

  Color.prototype.premultiply = function() {
    var a, rgb;
    rgb = this.rgb();
    a = this.alpha();
    return chroma(rgb[0] * a, rgb[1] * a, rgb[2] * a, a);
  };

  blend = function(bottom, top, mode) {
    if (!blend[mode]) {
      throw 'unknown blend mode ' + mode;
    }
    return blend[mode](bottom, top);
  };

  blend_f = function(f) {
    return function(bottom, top) {
      var c0, c1;
      c0 = chroma(top).rgb();
      c1 = chroma(bottom).rgb();
      return chroma(f(c0, c1), 'rgb');
    };
  };

  each = function(f) {
    return function(c0, c1) {
      var i, o, out;
      out = [];
      for (i = o = 0; o <= 3; i = ++o) {
        out[i] = f(c0[i], c1[i]);
      }
      return out;
    };
  };

  normal = function(a, b) {
    return a;
  };

  multiply = function(a, b) {
    return a * b / 255;
  };

  darken = function(a, b) {
    if (a > b) {
      return b;
    } else {
      return a;
    }
  };

  lighten = function(a, b) {
    if (a > b) {
      return a;
    } else {
      return b;
    }
  };

  screen = function(a, b) {
    return 255 * (1 - (1 - a / 255) * (1 - b / 255));
  };

  overlay = function(a, b) {
    if (b < 128) {
      return 2 * a * b / 255;
    } else {
      return 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
    }
  };

  burn = function(a, b) {
    return 255 * (1 - (1 - b / 255) / (a / 255));
  };

  dodge = function(a, b) {
    if (a === 255) {
      return 255;
    }
    a = 255 * (b / 255) / (1 - a / 255);
    if (a > 255) {
      return 255;
    } else {
      return a;
    }
  };

  blend.normal = blend_f(each(normal));

  blend.multiply = blend_f(each(multiply));

  blend.screen = blend_f(each(screen));

  blend.overlay = blend_f(each(overlay));

  blend.darken = blend_f(each(darken));

  blend.lighten = blend_f(each(lighten));

  blend.dodge = blend_f(each(dodge));

  blend.burn = blend_f(each(burn));

  chroma.blend = blend;

  chroma.analyze = function(data) {
    var len, o, r, val;
    r = {
      min: Number.MAX_VALUE,
      max: Number.MAX_VALUE * -1,
      sum: 0,
      values: [],
      count: 0
    };
    for (o = 0, len = data.length; o < len; o++) {
      val = data[o];
      if ((val != null) && !isNaN(val)) {
        r.values.push(val);
        r.sum += val;
        if (val < r.min) {
          r.min = val;
        }
        if (val > r.max) {
          r.max = val;
        }
        r.count += 1;
      }
    }
    r.domain = [r.min, r.max];
    r.limits = function(mode, num) {
      return chroma.limits(r, mode, num);
    };
    return r;
  };

  chroma.scale = function(colors, positions) {
    var _classes, _colorCache, _colors, _correctLightness, _domain, _fixed, _gamma, _max, _min, _mode, _nacol, _out, _padding, _pos, _spread, _useCache, classifyValue, f, getClass, getColor, resetCache, setColors, tmap;
    _mode = 'rgb';
    _nacol = chroma('#ccc');
    _spread = 0;
    _fixed = false;
    _domain = [0, 1];
    _pos = [];
    _padding = [0, 0];
    _classes = false;
    _colors = [];
    _out = false;
    _min = 0;
    _max = 1;
    _correctLightness = false;
    _colorCache = {};
    _useCache = true;
    _gamma = 1;
    setColors = function(colors) {
      var c, col, o, ref, ref1, w;
      if (colors == null) {
        colors = ['#fff', '#000'];
      }
      if ((colors != null) && type(colors) === 'string' && (chroma.brewer != null)) {
        colors = chroma.brewer[colors] || chroma.brewer[colors.toLowerCase()] || colors;
      }
      if (type(colors) === 'array') {
        if (colors.length === 1) {
          colors = [colors[0], colors[0]];
        }
        colors = colors.slice(0);
        for (c = o = 0, ref = colors.length - 1; 0 <= ref ? o <= ref : o >= ref; c = 0 <= ref ? ++o : --o) {
          col = colors[c];
          if (type(col) === "string") {
            colors[c] = chroma(col);
          }
        }
        _pos.length = 0;
        for (c = w = 0, ref1 = colors.length - 1; 0 <= ref1 ? w <= ref1 : w >= ref1; c = 0 <= ref1 ? ++w : --w) {
          _pos.push(c / (colors.length - 1));
        }
      }
      resetCache();
      return _colors = colors;
    };
    getClass = function(value) {
      var i, n;
      if (_classes != null) {
        n = _classes.length - 1;
        i = 0;
        while (i < n && value >= _classes[i]) {
          i++;
        }
        return i - 1;
      }
      return 0;
    };
    tmap = function(t) {
      return t;
    };
    classifyValue = function(value) {
      var i, maxc, minc, n, val;
      val = value;
      if (_classes.length > 2) {
        n = _classes.length - 1;
        i = getClass(value);
        minc = _classes[0] + (_classes[1] - _classes[0]) * (0 + _spread * 0.5);
        maxc = _classes[n - 1] + (_classes[n] - _classes[n - 1]) * (1 - _spread * 0.5);
        val = _min + ((_classes[i] + (_classes[i + 1] - _classes[i]) * 0.5 - minc) / (maxc - minc)) * (_max - _min);
      }
      return val;
    };
    getColor = function(val, bypassMap) {
      var c, col, i, k, o, p, ref, t;
      if (bypassMap == null) {
        bypassMap = false;
      }
      if (isNaN(val) || val === null) {
        return _nacol;
      }
      if (!bypassMap) {
        if (_classes && _classes.length > 2) {
          c = getClass(val);
          t = c / (_classes.length - 2);
        } else if (_max !== _min) {
          t = (val - _min) / (_max - _min);
        } else {
          t = 1;
        }
      } else {
        t = val;
      }
      if (!bypassMap) {
        t = tmap(t);
      }
      if (_gamma !== 1) {
        t = pow(t, _gamma);
      }
      t = _padding[0] + (t * (1 - _padding[0] - _padding[1]));
      t = Math.min(1, Math.max(0, t));
      k = Math.floor(t * 10000);
      if (_useCache && _colorCache[k]) {
        col = _colorCache[k];
      } else {
        if (type(_colors) === 'array') {
          for (i = o = 0, ref = _pos.length - 1; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o) {
            p = _pos[i];
            if (t <= p) {
              col = _colors[i];
              break;
            }
            if (t >= p && i === _pos.length - 1) {
              col = _colors[i];
              break;
            }
            if (t > p && t < _pos[i + 1]) {
              t = (t - p) / (_pos[i + 1] - p);
              col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
              break;
            }
          }
        } else if (type(_colors) === 'function') {
          col = _colors(t);
        }
        if (_useCache) {
          _colorCache[k] = col;
        }
      }
      return col;
    };
    resetCache = function() {
      return _colorCache = {};
    };
    setColors(colors);
    f = function(v) {
      var c;
      c = chroma(getColor(v));
      if (_out && c[_out]) {
        return c[_out]();
      } else {
        return c;
      }
    };
    f.classes = function(classes) {
      var d;
      if (classes != null) {
        if (type(classes) === 'array') {
          _classes = classes;
          _domain = [classes[0], classes[classes.length - 1]];
        } else {
          d = chroma.analyze(_domain);
          if (classes === 0) {
            _classes = [d.min, d.max];
          } else {
            _classes = chroma.limits(d, 'e', classes);
          }
        }
        return f;
      }
      return _classes;
    };
    f.domain = function(domain) {
      var c, d, k, len, o, ref, w;
      if (!arguments.length) {
        return _domain;
      }
      _min = domain[0];
      _max = domain[domain.length - 1];
      _pos = [];
      k = _colors.length;
      if (domain.length === k && _min !== _max) {
        for (o = 0, len = domain.length; o < len; o++) {
          d = domain[o];
          _pos.push((d - _min) / (_max - _min));
        }
      } else {
        for (c = w = 0, ref = k - 1; 0 <= ref ? w <= ref : w >= ref; c = 0 <= ref ? ++w : --w) {
          _pos.push(c / (k - 1));
        }
      }
      _domain = [_min, _max];
      return f;
    };
    f.mode = function(_m) {
      if (!arguments.length) {
        return _mode;
      }
      _mode = _m;
      resetCache();
      return f;
    };
    f.range = function(colors, _pos) {
      setColors(colors, _pos);
      return f;
    };
    f.out = function(_o) {
      _out = _o;
      return f;
    };
    f.spread = function(val) {
      if (!arguments.length) {
        return _spread;
      }
      _spread = val;
      return f;
    };
    f.correctLightness = function(v) {
      if (v == null) {
        v = true;
      }
      _correctLightness = v;
      resetCache();
      if (_correctLightness) {
        tmap = function(t) {
          var L0, L1, L_actual, L_diff, L_ideal, max_iter, pol, t0, t1;
          L0 = getColor(0, true).lab()[0];
          L1 = getColor(1, true).lab()[0];
          pol = L0 > L1;
          L_actual = getColor(t, true).lab()[0];
          L_ideal = L0 + (L1 - L0) * t;
          L_diff = L_actual - L_ideal;
          t0 = 0;
          t1 = 1;
          max_iter = 20;
          while (Math.abs(L_diff) > 1e-2 && max_iter-- > 0) {
            (function() {
              if (pol) {
                L_diff *= -1;
              }
              if (L_diff < 0) {
                t0 = t;
                t += (t1 - t) * 0.5;
              } else {
                t1 = t;
                t += (t0 - t) * 0.5;
              }
              L_actual = getColor(t, true).lab()[0];
              return L_diff = L_actual - L_ideal;
            })();
          }
          return t;
        };
      } else {
        tmap = function(t) {
          return t;
        };
      }
      return f;
    };
    f.padding = function(p) {
      if (p != null) {
        if (type(p) === 'number') {
          p = [p, p];
        }
        _padding = p;
        return f;
      } else {
        return _padding;
      }
    };
    f.colors = function(numColors, out) {
      var dd, dm, i, o, ref, result, results, samples, w;
      if (arguments.length < 2) {
        out = 'hex';
      }
      result = [];
      if (arguments.length === 0) {
        result = _colors.slice(0);
      } else if (numColors === 1) {
        result = [f(0.5)];
      } else if (numColors > 1) {
        dm = _domain[0];
        dd = _domain[1] - dm;
        result = (function() {
          results = [];
          for (var o = 0; 0 <= numColors ? o < numColors : o > numColors; 0 <= numColors ? o++ : o--){ results.push(o); }
          return results;
        }).apply(this).map(function(i) {
          return f(dm + i / (numColors - 1) * dd);
        });
      } else {
        colors = [];
        samples = [];
        if (_classes && _classes.length > 2) {
          for (i = w = 1, ref = _classes.length; 1 <= ref ? w < ref : w > ref; i = 1 <= ref ? ++w : --w) {
            samples.push((_classes[i - 1] + _classes[i]) * 0.5);
          }
        } else {
          samples = _domain;
        }
        result = samples.map(function(v) {
          return f(v);
        });
      }
      if (chroma[out]) {
        result = result.map(function(c) {
          return c[out]();
        });
      }
      return result;
    };
    f.cache = function(c) {
      if (c != null) {
        _useCache = c;
        return f;
      } else {
        return _useCache;
      }
    };
    f.gamma = function(g) {
      if (g != null) {
        _gamma = g;
        return f;
      } else {
        return _gamma;
      }
    };
    f.nodata = function(d) {
      if (d != null) {
        _nacol = chroma(d);
        return f;
      } else {
        return _nacol;
      }
    };
    return f;
  };

  if (chroma.scales == null) {
    chroma.scales = {};
  }

  chroma.scales.cool = function() {
    return chroma.scale([chroma.hsl(180, 1, .9), chroma.hsl(250, .7, .4)]);
  };

  chroma.scales.hot = function() {
    return chroma.scale(['#000', '#f00', '#ff0', '#fff'], [0, .25, .75, 1]).mode('rgb');
  };

  chroma.analyze = function(data, key, filter) {
    var add, k, len, o, r, val, visit;
    r = {
      min: Number.MAX_VALUE,
      max: Number.MAX_VALUE * -1,
      sum: 0,
      values: [],
      count: 0
    };
    if (filter == null) {
      filter = function() {
        return true;
      };
    }
    add = function(val) {
      if ((val != null) && !isNaN(val)) {
        r.values.push(val);
        r.sum += val;
        if (val < r.min) {
          r.min = val;
        }
        if (val > r.max) {
          r.max = val;
        }
        r.count += 1;
      }
    };
    visit = function(val, k) {
      if (filter(val, k)) {
        if ((key != null) && type(key) === 'function') {
          return add(key(val));
        } else if ((key != null) && type(key) === 'string' || type(key) === 'number') {
          return add(val[key]);
        } else {
          return add(val);
        }
      }
    };
    if (type(data) === 'array') {
      for (o = 0, len = data.length; o < len; o++) {
        val = data[o];
        visit(val);
      }
    } else {
      for (k in data) {
        val = data[k];
        visit(val, k);
      }
    }
    r.domain = [r.min, r.max];
    r.limits = function(mode, num) {
      return chroma.limits(r, mode, num);
    };
    return r;
  };

  chroma.limits = function(data, mode, num) {
    var aa, ab, ac, ad, ae, af, ag, ah, ai, aj, ak, al, am, assignments, best, centroids, cluster, clusterSizes, dist, i, j, kClusters, limits, max_log, min, min_log, mindist, n, nb_iters, newCentroids, o, p, pb, pr, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, repeat, sum, tmpKMeansBreaks, v, value, values, w;
    if (mode == null) {
      mode = 'equal';
    }
    if (num == null) {
      num = 7;
    }
    if (type(data) === 'array') {
      data = chroma.analyze(data);
    }
    min = data.min;
    max = data.max;
    sum = data.sum;
    values = data.values.sort(function(a, b) {
      return a - b;
    });
    if (num === 1) {
      return [min, max];
    }
    limits = [];
    if (mode.substr(0, 1) === 'c') {
      limits.push(min);
      limits.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
      limits.push(min);
      for (i = o = 1, ref = num - 1; 1 <= ref ? o <= ref : o >= ref; i = 1 <= ref ? ++o : --o) {
        limits.push(min + (i / num) * (max - min));
      }
      limits.push(max);
    } else if (mode.substr(0, 1) === 'l') {
      if (min <= 0) {
        throw 'Logarithmic scales are only possible for values > 0';
      }
      min_log = Math.LOG10E * log(min);
      max_log = Math.LOG10E * log(max);
      limits.push(min);
      for (i = w = 1, ref1 = num - 1; 1 <= ref1 ? w <= ref1 : w >= ref1; i = 1 <= ref1 ? ++w : --w) {
        limits.push(pow(10, min_log + (i / num) * (max_log - min_log)));
      }
      limits.push(max);
    } else if (mode.substr(0, 1) === 'q') {
      limits.push(min);
      for (i = aa = 1, ref2 = num - 1; 1 <= ref2 ? aa <= ref2 : aa >= ref2; i = 1 <= ref2 ? ++aa : --aa) {
        p = (values.length - 1) * i / num;
        pb = floor(p);
        if (pb === p) {
          limits.push(values[pb]);
        } else {
          pr = p - pb;
          limits.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
        }
      }
      limits.push(max);
    } else if (mode.substr(0, 1) === 'k') {

      /*
      implementation based on
      http://code.google.com/p/figue/source/browse/trunk/figue.js#336
      simplified for 1-d input values
       */
      n = values.length;
      assignments = new Array(n);
      clusterSizes = new Array(num);
      repeat = true;
      nb_iters = 0;
      centroids = null;
      centroids = [];
      centroids.push(min);
      for (i = ab = 1, ref3 = num - 1; 1 <= ref3 ? ab <= ref3 : ab >= ref3; i = 1 <= ref3 ? ++ab : --ab) {
        centroids.push(min + (i / num) * (max - min));
      }
      centroids.push(max);
      while (repeat) {
        for (j = ac = 0, ref4 = num - 1; 0 <= ref4 ? ac <= ref4 : ac >= ref4; j = 0 <= ref4 ? ++ac : --ac) {
          clusterSizes[j] = 0;
        }
        for (i = ad = 0, ref5 = n - 1; 0 <= ref5 ? ad <= ref5 : ad >= ref5; i = 0 <= ref5 ? ++ad : --ad) {
          value = values[i];
          mindist = Number.MAX_VALUE;
          for (j = ae = 0, ref6 = num - 1; 0 <= ref6 ? ae <= ref6 : ae >= ref6; j = 0 <= ref6 ? ++ae : --ae) {
            dist = abs(centroids[j] - value);
            if (dist < mindist) {
              mindist = dist;
              best = j;
            }
          }
          clusterSizes[best]++;
          assignments[i] = best;
        }
        newCentroids = new Array(num);
        for (j = af = 0, ref7 = num - 1; 0 <= ref7 ? af <= ref7 : af >= ref7; j = 0 <= ref7 ? ++af : --af) {
          newCentroids[j] = null;
        }
        for (i = ag = 0, ref8 = n - 1; 0 <= ref8 ? ag <= ref8 : ag >= ref8; i = 0 <= ref8 ? ++ag : --ag) {
          cluster = assignments[i];
          if (newCentroids[cluster] === null) {
            newCentroids[cluster] = values[i];
          } else {
            newCentroids[cluster] += values[i];
          }
        }
        for (j = ah = 0, ref9 = num - 1; 0 <= ref9 ? ah <= ref9 : ah >= ref9; j = 0 <= ref9 ? ++ah : --ah) {
          newCentroids[j] *= 1 / clusterSizes[j];
        }
        repeat = false;
        for (j = ai = 0, ref10 = num - 1; 0 <= ref10 ? ai <= ref10 : ai >= ref10; j = 0 <= ref10 ? ++ai : --ai) {
          if (newCentroids[j] !== centroids[i]) {
            repeat = true;
            break;
          }
        }
        centroids = newCentroids;
        nb_iters++;
        if (nb_iters > 200) {
          repeat = false;
        }
      }
      kClusters = {};
      for (j = aj = 0, ref11 = num - 1; 0 <= ref11 ? aj <= ref11 : aj >= ref11; j = 0 <= ref11 ? ++aj : --aj) {
        kClusters[j] = [];
      }
      for (i = ak = 0, ref12 = n - 1; 0 <= ref12 ? ak <= ref12 : ak >= ref12; i = 0 <= ref12 ? ++ak : --ak) {
        cluster = assignments[i];
        kClusters[cluster].push(values[i]);
      }
      tmpKMeansBreaks = [];
      for (j = al = 0, ref13 = num - 1; 0 <= ref13 ? al <= ref13 : al >= ref13; j = 0 <= ref13 ? ++al : --al) {
        tmpKMeansBreaks.push(kClusters[j][0]);
        tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
      }
      tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
        return a - b;
      });
      limits.push(tmpKMeansBreaks[0]);
      for (i = am = 1, ref14 = tmpKMeansBreaks.length - 1; am <= ref14; i = am += 2) {
        v = tmpKMeansBreaks[i];
        if (!isNaN(v) && limits.indexOf(v) === -1) {
          limits.push(v);
        }
      }
    }
    return limits;
  };

  hsi2rgb = function(h, s, i) {

    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
     */
    var args, b, g, r;
    args = unpack(arguments);
    h = args[0], s = args[1], i = args[2];
    if (isNaN(h)) {
      h = 0;
    }
    h /= 360;
    if (h < 1 / 3) {
      b = (1 - s) / 3;
      r = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
      g = 1 - (b + r);
    } else if (h < 2 / 3) {
      h -= 1 / 3;
      r = (1 - s) / 3;
      g = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
      b = 1 - (r + g);
    } else {
      h -= 2 / 3;
      g = (1 - s) / 3;
      b = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
      r = 1 - (g + b);
    }
    r = limit(i * r * 3);
    g = limit(i * g * 3);
    b = limit(i * b * 3);
    return [r * 255, g * 255, b * 255, args.length > 3 ? args[3] : 1];
  };

  rgb2hsi = function() {

    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
     */
    var b, g, h, i, min, r, ref, s;
    ref = unpack(arguments), r = ref[0], g = ref[1], b = ref[2];
    TWOPI = Math.PI * 2;
    r /= 255;
    g /= 255;
    b /= 255;
    min = Math.min(r, g, b);
    i = (r + g + b) / 3;
    s = 1 - min / i;
    if (s === 0) {
      h = 0;
    } else {
      h = ((r - g) + (r - b)) / 2;
      h /= Math.sqrt((r - g) * (r - g) + (r - b) * (g - b));
      h = Math.acos(h);
      if (b > g) {
        h = TWOPI - h;
      }
      h /= TWOPI;
    }
    return [h * 360, s, i];
  };

  chroma.hsi = function() {
    return (function(func, args, ctor) {
      ctor.prototype = func.prototype;
      var child = new ctor, result = func.apply(child, args);
      return Object(result) === result ? result : child;
    })(Color, slice.call(arguments).concat(['hsi']), function(){});
  };

  _input.hsi = hsi2rgb;

  Color.prototype.hsi = function() {
    return rgb2hsi(this._rgb);
  };

  interpolate_hsx = function(col1, col2, f, m) {
    var dh, hue, hue0, hue1, lbv, lbv0, lbv1, res, sat, sat0, sat1, xyz0, xyz1;
    if (m === 'hsl') {
      xyz0 = col1.hsl();
      xyz1 = col2.hsl();
    } else if (m === 'hsv') {
      xyz0 = col1.hsv();
      xyz1 = col2.hsv();
    } else if (m === 'hcg') {
      xyz0 = col1.hcg();
      xyz1 = col2.hcg();
    } else if (m === 'hsi') {
      xyz0 = col1.hsi();
      xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
      m = 'hcl';
      xyz0 = col1.hcl();
      xyz1 = col2.hcl();
    }
    if (m.substr(0, 1) === 'h') {
      hue0 = xyz0[0], sat0 = xyz0[1], lbv0 = xyz0[2];
      hue1 = xyz1[0], sat1 = xyz1[1], lbv1 = xyz1[2];
    }
    if (!isNaN(hue0) && !isNaN(hue1)) {
      if (hue1 > hue0 && hue1 - hue0 > 180) {
        dh = hue1 - (hue0 + 360);
      } else if (hue1 < hue0 && hue0 - hue1 > 180) {
        dh = hue1 + 360 - hue0;
      } else {
        dh = hue1 - hue0;
      }
      hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
      hue = hue0;
      if ((lbv1 === 1 || lbv1 === 0) && m !== 'hsv') {
        sat = sat0;
      }
    } else if (!isNaN(hue1)) {
      hue = hue1;
      if ((lbv0 === 1 || lbv0 === 0) && m !== 'hsv') {
        sat = sat1;
      }
    } else {
      hue = Number.NaN;
    }
    if (sat == null) {
      sat = sat0 + f * (sat1 - sat0);
    }
    lbv = lbv0 + f * (lbv1 - lbv0);
    return res = chroma[m](hue, sat, lbv);
  };

  _interpolators = _interpolators.concat((function() {
    var len, o, ref, results;
    ref = ['hsv', 'hsl', 'hsi', 'hcl', 'lch', 'hcg'];
    results = [];
    for (o = 0, len = ref.length; o < len; o++) {
      m = ref[o];
      results.push([m, interpolate_hsx]);
    }
    return results;
  })());

  interpolate_num = function(col1, col2, f, m) {
    var n1, n2;
    n1 = col1.num();
    n2 = col2.num();
    return chroma.num(n1 + (n2 - n1) * f, 'num');
  };

  _interpolators.push(['num', interpolate_num]);

  interpolate_lab = function(col1, col2, f, m) {
    var res, xyz0, xyz1;
    xyz0 = col1.lab();
    xyz1 = col2.lab();
    return res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
  };

  _interpolators.push(['lab', interpolate_lab]);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)(module)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var has = Object.prototype.hasOwnProperty;
module.exports = function assign(target, source) {
	if (Object.assign) {
		return Object.assign(target, source);
	}
	for (var key in source) {
		if (has.call(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAAxQTFRF4ODg5OTk9fX1////jol00AAAAAR0Uk5T////AEAqqfQAAABHSURBVHja7NYxCgAwCARBNf//c4SIZfCs9/pB7NYsd8azms+JF4k5iXdDEGlc+aP/gUAgEAgEAvmljx4km+xZxZWYcFeAAQDy2ByxvZuuEQAAAABJRU5ErkJggg=="

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CountingNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_countup__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_countup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_countup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CountingNumber_module_css__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CountingNumber_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CountingNumber_module_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var CountingNumber=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(CountingNumber,_React$Component);function CountingNumber(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CountingNumber);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CountingNumber.__proto__||Object.getPrototypeOf(CountingNumber)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'previousNumber',_descriptor,_this),_initDefineProp(_this,'speed',_descriptor2,_this),_initDefineProp(_this,'changeNumber',_descriptor3,_this),_initDefineProp(_this,'setSpeed',_descriptor4,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CountingNumber,[{key:'componentWillUpdate',value:function componentWillUpdate(oldProps){if(this.props.number!==oldProps.number){this.setSpeed(this.props.number,oldProps.number);this.changeNumber();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_countup___default.a,{className:this.props.absolute?__WEBPACK_IMPORTED_MODULE_4__CountingNumber_module_css___default.a.absolute:__WEBPACK_IMPORTED_MODULE_4__CountingNumber_module_css___default.a.relative,start:this.previousNumber,end:this.props.number,separator:',',suffix:this.props.suffix,duration:this.speed,easingFn:function easingFn(t,b,c,d){t/=d;t--;return c*(t*t*t+1)+b;}});}}]);return CountingNumber;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'previousNumber',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'speed',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 1.2;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'changeNumber',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){_this2.previousNumber=_this2.props.number;};}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'setSpeed',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(newnum,old){var diff=Math.abs(newnum-old);console.log(diff);_this3.speed=diff/100*_this3.props.maxDuration;// if(this.speed < 0.2) this.speed = 0.01
// else if(this.speed < 0.4) this.speed = 0.4
if(_this3.speed>_this3.props.maxDuration)_this3.speed=_this3.props.maxDuration;};}})),_class2))||_class;CountingNumber.defaultProps={maxDuration:2};

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IntersectionObserver__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IntersectionObserver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(32);
/* unused harmony reexport parseRootMargin */



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMTypeElement;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRootMargin;
/* harmony export (immutable) */ __webpack_exports__["c"] = shallowCompare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function isDOMTypeElement(element) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element) && typeof element.type === 'string';
}

var marginRE = /^-?\d*\.?\d+(px|%)$/;

function parseRootMargin(rootMargin) {
    var marginString = rootMargin ? rootMargin.trim() : '0px';

    var _marginString$split$m = marginString.split(/\s+/).map(function (margin) {
        if (!marginRE.test(margin)) {
            throw new Error('rootMargin must be a string literal containing pixels and/or percent values');
        }
        return margin;
    }),
        _marginString$split$m2 = _marginString$split$m[0],
        m0 = _marginString$split$m2 === undefined ? '0px' : _marginString$split$m2,
        _marginString$split$m3 = _marginString$split$m[1],
        m1 = _marginString$split$m3 === undefined ? m0 : _marginString$split$m3,
        _marginString$split$m4 = _marginString$split$m[2],
        m2 = _marginString$split$m4 === undefined ? m0 : _marginString$split$m4,
        _marginString$split$m5 = _marginString$split$m[3],
        m3 = _marginString$split$m5 === undefined ? m1 : _marginString$split$m5;

    return m0 + ' ' + m1 + ' ' + m2 + ' ' + m3;
}

function shallowCompare(next, prev) {
    if (Array.isArray(next) && Array.isArray(prev)) {
        if (next.length === prev.length) {
            return next.some(function (_, index) {
                return shallowCompare(next[index], prev[index]);
            });
        }
    }
    return next !== prev;
}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sigFig;
/* harmony export (immutable) */ __webpack_exports__["b"] = rawSigFig;
/* harmony export (immutable) */ __webpack_exports__["c"] = truncateNum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commaNumber__ = __webpack_require__(19);
function sigFig(number){if(number>=1000000){return(number/1000000).toPrecision(2)+' million';}else if(number>=1000){return Object(__WEBPACK_IMPORTED_MODULE_0__commaNumber__["a" /* default */])((number/1000).toPrecision(3)*1000);}else return number;// else console.log('sigFig didnt know what to do with' , number)
}function rawSigFig(number){if(number>=1000000){return(number/1000000).toPrecision(2)*1000000;}else if(number>=1000){return(number/1000).toPrecision(3)*1000;}else return number;}function truncateNum(number){if(number>=1000000){return(number/1000000).toPrecision(2)+'m';}else if(number>=100000){return(number/1000).toPrecision(3)+'k';}else if(number>=10000){return(number/1000).toPrecision(2)+'k';}else if(number>=1000){return(number/1000).toPrecision(1)+'k';}else if(number>=100){return(number/100).toPrecision(2)*100;}else return number;}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(71);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = ["of","and","with","who","by","California","in","kids","children","at","in","boys","girls","while","the","2012","2013","2014","2015","2016","year","san","county","race","black","african-american","asian","latino","white","other","childhood"]

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(17);

var implementation = __webpack_require__(41);
var getPolyfill = __webpack_require__(49);
var shim = __webpack_require__(139);

var polyfill = getPolyfill();

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(130);
var has = __webpack_require__(21);
var bind = __webpack_require__(22);
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

module.exports = function values(O) {
	var obj = ES.RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES2015 = __webpack_require__(43);
var assign = __webpack_require__(28);

var ES2016 = assign(assign({}, ES2015), {
	// https://github.com/tc39/ecma262/pull/60
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	}
});

module.exports = ES2016;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(21);
var toPrimitive = __webpack_require__(132);

var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
var SymbolIterator = hasSymbols ? Symbol.iterator : null;

var $isNaN = __webpack_require__(45);
var $isFinite = __webpack_require__(46);
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var assign = __webpack_require__(28);
var sign = __webpack_require__(47);
var mod = __webpack_require__(48);
var isPrimitive = __webpack_require__(135);
var parseInteger = parseInt;
var bind = __webpack_require__(22);
var arraySlice = bind.call(Function.call, Array.prototype.slice);
var strSlice = bind.call(Function.call, String.prototype.slice);
var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
var regexExec = bind.call(Function.call, RegExp.prototype.exec);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);

// whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = bind.call(Function.call, String.prototype.replace);
var trim = function (value) {
	return replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(136);

var hasRegExpMatcher = __webpack_require__(138);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new TypeError(F + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, Number);
		if (typeof value === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) { return 0; }
		if (number >= 0xFF) { return 0xFF; }
		var f = Math.floor(argument);
		if (f + 0.5 < number) { return f + 1; }
		if (number < f + 0.5) { return f; }
		if (f % 2 !== 0) { return f + 1; }
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a string');
		}
		return String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, String);
		return typeof key === 'symbol' ? key : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr.call(argument) !== '[object String]') {
			throw new TypeError('must be a string');
		}
		if (argument === '-0') { return -0; }
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) { return n; }
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: Array.isArray || function IsArray(argument) {
		return toStr.call(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: function IsExtensible(obj) {
		if (!Object.preventExtensions) { return true; }
		if (isPrimitive(obj)) {
			return false;
		}
		return Object.isExtensible(obj);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = Math.abs(argument);
		return Math.floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || typeof argument !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	},

	/**
	 * 7.3.2 GetV (V, P)
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let O be ToObject(V).
	 * 3. ReturnIfAbrupt(O).
	 * 4. Return O.[[Get]](P, V).
	 */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
	 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let func be GetV(O, P).
	 * 3. ReturnIfAbrupt(func).
	 * 4. If func is either undefined or null, return undefined.
	 * 5. If IsCallable(func) is false, throw a TypeError exception.
	 * 6. Return func.
	 */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return void 0;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
	 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
	 * 1. Assert: Type(O) is Object.
	 * 2. Assert: IsPropertyKey(P) is true.
	 * 3. Return O.[[Get]](P, O).
	 */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && Symbol.species ? C[Symbol.species] : void 0;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new TypeError('no constructor found');
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
	CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
			if (!has(Desc, '[[Value]]')) {
				Desc['[[Value]]'] = void 0;
			}
			if (!has(Desc, '[[Writable]]')) {
				Desc['[[Writable]]'] = false;
			}
		} else {
			if (!has(Desc, '[[Get]]')) {
				Desc['[[Get]]'] = void 0;
			}
			if (!has(Desc, '[[Set]]')) {
				Desc['[[Set]]'] = void 0;
			}
		}
		if (!has(Desc, '[[Enumerable]]')) {
			Desc['[[Enumerable]]'] = false;
		}
		if (!has(Desc, '[[Configurable]]')) {
			Desc['[[Configurable]]'] = false;
		}
		return Desc;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
	Set: function Set(O, P, V, Throw) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		if (this.Type(Throw) !== 'Boolean') {
			throw new TypeError('Throw must be a Boolean');
		}
		if (Throw) {
			O[P] = V;
			return true;
		} else {
			try {
				O[P] = V;
			} catch (e) {
				return false;
			}
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
	HasOwnProperty: function HasOwnProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		return has(O, P);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-hasproperty
	HasProperty: function HasProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		return P in O;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
	IsConcatSpreadable: function IsConcatSpreadable(O) {
		if (this.Type(O) !== 'Object') {
			return false;
		}
		if (hasSymbols && typeof Symbol.isConcatSpreadable === 'symbol') {
			var spreadable = this.Get(O, Symbol.isConcatSpreadable);
			if (typeof spreadable !== 'undefined') {
				return this.ToBoolean(spreadable);
			}
		}
		return this.IsArray(O);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-invoke
	Invoke: function Invoke(O, P) {
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		var argumentsList = arraySlice(arguments, 2);
		var func = this.GetV(O, P);
		return this.Call(func, O, argumentsList);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-getiterator
	GetIterator: function GetIterator(obj, method) {
		if (!hasSymbols) {
			throw new SyntaxError('ES.GetIterator depends on native iterator support.');
		}

		var actualMethod = method;
		if (arguments.length < 2) {
			actualMethod = this.GetMethod(obj, SymbolIterator);
		}
		var iterator = this.Call(actualMethod, obj);
		if (this.Type(iterator) !== 'Object') {
			throw new TypeError('iterator must return an object');
		}

		return iterator;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-iteratornext
	IteratorNext: function IteratorNext(iterator, value) {
		var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
		if (this.Type(result) !== 'Object') {
			throw new TypeError('iterator next must return an object');
		}
		return result;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
	IteratorComplete: function IteratorComplete(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.ToBoolean(this.Get(iterResult, 'done'));
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
	IteratorValue: function IteratorValue(iterResult) {
		if (this.Type(iterResult) !== 'Object') {
			throw new TypeError('Assertion failed: Type(iterResult) is not Object');
		}
		return this.Get(iterResult, 'value');
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
	IteratorStep: function IteratorStep(iterator) {
		var result = this.IteratorNext(iterator);
		var done = this.IteratorComplete(result);
		return done === true ? false : result;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
	IteratorClose: function IteratorClose(iterator, completion) {
		if (this.Type(iterator) !== 'Object') {
			throw new TypeError('Assertion failed: Type(iterator) is not Object');
		}
		if (!this.IsCallable(completion)) {
			throw new TypeError('Assertion failed: completion is not a thunk for a Completion Record');
		}
		var completionThunk = completion;

		var iteratorReturn = this.GetMethod(iterator, 'return');

		if (typeof iteratorReturn === 'undefined') {
			return completionThunk();
		}

		var completionRecord;
		try {
			var innerResult = this.Call(iteratorReturn, iterator, []);
		} catch (e) {
			// if we hit here, then "e" is the innerResult completion that needs re-throwing

			// if the completion is of type "throw", this will throw.
			completionRecord = completionThunk();
			completionThunk = null; // ensure it's not called twice.

			// if not, then return the innerResult completion
			throw e;
		}
		completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
		completionThunk = null; // ensure it's not called twice.

		if (this.Type(innerResult) !== 'Object') {
			throw new TypeError('iterator .return must return an object');
		}

		return completionRecord;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
	CreateIterResultObject: function CreateIterResultObject(value, done) {
		if (this.Type(done) !== 'Boolean') {
			throw new TypeError('Assertion failed: Type(done) is not Boolean');
		}
		return {
			value: value,
			done: done
		};
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-regexpexec
	RegExpExec: function RegExpExec(R, S) {
		if (this.Type(R) !== 'Object') {
			throw new TypeError('R must be an Object');
		}
		if (this.Type(S) !== 'String') {
			throw new TypeError('S must be a String');
		}
		var exec = this.Get(R, 'exec');
		if (this.IsCallable(exec)) {
			var result = this.Call(exec, R, [S]);
			if (result === null || this.Type(result) === 'Object') {
				return result;
			}
			throw new TypeError('"exec" method must return `null` or an Object');
		}
		return regexExec(R, S);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
	ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
		if (!this.IsInteger(length) || length < 0) {
			throw new TypeError('Assertion failed: length must be an integer >= 0');
		}
		var len = length === 0 ? 0 : length;
		var C;
		var isArray = this.IsArray(originalArray);
		if (isArray) {
			C = this.Get(originalArray, 'constructor');
			// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
			// if (this.IsConstructor(C)) {
			// 	if C is another realm's Array, C = undefined
			// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
			// }
			if (this.Type(C) === 'Object' && hasSymbols && Symbol.species) {
				C = this.Get(C, Symbol.species);
				if (C === null) {
					C = void 0;
				}
			}
		}
		if (typeof C === 'undefined') {
			return Array(len);
		}
		if (!this.IsConstructor(C)) {
			throw new TypeError('C must be a constructor');
		}
		return new C(len); // this.Construct(C, len);
	},

	CreateDataProperty: function CreateDataProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var oldDesc = Object.getOwnPropertyDescriptor(O, P);
		var extensible = oldDesc || (typeof Object.isExtensible !== 'function' || Object.isExtensible(O));
		var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
		if (immutable || !extensible) {
			return false;
		}
		var newDesc = {
			configurable: true,
			enumerable: true,
			value: V,
			writable: true
		};
		Object.defineProperty(O, P, newDesc);
		return true;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
	CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var success = this.CreateDataProperty(O, P, V);
		if (!success) {
			throw new TypeError('unable to create data property');
		}
		return success;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
	AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
		if (this.Type(S) !== 'String') {
			throw new TypeError('Assertion failed: Type(S) is not String');
		}
		if (!this.IsInteger(index)) {
			throw new TypeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
		}
		if (index < 0 || index > MAX_SAFE_INTEGER) {
			throw new RangeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
		}
		if (this.Type(unicode) !== 'Boolean') {
			throw new TypeError('Assertion failed: Type(unicode) is not Boolean');
		}
		if (!unicode) {
			return index + 1;
		}
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}
		var first = S.charCodeAt(index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}
		var second = S.charCodeAt(index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}
		return index + 2;
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(41);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(140);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_media__ = __webpack_require__(3);
var _templateObject=_taggedTemplateLiteral(['\n    html{\n        @media ','{\n            // background: var(--offwhitefg);\n        }\n    }\n    @media ',', ','{\n        body{\n            &::before{\n                position: absolute;\n                top: 0;\n                content: \'\';\n                width: 100%;\n                background: var(--offwhitebg);\n                @media ','{\n                    height: 90px;\n                }\n                @media ','{\n                    height: 75px;\n                }\n                z-index: 3;\n\n            }\n            &::after{\n                position: absolute;\n                content: \'\';\n                width: 100%;\n                background: var(--offwhitebg);\n                @media ','{\n                    top: 960px;\n                    height: 75px;\n                }\n                @media ','{\n                    top: 740px;\n                    height: 75px;\n                }\n                z-index: 0;\n            }\n        }\n\n        .listitem{\n            @media ','{\n                font-size: 16px;\n                letter-spacing: .7px;\n            }\n            @media ','{\n                font-size: 13px;\n                letter-spacing: .5px;\n            }\n        }\n\n        .title{\n            font-size: 24px;\n            letter-spacing: .92px;\n            font-weight: 400;\n            @media ','{\n                font-size: 24px;\n            }\n            @media ','{\n                font-size: 20px;\n            }\n        }\n    }\n    @media ','{\n        body{\n            // background: transparent;\n            background-image: url(',');\n            background-size: 20px;\n            background-position: 17px 17px;\n        }\n    }\n\n'],['\n    html{\n        @media ','{\n            // background: var(--offwhitefg);\n        }\n    }\n    @media ',', ','{\n        body{\n            &::before{\n                position: absolute;\n                top: 0;\n                content: \'\';\n                width: 100%;\n                background: var(--offwhitebg);\n                @media ','{\n                    height: 90px;\n                }\n                @media ','{\n                    height: 75px;\n                }\n                z-index: 3;\n\n            }\n            &::after{\n                position: absolute;\n                content: \'\';\n                width: 100%;\n                background: var(--offwhitebg);\n                @media ','{\n                    top: 960px;\n                    height: 75px;\n                }\n                @media ','{\n                    top: 740px;\n                    height: 75px;\n                }\n                z-index: 0;\n            }\n        }\n\n        .listitem{\n            @media ','{\n                font-size: 16px;\n                letter-spacing: .7px;\n            }\n            @media ','{\n                font-size: 13px;\n                letter-spacing: .5px;\n            }\n        }\n\n        .title{\n            font-size: 24px;\n            letter-spacing: .92px;\n            font-weight: 400;\n            @media ','{\n                font-size: 24px;\n            }\n            @media ','{\n                font-size: 20px;\n            }\n        }\n    }\n    @media ','{\n        body{\n            // background: transparent;\n            background-image: url(',');\n            background-size: 20px;\n            background-position: 17px 17px;\n        }\n    }\n\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var dots=__webpack_require__(29);var GlobalStyle=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["a" /* createGlobalStyle */])(_templateObject,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].mobile,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_1__utilities_media__["a" /* default */].mobile,dots);/* harmony default export */ __webpack_exports__["a"] = (GlobalStyle);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var prefix = __webpack_require__(155)
var toCamelCase = __webpack_require__(156)
var cache = { 'float': 'cssFloat' }
var addPxToStyle = __webpack_require__(159)

function style (element, property, value) {
  var camel = cache[property]
  if (typeof camel === 'undefined') {
    camel = detect(property)
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value)
  }
}

function each (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k])
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp)
  var result = prefix(camel)
  cache[camel] = cache[cssProp] = cache[result] = result
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1]
    } else {
      each(arguments[0], arguments[1])
    }
  } else {
    style(arguments[0], arguments[1], arguments[2])
  }
}

module.exports = set
module.exports.set = set

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '')
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Readout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_commaNumber__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CountingNumber__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_media__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5;var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    padding-right: 30px;\n    @media ','{\n        width: 950px;   \n    }\n    @media ','{\n        width: 850px;   \n    }\n    @media ','{\n        width: 100%;\n        padding: 15px;\n    }\n    left: 0;\n    top: 0;\n    transform-origin: 50% 0%;\n    /*position: absolute;*/\n    /*flex-grow: ',';*/\n    b{\n        font-weight: 600;\n    }\n    h1{\n        position: absolute;\n        top: -6px;\n        left: 0;\n        margin: 0;\n        font-size: 48px;\n        @media ','{\n            font-size: 42px;\n        }\n        @media ','{\n            font-size: 32px;\n        }\n        font-weight: 600;\n    }\n    ','\n\n'],['\n    display: flex;\n    align-items: center;\n    padding-right: 30px;\n    @media ','{\n        width: 950px;   \n    }\n    @media ','{\n        width: 850px;   \n    }\n    @media ','{\n        width: 100%;\n        padding: 15px;\n    }\n    left: 0;\n    top: 0;\n    transform-origin: 50% 0%;\n    /*position: absolute;*/\n    /*flex-grow: ',';*/\n    b{\n        font-weight: 600;\n    }\n    h1{\n        position: absolute;\n        top: -6px;\n        left: 0;\n        margin: 0;\n        font-size: 48px;\n        @media ','{\n            font-size: 42px;\n        }\n        @media ','{\n            font-size: 32px;\n        }\n        font-weight: 600;\n    }\n    ','\n\n']),_templateObject2=_taggedTemplateLiteral(['\n    \n    @media ','{\n        padding-top: 18px;\n        line-height: 40px;\n    }\n    @media ','{\n        padding-top: 12px;\n        line-height: 34px;\n    }\n    @media ','{\n        padding-top: 9px;\n        line-height: 25px;\n        ','\n    }\n'],['\n    \n    @media ','{\n        padding-top: 18px;\n        line-height: 40px;\n    }\n    @media ','{\n        padding-top: 12px;\n        line-height: 34px;\n    }\n    @media ','{\n        padding-top: 9px;\n        line-height: 25px;\n        ','\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    // display: inline-flex;\n    position: relative;\n    box-sizing: border-box;\n    padding-bottom: 5px;\n    border-bottom: ',';\n    margin: ',';   \n'],['\n    // display: inline-flex;\n    position: relative;\n    box-sizing: border-box;\n    padding-bottom: 5px;\n    border-bottom: ',';\n    margin: ',';   \n']),_templateObject4=_taggedTemplateLiteral(['\n    opacity: 0;\n'],['\n    opacity: 0;\n']),_templateObject5=_taggedTemplateLiteral(['\n    font-size: 13px;\n    margin-left: 10px;\n    color: var(--fainttext);\n'],['\n    font-size: 13px;\n    margin-left: 10px;\n    color: var(--fainttext);\n']),_templateObject6=_taggedTemplateLiteral(['\n    // border: 1px solid red;\n    padding-top: 3px;\n    line-height: 170%;\n    @media ','{\n        \n    }\n    @media ','{\n        width: 480px;\n    }\n    @media ','{\n\n    }\n'],['\n    // border: 1px solid red;\n    padding-top: 3px;\n    line-height: 170%;\n    @media ','{\n        \n    }\n    @media ','{\n        width: 480px;\n    }\n    @media ','{\n\n    }\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import semanticTitles from '../assets/semanticTitles'
var ReadoutBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].mobile,function(props){return props.compact?0:1;},__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].mobile,function(props){return props.tiny?'\n        h1{\n            font-size: 18px;\n        }\n    ':'';});var IndentedTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].mobile,function(props){return props.tiny?'\n            font-size: 14px;\n            line-height: 21px;\n            margin-top: -2px;\n            padding-top: 0;\n        ':'';});var Crumb=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject3,function(props){return props.active?'1px solid black':'1px solid transparent';},function(props){return props.active?'0 .5rem':'0 0 0 0.4rem';});var ShadowNum=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h1(_templateObject4);var Readout=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(Readout,_React$Component);function Readout(props){_classCallCheck(this,Readout);var _this=_possibleConstructorReturn(this,(Readout.__proto__||Object.getPrototypeOf(Readout)).call(this,props));_initDefineProp(_this,'bigNumberWidth',_descriptor,_this);_initDefineProp(_this,'setBigNumberWidth',_descriptor2,_this);_initDefineProp(_this,'firstLine',_descriptor3,_this);_initDefineProp(_this,'subsequentLines',_descriptor4,_this);_initDefineProp(_this,'computeLineBreaks',_descriptor5,_this);_this.nbspString=function(str){//what if theres less than 3 words?
var words=str.split(' ');if(words.length>=2){return words.slice(0,words.length-2).join(' ')+' '+words.slice(words.length-2).join('\xa0');}else return str;};_this.componentDidMount=function(){if(_this.props.store.indicator)_this.setBigNumberWidth();_this.computeLineBreaks();// document.fonts.ready.then(()=>this.setBigNumberWidth())
};_this.componentDidUpdate=function(newProps){if(_this.props.store.indicator)_this.setBigNumberWidth();_this.computeLineBreaks();};_this.offsetBreakdown=function(v){console.log('readout offset breakdown',v);// this.props.offsetBreakdown(v)
};_this.bigNumber=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(Readout,[{key:'render',value:function render(){var tiny=this.props.tiny;var _props$store=this.props.store,county=_props$store.county,indicator=_props$store.indicator,race=_props$store.race,year=_props$store.year;var raceString=race?''+(race!=='white'?race.charAt(0).toUpperCase()+race.substr(1):race):'';var countyString=county?Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_9__assets_counties__["a" /* counties */],{id:county}).label+' county':'California';var semanticTitle=indicator?__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */][indicator].semantics:'';var who=indicator?semanticTitle.who:'children';var what=indicator?semanticTitle.what:'';var descriptor=indicator?semanticTitle.descriptor:'';var popCount=county&&race?(__WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json___default.a[county][race]/100*__WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json___default.a[county].population).toFixed(0):county?__WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json___default.a[county].population:race?(__WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json___default.a.california[race]/100*__WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation_json___default.a.california.population).toFixed(0):'';var ind=__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */][indicator];var actualYear=ind?ind.years[year]:'';var displayNum=void 0;var cty=!this.props.forceCA?county:'california';if(indicator){displayNum=county&&race?ind.counties[cty][race][year]:county&&!race?ind.counties[cty].totals[year]:!county&&race?ind.counties.california[race][year]:!county&&!race?ind.counties.california.totals[year]:'wat';}var computedString=raceString+' '+who+' live in '+countyString;var readout='of '+(descriptor||'')+' '+raceString+' '+who+' '+what+' in '+countyString+' in '+actualYear+'.';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReadoutBlock,{className:['title',this.props.className].join(' '),compact:this.props.store.activeWorkflow,tiny:tiny},indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',display:'inline-flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShadowNum,{ref:this.bigNumber},displayNum,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CountingNumber__["a" /* default */],{number:displayNum,suffix:'%',absolute:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndentedTitle,{tiny:tiny,style:{textIndent:this.bigNumberWidth+(tiny?5:8)+'px'}},this.firstLine,__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */][indicator].categories.includes('unstable')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnstableAddendum,null,'Indicator data is unstable; exceptions listed in notes and sources.'))));}}]);return Readout;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'bigNumberWidth',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'setBigNumberWidth',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return function(){var width=Object(__WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"])(_this2.bigNumber.current).offsetWidth;_this2.bigNumberWidth=width;console.log('set big number widcth: ',width);console.log(_this2.bigNumber.current.offsetWidth);};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'firstLine',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'subsequentLines',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'computeLineBreaks',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(str){var _props$store2=_this3.props.store,county=_props$store2.county,indicator=_props$store2.indicator,race=_props$store2.race,year=_props$store2.year,screen=_props$store2.screen;var raceString=race==='other'?'of other races':race?race.charAt(0).toUpperCase()+race.substr(1):'';var countyString=county&&!_this3.props.forceCA?Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_9__assets_counties__["a" /* counties */],{id:county}).label+' county':'California';var semanticTitle=indicator?__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */][indicator].semantics:'';var who=indicator?semanticTitle.who:'children';var what=indicator?semanticTitle.what:'';var descriptor=indicator?semanticTitle.descriptor:'';var ind=__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */][indicator];var actualYear=ind?ind.years[year]:'';var readout='of '+(descriptor||'')+' '+(race!=='other'?raceString:'')+' '+who+(race==='other'?raceString:'')+(what[0]===','?'':' ')+what+' in '+countyString+' in '+actualYear+'.';var firstLineBreakPoint=screen==='optimal'?85:screen==='compact'?60:40;var minCharsInSubsequent=15;if(readout.length>firstLineBreakPoint){var i=0;var actualBreakIndex=void 0;while(i<firstLineBreakPoint){if(readout[firstLineBreakPoint-i]===' '&&readout.slice(firstLineBreakPoint-i).length>minCharsInSubsequent){console.log('blank space (that wont widow) at',firstLineBreakPoint-i);actualBreakIndex=firstLineBreakPoint-i;break;}i++;}// this.firstLine = readout.slice(0,actualBreakIndex)
// this.subsequentLines = this.nbspString(readout.slice(actualBreakIndex))
_this3.firstLine=readout;}else{_this3.firstLine=readout;// this.subsequentLines = ''
}};}})),_class2))||_class;var UnstableAddendum=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject5);var Sublines=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].device);var SubsequentLines=function(_React$Component2){_inherits(SubsequentLines,_React$Component2);function SubsequentLines(props){_classCallCheck(this,SubsequentLines);var _this4=_possibleConstructorReturn(this,(SubsequentLines.__proto__||Object.getPrototypeOf(SubsequentLines)).call(this,props));_this4.getHeight=function(){_this4.props.offsetBreakdown(_this4.wrapper.current.offsetHeight);};_this4.wrapper=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this4;}_createClass(SubsequentLines,[{key:'componentDidUpdate',// componentDidMount(){
//     // this.getHeight()
// }
value:function componentDidUpdate(oldProps){this.getHeight();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sublines,{ref:this.wrapper},this.props.children);}}]);return SubsequentLines;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndicatorByRaces; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HorizontalBarGraph__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_media__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2;var _templateObject=_taggedTemplateLiteral(['\n    color: ',';\n    span{\n        color: ',';\n    }\n'],['\n    color: ',';\n    span{\n        color: ',';\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    // margin-top: 45px;\n    position: absolute;\n    \n    width: 100%;\n    bottom: 0;\n    z-index: 11;\n    transform: translate(',');\n    transition: transform ','s  cubic-bezier(0.215, 0.61, 0.355, 1), opacity ',';\n    opacity: ',';\n    cursor: ',';\n\n    @media ','{\n        top: 490px;\n    }\n'],['\n    // margin-top: 45px;\n    position: absolute;\n    \n    width: 100%;\n    bottom: 0;\n    z-index: 11;\n    transform: translate(',');\n    transition: transform ','s  cubic-bezier(0.215, 0.61, 0.355, 1), opacity ',';\n    opacity: ',';\n    cursor: ',';\n\n    @media ','{\n        top: 490px;\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    margin: 0 20px;\n    padding: 0 15px;\n    @media ','{\n        margin: 0 15px;\n    }\n    background: var(--offwhitefg);\n    transform: translate(',');\n    transition: transform ','s cubic-bezier(0.215, 0.61, 0.355, 1), opacity .2s;\n    color: ',';\n\n'],['\n    margin: 0 20px;\n    padding: 0 15px;\n    @media ','{\n        margin: 0 15px;\n    }\n    background: var(--offwhitefg);\n    transform: translate(',');\n    transition: transform ','s cubic-bezier(0.215, 0.61, 0.355, 1), opacity .2s;\n    color: ',';\n\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import semanticTitles from '../assets/semanticTitles'
var races=['asian','black','latinx','white','other'];var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject,function(props){return props.invalid?'var(--fainttext)':props.hovered||props.selected?'var(--strokepeach)':'var(--normtext)';},function(props){return props.hovered||props.selected?'var(--peach)':'var(--fainttext)';});var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.offset;},function(props){return props.hide?.5:.35;},function(props){return props.hide?'.2s .15s':'.1s';},function(props){return props.hide?0:1;},function(props){return props.clickable?'pointer':'auto';},__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].mobile);var IndicatorByRaces=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(IndicatorByRaces,_React$Component);function IndicatorByRaces(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IndicatorByRaces);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IndicatorByRaces.__proto__||Object.getPrototypeOf(IndicatorByRaces)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'hovered',_descriptor,_this),_initDefineProp(_this,'hover',_descriptor2,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IndicatorByRaces,[{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.expand)this.hover(false);}},{key:'render',value:function render(){var _this2=this;var store=this.props.store;var indicator=store.indicator,year=store.year,county=store.county,colorScale=store.colorScale,screen=store.screen,setHover=store.setHover,hoveredRace=store.hoveredRace;var selectedRace=this.props.store.race;var ind=county?__WEBPACK_IMPORTED_MODULE_4__data_indicators__["a" /* default */][indicator].counties[county]:__WEBPACK_IMPORTED_MODULE_4__data_indicators__["a" /* default */][indicator].counties.california;var indicatorPerformanceByRace=races.map(function(race){var isSomeBullshit=false;var val=void 0;if(ind[race][year]===0||ind[race][year]&&ind[race][year]!=='*'){//use value as is
val=ind[race][year];}else{//trueValue is N/A
val=0;isSomeBullshit=ind[race][year]==='*'&&screen==='mobile'?'Small/unstable':ind[race][year]==='*'?'Data too small or unstable':'No data';isSomeBullshit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{invalid:true},isSomeBullshit);}var who=__WEBPACK_IMPORTED_MODULE_4__data_indicators__["a" /* default */][indicator].semantics.shortWho||__WEBPACK_IMPORTED_MODULE_4__data_indicators__["a" /* default */][indicator].semantics.who;var selected=race===selectedRace;return{id:race,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{selected:selected},Object(__WEBPACK_IMPORTED_MODULE_6__utilities_toLowerCase__["b" /* capitalize */])(race),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',who)),value:val,hoverable:isSomeBullshit?false:true,trueValue:isSomeBullshit||false,noTransition:isSomeBullshit,fill:race===selectedRace?'var(--peach)':colorScale?colorScale(ind[race][year]):''};});var vertOffsets=[-150,-50];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{offset:this.props.hideForSources?'0, '+vertOffsets[0]+'px':!this.props.expand?'0, '+vertOffsets[1]+'px':'0, '+vertOffsets[0]+'px',clickable:!this.props.expand,onClick:!this.props.expand?this.props.onClick:function(){},onMouseEnter:this.props.expand?function(){}:function(){return _this2.hover(true);},onMouseLeave:this.props.expand?function(){}:function(){return _this2.hover(false);},hide:this.props.hideForSources},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HorizontalBarGraph__["a" /* default */],{expandable:true,modes:{expanded:{width:screen==='mobile'?store.mobileDeviceWidth-50:screen==='optimal'?610:480,height:screen==='mobile'?170:150},collapsed:{width:screen==='mobile'?store.mobileDeviceWidth-50:screen==='optimal'?610:480,height:50},sources:{width:100,height:150}},currentMode:this.props.hideForSources?'sources':!this.props.expand?'collapsed':'expanded',fullHeight:this.props.expand//kinda redundant for the above but in place for vestige styledcomponents changes
,hideGraph:!this.props.expand||this.props.hideForSources,onHoverRow:function onHoverRow(val){setHover('race',val);},hovered:hoveredRace,selectable:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{hovered:!this.props.expand?this.hovered:false,offset:!this.props.expand?true:0,buttonMode:!this.props.expand},screen!=='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Indicator breakdown'),' by race'),screen==='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'Race breakdown')),bars:this.props.expand?indicatorPerformanceByRace:[],labelWidth:screen==='mobile'?125:150,selectBar:function selectBar(val){return _this2.props.store.completeWorkflow('race',_this2.props.store.race===val?'':val);}}));}}]);return IndicatorByRaces;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'hovered',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'hover',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(tf){return _this3.hovered=tf;};}})),_class2))||_class;var Header=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_7__utilities_media__["a" /* default */].mobile,function(props){return props.offset?'0, 25px':'0,0';},function(props){return props.hide?.2:.35;},function(props){return props.hovered?'var(--strokepeach)':'var(--normtext)';});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExpandBox__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flip_move__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6;var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    width: 100%;\n    border: 1px solid var(--bordergrey);\n'],['\n    position: relative;\n    width: 100%;\n    border: 1px solid var(--bordergrey);\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    margin: 0 20px;\n    display: inline-flex;\n    padding: 0 15px;\n    background: var(--offwhitefg);\n    z-index: 3;\n    transform: translateY(-50%);\n'],['\n    position: absolute;\n    margin: 0 20px;\n    display: inline-flex;\n    padding: 0 15px;\n    background: var(--offwhitefg);\n    z-index: 3;\n    transform: translateY(-50%);\n']),_templateObject3=_taggedTemplateLiteral(['\n    margin-left: 1px;\n'],['\n    margin-left: 1px;\n']),_templateObject4=_taggedTemplateLiteral(['\n    /*position: absolute;*/\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    letter-spacing: 0.5px;\n    font-size: 13px;\n    @media ','{\n        font-size: 12px;\n    }\n    transition: border-color .25s, background-color .25s, box-shadow .25s, opacity .45s;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    @media ','{\n        width: 610px;\n    }\n    @media ','{\n        width: 480px;\n    }\n    opacity: ',';\n    pointer-events: ',';\n'],['\n    /*position: absolute;*/\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    letter-spacing: 0.5px;\n    font-size: 13px;\n    @media ','{\n        font-size: 12px;\n    }\n    transition: border-color .25s, background-color .25s, box-shadow .25s, opacity .45s;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    @media ','{\n        width: 610px;\n    }\n    @media ','{\n        width: 480px;\n    }\n    opacity: ',';\n    pointer-events: ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    margin: 0 20px;\n    display: inline-flex;\n    padding: 0 15px;\n    background: var(--offwhitefg);\n    z-index: 3;\n'],['\n    position: absolute;\n    margin: 0 20px;\n    display: inline-flex;\n    padding: 0 15px;\n    background: var(--offwhitefg);\n    z-index: 3;\n']),_templateObject6=_taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    padding: 0 36px 0px 25px;\n    margin: ',';\n    @media ','{\n        padding: 0 30px 0px 20px;\n    }\n    transition: transform .25s;\n    // transform: ',';\n'],['\n    width: 100%;\n    height: 100%;\n    padding: 0 36px 0px 25px;\n    margin: ',';\n    @media ','{\n        padding: 0 30px 0px 20px;\n    }\n    transition: transform .25s;\n    // transform: ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n    position: relative;\n    display: inline-flex;\n    width: ','px;\n    align-items: center;\n    flex-shrink: 0;\n    justify-content: ',';\n    padding-right: 20px;\n    @media ','{\n        padding-right: 6px;\n    }\n    // border: 1px solid black;\n    color: ',';\n    white-space: nowrap;\n\n\n'],['\n    position: relative;\n    display: inline-flex;\n    width: ','px;\n    align-items: center;\n    flex-shrink: 0;\n    justify-content: ',';\n    padding-right: 20px;\n    @media ','{\n        padding-right: 6px;\n    }\n    // border: 1px solid black;\n    color: ',';\n    white-space: nowrap;\n\n\n']),_templateObject8=_taggedTemplateLiteral(['\n    color: ',';\n\n'],['\n    color: ',';\n\n']),_templateObject9=_taggedTemplateLiteral(['\n    color: var(--fainttext);\n'],['\n    color: var(--fainttext);\n']),_templateObject10=_taggedTemplateLiteral(['\n    margin-right: 5px;\n    color: var(--fainttext);\n'],['\n    margin-right: 5px;\n    color: var(--fainttext);\n']),_templateObject11=_taggedTemplateLiteral(['\n    cursor: ',';\n    position: relative;\n    width: calc(100% - 20px);\n    display: flex;\n    align-items: center;\n    margin-top: 3px;\n    @media ','{\n        margin-top: 5.5px;\n        height: 18px;\n    }\n'],['\n    cursor: ',';\n    position: relative;\n    width: calc(100% - 20px);\n    display: flex;\n    align-items: center;\n    margin-top: 3px;\n    @media ','{\n        margin-top: 5.5px;\n        height: 18px;\n    }\n']),_templateObject12=_taggedTemplateLiteral(['\n    position: absolute;\n    bottom: 20px;\n    left: ','px;\n\n    width: 1px;\n    background-color: var(--fainttext);\n    height: calc(100% - 52px);\n    @media ','{\n        left: ','px;\n        height: calc(100% - 56px);\n        bottom: 25px;\n    }\n    box-shadow: -1.5px 0 0 0 var(--offwhitefg);\n    /*border-left: 1.5px solid var(--offwhitefg);*/\n    /*border-right: 1px solid var(--normtext);*/\n    z-index: 2;\n    // margin-left: calc(','% - 200px);\n    transition: transform .5s, border-color .15s;\n    transform: translateX(','px);\n    // opacity: ',';\n\n    &::before{  \n        content: \'\';\n        position: absolute;\n        width: 15px;\n        height: 1px;\n        border-bottom: 1px var(--fainttext) solid;\n        top: -1px;\n        transform-origin: 0%;\n        transform: scaleX(',');\n        /*transition: transform .5s;*/\n        /*left: -10px;*/\n    }\n    &::after{\n        content: \'\';\n        position: absolute;\n        white-space: nowrap;\n        /*width: 0;*/\n        border-top: 1px var(--fainttext) solid;\n        width: 25px;\n        height: 1px;\n        transform: translateX(-50%);\n        bottom: -1px;\n        text-align: center;\n    }\n'],['\n    position: absolute;\n    bottom: 20px;\n    left: ','px;\n\n    width: 1px;\n    background-color: var(--fainttext);\n    height: calc(100% - 52px);\n    @media ','{\n        left: ','px;\n        height: calc(100% - 56px);\n        bottom: 25px;\n    }\n    box-shadow: -1.5px 0 0 0 var(--offwhitefg);\n    /*border-left: 1.5px solid var(--offwhitefg);*/\n    /*border-right: 1px solid var(--normtext);*/\n    z-index: 2;\n    // margin-left: calc(','% - 200px);\n    transition: transform .5s, border-color .15s;\n    transform: translateX(','px);\n    // opacity: ',';\n\n    &::before{  \n        content: \'\';\n        position: absolute;\n        width: 15px;\n        height: 1px;\n        border-bottom: 1px var(--fainttext) solid;\n        top: -1px;\n        transform-origin: 0%;\n        transform: scaleX(',');\n        /*transition: transform .5s;*/\n        /*left: -10px;*/\n    }\n    &::after{\n        content: \'\';\n        position: absolute;\n        white-space: nowrap;\n        /*width: 0;*/\n        border-top: 1px var(--fainttext) solid;\n        width: 25px;\n        height: 1px;\n        transform: translateX(-50%);\n        bottom: -1px;\n        text-align: center;\n    }\n']),_templateObject13=_taggedTemplateLiteral(['\n    white-space: nowrap;\n    position: absolute;\n    display: inline-flex;\n    justify-content: ',';\n    top: -10px;\n    @media ','{\n        top: -6px;\n    }\n    transform: translateX(','%);\n    /*transition: transform .5s;*/\n    padding: 0 23px;\n    color: var(--fainttext);\n\n'],['\n    white-space: nowrap;\n    position: absolute;\n    display: inline-flex;\n    justify-content: ',';\n    top: -10px;\n    @media ','{\n        top: -6px;\n    }\n    transform: translateX(','%);\n    /*transition: transform .5s;*/\n    padding: 0 23px;\n    color: var(--fainttext);\n\n']),_templateObject14=_taggedTemplateLiteral(['   \n    margin-left: 5px;\n    color: var(--normtext);\n'],['   \n    margin-left: 5px;\n    color: var(--normtext);\n']),_templateObject15=_taggedTemplateLiteral(['\n    position: relative;\n    width: 100%;\n    height: ',';\n    transform-origin: 0% 0%;\n    transition: transform ','s, background-color ','s;\n    transform: scaleX(',');\n\n    background: ',';\n    /*border-right-color: transparent;*/\n    border: 1.5px solid ',';\n    border-left-width: ','px;\n    border-right-width: ','px;\n\n'],['\n    position: relative;\n    width: 100%;\n    height: ',';\n    transform-origin: 0% 0%;\n    transition: transform ','s, background-color ','s;\n    transform: scaleX(',');\n\n    background: ',';\n    /*border-right-color: transparent;*/\n    border: 1.5px solid ',';\n    border-left-width: ','px;\n    border-right-width: ','px;\n\n']),_templateObject16=_taggedTemplateLiteral(['\n    color: ',';\n    letter-spacing: 0.5px;\n    position: absolute;\n    // right: 0;\n    ','\n    transition: transform ','s;\n    transform: translateX(','px);\n    margin-left: ','px;\n    @media ','{\n        margin-left: ','px;\n    }\n'],['\n    color: ',';\n    letter-spacing: 0.5px;\n    position: absolute;\n    // right: 0;\n    ','\n    transition: transform ','s;\n    transform: translateX(','px);\n    margin-left: ','px;\n    @media ','{\n        margin-left: ','px;\n    }\n']),_templateObject17=_taggedTemplateLiteral(['left: 0;'],['left: 0;']),_templateObject18=_taggedTemplateLiteral(['right: 0;'],['right: 0;']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject);var WrappedGraphComponent=function WrappedGraphComponent(props){var noFade=props.noFade,header=props.header,footer=props.footer,modes=props.modes,duration=props.duration,delay=props.delay,currentMode=props.currentMode,fullHeight=props.fullHeight,withScroll=props.withScroll,hideScroll=props.hideScroll,borderColor=props.borderColor,restOfProps=_objectWithoutProperties(props,['noFade','header','footer','modes','duration','delay','currentMode','fullHeight','withScroll','hideScroll','borderColor']);return props.expandable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ExpandBox__["a" /* default */],{currentMode:currentMode,modes:modes,duration:duration,delay:delay,borderColor:borderColor,noFade:noFade,header:header,footer:footer,expand:fullHeight,withScroll:withScroll,hideScroll:hideScroll,collapseHeight:props.collapseHeight,expandHeight:props.expandHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HorizontalBarGraph,Object.assign({},restOfProps,{noFade:noFade}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,props.header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HorizontalBarGraph,restOfProps));};var Header=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2);var HorizontalBarGraph=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(HorizontalBarGraph,_React$Component);function HorizontalBarGraph(props){_classCallCheck(this,HorizontalBarGraph);var _this=_possibleConstructorReturn(this,(HorizontalBarGraph.__proto__||Object.getPrototypeOf(HorizontalBarGraph)).call(this,props));_initDefineProp(_this,'width',_descriptor,_this);_initDefineProp(_this,'contentHeight',_descriptor2,_this);_initDefineProp(_this,'expanded',_descriptor3,_this);_initDefineProp(_this,'handleHoverRow',_descriptor4,_this);_initDefineProp(_this,'expandGraph',_descriptor5,_this);_initDefineProp(_this,'setGraphDimensions',_descriptor6,_this);_this.graph=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}// @observable hoveredRow = null
_createClass(HorizontalBarGraph,[{key:'componentDidMount',value:function componentDidMount(){this.setGraphDimensions();window.addEventListener('resize',this.setGraphDimensions);}},{key:'render',value:function render(){var _this2=this;var selectBar=this.props.selectBar;// console.log(selectBar)
var screen=Object(__WEBPACK_IMPORTED_MODULE_5__utilities_media__["b" /* getMedia */])();var labelLineOffset=screen==='mobile'?65:75;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GraphTable,{ref:this.graph,onClick:this.props.expandable?this.expandGraph:function(){},expanded:this.expanded,hideGraph:this.props.hideGraph},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{beefyPadding:this.props.beefyPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_flip_move__["a" /* default */],{duration:175// staggerDurationBy = {5}
// typeName = {null}
,enterAnimation:'fade',leaveAnimation:'fade'// disableAllAnimations = {this.props.disableAnim || this.expanded}
},this.props.bars.map(function(item,i,bars){var invalidValue=item.value!==0&&(!item.value||item.value==='*');var condensed=item.condensed;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{key:i,condensed:condensed,onClick:selectBar?function(){selectBar(item.id);}:function(){},onMouseEnter:function onMouseEnter(){_this2.handleHoverRow(item.id);},onMouseLeave:function onMouseLeave(){_this2.handleHoverRow(null);},hovered:item.id===_this2.props.hovered,hoverable:item.hoverable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{selected:item.id===_this2.props.selected,labelWidth:_this2.props.labelWidth,invalid:invalidValue,hovered:item.id===_this2.props.hovered,onMouseEnter:item.hoverable?function(){_this2.handleHoverRow(item.id);}:function(){},onMouseLeave:item.hoverable?function(){_this2.handleHoverRow(null);}:function(){},hasLeftLabel:item.leftLabel},item.leftLabel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeftLabel,{hovered:item.id===_this2.props.hovered,selected:item.id===_this2.props.selected},!condensed&&item.leftLabel),!condensed&&item.label&&typeof item.label==='string'&&item.label,!condensed&&item.label&&typeof item.label!=='string'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item.label,Object.assign({hovered:item.id===_this2.props.hovered},item.label.props))),!invalidValue&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bar,{condensed:condensed,hovered:item.id===_this2.props.hovered,selected:item.id===_this2.props.selected,percentage:item.value,noTransition:item.noTransition,height:100/bars.length,fill:item.fill||'',onMouseEnter:function onMouseEnter(){_this2.handleHoverRow(item.id);},onMouseLeave:function onMouseLeave(){_this2.handleHoverRow(null);}}),!condensed&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value,{percentage:item.value,muted:i!==0,hovered:item.id===_this2.props.hovered,selected:item.id===_this2.props.selected,alignValue:_this2.props.alignValue,offset:_this2.props.labelWidth+(_this2.width-labelLineOffset-_this2.props.labelWidth)*(item.value/100),noTransition:item.noTransition},item.trueValue&&item.trueValue,!item.trueValue&&item.value.toFixed(2).replace(/[.,]00$/,""),!item.trueValue&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pct,null,'%'))),invalidValue&&!item.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Invalid,null,' No data '),invalidValue&&item.value==='*'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Invalid,null,!_this2.props.noFade&&'Data too small or unstable',_this2.props.noFade&&'Small/unstable'));})),this.props.average&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AverageLine,{labelWidth:this.props.labelWidth// offset = {0}
,side:this.props.average>65?'left':'right',muted:this.props.hovered,offset:this.props.average/100*(this.width-this.props.labelWidth-labelLineOffset)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AverageLabel,{side:this.props.average>65?'left':'right'},'CA Avg'))));}}]);return HorizontalBarGraph;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'width',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 400;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'contentHeight',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 300;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'expanded',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'handleHoverRow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(row){// if(this.props.selectable) this.hoveredRow = row
var screen=Object(__WEBPACK_IMPORTED_MODULE_5__utilities_media__["b" /* getMedia */])();if(_this3.props.onHoverRow&&screen!=='mobile')_this3.props.onHoverRow(row);};}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'expandGraph',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(){_this4.expanded=!_this4.expanded;if(_this4.props.onClickGraph)_this4.props.onClickGraph();};}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'setGraphDimensions',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){if(!_this5.graph)return;if(!_this5.graph.current)return;_this5.width=Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(_this5.graph.current).offsetWidth;// this.contentHeight = findDOMNode(this.graph.current).offsetHeight 
// console.log(this.contentHeight)
};}})),_class2))||_class;var Pct=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject3);var GraphTable=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].mobile,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].compact,function(props){return props.hideGraph?0:1;},function(props){return props.hideGraph?'none':'auto';});var CropBox=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject5);var Content=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject6,function(props){return props.beefyPadding?'42px 0 32px 0':'25px 0 18px 0';},__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].mobile,function(props){return props.offset?'translateY(-20px)':'';});var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject7,function(props){return props.labelWidth;},function(props){return props.hasLeftLabel?'space-between':'flex-end';},__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].mobile,function(props){return props.selected||props.hovered?"var(--strokepeach)":props.invalid?"var(--fainttext)":"var(--normtext)";});var LeftLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject8,function(props){return props.selected||props.hovered?"var(--strokepeach)":"var(--fainttext)";});var Invalid=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject9);var Rank=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject10);var Row=function(_React$Component2){_inherits(Row,_React$Component2);function Row(){_classCallCheck(this,Row);return _possibleConstructorReturn(this,(Row.__proto__||Object.getPrototypeOf(Row)).apply(this,arguments));}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,children=_props.children,restOfProps=_objectWithoutProperties(_props,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowComponent,restOfProps,' ',children,' ');}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var RowComponent=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject11,function(props){return props.hoverable?'pointer':'auto';},__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].mobile);var AverageLine=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject12,function(props){return props.labelWidth+20;},__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].mobile,function(props){return props.labelWidth+15;},function(props){return props.percentage;},function(props){return props.offset;},function(props){return props.muted?0.5:1;},function(props){return props.side==='left'?-1:1;});var AverageLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject13,function(props){return props.side==='left'?'flex-end':'flex-start';},__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].mobile,function(props){return props.side==='left'?-100:0;});var AverageValue=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject14);var Bar=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject15,function(props){return props.condensed?'6px':'13px';},function(p){return p.noTransition?0:.25;},function(props){return props.selected?0:.25;},function(props){return props.percentage/100;},function(props){return props.selected?'var(--peach)':props.condensed?'var(--inactivegrey)':props.fill?props.fill:'green';},function(props){return props.hovered?'var(--peach)':'transparent';},function(props){return(150/props.percentage).toFixed(3);},function(props){return(150/props.percentage).toFixed(3);});var Value=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject16,function(props){return props.hovered||props.selected?'var(--strokepeach)':props.muted?'var(--fainttext)':'var(--normtext)';},function(props){return props.alignValue==='outside'?Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject17):Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject18);},function(p){return p.noTransition?0:.25;},function(props){return props.alignValue==='outside'?props.offset:-props.offset;},function(props){return props.percentage===0?0:5;},__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].mobile,function(props){return props.percentage===0?0:3;});HorizontalBarGraph.defaultProps={header:'Needs header',alignValue:'outside'//outside or inside
};/* harmony default export */ __webpack_exports__["a"] = (WrappedGraphComponent);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndicatorByCounties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_commaNumber__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__researchgate_react_intersection_observer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intersection_observer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_sigFig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ordinal__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ordinal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ordinal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HorizontalBarGraph__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__generic_Icon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ExpandBox__ = __webpack_require__(16);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_class4;var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    display: flex; align-items: center; justify-content: center;\n    /*right: -45px;*/\n    left: calc(100vw - 85px);\n    height: 35px;\n    width: 35px;\n    background: var(--offwhitefg);\n    opacity: ',';\n    transition: transform .2s, opacity .125s;\n'],['\n    position: absolute;\n    display: flex; align-items: center; justify-content: center;\n    /*right: -45px;*/\n    left: calc(100vw - 85px);\n    height: 35px;\n    width: 35px;\n    background: var(--offwhitefg);\n    opacity: ',';\n    transition: transform .2s, opacity .125s;\n']),_templateObject2=_taggedTemplateLiteral(['\n    width: 18px; height: 18px;\n'],['\n    width: 18px; height: 18px;\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: fixed;\n    top: 90px; right: 18px;\n    transform: scale(',');\n\n    z-index: 1000;\n'],['\n    position: fixed;\n    top: 90px; right: 18px;\n    transform: scale(',');\n\n    z-index: 1000;\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: relative;\n    z-index: 10;\n    transform: translateY(',');\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    //this needs z-index adjustment to sit atop demo when it\'s in btn mode\n'],['\n    position: relative;\n    z-index: 10;\n    transform: translateY(',');\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    //this needs z-index adjustment to sit atop demo when it\'s in btn mode\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    left: 158px;\n    z-index: 10;\n    opacity: ',';\n    pointer-events: ',';\n    transition: opacity .2s;\n    transition-delay: ',';\n'],['\n    position: absolute;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    left: 158px;\n    z-index: 10;\n    opacity: ',';\n    pointer-events: ',';\n    transition: opacity .2s;\n    transition-delay: ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    width: 30px; height: 30px;\n    margin-left: 10px;\n'],['\n    width: 30px; height: 30px;\n    margin-left: 10px;\n']),_templateObject7=_taggedTemplateLiteral(['\n    margin-top: 1px;\n    &:hover{\n        .sprite-chevsprite{\n            fill: var(--strokepeach);\n        }\n    }\n'],['\n    margin-top: 1px;\n    &:hover{\n        .sprite-chevsprite{\n            fill: var(--strokepeach);\n        }\n    }\n']),_templateObject8=_taggedTemplateLiteral(['\n    display: inline-flex; align-items: center; \n    height: 3px;\n    margin: 0 20px;\n    @media ','{\n        margin: 0 15px;\n    }\n    /*background: var(--offwhitefg);*/\n'],['\n    display: inline-flex; align-items: center; \n    height: 3px;\n    margin: 0 20px;\n    @media ','{\n        margin: 0 15px;\n    }\n    /*background: var(--offwhitefg);*/\n']),_templateObject9=_taggedTemplateLiteral(['\n&::before{\n    content: \'\';\n    position: absolute;\n    width: 369px;\n    height: 48px; margin-top: 1px;\n    left: -19px;\n    pointer-events: ',';\n    background: white;\n    opacity: ',';\n    transition: opacity .25s ',';\n}\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateY(',');\n    cursor: ',';\n    fill: var(--normtext);\n    ','\n'],['\n&::before{\n    content: \'\';\n    position: absolute;\n    width: 369px;\n    height: 48px; margin-top: 1px;\n    left: -19px;\n    pointer-events: ',';\n    background: white;\n    opacity: ',';\n    transition: opacity .25s ',';\n}\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translateY(',');\n    cursor: ',';\n    fill: var(--normtext);\n    ','\n']),_templateObject10=_taggedTemplateLiteral(['\n    width: 18px; height: 18px;\n    opacity: ',';\n    transition: opacity .35s, transform .35s;\n    transform: translateX(','px);\n    /*border: 1px solid red;*/\n    position: absolute;\n    z-index: 5;\n'],['\n    width: 18px; height: 18px;\n    opacity: ',';\n    transition: opacity .35s, transform .35s;\n    transform: translateX(','px);\n    /*border: 1px solid red;*/\n    position: absolute;\n    z-index: 5;\n']),_templateObject11=_taggedTemplateLiteral(['\n    width: ',';\n    @media ','{\n         width: ',';\n    }\n    position: relative;\n    height: 10px;\n    padding: 0 15px;\n    box-sizing: content-box;\n    display: inline-flex;\n    align-items: center;\n    background: var(--offwhitefg);\n    transition: transform .35s;\n    transform: translateX(',');\n'],['\n    width: ',';\n    @media ','{\n         width: ',';\n    }\n    position: relative;\n    height: 10px;\n    padding: 0 15px;\n    box-sizing: content-box;\n    display: inline-flex;\n    align-items: center;\n    background: var(--offwhitefg);\n    transition: transform .35s;\n    transform: translateX(',');\n']),_templateObject12=_taggedTemplateLiteral(['\n    position: absolute;\n    left: 15px;\n    opacity: ',';\n    transition: opacity .15s;\n    transition-delay: ',';\n    white-space: nowrap;\n    @media ','{\n        font-size: ',';\n        letter-spacing: ','px;\n    }\n'],['\n    position: absolute;\n    left: 15px;\n    opacity: ',';\n    transition: opacity .15s;\n    transition-delay: ',';\n    white-space: nowrap;\n    @media ','{\n        font-size: ',';\n        letter-spacing: ','px;\n    }\n']),_templateObject13=_taggedTemplateLiteral(['\n    /*margin-left: 15px;*/\n    position: relative;\n    &::before{\n        position: absolute;\n        content: \'\';\n        width: 15px;\n        right: -15px;\n        top: 0; bottom: 0; margin: auto;\n        height: 2px;\n        background-color: var(--offwhitefg);\n    }\n    transform: translateX(','px);\n    @media ','{\n        transform: translateX(','px);\n    }\n    transition: opacity .35s, transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: ',';\n    transition-delay: ',';\n    pointer-events: ',';\n    z-index: 15;\n'],['\n    /*margin-left: 15px;*/\n    position: relative;\n    &::before{\n        position: absolute;\n        content: \'\';\n        width: 15px;\n        right: -15px;\n        top: 0; bottom: 0; margin: auto;\n        height: 2px;\n        background-color: var(--offwhitefg);\n    }\n    transform: translateX(','px);\n    @media ','{\n        transform: translateX(','px);\n    }\n    transition: opacity .35s, transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    opacity: ',';\n    transition-delay: ',';\n    pointer-events: ',';\n    z-index: 15;\n']),_templateObject14=_taggedTemplateLiteral(['\n    /*bottom: -1px; right: 182px;*/\n    position: absolute;\n    width: 192px;\n    @media ','{\n        width: 130px;\n    }\n    right: 0px;\n    padding: 0 15px;\n    opacity: ',';\n    pointer-events: ',';\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1), opacity .35s;\n    transform: translateX(',');\n    &::before{\n        position: absolute;\n        content: \'\';\n        width: 100%;\n        left: 0;\n        height: 3px;\n        background: var(--offwhitefg);\n        transform: scaleX(',');\n        transform-origin: 0 0;\n        transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n'],['\n    /*bottom: -1px; right: 182px;*/\n    position: absolute;\n    width: 192px;\n    @media ','{\n        width: 130px;\n    }\n    right: 0px;\n    padding: 0 15px;\n    opacity: ',';\n    pointer-events: ',';\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1), opacity .35s;\n    transform: translateX(',');\n    &::before{\n        position: absolute;\n        content: \'\';\n        width: 100%;\n        left: 0;\n        height: 3px;\n        background: var(--offwhitefg);\n        transform: scaleX(',');\n        transform-origin: 0 0;\n        transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n']),_templateObject15=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    padding: 10px;\n    opacity: ',';\n'],['\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    padding: 10px;\n    opacity: ',';\n']),_templateObject16=_taggedTemplateLiteral(['\n    color: var(--peach);\n    margin-right: 4px;\n'],['\n    color: var(--peach);\n    margin-right: 4px;\n']),_templateObject17=_taggedTemplateLiteral(['\n    color: var(--strokepeach);\n'],['\n    color: var(--strokepeach);\n']),_templateObject18=_taggedTemplateLiteral(['\n    color: ',';\n'],['\n    color: ',';\n']),_templateObject19=_taggedTemplateLiteral(['\n    margin-right: 5px;\n'],['\n    margin-right: 5px;\n']),_templateObject20=_taggedTemplateLiteral(['\n    margin-left: 5px;\n'],['\n    margin-left: 5px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import semanticTitles from '../assets/semanticTitles'
function indexOfClosest(nums,target){var closest=1000;var index=0;nums.forEach(function(num,i){var dist=Math.abs(target-num);if(dist<closest){index=i;closest=dist;}});return index;}var IndicatorByCounties=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(IndicatorByCounties,_React$Component);function IndicatorByCounties(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IndicatorByCounties);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IndicatorByCounties.__proto__||Object.getPrototypeOf(IndicatorByCounties)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'distribute',_descriptor,_this),_initDefineProp(_this,'fullHeight',_descriptor2,_this),_initDefineProp(_this,'performance',_descriptor3,_this),_initDefineProp(_this,'distribution',_descriptor4,_this),_initDefineProp(_this,'condensed',_descriptor5,_this),_initDefineProp(_this,'sortOverviewBy',_descriptor6,_this),_initDefineProp(_this,'setOverviewSort',_descriptor7,_this),_initDefineProp(_this,'toggleFixedX',_descriptor8,_this),_initDefineProp(_this,'headerVisible',_descriptor9,_this),_initDefineProp(_this,'footerVisible',_descriptor10,_this),_initDefineProp(_this,'onHeaderFooterIntersect',_descriptor11,_this),_initDefineProp(_this,'calculatePerformance',_descriptor12,_this),_initDefineProp(_this,'toggleDistribute',_descriptor13,_this),_initDefineProp(_this,'generateDistribution',_descriptor14,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IndicatorByCounties,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;// this.calculatePerformance()
// this.generateDistribution()
var wtf=Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* autorun */])(function(){var _props$store=_this2.props.store,indicator=_props$store.indicator,race=_props$store.race,county=_props$store.county,year=_props$store.year;// console.log(indicator, race, county, year)
if(!indicator)return;_this2.calculatePerformance();_this2.generateDistribution();});// this.averageTweeners()
}},{key:'render',value:function render(){var _this3=this;var store=this.props.store;var county=store.county,race=store.race,year=store.year,indicator=store.indicator,completeWorkflow=store.completeWorkflow,colorScale=store.colorScale,screen=store.screen,setHover=store.setHover,hoveredCounty=store.hoveredCounty;var performance=this.performance;var ind=__WEBPACK_IMPORTED_MODULE_10__data_indicators__["a" /* default */][indicator];var unstable=ind.categories.includes('unstable');var distribute=!this.props.expand;var maxNumRows=!race?performance.length:0;var width=store.mobileDeviceWidth-50;if(this.sortOverviewBy==='pop'){performance=performance.sort(function(a,b){if(Number(a.population)>Number(b.population))return-1;else if(Number(b.population)>Number(a.population))return 1;else return 0;}).slice(0,distribute?this.props.entries:performance.length).map(function(e){console.log(e);return _extends({},e,{leftLabel:!distribute&&!unstable?e.rank+'.':'',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelComponent,{selected:e.id===county,label:e.label,right:Object(__WEBPACK_IMPORTED_MODULE_13__utilities_sigFig__["c" /* truncateNum */])(e.population)})});});}else performance=performance.map(function(e,i,arr){var distrib=_this3.distribution;if(!distribute){return _extends({},e,{leftLabel:!unstable?e.rank+'.':''});}else if(distrib.includes(i)){return _extends({},e,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelComponent,{left:unstable?'':i===0?'1.':i===arr.length-1?arr.length+'.':e.id===county?e.rank+'.':'',selected:e.id===county,label:e.label})});}else return null;}).filter(function(e,i){if(!distribute)return true;if(e===null)return false;else return true;});var sem=ind.semantics;var expandedHeader=(sem.descriptor||'')+' '+(race?Object(__WEBPACK_IMPORTED_MODULE_12__utilities_toLowerCase__["b" /* capitalize */])(race):'')+' '+sem.who+' who '+sem.what;expandedHeader=expandedHeader.slice(0,1).toUpperCase()+expandedHeader.substr(1);var highestValue=0;var withRace=!race?'':Object.keys(__WEBPACK_IMPORTED_MODULE_11__data_demographicsAndPopulation___default.a).filter(function(cty){return cty!=='california';}).map(function(cty){var pop=parseInt((__WEBPACK_IMPORTED_MODULE_11__data_demographicsAndPopulation___default.a[cty][race]/100*__WEBPACK_IMPORTED_MODULE_11__data_demographicsAndPopulation___default.a[cty].population).toFixed(0));if(pop>highestValue)highestValue=pop;return{id:cty,label:__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[cty],value:pop};}).sort(function(a,b){return a.value>b.value?-1:a.value<b.value?1:0;});if(race){maxNumRows=withRace.length;withRace=withRace.slice(0,distribute?this.props.entries:withRace.length).map(function(cty){var val=__WEBPACK_IMPORTED_MODULE_10__data_indicators__["a" /* default */][indicator].counties[cty.id][race][year];var selected=cty.id===county;return _extends({},cty,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelComponent,{selected:selected,label:cty.label}),value:val,fill:selected?'var(--peach)':colorScale?colorScale(val):'',trueValue:val+'%'});});}if(race&&county&&distribute){if(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(withRace,function(o){return o.id===county;})){console.log('withRace bars already includes selected county, no need to replace last');}else{withRace[withRace.length-1]={label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelComponent,{selected:true,label:__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[county]}),value:__WEBPACK_IMPORTED_MODULE_10__data_indicators__["a" /* default */][indicator].counties[county][race][year],fill:'var(--peach)'};}}// let expandDims, collapseDims, noRaceExpandDims, noRaceCollapseDims
var modes=void 0;if(screen==='optimal'){modes={optimalExpanded:{width:610,height:515},optimalCollapsed:{width:610,height:390},optimalNoRaceExpanded:{width:610,height:575},optimalNoRaceCollapsed:{width:610,height:575},optimalsources:{width:370,height:50}};}else if(screen==='compact'){modes={compactExpanded:{width:480,height:390},compactCollapsed:{width:480,height:280},compactNoRaceExpanded:{width:480,height:450},compactNoRaceCollapsed:{width:480,height:450},compactsources:{width:370,height:50}};}else if(screen==='mobile'){modes={mobileExpanded:{width:width,height:100+maxNumRows*23},mobileCollapsed:{width:width,height:285},mobileNoRaceExpanded:{width:width,height:100+maxNumRows*23},mobileNoRaceCollapsed:{width:width,height:360},mobilesources:{width:width,height:50}};}// console.log('indbycounties max:')
// console.log(maxNumRows)
// const modes = {
//     collapsed: collapseDims,
//     expanded: expandDims,
//     noraceexpanded: noRaceExpandDims,
//     noracecollapsed: noRaceCollapseDims,
//     sources: {width: 370, height: 50}
// }
// console.log(modes)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{offset:this.props.sources},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__HorizontalBarGraph__["a" /* default */],{expandable:true,withScroll:screen!=='mobile',noFade:screen==='mobile',hideScroll:distribute||this.props.sources,currentMode:this.props.sources?screen+'sources':!this.props.hasRace&&this.props.expand?screen+'NoRaceExpanded':!this.props.hasRace&&!this.props.expand?screen+'NoRaceCollapsed':this.props.expand?screen+'Expanded':screen+'Collapsed',modes:modes,duration:screen==='mobile'?0:this.props.sources?.5:.35,onHoverRow:screen!=='mobile'?function(val){setHover('county',val);}:function(){},hovered:screen==='mobile'?null:hoveredCounty,borderColor:this.props.sources?'var(--fainttext)':'',selected:county,selectable:true,beefyPadding:true,header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderComponent,{screen:screen,sources:this.props.sources,race:race,distribute:distribute,setOverviewSort:this.setOverviewSort,sortOverviewBy:this.sortOverviewBy,setSourcesMode:this.props.store.setSourcesMode,toggleDistribute:this.props.toggleDistribute//mobile intersect stuff
,onIntersect:function onIntersect(tf){return _this3.onHeaderFooterIntersect('header',tf);}}),hideGraph:this.props.sources,labelWidth:screen==='mobile'&&this.sortOverviewBy==='pop'?145:screen==='mobile'?125:this.sortOverviewBy==='pop'?180:150,bars:race?withRace:performance,average:ind.counties.california[race||'totals'][year],selectBar:function selectBar(id){completeWorkflow('county',store.county===id?'':id);},footer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterComponent,{mobile:screen==='mobile',offset:this.props.expand,onClick:this.props.toggleDistribute,hide:this.props.sources,onIntersect:function onIntersect(tf){return _this3.onHeaderFooterIntersect('footer',tf);}}),fullHeight:this.props.expand})));}}]);return IndicatorByCounties;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'distribute',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'fullHeight',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'performance',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'distribution',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'condensed',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'sortOverviewBy',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'pct';}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'setOverviewSort',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(v){console.log('setting sort for overview');_this4.sortOverviewBy=v;};}}),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'toggleFixedX',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(tf){if(_this5.props.store.screen!=='mobile')return;// if(this.distribute) this.props.toggleFixedX(false)
else _this5.props.toggleFixedX(tf);};}}),_descriptor9=_applyDecoratedDescriptor(_class2.prototype,'headerVisible',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class2.prototype,'footerVisible',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class2.prototype,'onHeaderFooterIntersect',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(which,tf){_this6[which+'Visible']=tf;if(_this6.headerVisible||_this6.footerVisible)_this6.toggleFixedX(false);else if(!_this6.headerVisible&&!_this6.footerVisible)_this6.toggleFixedX(true);};}}),_descriptor12=_applyDecoratedDescriptor(_class2.prototype,'calculatePerformance',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){// console.log('calculating performance')
var _props$store2=_this7.props.store,county=_props$store2.county,indicator=_props$store2.indicator,year=_props$store2.year,race=_props$store2.race,colorScale=_props$store2.colorScale;var ind=__WEBPACK_IMPORTED_MODULE_10__data_indicators__["a" /* default */][indicator];//all counties' performance in this indicator 
_this7.performance=Object.keys(ind.counties).filter(function(cty){if(cty==='california')return false;if(race){var value=ind.counties[cty][race?race:'totals'][year];return value!==''&&value!=='*';}else{var rank=ind.counties[cty].ranks[year];return!rank?false:typeof rank!=='number'?false:true;}}).map(function(cty,i){var rank=ind.counties[cty].ranks[year];var value=ind.counties[cty][race?race:'totals'][year];return{//label should be dom element featuring rank ordinal
id:cty,label:__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[cty],// leftLabel: !race? ordinal(rank) : '',
rank:!race?rank:'',value:value,//should i do this at the bargraph level?
fill:colorScale?colorScale(value):'',population:__WEBPACK_IMPORTED_MODULE_11__data_demographicsAndPopulation___default.a[cty].population};}).sort(function(a,b){if(race)return a.value>b.value?-1:a.value<b.value?1:0;else return a.rank>b.rank?1:a.rank<b.rank?-1:0;}).map(function(cty,i){if(!race)return _extends({},cty);else return _extends({},cty,{// leftLabel: ordinal(i+1),
rank:i+1});});};}}),_descriptor13=_applyDecoratedDescriptor(_class2.prototype,'toggleDistribute',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){_this8.distribute=!_this8.distribute;_this8.fullHeight=!_this8.distribute;if(_this8.props.onExpand)_this8.props.onExpand(!_this8.distribute);};}}),_descriptor14=_applyDecoratedDescriptor(_class2.prototype,'generateDistribution',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){// console.log('generating distribution')
var _props$store3=_this9.props.store,county=_props$store3.county,indicator=_props$store3.indicator,year=_props$store3.year,race=_props$store3.race;var ind=__WEBPACK_IMPORTED_MODULE_10__data_indicators__["a" /* default */][indicator];var validCounties=Object.keys(ind.counties).filter(function(cty){if(!race){var rank=ind.counties[cty].ranks[year];return cty!=='california'&&rank&&typeof rank==='number';}else{var value=ind.counties[cty][race][year];return cty!=='california'&&value&&typeof value=='number';}});var entries=_this9.props.entries;var countyCount=validCounties.length;var unit=(countyCount-1)/entries;// const offset = parseInt((Math.abs((countyCount - (unit*(entries-2))) - unit) / 2).toFixed(0))
// console.log(offset)
var offset=0;//-1 for california...
var distribution=[];for(var i=1;i<entries-1;i++){distribution.push(Math.round(i*unit));}distribution.unshift(0);distribution.push(countyCount-1);if(county){var mustInclude=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(_this9.performance,function(o){return o.id===county;});//get actual index of this county within the performance list
//to find the equivalent in race, we need to find its place in the entire pecking order
if(race){var valueSortedCounties=Object.keys(ind.counties).map(function(cty){return{county:cty,value:ind.counties[cty][race][year]};}).filter(function(item){return item.county!=='california'&&item.value!==''&&item.value!=='*';}).sort(function(a,b){return a.value>b.value?-1:a.value<b.value?1:0;});mustInclude=Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["findIndex"])(valueSortedCounties,function(item){return item.county===county;});}var replaceIndex=indexOfClosest(distribution,mustInclude);// console.log('mustInclude is', mustInclude, 'replaceIndex is', replaceIndex)
if(replaceIndex===0&&mustInclude!==0)replaceIndex=1;//don't replace the first-ranked item
if(replaceIndex===entries-1&&mustInclude!==distribution[entries-1])replaceIndex=entries-2;else if(replaceIndex===entries-1&&mustInclude===distribution[entries-1])console.log('last one');_this9.selectedIndex=replaceIndex;distribution[replaceIndex]=mustInclude;'';// console.log('adjusted distribution:', distribution)
// this.condensed = distribution.slice(0)
// this.condensed.splice(replaceIndex,1)
// if(replaceIndex !== 0) this.condensed.splice(0,1)
// if(replaceIndex !== this.condensed.length - 1) this.condensed.splice(this.condensed.length-1,1)
}else if(!county){_this9.condensed=[];}_this9.distribution=distribution;// console.log(indicator, entries)
// console.log(distribution)
};}})),_class2))||_class;var MobileX=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject,function(props){return props.visible?1:0;});var XIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_17__generic_Icon__["b" /* default */])(_templateObject2);var FixedMobileX=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(MobileX)(_templateObject3,function(props){return props.visible?1:0.6;});var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.offset?'-25px':0;});var HeaderComponent=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class4=function(_React$Component2){_inherits(HeaderComponent,_React$Component2);function HeaderComponent(props){_classCallCheck(this,HeaderComponent);var _this10=_possibleConstructorReturn(this,(HeaderComponent.__proto__||Object.getPrototypeOf(HeaderComponent)).call(this,props));if(props.screen==='mobile'){_this10.mobileX=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();}return _this10;}_createClass(HeaderComponent,[{key:'render',value:function render(){var _this11=this;var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__researchgate_react_intersection_observer__["a" /* default */],{onChange:props.screen==='mobile'?function(wat){_this11.props.onIntersect(wat.isIntersecting);}:function(){}// rootMargin = '75px 0% 0% 0%'
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{offset:props.sources,buttonMode:props.sources,onClick:props.sources?function(){props.setSourcesMode(false);}:function(){}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BackArrow,{img:'chevleft',sources:props.sources// color = 'normtext'
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderTitle,{hasRace:props.race,sources:props.sources},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FadeTitle,{show:props.sources&&props.distribute||!props.race&&props.distribute},props.screen!=='mobile'&&'County overview',props.screen==='mobile'&&'By counties'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FadeTitle,{show:props.sources&&!props.distribute||!props.race&&!props.distribute},'All counties'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FadeTitle,{show:!props.sources&&props.race,superLong:true},props.race==='other'&&props.screen!=='mobile'&&'In counties with the most children of other races',props.screen==='mobile'&&props.race==='other'&&'By most children of other races',!props.sources&&props.race&&props.race!=='other'&&props.screen!=='mobile'&&'In counties with the most '+Object(__WEBPACK_IMPORTED_MODULE_12__utilities_toLowerCase__["b" /* capitalize */])(props.race)+' children',props.screen==='mobile'&&!props.sources&&props.race&&props.race!=='other'&&'Counties w/ most '+Object(__WEBPACK_IMPORTED_MODULE_12__utilities_toLowerCase__["b" /* capitalize */])(props.race)+' children')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourceString,{show:props.sources},'/ race breakdown',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Minigraph,{img:'minigraph'})),!props.race&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderToggle,{hide:props.sources,offset:!props.distribute,options:[{label:props.screen==='mobile'?'%':'by %',value:'pct'},{label:props.screen==='mobile'?'pop.':'by Child Population',value:'pop'}],theme:'bw',onClick:props.setOverviewSort,selected:props.sortOverviewBy==='pct'?0:1}),props.screen==='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileX,{ref:this.mobileX,visible:props.sources&&!props.distribute||!props.race&&!props.distribute},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(XIcon,{img:'x',color:'bordergrey',onClick:this.props.toggleDistribute}))));}}]);return HeaderComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class4;//on mode change, get boundingclientrect and use it to build a keyframe transition...?
var SourceString=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject5,function(props){return props.show?1:0;},function(props){return props.show?'auto':'none';},function(props){return props.show?'.15s':'0s';});var Minigraph=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_17__generic_Icon__["b" /* default */])(_templateObject6);var FooterComponent=function(_React$Component3){_inherits(FooterComponent,_React$Component3);function FooterComponent(){_classCallCheck(this,FooterComponent);return _possibleConstructorReturn(this,(FooterComponent.__proto__||Object.getPrototypeOf(FooterComponent)).apply(this,arguments));}_createClass(FooterComponent,[{key:'render',value:function render(){var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__researchgate_react_intersection_observer__["a" /* default */],{onChange:function onChange(wat){if(props.mobile){props.onIntersect(wat.isIntersecting);}}// rootMargin = '0px 0px -100px 0px'
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer,{offset:!props.mobile?props.offset:0,hide:props.hide},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ExpandBox__["a" /* default */],{currentMode:(props.mobile?'mobile':'')+(!props.offset?'expanded':'collapsed'),modes:{expanded:{width:160,height:33},mobileexpanded:{width:100,height:33},collapsed:{width:112,height:33},mobilecollapsed:{width:112,height:33}},borderColor:'var(--fainttext)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ExpandButton,{onClick:props.onClick,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!props.offset&&!props.mobile&&'See all counties',!props.offset&&props.mobile&&'See all',props.offset&&'See less',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__generic_Icon__["a" /* Sprite */],{style:{marginLeft:'9px',width:'18px',height:'18px'},img:'chevsprite',color:'normtext',state:props.offset?'up':'down'})),className:'compact borderless'}))));}}]);return FooterComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var ExpandButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_18__generic__["a" /* Button */])(_templateObject7);var headerfooter=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject8,__WEBPACK_IMPORTED_MODULE_14__utilities_media__["a" /* default */].mobile);var Header=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(headerfooter)(_templateObject9,function(props){return props.buttonMode?'auto':'none';},function(props){return props.buttonMode?1:0;},function(props){return props.buttonMode?'.25s':0;},function(props){return props.offset?'25px':0;},function(props){return props.buttonMode?'pointer':'auto';},function(props){return props.buttonMode?'\n            &:hover{\n                color: var(--strokepeach);\n                fill: var(--strokepeach);\n            }\n        ':'';});var BackArrow=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_17__generic_Icon__["b" /* default */])(_templateObject10,function(props){return props.sources?1:0;},function(props){return props.sources?0:10;});var HeaderTitle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject11,function(props){return props.sources||!props.hasRace?'130px':'315px';},__WEBPACK_IMPORTED_MODULE_14__utilities_media__["a" /* default */].mobile,function(props){return props.sources||!props.hasRace?'90px':'212px';},function(props){return props.sources?'10px':0;});var FadeTitle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject12,function(props){return props.show?1:0;},function(props){return props.show?'.15s':'0s';},__WEBPACK_IMPORTED_MODULE_14__utilities_media__["a" /* default */].mobile,function(props){return props.superLong?'14px':'16px';},function(props){return props.superLong?'0.4':'0.6';});var HeaderToggle=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_18__generic__["d" /* Toggle */])(_templateObject13,function(props){return props.offset?-35:0;},__WEBPACK_IMPORTED_MODULE_14__utilities_media__["a" /* default */].mobile,function(props){return props.offset?0:0;},function(props){return props.hide?0:1;},function(props){return props.hide?'0s':'0.15s';},function(props){return props.hide?'none':'auto';});var Footer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(headerfooter)(_templateObject14,__WEBPACK_IMPORTED_MODULE_14__utilities_media__["a" /* default */].mobile,function(props){return props.hide?0:1;},function(props){return props.hide?'none':'auto';},function(props){return props.hide?'-75%':props.offset?'48px':0;},function(props){return props.offset?0.75:1;});var Prompt=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject15,function(props){return props.visible?1:0;});var SelectedNum=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject16);var SelectedCounty=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject17);var LabelComponent=function LabelComponent(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowLabel,props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FaintLeft,props,props.left),props.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FaintRight,props,props.right));};var RowLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject18,function(props){return props.selected||props.hovered?'var(--strokepeach)':'var(--normtext)';});var Faint=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject18,function(props){return props.selected||props.hovered?'var(--peach)':'var(--fainttext)';});var FaintLeft=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Faint)(_templateObject19);var FaintRight=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Faint)(_templateObject20);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Legend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chroma_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chroma_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chroma_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_media__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3;var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    width: 119px;\n    height: 140px;\n    padding: 20px;\n    @media ','{\n        padding: 15px;\n        /*height: 130px;*/\n    }\n'],['\n    position: absolute;\n    top: 0; left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    width: 119px;\n    height: 140px;\n    padding: 20px;\n    @media ','{\n        padding: 15px;\n        /*height: 130px;*/\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex; align-items: center;\n'],['\n    display: flex; align-items: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 12px; color: var(--fainttext);\n    margin-right: 15px; letter-spacing: 0.5px;\n'],['\n    font-size: 12px; color: var(--fainttext);\n    margin-right: 15px; letter-spacing: 0.5px;\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 16px; \n    height: 24px;\n    background: ',';\n    &:not(:first-of-type){\n        margin-top: 2px;\n    }\n    @media ','{\n        /*width: 12px;*/\n    }\n'],['\n    width: 16px; \n    height: 24px;\n    background: ',';\n    &:not(:first-of-type){\n        margin-top: 2px;\n    }\n    @media ','{\n        /*width: 12px;*/\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    cursor: pointer;\n    /*width: 450px;*/\n    width: 100%;\n'],['\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    cursor: pointer;\n    /*width: 450px;*/\n    width: 100%;\n']),_templateObject6=_taggedTemplateLiteral(['\n    height: 0;\n    border-top: 1px solid var(--bordergrey);\n    width: 5px;\n    margin: 0 3px;\n'],['\n    height: 0;\n    border-top: 1px solid var(--bordergrey);\n    width: 5px;\n    margin: 0 3px;\n']),_templateObject7=_taggedTemplateLiteral(['\n    margin-left: 2px;\n'],['\n    margin-left: 2px;\n']),_templateObject8=_taggedTemplateLiteral(['\n    width: ','%;\n'],['\n    width: ','%;\n']),_templateObject9=_taggedTemplateLiteral(['\n    height: 13px;\n    background: ',';\n    position: absolute;\n    left: -100%;\n    width: 100%;\n    z-index: ',';\n    transition: all ','s;\n    transform: translateX(','%);\n'],['\n    height: 13px;\n    background: ',';\n    position: absolute;\n    left: -100%;\n    width: 100%;\n    z-index: ',';\n    transition: all ','s;\n    transform: translateX(','%);\n']),_templateObject10=_taggedTemplateLiteral(['\n    color: var(--fainttext);\n    letter-spacing: 0.05px;\n    margin-top: 30px;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    left: 0;\n    width: 25%;\n    justify-content: center;\n\n        transform: translateX(',') ',';        \n    \n\n\n    ','\n\n    transition: transform ','s;\n'],['\n    color: var(--fainttext);\n    letter-spacing: 0.05px;\n    margin-top: 30px;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    position: absolute;\n    left: 0;\n    width: 25%;\n    justify-content: center;\n\n        transform: translateX(',') ',';        \n    \n\n\n    ','\n\n    transition: transform ','s;\n']),_templateObject11=_taggedTemplateLiteral(['\n        left: ',';\n        right: ',';\n        display: flex;\n        align-items: center;\n        position: absolute;\n        transition: all .25s;\n        opacity: ',';\n        // transform: translateY(','px);\n\n    '],['\n        left: ',';\n        right: ',';\n        display: flex;\n        align-items: center;\n        position: absolute;\n        transition: all .25s;\n        opacity: ',';\n        // transform: translateY(','px);\n\n    ']),_templateObject12=_taggedTemplateLiteral(['\n        left: 0;\n        position: absolute;\n        width: 100%;\n        transition: all .25s;\n        opacity: ',';\n        // transform: translateY(','px);\n    '],['\n        left: 0;\n        position: absolute;\n        width: 100%;\n        transition: all .25s;\n        opacity: ',';\n        // transform: translateY(','px);\n    ']),_templateObject13=_taggedTemplateLiteral(['\n    width: 100%;\n    height: 40px;\n    @media ','{\n        font-size: 16px;\n        color: var(--normtext);\n    }\n    @media ','{\n        height: 30px;\n        color: var(--fainttext);\n        font-size: 13px;\n    }\n'],['\n    width: 100%;\n    height: 40px;\n    @media ','{\n        font-size: 16px;\n        color: var(--normtext);\n    }\n    @media ','{\n        height: 30px;\n        color: var(--fainttext);\n        font-size: 13px;\n    }\n']),_templateObject14=_taggedTemplateLiteral(['\n    width: 100%;\n    // border: 1px solid blue;\n    height: 40px;\n'],['\n    width: 100%;\n    // border: 1px solid blue;\n    height: 40px;\n']),_templateObject15=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    right: 0;\n'],['\n    position: absolute;\n    top: 0;\n    right: 0;\n']),_templateObject16=_taggedTemplateLiteral(['\n    opacity: ',';\n    transition: opacity .35s;\n'],['\n    opacity: ',';\n    transition: opacity .35s;\n']),_templateObject17=_taggedTemplateLiteral(['\n    opacity: 0;\n    transition: opacity .25s;\n    ','\n\n'],['\n    opacity: 0;\n    transition: opacity .25s;\n    ','\n\n']),_templateObject18=_taggedTemplateLiteral(['\n\n    \n'],['\n\n    \n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var Legend=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(Legend,_React$Component);function Legend(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Legend);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Legend.__proto__||Object.getPrototypeOf(Legend)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'hovered',_descriptor,_this),_initDefineProp(_this,'pcts',_descriptor2,_this),_initDefineProp(_this,'handleHover',_descriptor3,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Legend,[{key:'render',value:function render(){var _this2=this;var store=this.props.store;var indicator=store.indicator,race=store.race,colorScale=store.colorScale,colorOptions=store.colorOptions,year=store.year,screen=store.screen;if(indicator){var ind=__WEBPACK_IMPORTED_MODULE_5__data_indicators__["a" /* default */][indicator];var allNums=Object.keys(ind.counties).map(function(cty){return cty==='california'?'*':ind.counties[cty][race||'totals'][year];}).filter(function(o){var inv=o===''||o==='*';// if(inv) invalids++
return inv?false:true;});var breaks=__WEBPACK_IMPORTED_MODULE_4_chroma_js___default.a.limits(allNums,colorOptions.breakAlgorithm,colorOptions.classes);var mode=this.hovered?'true':'';var nums=breaks.map(function(e,i,a){var count=allNums.filter(function(num){if(i<a.length-2)return num>=breaks[i]&&num<breaks[i+1];else if(i<a.length-1)return num>=breaks[i]&&num<=breaks[i+1];}).length;return count;});var pcts=breaks.map(function(e,i,a){return nums[i]/allNums.length;});return screen!=='mobile'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Lgd,{onMouseEnter:function onMouseEnter(){return _this2.handleHover(true);},onMouseLeave:function onMouseLeave(){return _this2.handleHover(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Labels,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NumCountiesLabel,{show:this.hovered},'# of counties in each range'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorGuideLabel,{hide:this.hovered},'Color guide')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Swatches,null,breaks.map(function(ele,i,arr){var numCountiesInClass=nums[i];var pctCountiesInClass=pcts[i];var prevPctsOffset=i>0?pcts.slice(0,i).reduce(function(a,b){return Number(a)+Number(b);}):0;var fill=colorScale((breaks[i]+breaks[i+1])/2);return i<arr.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{classes:arr.length-1,key:'legendsection'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Swatch,{fill:fill,index:i,classes:arr.length-1,scale:pctCountiesInClass,offset:prevPctsOffset,mode:_this2.hovered?'truescale':''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{firstLast:i===0?'first':i===arr.length-2?'last':'',offset:prevPctsOffset,index:i,classes:arr.length-1,scale:pctCountiesInClass,mode:_this2.hovered?'truescale':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelRange,{hide:_this2.hovered,last:i===arr.length-2},Math.ceil(breaks[i]),'-',Math.floor(breaks[i+1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pct,null,'%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelNum,{show:_this2.hovered},nums[i]!==0&&nums[i]))):'';}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileLgd,null,breaks.map(function(ele,i,arr){var numCountiesInClass=nums[i];var pctCountiesInClass=pcts[i];var prevPctsOffset=i>0?pcts.slice(0,i).reduce(function(a,b){return Number(a)+Number(b);}):0;var fill=colorScale((breaks[i]+breaks[i+1])/2);return i<arr.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobSwatchSect,{key:'swatch'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobLabel,null,Math.ceil(breaks[i]),'-',Math.floor(breaks[i+1]),'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobSwatch,{fill:fill})):'';}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return Legend;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'hovered',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'pcts',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return[0,0,0,0];}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'handleHover',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(tf){return _this3.hovered=tf;};}})),_class2))||_class;var MobileLgd=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_6__utilities_media__["a" /* default */].smallphone);var MobSwatchSect=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2);var MobLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3);var MobSwatch=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.fill;},__WEBPACK_IMPORTED_MODULE_6__utilities_media__["a" /* default */].smallphone);var Lgd=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject5);var Dash=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject6);var Pct=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject7);var Section=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject8,function(props){return 100/props.classes;});var Swatch=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject9,function(props){return props.fill;},function(props){return props.classes-props.index;},function(props){return .25+props.index*.05;},function(props){return props.mode==='truescale'?(props.scale+props.offset)*100:100/props.classes*(props.index+1);});var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject10,function(p){return p.mode==='truescale'&&p.firstLast==='first'?0:p.mode==='truescale'?320*(p.offset+p.scale/2)+'px':320/p.classes*p.index+'px';},function(p){return p.mode!=='truescale'&&!p.firstLast?'translateX(10%)':'translateX(0)';},function(props){return props.firstLast==='last'?'\n        right: 0; left: auto;\n        transform: translateX(0);\n        text-align: right;\n    ':'';},function(props){return .25+props.index*.05;});var LabelRange=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject11,function(props){return props.last?'auto':0;},function(props){return props.last?0:'auto';},function(props){return props.hide?0:1;},function(props){return props.hide?-10:0;});var LabelNum=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject12,function(props){return props.show?1:0;},function(props){return props.show?0:10;});var Labels=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject13,__WEBPACK_IMPORTED_MODULE_6__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_6__utilities_media__["a" /* default */].compact);var Swatches=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject14);var Titles=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject15);var ColorGuideLabel=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Titles)(_templateObject16,function(props){return props.hide?0:1;});var NumCountiesLabel=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Titles)(_templateObject17,function(props){return props.show?'\n        opacity: 1;\n    ':'';});var NumCounties=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Label)(_templateObject18);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CaliforniaCountyMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chroma_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_chroma_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_chroma_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generic___ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_media__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7;var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    width: 100%;\n    height: 100%;\n'],['\n    position: relative;\n    width: 100%;\n    height: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    right: 0;\n    /*transition: transform .5s;*/\n    /*transform-origin: 50% 50%;*/\n'],['\n    position: absolute;\n    right: 0;\n    /*transition: transform .5s;*/\n    /*transform-origin: 50% 50%;*/\n']),_templateObject3=_taggedTemplateLiteral(['\n    cursor: pointer;\n    stroke: ',';\n    stroke-width: ',';\n    @media ','{\n        stroke-width: 2.25;\n    }\n'],['\n    cursor: pointer;\n    stroke: ',';\n    stroke-width: ',';\n    @media ','{\n        stroke-width: 2.25;\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    white-space: nowrap;\n'],['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    white-space: nowrap;\n']),_templateObject5=_taggedTemplateLiteral(['\n    width: 200px;\n    white-space: wrap;\n    font-size: 13px;\n    display: flex;\n    justify-content: center;\n'],['\n    width: 200px;\n    white-space: wrap;\n    font-size: 13px;\n    display: flex;\n    justify-content: center;\n']),_templateObject6=_taggedTemplateLiteral(['\n    margin-top: -3px;\n'],['\n    margin-top: -3px;\n']),_templateObject7=_taggedTemplateLiteral(['\n    padding-left: 20px;\n    color: ',';\n'],['\n    padding-left: 20px;\n    color: ',';\n']),_templateObject8=_taggedTemplateLiteral(['',''],['','']),_templateObject9=_taggedTemplateLiteral(['\n    opacity: ',';\n    transition: opacity ','s;\n    fill: black;\n    stroke: black;\n    stroke-width: 2;\n'],['\n    opacity: ',';\n    transition: opacity ','s;\n    fill: black;\n    stroke: black;\n    stroke-width: 2;\n']),_templateObject10=_taggedTemplateLiteral(['\n    fill: var(--offwhitefg);\n    transition: opacity .5s;\n    @media ','{\n        transform: translate(-10px, 10px);\n    }\n'],['\n    fill: var(--offwhitefg);\n    transition: opacity .5s;\n    @media ','{\n        transform: translate(-10px, 10px);\n    }\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import semanticTitles from '../assets/semanticTitles'
var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject);var TheMap=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].svg(_templateObject2);var CountyStyle=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* css */])(_templateObject3,function(props){return props.highlighted?'var(--peach)':'transparent';},function(props){return props.selected?3.5:3.5;},__WEBPACK_IMPORTED_MODULE_12__utilities_media__["a" /* default */].mobile);var exemptPathIDs=['svgMap','full','garbmask'];var InteractiveMap=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(InteractiveMap,_React$Component);function InteractiveMap(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InteractiveMap);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InteractiveMap.__proto__||Object.getPrototypeOf(InteractiveMap)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'targetCoords',_descriptor,_this),_initDefineProp(_this,'defaultCoords',_descriptor2,_this),_initDefineProp(_this,'updateCoords',_descriptor3,_this),_initDefineProp(_this,'defaultTooltip',_descriptor4,_this),_initDefineProp(_this,'setDefaultTooltip',_descriptor5,_this),_initDefineProp(_this,'tooltip',_descriptor6,_this),_initDefineProp(_this,'toggleTooltip',_descriptor7,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InteractiveMap,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(!Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["isEqual"])(this.props.colorStops,prevProps.colorStops)||this.props.colorInterpolation!==prevProps.colorInterpolation){console.log('color stop or colorinterp changed');this.updateColors();}if(this.props.hoveredCounty!==prevProps.hoveredCounty){if(!this.props.hoveredCounty){this.toggleTooltip(false);}else if(this.props.hoveredCounty){var svgRect=document.getElementById('svgMap').getBoundingClientRect();this.toggleTooltip(true);var bbox=document.getElementById(this.props.hoveredCounty).getBoundingClientRect();var newX=bbox.left+bbox.width/2-svgRect.left;var newY=bbox.top-svgRect.top;this.updateCoords(newX,newY);}}else if(this.props.defaultHighlight&&this.props.defaultHighlight!==prevProps.defaultHighlight){console.log('hello');// this.defaultTooltip = indicators[indicator].highlight
this.setDefaultTooltip(this.props.defaultHighlight);var _svgRect=document.getElementById('svgMap').getBoundingClientRect();var _bbox=document.getElementById(this.props.defaultHighlight).getBoundingClientRect();var _newX=_bbox.left+_bbox.width/2-_svgRect.left;var _newY=_bbox.top-_svgRect.top;this.updateCoords(_newX,_newY,true);}else if(!this.props.defaultHighlight){this.setDefaultTooltip(null);}}},{key:'handleClick',value:function handleClick(e,id){if(this.props.onSelect){console.log('made county selection from map:',id);if(exemptPathIDs.includes(id)){// this.props.clickedOutside()
// ^ rendered unnecessary by click outside event listener for nav
}else{this.props.onSelect('county',id);}}e.preventDefault();e.stopPropagation();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,store=_props.store,colorStops=_props.colorStops,quantile=_props.quantile,selected=_props.selected,hoveredCounty=_props.hoveredCounty,domProps=_objectWithoutProperties(_props,['store','colorStops','quantile','selected','hoveredCounty']);var indicator=store.indicator,colorScale=store.colorScale,race=store.race,screen=store.screen;var tooltipCty=hoveredCounty?hoveredCounty:this.defaultTooltip?this.defaultTooltip:'';var tipPopulation=tooltipCty?__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a[tooltipCty].population:'';if(tipPopulation>=1000000)tipPopulation=(tipPopulation/1000000).toFixed(1)+' million';else if(tipPopulation>=1000)tipPopulation=(tipPopulation/1000).toFixed(1)+'k';var tipData=this.props.data&&tooltipCty?this.props.data[tooltipCty]:'other';var noData=false;var cty=__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[tooltipCty];var semanticTitle=indicator?__WEBPACK_IMPORTED_MODULE_10__data_indicators__["a" /* default */][indicator].semantics:'';if(!tipData&&tipData!==0){if(race){if(race==='other')'There\'s no data on '+semanticTitle.who+' of other races in '+cty+' for this indicator.';else tipData='There\'s no data on '+Object(__WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__["b" /* capitalize */])(race)+' '+semanticTitle.who+' in '+cty+' for this indicator.';}else tipData='There\'s no data on '+cty+' county for this indicator.';noData=true;}else if(tipData==='*'){noData=true;if(race){if(race==='other')tipData='Indicator data on '+semanticTitle.who+' of other races in '+cty+' is too small or unstable to display.';else tipData='Indicator data on '+Object(__WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__["b" /* capitalize */])(race)+' '+semanticTitle.who+' in '+cty+' is too small or unstable to display.';}else tipData='Indicator data on '+cty+' is too small or unstable to display.';}else tipData+='%';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{onClick:function onClick(e){return _this2.handleClick(e,store.county===e.target.id?null:e.target.id);}},this.props.data&&this.defaultTooltip&&!this.tooltip&&!selected&&store.screen!=='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__generic___["e" /* Tooltip */],{key:this.defaultTooltip,pos:this.defaultCoords,style:{pointerEvents:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tip,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,cty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subtip,null,tipPopulation,' children')),this.props.data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tipnum,null,tipData)))),this.tooltip&&store.screen!=='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__generic___["e" /* Tooltip */],{key:hoveredCounty,pos:this.targetCoords,style:{pointerEvents:'none'}},!noData&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tip,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,cty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subtip,null,tipPopulation,' children')),this.props.data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tipnum,null,tipData))),noData&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoDataTip,null,tipData)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TheMap,Object.assign({id:'svgMap',viewBox:'5 14 510 615'},domProps,{version:'1.1'// zoomable = {this.props.zoomable}
// zoomOrigin = {this.zoomOrigin}
// zoomed = {this.props.zoom}
}),this.props.children.map(function(child,i){var InteractivePolygonOrPath=child.props.id==='full'?SVGComponents.full:exemptPathIDs.includes(child.props.id)?SVGComponents.garb:SVGComponents['Interactive'+child.type.charAt(0).toUpperCase()+child.type.slice(1)];var data=_this2.props.data;var _child$props=child.props,points=_child$props.points,d=_child$props.d,id=_child$props.id,childProps=_objectWithoutProperties(_child$props,['points','d','id']);var wire=!data&&_this2.props.mode==='offset';var fill=wire?'var(--offwhitefg)':data[id]!==''&&data[id]!=='*'?store.colorScale(data[id]):'var(--inactivegrey)';// TODO
var foistProps=!exemptPathIDs.includes(id)&&child.type!=='polyline'?{//props that don't apply to full or outlinebox
style:{fill:selected===id?'var(--peach)':fill,transition:selected===id?'fill 0.1s':data?'fill '+(0.1+i*0.02)+'s, stroke 0s':'fill .25s'},// 'data-tip': data[id]==='*'? `${countyLabels[id]} county's data set is too small or unstable.` : !data[id]? `${countyLabels[id]} has no data` : `${countyLabels[id]}: ${data[id]}%`,
selected:selected===id,highlighted:_this2.highlighted===id||_this2.props.hoveredCounty===id||!selected&&!_this2.props.hoveredCounty&&_this2.defaultTooltip===id// onClick: ()=> this.handleClick(id)
}:{};var hoverActions=screen!=='mobile'&&_this2.props.onHoverCounty&&!exemptPathIDs.includes(id)?{onMouseEnter:function onMouseEnter(){return _this2.props.onHoverCounty(id);},onMouseLeave:function onMouseLeave(){return _this2.props.onHoverCounty();}}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InteractivePolygonOrPath,Object.assign({},childProps,foistProps,{id:id,key:id,points:points,d:d,wire:wire,offset:_this2.props.mode==='offset',onTransitionEnd:i===_this2.props.children.length-1?function(){console.log('end of transitions');}:function(){}},hoverActions));})));}}]);return InteractiveMap;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'targetCoords',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{x:0,y:0};}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'defaultCoords',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{x:0,y:0};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'updateCoords',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(x,y,forDefault){if(!forDefault)_this3.targetCoords={x:x,y:y};else _this3.defaultCoords={x:x,y:y};};}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'defaultTooltip',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'setDefaultTooltip',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(val){return _this4.defaultTooltip=val;};}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'tooltip',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'toggleTooltip',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(tf){return _this5.tooltip=tf;};}})),_class2))||_class;InteractiveMap.defaultProps={colorStops:['#CDFCFE','#135F80'],colorInterpolation:'hcl',quantile:false,clickedOutside:function clickedOutside(){console.log('clicked map container but no county');}};var Tip=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4);var NoDataTip=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject5);var Subtip=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].h3(_templateObject6);var Tipnum=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].h1(_templateObject7,function(props){return props.faint?'var(--fainttext)':'white';});var SVGComponents={InteractivePolygon:function InteractivePolygon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountyPolygon,props);},InteractivePath:function InteractivePath(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountyPath,props);},full:function full(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FullState,props);},garb:function garb(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GarbMask,props);}};var CountyPolygon=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].polygon(_templateObject8,CountyStyle);var CountyPath=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].path(_templateObject8,CountyStyle);var FullState=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].polygon(_templateObject9,function(props){return props.wire?1:0;},function(props){return props.wire?1:0.25;});var GarbMask=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].polygon(_templateObject10,__WEBPACK_IMPORTED_MODULE_12__utilities_media__["a" /* default */].smallphone);var CaliforniaCountyMap=function(_React$Component2){_inherits(CaliforniaCountyMap,_React$Component2);function CaliforniaCountyMap(){_classCallCheck(this,CaliforniaCountyMap);return _possibleConstructorReturn(this,(CaliforniaCountyMap.__proto__||Object.getPrototypeOf(CaliforniaCountyMap)).apply(this,arguments));}_createClass(CaliforniaCountyMap,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InteractiveMap,this.props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{style:{opacity:this.props.garbMask?1:0},id:'garbmask',points:'289.3,16 289.3,194 520,398.7 565,482 537,600 336,622 306,548 162,495 -19,127 -19,16 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'full',points:'505.2,481.5 496.9,475 490.7,459.8 483,450.4 483,443 434.6,395.8 331.5,298.4 246.6,221.5  246.6,221.4 231.5,208 231.5,207.9 226.8,199.7 226.7,199.7 226.5,184.5 226.6,184.5 226.7,176.6 226.6,176.5 226.7,159.4  226.8,159.3 226.8,67.6 226.8,16 20.2,16 22.3,24.6 19.5,30.4 25.8,36 29.4,49.8 24.3,58.3 28.2,60.9 24,72.8 27.2,79.3 25.7,85.2  13.2,113.3 15.5,126.4 29.4,141.9 29.4,141.9 40.1,154.6 43.8,170.1 41,183.2 47.3,201.5 46.2,210.5 53.4,218.7 53.4,218.7  53.4,218.7 53.5,218.8 53.5,218.8 59.8,224.2 66.3,233.9 73.1,238.1 77.2,246.9 82.8,255.9 79.4,264.5 81.1,268.2 88.2,266.4  102.1,276.3 106,275.7 104.7,269.7 106.8,266 103.9,264.2 106.8,258.8 106.7,258.7 108.7,253.3 114.6,253.2 114.6,253.3  115.6,255.4 116.2,255.4 118,260.2 129.3,256.2 133.9,260.4 137.9,260.9 145.3,259.5 145.4,259.4 151.3,259.1 146.6,260.7  142.1,264.4 125.5,262.7 114.2,265.6 110.7,269.2 113.6,271.9 117.9,282.5 127.6,296.2 127.4,296.4 124.6,297.7 124,298.8  123.9,298.9 112.3,289.9 111.8,283.7 112.3,283.7 109,277.3 104.3,278.3 103.9,283.8 104.2,293.9 109.2,304 108.5,311.3  113.5,321.1 116.3,321.8 116.3,321.8 127.7,330.4 133.7,329.7 137.1,333.9 137.8,339.9 131,346.2 128.9,349.5 132.9,367.2  142.3,375.2 149.2,386.4 157.9,396.6 158,396.8 163.5,406.8 169.3,409.2 176.9,418.8 182.1,420.4 180.7,428.7 185.3,434.7  193.7,437.5 193.1,443.3 193.2,443.4 191.8,448.9 194.6,452.5 195.1,460.8 192.8,468.2 205,478.4 213.1,477 225.6,477.4  240.4,481.6 250.6,482.2 258.6,487.4 264.1,497.4 276.8,501.5 283.4,504 295.7,501.7 301.1,510.3 300,516.8 305.8,520.4  316.3,518.5 340.9,539.3 349.4,548 354.8,563.7 354.9,575.8 360.4,584.9 412.7,579.9 412.7,580 478.8,574.4 488,572.1 491.1,563.5  488.3,556.6 479.5,553.3 480.5,542.6 478.6,535.4 483.3,533.6 483.2,533.4 483.5,533.4 488.3,526.7 489.7,518.4 487.8,505.2  492.4,496.5 492.5,496.5 506.9,486.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sierra',points:'201.7,174.7 223.2,175.9 226.1,175.9 226.2,160 219.9,160.9 195.4,161.2 185.4,156.7 181.6,163.1  179.3,164.8 178.7,178.9 189.2,175.8 190.6,175.2 190.8,175.1 198.8,171 199.3,171.1 199.9,171.1 199.9,171.6 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sacramento',points:'173,222.1 172.4,222.2 172.3,222.2 156,220.8 150.7,220.7 149.5,222.6 155.2,231.9 154.8,243.2  151.2,246.3 150.3,253.2 146.4,258.8 151,258.6 156,249.2 159.7,250.2 176.8,246.5 177,246.3 177.2,246.2 177.2,234.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'santaBarbara',points:'252.9,449.5 251.8,449.5 238.8,445.2 223.1,437.2 218,441.9 212.1,442.7 213.4,449.8 205.9,444.5  196.4,446.1 193.6,444.1 192.4,448.8 195.2,452.3 195.7,460.9 193.5,468 205.2,477.8 213,476.4 213.1,476.4 225.8,476.8 240.5,481  250.2,481.5 252.9,475 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'calaveras',points:'180,251.5 183.1,259.9 195.7,274.2 204.3,263.9 210.6,252.8 217.7,242.3 225,238.3 223.1,234.5  206,237.3 196.9,244.8 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'ventura',points:'289.9,490.8 291.3,484.4 279.8,455.9 262.5,454.5 260.9,450.7 254.1,449.6 254.1,475.2 251.4,481.9  259.1,486.9 264.5,496.9 276.3,500.7 276.6,498.1 284.4,490.8 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'losAngeles',points:'332.2,503.5 338.5,484.6 337.6,454.1 334.3,454 281.8,454.3 280.9,455.5 292.6,484.2 290.8,492  284.9,492 277.7,498.7 277.5,501.1 283.5,503.4 296,501.1 301.8,510.2 300.7,516.5 306,519.7 315.9,517.9 323.1,503.5 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sonoma',points:'113.7,252.6 100.9,224.6 95.1,217.2 91.8,213.7 80,213.6 77.4,216.2 54.9,219.1 60.3,223.8 66.8,233.4  73.6,237.7 77.5,246.2 86.9,245.2 96.3,251.7 103.8,252.9 104.8,253.9 106.6,257.3 108.3,252.7 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'kings',points:'247.2,356.4 243,360.3 229.4,361.3 229.4,374 212.6,390 216.9,396.2 248.3,396.2 248.4,377.1  251.2,360.9 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sanDiego',points:'358.5,534.3 358.4,534.3 346,530.1 341.6,539.2 349.7,547.8 355.2,563.8 355.4,575.7 360.6,584.4  412.1,579.4 413,534.6 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'placer',points:'215.3,201.9 226.1,199.3 225.9,185 196.2,185.1 188.1,190.4 180.4,197.4 178.1,202.2 173.4,203.1  167.5,203.1 165.8,202.4 159.7,204.7 157.3,208.7 156.6,219.7 172,221 176.7,208.6 192.1,203 199.5,208.4 205.8,201.5 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sanFrancisco',points:'111.3,283.1 108.7,278 104.9,278.8 104.5,283.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'marin',points:'88.4,265.6 102.3,275.5 105.3,275.1 104.1,269.5 105.9,266.1 103.1,264.4 106.1,258.8 103.2,254.1  95.8,252.9 86.6,246.5 78.2,247.4 83.5,255.8 80.2,264.4 81.5,267.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'mariposa',points:'243.1,299.4 246.2,291.1 258.9,278.4 247.7,271.7 243.1,277.4 229.3,279.8 223.8,276.3 221.3,278.4  217.5,279.7 214.5,281.6 213.3,281 211.8,281.9 211.5,283.3 208.7,284.6 208.9,286.9 218.8,309 224.3,313.3 237.9,299.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'lassen',points:'226.2,68.2 163.8,68.2 164,113.6 176.7,113.5 177.7,127 185,128.9 190.1,121.6 199.6,123.6  210.8,134.3 217.2,136.2 222.3,145.7 220.5,159.6 226.2,158.8 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'napa',points:'127.5,245.2 125.9,233.9 121.1,223.3 117.1,214.2 112.9,213 109.7,222.5 102.3,224.7 115.2,253  116,254.7 119.5,254.8 121,245.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'shasta',points:'97.1,119.7 106.4,117.2 122.9,117.7 125.6,116 141.9,114.1 146.3,113.1 155.4,113.5 162.8,113.6  162.6,68.2 157.7,68.2 109.5,68.3 110.8,69.1 96.7,100.3 96.9,100.7 98.7,106.7 84.2,117.7 81.6,123.1 85.1,122 86,122.1  86.8,122.1 87.8,121.7 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'monterey',points:'133.7,366.8 143.1,374.8 150,386 158.5,395.9 215.4,396.2 211.3,390.4 210.4,389.5 207.9,386.8  203,384 195.2,378.4 195.1,374.3 193.9,369 192.6,368 192.3,367.9 193.3,369.6 193.8,372.8 192.5,373.4 191.3,373 186.5,368.9  185.3,367.8 182,368.2 178.6,369.3 176.8,368.7 176.5,365.6 167.2,355.1 163.7,355.2 162.2,347.1 155.9,343.6 155.9,343.3  155.6,343.2 155.4,342.1 156.8,341.3 156.7,341.1 148.1,332 137.8,334.4 138.5,340.2 131.8,346.4 129.9,349.5 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'trinity',points:'95.3,100.3 109.3,69.6 107,68 106.7,57.9 103.5,57.1 85.7,72.3 89.5,77.9 81.8,79.6 71.8,75 64.7,69.1  64.1,78.9 61,85.2 55.6,86.6 58.2,95.7 58.2,142.9 86.1,142.8 84.1,127.3 80.2,125.1 79.8,124.1 83.3,116.9 97.3,106.2 95.8,101.1  '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'mendocino',points:'89.6,212.4 85.7,210.4 78.5,199.5 83.2,189.3 79.4,178.8 80.1,172.4 88.3,170.8 88.4,168.2 86,154.7  85,151.5 87.2,146 86.4,144 57,144.1 57,142.5 30.7,142.5 40.7,154.3 44.4,170 41.6,183.1 47.9,201.4 46.8,210.2 53.7,218.1  76.8,215.1 79.5,212.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'inyo',points:'403,396 430.3,396 433.3,395.3 330,297.8 285.9,297.9 285.4,304.2 291.1,309 294.6,316.5 301.4,320.5  305.7,331.7 305,336.9 305.6,340.2 310.9,355.6 318.3,364.7 317.8,371.6 323.8,392.3 322.7,396.2 339.8,395.8 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'mono',points:'267.9,280.5 273.9,289.5 285.5,296.7 328.7,296.6 246.9,222.6 245.6,227.7 248.4,238.1 244.6,245.2  245.3,251.6 248.8,255.7 257,258.7 259.6,266.3 265.2,270.8 262.5,280.1 265.9,280.1 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'tuolumne',points:'258.6,267 256.1,259.7 248.1,256.7 244.1,252.1 243.4,245.3 240.5,240.3 232.3,243.9 225.8,239.2  218.5,243.2 211.6,253.4 205.2,264.6 196.5,275.1 207.6,285.6 207.5,283.9 210.4,282.5 210.8,281.1 213.3,279.7 214.4,280.2  217,278.6 220.8,277.3 223.6,274.8 229.6,278.5 242.4,276.3 247.4,270.1 260.3,277.9 261.5,279.4 263.8,271.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'solano',points:'117,255.9 118.4,259.5 129.4,255.6 134.1,259.8 137.8,260.3 144.9,258.9 149.2,252.8 150,246.5  145.3,246.4 144.9,233.2 127.1,234.3 128.9,246.4 122.1,246.4 121,255.8 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sanBernardino',points:'449.8,495.9 450.4,495.9 492.2,495.8 506.1,485.9 504.7,481.8 496.4,475.3 496.3,475.2 490.1,460.1  482.3,450.6 482.4,443.2 434.3,396.3 430.4,397.2 403,397.2 340.4,397.1 340.5,454.1 338.8,454.1 339.7,484.8 333.3,503.9  337.3,507.2 337.3,507.1 343.1,498.5 352.1,498.9 372.8,500.1 372.8,498.4 449.8,498.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'contraCosta',points:'125.6,263.4 114.5,266.2 111.5,269.2 113.7,271.3 119.2,270.3 119.9,271.2 122.4,274 133.3,281.2  151.9,275.5 150.8,260 146.9,261.4 142.3,265.1 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'alpine',points:'244.3,227.8 245.9,221.7 232.7,209.9 233.3,211.8 224,222.4 224,233.7 226.3,238.1 232.4,242.6  240.9,238.7 244,243.9 247.1,238 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'elDorado',points:'223,221.7 232,211.5 230.9,208.2 226.4,200.4 215.4,203.1 206.3,202.7 199.6,210 191.9,204.3  177.6,209.6 173.4,220.7 173.8,220.6 178.2,233.3 185,231.5 192.1,230.6 191.9,231.2 196.9,233.7 204.4,232.5 212.1,231 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'yolo',points:'118,213.2 122.2,222.8 126.8,233.1 146,231.9 146.5,245.2 150.6,245.3 153.6,242.6 154,232.2  148.1,222.7 149.7,220 149,218.1 146.6,220.2 138.9,209.1 115.4,209.1 113.5,211.9 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'yuba',points:'165.2,189.5 172.8,180 177.5,179.2 178,165.8 175.9,167.5 172.3,171.9 163.6,175.5 160.1,183.4  149.9,186.1 149.8,187.2 151.9,207.5 159,203.6 165.2,201.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sanBenito',points:'197.4,355.8 182.6,341 171.9,335.3 168.5,328 156,326.7 153.3,330.5 151.6,331.7 149.6,331.9  157.8,340.6 158.2,341.6 157.3,342.4 156.9,342.6 157,342.8 163.3,346.3 164.7,354 167.7,353.9 177.7,365.1 177.9,367.8 178.6,368  181.8,367 185.8,366.6 187.2,368 192,372 192.4,372.1 192.5,372.1 192.1,369.9 189,364.7 193.3,367 194.4,367.9 197.7,364.8 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'humboldt',points:'63.5,68 59.3,55.6 46.3,55.7 46.2,50.4 29.7,50.4 25.2,58.1 28.9,60.7 24.6,72.8 27.8,79.2 26.2,85.4  13.8,113.4 16,126.1 29.7,141.3 57,141.3 57,95.8 54.2,85.8 60.2,84.1 63,78.5 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'riverside',points:'413.7,533.4 483,532.9 487.6,526.6 489,518.5 487.1,505.2 491.4,497 451,497.1 451,499.6 374,499.6  374,501.4 352,500.1 343.7,499.7 338.4,507.6 338.4,508.2 344.9,517.2 351.1,520.5 346.5,529.1 358.7,533.1 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'kern',points:'281.5,453.1 334.3,452.8 339.3,452.9 339.2,397.1 322,397.4 218.1,397.4 218.1,406.6 223.1,406.6  227.4,416.8 233,416.9 236.4,427.2 243.4,427.2 243.3,432.3 248.8,432 248.4,437.5 252.6,438.2 252.6,448.3 253.5,448.3  261.7,449.6 263.3,453.3 279.9,454.7 281.2,453.1 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'colusa',points:'115.4,207.9 138.7,207.9 139.2,202.3 133.3,192.9 135.2,185.1 135.9,180.8 96.5,180.9 95.1,184.6  100,190 107.2,190.4 109.3,196 109,196 109.3,200.6 112,203.8 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'delNorte',points:'21,16.5 22.9,24.6 20.2,30.2 26.3,35.6 29.9,49.2 47.4,49.2 47.5,54.5 51.4,54.4 50,44.1 51.9,23.1  52.5,22.3 57.6,16.5 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'modoc',points:'226.2,16.5 158.3,16.5 158.3,67 226.2,67 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'fresno',points:'304.4,331.8 300.4,321.3 293.7,317.4 290.1,309.7 284.2,304.7 284.7,297.7 273.6,290.7 261.5,302.8  257.8,315.4 248.8,316.9 248.3,321.6 241.6,325 235.9,334.8 208.8,338.5 204.9,333.6 200.8,323.5 183.8,340.5 198.5,355.3  199,365.3 195.1,368.8 196.3,374.2 196.4,377.7 203.6,383 208.7,385.9 211.8,389.1 228.2,373.5 228.2,360.2 242.5,359.1  246.8,355.1 252,349.7 259.4,349.9 259.4,344.7 274.7,344.9 274.9,339.9 304.3,339.7 303.8,336.9 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'madera',points:'247.2,320.8 247.7,315.8 256.8,314.3 260.5,302.2 272.7,289.9 267.2,281.6 265.7,281.3 261.4,281.3  259.8,279.2 247.2,291.7 243.9,300.6 238.4,300.6 224.7,314.7 221.6,315.7 213.2,316.5 201.7,322.7 205.9,333.1 209.3,337.2  235.1,333.6 240.8,324.1 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'santaClara',points:'167.9,326.7 166.6,323.2 167.7,317.1 167.4,316.6 165.2,315.3 159.8,316.9 158.1,307.1 159,306.2  155.3,296.7 137.9,296.6 134.6,298.1 127.6,297 125,298.2 122.9,301.8 123.3,305.3 124.1,306.9 124.1,307.2 124.6,307.6  130.7,314.7 136.8,318.1 138.9,318.7 142.4,321.3 143.4,321.6 145.2,324.9 145.3,325 146.9,326.5 147.2,326.6 151.4,330.3  152.5,329.6 155.5,325.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'tehama',points:'147.8,142.8 150.6,135.3 157.8,132.1 161.9,123 156,120.5 154.9,114.7 146.4,114.3 142.1,115.2  126,117.2 123.2,118.9 106.5,118.4 97.4,120.8 88.1,122.9 87,123.3 86,123.3 85.2,123.2 81.4,124.4 85.3,126.6 87.4,143.2 88.5,146  86.3,151.5 87.1,154 128.5,154 128.6,148.7 141.8,148.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sanJoaquin',points:'153.1,292.2 156.6,295.2 168.1,283.6 169.9,283.1 170.9,282.5 172.8,281.1 174,280.1 176.5,279.4  176.9,279.7 182.2,280.1 182,260.3 178.7,251.4 177.5,247.5 177.3,247.6 159.6,251.5 156.6,250.6 152,259.3 153.1,275.9 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'alameda',points:'155.1,295.5 151.9,292.8 151.9,276.7 133.1,282.5 121.6,274.9 118.7,271.6 114.4,272.4 118.4,282.2  127.8,295.8 134.5,296.8 137.7,295.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'nevada',points:'223.2,177.1 201,175.9 198.9,172.2 191.3,176.3 189.6,176.9 178.2,180.3 173.4,181.1 166.4,189.9  166.4,201.4 167.7,201.9 173.3,201.9 177.2,201.1 179.5,196.6 187.3,189.5 195.9,183.9 225.9,183.8 226.1,177.1 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'butte',points:'162.7,174.6 171.5,170.9 174.7,167.1 157.9,148.5 160.4,135.5 158.1,133.3 151.6,136.2 148.8,143.5  142.3,149.6 129.8,149.8 129.7,154.4 134.8,160.7 132.4,170.3 138.9,170.2 137.8,177.8 137.2,180.4 136.5,184.6 149.2,185.1  159.3,182.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'merced',points:'213,315.3 221.4,314.5 223.1,313.9 217.8,309.7 208,287.9 180.7,301.4 181.5,304.5 168.9,317.3  167.8,323 169.4,327.2 172.8,334.4 182.9,339.8 200.7,321.9 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'tulare',points:'316.6,371.7 317,365.1 309.8,356.1 304.6,340.9 276,341.1 275.8,346.1 260.6,345.9 260.6,351.1  252.5,351 248,355.6 252.5,360.6 249.6,377.2 249.5,396.2 321.5,396.2 322.6,392.3 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'stanislaus',points:'207.3,286.9 195.1,275.4 195.1,275.3 183.2,261.8 183.4,281.4 176.4,280.8 176.3,280.7 174.6,281.2  173.5,282 171.6,283.5 170.2,284.3 168.7,284.6 156.8,296.7 156.6,296.8 160.4,306.5 159.4,307.5 160.8,315.4 165.3,314.1  168.3,315.7 168.5,316 180.1,304.2 179.3,300.7 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'orange',points:'349.5,521 344.1,518.1 337.4,508.9 332.4,504.7 323.8,504.7 317.1,518.3 340.7,538.3 345.1,529.1 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'imperial',points:'490.6,563.5 487.9,557 478.9,553.6 480,542.6 477.9,534.9 480,534.1 414.3,534.6 413.3,579.3  478.8,573.7 487.7,571.5 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sutter',points:'157.6,205.8 150.8,209.4 148.6,187.2 148.7,186.2 136.2,185.8 134.6,192.7 140.4,202 139.9,208.4  146.8,218.4 149.5,216 150.7,219.5 155.4,219.6 156.1,208.3 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'amador',points:'222.8,233.4 222.8,223.4 212.7,232.1 204.7,233.7 196.7,235 190.8,232 185.2,232.7 178.4,234.5  178.4,246.6 179.7,250.4 196.4,243.7 205.5,236.2 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'lake',points:'114.4,208.6 108.2,201 107.8,195.3 106.3,191.6 99.5,191.2 93.7,184.9 95.5,180.2 95.6,168.7  89.6,168.7 89.5,171.8 81.2,173.4 80.6,178.7 84.5,189.4 79.9,199.4 86.5,209.5 92.6,212.7 93.3,213.5 96.1,216.4 101.7,223.6  108.8,221.5 112,211.9 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'plumas',points:'216.4,137.2 210.2,135.4 199,124.7 190.6,122.9 185.5,130.2 176.5,127.9 175.6,114.7 163.4,114.8  156.1,114.7 157.1,119.6 163.5,122.4 158.9,132.4 161.7,135.1 159.2,148.1 175.5,166.3 178.3,164 180.7,162.3 184.9,155.1  195.7,160 219.3,159.7 221.1,145.9 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sanMateo',points:'122.9,307.7 122.9,307.2 122.1,305.6 121.7,301.5 123.1,299.1 111.7,290.2 111.2,284.3 104.5,284.4  104.6,293.9 109.7,304 109,311.2 113.8,320.6 115.8,321 115.6,313.5 120.3,311.7 123.3,308 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'siskiyou',points:'108.2,67.1 157.1,67 157.1,16.5 123.9,16.5 59.2,16.5 53.4,23 53.1,23.5 51.2,44.1 52.6,54.4 60.1,54.3  64.6,67.5 72.5,74 81.9,78.4 87.5,77.1 84.1,72.1 103.2,55.8 107.9,57 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'santaCruz',points:'146.6,327.7 146.3,327.5 144.7,326 144.5,326 144.3,325.7 142.6,322.6 141.8,322.3 138.2,319.7  136.2,319.2 129.5,315.5 129.5,315.2 124.1,308.9 121,312.7 116.8,314.3 117,321.5 127.9,329.8 134,329.1 137.4,333.3 148.2,330.8  149.9,330.6 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'glenn',points:'130.8,171.5 133.5,160.9 128.8,155.2 87.3,155.2 89.5,167.5 96.9,167.5 96.7,179.7 136.1,179.6  136.6,177.6 137.5,171.4 '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'sanLuisObispo',points:'239.2,444 251.4,448.1 251.4,439.2 247.1,438.5 247.5,433.3 242.1,433.5 242.2,428.4 235.5,428.4  232.2,418.1 226.6,418 222.3,407.8 216.9,407.8 216.9,397.4 216.6,397.4 159.2,397.1 164.1,406.1 169.9,408.4 177.5,418 183,419.7  181.5,428.3 185.9,434 194.6,436.9 193.9,442.9 196.7,444.8 206.2,443.2 211.7,447.1 210.7,441.6 217.5,440.8 222.9,435.8 '})));}}]);return CaliforniaCountyMap;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CaliforniaCountyMap.defaultProps={debug:true};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CountingNumber__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_class2,_desc,_value,_class3,_descriptor,_descriptor2,_descriptor3;var _templateObject=_taggedTemplateLiteral(['\n    height: ','px;\n    width: ',';\n    position: relative;\n    display: flex;\n\n    flex-shrink: 0;\n'],['\n    height: ','px;\n    width: ',';\n    position: relative;\n    display: flex;\n\n    flex-shrink: 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: relative;\n    height: 100%;\n\n'],['\n    position: relative;\n    height: 100%;\n\n']),_templateObject3=_taggedTemplateLiteral(['\n    width: ',';\n    box-shadow: ',' var(',');\n    overflow: hidden;\n'],['\n    width: ',';\n    box-shadow: ',' var(',');\n    overflow: hidden;\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 100px;\n'],['\n    width: 100px;\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n    transition: transform .35s;\n    transform: translate','(','px);    \n'],['\n    position: absolute;\n    top: 0; left: 0;\n    transition: transform .35s;\n    transform: translate','(','px);    \n']),_templateObject6=_taggedTemplateLiteral(['\n    background: white;\n    width: 100%;\n    height: ',';\n    border: 1.5px solid var(',');\n\n'],['\n    background: white;\n    width: 100%;\n    height: ',';\n    border: 1.5px solid var(',');\n\n']),_templateObject7=_taggedTemplateLiteral(['\n    height: 0;\n    left: 2px;\n    width: calc(100% - 4px);\n    border-width: 0.5px;\n    border-style: solid;\n    border-top: .5px solid var(',');\n    border-bottom: .5px solid var(',');\n\n    border-color: var(--',');\n    display: ',';\n    ','\n'],['\n    height: 0;\n    left: 2px;\n    width: calc(100% - 4px);\n    border-width: 0.5px;\n    border-style: solid;\n    border-top: .5px solid var(',');\n    border-bottom: .5px solid var(',');\n\n    border-color: var(--',');\n    display: ',';\n    ','\n']),_templateObject8=_taggedTemplateLiteral(['\n    /*outline: 2px solid var(--bordergrey);*/\n'],['\n    /*outline: 2px solid var(--bordergrey);*/\n']),_templateObject9=_taggedTemplateLiteral(['\n    @media ','{ \n        font-size: 16px; \n        margin-top: ','rem;\n    }\n    @media ','{ \n        font-size: 13px; \n        margin-top: ','rem;\n    }\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    height: 0;\n\n    cursor: ',';\n\n'],['\n    @media ','{ \n        font-size: 16px; \n        margin-top: ','rem;\n    }\n    @media ','{ \n        font-size: 13px; \n        margin-top: ','rem;\n    }\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    height: 0;\n\n    cursor: ',';\n\n']),_templateObject10=_taggedTemplateLiteral(['\n    width: 12px; \n    border-top: .75px solid var(',');\n    border-bottom: .75px solid var(',');\n    margin-right: 10px;\n'],['\n    width: 12px; \n    border-top: .75px solid var(',');\n    border-bottom: .75px solid var(',');\n    margin-right: 10px;\n']),_templateObject11=_taggedTemplateLiteral(['\n    @media ','{ \n        font-size: 16px; \n        height: ','rem;\n    }\n    @media ','{ \n        font-size: 13px; \n        height: ','rem;\n    }\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    \n    cursor: ',';\n    \n'],['\n    @media ','{ \n        font-size: 16px; \n        height: ','rem;\n    }\n    @media ','{ \n        font-size: 13px; \n        height: ','rem;\n    }\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    \n    cursor: ',';\n    \n']),_templateObject12=_taggedTemplateLiteral(['\n    position: absolute;\n    @media ','{\n        bottom: -1rem;\n    }\n    @media ','{\n        bottom: -.25rem;\n    }\n    display: flex; flex-direction: column;\n    padding-left: 22px;\n'],['\n    position: absolute;\n    @media ','{\n        bottom: -1rem;\n    }\n    @media ','{\n        bottom: -.25rem;\n    }\n    display: flex; flex-direction: column;\n    padding-left: 22px;\n']),_templateObject13=_taggedTemplateLiteral(['\n    ','\n\n'],['\n    ','\n\n']),_templateObject14=_taggedTemplateLiteral(['\n    margin-left: 7px;\n    font-weight: bold;\n     ','\n'],['\n    margin-left: 7px;\n    font-weight: bold;\n     ','\n']),_templateObject15=_taggedTemplateLiteral(['\n    from{ transform: translateX(100%);}\n    to{ transform: translateX(0%);}\n'],['\n    from{ transform: translateX(100%);}\n    to{ transform: translateX(0%);}\n']),_templateObject16=_taggedTemplateLiteral(['\n    from{ transform: translateX(0%);}\n    to{ transform: translateX(-100%);}\n'],['\n    from{ transform: translateX(0%);}\n    to{ transform: translateX(-100%);}\n']),_templateObject17=_taggedTemplateLiteral(['\n    from{ transform: translateY(100%);}\n    to{ transform: translateY(0%);}\n'],['\n    from{ transform: translateY(100%);}\n    to{ transform: translateY(0%);}\n']),_templateObject18=_taggedTemplateLiteral(['\n    from{ transform: translateY(0%);}\n    to{ transform: translateY(-100%);}\n'],['\n    from{ transform: translateY(0%);}\n    to{ transform: translateY(-100%);}\n']),_templateObject19=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%; height: 100%;\n    /*mask-repeat: repeat;*/\n    background-color: ',';\n    mask-size: 32px;\n    \n    ','\n    &.asian{\n        mask-image: ',';\n        mask-position: 2px -7px;\n    }\n    &.black{\n        mask-image: ',';\n    }\n    &.latinx{ \n        mask-image: ',';\n    }\n    &.white{\n        mask-image: ',';\n    }\n    &.other{\n        mask-size: 25px;\n        mask-position-x: -1px;\n        mask-image: ',';\n    }\n    animation-duration: .25s;\n    animation-fill-mode: forwards;\n    &.animating{\n        animation-name: ','\n    }\n    cursor: ',';\n'],['\n    position: absolute;\n    width: 100%; height: 100%;\n    /*mask-repeat: repeat;*/\n    background-color: ',';\n    mask-size: 32px;\n    \n    ','\n    &.asian{\n        mask-image: ',';\n        mask-position: 2px -7px;\n    }\n    &.black{\n        mask-image: ',';\n    }\n    &.latinx{ \n        mask-image: ',';\n    }\n    &.white{\n        mask-image: ',';\n    }\n    &.other{\n        mask-size: 25px;\n        mask-position-x: -1px;\n        mask-image: ',';\n    }\n    animation-duration: .25s;\n    animation-fill-mode: forwards;\n    &.animating{\n        animation-name: ','\n    }\n    cursor: ',';\n']),_templateObject20=_taggedTemplateLiteral(['\n    transform: translate','(100%);\n    &.animating{\n        animation-name: ','\n    }\n'],['\n    transform: translate','(100%);\n    &.animating{\n        animation-name: ','\n    }\n']),_templateObject21=_taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    margin-top: 20px;\n    line-height: 23px;\n    letter-spacing: 0.5px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid var(--bordergrey);\n'],['\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    margin-top: 20px;\n    line-height: 23px;\n    letter-spacing: 0.5px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid var(--bordergrey);\n']),_templateObject22=_taggedTemplateLiteral(['\n    margin-right: 6px;\n    b {\n        font-weight: 600;\n    }\n    color: ',';\n'],['\n    margin-right: 6px;\n    b {\n        font-weight: 600;\n    }\n    color: ',';\n']),_templateObject23=_taggedTemplateLiteral(['\n    position: absolute;\n    left: 1px;\n    top: -20px;\n    width: 0px; height: 12px;\n    border-left: 2px solid ',';\n'],['\n    position: absolute;\n    left: 1px;\n    top: -20px;\n    width: 0px; height: 12px;\n    border-left: 2px solid ',';\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var races=['asian','black','latinx','white','other'];var RaceBreakdownBar=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=function(_React$Component){_inherits(RaceBreakdownBar,_React$Component);function RaceBreakdownBar(){_classCallCheck(this,RaceBreakdownBar);return _possibleConstructorReturn(this,(RaceBreakdownBar.__proto__||Object.getPrototypeOf(RaceBreakdownBar)).apply(this,arguments));}_createClass(RaceBreakdownBar,[{key:'render',value:function render(){var props=this.props;var height=props.height,store=props.store,width=props.width;var screen=store.screen,hoveredRace=store.hoveredRace;var county=this.props.forceCA?'':store.county;var clt=screen==='compact'?9:8;//compressed label threshold (% below which label becomes compressed)
var est=screen==='compact'?22:24;//exception segment threshold (% below which the last non-compressed seg has its label offset)
var numOfCompressedLabels=0;var racePercentages=races.map(function(race){var pct=__WEBPACK_IMPORTED_MODULE_6__data_demographicsAndPopulation___default.a[county||'california'][race];if(pct<=clt&&pct>0)numOfCompressedLabels++;return{label:race,percentage:pct};}).sort(function(a,b){return b.label==='other'?-2:a.percentage>b.percentage?-1:a.percentage<b.percentage?1:0;});var totalOfPcts=racePercentages.map(function(o){return o.percentage;}).reduce(function(a,b){return a+b;});var compressedLabels=racePercentages.filter(function(r){return r.percentage<=clt&&r.percentage>0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RaceBreakdown,{width:width,height:height,horizontal:screen==='mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RaceBar,{width:width,horizontal:screen==='mobile',lastSegSelected:racePercentages[racePercentages.length-1].label===store.race},racePercentages.map(function(race,i,arr){var previousSegs=arr.slice(0,i);var offset=previousSegs.map(function(seg){return seg.percentage*100/totalOfPcts;}).reduce(function(a,b){return a+b;},0);var pct=totalOfPcts!==100?race.percentage*100/totalOfPcts:race.percentage;console.log(race.label,race.label===hoveredRace);var hoverProps=store.screen!=='mobile'?{onMouseEnter:function onMouseEnter(){store.setHover('race',race.label);},onMouseLeave:function onMouseLeave(){store.setHover('race',null);},hoverable:store.indicator?function(){store.setHover('race',race.label,true);}:function(){}}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:'racefrag'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Backing,{horizontal:screen==='mobile',key:'backing'+i,offset:offset/100*(screen==='mobile'?width:height),selected:race.label===store.race}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RaceSegment,Object.assign({horizontal:screen==='mobile',key:i,offset:offset/100*(screen==='mobile'?width:height)// className = {race.label}
,style:{position:'absolute',height:'500px',width:'100%'},infinitesimal:pct<3,zero:pct==0,race:race.label,selected:race.label===store.race,hovered:race.label===hoveredRace,onClick:race.label===store.race?function(){store.completeWorkflow('race');}:function(){return store.completeWorkflow('race',race.label);}},hoverProps)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EndNotch,{id:'endnotch',key:'hatch'+i,offset:offset/100*(screen==='mobile'?width:height),infinitesimal:pct<3,hide:i===0// hide
,horizontal:screen==='mobile',selected:race.label===store.race||i>0&&arr[i-1].label===store.race}));})),screen!=='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelBar,null,racePercentages.map(function(race,i,arr){var previousSegs=arr.slice(0,i);var offset=previousSegs.map(function(seg){return seg.percentage*100/totalOfPcts;}).reduce(function(a,b){return a+b;},0);var pct=totalOfPcts!==100?race.percentage*100/totalOfPcts:race.percentage;return race.percentage>clt?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelSection,{key:'label'+i,offset:(offset+race.percentage/2)/100*height,specialOffset:numOfCompressedLabels===3&&racePercentages[1].percentage<est||numOfCompressedLabels===2&&racePercentages[2].percentage<est,onMouseEnter:function onMouseEnter(){return store.setHover('race',race.label);},onMouseLeave:function onMouseLeave(){return store.setHover('race',null);},onClick:race.label===store.race?function(){store.completeWorkflow('race');}:function(){return store.completeWorkflow('race',race.label);},hoverable:store.indicator?store.setHover('race',race.label,true):function(){}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelNotch,{selected:race.label===store.race}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{selected:race.label===store.race},' ',Object(__WEBPACK_IMPORTED_MODULE_5__utilities_toLowerCase__["b" /* capitalize */])(race.label),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Percentage,{selected:race.label===store.race},' ',race.percentage,'%')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null);}),racePercentages[racePercentages.length-1].percentage<clt&&racePercentages[racePercentages.length-1].percentage>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelSection,{offset:height+1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelNotch,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompressedLabels,null,compressedLabels.map(function(r,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Compressed,{num:numOfCompressedLabels,key:'compressedlabel'+i,specialOffset:numOfCompressedLabels===3&&racePercentages[1].percentage<est||numOfCompressedLabels===2&&racePercentages[2].percentage<est,onMouseEnter:function onMouseEnter(){return store.setHover('race',r.label);},onClick:r.label===store.race?function(){store.completeWorkflow('race');}:function(){return store.completeWorkflow('race',r.label);},onMouseLeave:function onMouseLeave(){return store.setHover('race',null);},hoverable:store.indicator?store.setHover('race',r.label,true):function(){}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{selected:r.label===store.race},' ',Object(__WEBPACK_IMPORTED_MODULE_5__utilities_toLowerCase__["b" /* capitalize */])(r.label),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Percentage,{selected:r.label===store.race},' ',r.percentage,'%'));})))),screen==='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PercentageTable,{percentages:racePercentages,store:store}));}}]);return RaceBreakdownBar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class;var RaceBreakdown=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject,function(props){return props.height;},function(props){return props.horizontal?props.width+'px':'175px';});var Bar=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2);var RaceBar=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Bar)(_templateObject3,function(props){return props.horizontal?props.width+'px':'50px';},function(props){return props.horizontal?'2px 0 0 0':'0 2px 0 0';},function(props){return props.lastSegSelected?'--peach':'--bordergrey';});var LabelBar=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Bar)(_templateObject4);var Positioned=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject5,function(props){return props.horizontal?'X':'Y';},function(props){return props.offset;});var Backing=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Positioned)(_templateObject6,function(props){return props.horizontal?'100%':'500px';},function(props){return props.selected?'--peach':'--bordergrey';});var EndNotch=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Positioned)(_templateObject7,function(props){return props.selected?'--peach':props.infinitesimal?'--offwhitefg':'--bordergrey';},function(props){return props.selected?'--peach':props.infinitesimal?'--offwhitefg':'--bordergrey';},function(props){return props.selected?'peach':props.infinitesimal?'offwhitefg':'bordergrey';},function(props){return props.hide?'none':'block';},function(props){return props.horizontal?'\n        left: 0;\n        width: 1px;\n        height: 100%;\n        border-top-width: 0;\n        border-bottom-width: 0;\n    ':'\n        border-left-width: 0px;\n        border-right-width: 0px;\n    ';});var Segment=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Positioned)(_templateObject8);var LabelSection=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Positioned)(_templateObject9,__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].optimal,function(props){return props.specialOffset?-.6:0;},__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].compact,function(props){return props.specialOffset?-.5:0;},function(props){return props.hoverable?'pointer':'auto';});var LabelNotch=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject10,function(props){return props.selected?'--peach':'--bordergrey';},function(props){return props.selected?'--peach':'--bordergrey';});var Compressed=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject11,__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].optimal,function(props){return props.specialOffset?1.15:1.25;},__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].compact,function(props){return props.specialOffset?.825:1;},function(props){return props.hoverable?'pointer':'auto';});var CompressedLabels=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject12,__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].compact);var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject13,function(props){return props.selected?'color: var(--strokepeach);':'';});var Percentage=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject14,function(props){return props.selected?'color: var(--strokepeach);':'';});var RaceSegment=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class2=(_class3=function(_React$Component2){_inherits(RaceSegment,_React$Component2);function RaceSegment(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,RaceSegment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=RaceSegment.__proto__||Object.getPrototypeOf(RaceSegment)).call.apply(_ref,[this].concat(args))),_this2),_initDefineProp(_this2,'oldHatches',_descriptor,_this2),_initDefineProp(_this2,'newHatches',_descriptor2,_this2),_initDefineProp(_this2,'setHatches',_descriptor3,_this2),_temp),_possibleConstructorReturn(_this2,_ret);}//same at outset
_createClass(RaceSegment,[{key:'componentDidUpdate',/*
        segments are keyed by index, not race, so that they animate
        organically; so they need to keep track via lifecycle methods
        of when the assigned race changes, and play an animation
        showing the pattern changing
    */value:function componentDidUpdate(oldProps){if(oldProps.race!==this.props.race){this.setHatches('new',this.props.race);}}},{key:'render',value:function render(){var _this3=this;var _props=this.props,race=_props.race,infinitesimal=_props.infinitesimal,zero=_props.zero,selected=_props.selected,hovered=_props.hovered,hoverable=_props.hoverable,horizontal=_props.horizontal,restOfProps=_objectWithoutProperties(_props,['race','infinitesimal','zero','selected','hovered','hoverable','horizontal']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment,Object.assign({selected:selected,horizontal:horizontal},restOfProps),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Hatches,{className:[this.oldHatches,this.oldHatches!==this.newHatches?'animating':''].join(' '),infinitesimal:infinitesimal,zero:zero,selected:selected,hovered:hovered,hoverable:hoverable,horizontal:horizontal// onAnimationEnd = {()=}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewHatches,{className:[this.newHatches,this.oldHatches!==this.newHatches?'animating':''].join(' '),onAnimationEnd:function onAnimationEnd(){_this3.setHatches('old',_this3.props.race);},infinitesimal:infinitesimal,zero:zero,selected:selected,hovered:hovered,hoverable:hoverable,horizontal:horizontal}));}}]);return RaceSegment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class3.prototype,'oldHatches',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return this.props.race;}}),_descriptor2=_applyDecoratedDescriptor(_class3.prototype,'newHatches',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return this.props.race;}}),_descriptor3=_applyDecoratedDescriptor(_class3.prototype,'setHatches',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(which,val){_this4[which+'Hatches']=val;};}})),_class3))||_class2;var hatch1=__webpack_require__(186);var hatch2=__webpack_require__(187);var hatch3=__webpack_require__(188);var hatch4=__webpack_require__(189);var hatch5=__webpack_require__(190);var animateIn=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* keyframes */])(_templateObject15);var animateOut=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* keyframes */])(_templateObject16);var vertanimateIn=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* keyframes */])(_templateObject17);var vertanimateOut=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* keyframes */])(_templateObject18);var Hatches=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject19,function(props){return props.hovered||props.selected?'var(--peach)':'var(--bordergrey)';},function(props){return props.zero?'display: none;':'';},function(props){return!props.infinitesimal?'url('+hatch3+')':'none';},function(props){return!props.infinitesimal?'url('+hatch4+')':'none';},function(props){return!props.infinitesimal?'url('+hatch1+')':'none';},function(props){return!props.infinitesimal?'url('+hatch2+')':'none';},function(props){return!props.infinitesimal?'url('+hatch5+')':'none';},function(props){return props.horizontal?vertanimateOut:animateOut;},function(props){return props.hoverable?'pointer':'auto';});var NewHatches=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Hatches)(_templateObject20,function(props){return props.horizontal?'Y':'X';},function(props){return props.horizontal?vertanimateIn:animateIn;});var PercentageTable=function PercentageTable(props){var store=props.store;var pcts=props.percentages;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PctTable,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HorizontalEndNotch,{selected:store.race===pcts[0].label}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PctBlock,{key:'pcttable-'+pcts[0].label,selected:store.race===pcts[0].label,onClick:store.race===pcts[0].label?function(){store.completeWorkflow('race');}:function(){return store.completeWorkflow('race',pcts[0].label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CountingNumber__["a" /* default */],{number:pcts[0].percentage}),'%'),'\xA0of\xA0them\xA0are\xA0',Object(__WEBPACK_IMPORTED_MODULE_5__utilities_toLowerCase__["b" /* capitalize */])(pcts[0].label),','),pcts.slice(1).map(function(pct,i){return i+1<pcts.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PctBlock,{key:'pcttable-'+pct.label,selected:pct.label===store.race,onClick:store.race===pct.label?function(){store.completeWorkflow('race');}:function(){return store.completeWorkflow('race',pct.label);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CountingNumber__["a" /* default */],{number:pct.percentage}),'%'),'\xA0',Object(__WEBPACK_IMPORTED_MODULE_5__utilities_toLowerCase__["b" /* capitalize */])(pct.label),','):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PctBlock,{key:'pcttable-'+pct.label,selected:pct.label===store.race,onClick:store.race===pct.label?function(){store.completeWorkflow('race');}:function(){return store.completeWorkflow('race',pct.label);}},'and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CountingNumber__["a" /* default */],{number:pct.percentage}),'%'),'\xA0are\xA0',Object(__WEBPACK_IMPORTED_MODULE_5__utilities_toLowerCase__["b" /* capitalize */])(pct.label),'.');}));};var PctTable=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject21);var PctBlock=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject22,function(props){return props.selected?'var(--strokepeach)':'var(--normtext)';});var HorizontalEndNotch=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject23,function(props){return props.selected?'var(--peach)':' var(--bordergrey)';});/* harmony default export */ __webpack_exports__["a"] = (RaceBreakdownBar);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generic_Icon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_browserCompatibility__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InitCopy__ = __webpack_require__(191);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2;var _templateObject=_taggedTemplateLiteral(['\n\n    @media ','{\n        margin-top: -100px;   \n    }\n    @media ','{\n        margin-top: -75px;\n    }\n    position: absolute;\n    left: 15px;\n    line-height: 170%;\n    z-index: 2;\n    h1{ \n        font-size: 24px;\n        @media ','{\n            margin-bottom: 60px;   \n        }\n        @media ','{\n            margin-bottom: 35px;\n        }\n        font-weight: medium;\n        opacity: ',';\n        transition: opacity .35s;\n     }\n     p{\n        margin-bottom: 20px;\n        letter-spacing: .4px;\n     }\n    @media ','{\n        width: 60%; \n        padding: 0 100px;\n    }\n    @media ','{\n        width: 57%;\n        padding-right: 30px;\n        /*padding: 0 50px;*/\n    }\n    transform: translateX(',');\n    pointer-events: ',';\n    transition: transform .35s;\n'],['\n\n    @media ','{\n        margin-top: -100px;   \n    }\n    @media ','{\n        margin-top: -75px;\n    }\n    position: absolute;\n    left: 15px;\n    line-height: 170%;\n    z-index: 2;\n    h1{ \n        font-size: 24px;\n        @media ','{\n            margin-bottom: 60px;   \n        }\n        @media ','{\n            margin-bottom: 35px;\n        }\n        font-weight: medium;\n        opacity: ',';\n        transition: opacity .35s;\n     }\n     p{\n        margin-bottom: 20px;\n        letter-spacing: .4px;\n     }\n    @media ','{\n        width: 60%; \n        padding: 0 100px;\n    }\n    @media ','{\n        width: 57%;\n        padding-right: 30px;\n        /*padding: 0 50px;*/\n    }\n    transform: translateX(',');\n    pointer-events: ',';\n    transition: transform .35s;\n']),_templateObject2=_taggedTemplateLiteral(['\n    transform: translateX(','px);\n    opacity: ',';\n    transition: transform .35s, opacity .35s;\n'],['\n    transform: translateX(','px);\n    opacity: ',';\n    transition: transform .35s, opacity .35s;\n']),_templateObject3=_taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    article {\n        position: relative;\n        border: 1px solid var(--bordergrey);\n        padding: 30px 20px 50px 20px;\n        font-size: 14px; letter-spacing: 0.5px;\n        background: var(--offwhitefg);\n        margin-bottom: 50px;\n        h1{\n            font-size: 16px;\n            top: 0; left: 0;\n            position: absolute;\n            transform: translateY(-50%);\n            margin: 0 15px;\n            padding: 0 15px;\n            background: var(--offwhitefg);\n        }\n        aside{\n            // display: block;\n            // text-align: left;\n            // width: 100%;\n            font-size: 12px;\n            color: var(--fainttext);\n        }\n        &::before{\n            content: \'\';\n            position: absolute;\n            bottom: -1px;\n            right: 15px;\n            width: 183px;\n            height: 1px;\n            background: var(--offwhitefg);\n            margin-top: 1;\n        }\n    }\n'],['\n    width: 100%;\n    height: 100%;\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    article {\n        position: relative;\n        border: 1px solid var(--bordergrey);\n        padding: 30px 20px 50px 20px;\n        font-size: 14px; letter-spacing: 0.5px;\n        background: var(--offwhitefg);\n        margin-bottom: 50px;\n        h1{\n            font-size: 16px;\n            top: 0; left: 0;\n            position: absolute;\n            transform: translateY(-50%);\n            margin: 0 15px;\n            padding: 0 15px;\n            background: var(--offwhitefg);\n        }\n        aside{\n            // display: block;\n            // text-align: left;\n            // width: 100%;\n            font-size: 12px;\n            color: var(--fainttext);\n        }\n        &::before{\n            content: \'\';\n            position: absolute;\n            bottom: -1px;\n            right: 15px;\n            width: 183px;\n            height: 1px;\n            background: var(--offwhitefg);\n            margin-top: 1;\n        }\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: absolute; bottom: 0;\n    right: 30px;\n    transform: translateY(50%);\n    z-index: 2;\n    padding: 15px 20px;\n\n'],['\n    position: absolute; bottom: 0;\n    right: 30px;\n    transform: translateY(50%);\n    z-index: 2;\n    padding: 15px 20px;\n\n']),_templateObject5=_taggedTemplateLiteral(['\n    height: 18px; width: 18px;\n    margin-left: 10px;\n'],['\n    height: 18px; width: 18px;\n    margin-left: 10px;\n']),_templateObject6=_taggedTemplateLiteral(['\n    opacity: ',';\n    transition: opacity .35s;\n    margin-top: 45px;\n    /*display: flex;*/\n    align-items: center;\n'],['\n    opacity: ',';\n    transition: opacity .35s;\n    margin-top: 45px;\n    /*display: flex;*/\n    align-items: center;\n']),_templateObject7=_taggedTemplateLiteral(['\n    font-size: 13px;\n    /*margin-right: 15px;*/\n    margin-bottom: 18px;\n    color: var(--fainttext, grey);\n    transform: translateX(','px);\n    transition: transform .35s;\n'],['\n    font-size: 13px;\n    /*margin-right: 15px;*/\n    margin-bottom: 18px;\n    color: var(--fainttext, grey);\n    transform: translateX(','px);\n    transition: transform .35s;\n']),_templateObject8=_taggedTemplateLiteral(['\n    white-space: nowrap;\n    font-size: 18px;\n    letter-spacing: 1px;\n    padding: 14px 20px 14px 30px;\n    transform: translateX(','px);\n    transition: transform .35s;\n    &:hover{\n        figure{\n            background-position: 100% center;\n        }\n    }\n'],['\n    white-space: nowrap;\n    font-size: 18px;\n    letter-spacing: 1px;\n    padding: 14px 20px 14px 30px;\n    transform: translateX(','px);\n    transition: transform .35s;\n    &:hover{\n        figure{\n            background-position: 100% center;\n        }\n    }\n']),_templateObject9=_taggedTemplateLiteral(['\n    display: inline-flex;\n    align-items: center;\n'],['\n    display: inline-flex;\n    align-items: center;\n']),_templateObject10=_taggedTemplateLiteral(['\n    width: 30px;\n    margin-left: 10px;\n    background-size: cover;\n    height: 30px;\n    background-image: url(',');\n    &:hover{\n        background-position: 100% center;\n    }\n    \n'],['\n    width: 30px;\n    margin-left: 10px;\n    background-size: cover;\n    height: 30px;\n    background-image: url(',');\n    &:hover{\n        background-position: 100% center;\n    }\n    \n']),_templateObject11=_taggedTemplateLiteral(['\n'],['\n']),_templateObject12=_taggedTemplateLiteral(['\n    margin-top: -5px;\n        padding: 25px 35px;\n    background: var(--faintpeach);\n    border: 1px solid var(--strokepeach, red);\n    color: var(--normtext, black);\n'],['\n    margin-top: -5px;\n        padding: 25px 35px;\n    background: var(--faintpeach);\n    border: 1px solid var(--strokepeach, red);\n    color: var(--normtext, black);\n']),_templateObject13=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-end;\n'],['\n    display: flex;\n    justify-content: flex-end;\n']),_templateObject14=_taggedTemplateLiteral(['\n    padding: 14px 30px 14px 30px;\n'],['\n    padding: 14px 30px 14px 30px;\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Box=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].compact,function(props){return props.show?1:0;},__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_5__utilities_media__["a" /* default */].compact,function(props){return props.show?0:'20%';},function(props){return props.show?'auto':'none';});var FirstPara=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].p(_templateObject2,function(props){return props.show?0:25;},function(props){return props.show?1:0;});var SecondPara=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].p(_templateObject2,function(props){return props.show?0:50;},function(props){return props.show?1:0;});var InitBox=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(InitBox,_React$Component);function InitBox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InitBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InitBox.__proto__||Object.getPrototypeOf(InitBox)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'browserBlock',_descriptor,_this),_initDefineProp(_this,'blockUserBrowser',_descriptor2,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InitBox,[{key:'componentDidMount',value:function componentDidMount(){var store=this.props.store;var browserName=store.browser.name;var ver=store.browser.version;if(!Object.keys(__WEBPACK_IMPORTED_MODULE_8__data_browserCompatibility__["a" /* default */]).includes(browserName)){this.blockUserBrowser('browser');}else{if(ver>=__WEBPACK_IMPORTED_MODULE_8__data_browserCompatibility__["a" /* default */][browserName]){//it's fine
}else{this.blockUserBrowser('version');}}}},{key:'render',value:function render(){var _props=this.props,store=_props.store,show=_props.show;return store.screen!=='mobile'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Box,{show:show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,' ',__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FirstPara,{show:show},' ',__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].firstpara,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecondPara,{show:show},' ',__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].secondpara,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Start,{show:show},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompatibilityNote,{show:show},__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].compatibility),!this.browserBlock&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StartButton,{show:show,className:'negative',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BtnLabel,null,'Get started',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null)),onClick:this.props.closeSplash}),this.browserBlock&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockUser,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockContext,null,this.browserBlock==='version'&&'Sorry, this application doesn\'t support your version ('+store.browser.version+') of '+(store.browser.name==='ie'?'Internet Explorer':Object(__WEBPACK_IMPORTED_MODULE_6__utilities_toLowerCase__["b" /* capitalize */])(store.browser.name))+'. Please upgrade to version '+__WEBPACK_IMPORTED_MODULE_8__data_browserCompatibility__["a" /* default */][store.browser.name]+' or greater.',this.browserBlock==='browser'&&'Sorry, this application doesn\'t support '+(store.browser.name==='ie'?'Internet Explorer':'your browser')+' - please visit us using a recent version of Google Chrome, Mozilla Firefox, or Safari!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockAction,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__generic__["a" /* Button */],{className:'negative',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BtnLabel,null,'Back to Children Now'),onClick:function onClick(){window.open('https://childrennow.org');}}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileVer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].firstpara),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].secondpara),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',null,__WEBPACK_IMPORTED_MODULE_9__InitCopy__["a" /* default */].compatibility),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileStartButton,{className:'negative',onClick:this.props.closeSplash,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'Browse data',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchIcon,{img:'searchzoom',color:'white'}))})));}}]);return InitBox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'browserBlock',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'blockUserBrowser',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return function(why){return _this2.browserBlock=why;};}})),_class2))||_class;var dots=__webpack_require__(29);var MobileVer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3);var MobileStartButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__generic__["a" /* Button */])(_templateObject4);var SearchIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_7__generic_Icon__["b" /* default */])(_templateObject5);var Start=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject6,function(props){return props.show?1:0;});var CompatibilityNote=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject7,function(props){return props.show?0:125;});var StartButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__generic__["a" /* Button */])(_templateObject8,function(props){return props.show?0:250;});var BtnLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject9);var arrow=__webpack_require__(192);var Icon=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].figure(_templateObject10,arrow);var BlockUser=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject11);var BlockContext=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].p(_templateObject12);var BlockAction=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject13);var CNButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(StartButton)(_templateObject14);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
    this object has both browsers that we support, as well as the version threshold for proper functioning;
    the numbers can be updated as we polyfill and do workarounds to expand support, as well as
    new keys for browsers (edge being a distinct possibility!) 
    
*/var browserCompatibility={chrome:'62',crios:'62',firefox:'53',safari:'11',edge:'18',ios:'10'};/* harmony default export */ __webpack_exports__["a"] = (browserCompatibility);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_commaNumber__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RaceBreakdownBar__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CountingNumber__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Sources__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_sigFig__ = __webpack_require__(34);
var _templateObject=_taggedTemplateLiteral(['\n        position: absolute;\n        opacity: ',';\n        top: 0;\n        right: 0;\n        @media ','{\n            width: 550px;\n            height: 475px;\n            padding: 35px;\n        }\n        @media ','{\n            padding: 35px;\n            padding-top: 25px;\n            width: 515px;\n            height: 390px;   \n\n        }\n        right: 0;\n        // border: 2px solid var(--bordergrey);\n        z-index: 1;\n        transition: transform .4s, opacity .4s;\n\n    @media ','{\n        position: relative;\n        padding: 0px 15px 100px 15px;\n        width: calc(100vw - 40px);\n        /*height: 500px;*/\n        font-size: 14px;\n        /*border: 1px solid var(--bordergrey);*/\n    }\n'],['\n        position: absolute;\n        opacity: ',';\n        top: 0;\n        right: 0;\n        @media ','{\n            width: 550px;\n            height: 475px;\n            padding: 35px;\n        }\n        @media ','{\n            padding: 35px;\n            padding-top: 25px;\n            width: 515px;\n            height: 390px;   \n\n        }\n        right: 0;\n        // border: 2px solid var(--bordergrey);\n        z-index: 1;\n        transition: transform .4s, opacity .4s;\n\n    @media ','{\n        position: relative;\n        padding: 0px 15px 100px 15px;\n        width: calc(100vw - 40px);\n        /*height: 500px;*/\n        font-size: 14px;\n        /*border: 1px solid var(--bordergrey);*/\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n'],['\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n    width: 100%; height: 100%;\n    fill: none;\n    stroke-width: 2;\n    stroke: var(--bordergrey);\n    pointer-events: none;\n'],['\n    position: absolute;\n    top: 0; left: 0;\n    width: 100%; height: 100%;\n    fill: none;\n    stroke-width: 2;\n    stroke: var(--bordergrey);\n    pointer-events: none;\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: relative;\n    margin: 0;\n    margin-top: 5px;\n    text-align: center;\n    b{\n        font-weight: 500;\n    }\n    white-space: nowrap;\n    @media ','{\n        text-align: left;\n        font-size: 16px;\n        font-weight: 400;\n        b{ font-weight: 600; }\n        letter-spacing: 0.5px;\n        white-space: normal;\n    }\n'],['\n    position: relative;\n    margin: 0;\n    margin-top: 5px;\n    text-align: center;\n    b{\n        font-weight: 500;\n    }\n    white-space: nowrap;\n    @media ','{\n        text-align: left;\n        font-size: 16px;\n        font-weight: 400;\n        b{ font-weight: 600; }\n        letter-spacing: 0.5px;\n        white-space: normal;\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    @media ','{\n        right: 25px; \n        top: 40px;\n        font-size: 16px;\n    }\n    @media ','{\n        right: 30px; \n        top: 32px;\n        font-size: 13px;\n    }\n    color: var(--fainttext);\n'],['\n    position: absolute;\n    @media ','{\n        right: 25px; \n        top: 40px;\n        font-size: 16px;\n    }\n    @media ','{\n        right: 30px; \n        top: 32px;\n        font-size: 13px;\n    }\n    color: var(--fainttext);\n']),_templateObject6=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    margin-top: 25px;\n    margin-right: 15px;\n    @media ','{\n        // padding-right: 20px;\n    }\n    @media ','{\n        align-items: flex-start;\n    }\n\n'],['\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    margin-top: 25px;\n    margin-right: 15px;\n    @media ','{\n        // padding-right: 20px;\n    }\n    @media ','{\n        align-items: flex-start;\n    }\n\n']),_templateObject7=_taggedTemplateLiteral(['\n    position: relative;\n    text-align: right;\n    font-size: 13px;\n\n    @media ','{\n        &:not(:first-of-type){\n            margin-top: 37px;   \n            \n        }\n        padding: 0 20px;\n        /*padding-left: 15px;*/\n        line-height: 160%;\n        &.last{\n            margin-left: 80px;\n            text-indent: -35px;\n        }\n    }\n    @media ','{\n        &:not(:first-of-type){\n            margin-top: 25px;   \n            \n        }\n        padding: 0 20px;\n        line-height: 150%;\n        &.last{\n            width: 210px;\n        }\n    }\n    @media ','{\n        font-size: 14px;\n        letter-spacing: 0.5px;\n        line-height: 19px;\n        text-align: left;\n        &:not(:first-of-type){\n            margin-top: 15px;\n        }\n    }\n\n'],['\n    position: relative;\n    text-align: right;\n    font-size: 13px;\n\n    @media ','{\n        &:not(:first-of-type){\n            margin-top: 37px;   \n            \n        }\n        padding: 0 20px;\n        /*padding-left: 15px;*/\n        line-height: 160%;\n        &.last{\n            margin-left: 80px;\n            text-indent: -35px;\n        }\n    }\n    @media ','{\n        &:not(:first-of-type){\n            margin-top: 25px;   \n            \n        }\n        padding: 0 20px;\n        line-height: 150%;\n        &.last{\n            width: 210px;\n        }\n    }\n    @media ','{\n        font-size: 14px;\n        letter-spacing: 0.5px;\n        line-height: 19px;\n        text-align: left;\n        &:not(:first-of-type){\n            margin-top: 15px;\n        }\n    }\n\n']),_templateObject8=_taggedTemplateLiteral(['\n    margin-left: 5px;\n'],['\n    margin-left: 5px;\n']),_templateObject9=_taggedTemplateLiteral(['\n    display: inline;\n    font-weight: bold;\n'],['\n    display: inline;\n    font-weight: bold;\n']),_templateObject10=_taggedTemplateLiteral(['\n    position: absolute;\n    font-size: 16px;\n    top: 0; right: 0;\n    transform: translateY(-50%);\n    margin-right: 20px;\n    padding: 0 15px;\n    background: var(--offwhitefg);\n    z-index: 2;\n    @media ','{\n        /*position: relative;*/\n        margin-left: 15px;\n        margin-right: 0;\n        right: auto;\n        left: 0;\n        letter-spacing: 0.5px;\n        white-space: nowrap;\n    }\n'],['\n    position: absolute;\n    font-size: 16px;\n    top: 0; right: 0;\n    transform: translateY(-50%);\n    margin-right: 20px;\n    padding: 0 15px;\n    background: var(--offwhitefg);\n    z-index: 2;\n    @media ','{\n        /*position: relative;*/\n        margin-left: 15px;\n        margin-right: 0;\n        right: auto;\n        left: 0;\n        letter-spacing: 0.5px;\n        white-space: nowrap;\n    }\n']),_templateObject11=_taggedTemplateLiteral(['\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n    z-index: 3;\n    @media ','{\n        display: flex;\n        flex-wrap: wrap;\n    }\n'],['\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n    z-index: 3;\n    @media ','{\n        display: flex;\n        flex-wrap: wrap;\n    }\n']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Box=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,function(props){return props.show?1:0;},__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].mobile);var DemoBox=function DemoBox(props){var store=props.store,forceCA=props.forceCA,restOfProps=_objectWithoutProperties(props,['store','forceCA']);var screen=store.screen;var county=forceCA?'':store.county;var pop=county?__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a[county].population:__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a.california.population;var countyLabel=county?__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[county]:'California';var needsAddendum=void 0;if(screen==='mobile'&&countyLabel!=='California'&&countyLabel.includes(' ')){countyLabel+='\xa0county';}else if((countyLabel.length<10||screen==='mobile')&&countyLabel!=='California')countyLabel+=' county';else needsAddendum=true;if(countyLabel==='California')needsAddendum=false;pop=Object(__WEBPACK_IMPORTED_MODULE_11__utilities_sigFig__["a" /* default */])(pop);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Box,Object.assign({id:'demobox'},restOfProps),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,screen!=='mobile'&&'Current '+(county?'county':'state')+' demographics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Population,{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,pop),' children live in\xA0',countyLabel,'.',needsAddendum&&screen!=='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountyAddendum,null,'(county)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,null,screen!=='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DataTable,{store:store}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__RaceBreakdownBar__["a" /* default */],{store:store,forceCA:props.forceCA,width:screen==='mobile'?store.mobileDeviceWidth-72:'idc',height:screen==='optimal'?315:screen==='compact'?275:44}),screen==='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DataTable,{store:store,forceCA:props.forceCA})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StrokeShape,{viewBox:screen==='optimal'?"0 0 515 433":screen==='compact'?"0 0 515 375":"0 0 100 100",preserveAspectRatio:'none'},screen!=='mobile'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',{points:screen==='optimal'?"0,194.85 0,0 515,0 515,433 231.75,433":screen==='compact'?"0,168.75 0,0 515,0 515,375 231.75,375":"0,45 0,0 100,0 100,100 45,100"})));};/* harmony default export */ __webpack_exports__["a"] = (DemoBox);var DemoToggle=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5__generic__["d" /* Toggle */])(_templateObject2);var StrokeShape=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].svg(_templateObject3);var Population=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h1(_templateObject4,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].mobile);var CountyAddendum=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].compact);var DataTable=function DataTable(props){var county=props.forceCA?'':props.store.county;var demo=county?__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a[county]:__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a.california;var place=county?__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[county]:'California';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowTable,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoValue,null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CountingNumber__["a" /* default */],{maxDuration:0.85,number:demo.immigrantFamilies}),' '),'have one or more immigrant parent.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoValue,null,' ',demo.poverty,'% '),'are living at or below 2X the\xA0poverty\xA0level.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoRow,{className:'last'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoValue,null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CountingNumber__["a" /* default */],{maxDuration:0.85,number:Object(__WEBPACK_IMPORTED_MODULE_11__utilities_sigFig__["b" /* rawSigFig */])(demo.homeless)}),' '),'students\xA0experience homelessness.'));};var RowTable=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].mobile);var DemoRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].mobile);var DemoLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject8);var DemoValue=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject9);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].mobile);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject11,__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].mobile);

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(202);

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || (Math.pow(2, 53) - 1);

// eslint-disable-next-line max-params, max-statements
var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var targetIndex = start;
	var sourceIndex = 0;

	/*
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}
	*/

	while (sourceIndex < sourceLen) {
		var P = ES.ToString(sourceIndex);
		var exists = ES.HasProperty(source, P);
		if (exists) {
			var element = ES.Get(source, P);
			/*
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = ES.Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			*/
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = ES.IsArray(element);
			}
			if (shouldFlatten) {
				var elementLen = ES.ToLength(ES.Get(element, 'length'));
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= MAX_SAFE_INTEGER) {
					throw new TypeError('index too large');
				}
				ES.CreateDataPropertyOrThrow(target, ES.ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};

module.exports = function flat() {
	var O = ES.ToObject(this);
	var sourceLen = ES.ToLength(ES.Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ES.ToInteger(arguments[0]);
	}

	var A = ES.ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(63);

module.exports = function getPolyfill() {
	return Array.prototype.flat || implementation;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(43);


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var ES = __webpack_require__(65);
var $isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};
var $isFinite = Number.isFinite || function isFinite(n) {
	return typeof n === 'number' && global.isFinite(n);
};
var indexOf = Array.prototype.indexOf;

module.exports = function includes(searchElement) {
	var fromIndex = arguments.length > 1 ? ES.ToInteger(arguments[1]) : 0;
	if (indexOf && !$isNaN(searchElement) && $isFinite(fromIndex) && typeof searchElement !== 'undefined') {
		return indexOf.apply(this, arguments) > -1;
	}

	var O = ES.ToObject(this);
	var length = ES.ToLength(O.length);
	if (length === 0) {
		return false;
	}
	var k = fromIndex >= 0 ? fromIndex : Math.max(0, length + fromIndex);
	while (k < length) {
		if (ES.SameValueZero(searchElement, O[k])) {
			return true;
		}
		k += 1;
	}
	return false;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(66);

module.exports = function getPolyfill() {
	return Array.prototype.includes || implementation;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69);
module.exports = __webpack_require__(74);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(70).enable();
  window.Promise = __webpack_require__(72);
}

// fetch() polyfill for making API calls.
__webpack_require__(73);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(24);


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(35);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(35);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_css_vars_ponyfill__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_css__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResponsiveScorecard__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
function noop(){}if(true){console.log=noop;console.warn=noop;console.error=noop;}__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ResponsiveScorecard__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();Object(__WEBPACK_IMPORTED_MODULE_2_css_vars_ponyfill__["a" /* default */])();

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(24),n=__webpack_require__(36),p=__webpack_require__(76),q=__webpack_require__(37),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(24),r=__webpack_require__(78);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;pa.hasOwnProperty("ReactCurrentDispatcher")||(pa.ReactCurrentDispatcher={current:null});pa.hasOwnProperty("ReactCurrentBatchConfig")||(pa.ReactCurrentBatchConfig={suspense:null});
var qa=/^(.*)[\\\/]/,v="function"===typeof Symbol&&Symbol.for,ra=v?Symbol.for("react.element"):60103,sa=v?Symbol.for("react.portal"):60106,ta=v?Symbol.for("react.fragment"):60107,ua=v?Symbol.for("react.strict_mode"):60108,va=v?Symbol.for("react.profiler"):60114,wa=v?Symbol.for("react.provider"):60109,xa=v?Symbol.for("react.context"):60110,ya=v?Symbol.for("react.concurrent_mode"):60111,za=v?Symbol.for("react.forward_ref"):60112,Aa=v?Symbol.for("react.suspense"):60113,Ba=v?Symbol.for("react.suspense_list"):
60120,Ca=v?Symbol.for("react.memo"):60115,Da=v?Symbol.for("react.lazy"):60116,Ea=v?Symbol.for("react.block"):60121,Fa="function"===typeof Symbol&&Symbol.iterator;function Ga(a){if(null===a||"object"!==typeof a)return null;a=Fa&&a[Fa]||a["@@iterator"];return"function"===typeof a?a:null}function Ha(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Ia(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ta:return"Fragment";case sa:return"Portal";case va:return"Profiler";case ua:return"StrictMode";case Aa:return"Suspense";case Ba:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case xa:return"Context.Consumer";case wa:return"Context.Provider";case za:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ca:return Ia(a.type);case Ea:return Ia(a.render);case Da:if(a=1===a._status?a._result:null)return Ia(a)}return null}function Ja(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Ia(a.type);c=null;d&&(c=Ia(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(qa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}var Ka=null,La={};
function Ma(){if(Ka)for(var a in La){var b=La[a],c=Ka.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!Na[c]){if(!b.extractEvents)throw Error(u(97,a));Na[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(Oa.hasOwnProperty(h))throw Error(u(99,h));Oa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Pa(k[e],g,h);e=!0}else f.registrationName?(Pa(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function Pa(a,b,c){if(Qa[a])throw Error(u(100,a));Qa[a]=b;Ra[a]=b.eventTypes[c].dependencies}var Na=[],Oa={},Qa={},Ra={};function Sa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!La.hasOwnProperty(c)||La[c]!==d){if(La[c])throw Error(u(102,c));La[c]=d;b=!0}}b&&Ma()}var Ta=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Ua=null,Va=null,Wa=null;
function Xa(a){if(a=ma(a)){if("function"!==typeof Ua)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),Ua(a.stateNode,a.type,b))}}function Ya(a){Va?Wa?Wa.push(a):Wa=[a]:Va=a}function Za(){if(Va){var a=Va,b=Wa;Wa=Va=null;Xa(a);if(b)for(a=0;a<b.length;a++)Xa(b[a])}}function $a(a,b){return a(b)}function ab(a,b,c,d,e){return a(b,c,d,e)}function bb(){}var cb=$a,db=!1,eb=!1;function fb(){if(null!==Va||null!==Wa)bb(),Za()}
function gb(a,b,c){if(eb)return a(b,c);eb=!0;try{return cb(a,b,c)}finally{eb=!1,fb()}}var hb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ib=Object.prototype.hasOwnProperty,jb={},kb={};
function lb(a){if(ib.call(kb,a))return!0;if(ib.call(jb,a))return!1;if(hb.test(a))return kb[a]=!0;jb[a]=!0;return!1}function mb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function nb(a,b,c,d){if(null===b||"undefined"===typeof b||mb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var E={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){E[a]=new C(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];E[b]=new C(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){E[a]=new C(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){E[a]=new C(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){E[a]=new C(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){E[a]=new C(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){E[a]=new C(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){E[a]=new C(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){E[a]=new C(a,5,!1,a.toLowerCase(),null,!1)});var ob=/[\-:]([a-z])/g;function pb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ob,
pb);E[b]=new C(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!1)});
E.xlinkHref=new C("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!0)});
function qb(a,b,c,d){var e=E.hasOwnProperty(b)?E[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(nb(b,c,e,d)&&(c=null),d||null===e?lb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&qb(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
Ta&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!Ta)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<Na.length;k++){var l=Na[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){db||bb();var e=id,f=db;db=!0;try{ab(e,a,b,c,d)}finally{(db=f)||fb()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{gb(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{gb(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=Ra[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=Ta&&"CompositionEvent"in window,ke=null;Ta&&"documentMode"in document&&(ke=document.documentMode);
var le=Ta&&"TextEvent"in window&&!ke,me=Ta&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Ya(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;Ta&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),db)mc(a);else{db=!0;try{$a(Ce,a)}finally{db=!1,fb()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=Ta&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=Ra.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(Ka)throw Error(u(101));Ka=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ma();var xf=Nc;la=Qd;ma=xf;na=Pd;Sa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Ia(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=pa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case ra:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case sa:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
Ga(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ra:return c.key===e?c.type===ta?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case sa:return c.key===e?l(a,b,c,d):null}if(Og(c)||Ga(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case ra:return a=a.get(null===d.key?c:d.key)||null,d.type===ta?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case sa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||Ga(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=Ga(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ta&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ra:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ta){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ta?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case sa:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(Ga(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=pa.ReactCurrentDispatcher,kh=pa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=pa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Qa.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(Qa.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):Qa.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(Qa.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&qb(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:Ja(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Ja(c));null!==c&&Ia(c.type);b=b.value;null!==a&&1===a.tag&&Ia(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):qb(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=pa.ReactCurrentDispatcher,dj=pa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):g.memoizedState=null}var m=0!==
(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;break a}h=void 0;g=b;var A=e.pingCache;
null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((Ia(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Ja(g))}S!==jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=
h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}
function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Ha(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===za)return 11;if(a===Ca)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ta:return Wg(c.children,e,f,b);case ya:g=8;e|=7;break;case ua:g=8;e|=1;break;case va:return a=Sh(12,c,b,e|8),a.elementType=va,a.type=va,a.expirationTime=f,a;case Aa:return a=Sh(13,c,b,e),a.type=Aa,a.elementType=Aa,a.expirationTime=f,a;case Ba:return a=Sh(19,c,b,e),a.elementType=Ba,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case wa:g=
10;break a;case xa:g=9;break a;case za:g=11;break a;case Ca:g=14;break a;case Da:g=16;d=null;break a;case Ea:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:sa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
Ua=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};$a=Mj;
ab=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};bb=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};cb=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,Sa,Oa,Xd,function(a){jc(a,Wd)},Ya,Za,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:pa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.0";


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(79);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * css-vars-ponyfill
 * v1.17.2
 * https://github.com/jhildenbiddle/css-vars-ponyfill
 * (c) 2018-2019 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function _extends() {
    _extends = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
        return arr2;
    }
}

function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/*!
 * get-css-data
 * v1.6.3
 * https://github.com/jhildenbiddle/get-css-data
 * (c) 2018-2019 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */ function getUrls(urls) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var settings = {
        mimeType: options.mimeType || null,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var urlArray = Array.isArray(urls) ? urls : [ urls ];
    var urlQueue = Array.apply(null, Array(urlArray.length)).map(function(x) {
        return null;
    });
    function isValidCss() {
        var cssText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var isHTML = cssText.trim().charAt(0) === "<";
        return !isHTML;
    }
    function onError(xhr, urlIndex) {
        settings.onError(xhr, urlArray[urlIndex], urlIndex);
    }
    function onSuccess(responseText, urlIndex) {
        var returnVal = settings.onSuccess(responseText, urlArray[urlIndex], urlIndex);
        responseText = returnVal === false ? "" : returnVal || responseText;
        urlQueue[urlIndex] = responseText;
        if (urlQueue.indexOf(null) === -1) {
            settings.onComplete(urlQueue);
        }
    }
    var parser = document.createElement("a");
    urlArray.forEach(function(url, i) {
        parser.setAttribute("href", url);
        parser.href = String(parser.href);
        var isIElte9 = Boolean(document.all && !window.atob);
        var isIElte9CORS = isIElte9 && parser.host.split(":")[0] !== location.host.split(":")[0];
        if (isIElte9CORS) {
            var isSameProtocol = parser.protocol === location.protocol;
            if (isSameProtocol) {
                var xdr = new XDomainRequest();
                xdr.open("GET", url);
                xdr.timeout = 0;
                xdr.onprogress = Function.prototype;
                xdr.ontimeout = Function.prototype;
                xdr.onload = function() {
                    if (isValidCss(xdr.responseText)) {
                        onSuccess(xdr.responseText, i);
                    } else {
                        onError(xdr, i);
                    }
                };
                xdr.onerror = function(err) {
                    onError(xdr, i);
                };
                setTimeout(function() {
                    xdr.send();
                }, 0);
            } else {
                console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(url, ")"));
                onError(null, i);
            }
        } else {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url);
            if (settings.mimeType && xhr.overrideMimeType) {
                xhr.overrideMimeType(settings.mimeType);
            }
            settings.onBeforeSend(xhr, url, i);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200 && isValidCss(xhr.responseText)) {
                        onSuccess(xhr.responseText, i);
                    } else {
                        onError(xhr, i);
                    }
                }
            };
            xhr.send();
        }
    });
}

/**
 * Gets CSS data from <style> and <link> nodes (including @imports), then
 * returns data in order processed by DOM. Allows specifying nodes to
 * include/exclude and filtering CSS data using RegEx.
 *
 * @preserve
 * @param {object}   [options] The options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {string}   [options.include] CSS selector matching <link> and <style>
 *                   nodes to include
 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
 *                   nodes to exclude
 * @param {object}   [options.filter] Regular expression used to filter node CSS
 *                   data. Each block of CSS data is tested against the filter,
 *                   and only matching data is included.
 * @param {object}   [options.useCSSOM=false] Determines if CSS data will be
 *                   collected from a stylesheet's runtime values instead of its
 *                   text content. This is required to get accurate CSS data
 *                   when a stylesheet has been modified using the deleteRule()
 *                   or insertRule() methods because these modifications will
 *                   not be reflected in the stylesheet's text content.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
 *                   1) CSS text, 2) source node reference, and 3) the source
 *                   URL as arguments.
 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
 *                   object for inspection, 2) soure node reference, and 3) the
 *                   source URL that failed (either a <link> href or an @import)
 *                   as arguments
 * @param {function} [options.onComplete] Callback after all nodes have been
 *                   processed. Passes 1) concatenated CSS text, 2) an array of
 *                   CSS text in DOM order, and 3) an array of nodes in DOM
 *                   order as arguments.
 *
 * @example
 *
 *   getCssData({
 *     rootElement: document,
 *     include    : 'style,link[rel="stylesheet"]',
 *     exclude    : '[href="skip.css"]',
 *     filter     : /red/,
 *     useCSSOM   : false,
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     }
 *     onError(xhr, node, url) {
 *       // ...
 *     },
 *     onComplete(cssText, cssArray, nodeArray) {
 *       // ...
 *     }
 *   });
 */ function getCssData(options) {
    var regex = {
        cssComments: /\/\*[\s\S]+?\*\//g,
        cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
    };
    var settings = {
        rootElement: options.rootElement || document,
        include: options.include || 'style,link[rel="stylesheet"]',
        exclude: options.exclude || null,
        filter: options.filter || null,
        useCSSOM: options.useCSSOM || false,
        onBeforeSend: options.onBeforeSend || Function.prototype,
        onSuccess: options.onSuccess || Function.prototype,
        onError: options.onError || Function.prototype,
        onComplete: options.onComplete || Function.prototype
    };
    var sourceNodes = Array.apply(null, settings.rootElement.querySelectorAll(settings.include)).filter(function(node) {
        return !matchesSelector(node, settings.exclude);
    });
    var cssArray = Array.apply(null, Array(sourceNodes.length)).map(function(x) {
        return null;
    });
    function handleComplete() {
        var isComplete = cssArray.indexOf(null) === -1;
        if (isComplete) {
            var cssText = cssArray.join("");
            settings.onComplete(cssText, cssArray, sourceNodes);
        }
    }
    function handleSuccess(cssText, cssIndex, node, sourceUrl) {
        var returnVal = settings.onSuccess(cssText, node, sourceUrl);
        cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
        resolveImports(cssText, node, sourceUrl, function(resolvedCssText, errorData) {
            if (cssArray[cssIndex] === null) {
                errorData.forEach(function(data) {
                    return settings.onError(data.xhr, node, data.url);
                });
                if (!settings.filter || settings.filter.test(resolvedCssText)) {
                    cssArray[cssIndex] = resolvedCssText;
                } else {
                    cssArray[cssIndex] = "";
                }
                handleComplete();
            }
        });
    }
    function parseImportData(cssText, baseUrl) {
        var ignoreRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var importData = {};
        importData.rules = (cssText.replace(regex.cssComments, "").match(regex.cssImports) || []).filter(function(rule) {
            return ignoreRules.indexOf(rule) === -1;
        });
        importData.urls = importData.rules.map(function(rule) {
            return rule.replace(regex.cssImports, "$1");
        });
        importData.absoluteUrls = importData.urls.map(function(url) {
            return getFullUrl(url, baseUrl);
        });
        importData.absoluteRules = importData.rules.map(function(rule, i) {
            var oldUrl = importData.urls[i];
            var newUrl = getFullUrl(importData.absoluteUrls[i], baseUrl);
            return rule.replace(oldUrl, newUrl);
        });
        return importData;
    }
    function resolveImports(cssText, node, baseUrl, callbackFn) {
        var __errorData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var __errorRules = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var importData = parseImportData(cssText, baseUrl, __errorRules);
        if (importData.rules.length) {
            getUrls(importData.absoluteUrls, {
                onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                    settings.onBeforeSend(xhr, node, url);
                },
                onSuccess: function onSuccess(cssText, url, urlIndex) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal === false ? "" : returnVal || cssText;
                    var responseImportData = parseImportData(cssText, url, __errorRules);
                    responseImportData.rules.forEach(function(rule, i) {
                        cssText = cssText.replace(rule, responseImportData.absoluteRules[i]);
                    });
                    return cssText;
                },
                onError: function onError(xhr, url, urlIndex) {
                    __errorData.push({
                        xhr: xhr,
                        url: url
                    });
                    __errorRules.push(importData.rules[urlIndex]);
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                },
                onComplete: function onComplete(responseArray) {
                    responseArray.forEach(function(importText, i) {
                        cssText = cssText.replace(importData.rules[i], importText);
                    });
                    resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
                }
            });
        } else {
            callbackFn(cssText, __errorData);
        }
    }
    if (sourceNodes.length) {
        sourceNodes.forEach(function(node, i) {
            var linkHref = node.getAttribute("href");
            var linkRel = node.getAttribute("rel");
            var isLink = node.nodeName === "LINK" && linkHref && linkRel && linkRel.toLowerCase() === "stylesheet";
            var isStyle = node.nodeName === "STYLE";
            if (isLink) {
                getUrls(linkHref, {
                    mimeType: "text/css",
                    onBeforeSend: function onBeforeSend(xhr, url, urlIndex) {
                        settings.onBeforeSend(xhr, node, url);
                    },
                    onSuccess: function onSuccess(cssText, url, urlIndex) {
                        var sourceUrl = getFullUrl(linkHref, location.href);
                        handleSuccess(cssText, i, node, sourceUrl);
                    },
                    onError: function onError(xhr, url, urlIndex) {
                        cssArray[i] = "";
                        settings.onError(xhr, node, url);
                        handleComplete();
                    }
                });
            } else if (isStyle) {
                var cssText = node.textContent;
                if (settings.useCSSOM) {
                    cssText = Array.apply(null, node.sheet.cssRules).map(function(rule) {
                        return rule.cssText;
                    }).join("");
                }
                handleSuccess(cssText, i, node, location.href);
            } else {
                cssArray[i] = "";
                handleComplete();
            }
        });
    } else {
        settings.onComplete("", []);
    }
}

function getFullUrl(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

function matchesSelector(elm, selector) {
    var matches = elm.matches || elm.matchesSelector || elm.webkitMatchesSelector || elm.mozMatchesSelector || elm.msMatchesSelector || elm.oMatchesSelector;
    return matches.call(elm, selector);
}

var balancedMatch = balanced;

function balanced(a, b, str) {
    if (a instanceof RegExp) a = maybeMatch(a, str);
    if (b instanceof RegExp) b = maybeMatch(b, str);
    var r = range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}

function maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}

balanced.range = range;

function range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        begs = [];
        left = str.length;
        while (i >= 0 && !result) {
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) {
                result = [ begs.pop(), bi ];
            } else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) {
            result = [ left, right ];
        }
    }
    return result;
}

function parseCss(css) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        onlyVars: false,
        removeComments: false
    };
    var settings = _extends({}, defaults, options);
    var errors = [];
    function error(msg) {
        throw new Error("CSS parse error: ".concat(msg));
    }
    function match(re) {
        var m = re.exec(css);
        if (m) {
            css = css.slice(m[0].length);
            return m;
        }
    }
    function open() {
        return match(/^{\s*/);
    }
    function close() {
        return match(/^}/);
    }
    function whitespace() {
        match(/^\s*/);
    }
    function comment() {
        whitespace();
        if (css[0] !== "/" || css[1] !== "*") {
            return;
        }
        var i = 2;
        while (css[i] && (css[i] !== "*" || css[i + 1] !== "/")) {
            i++;
        }
        if (!css[i]) {
            return error("end of comment is missing");
        }
        var str = css.slice(2, i);
        css = css.slice(i + 2);
        return {
            type: "comment",
            comment: str
        };
    }
    function comments() {
        var cmnts = [];
        var c;
        while (c = comment()) {
            cmnts.push(c);
        }
        return settings.removeComments ? [] : cmnts;
    }
    function selector() {
        whitespace();
        while (css[0] === "}") {
            error("extra closing bracket");
        }
        var m = match(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
        if (m) {
            return m[0].trim().replace(/\/\*([^*]|[\r\n]|(\*+([^*\/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(m) {
                return m.replace(/,/g, "‌");
            }).split(/\s*(?![^(]*\)),\s*/).map(function(s) {
                return s.replace(/\u200C/g, ",");
            });
        }
    }
    function declaration() {
        match(/^([;\s]*)+/);
        var comment_regexp = /\/\*[^*]*\*+([^\/*][^*]*\*+)*\//g;
        var prop = match(/^(\*?[-#\/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
        if (!prop) {
            return;
        }
        prop = prop[0].trim();
        if (!match(/^:\s*/)) {
            return error("property missing ':'");
        }
        var val = match(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/);
        var ret = {
            type: "declaration",
            property: prop.replace(comment_regexp, ""),
            value: val ? val[0].replace(comment_regexp, "").trim() : ""
        };
        match(/^[;\s]*/);
        return ret;
    }
    function declarations() {
        if (!open()) {
            return error("missing '{'");
        }
        var d;
        var decls = comments();
        while (d = declaration()) {
            decls.push(d);
            decls = decls.concat(comments());
        }
        if (!close()) {
            return error("missing '}'");
        }
        return decls;
    }
    function keyframe() {
        whitespace();
        var vals = [];
        var m;
        while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
            vals.push(m[1]);
            match(/^,\s*/);
        }
        if (vals.length) {
            return {
                type: "keyframe",
                values: vals,
                declarations: declarations()
            };
        }
    }
    function at_keyframes() {
        var m = match(/^@([-\w]+)?keyframes\s*/);
        if (!m) {
            return;
        }
        var vendor = m[1];
        m = match(/^([-\w]+)\s*/);
        if (!m) {
            return error("@keyframes missing name");
        }
        var name = m[1];
        if (!open()) {
            return error("@keyframes missing '{'");
        }
        var frame;
        var frames = comments();
        while (frame = keyframe()) {
            frames.push(frame);
            frames = frames.concat(comments());
        }
        if (!close()) {
            return error("@keyframes missing '}'");
        }
        return {
            type: "keyframes",
            name: name,
            vendor: vendor,
            keyframes: frames
        };
    }
    function at_page() {
        var m = match(/^@page */);
        if (m) {
            var sel = selector() || [];
            return {
                type: "page",
                selectors: sel,
                declarations: declarations()
            };
        }
    }
    function at_fontface() {
        var m = match(/^@font-face\s*/);
        if (m) {
            return {
                type: "font-face",
                declarations: declarations()
            };
        }
    }
    function at_supports() {
        var m = match(/^@supports *([^{]+)/);
        if (m) {
            return {
                type: "supports",
                supports: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_host() {
        var m = match(/^@host\s*/);
        if (m) {
            return {
                type: "host",
                rules: rules()
            };
        }
    }
    function at_media() {
        var m = match(/^@media *([^{]+)/);
        if (m) {
            return {
                type: "media",
                media: m[1].trim(),
                rules: rules()
            };
        }
    }
    function at_custom_m() {
        var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
        if (m) {
            return {
                type: "custom-media",
                name: m[1].trim(),
                media: m[2].trim()
            };
        }
    }
    function at_document() {
        var m = match(/^@([-\w]+)?document *([^{]+)/);
        if (m) {
            return {
                type: "document",
                document: m[2].trim(),
                vendor: m[1] ? m[1].trim() : null,
                rules: rules()
            };
        }
    }
    function at_x() {
        var m = match(/^@(import|charset|namespace)\s*([^;]+);/);
        if (m) {
            return {
                type: m[1],
                name: m[2].trim()
            };
        }
    }
    function at_rule() {
        whitespace();
        if (css[0] === "@") {
            var ret = at_keyframes() || at_supports() || at_host() || at_media() || at_custom_m() || at_page() || at_document() || at_fontface() || at_x();
            if (ret && settings.onlyVars) {
                var hasVarFunc = false;
                if (ret.declarations) {
                    hasVarFunc = ret.declarations.some(function(decl) {
                        return /var\(/.test(decl.value);
                    });
                } else {
                    var arr = ret.keyframes || ret.rules || [];
                    hasVarFunc = arr.some(function(obj) {
                        return (obj.declarations || []).some(function(decl) {
                            return /var\(/.test(decl.value);
                        });
                    });
                }
                return hasVarFunc ? ret : {};
            }
            return ret;
        }
    }
    function rule() {
        if (settings.onlyVars) {
            var balancedMatch$$1 = balancedMatch("{", "}", css);
            if (balancedMatch$$1) {
                var hasVarDecl = balancedMatch$$1.pre.indexOf(":root") !== -1 && /--\S*\s*:/.test(balancedMatch$$1.body);
                var hasVarFunc = /var\(/.test(balancedMatch$$1.body);
                if (!hasVarDecl && !hasVarFunc) {
                    css = css.slice(balancedMatch$$1.end + 1);
                    return {};
                }
            }
        }
        var sel = selector() || [];
        var decls = !settings.onlyVars ? declarations() : declarations().filter(function(decl) {
            var hasVarDecl = sel.some(function(s) {
                return s.indexOf(":root") !== -1;
            }) && /^--\S/.test(decl.property);
            var hasVarFunc = /var\(/.test(decl.value);
            return hasVarDecl || hasVarFunc;
        });
        if (!sel.length) {
            error("selector missing");
        }
        return {
            type: "rule",
            selectors: sel,
            declarations: decls
        };
    }
    function rules(core) {
        if (!core && !open()) {
            return error("missing '{'");
        }
        var node;
        var rules = comments();
        while (css.length && (core || css[0] !== "}") && (node = at_rule() || rule())) {
            if (node.type) {
                rules.push(node);
            }
            rules = rules.concat(comments());
        }
        if (!core && !close()) {
            return error("missing '}'");
        }
        return rules;
    }
    return {
        type: "stylesheet",
        stylesheet: {
            rules: rules(true),
            errors: errors
        }
    };
}

function stringifyCss(tree) {
    var delim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var renderMethods = {
        charset: function charset(node) {
            return "@charset " + node.name + ";";
        },
        comment: function comment(node) {
            return node.comment.indexOf("__CSSVARSPONYFILL") === 0 ? "/*" + node.comment + "*/" : "";
        },
        "custom-media": function customMedia(node) {
            return "@custom-media " + node.name + " " + node.media + ";";
        },
        declaration: function declaration(node) {
            return node.property + ":" + node.value + ";";
        },
        document: function document(node) {
            return "@" + (node.vendor || "") + "document " + node.document + "{" + visit(node.rules) + "}";
        },
        "font-face": function fontFace(node) {
            return "@font-face" + "{" + visit(node.declarations) + "}";
        },
        host: function host(node) {
            return "@host" + "{" + visit(node.rules) + "}";
        },
        import: function _import(node) {
            return "@import " + node.name + ";";
        },
        keyframe: function keyframe(node) {
            return node.values.join(",") + "{" + visit(node.declarations) + "}";
        },
        keyframes: function keyframes(node) {
            return "@" + (node.vendor || "") + "keyframes " + node.name + "{" + visit(node.keyframes) + "}";
        },
        media: function media(node) {
            return "@media " + node.media + "{" + visit(node.rules) + "}";
        },
        namespace: function namespace(node) {
            return "@namespace " + node.name + ";";
        },
        page: function page(node) {
            return "@page " + (node.selectors.length ? node.selectors.join(", ") : "") + "{" + visit(node.declarations) + "}";
        },
        rule: function rule(node) {
            var decls = node.declarations;
            if (decls.length) {
                return node.selectors.join(",") + "{" + visit(decls) + "}";
            }
        },
        supports: function supports(node) {
            return "@supports " + node.supports + "{" + visit(node.rules) + "}";
        }
    };
    function visit(nodes) {
        var buf = "";
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (cb) {
                cb(n);
            }
            var txt = renderMethods[n.type](n);
            if (txt) {
                buf += txt;
                if (txt.length && n.selectors) {
                    buf += delim;
                }
            }
        }
        return buf;
    }
    return visit(tree.stylesheet.rules);
}

function walkCss(node, fn) {
    node.rules.forEach(function(rule) {
        if (rule.rules) {
            walkCss(rule, fn);
            return;
        }
        if (rule.keyframes) {
            rule.keyframes.forEach(function(keyframe) {
                if (keyframe.type === "keyframe") {
                    fn(keyframe.declarations, rule);
                }
            });
            return;
        }
        if (!rule.declarations) {
            return;
        }
        fn(rule.declarations, node);
    });
}

var VAR_PROP_IDENTIFIER = "--";

var VAR_FUNC_IDENTIFIER = "var";

var variableStore = {
    dom: {},
    temp: {},
    user: {}
};

function transformVars(cssText) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var defaults = {
        fixNestedCalc: true,
        onlyVars: false,
        persist: false,
        preserve: false,
        variables: {},
        onWarning: function onWarning() {}
    };
    var settings = _extends({}, defaults, options);
    var map = settings.persist ? variableStore.dom : variableStore.temp = JSON.parse(JSON.stringify(variableStore.dom));
    var cssTree = parseCss(cssText, {
        onlyVars: settings.onlyVars
    });
    cssTree.stylesheet.rules.forEach(function(rule) {
        var varNameIndices = [];
        if (rule.type !== "rule") {
            return;
        }
        if (rule.selectors.length !== 1 || rule.selectors[0] !== ":root") {
            return;
        }
        rule.declarations.forEach(function(decl, i) {
            var prop = decl.property;
            var value = decl.value;
            if (prop && prop.indexOf(VAR_PROP_IDENTIFIER) === 0) {
                map[prop] = value;
                varNameIndices.push(i);
            }
        });
        if (!settings.preserve) {
            for (var i = varNameIndices.length - 1; i >= 0; i--) {
                rule.declarations.splice(varNameIndices[i], 1);
            }
        }
    });
    Object.keys(variableStore.user).forEach(function(key) {
        map[key] = variableStore.user[key];
    });
    if (Object.keys(settings.variables).length) {
        var newRule = {
            declarations: [],
            selectors: [ ":root" ],
            type: "rule"
        };
        Object.keys(settings.variables).forEach(function(key) {
            var prop = "--".concat(key.replace(/^-+/, ""));
            var value = settings.variables[key];
            if (settings.persist) {
                variableStore.user[prop] = value;
            }
            if (map[prop] !== value) {
                map[prop] = value;
                newRule.declarations.push({
                    type: "declaration",
                    property: prop,
                    value: value
                });
            }
        });
        if (settings.preserve && newRule.declarations.length) {
            cssTree.stylesheet.rules.push(newRule);
        }
    }
    walkCss(cssTree.stylesheet, function(declarations, node) {
        var decl;
        var resolvedValue;
        var value;
        for (var i = 0; i < declarations.length; i++) {
            decl = declarations[i];
            value = decl.value;
            if (decl.type !== "declaration") {
                continue;
            }
            if (!value || value.indexOf(VAR_FUNC_IDENTIFIER + "(") === -1) {
                continue;
            }
            resolvedValue = resolveValue(value, map, settings);
            if (resolvedValue !== decl.value) {
                if (!settings.preserve) {
                    decl.value = resolvedValue;
                } else {
                    declarations.splice(i, 0, {
                        type: decl.type,
                        property: decl.property,
                        value: resolvedValue
                    });
                    i++;
                }
            }
        }
    });
    if (settings.fixNestedCalc) {
        fixNestedCalc(cssTree.stylesheet.rules);
    }
    return stringifyCss(cssTree);
}

function fixNestedCalc(rules) {
    var reCalcExp = /(-[a-z]+-)?calc\(/;
    rules.forEach(function(rule) {
        if (rule.declarations) {
            rule.declarations.forEach(function(decl) {
                var oldValue = decl.value;
                var newValue = "";
                while (reCalcExp.test(oldValue)) {
                    var rootCalc = balancedMatch("calc(", ")", oldValue || "");
                    oldValue = oldValue.slice(rootCalc.end);
                    while (reCalcExp.test(rootCalc.body)) {
                        var nestedCalc = balancedMatch(reCalcExp, ")", rootCalc.body);
                        rootCalc.body = "".concat(nestedCalc.pre, "(").concat(nestedCalc.body, ")").concat(nestedCalc.post);
                    }
                    newValue += "".concat(rootCalc.pre, "calc(").concat(rootCalc.body);
                    newValue += !reCalcExp.test(oldValue) ? ")".concat(rootCalc.post) : "";
                }
                decl.value = newValue || decl.value;
            });
        }
    });
}

function resolveValue(value, map) {
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var __recursiveFallback = arguments.length > 3 ? arguments[3] : undefined;
    if (value.indexOf("var(") === -1) {
        return value;
    }
    var valueData = balancedMatch("(", ")", value);
    function resolveFunc(value) {
        var name = value.split(",")[0].replace(/[\s\n\t]/g, "");
        var fallback = (value.match(/(?:\s*,\s*){1}(.*)?/) || [])[1];
        var match = map.hasOwnProperty(name) ? String(map[name]) : undefined;
        var replacement = match || (fallback ? String(fallback) : undefined);
        var unresolvedFallback = __recursiveFallback || value;
        if (!match) {
            settings.onWarning('variable "'.concat(name, '" is undefined'));
        }
        if (replacement && replacement !== "undefined" && replacement.length > 0) {
            return resolveValue(replacement, map, settings, unresolvedFallback);
        } else {
            return "var(".concat(unresolvedFallback, ")");
        }
    }
    if (!valueData) {
        if (value.indexOf("var(") !== -1) {
            settings.onWarning('missing closing ")" in the value "'.concat(value, '"'));
        }
        return value;
    } else if (valueData.pre.slice(-3) === "var") {
        var isEmptyVarFunc = valueData.body.trim().length === 0;
        if (isEmptyVarFunc) {
            settings.onWarning("var() must contain a non-whitespace string");
            return value;
        } else {
            return valueData.pre.slice(0, -3) + resolveFunc(valueData.body) + resolveValue(valueData.post, map, settings);
        }
    } else {
        return valueData.pre + "(".concat(resolveValue(valueData.body, map, settings), ")") + resolveValue(valueData.post, map, settings);
    }
}

var name = "css-vars-ponyfill";

var isBrowser = typeof window !== "undefined";

var isNativeSupport = isBrowser && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)");

var consoleMsgPrefix = "cssVars(): ";

var defaults = {
    rootElement: isBrowser ? document : null,
    shadowDOM: false,
    include: "style,link[rel=stylesheet]",
    exclude: "",
    variables: {},
    fixNestedCalc: true,
    onlyLegacy: true,
    onlyVars: false,
    preserve: false,
    silent: false,
    updateDOM: true,
    updateURLs: true,
    watch: null,
    onBeforeSend: function onBeforeSend() {},
    onSuccess: function onSuccess() {},
    onWarning: function onWarning() {},
    onError: function onError() {},
    onComplete: function onComplete() {}
};

var regex = {
    cssComments: /\/\*[\s\S]+?\*\//g,
    cssKeyframes: /@(?:-\w*-)?keyframes/,
    cssRootRules: /(?::root\s*{\s*[^}]*})/g,
    cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
    cssVars: /(?:(?::root\s*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
};

var cssVarsObserver = null;

var debounceTimer = null;

var isShadowDOMReady = false;

/**
 * Fetches, parses, and transforms CSS custom properties from specified
 * <style> and <link> elements into static values, then appends a new <style>
 * element with static values to the DOM to provide CSS custom property
 * compatibility for legacy browsers. Also provides a single interface for
 * live updates of runtime values in both modern and legacy browsers.
 *
 * @preserve
 * @param {object}   [options] Options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {boolean}  [options.shadowDOM=false] Determines if shadow DOM <link>
 *                   and <style> nodes will be processed.
 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
 *                   matching <link re="stylesheet"> and <style> nodes to
 *                   process
 * @param {string}   [options.exclude] CSS selector matching <link
 *                   rel="stylehseet"> and <style> nodes to exclude from those
 *                   matches by options.include
 * @param {object}   [options.variables] A map of custom property name/value
 *                   pairs. Property names can omit or include the leading
 *                   double-hyphen (—), and values specified will override
 *                   previous values.
 * @param {boolean}  [options.fixNestedCalc=true] Removes nested 'calc' keywords
 *                   for legacy browser compatibility.
 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
 *                   only generate legacy-compatible CSS in browsers that lack
 *                   native support (i.e., legacy browsers)
 * @param {boolean}  [options.onlyVars=false] Determines if CSS rulesets and
 *                   declarations without a custom property value should be
 *                   removed from the ponyfill-generated CSS
 * @param {boolean}  [options.preserve=false] Determines if the original CSS
 *                   custom property declaration will be retained in the
 *                   ponyfill-generated CSS.
 * @param {boolean}  [options.silent=false] Determines if warning and error
 *                   messages will be displayed on the console
 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
 *                   update the DOM after processing CSS custom properties
 * @param {boolean}  [options.updateURLs=true] Determines if the ponyfill will
 *                   convert relative url() paths to absolute urls.
 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
 *                   be created that will execute the ponyfill when a <link> or
 *                   <style> DOM mutation is observed.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback after CSS data has been
 *                   collected from each node and before CSS custom properties
 *                   have been transformed. Allows modifying the CSS data before
 *                   it is transformed by returning any string value (or false
 *                   to skip). Passes 1) CSS text, 2) source node reference, and
 *                   3) the source URL as arguments.
 * @param {function} [options.onWarning] Callback after each CSS parsing warning
 *                   has occurred. Passes 1) a warning message as an argument.
 * @param {function} [options.onError] Callback after a CSS parsing error has
 *                   occurred or an XHR request has failed. Passes 1) an error
 *                   message, and 2) source node reference, 3) xhr, and 4 url as
 *                   arguments.
 * @param {function} [options.onComplete] Callback after all CSS has been
 *                   processed, legacy-compatible CSS has been generated, and
 *                   (optionally) the DOM has been updated. Passes 1) a CSS
 *                   string with CSS variable values resolved, 2) a reference to
 *                   the appended <style> node, 3) an object containing all
 *                   custom properies names and values, and 4) the ponyfill
 *                   execution time in milliseconds.
 *
 * @example
 *
 *   cssVars({
 *     rootElement  : document,
 *     shadowDOM    : false,
 *     include      : 'style,link[rel="stylesheet"]',
 *     exclude      : '',
 *     variables    : {},
 *     fixNestedCalc: true,
 *     onlyLegacy   : true,
 *     onlyVars     : false,
 *     preserve     : false,
 *     silent       : false,
 *     updateDOM    : true,
 *     updateURLs   : true,
 *     watch        : false,
 *     onBeforeSend(xhr, node, url) {},
 *     onSuccess(cssText, node, url) {},
 *     onWarning(message) {},
 *     onError(message, node, xhr, url) {},
 *     onComplete(cssText, styleNode, cssVariables, benchmark) {}
 *   });
 */ function cssVars() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var settings = _extends({}, defaults, options);
    var styleNodeId = name;
    settings.exclude = "#".concat(styleNodeId) + (settings.exclude ? ",".concat(settings.exclude) : "");
    settings._benchmark = !settings._benchmark ? getTimeStamp() : settings._benchmark;
    function handleError(message, sourceNode, xhr, url) {
        if (!settings.silent) {
            console.error("".concat(consoleMsgPrefix).concat(message, "\n"), sourceNode);
        }
        settings.onError(message, sourceNode, xhr, url);
    }
    function handleWarning(message) {
        if (!settings.silent) {
            console.warn("".concat(consoleMsgPrefix).concat(message));
        }
        settings.onWarning(message);
    }
    if (!isBrowser) {
        return;
    }
    if (settings.watch === false && cssVarsObserver) {
        cssVarsObserver.disconnect();
    }
    if (settings.watch) {
        addMutationObserver(settings, styleNodeId);
        cssVarsDebounced(settings);
    } else if (document.readyState !== "loading") {
        var isShadowElm = settings.shadowDOM || settings.rootElement.shadowRoot || settings.rootElement.host;
        if (isNativeSupport && settings.onlyLegacy) {
            if (settings.updateDOM) {
                var targetElm = settings.rootElement.host || (settings.rootElement === document ? document.documentElement : settings.rootElement);
                Object.keys(settings.variables).forEach(function(key) {
                    var prop = "--".concat(key.replace(/^-+/, ""));
                    var value = settings.variables[key];
                    targetElm.style.setProperty(prop, value);
                });
            }
        } else if (isShadowElm && !isShadowDOMReady) {
            getCssData({
                rootElement: defaults.rootElement,
                include: defaults.include,
                exclude: settings.exclude,
                onSuccess: function onSuccess(cssText, node, url) {
                    var cssRootDecls = (cssText.match(regex.cssRootRules) || []).join("");
                    return cssRootDecls || false;
                },
                onComplete: function onComplete(cssText, cssArray, nodeArray) {
                    transformVars(cssText, {
                        persist: true
                    });
                    isShadowDOMReady = true;
                    cssVars(settings);
                }
            });
        } else {
            getCssData({
                rootElement: settings.rootElement,
                include: settings.include,
                exclude: settings.exclude,
                filter: settings.onlyVars ? regex.cssVars : null,
                onBeforeSend: settings.onBeforeSend,
                onSuccess: function onSuccess(cssText, node, url) {
                    var returnVal = settings.onSuccess(cssText, node, url);
                    cssText = returnVal !== undefined && Boolean(returnVal) === false ? "" : returnVal || cssText;
                    node.setAttribute("data-cssvars", "");
                    if (settings.updateURLs) {
                        var cssUrls = cssText.replace(regex.cssComments, "").match(regex.cssUrls) || [];
                        cssUrls.forEach(function(cssUrl) {
                            var oldUrl = cssUrl.replace(regex.cssUrls, "$1");
                            var newUrl = getFullUrl$1(oldUrl, url);
                            cssText = cssText.replace(cssUrl, cssUrl.replace(oldUrl, newUrl));
                        });
                    }
                    return cssText;
                },
                onError: function onError(xhr, node, url) {
                    var responseUrl = xhr.responseURL || getFullUrl$1(url, location.href);
                    var statusText = xhr.statusText ? "(".concat(xhr.statusText, ")") : "Unspecified Error" + (xhr.status === 0 ? " (possibly CORS related)" : "");
                    var errorMsg = "CSS XHR Error: ".concat(responseUrl, " ").concat(xhr.status, " ").concat(statusText);
                    handleError(errorMsg, node, xhr, responseUrl);
                },
                onComplete: function onComplete(cssText, cssArray, nodeArray) {
                    var cssMarker = /\/\*__CSSVARSPONYFILL-(\d+)__\*\//g;
                    var cssSettings = JSON.stringify({
                        include: settings.include,
                        exclude: settings.exclude,
                        variables: settings.variables,
                        fixNestedCalc: settings.fixNestedCalc,
                        onlyVars: settings.onlyVars,
                        preserve: settings.preserve,
                        silent: settings.silent,
                        updateURLs: settings.updateURLs
                    });
                    var styleNode = settings.rootElement.querySelector("#".concat(styleNodeId)) || document.createElement("style");
                    var prevData = styleNode.__cssVars || {};
                    var isSameData = prevData.cssText === cssText && prevData.settings === cssSettings;
                    var hasKeyframesWithVars;
                    if (isSameData) {
                        cssText = styleNode.textContent;
                        if (!settings.silent) {
                            console.info("".concat(consoleMsgPrefix, "No changes"), styleNode);
                        }
                    } else {
                        styleNode.__cssVars = {
                            cssText: cssText,
                            settings: cssSettings
                        };
                        cssText = cssArray.map(function(css, i) {
                            return regex.cssVars.test(css) ? css : "/*__CSSVARSPONYFILL-".concat(i, "__*/");
                        }).join("");
                        try {
                            cssText = transformVars(cssText, {
                                fixNestedCalc: settings.fixNestedCalc,
                                onlyVars: settings.onlyVars,
                                persist: settings.updateDOM,
                                preserve: settings.preserve,
                                variables: settings.variables,
                                onWarning: handleWarning
                            });
                            hasKeyframesWithVars = regex.cssKeyframes.test(cssText);
                            cssText = cssText.replace(cssMarker, function(match, group1) {
                                return cssArray[group1];
                            });
                        } catch (err) {
                            var errorThrown = false;
                            cssArray.forEach(function(cssText, i) {
                                try {
                                    cssText = transformVars(cssText, settings);
                                } catch (err) {
                                    var errorNode = nodeArray[i - 0];
                                    errorThrown = true;
                                    handleError(err.message, errorNode);
                                }
                            });
                            if (!errorThrown) {
                                handleError(err.message || err);
                            }
                        }
                    }
                    if (settings.shadowDOM) {
                        var elms = [ settings.rootElement ].concat(_toConsumableArray(settings.rootElement.querySelectorAll("*")));
                        for (var i = 0, elm; elm = elms[i]; ++i) {
                            if (elm.shadowRoot && elm.shadowRoot.querySelector("style")) {
                                var shadowSettings = _extends({}, settings, {
                                    rootElement: elm.shadowRoot,
                                    variables: variableStore.dom
                                });
                                cssVars(shadowSettings);
                            }
                        }
                    }
                    if (!isSameData && nodeArray && nodeArray.length) {
                        var cssNodes = settings.rootElement.querySelectorAll("link[data-cssvars],style[data-cssvars]") || settings.rootElement.querySelectorAll('link[rel+="stylesheet"],style');
                        var lastNode = cssNodes ? cssNodes[cssNodes.length - 1] : null;
                        if (lastNode) {
                            lastNode.parentNode.insertBefore(styleNode, lastNode.nextSibling);
                        } else {
                            var targetNode = settings.rootElement.head || settings.rootElement.body || settings.rootElement;
                            targetNode.appendChild(styleNode);
                        }
                        if (settings.updateDOM) {
                            styleNode.setAttribute("id", styleNodeId);
                            styleNode.textContent = cssText;
                            if (hasKeyframesWithVars) {
                                fixKeyframes(settings.rootElement);
                            }
                        }
                        settings.onComplete(cssText, styleNode, JSON.parse(JSON.stringify(settings.updateDOM ? variableStore.dom : variableStore.temp)), getTimeStamp() - settings._benchmark);
                    }
                }
            });
        }
    } else {
        document.addEventListener("DOMContentLoaded", function init(evt) {
            cssVars(options);
            document.removeEventListener("DOMContentLoaded", init);
        });
    }
}

function cssVarsDebounced(settings) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
        settings._benchmark = null;
        cssVars(settings);
    }, 100);
}

function addMutationObserver(settings, ignoreId) {
    if (!window.MutationObserver) {
        return;
    }
    var isLink = function isLink(node) {
        return node.tagName === "LINK" && (node.getAttribute("rel") || "").indexOf("stylesheet") !== -1;
    };
    var isStyle = function isStyle(node) {
        return node.tagName === "STYLE" && (ignoreId ? node.id !== ignoreId : true);
    };
    if (cssVarsObserver) {
        cssVarsObserver.disconnect();
    }
    settings.watch = defaults.watch;
    cssVarsObserver = new MutationObserver(function(mutations) {
        var hasCSSMutation = mutations.some(function(mutation) {
            var isCSSMutation = false;
            if (mutation.type === "attributes") {
                isCSSMutation = isLink(mutation.target) || isStyle(mutation.target);
            } else if (mutation.type === "childList") {
                var addedNodes = Array.apply(null, mutation.addedNodes);
                var removedNodes = Array.apply(null, mutation.removedNodes);
                isCSSMutation = [].concat(addedNodes, removedNodes).some(function(node) {
                    var isValidLink = isLink(node) && !node.disabled;
                    var isValidStyle = isStyle(node) && regex.cssVars.test(node.textContent);
                    return isValidLink || isValidStyle;
                });
            }
            return isCSSMutation;
        });
        if (hasCSSMutation) {
            cssVarsDebounced(settings);
        }
    });
    cssVarsObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [ "disabled", "href" ],
        childList: true,
        subtree: true
    });
}

function fixKeyframes(rootElement) {
    var animationNameProp = [ "animation-name", "-moz-animation-name", "-webkit-animation-name" ].filter(function(prop) {
        return getComputedStyle(document.body)[prop];
    })[0];
    if (animationNameProp) {
        var allNodes = rootElement.getElementsByTagName("*");
        var keyframeNodes = [];
        var nameMarker = "__CSSVARSPONYFILL-KEYFRAMES__";
        for (var i = 0, len = allNodes.length; i < len; i++) {
            var node = allNodes[i];
            var animationName = getComputedStyle(node)[animationNameProp];
            if (animationName !== "none") {
                node.style[animationNameProp] += nameMarker;
                keyframeNodes.push(node);
            }
        }
        void document.body.offsetHeight;
        for (var _i = 0, _len = keyframeNodes.length; _i < _len; _i++) {
            var nodeStyle = keyframeNodes[_i].style;
            nodeStyle[animationNameProp] = nodeStyle[animationNameProp].replace(nameMarker, "");
        }
    }
}

function getFullUrl$1(url) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var d = document.implementation.createHTMLDocument("");
    var b = d.createElement("base");
    var a = d.createElement("a");
    d.head.appendChild(b);
    d.body.appendChild(a);
    b.href = base;
    a.href = url;
    return a.href;
}

function getTimeStamp() {
    return isBrowser && (window.performance || {}).now ? window.performance.now() : new Date().getTime();
}

/* harmony default export */ __webpack_exports__["a"] = (cssVars);
//# sourceMappingURL=css-vars-ponyfill.esm.js.map


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResponsiveScorecard; });
/* unused harmony export MobileBlocker */
/* unused harmony export BrowserBlocker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ScorecardStore__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Styles__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResponsiveNav__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Readout__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Breakdown__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Legend__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_InteractiveMap__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_RaceBreakdownBar__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_InitBox__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Sources__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DemoBox__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__MobileScorecard__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_generic_Icon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_pdfmanifest__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_cnlogo_long_svg__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_cnlogo_long_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_cnlogo_long_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_mask2_png__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_mask2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_mask2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__data_browserCompatibility__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17;var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    display: flex;\n'],['\n    position: absolute;\n    display: flex;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    height: 100%;\n    background: var(--offwhitefg);\n    margin: auto;\n    @media ','{\n        height: 960px;\n    }\n    @media ','{\n        height: 740px;\n    }\n    @media ','{\n        width: 100vw;\n    }\n'],['\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    height: 100%;\n    background: var(--offwhitefg);\n    margin: auto;\n    @media ','{\n        height: 960px;\n    }\n    @media ','{\n        height: 740px;\n    }\n    @media ','{\n        width: 100vw;\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    width: 100%;\n    display: flex;\n    position: relative;\n    align-items: center;\n\n    @media ','{\n        width: 1550px;\n    }\n    @media ','{\n        width: 1300px;\n    }\n'],['\n    width: 100%;\n    display: flex;\n    position: relative;\n    align-items: center;\n\n    @media ','{\n        width: 1550px;\n    }\n    @media ','{\n        width: 1300px;\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%;\n    left: 0;\n    background: var(--offwhitebg, black);\n    @media ','{\n        /*padding: 0 calc(50% - 775px);*/\n    }\n    @media ','{\n        /*padding: 0 calc(50% - 650px);*/\n    }\n'],['\n    position: absolute;\n    width: 100%;\n    left: 0;\n    background: var(--offwhitebg, black);\n    @media ','{\n        /*padding: 0 calc(50% - 775px);*/\n    }\n    @media ','{\n        /*padding: 0 calc(50% - 650px);*/\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    top: 0;\n    height: 90px;\n    width: auto;\n    @media ','{\n        height: 90px;\n    }\n    @media ','{\n        height: 75px;\n    }\n    flex-grow: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 3;\n'],['\n    top: 0;\n    height: 90px;\n    width: auto;\n    @media ','{\n        height: 90px;\n    }\n    @media ','{\n        height: 75px;\n    }\n    flex-grow: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 3;\n']),_templateObject6=_taggedTemplateLiteral(['\n    position: relative;\n    align-items: center;\n    justify-content: space-between;\n    @media ','{\n        margin-top: 110px;\n        height: 185px;\n    } \n    @media ','{\n        margin-top: 90px;\n        height: 150px;\n    }\n'],['\n    position: relative;\n    align-items: center;\n    justify-content: space-between;\n    @media ','{\n        margin-top: 110px;\n        height: 185px;\n    } \n    @media ','{\n        margin-top: 90px;\n        height: 150px;\n    }\n']),_templateObject7=_taggedTemplateLiteral(['\n    height: 100%;\n    /*margin-top: 25px;*/\n    @media ','{\n        margin: 32px 0 100px 0;\n    }\n    @media ','{\n        margin: 25px 0 50px 0;\n    }\n'],['\n    height: 100%;\n    /*margin-top: 25px;*/\n    @media ','{\n        margin: 32px 0 100px 0;\n    }\n    @media ','{\n        margin: 25px 0 50px 0;\n    }\n']),_templateObject8=_taggedTemplateLiteral(['\n    position: absolute;\n    pointer-events: ',';\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    overflow: hidden;\n    &::before, &::after{\n        content: \'\';\n        position: absolute;\n        top: 0;\n        transition: transform ','s linear;\n        @media ','{\n            transform: translateX(',');\n        }\n        @media ',' {\n            transform: translateX(',');\n        }\n    }\n    &::before{\n        right: calc(100% + 300px);\n        width: 100%;\n        height: 100%;\n        background: var(--offwhitefg);\n    }\n    &::after{\n        width: 300px;\n        background-repeat: no-repeat;\n        background-size: cover;\n        height: 100%;\n        left: -300px;\n        background-image: url(',');\n\n    }\n'],['\n    position: absolute;\n    pointer-events: ',';\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    overflow: hidden;\n    &::before, &::after{\n        content: \'\';\n        position: absolute;\n        top: 0;\n        transition: transform ','s linear;\n        @media ','{\n            transform: translateX(',');\n        }\n        @media ',' {\n            transform: translateX(',');\n        }\n    }\n    &::before{\n        right: calc(100% + 300px);\n        width: 100%;\n        height: 100%;\n        background: var(--offwhitefg);\n    }\n    &::after{\n        width: 300px;\n        background-repeat: no-repeat;\n        background-size: cover;\n        height: 100%;\n        left: -300px;\n        background-image: url(',');\n\n    }\n']),_templateObject9=_taggedTemplateLiteral(['\n    flex-shrink: 0;\n    @media ','{\n        /*top: 90px;*/\n        /*height: 185px;*/\n    } \n    @media ','{\n        /*top: 75px;*/\n        /*height: 150px;*/\n    }\n'],['\n    flex-shrink: 0;\n    @media ','{\n        /*top: 90px;*/\n        /*height: 185px;*/\n    } \n    @media ','{\n        /*top: 75px;*/\n        /*height: 150px;*/\n    }\n']),_templateObject10=_taggedTemplateLiteral(['\n    position: relative;\n    width: 30px; height: 30px;\n    margin-left: 10px;\n    transform: translateY(',');\n    transition: transform .2s;\n'],['\n    position: relative;\n    width: 30px; height: 30px;\n    margin-left: 10px;\n    transform: translateY(',');\n    transition: transform .2s;\n']),_templateObject11=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n'],['\n    position: absolute;\n    top: 0; left: 0;\n']),_templateObject12=_taggedTemplateLiteral(['\n    width: 30px; height: 30px;\n    margin-left: 8px;\n'],['\n    width: 30px; height: 30px;\n    margin-left: 8px;\n']),_templateObject13=_taggedTemplateLiteral(['\n    height: 48px;\n    fill: ',';\n    &:hover{\n        fill: ',';    \n    }\n    margin-right: 15px;\n'],['\n    height: 48px;\n    fill: ',';\n    &:hover{\n        fill: ',';    \n    }\n    margin-right: 15px;\n']),_templateObject14=_taggedTemplateLiteral(['\n    height: 48px;\n    fill: var(--normtext);\n    &:hover{\n        fill: var(--strokepeach); \n    }\n'],['\n    height: 48px;\n    fill: var(--normtext);\n    &:hover{\n        fill: var(--strokepeach); \n    }\n']),_templateObject15=_taggedTemplateLiteral(['\n    z-index: 2;\n    transform-origin: 0% 100%;\n    transition: transform .5s;\n    position: absolute;\n\n    @media ','{\n        left: 666px;\n        width: 530px;\n        height: 100%;\n        transform: translateX(',');\n        transform: ',';\n    }\n    @media ','{\n        left: 520px;\n        width: 430px; \n        height: 100%;\n        transform: translateX(',');\n    }\n    @media ','{}\n'],['\n    z-index: 2;\n    transform-origin: 0% 100%;\n    transition: transform .5s;\n    position: absolute;\n\n    @media ','{\n        left: 666px;\n        width: 530px;\n        height: 100%;\n        transform: translateX(',');\n        transform: ',';\n    }\n    @media ','{\n        left: 520px;\n        width: 430px; \n        height: 100%;\n        transform: translateX(',');\n    }\n    @media ','{}\n']),_templateObject16=_taggedTemplateLiteral(['\n    font-size: 13px;\n    white-space: nowrap;\n    text-align: right;\n\n    position: absolute;\n\n    transform: translateX(',');\n    opacity: ',';\n    transition: opacity .35s, transform .35s;\n\n\n    @media ','{\n        bottom: 20px; \n        right: 290px;\n    } \n    @media ','{\n        bottom: 20px; \n        right: 290px;\n    }\n\n    color: var(--normtext);\n'],['\n    font-size: 13px;\n    white-space: nowrap;\n    text-align: right;\n\n    position: absolute;\n\n    transform: translateX(',');\n    opacity: ',';\n    transition: opacity .35s, transform .35s;\n\n\n    @media ','{\n        bottom: 20px; \n        right: 290px;\n    } \n    @media ','{\n        bottom: 20px; \n        right: 290px;\n    }\n\n    color: var(--normtext);\n']),_templateObject17=_taggedTemplateLiteral(['\n    margin-top: 3px;\n    color: var(--fainttext);\n    margin-right: -25px;\n\n    transition: transform .35s;\n    transform: translateX(',');\n'],['\n    margin-top: 3px;\n    color: var(--fainttext);\n    margin-right: -25px;\n\n    transition: transform .35s;\n    transform: translateX(',');\n']),_templateObject18=_taggedTemplateLiteral(['\n    position: relative;\n    top: 0; left: 0;\n    height: 100%;\n    @media ','{\n        width: 610px;\n    }\n    @media ','{\n        width: 480px;\n    }\n    @media ','{}\n    z-index: 1; \n'],['\n    position: relative;\n    top: 0; left: 0;\n    height: 100%;\n    @media ','{\n        width: 610px;\n    }\n    @media ','{\n        width: 480px;\n    }\n    @media ','{}\n    z-index: 1; \n']),_templateObject19=_taggedTemplateLiteral(['\n    position: absolute;\n    z-index: 1;\n    bottom: 0;\n    right: 0;\n    width: 300px; \n    /*height: 80px;*/\n    @media ','{\n        height: 80px;\n    }\n    @media ','{\n        height: 64px;\n    }\n\n'],['\n    position: absolute;\n    z-index: 1;\n    bottom: 0;\n    right: 0;\n    width: 300px; \n    /*height: 80px;*/\n    @media ','{\n        height: 80px;\n    }\n    @media ','{\n        height: 64px;\n    }\n\n']),_templateObject20=_taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @media ','{\n        padding: 0 calc((100vw - 1550px) / 2);\n        top: 960px;\n    }\n    @media ','{\n        padding: 0 calc((100vw - 1300px) / 2);\n        top: 740px;\n    }\n    z-index: 3;\n'],['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @media ','{\n        padding: 0 calc((100vw - 1550px) / 2);\n        top: 960px;\n    }\n    @media ','{\n        padding: 0 calc((100vw - 1300px) / 2);\n        top: 740px;\n    }\n    z-index: 3;\n']),_templateObject21=_taggedTemplateLiteral(['\n    width: 175px; height: 21px;\n    /*border: 1px solid white;*/\n    background-image: url(',');\n    background-size: cover;\n    background-repeat: none;\n\n'],['\n    width: 175px; height: 21px;\n    /*border: 1px solid white;*/\n    background-image: url(',');\n    background-size: cover;\n    background-repeat: none;\n\n']),_templateObject22=_taggedTemplateLiteral(['\n    @media ','{\n        width: 1550px;\n    }\n    @media ','{\n        width: 1295px;\n    }\n    display: flex;\n    height: 75px;\n    align-items: center;\n    justify-content: flex-end;\n'],['\n    @media ','{\n        width: 1550px;\n    }\n    @media ','{\n        width: 1295px;\n    }\n    display: flex;\n    height: 75px;\n    align-items: center;\n    justify-content: flex-end;\n']),_templateObject23=_taggedTemplateLiteral(['\n    color: white;\n    margin-right: 70px;\n    text-decoration: none;\n    &:hover{\n        color: var(--peach, orange);\n    }\n'],['\n    color: white;\n    margin-right: 70px;\n    text-decoration: none;\n    &:hover{\n        color: var(--peach, orange);\n    }\n']),_templateObject24=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 25px;\n'],['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 25px;\n']),_templateObject25=_taggedTemplateLiteral(['\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%; \n    /*background: lightgrey;*/\n    background: #f3f3f5;\n    background: var(--offwhitefg);\n    padding: 20px;\n    top: 0;\n    left: 0;\n    line-height: 160%;\n'],['\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%; \n    /*background: lightgrey;*/\n    background: #f3f3f5;\n    background: var(--offwhitefg);\n    padding: 20px;\n    top: 0;\n    left: 0;\n    line-height: 160%;\n']),_templateObject26=_taggedTemplateLiteral(['\n    background: white;\n    color: var(--normtext, black);\n    border: 1px solid grey;\n    border: 1px solid var(--bordergrey);\n    padding: 25px;\n    max-width: 540px;\n\n'],['\n    background: white;\n    color: var(--normtext, black);\n    border: 1px solid grey;\n    border: 1px solid var(--bordergrey);\n    padding: 25px;\n    max-width: 540px;\n\n']),_templateObject27=_taggedTemplateLiteral(['\n    width: 36px; height: 36px;\n    background-image: url(',');\n    background-size: cover;\n    margin-right: 10px;\n'],['\n    width: 36px; height: 36px;\n    background-image: url(',');\n    background-size: cover;\n    margin-right: 10px;\n']),_templateObject28=_taggedTemplateLiteral(['\n    display: flex;\n    text-decoration: none;\n    align-items: center;\n    color: var(--bordergrey);\n    white-space: nowrap;\n    cursor: pointer;\n    &:hover{\n        color: var(--peach);\n        figure{\n            background-position: 100% center;\n        }\n    }\n'],['\n    display: flex;\n    text-decoration: none;\n    align-items: center;\n    color: var(--bordergrey);\n    white-space: nowrap;\n    cursor: pointer;\n    &:hover{\n        color: var(--peach);\n        figure{\n            background-position: 100% center;\n        }\n    }\n']),_templateObject29=_taggedTemplateLiteral(['\n    text-decoration: none;\n'],['\n    text-decoration: none;\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import DemoDataTable from './components/DemoDataTable'
// import semanticTitles from './assets/semanticTitles'
var store=new __WEBPACK_IMPORTED_MODULE_6__ScorecardStore__["a" /* default */]();window.store=store;var flat=__webpack_require__(201);var includes=__webpack_require__(204);var values=__webpack_require__(40);var assert=__webpack_require__(50);delete Array.prototype.flat;var shimmedFlat=flat.shim();delete Array.prototype.includes;var shimmedIncludes=includes.shim();if(!Object.values)values.shim();var Quadrant=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject);var App=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].mobile);var Row=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var DarkBar=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var Nav=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(DarkBar)(_templateObject5,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var TopRow=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Row)(_templateObject6,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var BottomRow=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Row)(_templateObject7,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var GreyMask=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject8,function(props){return props.show?'auto':'none';},function(props){return props.show?.45:.35;},__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,function(props){return props.show?'calc(1550px + 300px)':0;},__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact,function(props){return props.show?'calc(1300px + 300px)':0;},__WEBPACK_IMPORTED_MODULE_28__assets_mask2_png___default.a);var ShareSources=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject9,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);// const pdfIcon = require('./assets/export.svg')
// const sourcesIcon = require('./assets/sources.svg')
// const Icon = styled.figure`
//     position: absolute;
//     right: 10px;
//     /*outline: 1px solid black;*/
//     width: 30px;
//     height: 30px;
//     background-repeat: no-repeat;
//     margin-right: 12px;
//     flex-shrink: 0;
//     background-size: cover;
// `
// const BtnLabel = styled.div`
//     display: flex;
//     align-items: center;
// `
// const SourcesIcon = styled(Icon)`
//     background-image: url(${sourcesIcon});
// `
// const PDFIcon = styled(Icon)`
//     background-image: url(${pdfIcon});
// `
var Bookwrap=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject10,function(props){return props.active?'0px':'3px';});var BookSprite=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_19__components_generic_Icon__["a" /* Sprite */])(_templateObject11);var PDFIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_19__components_generic_Icon__["b" /* default */])(_templateObject12);var SourceButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_18__components_generic__["a" /* Button */])(_templateObject13,function(props){return props.active?'white':'var(--normtext)';},function(props){return props.active?'var(--peach)':'var(--strokepeach)';});var PDFButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_18__components_generic__["a" /* Button */])(_templateObject14);var ResponsiveScorecard=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(ResponsiveScorecard,_React$Component);function ResponsiveScorecard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ResponsiveScorecard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ResponsiveScorecard.__proto__||Object.getPrototypeOf(ResponsiveScorecard)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'browserBlock',_descriptor,_this),_initDefineProp(_this,'blockUserBrowser',_descriptor2,_this),_initDefineProp(_this,'setInit',_descriptor3,_this),_initDefineProp(_this,'closeSplash',_descriptor4,_this),_initDefineProp(_this,'navOpen',_descriptor5,_this),_initDefineProp(_this,'hoveredCounty',_descriptor6,_this),_initDefineProp(_this,'breakdownOffset',_descriptor7,_this),_initDefineProp(_this,'setBreakdownOffset',_descriptor8,_this),_initDefineProp(_this,'extraReadoutLines',_descriptor9,_this),_initDefineProp(_this,'reset',_descriptor10,_this),_initDefineProp(_this,'openNav',_descriptor11,_this),_initDefineProp(_this,'onHoverCounty',_descriptor12,_this),_initDefineProp(_this,'screen',_descriptor13,_this),_initDefineProp(_this,'displayApp',_descriptor14,_this),_initDefineProp(_this,'setDisplay',_descriptor15,_this),_initDefineProp(_this,'alreadyDisplayedRandomIndicators',_descriptor16,_this),_initDefineProp(_this,'foistRandomIndicator',_descriptor17,_this),_this.setRandomIndicatorCycle=function(tf){if(tf){console.log('starting interval for rand ');//set the first one too
_this.foistRandomIndicator();_this.randomIndicatorInterval=setInterval(_this.foistRandomIndicator,5000);}else{console.log('clearing rand interval');store.completeWorkflow('indicator',null);clearInterval(_this.randomIndicatorInterval);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ResponsiveScorecard,[{key:'componentWillMount',value:function componentWillMount(){store.setIndicatorPages();// window.addEventListener('resize', this.resizeRefresh, false)
//eventually....
window.addEventListener('resize',store.resize,false);var browserName=store.browser.name;var ver=store.browser.version;if(!Object.keys(__WEBPACK_IMPORTED_MODULE_29__data_browserCompatibility__["a" /* default */]).includes(browserName)){this.blockUserBrowser('browser');}else{if(ver>=__WEBPACK_IMPORTED_MODULE_29__data_browserCompatibility__["a" /* default */][browserName]){//it's fine
}else{this.blockUserBrowser('version');}}//query params check
var urlParams=new URLSearchParams(window.location.search);var urlInd=urlParams.get('ind');var urlCty=urlParams.get('cty');var urlRace=urlParams.get('race');var urlYr=urlParams.get('yr');if(urlParams.has('ind')&&Object.keys(__WEBPACK_IMPORTED_MODULE_20__data_indicators__["a" /* default */]).includes(urlInd)){console.log('url has valid indicator');this.setInit(false);store.completeWorkflow('indicator',urlInd);//we only care if theres cty/race if the url contains ind
if(urlParams.has('cty')){if(Object.keys(__WEBPACK_IMPORTED_MODULE_23__assets_countyLabels___default.a).includes(urlCty)){store.completeWorkflow('county',urlCty);}}if(urlParams.has('race')){var races=['asian','black','latinx','white','other'];if(races.includes(urlRace)){store.completeWorkflow('race',urlRace);}}if(urlParams.has('yr')){if(__WEBPACK_IMPORTED_MODULE_20__data_indicators__["a" /* default */][store.indicator].years[urlYr]){console.log(urlYr);store.completeWorkflow('year',urlYr);}}}else{if(store.screen!=='mobile')this.setRandomIndicatorCycle(true);}}},{key:'componentDidMount',value:function componentDidMount(){window.setTimeout(this.setDisplay,10);}},{key:'render',value:function render(){var _this2=this;var indicator=store.indicator,year=store.year,race=store.race,screen=store.screen;var dataForMap=indicator?Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapValues"])(__WEBPACK_IMPORTED_MODULE_20__data_indicators__["a" /* default */][indicator].counties,function(county){return county[race||'totals'][year];}):'';return this.browserBlock?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BrowserBlocker,{store:store,why:this.browserBlock}):store.screen==='mobile'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__MobileScorecard__["a" /* default */],{store:store}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Styles__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(App,{style:{visibility:this.displayApp?'visible':'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Nav,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ResponsiveNav__["a" /* default */],{init:store.init,store:store,open:this.navOpen,openNav:this.openNav,closeSplash:this.closeSplash,reset:this.reset})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Readout__["a" /* default */],{store:store,setBreakdownOffset:this.setBreakdownOffset}),store.indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareSources,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourceButton,{className:store.sourcesMode?'negative':'',active:store.sourcesMode,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,store.sourcesMode?'Hide':'View',' sources and notes',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bookwrap,{active:store.sourcesMode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookSprite,{img:'book',width:30,height:30,duration:.275,state:store.sourcesMode?'up':'down',fillMode:'none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookSprite,{img:'underbook',duration:.2,width:30,height:30,state:store.sourcesMode?'up':'down'}))),onClick:function onClick(){store.setSourcesMode(!store.sourcesMode);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PDFButton,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'Download PDF ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PDFIcon,{img:'document'})),onClick:function onClick(){if(__WEBPACK_IMPORTED_MODULE_24__assets_pdfmanifest__["a" /* default */][store.county||'california']){window.location.assign(__WEBPACK_IMPORTED_MODULE_24__assets_pdfmanifest__["a" /* default */][store.county||'california']);}else alert('Sorry -- PDF for '+__WEBPACK_IMPORTED_MODULE_23__assets_countyLabels___default.a[store.county]+' county coming soon.');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BottomRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_DemoBox__["a" /* default */],{id:'demobox'// show = {!store.sourcesMode && !store.init}
,show:!store.init,store:store,sources:store.sourcesMode}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_InitBox__["a" /* default */],{store:store,show:store.init,closeSplash:this.closeSplash}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Breakdown,{sources:store.sourcesMode},store.indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Breakdown__["a" /* default */],{offset:this.breakdownOffset,store:store,sources:store.sourcesMode})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MapContainer,{offset:store.init||this.navOpen// init = {store.init}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_InteractiveMap__["a" /* default */],{store:store,onHoverCounty:function onHoverCounty(val){return store.setHover('county',val);},hoveredCounty:store.hoveredCounty,onSelect:store.completeWorkflow,selected:store.county,defaultHighlight:indicator?__WEBPACK_IMPORTED_MODULE_20__data_indicators__["a" /* default */][indicator].highlight:'',data:dataForMap,mode:store.init?'init':this.navOpen?'offset':dataForMap?'heat':'',clickedOutside:this.navOpen?function(){return _this2.openNav(false);}:function(){}// mode = 'wire'
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RandomIndicatorLabel,{show:store.init},indicator&&__WEBPACK_IMPORTED_MODULE_20__data_indicators__["a" /* default */][indicator].semantics.shorthand,!store.init&&!indicator&&this.alreadyDisplayedRandomIndicators.length>0&&__WEBPACK_IMPORTED_MODULE_20__data_indicators__["a" /* default */][this.alreadyDisplayedRandomIndicators[this.alreadyDisplayedRandomIndicators.length-1]].semantics.shorthand,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubRandLabel,{show:store.init},!race&&'All races',', ',indicator&&__WEBPACK_IMPORTED_MODULE_20__data_indicators__["a" /* default */][indicator].years[year],!indicator&&'2018'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LegendContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Legend__["a" /* default */],{store:store}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GreyMask,{className:'greymask',show:this.navOpen||store.init,onClick:function onClick(){return _this2.navOpen?function(){return _this2.openNav(false);}:function(){console.log('clicked grey mask');};}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeedbackLink,{href:'mailto:research@childrennow.org?subject=Scorecard%20Feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Feedback// onClick = {()=>{
//     window.location.href = "mailto:research@childrennow.org?subject=Scorecard%20Feedback";
// }}
,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeedbackIcon,null),' Provide feedback')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLink,{href:'https://www.childrennow.org/about/'},'About us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLink,{href:'http://ccnstaging.childrennow.webfactional.com/portfolio-posts/2018scorecard/'},'Credits & Acknowledgments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.childrennow.org'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CNLogo,null)))));}}]);return ResponsiveScorecard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'browserBlock',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'blockUserBrowser',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(why){return _this3.browserBlock=why;};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'setInit',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(tf){if(store.screen!=='mobile'){if(!tf){_this4.setRandomIndicatorCycle(false);}else if(tf)_this4.setRandomIndicatorCycle(true);}store.init=tf;};}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'closeSplash',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.setInit(false);_this5.openNav('indicator');};}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'navOpen',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'hoveredCounty',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'breakdownOffset',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'setBreakdownOffset',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(val){return _this6.breakdownOffset=val;};}}),_descriptor9=_applyDecoratedDescriptor(_class2.prototype,'extraReadoutLines',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor10=_applyDecoratedDescriptor(_class2.prototype,'reset',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){store.completeWorkflow('race',null);store.completeWorkflow('county',null);store.completeWorkflow('indicator',null);_this7.openNav('indicator');};}}),_descriptor11=_applyDecoratedDescriptor(_class2.prototype,'openNav',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(status){console.log('nav',status);if(store.sourcesMode&&status){store.setSourcesMode(false);}if(store.init&&status){console.log('user opened nav while init');_this8.setInit(false);}if(!store.indicator&&_this8.navOpen==='indicator'&&!status){_this8.setInit(true);store.completeWorkflow('county',null);store.completeWorkflow('race',null);_this8.navOpen=false;}else if(!status&&!store.indicator){_this8.navOpen='indicator';}else _this8.navOpen=status;};}}),_descriptor12=_applyDecoratedDescriptor(_class2.prototype,'onHoverCounty',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(id){if(id)_this9.hoveredCounty=Object(__WEBPACK_IMPORTED_MODULE_26__utilities_toLowerCase__["a" /* camelLower */])(id);else _this9.hoveredCounty=null;};}}),_descriptor13=_applyDecoratedDescriptor(_class2.prototype,'screen',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_25__utilities_media__["b" /* getMedia */])();}}),_descriptor14=_applyDecoratedDescriptor(_class2.prototype,'displayApp',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor15=_applyDecoratedDescriptor(_class2.prototype,'setDisplay',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this10=this;return function(){return _this10.displayApp=true;};}}),_descriptor16=_applyDecoratedDescriptor(_class2.prototype,'alreadyDisplayedRandomIndicators',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor17=_applyDecoratedDescriptor(_class2.prototype,'foistRandomIndicator',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this11=this;return function(){var availableInds=void 0;if(_this11.alreadyDisplayedRandomIndicators.length===__WEBPACK_IMPORTED_MODULE_20__data_indicators__["b" /* featuredInds */].length){availableInds=__WEBPACK_IMPORTED_MODULE_20__data_indicators__["b" /* featuredInds */];_this11.alreadyDisplayedRandomIndicators=[];}else{availableInds=__WEBPACK_IMPORTED_MODULE_20__data_indicators__["b" /* featuredInds */].filter(function(ind){return!_this11.alreadyDisplayedRandomIndicators.includes(ind);});}var randomIndex=Math.floor(Math.random()*availableInds.length);console.log(availableInds);var choice=availableInds[randomIndex];console.log(choice);store.completeWorkflow('indicator',choice);_this11.alreadyDisplayedRandomIndicators.push(choice);};}})),_class2))||_class;var MapContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Quadrant)(_templateObject15,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,function(props){return props.offset?'350px':0;},function(props){return props.offset?'translateX(350px)':'translateX(0) scale(1)';},__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact,function(props){return props.offset?'320px':0;},__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].mobile);var RandomIndicatorLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject16,function(props){return props.show?'0px':'50px';},function(props){return props.show?1:0;},__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var SubRandLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject17,function(props){return props.show?'0px':'20px';});var Breakdown=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(Quadrant)(_templateObject18,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].mobile);var LegendContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject19,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var Footer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(DarkBar)(_templateObject20,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var CNLogo=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_27__assets_cnlogo_long_svg___default.a);var FooterContent=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject22,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_25__utilities_media__["a" /* default */].compact);var FooterLink=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].a(_templateObject23);var MobileBlocker=function MobileBlocker(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockUser,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Notif,null,'Sorry, this application doesn\'t support your screen resolution and/or mobile devices yet. Check back soon!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileBlockActions,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_generic__["a" /* Button */],{style:{marginLeft:'15px'},label:'Back to Children Now',className:'negative',onClick:function onClick(){window.open('https://childrennow.org');}}))));};var BrowserBlocker=function BrowserBlocker(props){var store=props.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BlockUser,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Notif,null,props.why==='version'&&'Sorry, this application doesn\'t support your version ('+store.browser.version+') of '+(store.browser.name==='ie'?'Internet Explorer':Object(__WEBPACK_IMPORTED_MODULE_26__utilities_toLowerCase__["b" /* capitalize */])(store.browser.name))+'. Please upgrade to version '+__WEBPACK_IMPORTED_MODULE_29__data_browserCompatibility__["a" /* default */][store.browser.name]+' or greater.',props.why==='browser'&&'Sorry, this application doesn\'t support '+(store.browser.name==='ie'?'Internet Explorer':'your browser')+' - please visit us using a recent version of Google Chrome, Mozilla Firefox, or Safari!',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileBlockActions,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_generic__["a" /* Button */],{style:{marginLeft:'15px'},label:'Back to Children Now',className:'negative',onClick:function onClick(){window.open('https://childrennow.org');}}))));};var MobileBlockActions=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject24);var BlockUser=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject25);var Notif=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject26);var feedbackico=__webpack_require__(206);var FeedbackIcon=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].figure(_templateObject27,feedbackico);var Feedback=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject28);var FeedbackLink=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].a(_templateObject29);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var c=/^\0+/g,r=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,k=/::(place)/g,p=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,w=/(\{[^{]+?);(?=\})/g,C=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z="-webkit-",F="-moz-",N="-ms-",S=59,B=125,W=123,q=40,D=41,E=91,G=93,H=10,I=13,J=9,K=64,L=32,M=38,P=45,Q=95,R=42,T=44,U=58,V=39,X=34,Y=47,Z=62,_=43,ee=126,ae=0,ce=12,re=11,se=107,te=109,ie=115,fe=112,ne=111,le=169,oe=163,he=100,ue=112,de=1,be=1,ke=0,pe=1,ge=1,Ae=1,we=0,Ce=0,ve=0,me=[],xe=[],$e=0,ye=null,Oe=-2,je=-1,ze=0,Fe=1,Ne=2,Se=3,Be=0,We=1,qe="",De="",Ee="";function Ge(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,w=0,C=0,m=0,$=0,y=0,O=0,j=0,Q=0,we=0,xe=0,ye=0,Oe=0,je=0,Ie=s.length,Pe=Ie-1,Qe="",Re="",Te="",Ue="",Ve="",Xe="";we<Ie;){if(w=s.charCodeAt(we),we===Pe)if(h+d+u+o!==0){if(0!==h)w=h===Y?H:Y;d=u=o=0,Ie++,Pe++}if(h+d+u+o===0){if(we===Pe){if(xe>0)Re=Re.replace(r,"");if(Re.trim().length>0){switch(w){case L:case J:case S:case I:case H:break;default:Re+=s.charAt(we)}w=S}}if(1===ye)switch(w){case W:case B:case S:case X:case V:case q:case D:case T:ye=0;case J:case I:case H:case L:break;default:for(ye=0,je=we,g=w,we--,w=S;je<Ie;)switch(s.charCodeAt(je++)){case H:case I:case S:++we,w=g,je=Ie;break;case U:if(xe>0)++we,w=g;case W:je=Ie}}switch(w){case W:for(g=(Re=Re.trim()).charCodeAt(0),y=1,je=++we;we<Ie;){switch(w=s.charCodeAt(we)){case W:y++;break;case B:y--}if(0===y)break;we++}if(Te=s.substring(je,we),g===ae)g=(Re=Re.replace(c,"").trim()).charCodeAt(0);switch(g){case K:if(xe>0)Re=Re.replace(r,"");switch(A=Re.charCodeAt(1)){case he:case te:case ie:case P:f=a;break;default:f=me}if(je=(Te=Ge(a,f,Te,A,i+1)).length,ve>0&&0===je)je=Re.length;if($e>0)if(f=He(me,Re,Oe),n=Me(Se,Te,f,a,be,de,je,A,i,t),Re=f.join(""),void 0!==n)if(0===(je=(Te=n.trim()).length))A=0,Te="";if(je>0)switch(A){case ie:Re=Re.replace(x,Le);case he:case te:case P:Te=Re+"{"+Te+"}";break;case se:if(Te=(Re=Re.replace(b,"$1 $2"+(We>0?qe:"")))+"{"+Te+"}",1===ge||2===ge&&Ke("@"+Te,3))Te="@"+z+Te+"@"+Te;else Te="@"+Te;break;default:if(Te=Re+Te,t===ue)Ue+=Te,Te=""}else Te="";break;default:Te=Ge(a,He(a,Re,Oe),Te,t,i+1)}Ve+=Te,O=0,ye=0,Q=0,xe=0,Oe=0,j=0,Re="",Te="",w=s.charCodeAt(++we);break;case B:case S:if((je=(Re=(xe>0?Re.replace(r,""):Re).trim()).length)>1){if(0===Q)if((g=Re.charCodeAt(0))===P||g>96&&g<123)je=(Re=Re.replace(" ",":")).length;if($e>0)if(void 0!==(n=Me(Fe,Re,a,e,be,de,Ue.length,t,i,t)))if(0===(je=(Re=n.trim()).length))Re="\0\0";switch((g=Re.charCodeAt(0))+(A=Re.charCodeAt(1))){case ae:break;case le:case oe:Xe+=Re+s.charAt(we);break;default:if(Re.charCodeAt(je-1)===U)break;Ue+=Je(Re,g,A,Re.charCodeAt(2))}}O=0,ye=0,Q=0,xe=0,Oe=0,Re="",w=s.charCodeAt(++we)}}switch(w){case I:case H:if(h+d+u+o+Ce===0)switch($){case D:case V:case X:case K:case ee:case Z:case R:case _:case Y:case P:case U:case T:case S:case W:case B:break;default:if(Q>0)ye=1}if(h===Y)h=0;else if(pe+O===0)xe=1,Re+="\0";if($e*Be>0)Me(ze,Re,a,e,be,de,Ue.length,t,i,t);de=1,be++;break;case S:case B:if(h+d+u+o===0){de++;break}default:switch(de++,Qe=s.charAt(we),w){case J:case L:if(d+o+h===0)switch(C){case T:case U:case J:case L:Qe="";break;default:if(w!==L)Qe=" "}break;case ae:Qe="\\0";break;case ce:Qe="\\f";break;case re:Qe="\\v";break;case M:if(d+h+o===0&&pe>0)Oe=1,xe=1,Qe="\f"+Qe;break;case 108:if(d+h+o+ke===0&&Q>0)switch(we-Q){case 2:if(C===fe&&s.charCodeAt(we-3)===U)ke=C;case 8:if(m===ne)ke=m}break;case U:if(d+h+o===0)Q=we;break;case T:if(h+u+d+o===0)xe=1,Qe+="\r";break;case X:case V:if(0===h)d=d===w?0:0===d?w:d;break;case E:if(d+h+u===0)o++;break;case G:if(d+h+u===0)o--;break;case D:if(d+h+o===0)u--;break;case q:if(d+h+o===0){if(0===O)switch(2*C+3*m){case 533:break;default:y=0,O=1}u++}break;case K:if(h+u+d+o+Q+j===0)j=1;break;case R:case Y:if(d+o+u>0)break;switch(h){case 0:switch(2*w+3*s.charCodeAt(we+1)){case 235:h=Y;break;case 220:je=we,h=R}break;case R:if(w===Y&&C===R){if(33===s.charCodeAt(je+2))Ue+=s.substring(je,we+1);Qe="",h=0}}}if(0===h){if(pe+d+o+j===0&&t!==se&&w!==S)switch(w){case T:case ee:case Z:case _:case D:case q:if(0===O){switch(C){case J:case L:case H:case I:Qe+="\0";break;default:Qe="\0"+Qe+(w===T?"":"\0")}xe=1}else switch(w){case q:O=++y;break;case D:if(0==(O=--y))xe=1,Qe+="\0"}break;case J:case L:switch(C){case ae:case W:case B:case S:case T:case ce:case J:case L:case H:case I:break;default:if(0===O)xe=1,Qe+="\0"}}if(Re+=Qe,w!==L&&w!==J)$=w}}m=C,C=w,we++}if(je=Ue.length,ve>0)if(0===je&&0===Ve.length&&0===a[0].length==false)if(t!==te||1===a.length&&(pe>0?De:Ee)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===pe&&t!==se?function(e){for(var a,c,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(c=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=c.charCodeAt(0),a="",0!==o)switch(u){case R:case ee:case Z:case _:case L:case q:break;default:a=" "}switch(d){case M:c=a+De;case ee:case Z:case _:case L:case D:case q:break;case E:c=a+c+De;break;case U:switch(2*c.charCodeAt(1)+3*c.charCodeAt(2)){case 530:if(Ae>0){c=a+c.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)c=a+De+c}break;case T:a="";default:if(h>1&&c.indexOf(":")>0)c=a+c.replace(v,"$1"+De+"$2");else c=a+c+De}n+=c}i[s]=n.replace(r,"").trim()}return i}(a):a,$e>0)if(void 0!==(n=Me(Ne,Ue,f,e,be,de,je,t,i,t))&&0===(Ue=n).length)return Xe+Ue+Ve;if(Ue=f.join(",")+"{"+Ue+"}",ge*ke!=0){if(2===ge&&!Ke(Ue,2))ke=0;switch(ke){case ne:Ue=Ue.replace(p,":"+F+"$1")+Ue;break;case fe:Ue=Ue.replace(k,"::"+z+"input-$1")+Ue.replace(k,"::"+F+"$1")+Ue.replace(k,":"+N+"input-$1")+Ue}ke=0}}return Xe+Ue+Ve}function He(e,a,c){var r=a.trim().split(o),s=r,t=r.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Ie(n,s[f],c,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Ie(e[h]+" ",r[f],c,i).trim()}return s}function Ie(e,a,c,r){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case M:switch(pe+r){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case U:switch(s.charCodeAt(1)){case 103:if(Ae>0&&pe>0)return s.replace(u,"$1").replace(h,"$1"+Ee);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(c*pe>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===U?"":"$1")+e.trim())}return e+s}function Je(e,a,c,r){var l,o=0,h=e+";",u=2*a+3*c+4*r;if(944===u)return function(e){var a=e.length,c=e.indexOf(":",9)+1,r=e.substring(0,c).trim(),s=e.substring(c,a-1).trim();switch(e.charCodeAt(9)*We){case 0:break;case P:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,c=0,a=t.length;i<a;c=0,++i){for(var l=t[i],o=l.split(n);l=o[c];){var h=l.charCodeAt(0);if(1===We&&(h>K&&h<90||h>96&&h<123||h===Q||h===P&&l.charCodeAt(1)!==P))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=qe}}o[c++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=r+s+";",1===ge||2===ge&&Ke(s,1))return z+s+s;return s}(h);else if(0===ge||2===ge&&!Ke(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?z+h+h:h;case 951:return 116===h.charCodeAt(3)?z+h+h:h;case 963:return 110===h.charCodeAt(5)?z+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return z+h+h;case 978:return z+h+F+h+h;case 1019:case 983:return z+h+F+h+N+h+h;case 883:return h.charCodeAt(8)===P?z+h+h:h;case 932:if(h.charCodeAt(4)===P)switch(h.charCodeAt(5)){case 103:return z+"box-"+h.replace("-grow","")+z+h+N+h.replace("grow","positive")+h;case 115:return z+h+N+h.replace("shrink","negative")+h;case 98:return z+h+N+h.replace("basis","preferred-size")+h}return z+h+N+h+h;case 964:return z+h+N+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),z+"box-pack"+l+z+h+N+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+z)+h.replace(s,":"+F)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return z+h+N+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,z+l)+";"+h;break;case 207:case 102:h=h.replace(l,z+(u>102?"inline-":"")+"box")+";"+h.replace(l,z+l)+";"+h.replace(l,N+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===P)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),z+h+z+"box-"+l+N+"flex-"+l+h;case 115:return z+h+N+"flex-item-"+h.replace(y,"")+h;default:return z+h+N+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==P||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Je(e.replace("stretch","fill-available"),a,c,r).replace(":fill-available",":stretch");else return h.replace(l,z+l)+h.replace(l,F+l.replace("fill-",""))+h;break;case 962:if(h=z+h+(102===h.charCodeAt(5)?N+h:"")+h,c+r===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+z+"$2")+h}return h}function Ke(e,a){var c=e.indexOf(1===a?":":"{"),r=e.substring(0,3!==a?c:10),s=e.substring(c+1,e.length-1);return ye(2!==a?r:r.replace(O,"$1"),s,a)}function Le(e,a){var c=Je(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return c!==a+";"?c.replace($," or ($1)").substring(4):"("+a+")"}function Me(e,a,c,r,s,t,i,f,n,l){for(var o,h=0,u=a;h<$e;++h)switch(o=xe[h].call(Qe,e,u,c,r,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}switch(u){case void 0:case false:case true:case null:case a:break;default:return u}}function Pe(e){for(var a in e){var c=e[a];switch(a){case"keyframe":We=0|c;break;case"global":Ae=0|c;break;case"cascade":pe=0|c;break;case"compress":we=0|c;break;case"semicolon":Ce=0|c;break;case"preserve":ve=0|c;break;case"prefix":if(ye=null,!c)ge=0;else if("function"!=typeof c)ge=1;else ge=2,ye=c}}return Pe}function Qe(a,c){if(void 0!==this&&this.constructor===Qe)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(We>0)qe=s.replace(d,t===E?"":"-");if(t=1,1===pe)Ee=s;else De=s;var i,f=[Ee];if($e>0)if(void 0!==(i=Me(je,c,f,f,be,de,0,0,0,0))&&"string"==typeof i)c=i;var n=Ge(me,f,c,0,0);if($e>0)if(void 0!==(i=Me(Oe,n,f,f,be,de,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return qe="",Ee="",De="",ke=0,be=1,de=1,we*t==0?n:n.replace(r,"").replace(g,"").replace(A,"$1").replace(w,"$1").replace(C," ")}if(Qe.use=function e(a){switch(a){case void 0:case null:$e=xe.length=0;break;default:switch(a.constructor){case Array:for(var c=0,r=a.length;c<r;++c)e(a[c]);break;case Function:xe[$e++]=a;break;case Boolean:Be=0|!!a}}return e},Qe.set=Pe,void 0!==a)Pe(a);return Qe});
//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(87);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(37);
var invariant = __webpack_require__(36);
var ReactPropTypesSecret = __webpack_require__(90);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(92);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concatArrays */
/* unused harmony export merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_what__ = __webpack_require__(94);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key)
        ? 'enumerable'
        : 'nonenumerable';
    if (propType === 'enumerable')
        carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(newComer)) {
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if ((!Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["c" /* isSymbol */])(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
                (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["c" /* isSymbol */])(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin))
            // @ts-ignore
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["b" /* isPlainObject */])(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(originVal) && Object(__WEBPACK_IMPORTED_MODULE_0_is_what__["a" /* isArray */])(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

/* harmony default export */ __webpack_exports__["a"] = (merge);



/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getType */
/* unused harmony export isAnyObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });
/* unused harmony export isBlob */
/* unused harmony export isBoolean */
/* unused harmony export isDate */
/* unused harmony export isEmptyString */
/* unused harmony export isError */
/* unused harmony export isFile */
/* unused harmony export isFullString */
/* unused harmony export isFunction */
/* unused harmony export isNull */
/* unused harmony export isNullOrUndefined */
/* unused harmony export isNumber */
/* unused harmony export isObject */
/* unused harmony export isObjectLike */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPlainObject; });
/* unused harmony export isPrimitive */
/* unused harmony export isPromise */
/* unused harmony export isRegExp */
/* unused harmony export isString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSymbol; });
/* unused harmony export isType */
/* unused harmony export isUndefined */
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is {[key: string]: any}}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function
 *
 * @param {*} payload
 * @returns {payload is Function}
 */
function isFunction(payload) {
    return getType(payload) === 'Function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number
 *
 * This will return false for NaN
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return getType(payload) === 'Number' && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */
function isSymbol(payload) {
    return getType(payload) === 'Symbol';
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return getType(payload) === 'Date' && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */
function isBlob(payload) {
    return getType(payload) === 'Blob';
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */
function isFile(payload) {
    return getType(payload) === 'File';
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise}
 */
function isPromise(payload) {
    return getType(payload) === 'Promise';
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */
function isError(payload) {
    return getType(payload) === 'Error';
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */
function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */
function isNullOrUndefined(payload) {
    return isNull(payload) || isUndefined(payload);
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}




/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chroma_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chroma_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chroma_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_isValid__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_stopwords__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_stopwords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__utilities_stopwords__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_descriptor20,_descriptor21,_descriptor22,_descriptor23,_descriptor24,_descriptor25,_descriptor26,_descriptor27,_descriptor28,_descriptor29,_descriptor30,_descriptor31,_descriptor32,_descriptor33,_descriptor34,_descriptor35,_descriptor36,_descriptor37,_descriptor38,_descriptor39;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}// import semanticTitles from './assets/semanticTitles'
var _require=__webpack_require__(126),detect=_require.detect;var browserInfo=detect();var values=__webpack_require__(40);var assert=__webpack_require__(50);if(!Object.values)values.shim();var AppStore=(_class=function(){function AppStore(){var _this=this;_classCallCheck(this,AppStore);this.browser={name:browserInfo.name,version:Number(browserInfo.version.slice(0,2)),os:browserInfo.os};_initDefineProp(this,'screen',_descriptor,this);_initDefineProp(this,'mobileDeviceWidth',_descriptor2,this);_initDefineProp(this,'mobileDeviceHeight',_descriptor3,this);_initDefineProp(this,'resize',_descriptor4,this);_initDefineProp(this,'init',_descriptor5,this);_initDefineProp(this,'indicator',_descriptor6,this);_initDefineProp(this,'county',_descriptor7,this);_initDefineProp(this,'race',_descriptor8,this);_initDefineProp(this,'year',_descriptor9,this);_initDefineProp(this,'colorOptions',_descriptor10,this);_initDefineProp(this,'setColorOption',_descriptor11,this);_initDefineProp(this,'setYearIndex',_descriptor12,this);_initDefineProp(this,'completeWorkflow',_descriptor13,this);this.checkValidity=function(which,value){var indicator=_this.indicator,county=_this.county,race=_this.race,year=_this.year;if(which!=='indicator'&&!indicator||!value){//picking county and race without an indicator; this can basically only happen
//from the init and we can probably just ignore it...
return true;}var ind=which==='indicator'&&value?value:indicator;var cty=which==='county'&&value?value:county?county:'california';var rce=which==='race'&&value?value:race?race:'totals';console.log(ind,cty,rce,year);console.log(__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][ind].counties[cty][rce]);var val=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][ind].counties[cty][rce][year];console.log(val);return val!==0&&(val==='*'||!val)?false:true;};_initDefineProp(this,'notifications',_descriptor14,this);_initDefineProp(this,'notify',_descriptor15,this);_initDefineProp(this,'indicatorPageSize',_descriptor16,this);_initDefineProp(this,'setIndicatorPages',_descriptor17,this);_initDefineProp(this,'indicatorPages',_descriptor18,this);_initDefineProp(this,'indicatorListPage',_descriptor19,this);_initDefineProp(this,'indicatorFilter',_descriptor20,this);_initDefineProp(this,'indicatorSearchString',_descriptor21,this);_initDefineProp(this,'indicatorSearchResults',_descriptor22,this);_initDefineProp(this,'setIndicatorFilter',_descriptor23,this);_initDefineProp(this,'setIndicatorListPage',_descriptor24,this);_initDefineProp(this,'sanityCheckIndicator',_descriptor25,this);_initDefineProp(this,'sanityCheckMessage',_descriptor26,this);_initDefineProp(this,'sanityCheck',_descriptor27,this);_initDefineProp(this,'setSanityCheck',_descriptor28,this);_initDefineProp(this,'clearSanityCheck',_descriptor29,this);_initDefineProp(this,'sourcesMode',_descriptor30,this);_initDefineProp(this,'setSourcesMode',_descriptor31,this);_initDefineProp(this,'hoveredCounty',_descriptor32,this);_initDefineProp(this,'hoveredRace',_descriptor33,this);_initDefineProp(this,'setHover',_descriptor34,this);_initDefineProp(this,'searchIndicator',_descriptor35,this);_initDefineProp(this,'modifySearchString',_descriptor36,this);_initDefineProp(this,'countySearchString',_descriptor37,this);_initDefineProp(this,'countySearchResults',_descriptor38,this);_initDefineProp(this,'searchCounty',_descriptor39,this);}//so that ht changes due to keyboard dont mess up positions that depend on innerheight
_createClass(AppStore,[{key:'colorScale',get:function get(){var _this2=this;var opts=this.colorOptions;var allNums=this.indicator?Object.keys(__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][this.indicator].counties).map(function(cty){return __WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this2.indicator].counties[cty][_this2.race||'totals'][_this2.year];}).filter(function(o){var inv=o===''||o==='*';return inv?false:true;}):[0,100];var classes=__WEBPACK_IMPORTED_MODULE_1_chroma_js___default.a.limits(allNums,opts.breakAlgorithm,opts.classes);return __WEBPACK_IMPORTED_MODULE_1_chroma_js___default.a.scale(this.init&&this.screen!=='mobile'?['#f4f4f4','#bbbbbb']:opts.scheme).domain([0,100]).padding([opts.padLo,opts.padHi]).classes(classes);}}]);return AppStore;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'screen',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return Object(__WEBPACK_IMPORTED_MODULE_6__utilities_media__["b" /* getMedia */])();}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'mobileDeviceWidth',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return this.screen==='mobile'?window.innerWidth:0;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'mobileDeviceHeight',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return this.screen==='mobile'?window.innerHeight:0;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'resize',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["debounce"])(function(){var size=Object(__WEBPACK_IMPORTED_MODULE_6__utilities_media__["b" /* getMedia */])();if(_this3.screen!==size){// this.screen = size 
window.location.reload();}if(_this3.screen==='mobile'&&size==='mobile'){if(window.innerWidth!==_this3.mobileDeviceWidth){console.log('width changed for mobile; refresh');window.location.reload();}}else return;},150);}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'init',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'indicator',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'county',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'race',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'year',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'colorOptions',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{scheme:'OrRd',padLo:0,padHi:0,classes:4,breakAlgorithm:'e'//equidistant (also l or q)
};}}),_applyDecoratedDescriptor(_class.prototype,'colorScale',[__WEBPACK_IMPORTED_MODULE_0_mobx__["e" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'colorScale'),_class.prototype),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'setColorOption',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(which,what){return _this4.colorOptions[which]=what;};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'setYearIndex',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){var yrs=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this5.indicator].years;//these facile checks work for setting yearIndex presuming there's data, but break on
//complex selections wherein county/race may not have a value for this year, even if the ind
// has data for this year generally
var targetYear=_this5.year||0;if(!_this5.year&&yrs.length>1)targetYear=yrs.length-1;else if(!_this5.year)targetYear=0;else if(_this5.year===1&&yrs.length===1)targetYear=0;//next, test targetYr's validity datawise
if(Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this5.indicator].counties[_this5.county||'california'][_this5.race||'totals'][targetYear])){console.log('final gauntlet: indicator selection passed year validity test');_this5.year=targetYear;}else{console.log('year correction at setYearIndex');if(targetYear===0)targetYear=1;else targetYear=0;_this5.year=targetYear;}console.log('year '+_this5.year+' ('+yrs[_this5.year]+')');};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'completeWorkflow',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(which,value){var county=_this6.county,race=_this6.race,year=_this6.year;console.log('set',which,'to',value);//INDICATOR SELECTION CHECKS
if(which==='indicator'){if(!value){//clearing value for reset
_this6[which]=value;return;}var ind=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][value];console.log('attempting to select indicator');if(race&&!ind.categories.includes('hasRace')){//even without race, will this work with user's selected county?
if(county){var arr=ind.counties[county].totals;//without any races, does this county have valid values in the indicator?
if(arr.filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(v);}).length>0){//yes: sanity check just for race, we can keep the county
_this6.setSanityCheck('indicator',value,'This indicator has no race data; picking it will deselect your currently selected race ('+Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(race)+') and show data for all races instead.',function(){_this6.completeWorkflow('race',null);_this6.completeWorkflow('indicator',value);});}else{//no: sanity check for unselecting both race and county
_this6.setSanityCheck('indicator',value,'This indicator has no data for your selected race ('+Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(race)+') or county ('+__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default.a[county]+'), but you can view its statewide data for all races.',function(){_this6.completeWorkflow('race',null);_this6.completeWorkflow('county',null);_this6.completeWorkflow('indicator',value);});}}//user didn't have a county: we still need to sanity check race
else{_this6.setSanityCheck('indicator',value,'This indicator has no race data; picking it will deselect your currently selected race ('+Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(race)+') and show data for all races instead.',function(){_this6.completeWorkflow('race',null);_this6.completeWorkflow('indicator',value);});}return false;}//end facile race w. !hasRace condition
else{// the more complicated case: indicator has race, but does it for selected?
var _arr=ind.counties[county||'california'][race||'totals'];if(_arr.filter(function(val){return Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(val);}).length>0){//YES: indicator selection is valid, proceed
console.log('user\'s indicator selection is valid, proceed');}else{//no valid years for the user's selection combo
if(county&&race){//reset both race and county
_this6.setSanityCheck('indicator',value,'This indicator has no data for your selected race ('+Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(race)+') or county ('+__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default.a[county]+'), but you can view its statewide data for all races.',function(){_this6.completeWorkflow('race',null);_this6.completeWorkflow('county',null);_this6.completeWorkflow('indicator',value);});}else if(county){//reset county
_this6.setSanityCheck('indicator',value,// `This indicator has no data for ${countyLabels[county]} county, so picking it will revert your selection to all counties.`,
'This indicator has no data for '+__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default.a[county]+' county, but you can view statewide data.',function(){_this6.completeWorkflow('county',null);_this6.completeWorkflow('indicator',value);_this6.notify('unselectCounty',__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default.a[_this6.county],8000);});}else if(race){//reset race
_this6.setSanityCheck('indicator',value,'This indicator has no data for your selected race ('+Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(race)+'), so picking it will revert your selection to all races.',function(){_this6.completeWorkflow('race',null);_this6.completeWorkflow('indicator',value);});}return false;}}}// END INDICATOR CHECKS
//COUNTY SELECTION CHECKS
else if(which==='county'){console.log('county selection');if(_this6.indicator){var val=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].counties[value||'california'][_this6.race||'totals'][_this6.year];if(Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(val)){//valid: user can continue
console.log('user\'s selected county works with existing indicator/race/year');}else{//invalid: this combo of ind/county/race/year doesnt have a value
console.log('invalid county selection');if(value){var indCty=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].counties[value];//user picked a county (not CA)
if(indCty.totals.filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(v);}).length>0){//county contains values, at least
if(_this6.race){//no need to check for hasRace: should have never gotten to this point...
//if user has race, does county have values for that?
if(indCty[_this6.race].filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(v);}).length>0){//race does have values, just not your year
var yrs=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].years;var validYear=year===0?1:0;_this6.setSanityCheck('county',value,'This county doesn\'t have indicator data for your selected race in '+yrs[year]+', but you can view '+yrs[validYear]+'.',function(){_this6.completeWorkflow('year',validYear);_this6.completeWorkflow('county',value);});}else{//race has no values: does totals have current year?
if(Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(indCty.totals[year])){//yes: sanity check race
_this6.setSanityCheck('county',value,'This county doesn\'t have indicator data for your selected race, so picking it will revert your selection to all races.',function(){_this6.completeWorkflow('race',null);_this6.completeWorkflow('county',value);});}else{//no: sanity check race + year
var _yrs=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].years;var _validYear=year===0?1:0;_this6.setSanityCheck('county',value,'This county doesn\'t have indicator data for your selected race in '+_yrs[year]+', but you can view its indicator data from '+_yrs[_validYear]+' for all races.',function(){_this6.completeWorkflow('race',null);_this6.completeWorkflow('year',_validYear);_this6.completeWorkflow('county',value);});}}}// end race check
else{//county has values, but returned invalid: switch the year
var _yrs2=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].years;var _validYear2=year===0?1:0;_this6.setSanityCheck('county',value,'This county doesn\'t have indicator data from '+_yrs2[year]+', but you can view it for '+_yrs2[_validYear2]+'.',function(){_this6.completeWorkflow('year',_validYear2);_this6.completeWorkflow('county',value);});}}else{//county doesnt even have values, disallow selection
console.log('county contains no info for this indicator - disallowing entirely');if(_this6.screen==='mobile'){//this sanity check only happens on mobile...
_this6.setSanityCheck('county',value,'There\'s no indicator data for this county.',false);}return false;}}//end check if theres values
else{//null value for county; user is returning to california
//but this is still in the invalid part of the conditional; how could there be no value?
console.log('california doesnt have data for this indicator with race and/or year...this shouldnt happen - inds should always have both years and all races at the california level.');alert('Sorry, an error occurred with our data - please refresh the app.');}console.log('returning false');return false;}//end invalid values operations
}//end county-indicator comaptibilyt check
}// END COUNTY CHECK
else if(which==='race'&&_this6.indicator){// if(!this.checkValidity(which,value)){
//     console.log('tried to pick race but it woludve resulted in invalid value: canceling')
//     return
// }
if(!__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].categories.includes('hasRace')){console.log('whyd this happen? tried to select race when indicator !hasRace...FOH');return false;}var _arr2=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].counties[_this6.county||'california'][value||'totals'];if(Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(_arr2[_this6.year]))console.log('race selection valid');else{//invalid
console.log('race selection invalid, determining....');if(_arr2.filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(v);}).length>0){var otherYear=_this6.year===0?1:0;var sem=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].semantics;console.log('race selection can be sanity checked: year');_this6.setSanityCheck('race',value,'This indicator has no data for '+(value!=='other'?Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(value):'')+' '+sem.who+' '+(value==='other'?'of other races':'')+' in '+(_this6.county?__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default.a[_this6.county]:'California')+' for the year '+__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].years[_this6.year]+', but you can view '+__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].years[otherYear]+'.',function(){_this6.completeWorkflow('year',otherYear);_this6.completeWorkflow('race',value);});return false;}if(_this6.county&&__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].counties.california[value||'totals'].filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_9__utilities_isValid__["a" /* isValid */])(v);}).length>0){console.log('race selection can be sanity checked: county');var _sem=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].semantics;_this6.setSanityCheck('race',value,'This indicator doesn\'t have data for '+(value!=='other'?Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(value):'')+' '+_sem.who+' '+(value==='other'?'of other races':'')+' in '+_this6.county+', but you can see statewide data.',function(){_this6.completeWorkflow('county',null);_this6.completeWorkflow('race',value);});return false;}console.log('got to the end of the invalid race selection check without another solution...uh oh');alert('Sorry, an error occurred - please refresh the app.');}}// if(which==='indicator'){
//     if(indicators[value].years.length <= this.year){
//         this.year = 0
//     }
// }
_this6[which]=value;//query string logic
var queryString=[];if(_this6.indicator&&!_this6.init)queryString.push('ind='+_this6.indicator);if(_this6.county)queryString.push('cty='+_this6.county);if(_this6.race)queryString.push('race='+_this6.race);if((_this6.year===0||_this6.year)&&!_this6.init)queryString.push('yr='+_this6.year);queryString='?'+queryString.join('&');window.history.replaceState({},'',window.location.href.split('?')[0]+queryString);if(which==='indicator'){//ensure year validity when changing indicators
_this6.setYearIndex();//set color scheme for indicator category
var catColors={welfare:'PuRd',health:'BuGn',education:'Purples',earlyChildhood:'PuBu'};var mainCategory=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].categories.filter(function(o){return o!=='hasRace';})[0];_this6.setColorOption('scheme',catColors[mainCategory]);//assign padding values 
var allNums=Object.keys(__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].counties).map(function(cty){return __WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this6.indicator].counties[cty][_this6.race||'totals'][_this6.year];}).filter(function(o){var inv=o===''||o==='*';// if(inv) invalids++
return inv?false:true;});var lo=Math.min.apply(Math,_toConsumableArray(allNums));var hi=Math.max.apply(Math,_toConsumableArray(allNums));var range=hi-lo;// cases: small range, small range low % (too light), 
var adjustLo=0;var adjustHi=0;if(range<25){//small range
if(100-hi>lo){console.log('faint tight range');//small range low end (too light)
adjustLo=(100-hi)/2/100;adjustHi=-((100-hi)/2/100);}else{console.log('dark tight range');adjustLo=-(lo/2)/100;// adjustHi = 0.1
//small range high end (too dark)
}}else{//if the range is normal, but some items are too faint, make adjustment
if(lo<30){console.log('faint normal range');adjustLo=0.2;adjustHi=-((100-hi)/3/100);}}_this6.setColorOption('padLo',lo/100+adjustLo);_this6.setColorOption('padHi',1-hi/100+adjustHi);}console.log('returning true!');return true;};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'notifications',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{unselectCounty:null};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'notify',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(which,what,time){_this7.notifications[which]=what;if(time){setTimeout(function(){_this7.notifications[which]=null;},time);}};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'indicatorPageSize',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 1;}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'setIndicatorPages',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){var screen=_this8.screen;var pages=[];if(screen==='optimal'){_this8.indicatorPageSize=8;}else if(screen==='compact'){_this8.indicatorPageSize=9;}var indKeys=Object.keys(__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */]).filter(function(ind){var cats=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][ind].categories;if(_this8.indicatorSearchString&&_this8.indicatorFilter==='all'){return _this8.indicatorSearchResults.includes(ind);}else if(_this8.indicatorSearchString){return _this8.indicatorSearchResults.includes(ind)&&cats.includes(_this8.indicatorFilter);}else return _this8.indicatorFilter==='all'?true:cats.includes(_this8.indicatorFilter);});console.log('total inds:',indKeys.length);for(var i=0;i<indKeys.length/_this8.indicatorPageSize;i++){pages.push(indKeys.slice(i*_this8.indicatorPageSize,(i+1)*_this8.indicatorPageSize));}_this8.indicatorPages=pages;console.log(_this8.indicatorPages.toJS());};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'indicatorPages',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor19=_applyDecoratedDescriptor(_class.prototype,'indicatorListPage',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor20=_applyDecoratedDescriptor(_class.prototype,'indicatorFilter',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'all';}}),_descriptor21=_applyDecoratedDescriptor(_class.prototype,'indicatorSearchString',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor22=_applyDecoratedDescriptor(_class.prototype,'indicatorSearchResults',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor23=_applyDecoratedDescriptor(_class.prototype,'setIndicatorFilter',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(val){console.log('setting indicator filter to ',val);if(_this9.indicatorSearchString&&_this9.indicatorSearchResults.length===0){//clear an empty search if user is changing topic
_this9.modifySearchString('indicator','');}_this9.indicatorListPage=0;_this9.indicatorFilter=val;_this9.setIndicatorPages();};}}),_descriptor24=_applyDecoratedDescriptor(_class.prototype,'setIndicatorListPage',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this10=this;return function(val){console.log('setting indicator page to ',val);_this10.indicatorListPage=val;};}}),_descriptor25=_applyDecoratedDescriptor(_class.prototype,'sanityCheckIndicator',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor26=_applyDecoratedDescriptor(_class.prototype,'sanityCheckMessage',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor27=_applyDecoratedDescriptor(_class.prototype,'sanityCheck',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{indicator:null,county:null,race:null,year:null,message:'',action:function action(){}};}}),_descriptor28=_applyDecoratedDescriptor(_class.prototype,'setSanityCheck',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this11=this;return function(which,target,message,action){console.log('setting sanity check on',which,target);_this11.sanityCheck[which]=target;_this11.sanityCheck.message=message;_this11.sanityCheck.action=action;};}}),_descriptor29=_applyDecoratedDescriptor(_class.prototype,'clearSanityCheck',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this12=this;return function(which){console.log('clearing sanity check for',which);_this12.sanityCheck[which]=null;};}}),_descriptor30=_applyDecoratedDescriptor(_class.prototype,'sourcesMode',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor31=_applyDecoratedDescriptor(_class.prototype,'setSourcesMode',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this13=this;return function(tf){return _this13.sourcesMode=tf;};}}),_descriptor32=_applyDecoratedDescriptor(_class.prototype,'hoveredCounty',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor33=_applyDecoratedDescriptor(_class.prototype,'hoveredRace',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor34=_applyDecoratedDescriptor(_class.prototype,'setHover',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this14=this;return function(which,value,check){//dont complete race hover action if the race has no data
if(which==='race'&&value){var ind=__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][_this14.indicator];var cty=_this14.county?_this14.county:'california';if(!ind.categories.includes('hasRace'))return false;if(ind.counties[cty][value][_this14.year]===''||ind.counties[cty][value][_this14.year]==='*')return false;}if(check)return true;_this14['hovered'+Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(which)]=value;console.log('hovered',which,':',_this14['hovered'+Object(__WEBPACK_IMPORTED_MODULE_7__utilities_toLowerCase__["b" /* capitalize */])(which)]);};}}),_descriptor35=_applyDecoratedDescriptor(_class.prototype,'searchIndicator',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this15=this;return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["debounce"])(function(str){if(str){_this15.indicatorFilter='all';_this15.indicatorListPage=0;}var searchWords=str.split(' ').filter(function(word){return!__WEBPACK_IMPORTED_MODULE_10__utilities_stopwords___default.a.includes(word);});var matches=[];searchWords.forEach(function(word,i){matches[i]=Object.keys(Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["pickBy"])(__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */],function(ind){return ind.keywords.concat(ind.categories,__WEBPACK_IMPORTED_MODULE_2__data_indicators__["a" /* default */][ind.indicator].semantics.label.split(' ')).some(function(keyword){return keyword.toLowerCase().startsWith(word);});}));});var finalMatches=matches[0];if(matches.length>1){var _loop=function _loop(i){finalMatches=finalMatches.filter(function(match){return matches[i].includes(match);});};for(var i=1;i<matches.length;i++){_loop(i);}}_this15.indicatorSearchResults=finalMatches;if(_this15.screen!=='mobile')_this15.setIndicatorPages();},150);}}),_descriptor36=_applyDecoratedDescriptor(_class.prototype,'modifySearchString',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this16=this;return function(which,str){_this16[which+'SearchString']=str;if(which==='indicator'){_this16.searchIndicator(_this16.indicatorSearchString.toLowerCase());}if(which==='county'){_this16.searchCounty(_this16.countySearchString.toLowerCase());}};}}),_descriptor37=_applyDecoratedDescriptor(_class.prototype,'countySearchString',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor38=_applyDecoratedDescriptor(_class.prototype,'countySearchResults',[__WEBPACK_IMPORTED_MODULE_0_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return[];}}),_descriptor39=_applyDecoratedDescriptor(_class.prototype,'searchCounty',[__WEBPACK_IMPORTED_MODULE_0_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this17=this;return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["debounce"])(function(str){var matches=Object.values(__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default.a).filter(function(cty){return cty.toLowerCase().split(' ').some(function(word){return word.startsWith(str);});}).map(function(cty){return Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["findKey"])(__WEBPACK_IMPORTED_MODULE_4__assets_countyLabels___default.a,function(o){return o===cty;});});console.log(matches);_this17.countySearchResults=matches;},150);}})),_class);

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = {"indicator":"notFoodInsecure","semantics":{"who":"children","what":"were not food insecure","label":"Children who were not food insecure","shorthand":"Not food insecure"},"years":["2015","2016"],"keywords":["food","hunger","insecurity","hungry","eat","nourish","meals","nutrition"],"categories":["health"],"counties":{"california":{"ranks":["",""],"totals":[79,81]},"alameda":{"ranks":[9,6],"totals":[82,84]},"alpine":{"ranks":[15,22],"totals":[81,81]},"amador":{"ranks":[31,26],"totals":[77,80]},"butte":{"ranks":[34,36],"totals":[76,78]},"calaveras":{"ranks":[24,26],"totals":[79,80]},"colusa":{"ranks":[40,50],"totals":[75,75]},"contraCosta":{"ranks":[4,6],"totals":[83,84]},"delNorte":{"ranks":[52,44],"totals":[73,76]},"elDorado":{"ranks":[15,12],"totals":[81,83]},"fresno":{"ranks":[52,54],"totals":[73,74]},"glenn":{"ranks":[34,40],"totals":[76,77]},"humboldt":{"ranks":[34,32],"totals":[76,79]},"imperial":{"ranks":[58,58],"totals":[68,67]},"inyo":{"ranks":[15,12],"totals":[81,83]},"kern":{"ranks":[40,50],"totals":[75,75]},"kings":{"ranks":[40,44],"totals":[75,76]},"lake":{"ranks":[52,44],"totals":[73,76]},"lassen":{"ranks":[40,40],"totals":[75,77]},"losAngeles":{"ranks":[24,22],"totals":[79,81]},"madera":{"ranks":[40,44],"totals":[75,76]},"marin":{"ranks":[2,1],"totals":[84,87]},"mariposa":{"ranks":[31,36],"totals":[77,78]},"mendocino":{"ranks":[34,36],"totals":[76,78]},"merced":{"ranks":[52,54],"totals":[73,74]},"modoc":{"ranks":[34,32],"totals":[76,79]},"mono":{"ranks":[4,12],"totals":[83,83]},"monterey":{"ranks":[24,26],"totals":[79,80]},"napa":{"ranks":[4,4],"totals":[83,85]},"nevada":{"ranks":[24,22],"totals":[79,81]},"orange":{"ranks":[9,6],"totals":[82,84]},"placer":{"ranks":[9,6],"totals":[82,84]},"plumas":{"ranks":[49,40],"totals":[74,77]},"riverside":{"ranks":[20,22],"totals":[80,81]},"sacramento":{"ranks":[29,32],"totals":[78,79]},"sanBenito":{"ranks":[9,12],"totals":[82,83]},"sanBernardino":{"ranks":[24,26],"totals":[79,80]},"sanDiego":{"ranks":[15,12],"totals":[81,83]},"sanFrancisco":{"ranks":[4,4],"totals":[83,85]},"sanJoaquin":{"ranks":[31,32],"totals":[77,79]},"sanLuisObispo":{"ranks":[15,12],"totals":[81,83]},"sanMateo":{"ranks":[1,1],"totals":[85,87]},"santaBarbara":{"ranks":[9,12],"totals":[82,83]},"santaClara":{"ranks":[2,3],"totals":[84,86]},"santaCruz":{"ranks":[20,19],"totals":[80,82]},"shasta":{"ranks":[40,44],"totals":[75,76]},"sierra":{"ranks":[40,26],"totals":[75,80]},"siskiyou":{"ranks":[57,54],"totals":[72,74]},"solano":{"ranks":[20,19],"totals":[80,82]},"sonoma":{"ranks":[9,6],"totals":[82,84]},"stanislaus":{"ranks":[34,36],"totals":[76,78]},"sutter":{"ranks":[40,40],"totals":[75,77]},"tehama":{"ranks":[40,50],"totals":[75,75]},"trinity":{"ranks":[49,44],"totals":[74,76]},"tulare":{"ranks":[52,57],"totals":[73,73]},"tuolumne":{"ranks":[29,26],"totals":[78,80]},"ventura":{"ranks":[4,6],"totals":[83,84]},"yolo":{"ranks":[20,19],"totals":[80,82]},"yuba":{"ranks":[49,50],"totals":[74,75]}}}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {"indicator":"earlyPrenatalCare","semantics":{"descriptor":"pregnant","who":"women","what":"received prenatal care beginning the first trimester","label":"Pregnant women who received prenatal care beginning the first trimester","shorthand":"Early prenatal care"},"keywords":["pregnancy","infants","pregnant","mothers","prenatal","care","trimester","birth"],"years":["2015","2016"],"categories":["hasRace","earlyChildhood","health"],"counties":{"california":{"ranks":["",""],"black":[79,79],"white":[87,88],"asian":[85,85],"latinx":[81,82],"other":[81,82],"totals":[83,84]},"alameda":{"ranks":[1,2],"black":[88,85],"white":[92,92],"asian":[92,91],"latinx":[89,87],"other":[86,88],"totals":[90,89]},"alpine":{"ranks":["",""],"black":["","*"],"white":["","*"],"asian":["",""],"latinx":["",""],"other":["*","*"],"totals":["*","*"]},"amador":{"ranks":[10,7],"black":["*",""],"white":[84,88],"asian":["*","*"],"latinx":[88,83],"other":[96,86],"totals":[85,88]},"butte":{"ranks":[44,46],"black":[46,60],"white":[74,73],"asian":[47,52],"latinx":[68,61],"other":[56,71],"totals":[69,69]},"calaveras":{"ranks":[24,24],"black":["","*"],"white":[82,83],"asian":["*","*"],"latinx":[65,77],"other":[77,67],"totals":[79,80]},"colusa":{"ranks":[38,52],"black":["","*"],"white":[78,75],"asian":["*","*"],"latinx":[72,63],"other":["*","*"],"totals":[72,65]},"contraCosta":{"ranks":[8,6],"black":[83,84],"white":[91,92],"asian":[88,87],"latinx":[83,84],"other":[87,87],"totals":[87,88]},"delNorte":{"ranks":[52,34],"black":["",""],"white":[71,75],"asian":[84,93],"latinx":[70,77],"other":[41,67],"totals":[65,75]},"elDorado":{"ranks":[22,30],"black":["*","*"],"white":[84,81],"asian":[89,87],"latinx":[76,65],"other":[76,82],"totals":[82,78]},"fresno":{"ranks":[4,4],"black":[90,84],"white":[92,92],"asian":[89,88],"latinx":[87,87],"other":[87,87],"totals":[88,88]},"glenn":{"ranks":[44,53],"black":["*","*"],"white":[77,72],"asian":["*","*"],"latinx":[65,57],"other":["*","*"],"totals":[69,65]},"humboldt":{"ranks":[31,26],"black":["*",63],"white":[80,83],"asian":[71,82],"latinx":[74,81],"other":[66,65],"totals":[76,80]},"imperial":{"ranks":[57,56],"black":[52,"*"],"white":[54,66],"asian":[57,66],"latinx":[39,58],"other":[44,57],"totals":[41,59]},"inyo":{"ranks":[33,31],"black":["","*"],"white":[80,84],"asian":["*","*"],"latinx":[76,90],"other":[67,57],"totals":[75,78]},"kern":{"ranks":[32,32],"black":[66,70],"white":[80,82],"asian":[83,85],"latinx":[75,76],"other":[66,66],"totals":[76,78]},"kings":{"ranks":[44,46],"black":[71,65],"white":[73,76],"asian":[72,80],"latinx":[67,65],"other":[76,74],"totals":[69,69]},"lake":{"ranks":[43,45],"black":["*","*"],"white":[73,73],"asian":["*","*"],"latinx":[67,66],"other":[58,56],"totals":[70,69]},"lassen":{"ranks":[51,41],"black":["*","*"],"white":[69,75],"asian":["*","*"],"latinx":[56,64],"other":[73,59],"totals":[66,71]},"losAngeles":{"ranks":[12,13],"black":[76,77],"white":[90,90],"asian":[85,86],"latinx":[84,84],"other":[83,84],"totals":[85,85]},"madera":{"ranks":[30,35],"black":[59,54],"white":[82,85],"asian":[70,74],"latinx":[75,72],"other":[86,80],"totals":[77,74]},"marin":{"ranks":[3,12],"black":[79,69],"white":[92,89],"asian":[86,84],"latinx":[84,82],"other":[86,84],"totals":[89,86]},"mariposa":{"ranks":[56,55],"black":["",""],"white":[63,64],"asian":["*",""],"latinx":[46,55],"other":["*","*"],"totals":[62,62]},"mendocino":{"ranks":[50,40],"black":["*","*"],"white":[68,72],"asian":[73,"*"],"latinx":[67,76],"other":[63,57],"totals":[67,71]},"merced":{"ranks":[49,50],"black":[62,62],"white":[75,72],"asian":[57,55],"latinx":[67,68],"other":[74,69],"totals":[68,68]},"modoc":{"ranks":[53,57],"black":["",""],"white":[70,47],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[64,50]},"mono":{"ranks":[34,44],"black":["","*"],"white":[77,67],"asian":["*","*"],"latinx":[76,72],"other":["*","*"],"totals":[75,70]},"monterey":{"ranks":[37,33],"black":[74,79],"white":[85,90],"asian":[75,85],"latinx":[69,72],"other":[81,82],"totals":[73,76]},"napa":{"ranks":[7,3],"black":[92,"*"],"white":[90,91],"asian":[86,93],"latinx":[86,85],"other":[86,96],"totals":[87,89]},"nevada":{"ranks":[42,29],"black":["*","*"],"white":[71,79],"asian":["*",79],"latinx":[70,80],"other":[61,66],"totals":[70,78]},"orange":{"ranks":[8,11],"black":[84,81],"white":[93,92],"asian":[81,78],"latinx":[87,87],"other":[85,88],"totals":[87,86]},"placer":{"ranks":[21,19],"black":[79,80],"white":[84,85],"asian":[85,87],"latinx":[72,74],"other":[85,81],"totals":[82,83]},"plumas":{"ranks":[48,39],"black":["","*"],"white":[69,74],"asian":["*","*"],"latinx":["*",75],"other":["*",61],"totals":[68,72]},"riverside":{"ranks":[18,17],"black":[81,82],"white":[86,87],"asian":[80,80],"latinx":[83,83],"other":[81,81],"totals":[83,83]},"sacramento":{"ranks":[13,15],"black":[84,83],"white":[84,85],"asian":[86,85],"latinx":[82,85],"other":[84,82],"totals":[84,85]},"sanBenito":{"ranks":[15,8],"black":["*","*"],"white":[86,88],"asian":[85,100],"latinx":[83,86],"other":[76,91],"totals":[84,87]},"sanBernardino":{"ranks":[14,18],"black":[79,77],"white":[85,84],"asian":[80,80],"latinx":[85,84],"other":[81,81],"totals":[84,83]},"sanDiego":{"ranks":[17,16],"black":[83,80],"white":[89,90],"asian":[89,88],"latinx":[79,80],"other":[75,78],"totals":[84,84]},"sanFrancisco":{"ranks":[5,9],"black":[68,72],"white":[94,93],"asian":[88,88],"latinx":[77,77],"other":[87,84],"totals":[87,87]},"sanJoaquin":{"ranks":[29,25],"black":[70,74],"white":[81,84],"asian":[78,81],"latinx":[75,78],"other":[81,80],"totals":[77,80]},"sanLuisObispo":{"ranks":[23,27],"black":[81,88],"white":[83,84],"asian":[83,68],"latinx":[79,75],"other":[81,75],"totals":[82,79]},"sanMateo":{"ranks":[2,1],"black":[86,88],"white":[94,94],"asian":[88,90],"latinx":[88,88],"other":[88,89],"totals":[90,91]},"santaBarbara":{"ranks":[28,28],"black":[80,72],"white":[88,87],"asian":[84,89],"latinx":[73,74],"other":[80,88],"totals":[77,79]},"santaClara":{"ranks":[10,10],"black":[74,79],"white":[92,92],"asian":[88,89],"latinx":[76,78],"other":[90,90],"totals":[85,87]},"santaCruz":{"ranks":[15,20],"black":[77,79],"white":[94,91],"asian":[85,93],"latinx":[77,75],"other":[88,84],"totals":[84,82]},"shasta":{"ranks":[36,38],"black":[61,68],"white":[75,75],"asian":[68,58],"latinx":[72,65],"other":[65,61],"totals":[73,72]},"sierra":{"ranks":[55,54],"black":["",""],"white":[67,68],"asian":["",""],"latinx":["*","*"],"other":["*","*"],"totals":[62,65]},"siskiyou":{"ranks":[27,36],"black":["*","*"],"white":[79,78],"asian":["*","*"],"latinx":[79,60],"other":[71,73],"totals":[78,73]},"solano":{"ranks":[26,23],"black":[80,79],"white":[83,84],"asian":[81,84],"latinx":[74,77],"other":[80,81],"totals":[79,81]},"sonoma":{"ranks":[5,5],"black":[80,75],"white":[90,89],"asian":[84,82],"latinx":[86,87],"other":[86,87],"totals":[87,88]},"stanislaus":{"ranks":[25,22],"black":[68,75],"white":[84,84],"asian":[76,82],"latinx":[78,79],"other":[72,80],"totals":[79,81]},"sutter":{"ranks":[39,42],"black":[73,57],"white":[75,78],"asian":[70,75],"latinx":[66,61],"other":[78,75],"totals":[71,71]},"tehama":{"ranks":[41,49],"black":["*","*"],"white":[72,71],"asian":["*","*"],"latinx":[69,64],"other":[68,71],"totals":[70,68]},"trinity":{"ranks":[54,51],"black":["",""],"white":[66,68],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[62,66]},"tulare":{"ranks":[35,37],"black":[68,63],"white":[74,72],"asian":[66,71],"latinx":[75,74],"other":[67,64],"totals":[74,73]},"tuolumne":{"ranks":[40,46],"black":["*","*"],"white":[74,72],"asian":["*","*"],"latinx":[59,61],"other":[54,59],"totals":[70,69]},"ventura":{"ranks":[19,14],"black":[78,86],"white":[92,92],"asian":[90,92],"latinx":[77,80],"other":[83,83],"totals":[83,85]},"yolo":{"ranks":[20,21],"black":[81,79],"white":[84,85],"asian":[84,84],"latinx":[82,79],"other":[77,77],"totals":[83,82]},"yuba":{"ranks":[47,43],"black":[69,61],"white":[72,74],"asian":[67,61],"latinx":[64,66],"other":[64,74],"totals":[69,70]},"":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]}}}

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = {"indicator":"registeredToVote","semantics":{"who":"18-25-year-olds","shortWho":"18-25 y/o's","what":"were registered to vote","label":"18-25-year-olds registered to vote","shorthand":"Young adult voter registration"},"keywords":["vote","election","registration","registered"],"years":["2016"],"categories":["education"],"counties":{"california":{"ranks":[""],"totals":[48]},"alameda":{"ranks":[13],"totals":[48]},"alpine":{"ranks":[56],"totals":[31]},"amador":{"ranks":[41],"totals":[38]},"butte":{"ranks":[35],"totals":[39]},"calaveras":{"ranks":[43],"totals":[37]},"colusa":{"ranks":[43],"totals":[37]},"contraCosta":{"ranks":[5],"totals":[56]},"delNorte":{"ranks":[43],"totals":[37]},"elDorado":{"ranks":[24],"totals":[43]},"fresno":{"ranks":[24],"totals":[43]},"glenn":{"ranks":[50],"totals":[35]},"humboldt":{"ranks":[35],"totals":[39]},"imperial":{"ranks":[43],"totals":[37]},"inyo":{"ranks":[50],"totals":[35]},"kern":{"ranks":[29],"totals":[41]},"kings":{"ranks":[50],"totals":[35]},"lake":{"ranks":[43],"totals":[37]},"lassen":{"ranks":[56],"totals":[31]},"losAngeles":{"ranks":[7],"totals":[50]},"madera":{"ranks":[50],"totals":[35]},"marin":{"ranks":[2],"totals":[58]},"mariposa":{"ranks":[48],"totals":[36]},"mendocino":{"ranks":[41],"totals":[38]},"merced":{"ranks":[32],"totals":[40]},"modoc":{"ranks":[58],"totals":[30]},"mono":{"ranks":[48],"totals":[36]},"monterey":{"ranks":[29],"totals":[41]},"napa":{"ranks":[13],"totals":[48]},"nevada":{"ranks":[24],"totals":[43]},"orange":{"ranks":[7],"totals":[50]},"placer":{"ranks":[1],"totals":[69]},"plumas":{"ranks":[22],"totals":[44]},"riverside":{"ranks":[19],"totals":[45]},"sacramento":{"ranks":[27],"totals":[42]},"sanBenito":{"ranks":[9],"totals":[49]},"sanBernardino":{"ranks":[19],"totals":[45]},"sanDiego":{"ranks":[9],"totals":[49]},"sanFrancisco":{"ranks":[2],"totals":[58]},"sanJoaquin":{"ranks":[22],"totals":[44]},"sanLuisObispo":{"ranks":[13],"totals":[48]},"sanMateo":{"ranks":[2],"totals":[58]},"santaBarbara":{"ranks":[13],"totals":[48]},"santaClara":{"ranks":[9],"totals":[49]},"santaCruz":{"ranks":[17],"totals":[46]},"shasta":{"ranks":[17],"totals":[46]},"sierra":{"ranks":[50],"totals":[35]},"siskiyou":{"ranks":[35],"totals":[39]},"solano":{"ranks":[27],"totals":[42]},"sonoma":{"ranks":[9],"totals":[49]},"stanislaus":{"ranks":[32],"totals":[40]},"sutter":{"ranks":[29],"totals":[41]},"tehama":{"ranks":[35],"totals":[39]},"trinity":{"ranks":[55],"totals":[33]},"tulare":{"ranks":[19],"totals":[45]},"tuolumne":{"ranks":[35],"totals":[39]},"ventura":{"ranks":[6],"totals":[54]},"yolo":{"ranks":[32],"totals":[40]},"yuba":{"ranks":[35],"totals":[39]}}}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = {"indicator":"upToDateImmunizations","semantics":{"who":"Kindergarteners","what":"had up-to-date immunizations","label":"Kindergarteners with up-to-date immunizations","shorthand":"Up-to-date immunizations"},"keywords":["immunization","vaccine","up","to","date","vaccination","sickness"],"years":["2017","2018"],"categories":["health","earlyChildhood"],"counties":{"california":{"ranks":["",""],"totals":[96,95]},"alameda":{"ranks":[6,11],"totals":[97,97]},"alpine":{"ranks":["",""],"totals":["*","*"]},"amador":{"ranks":[18,40],"totals":[96,92]},"butte":{"ranks":[35,26],"totals":[94,95]},"calaveras":{"ranks":[49,51],"totals":[90,88]},"colusa":{"ranks":[6,1],"totals":[97,99]},"contraCosta":{"ranks":[6,19],"totals":[97,96]},"delNorte":{"ranks":[39,2],"totals":[93,98]},"elDorado":{"ranks":[35,45],"totals":[94,90]},"fresno":{"ranks":[6,19],"totals":[97,96]},"glenn":{"ranks":[6,2],"totals":[97,98]},"humboldt":{"ranks":[53,51],"totals":[87,88]},"imperial":{"ranks":[6,2],"totals":[97,98]},"inyo":{"ranks":[31,2],"totals":[95,98]},"kern":{"ranks":[31,38],"totals":[95,93]},"kings":{"ranks":[2,2],"totals":[98,98]},"lake":{"ranks":[18,35],"totals":[96,94]},"lassen":{"ranks":[46,26],"totals":[91,95]},"losAngeles":{"ranks":[31,26],"totals":[95,95]},"madera":{"ranks":[18,26],"totals":[96,95]},"marin":{"ranks":[39,35],"totals":[93,94]},"mariposa":{"ranks":["",45],"totals":["*",90]},"mendocino":{"ranks":[51,53],"totals":[89,87]},"merced":{"ranks":[2,11],"totals":[98,97]},"modoc":{"ranks":[56,2],"totals":[79,98]},"mono":{"ranks":[35,45],"totals":[94,90]},"monterey":{"ranks":[2,11],"totals":[98,97]},"napa":{"ranks":[18,26],"totals":[96,95]},"nevada":{"ranks":[55,56],"totals":[81,82]},"orange":{"ranks":[18,19],"totals":[96,96]},"placer":{"ranks":[44,40],"totals":[92,92]},"plumas":{"ranks":[49,44],"totals":[90,91]},"riverside":{"ranks":[18,11],"totals":[96,97]},"sacramento":{"ranks":[35,35],"totals":[94,94]},"sanBenito":{"ranks":[2,2],"totals":[98,98]},"sanBernardino":{"ranks":[18,11],"totals":[96,97]},"sanDiego":{"ranks":[31,38],"totals":[95,93]},"sanFrancisco":{"ranks":[18,26],"totals":[96,95]},"sanJoaquin":{"ranks":[6,19],"totals":[97,96]},"sanLuisObispo":{"ranks":[18,26],"totals":[96,95]},"sanMateo":{"ranks":[6,11],"totals":[97,97]},"santaBarbara":{"ranks":[18,11],"totals":[96,97]},"santaClara":{"ranks":[6,11],"totals":[97,97]},"santaCruz":{"ranks":[46,45],"totals":[91,90]},"shasta":{"ranks":[44,45],"totals":[92,90]},"sierra":{"ranks":[18,26],"totals":[96,95]},"siskiyou":{"ranks":[39,45],"totals":[93,90]},"solano":{"ranks":[6,2],"totals":[97,98]},"sonoma":{"ranks":[39,40],"totals":[93,92]},"stanislaus":{"ranks":[6,19],"totals":[97,96]},"sutter":{"ranks":[54,57],"totals":[85,78]},"tehama":{"ranks":[39,19],"totals":[93,96]},"trinity":{"ranks":[46,55],"totals":[91,85]},"tulare":{"ranks":[1,2],"totals":[99,98]},"tuolumne":{"ranks":[51,53],"totals":[89,87]},"ventura":{"ranks":[18,19],"totals":[96,96]},"yolo":{"ranks":[6,26],"totals":[97,95]},"yuba":{"ranks":[18,40],"totals":[96,92]}}}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = {"indicator":"lowIncomeDental","semantics":{"descriptor":"Low-income","who":"children","shortWho":"0-5 y/o's","what":", ages birth-5, had visited a dentist in the last year","label":"Children, ages birth-5, of low-income families, who had visited a dentist in the last year","shorthand":"Low-income families' dental visits"},"years":["2015","2016"],"keywords":["dental","dentist","low","income","teeth","exam","visit"],"categories":["hasRace","health","earlyChildhood"],"counties":{"california":{"ranks":["",""],"black":[20,20],"white":[20,19],"asian":[24,23],"latinx":[30,30],"other":[22,22],"totals":[26,26]},"alameda":{"ranks":[28,35],"black":[25,23],"white":[22,21],"asian":[33,31],"latinx":[35,33],"other":[27,24],"totals":[28,27]},"alpine":{"ranks":["",58],"black":["",0],"white":["",0],"asian":["",""],"latinx":["",0],"other":["",0],"totals":["",0]},"amador":{"ranks":[53,44],"black":["",0],"white":[13,32],"asian":["",0],"latinx":[22,24],"other":[12,7],"totals":[14,22]},"butte":{"ranks":[14,13],"black":[26,22],"white":[35,35],"asian":[31,24],"latinx":[45,57],"other":[31,26],"totals":[37,37]},"calaveras":{"ranks":[54,56],"black":["",0],"white":[12,13],"asian":["",0],"latinx":[20,22],"other":[11,6],"totals":[13,14]},"colusa":{"ranks":[4,27],"black":["",0],"white":[23,24],"asian":["",0],"latinx":[50,32],"other":[39,13],"totals":[47,30]},"contraCosta":{"ranks":[47,48],"black":[27,36],"white":[19,27],"asian":[27,38],"latinx":[27,24],"other":[23,15],"totals":[21,19]},"delNorte":{"ranks":[16,12],"black":["",0],"white":[33,48],"asian":[22,0],"latinx":[30,33],"other":[30,23],"totals":[36,37]},"elDorado":{"ranks":[33,28],"black":["",""],"white":[22,37],"asian":[9,0],"latinx":[39,26],"other":[17,16],"totals":[27,30]},"fresno":{"ranks":[41,41],"black":[30,43],"white":[27,38],"asian":[24,19],"latinx":[25,24],"other":[25,26],"totals":[23,22]},"glenn":{"ranks":[2,1],"black":["",""],"white":[26,23],"asian":["",0],"latinx":[55,54],"other":[39,14],"totals":[49,61]},"humboldt":{"ranks":[24,49],"black":[43,22],"white":[25,23],"asian":[37,17],"latinx":[26,53],"other":[36,29],"totals":[29,19]},"imperial":{"ranks":[50,15],"black":[24,24],"white":[15,17],"asian":["",0],"latinx":[19,37],"other":[19,18],"totals":[18,36]},"inyo":{"ranks":[17,17],"black":["",""],"white":[15,18],"asian":["",0],"latinx":[26,30],"other":[62,26],"totals":[35,36]},"kern":{"ranks":[26,34],"black":[38,35],"white":[21,44],"asian":[28,26],"latinx":[32,30],"other":[27,28],"totals":[29,27]},"kings":{"ranks":[38,40],"black":[22,20],"white":[31,42],"asian":[22,17],"latinx":[38,55],"other":[31,20],"totals":[24,24]},"lake":{"ranks":[11,7],"black":[63,28],"white":[35,37],"asian":["",0],"latinx":[47,45],"other":[32,28],"totals":[40,40]},"lassen":{"ranks":[13,23],"black":["",0],"white":[25,31],"asian":[69,0],"latinx":[37,22],"other":[39,14],"totals":[38,32]},"losAngeles":{"ranks":[31,32],"black":[21,22],"white":[22,19],"asian":[26,23],"latinx":[31,32],"other":[27,24],"totals":[28,28]},"madera":{"ranks":[5,29],"black":[21,19],"white":[30,20],"asian":[34,0],"latinx":[50,33],"other":[40,22],"totals":[45,29]},"marin":{"ranks":[3,4],"black":[28,26],"white":[31,35],"asian":[45,59],"latinx":[59,58],"other":[22,23],"totals":[47,47]},"mariposa":{"ranks":[55,57],"black":["",0],"white":[12,8],"asian":["",0],"latinx":[37,12],"other":[0,0],"totals":[11,8]},"mendocino":{"ranks":[7,8],"black":["",0],"white":[25,33],"asian":["",0],"latinx":[52,32],"other":[41,22],"totals":[43,39]},"merced":{"ranks":[40,3],"black":[19,17],"white":[17,16],"asian":[26,20],"latinx":[37,51],"other":[16,22],"totals":[23,48]},"modoc":{"ranks":[39,45],"black":["",""],"white":[24,18],"asian":["",0],"latinx":[47,27],"other":[0,7],"totals":[23,21]},"mono":{"ranks":[1,19],"black":["",0],"white":[34,23],"asian":["",""],"latinx":[67,41],"other":["",12],"totals":[52,34]},"monterey":{"ranks":[12,14],"black":[28,31],"white":[35,23],"asian":[46,35],"latinx":[41,39],"other":[35,27],"totals":[38,37]},"napa":{"ranks":[22,25],"black":[47,19],"white":[26,25],"asian":[36,0],"latinx":[38,37],"other":[35,20],"totals":[32,31]},"nevada":{"ranks":[37,52],"black":["",0],"white":[17,17],"asian":["",0],"latinx":[19,18],"other":[12,7],"totals":[25,16]},"orange":{"ranks":[23,26],"black":[34,22],"white":[20,20],"asian":[33,26],"latinx":[35,35],"other":[24,25],"totals":[30,31]},"placer":{"ranks":[30,11],"black":[31,14],"white":[16,35],"asian":[19,20],"latinx":[46,40],"other":[20,12],"totals":[28,38]},"plumas":{"ranks":[43,47],"black":["",0],"white":[23,18],"asian":["",0],"latinx":[56,32],"other":[15,4],"totals":[22,19]},"riverside":{"ranks":[45,46],"black":[28,41],"white":[26,37],"asian":[30,24],"latinx":[24,23],"other":[18,19],"totals":[21,20]},"sacramento":{"ranks":[51,50],"black":[21,17],"white":[12,15],"asian":[26,42],"latinx":[29,23],"other":[18,24],"totals":[16,19]},"sanBenito":{"ranks":[8,5],"black":["",""],"white":[18,19],"asian":["",0],"latinx":[47,63],"other":[21,16],"totals":[43,44]},"sanBernardino":{"ranks":[42,42],"black":[28,40],"white":[28,38],"asian":[28,48],"latinx":[25,24],"other":[19,19],"totals":[23,22]},"sanDiego":{"ranks":[25,30],"black":[38,36],"white":[21,22],"asian":[32,34],"latinx":[35,34],"other":[25,24],"totals":[29,29]},"sanFrancisco":{"ranks":[20,20],"black":[36,42],"white":[27,17],"asian":[43,44],"latinx":[58,39],"other":[27,20],"totals":[33,34]},"sanJoaquin":{"ranks":[49,51],"black":[15,35],"white":[22,14],"asian":[21,21],"latinx":[32,48],"other":[14,16],"totals":[19,18]},"sanLuisObispo":{"ranks":[19,18],"black":[57,19],"white":[26,26],"asian":[45,33],"latinx":[46,47],"other":[37,22],"totals":[34,34]},"sanMateo":{"ranks":[35,39],"black":[27,20],"white":[21,16],"asian":[27,20],"latinx":[33,31],"other":[25,16],"totals":[26,25]},"santaBarbara":{"ranks":[27,33],"black":[33,25],"white":[30,28],"asian":[22,22],"latinx":[28,61],"other":[26,18],"totals":[28,28]},"santaClara":{"ranks":[34,36],"black":[32,20],"white":[23,32],"asian":[30,30],"latinx":[31,29],"other":[29,27],"totals":[27,26]},"santaCruz":{"ranks":[21,21],"black":[37,19],"white":[19,28],"asian":[48,20],"latinx":[39,39],"other":[29,24],"totals":[33,33]},"shasta":{"ranks":[32,10],"black":[15,20],"white":[26,26],"asian":[30,19],"latinx":[23,23],"other":[33,26],"totals":[27,38]},"sierra":{"ranks":[57,54],"black":["",""],"white":["",0],"asian":["",0],"latinx":["",0],"other":["",0],"totals":[0,16]},"siskiyou":{"ranks":[44,55],"black":["",0],"white":[13,14],"asian":["",0],"latinx":[21,20],"other":[30,11],"totals":[22,15]},"solano":{"ranks":[48,24],"black":[29,28],"white":[23,33],"asian":[23,23],"latinx":[40,40],"other":[23,20],"totals":[21,32]},"sonoma":{"ranks":[18,22],"black":[29,21],"white":[30,33],"asian":[48,30],"latinx":[46,44],"other":[30,24],"totals":[34,32]},"stanislaus":{"ranks":[46,43],"black":[19,45],"white":[25,41],"asian":[21,21],"latinx":[34,55],"other":[14,16],"totals":[21,22]},"sutter":{"ranks":[6,2],"black":[52,28],"white":[25,38],"asian":[30,34],"latinx":[48,48],"other":[25,21],"totals":[44,59]},"tehama":{"ranks":[9,6],"black":["",0],"white":[38,36],"asian":["",0],"latinx":[50,51],"other":[41,20],"totals":[43,43]},"trinity":{"ranks":[56,37],"black":["",0],"white":[9,28],"asian":["",0],"latinx":[30,0],"other":[0,0],"totals":[10,25]},"tulare":{"ranks":[36,38],"black":[30,44],"white":[29,39],"asian":[23,28],"latinx":[28,27],"other":[28,34],"totals":[26,25]},"tuolumne":{"ranks":[52,53],"black":["",0],"white":[15,16],"asian":["",0],"latinx":[20,22],"other":[21,7],"totals":[16,16]},"ventura":{"ranks":[29,31],"black":[19,18],"white":[30,42],"asian":[30,19],"latinx":[47,32],"other":[24,23],"totals":[28,28]},"yolo":{"ranks":[15,16],"black":[22,20],"white":[28,37],"asian":[23,28],"latinx":[43,42],"other":[31,16],"totals":[37,36]},"yuba":{"ranks":[10,9],"black":[26,25],"white":[41,36],"asian":[37,25],"latinx":[49,46],"other":[37,15],"totals":[42,38]}}}

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = {"indicator":"collegeCareerReady","semantics":{"who":"students","what":"were college-or-career-ready","label":"Students who were college-or-career-ready","shorthand":"College / career readiness"},"years":["2017"],"keywords":["college","career","ready","readiness","graduation","university","school","job"],"categories":["hasRace","education"],"counties":{"california":{"ranks":[""],"black":[28],"white":[48],"asian":[57],"latinx":[33],"other":[43],"totals":[41]},"alameda":{"ranks":[11],"black":[28],"white":[57],"asian":[56],"latinx":[38],"other":[58],"totals":[52]},"alpine":{"ranks":[""],"black":[""],"white":[""],"asian":[""],"latinx":[""],"other":[""],"totals":[""]},"amador":{"ranks":[47],"black":[""],"white":[34],"asian":["*"],"latinx":[14],"other":["*"],"totals":[32]},"butte":{"ranks":[41],"black":[29],"white":[39],"asian":[69],"latinx":[29],"other":[30],"totals":[36]},"calaveras":{"ranks":[51],"black":["*"],"white":[33],"asian":["*"],"latinx":[24],"other":[27],"totals":[30]},"colusa":{"ranks":[35],"black":["*"],"white":[52],"asian":["*"],"latinx":[32],"other":["*"],"totals":[37]},"contraCosta":{"ranks":[19],"black":[32],"white":[50],"asian":[54],"latinx":[37],"other":[46],"totals":[46]},"delNorte":{"ranks":[53],"black":[""],"white":[24],"asian":[63],"latinx":[21],"other":[29],"totals":[28]},"elDorado":{"ranks":[22],"black":[35],"white":[48],"asian":[69],"latinx":[35],"other":[69],"totals":[44]},"fresno":{"ranks":[31],"black":[23],"white":[51],"asian":[52],"latinx":[38],"other":[37],"totals":[40]},"glenn":{"ranks":[56],"black":["*"],"white":[37],"asian":["*"],"latinx":[26],"other":["*"],"totals":[25]},"humboldt":{"ranks":[45],"black":["*"],"white":[39],"asian":[39],"latinx":[24],"other":[35],"totals":[32]},"imperial":{"ranks":[42],"black":[25],"white":[55],"asian":[58],"latinx":[34],"other":["*"],"totals":[35]},"inyo":{"ranks":[5],"black":["*"],"white":[66],"asian":["*"],"latinx":[28],"other":[13],"totals":[56]},"kern":{"ranks":[44],"black":[19],"white":[37],"asian":[43],"latinx":[30],"other":[25],"totals":[32]},"kings":{"ranks":[52],"black":[30],"white":[45],"asian":[60],"latinx":[25],"other":[18],"totals":[28]},"lake":{"ranks":[39],"black":["*"],"white":[37],"asian":["*"],"latinx":[37],"other":["*"],"totals":[36]},"lassen":{"ranks":[57],"black":["*"],"white":[19],"asian":["*"],"latinx":[32],"other":[13],"totals":[17]},"losAngeles":{"ranks":[14],"black":[33],"white":[55],"asian":[57],"latinx":[42],"other":[46],"totals":[50]},"madera":{"ranks":[49],"black":[25],"white":[39],"asian":[81],"latinx":[22],"other":[36],"totals":[31]},"marin":{"ranks":[7],"black":[19],"white":[61],"asian":[71],"latinx":[42],"other":[64],"totals":[55]},"mariposa":{"ranks":[48],"black":["*"],"white":[33],"asian":["*"],"latinx":[24],"other":["*"],"totals":[31]},"mendocino":{"ranks":[46],"black":["*"],"white":[40],"asian":["*"],"latinx":[34],"other":[27],"totals":[32]},"merced":{"ranks":[40],"black":[24],"white":[46],"asian":[53],"latinx":[33],"other":[30],"totals":[36]},"modoc":{"ranks":[50],"black":[""],"white":[50],"asian":["*"],"latinx":[19],"other":["*"],"totals":[30]},"mono":{"ranks":[33],"black":[""],"white":[51],"asian":["*"],"latinx":[26],"other":["*"],"totals":[38]},"monterey":{"ranks":[23],"black":[27],"white":[51],"asian":[52],"latinx":[36],"other":[59],"totals":[44]},"napa":{"ranks":[13],"black":[41],"white":[62],"asian":[58],"latinx":[44],"other":[56],"totals":[51]},"nevada":{"ranks":[6],"black":["*"],"white":[58],"asian":["*"],"latinx":[44],"other":[40],"totals":[55]},"orange":{"ranks":[3],"black":[41],"white":[62],"asian":[65],"latinx":[44],"other":[62],"totals":[58]},"placer":{"ranks":[2],"black":[55],"white":[64],"asian":[63],"latinx":[46],"other":[57],"totals":[60]},"plumas":{"ranks":[8],"black":[""],"white":[58],"asian":[""],"latinx":[55],"other":["*"],"totals":[54]},"riverside":{"ranks":[32],"black":[33],"white":[45],"asian":[57],"latinx":[35],"other":[42],"totals":[39]},"sacramento":{"ranks":[29],"black":[21],"white":[45],"asian":[51],"latinx":[33],"other":[31],"totals":[40]},"sanBenito":{"ranks":[34],"black":["*"],"white":[48],"asian":[77],"latinx":[32],"other":["*"],"totals":[38]},"sanBernardino":{"ranks":[43],"black":[22],"white":[38],"asian":[57],"latinx":[30],"other":[45],"totals":[33]},"sanDiego":{"ranks":[15],"black":[43],"white":[60],"asian":[61],"latinx":[42],"other":[46],"totals":[50]},"sanFrancisco":{"ranks":[4],"black":[16],"white":[56],"asian":[53],"latinx":[28],"other":[42],"totals":[57]},"sanJoaquin":{"ranks":[28],"black":[28],"white":[42],"asian":[45],"latinx":[35],"other":[32],"totals":[40]},"sanLuisObispo":{"ranks":[18],"black":["*"],"white":[55],"asian":[58],"latinx":[40],"other":[65],"totals":[47]},"sanMateo":{"ranks":[16],"black":[17],"white":[59],"asian":[51],"latinx":[33],"other":[59],"totals":[48]},"santaBarbara":{"ranks":[25],"black":[25],"white":[60],"asian":[58],"latinx":[32],"other":[57],"totals":[42]},"santaClara":{"ranks":[1],"black":[37],"white":[64],"asian":[59],"latinx":[36],"other":[43],"totals":[60]},"santaCruz":{"ranks":[10],"black":[36],"white":[60],"asian":[46],"latinx":[44],"other":[68],"totals":[52]},"shasta":{"ranks":[36],"black":[19],"white":[38],"asian":[49],"latinx":[36],"other":[31],"totals":[37]},"sierra":{"ranks":[9],"black":[""],"white":[63],"asian":[""],"latinx":["*"],"other":[""],"totals":[54]},"siskiyou":{"ranks":[12],"black":["*"],"white":[60],"asian":["*"],"latinx":[47],"other":[67],"totals":[52]},"solano":{"ranks":[26],"black":[25],"white":[46],"asian":[52],"latinx":[34],"other":[40],"totals":[42]},"sonoma":{"ranks":[27],"black":[21],"white":[52],"asian":[46],"latinx":[30],"other":[32],"totals":[41]},"stanislaus":{"ranks":[30],"black":[33],"white":[46],"asian":[51],"latinx":[35],"other":[40],"totals":[40]},"sutter":{"ranks":[17],"black":[31],"white":[54],"asian":[54],"latinx":[35],"other":[42],"totals":[47]},"tehama":{"ranks":[54],"black":["*"],"white":[38],"asian":["*"],"latinx":[15],"other":[46],"totals":[26]},"trinity":{"ranks":[55],"black":[""],"white":[27],"asian":["*"],"latinx":["*"],"other":[25],"totals":[26]},"tulare":{"ranks":[38],"black":[32],"white":[52],"asian":[60],"latinx":[34],"other":[41],"totals":[36]},"tuolumne":{"ranks":[37],"black":["*"],"white":[40],"asian":["*"],"latinx":[22],"other":["*"],"totals":[36]},"ventura":{"ranks":[20],"black":[26],"white":[53],"asian":[55],"latinx":[33],"other":[50],"totals":[45]},"yolo":{"ranks":[21],"black":[21],"white":[49],"asian":[65],"latinx":[37],"other":[75],"totals":[44]},"yuba":{"ranks":[24],"black":[19],"white":[41],"asian":[49],"latinx":[46],"other":[38],"totals":[43]}}}

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = {"indicator":"breastFeeding","semantics":{"who":"newborns","what":"were exclusively breastfed while in the hospital","label":"Newborns who were exclusively breastfed while in the hospital","shorthand":"Newborns breastfed in hospital"},"keywords":["exclusively","newborns","breastfed","milk","hospital","mothers","babies","baby","breastfeeding"],"years":["2015","2016"],"categories":["hasRace","earlyChildhood","health"],"counties":{"california":{"ranks":["",""],"black":[58,60],"white":[81,82],"asian":[62,64],"latinx":[63,65],"other":[71,71],"totals":[69,70]},"alameda":{"ranks":[15,14],"black":[79,78],"white":[88,88],"asian":[74,82],"latinx":[81,80],"other":[89,87],"totals":[83,83]},"alpine":{"ranks":["",55],"black":["","*"],"white":["","*"],"asian":["","*"],"latinx":["","*"],"other":["","*"],"totals":["",57]},"amador":{"ranks":[14,10],"black":["*","*"],"white":[87,87],"asian":["*","*"],"latinx":[69,74],"other":["*","*"],"totals":[83,84]},"butte":{"ranks":[24,30],"black":[56,53],"white":[84,82],"asian":[28,34],"latinx":[72,71],"other":[61,58],"totals":[77,75]},"calaveras":{"ranks":["",25],"black":["","*"],"white":["",80],"asian":["","*"],"latinx":["",78],"other":["",89],"totals":["",79]},"colusa":{"ranks":[50,43],"black":["*","*"],"white":[57,82],"asian":["*","*"],"latinx":[28,60],"other":["*","*"],"totals":[34,66]},"contraCosta":{"ranks":[17,16],"black":[70,72],"white":[85,84],"asian":[76,80],"latinx":[80,81],"other":[82,80],"totals":[82,82]},"delNorte":{"ranks":[34,31],"black":["*","*"],"white":[71,78],"asian":["*","*"],"latinx":[69,74],"other":[69,78],"totals":[67,74]},"elDorado":{"ranks":[10,13],"black":["*","*"],"white":[90,85],"asian":[69,71],"latinx":[71,77],"other":[89,87],"totals":[84,83]},"fresno":{"ranks":[39,39],"black":[46,63],"white":[79,81],"asian":[42,53],"latinx":[58,70],"other":[55,55],"totals":[61,69]},"glenn":{"ranks":["",34],"black":["","*"],"white":["",77],"asian":["","*"],"latinx":["",70],"other":["","*"],"totals":["",73]},"humboldt":{"ranks":[26,28],"black":["*","*"],"white":[82,82],"asian":["*",44],"latinx":[64,66],"other":[71,63],"totals":[75,76]},"imperial":{"ranks":[49,58],"black":["*","*"],"white":[52,53],"asian":["*","*"],"latinx":[36,42],"other":["*","*"],"totals":[37,42]},"inyo":{"ranks":[8,5],"black":["*","*"],"white":[85,94],"asian":["*","*"],"latinx":[93,81],"other":[87,85],"totals":[87,88]},"kern":{"ranks":[43,48],"black":[39,47],"white":[73,75],"asian":[62,66],"latinx":[55,60],"other":[66,71],"totals":[59,64]},"kings":{"ranks":[44,46],"black":[73,56],"white":[78,81],"asian":[63,75],"latinx":[49,59],"other":[70,70],"totals":[57,65]},"lake":{"ranks":[35,36],"black":["*","*"],"white":[75,77],"asian":["*","*"],"latinx":[55,64],"other":[57,61],"totals":[66,71]},"lassen":{"ranks":[22,33],"black":["*","*"],"white":[82,76],"asian":["*","*"],"latinx":[78,81],"other":[68,65],"totals":[79,73]},"losAngeles":{"ranks":[41,49],"black":[52,54],"white":[78,79],"asian":[56,54],"latinx":[57,59],"other":[69,66],"totals":[60,62]},"madera":{"ranks":[45,45],"black":[56,50],"white":[62,82],"asian":["*",76],"latinx":[51,61],"other":["*",88],"totals":[52,65]},"marin":{"ranks":[2,2],"black":[75,82],"white":[89,91],"asian":[83,84],"latinx":[92,92],"other":[84,83],"totals":[89,90]},"mariposa":{"ranks":["",28],"black":["","*"],"white":["",76],"asian":["","*"],"latinx":["",76],"other":["","*"],"totals":["",76]},"mendocino":{"ranks":[28,35],"black":["*","*"],"white":[83,83],"asian":["*","*"],"latinx":[63,63],"other":[71,58],"totals":[74,72]},"merced":{"ranks":[36,50],"black":[51,50],"white":[77,73],"asian":[44,52],"latinx":[66,60],"other":[45,48],"totals":[66,61]},"modoc":{"ranks":["",9],"black":["","*"],"white":["",88],"asian":["","*"],"latinx":["",91],"other":["","*"],"totals":["",85]},"mono":{"ranks":[3,17],"black":["*","*"],"white":[96,90],"asian":["*","*"],"latinx":[84,70],"other":["*","*"],"totals":[89,81]},"monterey":{"ranks":[37,51],"black":[74,67],"white":[83,85],"asian":[74,74],"latinx":[57,53],"other":[76,77],"totals":[63,60]},"napa":{"ranks":[11,11],"black":["*","*"],"white":[88,87],"asian":[73,81],"latinx":[84,83],"other":[71,92],"totals":[84,84]},"nevada":{"ranks":[7,3],"black":["*","*"],"white":[89,89],"asian":["*","*"],"latinx":[85,89],"other":[79,94],"totals":[87,90]},"orange":{"ranks":[33,44],"black":[68,71],"white":[80,81],"asian":[54,57],"latinx":[65,63],"other":[75,75],"totals":[67,66]},"placer":{"ranks":[16,23],"black":[77,77],"white":[85,84],"asian":[77,75],"latinx":[78,72],"other":[75,80],"totals":[82,81]},"plumas":{"ranks":[23,26],"black":["*","*"],"white":[82,81],"asian":["*","*"],"latinx":["*",64],"other":["*","*"],"totals":[78,78]},"riverside":{"ranks":[32,41],"black":[59,61],"white":[77,79],"asian":[66,56],"latinx":[65,66],"other":[69,62],"totals":[68,68]},"sacramento":{"ranks":[29,32],"black":[62,65],"white":[81,82],"asian":[63,64],"latinx":[73,76],"other":[68,63],"totals":[72,74]},"sanBenito":{"ranks":[46,42],"black":["*","*"],"white":[67,81],"asian":["*","*"],"latinx":[47,60],"other":["*",92],"totals":[51,68]},"sanBernardino":{"ranks":[38,51],"black":[47,49],"white":[72,71],"asian":[46,46],"latinx":[61,61],"other":[63,65],"totals":[61,60]},"sanDiego":{"ranks":[20,18],"black":[71,74],"white":[87,87],"asian":[72,76],"latinx":[75,77],"other":[76,78],"totals":[80,81]},"sanFrancisco":{"ranks":[19,21],"black":[66,74],"white":[89,89],"asian":[63,68],"latinx":[86,87],"other":[87,81],"totals":[81,81]},"sanJoaquin":{"ranks":[40,47],"black":[41,51],"white":[73,74],"asian":[44,53],"latinx":[64,67],"other":[59,57],"totals":[61,65]},"sanLuisObispo":{"ranks":[4,8],"black":[83,"*"],"white":[90,91],"asian":[77,73],"latinx":[84,80],"other":[97,90],"totals":[88,86]},"sanMateo":{"ranks":[13,19],"black":[80,62],"white":[89,86],"asian":[80,76],"latinx":[79,76],"other":[80,79],"totals":[83,81]},"santaBarbara":{"ranks":[42,54],"black":[61,"*"],"white":[74,80],"asian":[51,62],"latinx":[53,50],"other":[63,61],"totals":[60,59]},"santaClara":{"ranks":[21,20],"black":[75,77],"white":[87,88],"asian":[73,81],"latinx":[73,76],"other":[84,81],"totals":[79,81]},"santaCruz":{"ranks":[1,1],"black":[100,"*"],"white":[97,95],"asian":[92,92],"latinx":[91,90],"other":[95,96],"totals":[93,92]},"shasta":{"ranks":[12,24],"black":[80,73],"white":[86,82],"asian":[58,60],"latinx":[73,69],"other":[78,81],"totals":[84,80]},"sierra":{"ranks":["",4],"black":["","*"],"white":["",100],"asian":["","*"],"latinx":["","*"],"other":["","*"],"totals":["",89]},"siskiyou":{"ranks":[9,15],"black":["*","*"],"white":[87,83],"asian":["*","*"],"latinx":[78,80],"other":[82,88],"totals":[85,82]},"solano":{"ranks":[18,21],"black":[70,71],"white":[85,84],"asian":[76,74],"latinx":[82,81],"other":[84,80],"totals":[82,81]},"sonoma":{"ranks":[5,7],"black":[80,81],"white":[90,90],"asian":[85,79],"latinx":[85,84],"other":[87,86],"totals":[88,87]},"stanislaus":{"ranks":[31,38],"black":[63,48],"white":[78,76],"asian":[64,63],"latinx":[68,66],"other":[67,70],"totals":[71,69]},"sutter":{"ranks":[48,56],"black":[45,"*"],"white":[57,69],"asian":[25,34],"latinx":[38,47],"other":[58,52],"totals":[45,54]},"tehama":{"ranks":[25,40],"black":["*","*"],"white":[82,74],"asian":["*","*"],"latinx":[67,62],"other":[65,78],"totals":[76,69]},"trinity":{"ranks":["",6],"black":["","*"],"white":["",90],"asian":["","*"],"latinx":["","*"],"other":["","*"],"totals":["",87]},"tulare":{"ranks":[47,57],"black":[54,38],"white":[65,69],"asian":[35,43],"latinx":[47,51],"other":[49,47],"totals":[51,54]},"tuolumne":{"ranks":[30,37],"black":["*","*"],"white":[73,73],"asian":["*","*"],"latinx":[62,64],"other":[92,65],"totals":[72,71]},"ventura":{"ranks":[27,27],"black":[72,72],"white":[82,83],"asian":[68,70],"latinx":[70,72],"other":[80,81],"totals":[74,76]},"yolo":{"ranks":[6,11],"black":[89,71],"white":[88,87],"asian":[90,83],"latinx":[87,83],"other":[84,83],"totals":[88,84]},"yuba":{"ranks":["",53],"black":["",56],"white":["",70],"asian":["",30],"latinx":["",52],"other":["",60],"totals":["",60]},"":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]}}}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = {"indicator":"mathStandards8","semantics":{"who":"8th-graders","what":"met or exceeded grade-level math standards","label":"8th-graders who met or exceeded grade-level standards in math","shorthand":"8th grade math standards"},"keywords":["8th","grade","math","standards","grade","level","arithmetic"],"years":["2016","2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":["",""],"black":[17,18],"white":[51,51],"asian":[53,53],"latinx":[23,23],"other":[37,37],"totals":[36,36]},"alameda":{"ranks":[10,9],"black":[14,15],"white":[59,59],"asian":[50,53],"latinx":[22,23],"other":[44,41],"totals":[46,46]},"alpine":{"ranks":["",""],"black":["",""],"white":["","*"],"asian":["",""],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"amador":{"ranks":[54,47],"black":["*","*"],"white":[20,30],"asian":["*","*"],"latinx":[6,15],"other":[24,15],"totals":[18,25]},"butte":{"ranks":[28,31],"black":[14,19],"white":[39,36],"asian":[55,49],"latinx":[23,20],"other":[26,22],"totals":[34,30]},"calaveras":{"ranks":[16,26],"black":["*","*"],"white":[43,37],"asian":["*","*"],"latinx":[29,36],"other":[33,10],"totals":[39,35]},"colusa":{"ranks":[35,43],"black":["*","*"],"white":[54,48],"asian":["*","*"],"latinx":[26,22],"other":["*","*"],"totals":[32,27]},"contraCosta":{"ranks":[12,10],"black":[13,14],"white":[58,60],"asian":[51,53],"latinx":[22,23],"other":[47,47],"totals":[43,45]},"delNorte":{"ranks":[53,52],"black":["*","*"],"white":[23,30],"asian":["*",37],"latinx":[14,13],"other":[18,16],"totals":[20,23]},"elDorado":{"ranks":[3,6],"black":[26,40],"white":[56,54],"asian":[65,64],"latinx":[33,31],"other":[42,56],"totals":[52,50]},"fresno":{"ranks":[38,38],"black":[13,15],"white":[50,49],"asian":[53,47],"latinx":[21,22],"other":[33,37],"totals":[29,30]},"glenn":{"ranks":[54,53],"black":["*","*"],"white":[27,37],"asian":[29,"*"],"latinx":[13,14],"other":["*","*"],"totals":[18,23]},"humboldt":{"ranks":[30,20],"black":[12,29],"white":[42,43],"asian":[29,40],"latinx":[22,27],"other":[20,24],"totals":[33,37]},"imperial":{"ranks":[35,37],"black":[17,17],"white":[45,48],"asian":["*",50],"latinx":[31,29],"other":[25,23],"totals":[32,30]},"inyo":{"ranks":[19,13],"black":["","*"],"white":[50,52],"asian":["*",""],"latinx":[29,37],"other":[24,19],"totals":[38,41]},"kern":{"ranks":[46,46],"black":[13,12],"white":[34,33],"asian":[46,46],"latinx":[21,21],"other":[26,31],"totals":[25,25]},"kings":{"ranks":[38,34],"black":[24,13],"white":[42,48],"asian":[51,48],"latinx":[24,25],"other":[14,17],"totals":[29,30]},"lake":{"ranks":[50,56],"black":[0,"*"],"white":[28,26],"asian":["*","*"],"latinx":[15,11],"other":[16,11],"totals":[21,19]},"lassen":{"ranks":[22,28],"black":["*","*"],"white":[40,40],"asian":["*","*"],"latinx":[35,28],"other":[12,8],"totals":[36,34]},"losAngeles":{"ranks":[30,29],"black":[16,18],"white":[54,54],"asian":[56,58],"latinx":[24,25],"other":[37,45],"totals":[33,34]},"madera":{"ranks":[54,55],"black":[9,14],"white":[33,38],"asian":[36,45],"latinx":[12,16],"other":[29,19],"totals":[18,21]},"marin":{"ranks":[1,1],"black":[29,18],"white":[72,72],"asian":[68,62],"latinx":[26,25],"other":[70,70],"totals":[59,57]},"mariposa":{"ranks":[21,25],"black":["","*"],"white":[35,41],"asian":["*",""],"latinx":[43,21],"other":[36,31],"totals":[37,36]},"mendocino":{"ranks":[50,51],"black":["*","*"],"white":[30,28],"asian":["*",50],"latinx":[12,20],"other":[13,13],"totals":[21,24]},"merced":{"ranks":[50,56],"black":[5,9],"white":[28,30],"asian":[33,32],"latinx":[18,16],"other":[32,23],"totals":[21,19]},"modoc":{"ranks":[57,54],"black":["*","*"],"white":[15,26],"asian":["*","*"],"latinx":[15,18],"other":["*","*"],"totals":[17,23]},"mono":{"ranks":[11,19],"black":["",""],"white":[72,66],"asian":["*","*"],"latinx":[26,21],"other":["*","*"],"totals":[45,37]},"monterey":{"ranks":[49,50],"black":[22,16],"white":[49,43],"asian":[45,47],"latinx":[17,18],"other":[33,46],"totals":[23,24]},"napa":{"ranks":[30,32],"black":[19,13],"white":[50,46],"asian":[56,56],"latinx":[19,18],"other":[41,45],"totals":[33,30]},"nevada":{"ranks":[14,18],"black":["*","*"],"white":[43,39],"asian":["*","*"],"latinx":[30,37],"other":[33,24],"totals":[41,38]},"orange":{"ranks":[8,8],"black":[31,27],"white":[62,62],"asian":[60,62],"latinx":[27,26],"other":[52,50],"totals":[48,48]},"placer":{"ranks":[3,4],"black":[29,24],"white":[55,55],"asian":[59,57],"latinx":[34,34],"other":[44,46],"totals":[52,51]},"plumas":{"ranks":[22,30],"black":["*","*"],"white":[39,35],"asian":["*","*"],"latinx":[18,17],"other":["*","*"],"totals":[36,31]},"riverside":{"ranks":[38,36],"black":[19,18],"white":[42,45],"asian":[51,52],"latinx":[22,22],"other":[34,32],"totals":[29,30]},"sacramento":{"ranks":[25,22],"black":[16,16],"white":[44,46],"asian":[45,44],"latinx":[22,24],"other":[28,33],"totals":[35,36]},"sanBenito":{"ranks":[38,16],"black":["*",""],"white":[38,48],"asian":[54,75],"latinx":[25,33],"other":["*","*"],"totals":[29,38]},"sanBernardino":{"ranks":[45,41],"black":[14,17],"white":[40,39],"asian":[56,53],"latinx":[21,22],"other":[28,29],"totals":[26,28]},"sanDiego":{"ranks":[15,14],"black":[23,23],"white":[56,56],"asian":[56,56],"latinx":[25,26],"other":[37,36],"totals":[40,41]},"sanFrancisco":{"ranks":[8,5],"black":[15,17],"white":[65,71],"asian":[45,46],"latinx":[23,21],"other":[52,45],"totals":[48,50]},"sanJoaquin":{"ranks":[42,40],"black":[12,15],"white":[37,39],"asian":[42,38],"latinx":[20,20],"other":[26,24],"totals":[27,28]},"sanLuisObispo":{"ranks":[13,12],"black":[20,20],"white":[52,51],"asian":[63,63],"latinx":[25,27],"other":[52,39],"totals":[42,41]},"sanMateo":{"ranks":[6,7],"black":[22,19],"white":[68,66],"asian":[55,53],"latinx":[25,26],"other":[47,45],"totals":[50,50]},"santaBarbara":{"ranks":[22,24],"black":[30,22],"white":[59,59],"asian":[59,58],"latinx":[26,25],"other":[49,44],"totals":[36,36]},"santaClara":{"ranks":[2,2],"black":[32,36],"white":[69,69],"asian":[58,56],"latinx":[25,24],"other":[52,56],"totals":[55,55]},"santaCruz":{"ranks":[28,33],"black":[29,17],"white":[54,51],"asian":[62,50],"latinx":[19,15],"other":[48,51],"totals":[34,30]},"shasta":{"ranks":[16,11],"black":[28,22],"white":[40,45],"asian":[52,53],"latinx":[30,33],"other":[38,36],"totals":[39,43]},"sierra":{"ranks":[6,15],"black":["",""],"white":[33,40],"asian":["",""],"latinx":["*","*"],"other":["*","*"],"totals":[50,39]},"siskiyou":{"ranks":[19,27],"black":["*","*"],"white":[44,36],"asian":["*","*"],"latinx":[30,39],"other":[28,30],"totals":[38,35]},"solano":{"ranks":[30,35],"black":[15,13],"white":[46,42],"asian":[45,39],"latinx":[23,21],"other":[38,34],"totals":[33,30]},"sonoma":{"ranks":[25,23],"black":[18,20],"white":[46,47],"asian":[40,47],"latinx":[22,23],"other":[35,31],"totals":[35,36]},"stanislaus":{"ranks":[46,45],"black":[15,14],"white":[36,35],"asian":[48,44],"latinx":[19,19],"other":[25,26],"totals":[25,25]},"sutter":{"ranks":[37,39],"black":[5,6],"white":[33,33],"asian":[45,42],"latinx":[27,21],"other":[30,32],"totals":[31,29]},"tehama":{"ranks":[42,42],"black":["*","*"],"white":[33,33],"asian":["*","*"],"latinx":[16,19],"other":[28,25],"totals":[27,28]},"trinity":{"ranks":[5,3],"black":["","*"],"white":[58,48],"asian":["*","*"],"latinx":[33,71],"other":[27,"*"],"totals":[51,52]},"tulare":{"ranks":[42,48],"black":[26,20],"white":[40,40],"asian":[49,39],"latinx":[23,20],"other":[21,23],"totals":[27,24]},"tuolumne":{"ranks":[30,44],"black":["*","*"],"white":[34,28],"asian":["*","*"],"latinx":[28,17],"other":[50,28],"totals":[33,27]},"ventura":{"ranks":[25,21],"black":[23,25],"white":[54,57],"asian":[53,55],"latinx":[19,20],"other":[52,40],"totals":[35,36]},"yolo":{"ranks":[16,17],"black":[22,16],"white":[56,54],"asian":[63,52],"latinx":[20,21],"other":[39,52],"totals":[39,38]},"yuba":{"ranks":[46,49],"black":[6,13],"white":[35,31],"asian":[26,29],"latinx":[13,16],"other":[32,19],"totals":[25,24]}}}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = {"indicator":"collegeLevelMath","semantics":{"who":"students","what":"were ready or conditionally ready for college-level math courses","label":"Students who were ready or conditionally ready for college-level math courses","shorthand":"College math readiness"},"keywords":["students","math","arithmetic","college","courses","level"],"years":["2016","2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":["",""],"black":[15,15],"white":[45,45],"asian":[49,48],"latinx":[20,20],"other":[33,32],"totals":[32,32]},"alameda":{"ranks":[9,8],"black":[13,11],"white":[55,54],"asian":[49,47],"latinx":[22,19],"other":[40,40],"totals":[43,43]},"alpine":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["*",""],"totals":["*",""]},"amador":{"ranks":[23,21],"black":["*","*"],"white":[31,33],"asian":["*","*"],"latinx":[19,21],"other":[36,50],"totals":[30,30]},"butte":{"ranks":[20,13],"black":[20,25],"white":[35,39],"asian":[27,34],"latinx":[26,25],"other":[22,23],"totals":[31,34]},"calaveras":{"ranks":[28,16],"black":["*","*"],"white":[30,35],"asian":["*","*"],"latinx":[25,18],"other":[22,32],"totals":[29,32]},"colusa":{"ranks":[52,46],"black":["*","*"],"white":[29,40],"asian":["*","*"],"latinx":[14,14],"other":["*","*"],"totals":[18,21]},"contraCosta":{"ranks":[11,9],"black":[14,11],"white":[56,51],"asian":[49,49],"latinx":[20,18],"other":[33,45],"totals":[41,39]},"delNorte":{"ranks":[32,51],"black":["*","*"],"white":[31,20],"asian":[25,50],"latinx":[29,12],"other":[13,11],"totals":[27,18]},"elDorado":{"ranks":[3,2],"black":[16,36],"white":[53,52],"asian":[63,62],"latinx":[29,30],"other":[47,49],"totals":[49,49]},"fresno":{"ranks":[38,33],"black":[12,11],"white":[40,44],"asian":[40,45],"latinx":[15,18],"other":[28,33],"totals":[23,26]},"glenn":{"ranks":[57,54],"black":["","*"],"white":[22,24],"asian":[0,"*"],"latinx":[9,12],"other":["*","*"],"totals":[14,17]},"humboldt":{"ranks":[31,31],"black":[0,"*"],"white":[34,32],"asian":[32,39],"latinx":[15,16],"other":[16,18],"totals":[28,27]},"imperial":{"ranks":[38,39],"black":[16,15],"white":[39,37],"asian":[83,88],"latinx":[21,23],"other":[7,0],"totals":[23,24]},"inyo":{"ranks":[51,43],"black":["*","*"],"white":[32,41],"asian":["*","*"],"latinx":[13,11],"other":[0,17],"totals":[19,22]},"kern":{"ranks":[38,45],"black":[13,10],"white":[31,28],"asian":[47,37],"latinx":[19,18],"other":[25,22],"totals":[23,21]},"kings":{"ranks":[54,53],"black":[18,9],"white":[24,29],"asian":[44,47],"latinx":[11,13],"other":[21,24],"totals":[16,18]},"lake":{"ranks":[54,57],"black":["*",19],"white":[21,18],"asian":["*","*"],"latinx":[8,8],"other":[14,11],"totals":[16,15]},"lassen":{"ranks":[48,48],"black":["*","*"],"white":[22,23],"asian":["*","*"],"latinx":[12,6],"other":[10,14],"totals":[20,20]},"losAngeles":{"ranks":[20,22],"black":[14,14],"white":[46,47],"asian":[52,50],"latinx":[22,21],"other":[35,33],"totals":[31,30]},"madera":{"ranks":[54,55],"black":[13,9],"white":[26,25],"asian":[38,45],"latinx":[13,13],"other":[18,15],"totals":[16,17]},"marin":{"ranks":[5,6],"black":[11,14],"white":[56,57],"asian":[65,61],"latinx":[21,20],"other":[55,38],"totals":[46,46]},"mariposa":{"ranks":[23,23],"black":["*",""],"white":[31,36],"asian":["*","*"],"latinx":[15,25],"other":["*","*"],"totals":[30,30]},"mendocino":{"ranks":[46,38],"black":["*","*"],"white":[26,32],"asian":[85,"*"],"latinx":[15,15],"other":[11,25],"totals":[21,24]},"merced":{"ranks":[44,49],"black":[15,4],"white":[27,30],"asian":[48,36],"latinx":[18,15],"other":[25,25],"totals":[22,19]},"modoc":{"ranks":[34,47],"black":["*","*"],"white":[36,28],"asian":["*","*"],"latinx":[10,7],"other":["*","*"],"totals":[25,20]},"mono":{"ranks":[44,32],"black":["*","*"],"white":[37,39],"asian":["","*"],"latinx":[13,14],"other":["*","*"],"totals":[22,27]},"monterey":{"ranks":[34,41],"black":[14,14],"white":[49,41],"asian":[45,48],"latinx":[18,16],"other":[34,45],"totals":[25,22]},"napa":{"ranks":[28,30],"black":[10,20],"white":[42,43],"asian":[46,56],"latinx":[18,15],"other":[43,47],"totals":[29,28]},"nevada":{"ranks":[16,28],"black":[0,5],"white":[38,35],"asian":["*","*"],"latinx":[14,8],"other":[26,27],"totals":[32,29]},"orange":{"ranks":[10,7],"black":[24,25],"white":[53,53],"asian":[58,55],"latinx":[22,22],"other":[46,44],"totals":[42,43]},"placer":{"ranks":[5,4],"black":[26,35],"white":[49,49],"asian":[60,57],"latinx":[32,30],"other":[35,40],"totals":[46,47]},"plumas":{"ranks":[7,20],"black":["*","*"],"white":[48,37],"asian":["*","*"],"latinx":[27,18],"other":[45,"*"],"totals":[45,31]},"riverside":{"ranks":[32,34],"black":[17,19],"white":[39,37],"asian":[48,47],"latinx":[20,19],"other":[28,26],"totals":[27,26]},"sacramento":{"ranks":[20,19],"black":[13,13],"white":[41,38],"asian":[40,39],"latinx":[18,19],"other":[27,27],"totals":[31,31]},"sanBenito":{"ranks":[38,24],"black":["*","*"],"white":[34,43],"asian":[64,58],"latinx":[18,25],"other":["*","*"],"totals":[23,30]},"sanBernardino":{"ranks":[36,37],"black":[13,14],"white":[33,34],"asian":[50,48],"latinx":[20,19],"other":[29,23],"totals":[24,24]},"sanDiego":{"ranks":[13,10],"black":[21,20],"white":[50,49],"asian":[52,53],"latinx":[24,22],"other":[37,35],"totals":[37,36]},"sanFrancisco":{"ranks":[1,1],"black":[14,12],"white":[64,61],"asian":[44,43],"latinx":[17,21],"other":[39,48],"totals":[50,52]},"sanJoaquin":{"ranks":[38,36],"black":[10,13],"white":[31,32],"asian":[30,35],"latinx":[15,17],"other":[22,22],"totals":[23,24]},"sanLuisObispo":{"ranks":[16,12],"black":[18,29],"white":[40,44],"asian":[45,51],"latinx":[20,21],"other":[26,32],"totals":[32,35]},"sanMateo":{"ranks":[8,5],"black":[5,17],"white":[61,65],"asian":[48,47],"latinx":[23,21],"other":[59,43],"totals":[44,46]},"santaBarbara":{"ranks":[23,25],"black":[19,19],"white":[49,48],"asian":[60,55],"latinx":[21,20],"other":[29,30],"totals":[30,29]},"santaClara":{"ranks":[4,3],"black":[23,24],"white":[62,59],"asian":[50,50],"latinx":[19,18],"other":[45,45],"totals":[48,48]},"santaCruz":{"ranks":[23,26],"black":[33,33],"white":[46,44],"asian":[49,44],"latinx":[16,16],"other":[63,49],"totals":[30,29]},"shasta":{"ranks":[14,15],"black":[18,25],"white":[35,36],"asian":[50,42],"latinx":[34,23],"other":[32,31],"totals":[35,34]},"sierra":{"ranks":[1,44],"black":["",""],"white":[0,27],"asian":["",""],"latinx":["*","*"],"other":["*","*"],"totals":[50,21]},"siskiyou":{"ranks":[16,17],"black":["*","*"],"white":[37,37],"asian":[55,"*"],"latinx":[14,19],"other":[16,21],"totals":[32,32]},"solano":{"ranks":[23,27],"black":[11,11],"white":[41,41],"asian":[43,37],"latinx":[21,19],"other":[27,28],"totals":[30,29]},"sonoma":{"ranks":[15,18],"black":[14,20],"white":[46,42],"asian":[42,43],"latinx":[19,18],"other":[28,36],"totals":[34,31]},"stanislaus":{"ranks":[38,40],"black":[8,10],"white":[32,32],"asian":[39,38],"latinx":[16,16],"other":[22,23],"totals":[23,22]},"sutter":{"ranks":[46,42],"black":[6,5],"white":[24,25],"asian":[36,30],"latinx":[15,17],"other":[12,23],"totals":[21,22]},"tehama":{"ranks":[53,56],"black":["*","*"],"white":[23,20],"asian":["*","*"],"latinx":[10,10],"other":[12,22],"totals":[17,16]},"trinity":{"ranks":[36,35],"black":["*","*"],"white":[20,32],"asian":["*","*"],"latinx":["*",6],"other":[46,17],"totals":[24,25]},"tulare":{"ranks":[48,50],"black":[14,13],"white":[32,31],"asian":[37,45],"latinx":[16,15],"other":[20,31],"totals":[20,19]},"tuolumne":{"ranks":[28,29],"black":["*","*"],"white":[30,30],"asian":["*","*"],"latinx":[23,27],"other":[20,13],"totals":[29,29]},"ventura":{"ranks":[16,14],"black":[16,30],"white":[47,49],"asian":[50,53],"latinx":[17,19],"other":[37,40],"totals":[32,34]},"yolo":{"ranks":[12,11],"black":[24,20],"white":[53,50],"asian":[68,50],"latinx":[17,16],"other":[39,39],"totals":[38,36]},"yuba":{"ranks":[48,52],"black":[6,12],"white":[24,20],"asian":[23,31],"latinx":[15,13],"other":[27,12],"totals":[20,18]}}}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = {"indicator":"familyLike","semantics":{"who":"adolescents in the child welfare system","shortWho":"adolescents","what":"were placed in family-like settings","label":"Adolescents in the child welfare system who were placed in family-like settings","shorthand":"Adolescents placed in family-like settings"},"keywords":["family-like","placement","placed","adolescents","welfare","system","settings"],"years":["2016","2017"],"categories":["hasRace","welfare"],"counties":{"california":{"ranks":["",""],"black":[66,67],"white":[71,72],"asian":[75,78],"latinx":[73,74],"other":[79,82],"totals":[71,73]},"alameda":{"ranks":[46,46],"black":[59,59],"white":[69,69],"asian":[63,81],"latinx":[63,64],"other":[100,92],"totals":[62,63]},"alpine":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"amador":{"ranks":[2,5],"black":[100,100],"white":[91,84],"asian":["",""],"latinx":[86,96],"other":["",""],"totals":[86,86]},"butte":{"ranks":[17,20],"black":[78,82],"white":[76,77],"asian":[92,84],"latinx":[72,64],"other":[78,77],"totals":[76,76]},"calaveras":{"ranks":[33,31],"black":["",""],"white":[69,74],"asian":["",""],"latinx":[77,42],"other":[50,92],"totals":[69,72]},"colusa":{"ranks":[55,25],"black":["",""],"white":[40,59],"asian":["",""],"latinx":[78,85],"other":["",50],"totals":[46,74]},"contraCosta":{"ranks":[38,39],"black":[63,66],"white":[67,69],"asian":[71,62],"latinx":[71,70],"other":[87,74],"totals":[67,68]},"delNorte":{"ranks":[36,12],"black":[25,13],"white":[69,77],"asian":["",100],"latinx":[17,64],"other":[76,87],"totals":[68,77]},"elDorado":{"ranks":[13,22],"black":[86,79],"white":[78,75],"asian":["",100],"latinx":[83,84],"other":[59,28],"totals":[78,75]},"fresno":{"ranks":[7,9],"black":[80,70],"white":[83,77],"asian":[90,90],"latinx":[82,82],"other":[90,82],"totals":[82,79]},"glenn":{"ranks":[26,14],"black":[100,100],"white":[65,72],"asian":["",""],"latinx":[81,79],"other":[62,78],"totals":[72,77]},"humboldt":{"ranks":[10,15],"black":[72,64],"white":[79,80],"asian":["",100],"latinx":[78,71],"other":[84,77],"totals":[81,77]},"imperial":{"ranks":[51,51],"black":[62,43],"white":[51,48],"asian":["",""],"latinx":[63,65],"other":[18,28],"totals":[60,61]},"inyo":{"ranks":[5,55],"black":["",""],"white":[100,50],"asian":["",""],"latinx":["",100],"other":[75,50],"totals":[83,48]},"kern":{"ranks":[27,21],"black":[58,70],"white":[68,69],"asian":[88,91],"latinx":[75,79],"other":[50,63],"totals":[71,75]},"kings":{"ranks":[6,4],"black":[70,75],"white":[80,76],"asian":[100,94],"latinx":[87,91],"other":[40,63],"totals":[83,86]},"lake":{"ranks":[40,26],"black":[54,65],"white":[63,75],"asian":["",""],"latinx":[78,85],"other":[57,67],"totals":[64,74]},"lassen":{"ranks":[29,18],"black":["",""],"white":[71,81],"asian":[25,75],"latinx":[83,78],"other":[39,""],"totals":[70,76]},"losAngeles":{"ranks":[24,24],"black":[69,69],"white":[73,76],"asian":[82,81],"latinx":[74,75],"other":[86,86],"totals":[73,74]},"madera":{"ranks":[3,7],"black":[80,73],"white":[82,79],"asian":[50,100],"latinx":[86,87],"other":[79,100],"totals":[84,84]},"marin":{"ranks":[48,49],"black":[77,79],"white":[55,62],"asian":["",""],"latinx":[56,49],"other":["",""],"totals":[62,62]},"mariposa":{"ranks":[16,41],"black":["",""],"white":[75,65],"asian":["",""],"latinx":[79,60],"other":[100,100],"totals":[77,67]},"mendocino":{"ranks":[32,38],"black":[95,92],"white":[67,68],"asian":["",""],"latinx":[74,66],"other":[63,69],"totals":[69,68]},"merced":{"ranks":[15,11],"black":[76,76],"white":[81,80],"asian":[93,92],"latinx":[74,76],"other":[78,96],"totals":[77,78]},"modoc":{"ranks":[56,2],"black":["",""],"white":[26,78],"asian":["",""],"latinx":[33,100],"other":[100,100],"totals":[37,89]},"mono":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"monterey":{"ranks":[54,54],"black":[67,62],"white":[47,62],"asian":["",8],"latinx":[51,59],"other":[100,92],"totals":[52,59]},"napa":{"ranks":[23,28],"black":[63,79],"white":[80,82],"asian":["",100],"latinx":[71,67],"other":[75,63],"totals":[74,74]},"nevada":{"ranks":[45,34],"black":["",""],"white":[57,69],"asian":["",""],"latinx":[100,88],"other":["",""],"totals":[63,70]},"orange":{"ranks":[28,34],"black":[60,49],"white":[71,70],"asian":[81,78],"latinx":[71,72],"other":[57,73],"totals":[70,70]},"placer":{"ranks":[25,33],"black":[82,74],"white":[80,72],"asian":[48,58],"latinx":[59,66],"other":[100,75],"totals":[73,71]},"plumas":{"ranks":[43,50],"black":["",100],"white":[63,57],"asian":["",""],"latinx":[71,83],"other":[38,83],"totals":[63,61]},"riverside":{"ranks":[18,18],"black":[72,74],"white":[75,75],"asian":[81,81],"latinx":[76,77],"other":[78,92],"totals":[75,76]},"sacramento":{"ranks":[47,44],"black":[59,63],"white":[63,68],"asian":[68,68],"latinx":[64,65],"other":[66,70],"totals":[62,65]},"sanBenito":{"ranks":[9,13],"black":[75,100],"white":[88,78],"asian":["",""],"latinx":[75,72],"other":[100,100],"totals":[82,77]},"sanBernardino":{"ranks":[22,17],"black":[68,69],"white":[73,75],"asian":[89,91],"latinx":[78,80],"other":[74,83],"totals":[74,76]},"sanDiego":{"ranks":[42,43],"black":[57,61],"white":[63,62],"asian":[78,84],"latinx":[67,68],"other":[59,78],"totals":[64,66]},"sanFrancisco":{"ranks":[50,48],"black":[60,59],"white":[61,69],"asian":[70,68],"latinx":[64,64],"other":[28,16],"totals":[61,62]},"sanJoaquin":{"ranks":[49,45],"black":[61,65],"white":[61,62],"asian":[59,53],"latinx":[64,66],"other":[42,50],"totals":[61,64]},"sanLuisObispo":{"ranks":[37,42],"black":[45,52],"white":[63,62],"asian":[25,28],"latinx":[75,74],"other":[95,71],"totals":[67,66]},"sanMateo":{"ranks":[39,37],"black":[54,58],"white":[68,82],"asian":[74,78],"latinx":[65,64],"other":[67,92],"totals":[65,69]},"santaBarbara":{"ranks":[52,40],"black":[30,19],"white":[62,66],"asian":[60,75],"latinx":[59,70],"other":[38,100],"totals":[58,67]},"santaClara":{"ranks":[41,52],"black":[51,52],"white":[59,40],"asian":[56,65],"latinx":[69,64],"other":[42,27],"totals":[64,60]},"santaCruz":{"ranks":[43,53],"black":[71,64],"white":[77,71],"asian":["",100],"latinx":[54,53],"other":["",100],"totals":[63,59]},"shasta":{"ranks":[12,10],"black":[49,52],"white":[80,79],"asian":[100,100],"latinx":[79,82],"other":[90,88],"totals":[79,79]},"sierra":{"ranks":[19,56],"black":["",""],"white":[75,38],"asian":["",""],"latinx":["",""],"other":["",""],"totals":[75,38]},"siskiyou":{"ranks":[14,32],"black":[50,25],"white":[76,72],"asian":[100,100],"latinx":[90,75],"other":[82,71],"totals":[77,71]},"solano":{"ranks":[34,27],"black":[66,72],"white":[65,68],"asian":[94,94],"latinx":[72,78],"other":[73,70],"totals":[68,74]},"sonoma":{"ranks":[53,47],"black":[69,46],"white":[52,62],"asian":[48,46],"latinx":[61,63],"other":[72,71],"totals":[58,62]},"stanislaus":{"ranks":[20,16],"black":[85,76],"white":[73,73],"asian":[100,98],"latinx":[73,77],"other":[75,100],"totals":[75,76]},"sutter":{"ranks":[35,29],"black":[78,84],"white":[67,70],"asian":["",""],"latinx":[65,77],"other":["",100],"totals":[68,74]},"tehama":{"ranks":[1,1],"black":[100,100],"white":[83,88],"asian":["",100],"latinx":[91,93],"other":[50,100],"totals":[87,90]},"trinity":{"ranks":[8,3],"black":["",""],"white":[88,91],"asian":[25,""],"latinx":[25,25],"other":["",100],"totals":[82,87]},"tulare":{"ranks":[4,6],"black":[80,74],"white":[79,80],"asian":["",100],"latinx":[86,87],"other":[90,92],"totals":[84,85]},"tuolumne":{"ranks":[21,23],"black":["",""],"white":[67,70],"asian":[88,100],"latinx":[82,82],"other":[100,67],"totals":[75,75]},"ventura":{"ranks":[30,30],"black":[77,62],"white":[65,65],"asian":[100,100],"latinx":[71,76],"other":[75,25],"totals":[70,73]},"yolo":{"ranks":[11,8],"black":[75,78],"white":[70,75],"asian":[100,100],"latinx":[85,89],"other":["",100],"totals":[80,84]},"yuba":{"ranks":[31,36],"black":[65,53],"white":[68,68],"asian":[25,67],"latinx":[78,73],"other":[88,100],"totals":[70,70]}}}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = {"indicator":"readToEveryday","semantics":{"who":"children","shortWho":"children","what":", ages birth-5, were read to everyday by an adult","label":"Children, ages birth-5, who were read to everyday by an adult","shorthand":"Children read to everyday"},"keywords":["read","everyday","birth","adult","night","bedtime","story","book","reading"],"years":["2014","2016"],"categories":["hasRace","earlyChildhood","unstable"],"counties":{"california":{"ranks":["",""],"black":[69,62],"white":[76,84],"asian":[57,63],"latinx":[53,55],"other":[78,68],"totals":[61,64]},"alameda":{"ranks":[1,1],"black":[52,56],"white":[86,86],"asian":[82,90],"latinx":[51,78],"other":[77,94],"totals":[74,79]},"alpine":{"ranks":[2,2],"black":["",""],"white":[91,96],"asian":["",""],"latinx":[100,100],"other":[100,""],"totals":[92,97]},"amador":{"ranks":[3,3],"black":["",""],"white":[91,96],"asian":["",""],"latinx":[100,100],"other":[100,""],"totals":[92,97]},"butte":{"ranks":[4,4],"black":["",""],"white":[85,94],"asian":["",""],"latinx":[85,48],"other":["",100],"totals":[72,90]},"calaveras":{"ranks":[5,5],"black":["",""],"white":[91,96],"asian":["",""],"latinx":[100,100],"other":[100,""],"totals":[92,97]},"colusa":{"ranks":[6,6],"black":["",""],"white":[63,69],"asian":["",""],"latinx":[64,71],"other":[100,""],"totals":[64,64]},"contraCosta":{"ranks":[7,7],"black":["",30],"white":[75,88],"asian":["",17],"latinx":[94,68],"other":[95,100],"totals":[79,73]},"delNorte":{"ranks":[8,8],"black":["",""],"white":[88,95],"asian":["",""],"latinx":[69,40],"other":[61,100],"totals":[78,86]},"elDorado":{"ranks":[9,9],"black":["",""],"white":[72,91],"asian":["",""],"latinx":[100,53],"other":[100,""],"totals":[87,77]},"fresno":{"ranks":[10,10],"black":[100,100],"white":[71,83],"asian":[100,""],"latinx":[58,75],"other":[100,100],"totals":[64,80]},"glenn":{"ranks":[11,11],"black":["",""],"white":[63,69],"asian":["",""],"latinx":[64,71],"other":[100,""],"totals":[64,64]},"humboldt":{"ranks":[12,12],"black":["",""],"white":[91,53],"asian":["",100],"latinx":[16,100],"other":[62,100],"totals":[83,73]},"imperial":{"ranks":[13,13],"black":["",""],"white":[100,""],"asian":["",""],"latinx":[34,34],"other":["",""],"totals":[38,34]},"inyo":{"ranks":[14,14],"black":["",""],"white":[91,96],"asian":["",""],"latinx":[100,100],"other":[100,""],"totals":[92,97]},"kern":{"ranks":[15,15],"black":["",100],"white":[76,87],"asian":[57,""],"latinx":[42,37],"other":[69,73],"totals":[57,52]},"kings":{"ranks":[16,16],"black":["",""],"white":[41,76],"asian":["",""],"latinx":[79,32],"other":["",50],"totals":[71,41]},"lake":{"ranks":[17,17],"black":["",100],"white":[100,76],"asian":["",""],"latinx":[95,76],"other":["",100],"totals":[98,85]},"lassen":{"ranks":[18,18],"black":["",""],"white":[88,95],"asian":["",""],"latinx":[69,40],"other":[61,100],"totals":[78,86]},"losAngeles":{"ranks":[19,19],"black":[78,46],"white":[83,89],"asian":[49,73],"latinx":[58,56],"other":[54,47],"totals":[61,60]},"madera":{"ranks":[20,20],"black":["",""],"white":[78,""],"asian":["",100],"latinx":[70,17],"other":["",""],"totals":[73,29]},"marin":{"ranks":[21,21],"black":["",""],"white":[56,75],"asian":["",""],"latinx":[50,63],"other":[100,""],"totals":[51,72]},"mariposa":{"ranks":[22,22],"black":["",""],"white":[91,96],"asian":["",""],"latinx":[100,100],"other":[100,""],"totals":[92,97]},"mendocino":{"ranks":[23,23],"black":["",""],"white":[94,76],"asian":["",""],"latinx":[48,49],"other":[100,57],"totals":[63,52]},"merced":{"ranks":[24,24],"black":[100,100],"white":[73,60],"asian":["",48],"latinx":[36,26],"other":["",""],"totals":[46,32]},"modoc":{"ranks":[25,25],"black":["",""],"white":[88,95],"asian":["",""],"latinx":[69,40],"other":[61,100],"totals":[78,86]},"mono":{"ranks":[26,26],"black":["",""],"white":[91,96],"asian":["",""],"latinx":[100,100],"other":[100,""],"totals":[92,97]},"monterey":{"ranks":[27,27],"black":["",""],"white":[93,100],"asian":[36,100],"latinx":[40,40],"other":[100,""],"totals":[54,42]},"napa":{"ranks":[28,28],"black":["",""],"white":[54,86],"asian":["",""],"latinx":[44,""],"other":["",100],"totals":[58,61]},"nevada":{"ranks":[29,29],"black":["",""],"white":[86,88],"asian":[100,""],"latinx":["",""],"other":["",""],"totals":[88,83]},"orange":{"ranks":[30,30],"black":[100,50],"white":[81,83],"asian":[39,46],"latinx":[32,62],"other":[100,95],"totals":[46,71]},"placer":{"ranks":[31,31],"black":["",""],"white":[79,29],"asian":[100,""],"latinx":[87,""],"other":[100,54],"totals":[86,30]},"plumas":{"ranks":[32,32],"black":["",""],"white":[88,95],"asian":["",""],"latinx":[69,40],"other":[61,100],"totals":[78,86]},"riverside":{"ranks":[33,33],"black":[46,83],"white":[38,87],"asian":[99,64],"latinx":[59,48],"other":[54,42],"totals":[62,60]},"sacramento":{"ranks":[34,34],"black":[97,71],"white":[86,80],"asian":[97,86],"latinx":[73,75],"other":[100,68],"totals":[84,78]},"sanBenito":{"ranks":[35,35],"black":["",""],"white":[76,64],"asian":["",""],"latinx":[35,69],"other":["",""],"totals":[56,67]},"sanBernardino":{"ranks":[36,36],"black":[85,61],"white":[55,70],"asian":[100,63],"latinx":[55,48],"other":[38,66],"totals":[56,54]},"sanDiego":{"ranks":[37,37],"black":[35,52],"white":[90,88],"asian":[79,57],"latinx":[49,57],"other":[75,90],"totals":[68,68]},"sanFrancisco":{"ranks":[38,38],"black":[100,93],"white":[63,93],"asian":[54,75],"latinx":[75,72],"other":[96,50],"totals":[71,72]},"sanJoaquin":{"ranks":[39,39],"black":["",100],"white":[75,74],"asian":[45,100],"latinx":[35,49],"other":[100,""],"totals":[42,57]},"sanLuisObispo":{"ranks":[40,40],"black":[100,""],"white":[43,36],"asian":["",""],"latinx":["",63],"other":["",100],"totals":[41,50]},"sanMateo":{"ranks":[41,41],"black":["",""],"white":[79,81],"asian":[100,50],"latinx":[62,59],"other":[100,100],"totals":[73,62]},"santaBarbara":{"ranks":[42,42],"black":["",""],"white":[100,74],"asian":["",""],"latinx":[42,48],"other":["",100],"totals":[64,53]},"santaClara":{"ranks":[43,43],"black":["",100],"white":[62,80],"asian":[35,70],"latinx":[58,72],"other":[100,88],"totals":[55,73]},"santaCruz":{"ranks":[44,44],"black":["",""],"white":[39,100],"asian":["",""],"latinx":[69,44],"other":[100,100],"totals":[53,67]},"shasta":{"ranks":[45,45],"black":["",""],"white":[90,90],"asian":["",""],"latinx":[87,24],"other":[100,91],"totals":[92,70]},"sierra":{"ranks":[46,46],"black":["",""],"white":[88,95],"asian":["",""],"latinx":[69,40],"other":[61,100],"totals":[78,86]},"siskiyou":{"ranks":[47,47],"black":["",""],"white":[88,95],"asian":["",""],"latinx":[69,40],"other":[61,100],"totals":[78,86]},"solano":{"ranks":[48,48],"black":[100,100],"white":[86,74],"asian":["",""],"latinx":[22,39],"other":[77,""],"totals":[59,57]},"sonoma":{"ranks":[49,49],"black":["",""],"white":[86,73],"asian":["",""],"latinx":[42,57],"other":["",55],"totals":[76,60]},"stanislaus":{"ranks":[50,50],"black":["",""],"white":[100,100],"asian":["",""],"latinx":[45,38],"other":[50,50],"totals":[53,55]},"sutter":{"ranks":[51,51],"black":["",""],"white":[97,63],"asian":["",100],"latinx":[35,64],"other":[100,67],"totals":[67,75]},"tehama":{"ranks":[52,52],"black":["",""],"white":[63,69],"asian":["",""],"latinx":[64,71],"other":[100,""],"totals":[64,64]},"trinity":{"ranks":[53,53],"black":["",""],"white":[88,95],"asian":["",""],"latinx":[69,40],"other":[61,100],"totals":[78,86]},"tulare":{"ranks":[54,54],"black":["",""],"white":[11,80],"asian":["",""],"latinx":[40,65],"other":["",81],"totals":[36,66]},"tuolumne":{"ranks":[55,55],"black":["",""],"white":[91,96],"asian":["",""],"latinx":[100,100],"other":[100,""],"totals":[92,97]},"ventura":{"ranks":[56,56],"black":["",""],"white":[95,77],"asian":["",""],"latinx":[30,48],"other":[100,""],"totals":[50,59]},"yolo":{"ranks":[57,57],"black":[100,""],"white":[100,100],"asian":["",100],"latinx":[53,39],"other":[98,""],"totals":[67,79]},"yuba":{"ranks":[58,58],"black":["",""],"white":[87,83],"asian":[100,""],"latinx":[52,62],"other":[52,""],"totals":[73,73]}}}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = {"indicator":"childCareSlots","semantics":{"who":"children","what":"with parents in the labor force for whom a licensed child care slot was available","label":"Children with parents in the labor force for whom a licensed child care slot was available","shorthand":"Child care slots for working parents"},"keywords":["day","childcare","child","care","available","parents","licensed"],"years":["2015","2017"],"categories":["earlyChildhood"],"counties":{"california":{"ranks":["",""],"totals":[25,23]},"alameda":{"ranks":[13,8],"totals":[31,34]},"alpine":{"ranks":[57,3],"totals":[13,41]},"amador":{"ranks":[38,14],"totals":[24,28]},"butte":{"ranks":[25,28],"totals":[26,24]},"calaveras":{"ranks":[17,21],"totals":[30,26]},"colusa":{"ranks":[8,5],"totals":[34,35]},"contraCosta":{"ranks":[17,14],"totals":[30,28]},"delNorte":{"ranks":[5,23],"totals":[36,25]},"elDorado":{"ranks":[30,34],"totals":[25,23]},"fresno":{"ranks":[48,51],"totals":[18,18]},"glenn":{"ranks":[25,28],"totals":[26,24]},"humboldt":{"ranks":[38,40],"totals":[24,21]},"imperial":{"ranks":[21,44],"totals":[28,20]},"inyo":{"ranks":[30,28],"totals":[25,24]},"kern":{"ranks":[48,53],"totals":[18,17]},"kings":{"ranks":[56,58],"totals":[15,11]},"lake":{"ranks":[48,34],"totals":[18,23]},"lassen":{"ranks":[25,14],"totals":[26,28]},"losAngeles":{"ranks":[30,38],"totals":[25,22]},"madera":{"ranks":[30,44],"totals":[25,20]},"marin":{"ranks":[2,4],"totals":[45,40]},"mariposa":{"ranks":[44,48],"totals":[20,19]},"mendocino":{"ranks":[43,28],"totals":[22,24]},"merced":{"ranks":[48,48],"totals":[18,19]},"modoc":{"ranks":[1,1],"totals":[84,62]},"mono":{"ranks":[53,28],"totals":[17,24]},"monterey":{"ranks":[41,48],"totals":[23,19]},"napa":{"ranks":[30,40],"totals":[25,21]},"nevada":{"ranks":[4,23],"totals":[38,25]},"orange":{"ranks":[25,23],"totals":[26,25]},"placer":{"ranks":[9,5],"totals":[32,35]},"plumas":{"ranks":[5,9],"totals":[36,33]},"riverside":{"ranks":[57,51],"totals":[13,18]},"sacramento":{"ranks":[21,18],"totals":[28,27]},"sanBenito":{"ranks":[21,34],"totals":[28,23]},"sanBernardino":{"ranks":[47,56],"totals":[19,15]},"sanDiego":{"ranks":[13,18],"totals":[31,27]},"sanFrancisco":{"ranks":[3,2],"totals":[40,42]},"sanJoaquin":{"ranks":[48,38],"totals":[18,22]},"sanLuisObispo":{"ranks":[9,10],"totals":[32,30]},"sanMateo":{"ranks":[21,21],"totals":[28,26]},"santaBarbara":{"ranks":[19,34],"totals":[29,23]},"santaClara":{"ranks":[13,11],"totals":[31,29]},"santaCruz":{"ranks":[9,11],"totals":[32,29]},"shasta":{"ranks":[25,5],"totals":[26,35]},"sierra":{"ranks":[9,11],"totals":[32,29]},"siskiyou":{"ranks":[30,23],"totals":[25,25]},"solano":{"ranks":[53,40],"totals":[17,21]},"sonoma":{"ranks":[38,23],"totals":[24,25]},"stanislaus":{"ranks":[53,55],"totals":[17,16]},"sutter":{"ranks":[30,44],"totals":[25,20]},"tehama":{"ranks":[44,40],"totals":[20,21]},"trinity":{"ranks":[13,44],"totals":[31,20]},"tulare":{"ranks":[44,53],"totals":[20,17]},"tuolumne":{"ranks":[19,18],"totals":[29,27]},"ventura":{"ranks":[30,28],"totals":[25,24]},"yolo":{"ranks":[7,14],"totals":[35,28]},"yuba":{"ranks":[41,56],"totals":[23,15]}}}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = {"indicator":"englishLearners","semantics":{"who":"English language learners","shortWho":"ELL students","what":"gained proficiency in English","label":"English Language Learners who gained proficiency in English","shorthand":"English language learner proficiency"},"years":["2017","2018"],"keywords":["english","language","second","ESL","ELL","students","proficiency"],"categories":["education"],"counties":{"california":{"ranks":["",""],"totals":[44,47]},"alameda":{"ranks":[6,8],"totals":[47,49]},"alpine":{"ranks":["",""],"totals":["",""]},"amador":{"ranks":[1,1],"totals":[72,63]},"butte":{"ranks":[9,2],"totals":[46,52]},"calaveras":{"ranks":[2,20],"totals":[51,45]},"colusa":{"ranks":[25,36],"totals":[41,40]},"contraCosta":{"ranks":[29,29],"totals":[40,42]},"delNorte":{"ranks":[36,36],"totals":[38,40]},"elDorado":{"ranks":[41,34],"totals":[36,41]},"fresno":{"ranks":[16,16],"totals":[44,46]},"glenn":{"ranks":[21,2],"totals":[42,52]},"humboldt":{"ranks":[55,54],"totals":[29,30]},"imperial":{"ranks":[54,50],"totals":[31,33]},"inyo":{"ranks":[25,5],"totals":[41,51]},"kern":{"ranks":[13,9],"totals":[45,48]},"kings":{"ranks":[36,26],"totals":[38,43]},"lake":{"ranks":[50,50],"totals":[32,33]},"lassen":{"ranks":[45,34],"totals":[35,41]},"losAngeles":{"ranks":[3,2],"totals":[49,52]},"madera":{"ranks":[9,16],"totals":[46,46]},"marin":{"ranks":[36,26],"totals":[38,43]},"mariposa":{"ranks":[41,50],"totals":[36,33]},"mendocino":{"ranks":[48,50],"totals":[33,33]},"merced":{"ranks":[13,9],"totals":[45,48]},"modoc":{"ranks":[56,57],"totals":[24,25]},"mono":{"ranks":[9,16],"totals":[46,46]},"monterey":{"ranks":[40,44],"totals":[37,38]},"napa":{"ranks":[9,9],"totals":[46,48]},"nevada":{"ranks":[50,46],"totals":[32,36]},"orange":{"ranks":[16,16],"totals":[44,46]},"placer":{"ranks":[6,6],"totals":[47,50]},"plumas":{"ranks":[50,56],"totals":[32,28]},"riverside":{"ranks":[21,20],"totals":[42,45]},"sacramento":{"ranks":[21,24],"totals":[42,44]},"sanBenito":{"ranks":[45,42],"totals":[35,39]},"sanBernardino":{"ranks":[16,13],"totals":[44,47]},"sanDiego":{"ranks":[25,24],"totals":[41,44]},"sanFrancisco":{"ranks":[19,29],"totals":[43,42]},"sanJoaquin":{"ranks":[31,26],"totals":[39,43]},"sanLuisObispo":{"ranks":[25,20],"totals":[41,45]},"sanMateo":{"ranks":[21,20],"totals":[42,45]},"santaBarbara":{"ranks":[45,36],"totals":[35,40]},"santaClara":{"ranks":[5,9],"totals":[48,48]},"santaCruz":{"ranks":[41,44],"totals":[36,38]},"shasta":{"ranks":[31,29],"totals":[39,42]},"sierra":{"ranks":[29,42],"totals":[40,39]},"siskiyou":{"ranks":[31,48],"totals":[39,35]},"solano":{"ranks":[3,6],"totals":[49,50]},"sonoma":{"ranks":[31,29],"totals":[39,42]},"stanislaus":{"ranks":[36,36],"totals":[38,40]},"sutter":{"ranks":[13,13],"totals":[45,47]},"tehama":{"ranks":[48,48],"totals":[33,35]},"trinity":{"ranks":[57,54],"totals":[21,30]},"tulare":{"ranks":[41,36],"totals":[36,40]},"tuolumne":{"ranks":[6,36],"totals":[47,40]},"ventura":{"ranks":[31,29],"totals":[39,42]},"yolo":{"ranks":[19,13],"totals":[43,47]},"yuba":{"ranks":[50,46],"totals":[32,36]}}}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = {"indicator":"enrolled34","semantics":{"who":"3 and 4-year-olds","shortWho":"3-4 y/o's","what":"enrolled in preschool or transitional kindergarten","label":"3-and-4-year-olds enrolled in preschool or transitional kindergarten","shorthand":"Preschool/transitional kindergarten"},"keywords":["enrolled","3-4","preschool","transitional","kindergarten"],"years":["2011","2016"],"categories":["hasRace","education","earlyChildhood"],"counties":{"california":{"ranks":["",""],"black":[53,52],"white":[59,56],"asian":[56,56],"latinx":[43,42],"other":[59,58],"totals":[50,49]},"alameda":{"ranks":[4,5],"black":["*","*"],"white":[67,65],"asian":[68,61],"latinx":[47,45],"other":["*","*"],"totals":[59,56]},"alpine":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"amador":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"butte":{"ranks":["",""],"black":[0,"*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"calaveras":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"colusa":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"contraCosta":{"ranks":[3,4],"black":["*","*"],"white":[68,72],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[59,58]},"delNorte":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"elDorado":{"ranks":["",""],"black":[0,"*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"fresno":{"ranks":[16,19],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":[40,34],"other":["*","*"],"totals":[41,36]},"glenn":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"humboldt":{"ranks":["",""],"black":[100,100],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"imperial":{"ranks":["",""],"black":["*",100],"white":["*","*"],"asian":[100,"*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"inyo":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"kern":{"ranks":[23,21],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":[30,34],"other":["*","*"],"totals":[35,35]},"kings":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"lake":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*",100],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"lassen":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"losAngeles":{"ranks":[6,6],"black":[61,55],"white":[70,69],"asian":[62,62],"latinx":[48,48],"other":[67,64],"totals":[55,54]},"madera":{"ranks":["",""],"black":[0,0],"white":["*","*"],"asian":[100,"*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"marin":{"ranks":["",""],"black":[0,"*"],"white":[91,"*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"mariposa":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"mendocino":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*",100],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"merced":{"ranks":[22,12],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[36,44]},"modoc":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"mono":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"monterey":{"ranks":[18,17],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":[36,33],"other":["*","*"],"totals":[39,36]},"napa":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"nevada":{"ranks":["*",""],"black":["*","*"],"white":["*",""],"asian":["*",""],"latinx":["*",""],"other":["*",""],"totals":["*",""]},"orange":{"ranks":[9,7],"black":["*","*"],"white":[63,61],"asian":[58,63],"latinx":[39,44],"other":["*","*"],"totals":[50,53]},"placer":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"plumas":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"riverside":{"ranks":[21,20],"black":["*","*"],"white":[50,42],"asian":["*","*"],"latinx":[30,32],"other":["*","*"],"totals":[38,35]},"sacramento":{"ranks":[12,10],"black":["*","*"],"white":[53,44],"asian":["*",42],"latinx":[44,45],"other":["*","*"],"totals":[47,45]},"sanBenito":{"ranks":[18,17],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":[36,33],"other":["*","*"],"totals":[39,36]},"sanBernardino":{"ranks":[17,16],"black":["*","*"],"white":[46,41],"asian":["*","*"],"latinx":[38,36],"other":["*","*"],"totals":[40,38]},"sanDiego":{"ranks":[8,8],"black":["*","*"],"white":[59,56],"asian":[49,"*"],"latinx":[46,47],"other":["*","*"],"totals":[52,51]},"sanFrancisco":{"ranks":[1,1],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[62,70]},"sanJoaquin":{"ranks":[14,14],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":[40,37],"other":["*","*"],"totals":[42,39]},"sanLuisObispo":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"sanMateo":{"ranks":[2,2],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[60,63]},"santaBarbara":{"ranks":[11,""],"black":[0,"*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[49,"*"]},"santaClara":{"ranks":[5,3],"black":["*","*"],"white":[66,69],"asian":[65,65],"latinx":[43,43],"other":["*","*"],"totals":[57,58]},"santaCruz":{"ranks":["",""],"black":["*",0],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"shasta":{"ranks":["",""],"black":["*",100],"white":["*","*"],"asian":["*",0],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"sierra":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"siskiyou":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"solano":{"ranks":[13,11],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[44,44]},"sonoma":{"ranks":[10,""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[50,"*"]},"stanislaus":{"ranks":[20,13],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*",35],"other":["*","*"],"totals":[39,40]},"sutter":{"ranks":["",""],"black":[100,"*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"tehama":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"trinity":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"tulare":{"ranks":[15,15],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":[40,40],"other":["*","*"],"totals":[41,38]},"tuolumne":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"ventura":{"ranks":[7,9],"black":["*","*"],"white":[69,"*"],"asian":["*","*"],"latinx":[41,"*"],"other":["*","*"],"totals":[52,51]},"yolo":{"ranks":["",""],"black":["*",0],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"yuba":{"ranks":["",""],"black":[100,"*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]}}}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = {"indicator":"fosterYouthGraduation","semantics":{"who":"youth in foster care","what":"graduated high school on time","label":"Youth in foster care who graduated high school on time","shorthand":"Graduating youth in foster care"},"keywords":["foster","youth","graduation","care","timely","on","graduated"],"years":["2016","2017"],"categories":["welfare","education"],"counties":{"california":{"ranks":["",""],"totals":[51,51]},"alameda":{"ranks":[52,37],"totals":[42,45]},"alpine":{"ranks":["",""],"totals":["",""]},"amador":{"ranks":[51,""],"totals":[43,"*"]},"butte":{"ranks":[11,20],"totals":[78,58]},"calaveras":{"ranks":[6,13],"totals":[94,64]},"colusa":{"ranks":[1,""],"totals":[100,"*"]},"contraCosta":{"ranks":[33,15],"totals":[57,62]},"delNorte":{"ranks":[14,""],"totals":[71,"*"]},"elDorado":{"ranks":[20,23],"totals":[63,55]},"fresno":{"ranks":[34,31],"totals":[55,49]},"glenn":{"ranks":[14,""],"totals":[71,"*"]},"humboldt":{"ranks":[16,8],"totals":[69,67]},"imperial":{"ranks":[22,8],"totals":[63,67]},"inyo":{"ranks":[55,44],"totals":[33,27]},"kern":{"ranks":[40,25],"totals":[52,54]},"kings":{"ranks":[36,34],"totals":[55,48]},"lake":{"ranks":[31,42],"totals":[57,36]},"lassen":{"ranks":[22,1],"totals":[63,77]},"losAngeles":{"ranks":[46,36],"totals":[47,47]},"madera":{"ranks":[49,19],"totals":[44,58]},"marin":{"ranks":[18,35],"totals":[67,47]},"mariposa":{"ranks":[12,""],"totals":[75,"*"]},"mendocino":{"ranks":[52,21],"totals":[42,58]},"merced":{"ranks":[21,7],"totals":[63,68]},"modoc":{"ranks":[1,""],"totals":[100,"*"]},"mono":{"ranks":[47,""],"totals":[46,"*"]},"monterey":{"ranks":[31,39],"totals":[57,45]},"napa":{"ranks":[9,11],"totals":[81,65]},"nevada":{"ranks":[56,45],"totals":[14,25]},"orange":{"ranks":[28,18],"totals":[60,59]},"placer":{"ranks":[17,16],"totals":[67,62]},"plumas":{"ranks":[1,""],"totals":[100,"*"]},"riverside":{"ranks":[37,28],"totals":[54,52]},"sacramento":{"ranks":[45,33],"totals":[48,48]},"sanBenito":{"ranks":[1,""],"totals":[100,"*"]},"sanBernardino":{"ranks":[41,29],"totals":[51,50]},"sanDiego":{"ranks":[43,40],"totals":[50,44]},"sanFrancisco":{"ranks":[54,41],"totals":[42,44]},"sanJoaquin":{"ranks":[38,29],"totals":[53,50]},"sanLuisObispo":{"ranks":[7,2],"totals":[93,75]},"sanMateo":{"ranks":[24,14],"totals":[62,64]},"santaBarbara":{"ranks":[35,27],"totals":[55,53]},"santaClara":{"ranks":[50,24],"totals":[43,55]},"santaCruz":{"ranks":[25,17],"totals":[62,60]},"shasta":{"ranks":[12,6],"totals":[75,70]},"sierra":{"ranks":["",""],"totals":["",""]},"siskiyou":{"ranks":[8,4],"totals":[86,73]},"solano":{"ranks":[30,22],"totals":[57,56]},"sonoma":{"ranks":[39,37],"totals":[53,45]},"stanislaus":{"ranks":[44,12],"totals":[48,64]},"sutter":{"ranks":[42,43],"totals":[50,27]},"tehama":{"ranks":[10,3],"totals":[80,73]},"trinity":{"ranks":[18,""],"totals":[67,"*"]},"tulare":{"ranks":[26,5],"totals":[61,71]},"tuolumne":{"ranks":[1,""],"totals":[100,"*"]},"ventura":{"ranks":[48,32],"totals":[45,48]},"yolo":{"ranks":[29,8],"totals":[58,67]},"yuba":{"ranks":[26,26],"totals":[61,53]}}}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = {"indicator":"FRPMSchoolYear","semantics":{"descriptor":"eligible","who":"students","what":"received free or reduced-price meals during the school year","label":"Eligible students who received free or reduced-price meals during the school year","shorthand":"Free/reduced $ meals, school year"},"keywords":["eligible","students","meals","food","hunger","reduced","free","price","cost","lunches","school","year"],"years":["2016"],"categories":["health","education"],"counties":{"california":{"ranks":[""],"totals":[54]},"alameda":{"ranks":[54],"totals":[41]},"alpine":{"ranks":[1],"totals":[96]},"amador":{"ranks":[45],"totals":[48]},"butte":{"ranks":[24],"totals":[55]},"calaveras":{"ranks":[47],"totals":[46]},"colusa":{"ranks":[2],"totals":[69]},"contraCosta":{"ranks":[30],"totals":[53]},"delNorte":{"ranks":[43],"totals":[48]},"elDorado":{"ranks":[32],"totals":[53]},"fresno":{"ranks":[4],"totals":[65]},"glenn":{"ranks":[16],"totals":[58]},"humboldt":{"ranks":[48],"totals":[46]},"imperial":{"ranks":[14],"totals":[58]},"inyo":{"ranks":[58],"totals":[22]},"kern":{"ranks":[7],"totals":[63]},"kings":{"ranks":[21],"totals":[57]},"lake":{"ranks":[31],"totals":[53]},"lassen":{"ranks":[55],"totals":[39]},"losAngeles":{"ranks":[38],"totals":[49]},"madera":{"ranks":[11],"totals":[61]},"marin":{"ranks":[34],"totals":[52]},"mariposa":{"ranks":[46],"totals":[46]},"mendocino":{"ranks":[40],"totals":[49]},"merced":{"ranks":[9],"totals":[62]},"modoc":{"ranks":[6],"totals":[63]},"mono":{"ranks":[56],"totals":[33]},"monterey":{"ranks":[19],"totals":[57]},"napa":{"ranks":[50],"totals":[45]},"nevada":{"ranks":[57],"totals":[26]},"orange":{"ranks":[13],"totals":[60]},"placer":{"ranks":[35],"totals":[52]},"plumas":{"ranks":[53],"totals":[42]},"riverside":{"ranks":[10],"totals":[61]},"sacramento":{"ranks":[28],"totals":[55]},"sanBenito":{"ranks":[15],"totals":[58]},"sanBernardino":{"ranks":[17],"totals":[58]},"sanDiego":{"ranks":[42],"totals":[49]},"sanFrancisco":{"ranks":[51],"totals":[44]},"sanJoaquin":{"ranks":[25],"totals":[55]},"sanLuisObispo":{"ranks":[49],"totals":[45]},"sanMateo":{"ranks":[36],"totals":[52]},"santaBarbara":{"ranks":[12],"totals":[60]},"santaClara":{"ranks":[41],"totals":[49]},"santaCruz":{"ranks":[44],"totals":[48]},"shasta":{"ranks":[26],"totals":[55]},"sierra":{"ranks":[23],"totals":[55]},"siskiyou":{"ranks":[33],"totals":[52]},"solano":{"ranks":[37],"totals":[50]},"sonoma":{"ranks":[52],"totals":[44]},"stanislaus":{"ranks":[18],"totals":[58]},"sutter":{"ranks":[39],"totals":[49]},"tehama":{"ranks":[3],"totals":[66]},"trinity":{"ranks":[22],"totals":[55]},"tulare":{"ranks":[8],"totals":[62]},"tuolumne":{"ranks":[29],"totals":[54]},"ventura":{"ranks":[27],"totals":[55]},"yolo":{"ranks":[20],"totals":[57]},"yuba":{"ranks":[5],"totals":[64]}}}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = {"indicator":"FRPMSummer","semantics":{"descriptor":"eligible","who":"students","what":"received free or reduced-price meals during the summer","label":"Eligible students who received free or reduced-price meals during the summer","shorthand":"Free/reduced $ meals, summer"},"keywords":["eligible","students","meals","food","hunger","reduced","free","price","cost","lunches","summer","vacation","break"],"years":["2016"],"categories":["health","education"],"counties":{"california":{"ranks":[""],"totals":[8]},"alameda":{"ranks":[9],"totals":[11]},"alpine":{"ranks":[""],"totals":[""]},"amador":{"ranks":[55],"totals":[0]},"butte":{"ranks":[23],"totals":[6]},"calaveras":{"ranks":[18],"totals":[8]},"colusa":{"ranks":[27],"totals":[6]},"contraCosta":{"ranks":[7],"totals":[11]},"delNorte":{"ranks":[4],"totals":[13]},"elDorado":{"ranks":[33],"totals":[5]},"fresno":{"ranks":[35],"totals":[5]},"glenn":{"ranks":[39],"totals":[4]},"humboldt":{"ranks":[30],"totals":[5]},"imperial":{"ranks":[24],"totals":[6]},"inyo":{"ranks":[49],"totals":[3]},"kern":{"ranks":[47],"totals":[3]},"kings":{"ranks":[48],"totals":[3]},"lake":{"ranks":[26],"totals":[6]},"lassen":{"ranks":[51],"totals":[1]},"losAngeles":{"ranks":[8],"totals":[11]},"madera":{"ranks":[32],"totals":[5]},"marin":{"ranks":[16],"totals":[8]},"mariposa":{"ranks":[54],"totals":[0]},"mendocino":{"ranks":[10],"totals":[11]},"merced":{"ranks":[22],"totals":[6]},"modoc":{"ranks":[17],"totals":[8]},"mono":{"ranks":[53],"totals":[0]},"monterey":{"ranks":[29],"totals":[5]},"napa":{"ranks":[36],"totals":[4]},"nevada":{"ranks":[42],"totals":[3]},"orange":{"ranks":[15],"totals":[8]},"placer":{"ranks":[34],"totals":[5]},"plumas":{"ranks":[6],"totals":[11]},"riverside":{"ranks":[25],"totals":[6]},"sacramento":{"ranks":[21],"totals":[7]},"sanBenito":{"ranks":[5],"totals":[13]},"sanBernardino":{"ranks":[50],"totals":[2]},"sanDiego":{"ranks":[3],"totals":[13]},"sanFrancisco":{"ranks":[1],"totals":[18]},"sanJoaquin":{"ranks":[38],"totals":[4]},"sanLuisObispo":{"ranks":[41],"totals":[4]},"sanMateo":{"ranks":[2],"totals":[13]},"santaBarbara":{"ranks":[12],"totals":[9]},"santaClara":{"ranks":[14],"totals":[8]},"santaCruz":{"ranks":[20],"totals":[7]},"shasta":{"ranks":[37],"totals":[4]},"sierra":{"ranks":[""],"totals":[""]},"siskiyou":{"ranks":[31],"totals":[5]},"solano":{"ranks":[28],"totals":[6]},"sonoma":{"ranks":[11],"totals":[10]},"stanislaus":{"ranks":[45],"totals":[3]},"sutter":{"ranks":[43],"totals":[3]},"tehama":{"ranks":[40],"totals":[4]},"trinity":{"ranks":[46],"totals":[3]},"tulare":{"ranks":[44],"totals":[3]},"tuolumne":{"ranks":[""],"totals":[""]},"ventura":{"ranks":[19],"totals":[8]},"yolo":{"ranks":[13],"totals":[9]},"yuba":{"ranks":[52],"totals":[1]}}}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = {"indicator":"FYTimelyDental","semantics":{"who":"children","shortWho":"children","what":"in the child welfare system had a timely dental exam","label":"Children in the child welfare system who had a timely dental exam","shorthand":"Dental exams in child welfare"},"keywords":["foster","youth","timely","dental","regular","dentist","teeth"],"years":["2016","2017"],"categories":["hasRace","welfare","health"],"counties":{"california":{"ranks":["",""],"black":[55,57],"white":[61,61],"asian":[60,61],"latinx":[63,63],"other":[71,74],"totals":[61,62]},"alameda":{"ranks":[23,30],"black":[67,62],"white":[74,63],"asian":[74,72],"latinx":[66,62],"other":[46,36],"totals":[67,62]},"alpine":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"amador":{"ranks":[33,52],"black":[75,0],"white":[56,41],"asian":[100,0],"latinx":[68,45],"other":[75,0],"totals":[60,38]},"butte":{"ranks":[30,29],"black":[64,75],"white":[64,63],"asian":[76,72],"latinx":[61,56],"other":[41,62],"totals":[63,63]},"calaveras":{"ranks":[50,51],"black":[0,""],"white":[51,42],"asian":[0,0],"latinx":[34,26],"other":[75,50],"totals":[47,40]},"colusa":{"ranks":[7,20],"black":["",50],"white":[90,75],"asian":["",""],"latinx":[69,68],"other":[90,56],"totals":[78,68]},"contraCosta":{"ranks":[51,50],"black":[46,39],"white":[44,43],"asian":[35,37],"latinx":[51,45],"other":[45,50],"totals":[47,42]},"delNorte":{"ranks":[12,17],"black":["",0],"white":[80,62],"asian":["",100],"latinx":[80,80],"other":[59,82],"totals":[75,71]},"elDorado":{"ranks":[25,10],"black":[69,63],"white":[65,74],"asian":[79,78],"latinx":[64,74],"other":[88,94],"totals":[66,74]},"fresno":{"ranks":[37,34],"black":[52,50],"white":[57,62],"asian":[64,73],"latinx":[57,62],"other":[52,49],"totals":[56,60]},"glenn":{"ranks":[18,15],"black":[50,88],"white":[68,70],"asian":["",""],"latinx":[73,73],"other":[88,79],"totals":[70,72]},"humboldt":{"ranks":[17,27],"black":[48,79],"white":[68,62],"asian":[63,88],"latinx":[74,71],"other":[77,64],"totals":[71,65]},"imperial":{"ranks":[53,37],"black":[45,71],"white":[37,47],"asian":["",""],"latinx":[40,59],"other":[28,33],"totals":[40,58]},"inyo":{"ranks":[57,55],"black":["",""],"white":[0,6],"asian":["",""],"latinx":[0,8],"other":[8,8],"totals":[2,9]},"kern":{"ranks":[13,9],"black":[74,73],"white":[71,74],"asian":[84,67],"latinx":[77,74],"other":[42,81],"totals":[74,74]},"kings":{"ranks":[43,33],"black":[40,52],"white":[54,64],"asian":[18,70],"latinx":[56,61],"other":[37,45],"totals":[53,60]},"lake":{"ranks":[27,42],"black":[40,31],"white":[70,57],"asian":["",0],"latinx":[55,51],"other":[68,58],"totals":[65,53]},"lassen":{"ranks":[54,56],"black":["",""],"white":[19,8],"asian":["",""],"latinx":[45,10],"other":[38,8],"totals":[24,8]},"losAngeles":{"ranks":[31,24],"black":[53,58],"white":[62,68],"asian":[60,63],"latinx":[65,67],"other":[76,77],"totals":[62,65]},"madera":{"ranks":[11,16],"black":[84,84],"white":[74,69],"asian":[100,100],"latinx":[75,71],"other":[94,92],"totals":[76,72]},"marin":{"ranks":[10,5],"black":[63,77],"white":[75,89],"asian":[100,""],"latinx":[82,71],"other":[100,100],"totals":[76,79]},"mariposa":{"ranks":[34,39],"black":["",""],"white":[56,48],"asian":["",""],"latinx":[79,75],"other":[58,100],"totals":[60,57]},"mendocino":{"ranks":[6,2],"black":[66,79],"white":[76,82],"asian":["",""],"latinx":[87,87],"other":[78,80],"totals":[78,83]},"merced":{"ranks":[24,28],"black":[76,71],"white":[63,57],"asian":[77,53],"latinx":[67,65],"other":[96,78],"totals":[67,64]},"modoc":{"ranks":[2,1],"black":["",""],"white":[69,95],"asian":["",""],"latinx":[76,87],"other":[100,100],"totals":[81,92]},"mono":{"ranks":[47,32],"black":["",""],"white":[100,75],"asian":["",""],"latinx":[0,0],"other":[75,83],"totals":[48,60]},"monterey":{"ranks":[1,23],"black":[78,66],"white":[78,54],"asian":[100,92],"latinx":[84,68],"other":[50,42],"totals":[83,67]},"napa":{"ranks":[5,12],"black":["",92],"white":[81,76],"asian":["",100],"latinx":[79,72],"other":[50,50],"totals":[79,74]},"nevada":{"ranks":[26,26],"black":[0,""],"white":[64,65],"asian":["",""],"latinx":[88,70],"other":[0,""],"totals":[65,65]},"orange":{"ranks":[28,38],"black":[62,58],"white":[64,56],"asian":[52,49],"latinx":[66,58],"other":[65,73],"totals":[65,58]},"placer":{"ranks":[48,44],"black":[43,46],"white":[49,52],"asian":[73,100],"latinx":[40,48],"other":[57,72],"totals":[48,52]},"plumas":{"ranks":[39,43],"black":[100,100],"white":[51,48],"asian":["",""],"latinx":[49,100],"other":[61,54],"totals":[55,53]},"riverside":{"ranks":[49,49],"black":[45,45],"white":[47,47],"asian":[50,64],"latinx":[48,48],"other":[39,32],"totals":[47,47]},"sacramento":{"ranks":[44,45],"black":[49,50],"white":[53,51],"asian":[48,56],"latinx":[55,55],"other":[53,62],"totals":[52,52]},"sanBenito":{"ranks":[55,54],"black":[38,38],"white":[12,0],"asian":["",""],"latinx":[6,19],"other":[31,28],"totals":[11,16]},"sanBernardino":{"ranks":[42,46],"black":[52,51],"white":[54,51],"asian":[47,40],"latinx":[52,51],"other":[66,60],"totals":[53,51]},"sanDiego":{"ranks":[16,6],"black":[71,74],"white":[71,76],"asian":[67,78],"latinx":[75,79],"other":[75,77],"totals":[73,77]},"sanFrancisco":{"ranks":[20,22],"black":[69,65],"white":[72,67],"asian":[74,67],"latinx":[68,70],"other":[100,71],"totals":[69,67]},"sanJoaquin":{"ranks":[40,40],"black":[54,52],"white":[59,59],"asian":[56,49],"latinx":[53,53],"other":[46,43],"totals":[55,54]},"sanLuisObispo":{"ranks":[21,25],"black":[68,54],"white":[72,62],"asian":[83,85],"latinx":[64,69],"other":[66,77],"totals":[68,65]},"sanMateo":{"ranks":[35,8],"black":[48,69],"white":[54,80],"asian":[71,72],"latinx":[62,75],"other":[0,38],"totals":[59,74]},"santaBarbara":{"ranks":[46,47],"black":[56,57],"white":[47,50],"asian":[36,36],"latinx":[51,51],"other":[38,33],"totals":[50,50]},"santaClara":{"ranks":[32,31],"black":[65,61],"white":[55,60],"asian":[70,60],"latinx":[61,62],"other":[40,100],"totals":[61,62]},"santaCruz":{"ranks":[52,53],"black":[52,36],"white":[37,42],"asian":[0,38],"latinx":[43,30],"other":[0,""],"totals":[41,34]},"shasta":{"ranks":[14,7],"black":[70,80],"white":[76,77],"asian":[100,25],"latinx":[73,76],"other":[60,68],"totals":[74,76]},"sierra":{"ranks":[56,57],"black":["",""],"white":[0,0],"asian":["",""],"latinx":[100,""],"other":["",""],"totals":[8,0]},"siskiyou":{"ranks":[29,4],"black":[83,100],"white":[67,82],"asian":[25,25],"latinx":[45,52],"other":[56,74],"totals":[63,79]},"solano":{"ranks":[22,21],"black":[63,63],"white":[72,66],"asian":[72,85],"latinx":[70,74],"other":[62,79],"totals":[67,68]},"sonoma":{"ranks":[36,41],"black":[69,69],"white":[59,54],"asian":[34,17],"latinx":[59,53],"other":[56,45],"totals":[59,54]},"stanislaus":{"ranks":[45,36],"black":[46,53],"white":[53,60],"asian":[65,69],"latinx":[51,61],"other":[13,77],"totals":[51,60]},"sutter":{"ranks":[3,3],"black":[79,87],"white":[83,80],"asian":[50,13],"latinx":[77,80],"other":[100,100],"totals":[80,80]},"tehama":{"ranks":[38,35],"black":[62,67],"white":[51,60],"asian":[0,0],"latinx":[65,60],"other":[45,51],"totals":[55,60]},"trinity":{"ranks":[15,18],"black":["",0],"white":[69,69],"asian":[100,25],"latinx":[96,50],"other":[82,92],"totals":[74,71]},"tulare":{"ranks":[8,19],"black":[71,66],"white":[81,71],"asian":[100,35],"latinx":[78,70],"other":[71,70],"totals":[78,70]},"tuolumne":{"ranks":[9,11],"black":["",""],"white":[81,80],"asian":[50,33],"latinx":[68,59],"other":[95,90],"totals":[78,74]},"ventura":{"ranks":[4,14],"black":[69,67],"white":[78,66],"asian":[80,85],"latinx":[80,75],"other":[38,100],"totals":[79,73]},"yolo":{"ranks":[41,48],"black":[45,41],"white":[53,45],"asian":[27,24],"latinx":[60,52],"other":[19,23],"totals":[54,48]},"yuba":{"ranks":[19,13],"black":[58,63],"white":[70,74],"asian":[97,76],"latinx":[67,69],"other":[63,94],"totals":[70,73]}}}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = {"indicator":"FYTimelyMedical","semantics":{"who":"children","shortWho":"children","what":"in the child welfare system had a timely medical exam","label":"Children in the child welfare system who had a timely medical exam","shorthand":"Medical exams in child welfare"},"keywords":["foster","youth","timely","regular","doctor","medical","exam","checkup"],"years":["2016","2017"],"categories":["hasRace","welfare","health"],"counties":{"california":{"ranks":["",""],"black":[74,72],"white":[77,75],"asian":[75,72],"latinx":[78,76],"other":[85,82],"totals":[77,75]},"alameda":{"ranks":[35,39],"black":[78,71],"white":[81,75],"asian":[77,65],"latinx":[78,75],"other":[62,72],"totals":[78,73]},"alpine":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"amador":{"ranks":[42,52],"black":[75,50],"white":[73,53],"asian":[100,25],"latinx":[72,66],"other":[75,0],"totals":[73,55]},"butte":{"ranks":[20,9],"black":[85,86],"white":[83,84],"asian":[90,82],"latinx":[81,86],"other":[78,88],"totals":[83,85]},"calaveras":{"ranks":[48,50],"black":[0,""],"white":[67,65],"asian":[100,0],"latinx":[57,54],"other":[100,50],"totals":[65,63]},"colusa":{"ranks":[23,14],"black":["",100],"white":[89,90],"asian":["",""],"latinx":[81,81],"other":[75,42],"totals":[82,82]},"contraCosta":{"ranks":[51,51],"black":[59,53],"white":[65,62],"asian":[51,49],"latinx":[65,62],"other":[75,71],"totals":[62,58]},"delNorte":{"ranks":[16,16],"black":["",100],"white":[85,79],"asian":["",100],"latinx":[86,91],"other":[79,78],"totals":[84,81]},"elDorado":{"ranks":[24,11],"black":[74,65],"white":[82,83],"asian":[79,92],"latinx":[85,85],"other":[87,90],"totals":[82,83]},"fresno":{"ranks":[38,35],"black":[71,68],"white":[77,77],"asian":[80,77],"latinx":[76,76],"other":[64,61],"totals":[75,75]},"glenn":{"ranks":[12,5],"black":[50,88],"white":[83,88],"asian":["",""],"latinx":[91,86],"other":[75,82],"totals":[85,86]},"humboldt":{"ranks":[2,3],"black":[78,89],"white":[91,91],"asian":[100,100],"latinx":[87,87],"other":[90,83],"totals":[90,88]},"imperial":{"ranks":[52,43],"black":[69,78],"white":[53,53],"asian":["",100],"latinx":[61,68],"other":[31,52],"totals":[61,67]},"inyo":{"ranks":[54,55],"black":["",""],"white":[59,29],"asian":["",""],"latinx":[32,6],"other":[33,0],"totals":[44,11]},"kern":{"ranks":[18,18],"black":[84,83],"white":[82,79],"asian":[87,80],"latinx":[84,82],"other":[76,81],"totals":[83,81]},"kings":{"ranks":[25,13],"black":[85,86],"white":[81,80],"asian":[66,70],"latinx":[81,82],"other":[73,87],"totals":[81,83]},"lake":{"ranks":[14,36],"black":[91,69],"white":[84,74],"asian":["",0],"latinx":[83,73],"other":[79,86],"totals":[84,74]},"lassen":{"ranks":[55,56],"black":["",""],"white":[39,3],"asian":["",""],"latinx":[45,27],"other":[63,28],"totals":[41,7]},"losAngeles":{"ranks":[29,28],"black":[75,72],"white":[80,81],"asian":[79,80],"latinx":[81,79],"other":[88,85],"totals":[80,78]},"madera":{"ranks":[5,4],"black":[84,85],"white":[89,87],"asian":[100,100],"latinx":[87,87],"other":[85,100],"totals":[87,87]},"marin":{"ranks":[18,17],"black":[65,76],"white":[87,80],"asian":[100,""],"latinx":[89,85],"other":[100,100],"totals":[83,81]},"mariposa":{"ranks":[41,19],"black":["",""],"white":[76,79],"asian":["",""],"latinx":[56,80],"other":[73,100],"totals":[73,80]},"mendocino":{"ranks":[13,8],"black":[72,82],"white":[83,85],"asian":["",""],"latinx":[88,86],"other":[88,86],"totals":[85,85]},"merced":{"ranks":[27,24],"black":[76,83],"white":[80,80],"asian":[71,54],"latinx":[81,80],"other":[100,91],"totals":[81,80]},"modoc":{"ranks":[1,1],"black":["",""],"white":[82,98],"asian":["",""],"latinx":[96,90],"other":[100,100],"totals":[91,94]},"mono":{"ranks":[49,7],"black":["",""],"white":[100,100],"asian":["",""],"latinx":[0,0],"other":[100,83],"totals":[63,85]},"monterey":{"ranks":[15,37],"black":[87,74],"white":[80,68],"asian":[88,92],"latinx":[84,75],"other":[75,79],"totals":[84,74]},"napa":{"ranks":[6,29],"black":["",100],"white":[87,80],"asian":["",100],"latinx":[89,75],"other":[50,50],"totals":[87,78]},"nevada":{"ranks":[30,20],"black":[0,100],"white":[79,78],"asian":["",""],"latinx":[100,95],"other":[0,100],"totals":[79,80]},"orange":{"ranks":[26,42],"black":[74,69],"white":[79,67],"asian":[80,70],"latinx":[82,72],"other":[98,85],"totals":[81,71]},"placer":{"ranks":[39,41],"black":[68,67],"white":[74,74],"asian":[84,79],"latinx":[79,68],"other":[65,63],"totals":[75,72]},"plumas":{"ranks":[11,45],"black":[100,100],"white":[79,65],"asian":["",""],"latinx":[96,79],"other":[96,58],"totals":[85,66]},"riverside":{"ranks":[50,49],"black":[63,65],"white":[63,61],"asian":[65,67],"latinx":[64,65],"other":[55,46],"totals":[63,64]},"sacramento":{"ranks":[43,47],"black":[67,61],"white":[69,64],"asian":[62,69],"latinx":[71,66],"other":[80,79],"totals":[69,64]},"sanBenito":{"ranks":[56,54],"black":[0,0],"white":[12,25],"asian":["",""],"latinx":[14,17],"other":[30,12],"totals":[14,18]},"sanBernardino":{"ranks":[37,40],"black":[76,73],"white":[76,72],"asian":[65,58],"latinx":[76,73],"other":[76,69],"totals":[76,72]},"sanDiego":{"ranks":[22,12],"black":[80,82],"white":[84,84],"asian":[80,83],"latinx":[82,83],"other":[79,79],"totals":[82,83]},"sanFrancisco":{"ranks":[28,25],"black":[79,78],"white":[80,81],"asian":[81,80],"latinx":[82,80],"other":[75,100],"totals":[80,79]},"sanJoaquin":{"ranks":[33,38],"black":[78,73],"white":[78,76],"asian":[83,69],"latinx":[78,72],"other":[82,70],"totals":[78,73]},"sanLuisObispo":{"ranks":[31,32],"black":[66,37],"white":[78,75],"asian":[42,75],"latinx":[82,81],"other":[88,76],"totals":[79,76]},"sanMateo":{"ranks":[45,34],"black":[61,71],"white":[66,75],"asian":[72,77],"latinx":[68,76],"other":[56,54],"totals":[67,75]},"santaBarbara":{"ranks":[46,46],"black":[72,78],"white":[61,63],"asian":[63,33],"latinx":[69,65],"other":[75,81],"totals":[66,64]},"santaClara":{"ranks":[36,33],"black":[81,72],"white":[74,78],"asian":[78,73],"latinx":[78,76],"other":[68,100],"totals":[78,76]},"santaCruz":{"ranks":[53,53],"black":[39,24],"white":[67,62],"asian":[0,75],"latinx":[58,50],"other":[38,""],"totals":[60,54]},"shasta":{"ranks":[9,21],"black":[80,84],"white":[86,83],"asian":[100,100],"latinx":[87,77],"other":[75,64],"totals":[86,80]},"sierra":{"ranks":[57,57],"black":["",""],"white":[0,0],"asian":["",""],"latinx":[100,""],"other":["",""],"totals":[8,0]},"siskiyou":{"ranks":[4,2],"black":[100,100],"white":[93,94],"asian":[38,25],"latinx":[73,62],"other":[73,73],"totals":[87,89]},"solano":{"ranks":[40,31],"black":[72,77],"white":[77,75],"asian":[80,73],"latinx":[73,78],"other":[68,68],"totals":[74,76]},"sonoma":{"ranks":[44,44],"black":[76,77],"white":[68,64],"asian":[18,71],"latinx":[67,67],"other":[64,77],"totals":[68,66]},"stanislaus":{"ranks":[32,23],"black":[75,82],"white":[80,77],"asian":[81,80],"latinx":[78,81],"other":[71,85],"totals":[79,80]},"sutter":{"ranks":[3,6],"black":[88,88],"white":[91,88],"asian":[100,100],"latinx":[87,84],"other":[100,67],"totals":[89,86]},"tehama":{"ranks":[10,30],"black":[96,86],"white":[82,77],"asian":[100,100],"latinx":[92,77],"other":[86,75],"totals":[85,77]},"trinity":{"ranks":[7,10],"black":["",0],"white":[83,81],"asian":[100,100],"latinx":[98,100],"other":[95,93],"totals":[86,84]},"tulare":{"ranks":[21,26],"black":[79,78],"white":[83,78],"asian":[100,46],"latinx":[83,80],"other":[80,62],"totals":[83,79]},"tuolumne":{"ranks":[8,22],"black":["",""],"white":[89,85],"asian":[50,33],"latinx":[81,63],"other":[88,100],"totals":[86,80]},"ventura":{"ranks":[17,27],"black":[74,73],"white":[83,79],"asian":[82,58],"latinx":[84,79],"other":[50,75],"totals":[83,78]},"yolo":{"ranks":[47,48],"black":[57,62],"white":[63,59],"asian":[36,47],"latinx":[70,69],"other":[63,58],"totals":[65,64]},"yuba":{"ranks":[34,15],"black":[78,73],"white":[79,82],"asian":[93,93],"latinx":[69,81],"other":[85,91],"totals":[78,82]}}}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = {"indicator":"graduation","semantics":{"who":"12th-graders","what":"graduated high school on time","label":"12th-graders who graduated high school on time","shorthand":"On-time high school graduation"},"keywords":["graduation","seniors","high school","12th","timely","on"],"years":["2016","2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":["",""],"black":[73,73],"white":[89,87],"asian":[90,89],"latinx":[81,80],"other":[73,62],"totals":[84,83]},"alameda":{"ranks":[31,25],"black":[73,75],"white":[92,90],"asian":[90,89],"latinx":[80,80],"other":[75,74],"totals":[86,86]},"alpine":{"ranks":["",""],"black":["","*"],"white":["","*"],"asian":["","*"],"latinx":["","*"],"other":["","*"],"totals":["","*"]},"amador":{"ranks":[24,22],"black":["","*"],"white":[89,88],"asian":[75,"*"],"latinx":[80,83],"other":[100,88],"totals":[88,87]},"butte":{"ranks":[26,33],"black":[83,83],"white":[88,85],"asian":[89,90],"latinx":[85,85],"other":[68,51],"totals":[87,84]},"calaveras":{"ranks":[2,4],"black":[100,"*"],"white":[96,91],"asian":[100,"*"],"latinx":[90,92],"other":[84,100],"totals":[94,91]},"colusa":{"ranks":[17,2],"black":[100,"*"],"white":[89,94],"asian":[100,"*"],"latinx":[91,93],"other":[43,"*"],"totals":[89,94]},"contraCosta":{"ranks":[19,14],"black":[79,79],"white":[93,92],"asian":[93,93],"latinx":[84,82],"other":[91,79],"totals":[89,88]},"delNorte":{"ranks":[52,50],"black":[67,"*"],"white":[81,79],"asian":[65,100],"latinx":[72,71],"other":[64,65],"totals":[78,76]},"elDorado":{"ranks":[11,9],"black":[71,63],"white":[93,91],"asian":[93,94],"latinx":[85,84],"other":[88,79],"totals":[91,89]},"fresno":{"ranks":[42,44],"black":[74,74],"white":[86,86],"asian":[90,88],"latinx":[82,78],"other":[67,64],"totals":[83,81]},"glenn":{"ranks":[54,52],"black":[46,"*"],"white":[87,81],"asian":[72,83],"latinx":[72,73],"other":[41,"*"],"totals":[74,74]},"humboldt":{"ranks":[26,28],"black":[96,100],"white":[89,85],"asian":[96,89],"latinx":[85,84],"other":[69,81],"totals":[87,84]},"imperial":{"ranks":[20,18],"black":[96,91],"white":[93,86],"asian":[100,88],"latinx":[88,88],"other":[94,57],"totals":[89,87]},"inyo":{"ranks":[57,56],"black":[18,26],"white":[78,71],"asian":[40,"*"],"latinx":[27,32],"other":[64,76],"totals":[34,38]},"kern":{"ranks":[40,26],"black":[75,76],"white":[85,85],"asian":[86,91],"latinx":[84,86],"other":[67,75],"totals":[84,85]},"kings":{"ranks":[45,38],"black":[83,80],"white":[85,86],"asian":[98,90],"latinx":[82,81],"other":[76,70],"totals":[83,83]},"lake":{"ranks":[34,51],"black":[100,"*"],"white":[87,76],"asian":[89,"*"],"latinx":[87,74],"other":[47,69],"totals":[85,76]},"lassen":{"ranks":[32,6],"black":[60,"*"],"white":[85,90],"asian":[100,75],"latinx":[89,86],"other":[72,88],"totals":[86,90]},"losAngeles":{"ranks":[49,44],"black":[73,73],"white":[87,85],"asian":[90,90],"latinx":[80,80],"other":[64,50],"totals":[82,81]},"madera":{"ranks":[38,39],"black":[71,82],"white":[90,87],"asian":[98,84],"latinx":[82,81],"other":[83,76],"totals":[84,82]},"marin":{"ranks":[8,13],"black":[92,78],"white":[96,94],"asian":[96,91],"latinx":[81,75],"other":[90,88],"totals":[91,88]},"mariposa":{"ranks":[3,3],"black":[100,"*"],"white":[93,94],"asian":[100,"*"],"latinx":[84,81],"other":[100,"*"],"totals":[93,92]},"mendocino":{"ranks":[35,41],"black":[80,69],"white":[84,81],"asian":[91,100],"latinx":[88,85],"other":[78,63],"totals":[85,82]},"merced":{"ranks":[18,8],"black":[83,81],"white":[92,91],"asian":[95,96],"latinx":[88,89],"other":[83,79],"totals":[89,89]},"modoc":{"ranks":[6,23],"black":[100,"*"],"white":[92,86],"asian":[100,"*"],"latinx":[95,87],"other":[83,"*"],"totals":[92,86]},"mono":{"ranks":[56,57],"black":[6,0],"white":[45,33],"asian":[14,"*"],"latinx":[40,55],"other":[85,"*"],"totals":[37,35]},"monterey":{"ranks":[33,32],"black":[86,85],"white":[89,87],"asian":[92,89],"latinx":[84,83],"other":[83,75],"totals":[86,84]},"napa":{"ranks":[9,14],"black":[98,89],"white":[92,90],"asian":[93,94],"latinx":[89,85],"other":[88,90],"totals":[91,88]},"nevada":{"ranks":[55,55],"black":[18,16],"white":[79,79],"asian":[46,52],"latinx":[23,25],"other":[40,45],"totals":[50,52]},"orange":{"ranks":[10,10],"black":[86,85],"white":[94,92],"asian":[95,94],"latinx":[88,85],"other":[86,81],"totals":[91,89]},"placer":{"ranks":[7,7],"black":[85,87],"white":[93,90],"asian":[93,90],"latinx":[86,85],"other":[86,76],"totals":[92,89]},"plumas":{"ranks":[47,35],"black":["","*"],"white":[84,87],"asian":["","*"],"latinx":[92,70],"other":[61,"*"],"totals":[83,84]},"riverside":{"ranks":[13,12],"black":[86,86],"white":[93,90],"asian":[94,95],"latinx":[88,87],"other":[82,81],"totals":[89,88]},"sacramento":{"ranks":[50,44],"black":[72,72],"white":[85,84],"asian":[90,89],"latinx":[76,78],"other":[71,57],"totals":[81,81]},"sanBenito":{"ranks":[12,11],"black":[100,"*"],"white":[92,91],"asian":[97,92],"latinx":[90,87],"other":[53,"*"],"totals":[90,88]},"sanBernardino":{"ranks":[45,37],"black":[77,76],"white":[85,85],"asian":[91,90],"latinx":[83,83],"other":[72,59],"totals":[83,83]},"sanDiego":{"ranks":[48,48],"black":[74,71],"white":[88,87],"asian":[89,88],"latinx":[77,75],"other":[62,68],"totals":[82,80]},"sanFrancisco":{"ranks":[51,53],"black":[60,56],"white":[79,68],"asian":[89,83],"latinx":[66,57],"other":[72,62],"totals":[80,72]},"sanJoaquin":{"ranks":[43,43],"black":[72,69],"white":[87,83],"asian":[89,88],"latinx":[82,80],"other":[71,73],"totals":[83,81]},"sanLuisObispo":{"ranks":[4,5],"black":[90,77],"white":[95,93],"asian":[97,93],"latinx":[88,87],"other":[93,93],"totals":[92,90]},"sanMateo":{"ranks":[13,16],"black":[77,76],"white":[93,92],"asian":[91,91],"latinx":[83,80],"other":[79,78],"totals":[89,87]},"santaBarbara":{"ranks":[20,20],"black":[88,82],"white":[92,89],"asian":[90,90],"latinx":[86,86],"other":[84,75],"totals":[89,87]},"santaClara":{"ranks":[43,33],"black":[82,83],"white":[93,92],"asian":[91,89],"latinx":[69,73],"other":[75,60],"totals":[83,84]},"santaCruz":{"ranks":[30,27],"black":[82,80],"white":[91,89],"asian":[96,93],"latinx":[82,82],"other":[71,63],"totals":[86,85]},"shasta":{"ranks":[20,17],"black":[93,80],"white":[89,88],"asian":[94,89],"latinx":[88,87],"other":[57,83],"totals":[89,87]},"sierra":{"ranks":[1,1],"black":["",""],"white":[100,100],"asian":["",""],"latinx":[100,"*"],"other":["","*"],"totals":[97,100]},"siskiyou":{"ranks":[5,21],"black":[100,"*"],"white":[94,86],"asian":[96,100],"latinx":[90,92],"other":[81,82],"totals":[92,87]},"solano":{"ranks":[37,42],"black":[79,78],"white":[88,88],"asian":[91,88],"latinx":[79,74],"other":[74,78],"totals":[85,82]},"sonoma":{"ranks":[38,40],"black":[69,71],"white":[88,86],"asian":[84,85],"latinx":[81,78],"other":[67,67],"totals":[84,82]},"stanislaus":{"ranks":[41,31],"black":[70,72],"white":[87,86],"asian":[89,90],"latinx":[83,83],"other":[83,74],"totals":[84,84]},"sutter":{"ranks":[26,47],"black":[63,79],"white":[87,79],"asian":[88,90],"latinx":[86,82],"other":[85,70],"totals":[87,81]},"tehama":{"ranks":[24,28],"black":[100,"*"],"white":[88,86],"asian":[100,"*"],"latinx":[89,84],"other":[53,80],"totals":[88,84]},"trinity":{"ranks":[13,54],"black":["","*"],"white":[90,78],"asian":[100,"*"],"latinx":[88,41],"other":[93,80],"totals":[89,72]},"tulare":{"ranks":[35,28],"black":[81,79],"white":[87,86],"asian":[90,90],"latinx":[85,84],"other":[81,79],"totals":[85,84]},"tuolumne":{"ranks":[23,36],"black":[100,"*"],"white":[91,84],"asian":[75,"*"],"latinx":[80,80],"other":[90,78],"totals":[88,83]},"ventura":{"ranks":[29,24],"black":[82,78],"white":[92,90],"asian":[95,94],"latinx":[81,82],"other":[62,70],"totals":[86,86]},"yolo":{"ranks":[13,19],"black":[85,84],"white":[92,91],"asian":[93,98],"latinx":[86,82],"other":[85,89],"totals":[89,87]},"yuba":{"ranks":[53,49],"black":[71,77],"white":[75,78],"asian":[80,83],"latinx":[79,84],"other":[79,71],"totals":[78,80]},"":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]}}}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = {"indicator":"healthInsurance","semantics":{"who":"children","what":"had health insurance","label":"Children who had health insurance","shorthand":"Children's health insurance"},"keywords":["health","insurance","insured","coverage"],"years":["2012","2016"],"categories":["hasRace","health"],"counties":{"california":{"ranks":["",""],"black":[94,96],"white":[95,96],"asian":[94,96],"latinx":[88,93],"other":[94,96],"totals":[91,95]},"alameda":{"ranks":[6,2],"black":[95,97],"white":[97,98],"asian":[96,98],"latinx":[92,94],"other":[96,"*"],"totals":[95,97]},"alpine":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"amador":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"butte":{"ranks":[21,28],"black":["*","*"],"white":[92,94],"asian":["*","*"],"latinx":["*",93],"other":[89,"*"],"totals":[91,94]},"calaveras":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"colusa":{"ranks":["",7],"black":["*","*"],"white":["*",98],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*",96]},"contraCosta":{"ranks":[13,7],"black":["*","*"],"white":[96,98],"asian":[95,97],"latinx":[89,94],"other":[95,"*"],"totals":[93,96]},"delNorte":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*",98],"other":["*","*"],"totals":["*","*"]},"elDorado":{"ranks":[1,2],"black":["*","*"],"white":[96,96],"asian":["*","*"],"latinx":["*",97],"other":[97,"*"],"totals":[96,97]},"fresno":{"ranks":[13,17],"black":["*","*"],"white":[94,96],"asian":[92,95],"latinx":[92,95],"other":[91,"*"],"totals":[93,95]},"glenn":{"ranks":["",17],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":[98,"*"],"totals":["*",95]},"humboldt":{"ranks":[28,46],"black":["*","*"],"white":[91,90],"asian":[94,"*"],"latinx":["*","*"],"other":[87,"*"],"totals":[90,90]},"imperial":{"ranks":[43,43],"black":["*","*"],"white":["*","*"],"asian":[97,"*"],"latinx":[86,92],"other":["*","*"],"totals":[87,92]},"inyo":{"ranks":["",28],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":[84,"*"],"totals":["*",94]},"kern":{"ranks":[28,17],"black":["*","*"],"white":[94,97],"asian":[89,"*"],"latinx":[87,94],"other":[94,"*"],"totals":[90,95]},"kings":{"ranks":[36,28],"black":["*","*"],"white":["*",97],"asian":[92,"*"],"latinx":[86,92],"other":["*","*"],"totals":[89,94]},"lake":{"ranks":["",45],"black":["*","*"],"white":["*",92],"asian":["*","*"],"latinx":["*","*"],"other":[76,"*"],"totals":["*",91]},"lassen":{"ranks":[1,""],"black":["*","*"],"white":[97,94],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[96,"*"]},"losAngeles":{"ranks":[28,28],"black":[93,95],"white":[95,96],"asian":[91,95],"latinx":[87,93],"other":[94,96],"totals":[90,94]},"madera":{"ranks":[36,28],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":[89,94],"other":["*","*"],"totals":[89,94]},"marin":{"ranks":[6,2],"black":["*","*"],"white":[97,98],"asian":[97,"*"],"latinx":["*",95],"other":["*","*"],"totals":[95,97]},"mariposa":{"ranks":["",""],"black":["*","*"],"white":["*",98],"asian":["*","*"],"latinx":[100,100],"other":["*","*"],"totals":["*","*"]},"mendocino":{"ranks":[28,28],"black":["*","*"],"white":["*",93],"asian":["*","*"],"latinx":["*",95],"other":[88,"*"],"totals":[90,94]},"merced":{"ranks":[13,7],"black":["*","*"],"white":[94,95],"asian":["*","*"],"latinx":[92,96],"other":[96,"*"],"totals":[93,96]},"modoc":{"ranks":["",""],"black":["*","*"],"white":[100,"*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"mono":{"ranks":["",""],"black":["*","*"],"white":["*",100],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"monterey":{"ranks":[21,43],"black":["*","*"],"white":[95,93],"asian":[91,"*"],"latinx":[90,92],"other":[92,"*"],"totals":[91,92]},"napa":{"ranks":[28,17],"black":["*","*"],"white":[93,96],"asian":[96,"*"],"latinx":["*",95],"other":[96,"*"],"totals":[90,95]},"nevada":{"ranks":[21,37],"black":["*","*"],"white":[91,94],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[91,93]},"orange":{"ranks":[21,17],"black":["*","*"],"white":[96,97],"asian":[93,96],"latinx":[86,93],"other":[96,"*"],"totals":[91,95]},"placer":{"ranks":[1,17],"black":["*","*"],"white":[97,95],"asian":["*","*"],"latinx":["*",93],"other":[96,"*"],"totals":[96,95]},"plumas":{"ranks":[45,""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[75,"*"]},"riverside":{"ranks":[36,37],"black":["*",94],"white":[92,95],"asian":[91,94],"latinx":[86,91],"other":[92,"*"],"totals":[89,93]},"sacramento":{"ranks":[6,7],"black":["*",97],"white":[95,96],"asian":[94,94],"latinx":[93,95],"other":[96,"*"],"totals":[95,96]},"sanBenito":{"ranks":[28,17],"black":["*","*"],"white":["*",98],"asian":["*","*"],"latinx":["*",94],"other":["*","*"],"totals":[90,95]},"sanBernardino":{"ranks":[36,28],"black":[92,96],"white":[94,96],"asian":[92,95],"latinx":[87,92],"other":[93,"*"],"totals":[89,94]},"sanDiego":{"ranks":[28,28],"black":["*",96],"white":[95,96],"asian":[94,96],"latinx":[85,91],"other":[93,"*"],"totals":[90,94]},"sanFrancisco":{"ranks":[1,1],"black":["*","*"],"white":[98,99],"asian":[95,97],"latinx":[92,98],"other":[97,"*"],"totals":[96,98]},"sanJoaquin":{"ranks":[13,17],"black":["*","*"],"white":[96,97],"asian":[92,95],"latinx":[91,95],"other":[94,"*"],"totals":[93,95]},"sanLuisObispo":{"ranks":[21,37],"black":["*","*"],"white":[93,97],"asian":[95,"*"],"latinx":["*",87],"other":[94,"*"],"totals":[91,93]},"sanMateo":{"ranks":[6,2],"black":["*","*"],"white":[97,98],"asian":[95,97],"latinx":[92,95],"other":[97,"*"],"totals":[95,97]},"santaBarbara":{"ranks":[28,37],"black":["*","*"],"white":[96,96],"asian":[94,"*"],"latinx":[86,91],"other":[94,"*"],"totals":[90,93]},"santaClara":{"ranks":[1,2],"black":["*","*"],"white":[98,98],"asian":[97,98],"latinx":[93,96],"other":[97,"*"],"totals":[96,97]},"santaCruz":{"ranks":[6,7],"black":["*","*"],"white":[97,98],"asian":["*","*"],"latinx":[93,95],"other":[96,"*"],"totals":[95,96]},"shasta":{"ranks":[36,37],"black":["*","*"],"white":[90,93],"asian":[94,"*"],"latinx":["*",96],"other":[88,"*"],"totals":[89,93]},"sierra":{"ranks":["",""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":["*","*"]},"siskiyou":{"ranks":[21,37],"black":["*","*"],"white":[93,95],"asian":["*","*"],"latinx":["*","*"],"other":[87,"*"],"totals":[91,93]},"solano":{"ranks":[12,7],"black":["*","*"],"white":[95,97],"asian":[96,"*"],"latinx":[92,95],"other":[96,"*"],"totals":[94,96]},"sonoma":{"ranks":[13,7],"black":["*","*"],"white":[95,97],"asian":[95,"*"],"latinx":[90,94],"other":["*","*"],"totals":[93,96]},"stanislaus":{"ranks":[13,7],"black":["*","*"],"white":[95,97],"asian":["*","*"],"latinx":[92,95],"other":[91,"*"],"totals":[93,96]},"sutter":{"ranks":[19,28],"black":["*","*"],"white":[95,95],"asian":[89,"*"],"latinx":["*",93],"other":[92,"*"],"totals":[92,94]},"tehama":{"ranks":[36,17],"black":["*","*"],"white":["*",96],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[89,95]},"trinity":{"ranks":[44,""],"black":["*","*"],"white":["*","*"],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[86,"*"]},"tulare":{"ranks":[42,17],"black":["*","*"],"white":[90,95],"asian":[87,"*"],"latinx":[86,95],"other":[92,"*"],"totals":[88,95]},"tuolumne":{"ranks":["",""],"black":["*","*"],"white":["*",95],"asian":["*","*"],"latinx":["*","*"],"other":[95,"*"],"totals":["*","*"]},"ventura":{"ranks":[21,17],"black":["*","*"],"white":[96,97],"asian":["*","*"],"latinx":[87,93],"other":[93,"*"],"totals":[91,95]},"yolo":{"ranks":[6,7],"black":["*","*"],"white":[98,95],"asian":[97,"*"],"latinx":[93,96],"other":[90,"*"],"totals":[95,96]},"yuba":{"ranks":[19,7],"black":["*","*"],"white":["*",96],"asian":["*","*"],"latinx":["*",96],"other":[95,"*"],"totals":[92,96]}}}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = {"indicator":"notAbsent","semantics":{"who":"students","what":"were not chronically absent from school","label":"Students who were not chronically absent from school","shorthand":"Chronic absence from school"},"keywords":["chronically","absence","attendance","truancy"],"years":["2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":[""],"black":[81],"white":[90],"asian":[92],"latinx":[88],"other":[85],"totals":[89]},"alameda":{"ranks":[12],"black":[78],"white":[93],"asian":[91],"latinx":[87],"other":[85],"totals":[90]},"alpine":{"ranks":[4],"black":["*"],"white":[95],"asian":["*"],"latinx":["*"],"other":[86],"totals":[91]},"amador":{"ranks":[41],"black":[68],"white":[85],"asian":[91],"latinx":[87],"other":[79],"totals":[85]},"butte":{"ranks":[39],"black":[79],"white":[86],"asian":[90],"latinx":[86],"other":[82],"totals":[86]},"calaveras":{"ranks":[32],"black":[89],"white":[87],"asian":[88],"latinx":[87],"other":[81],"totals":[87]},"colusa":{"ranks":[4],"black":[72],"white":[91],"asian":[91],"latinx":[92],"other":[75],"totals":[91]},"contraCosta":{"ranks":[20],"black":[79],"white":[92],"asian":[90],"latinx":[87],"other":[86],"totals":[89]},"delNorte":{"ranks":[52],"black":[84],"white":[79],"asian":[89],"latinx":[83],"other":[72],"totals":[79]},"elDorado":{"ranks":[12],"black":[89],"white":[90],"asian":[91],"latinx":[88],"other":[83],"totals":[90]},"fresno":{"ranks":[32],"black":[78],"white":[89],"asian":[93],"latinx":[87],"other":[82],"totals":[87]},"glenn":{"ranks":[32],"black":[75],"white":[87],"asian":[93],"latinx":[88],"other":[70],"totals":[87]},"humboldt":{"ranks":[41],"black":[83],"white":[86],"asian":[92],"latinx":[84],"other":[76],"totals":[85]},"imperial":{"ranks":[12],"black":[89],"white":[91],"asian":[100],"latinx":[90],"other":[83],"totals":[90]},"inyo":{"ranks":[58],"black":[30],"white":[83],"asian":[70],"latinx":[42],"other":[73],"totals":[52]},"kern":{"ranks":[25],"black":[79],"white":[87],"asian":[91],"latinx":[89],"other":[83],"totals":[88]},"kings":{"ranks":[12],"black":[89],"white":[92],"asian":[93],"latinx":[90],"other":[84],"totals":[90]},"lake":{"ranks":[50],"black":[75],"white":[80],"asian":[92],"latinx":[80],"other":[76],"totals":[80]},"lassen":{"ranks":[25],"black":[77],"white":[89],"asian":[95],"latinx":[87],"other":[83],"totals":[88]},"losAngeles":{"ranks":[20],"black":[81],"white":[92],"asian":[92],"latinx":[89],"other":[87],"totals":[89]},"madera":{"ranks":[32],"black":[81],"white":[87],"asian":[93],"latinx":[88],"other":[79],"totals":[87]},"marin":{"ranks":[4],"black":[79],"white":[93],"asian":[91],"latinx":[89],"other":[89],"totals":[91]},"mariposa":{"ranks":[49],"black":[94],"white":[81],"asian":[81],"latinx":[78],"other":[81],"totals":[81]},"mendocino":{"ranks":[50],"black":[74],"white":[80],"asian":[85],"latinx":[83],"other":[69],"totals":[80]},"merced":{"ranks":[32],"black":[79],"white":[87],"asian":[89],"latinx":[87],"other":[84],"totals":[87]},"modoc":{"ranks":[52],"black":[69],"white":[82],"asian":[86],"latinx":[81],"other":[60],"totals":[79]},"mono":{"ranks":[56],"black":[67],"white":[83],"asian":[84],"latinx":[72],"other":[88],"totals":[76]},"monterey":{"ranks":[25],"black":[83],"white":[88],"asian":[89],"latinx":[88],"other":[87],"totals":[88]},"napa":{"ranks":[12],"black":[87],"white":[90],"asian":[92],"latinx":[90],"other":[86],"totals":[90]},"nevada":{"ranks":[57],"black":[55],"white":[79],"asian":[74],"latinx":[55],"other":[71],"totals":[71]},"orange":{"ranks":[2],"black":[86],"white":[92],"asian":[94],"latinx":[91],"other":[89],"totals":[92]},"placer":{"ranks":[1],"black":[92],"white":[93],"asian":[96],"latinx":[91],"other":[89],"totals":[93]},"plumas":{"ranks":[54],"black":[68],"white":[79],"asian":[87],"latinx":[81],"other":[71],"totals":[78]},"riverside":{"ranks":[25],"black":[84],"white":[89],"asian":[92],"latinx":[88],"other":[85],"totals":[88]},"sacramento":{"ranks":[32],"black":[78],"white":[88],"asian":[90],"latinx":[85],"other":[72],"totals":[87]},"sanBenito":{"ranks":[20],"black":[90],"white":[89],"asian":[94],"latinx":[89],"other":[85],"totals":[89]},"sanBernardino":{"ranks":[25],"black":[81],"white":[88],"asian":[92],"latinx":[88],"other":[84],"totals":[88]},"sanDiego":{"ranks":[12],"black":[87],"white":[92],"asian":[92],"latinx":[88],"other":[86],"totals":[90]},"sanFrancisco":{"ranks":[2],"black":[83],"white":[94],"asian":[95],"latinx":[87],"other":[88],"totals":[92]},"sanJoaquin":{"ranks":[39],"black":[77],"white":[87],"asian":[90],"latinx":[86],"other":[81],"totals":[86]},"sanLuisObispo":{"ranks":[20],"black":[89],"white":[90],"asian":[95],"latinx":[88],"other":[86],"totals":[89]},"sanMateo":{"ranks":[4],"black":[82],"white":[93],"asian":[90],"latinx":[86],"other":[87],"totals":[91]},"santaBarbara":{"ranks":[4],"black":[87],"white":[92],"asian":[96],"latinx":[91],"other":[87],"totals":[91]},"santaClara":{"ranks":[4],"black":[88],"white":[93],"asian":[93],"latinx":[86],"other":[90],"totals":[91]},"santaCruz":{"ranks":[48],"black":[83],"white":[86],"asian":[87],"latinx":[77],"other":[86],"totals":[82]},"shasta":{"ranks":[25],"black":[84],"white":[88],"asian":[89],"latinx":[86],"other":[85],"totals":[88]},"sierra":{"ranks":[4],"black":["*"],"white":[92],"asian":["*"],"latinx":[89],"other":["*"],"totals":[91]},"siskiyou":{"ranks":[46],"black":[77],"white":[84],"asian":[87],"latinx":[83],"other":[77],"totals":[83]},"solano":{"ranks":[41],"black":[77],"white":[89],"asian":[87],"latinx":[84],"other":[82],"totals":[85]},"sonoma":{"ranks":[46],"black":[79],"white":[85],"asian":[84],"latinx":[82],"other":[75],"totals":[83]},"stanislaus":{"ranks":[25],"black":[80],"white":[89],"asian":[93],"latinx":[88],"other":[85],"totals":[88]},"sutter":{"ranks":[41],"black":[78],"white":[85],"asian":[88],"latinx":[84],"other":[83],"totals":[85]},"tehama":{"ranks":[32],"black":[81],"white":[87],"asian":[87],"latinx":[88],"other":[79],"totals":[87]},"trinity":{"ranks":[55],"black":[83],"white":[78],"asian":[98],"latinx":[70],"other":[70],"totals":[77]},"tulare":{"ranks":[12],"black":[86],"white":[89],"asian":[93],"latinx":[90],"other":[87],"totals":[90]},"tuolumne":{"ranks":[41],"black":[73],"white":[85],"asian":[93],"latinx":[82],"other":[83],"totals":[85]},"ventura":{"ranks":[4],"black":[89],"white":[92],"asian":[93],"latinx":[90],"other":[88],"totals":[91]},"yolo":{"ranks":[20],"black":[83],"white":[90],"asian":[93],"latinx":[86],"other":[86],"totals":[89]},"yuba":{"ranks":[12],"black":[86],"white":[89],"asian":[94],"latinx":[90],"other":[85],"totals":[90]}}}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = {"indicator":"notLowBirthWeight","semantics":{"who":"newborns","what":"were not low birthweight","label":"Newborns who were not low birthweight","shorthand":"Not low birthweight"},"keywords":["birthweight","weight","birth","baby","babies","newborns","low","infants"],"years":["2015","2016"],"categories":["hasRace","earlyChildhood","health"],"counties":{"california":{"ranks":["",""],"black":[88,89],"white":[94,94],"asian":[92,92],"latinx":[94,94],"other":[92,91],"totals":[93,93]},"alameda":{"ranks":[42,41],"black":[89,89],"white":[94,94],"asian":[92,93],"latinx":[94,94],"other":[92,93],"totals":[93,93]},"alpine":{"ranks":["",""],"black":["",""],"white":["","*"],"asian":["",""],"latinx":["",""],"other":["*","*"],"totals":["*","*"]},"amador":{"ranks":[30,53],"black":["*",""],"white":[94,92],"asian":["*","*"],"latinx":[84,87],"other":[85,93],"totals":[93,92]},"butte":{"ranks":[21,9],"black":[71,78],"white":[94,95],"asian":[96,87],"latinx":[93,94],"other":[95,93],"totals":[94,95]},"calaveras":{"ranks":[2,17],"black":["","*"],"white":[97,94],"asian":["*","*"],"latinx":[86,81],"other":[87,76],"totals":[96,94]},"colusa":{"ranks":[47,35],"black":["*","*"],"white":[95,82],"asian":["*","*"],"latinx":[92,94],"other":["*","*"],"totals":[93,93]},"contraCosta":{"ranks":[37,32],"black":[89,89],"white":[94,95],"asian":[91,91],"latinx":[95,94],"other":[90,92],"totals":[93,93]},"delNorte":{"ranks":[31,28],"black":["",""],"white":[93,93],"asian":[84,80],"latinx":[84,90],"other":[88,87],"totals":[93,93]},"elDorado":{"ranks":[41,26],"black":[100,"*"],"white":[94,93],"asian":[87,79],"latinx":[92,95],"other":[80,86],"totals":[93,93]},"fresno":{"ranks":[51,41],"black":[84,87],"white":[94,94],"asian":[91,92],"latinx":[93,93],"other":[94,92],"totals":[92,93]},"glenn":{"ranks":[5,2],"black":["*","*"],"white":[95,94],"asian":[91,"*"],"latinx":[95,97],"other":["*",83],"totals":[95,96]},"humboldt":{"ranks":[4,28],"black":[100,88],"white":[94,93],"asian":[90,92],"latinx":[97,92],"other":[96,95],"totals":[95,93]},"imperial":{"ranks":[6,15],"black":[93,92],"white":[94,93],"asian":[92,93],"latinx":[95,95],"other":[71,62],"totals":[95,94]},"inyo":{"ranks":[12,4],"black":["","*"],"white":[89,90],"asian":["*","*"],"latinx":[93,90],"other":[81,82],"totals":[94,95]},"kern":{"ranks":[44,51],"black":[86,84],"white":[93,93],"asian":[88,92],"latinx":[94,93],"other":[90,91],"totals":[93,93]},"kings":{"ranks":[24,24],"black":[87,80],"white":[94,95],"asian":[89,80],"latinx":[93,93],"other":[93,93],"totals":[94,93]},"lake":{"ranks":[10,12],"black":[91,91],"white":[94,92],"asian":[100,"*"],"latinx":[94,96],"other":[81,87],"totals":[94,94]},"lassen":{"ranks":[48,55],"black":["*","*"],"white":[93,94],"asian":["*",86],"latinx":[89,79],"other":[74,77],"totals":[93,92]},"losAngeles":{"ranks":[44,45],"black":[88,88],"white":[93,94],"asian":[93,93],"latinx":[93,93],"other":[90,91],"totals":[93,93]},"madera":{"ranks":[12,35],"black":[79,79],"white":[95,93],"asian":[95,90],"latinx":[94,93],"other":[85,85],"totals":[94,93]},"marin":{"ranks":[10,14],"black":[88,75],"white":[95,94],"asian":[85,94],"latinx":[94,96],"other":[89,95],"totals":[94,94]},"mariposa":{"ranks":[52,3],"black":["",""],"white":[93,94],"asian":["*",""],"latinx":[79,86],"other":["*","*"],"totals":[92,95]},"mendocino":{"ranks":[16,48],"black":["*","*"],"white":[94,91],"asian":[80,91],"latinx":[94,96],"other":[95,85],"totals":[94,93]},"merced":{"ranks":[15,15],"black":[85,81],"white":[95,95],"asian":[96,92],"latinx":[94,95],"other":[75,77],"totals":[94,94]},"modoc":{"ranks":[55,45],"black":["",""],"white":[88,93],"asian":["*","*"],"latinx":["*",94],"other":["*","*"],"totals":[86,93]},"mono":{"ranks":[54,33],"black":["","*"],"white":[89,94],"asian":["*","*"],"latinx":[92,91],"other":["*","*"],"totals":[90,93]},"monterey":{"ranks":[24,12],"black":[91,87],"white":[94,95],"asian":[92,95],"latinx":[94,94],"other":[90,86],"totals":[94,94]},"napa":{"ranks":[3,11],"black":[92,"*"],"white":[96,95],"asian":[88,82],"latinx":[96,94],"other":[90,81],"totals":[95,94]},"nevada":{"ranks":[32,6],"black":["*","*"],"white":[94,95],"asian":[92,86],"latinx":[95,94],"other":[82,77],"totals":[93,95]},"orange":{"ranks":[21,18],"black":[89,90],"white":[95,95],"asian":[93,93],"latinx":[94,94],"other":[93,93],"totals":[94,94]},"placer":{"ranks":[12,7],"black":[79,89],"white":[95,95],"asian":[94,93],"latinx":[91,94],"other":[94,93],"totals":[94,95]},"plumas":{"ranks":[56,56],"black":["","*"],"white":[79,84],"asian":["*","*"],"latinx":[94,96],"other":["*",79],"totals":[82,91]},"riverside":{"ranks":[24,35],"black":[90,89],"white":[94,94],"asian":[93,91],"latinx":[94,94],"other":[92,89],"totals":[94,93]},"sacramento":{"ranks":[32,28],"black":[88,90],"white":[95,95],"asian":[92,92],"latinx":[94,94],"other":[92,92],"totals":[93,93]},"sanBenito":{"ranks":[48,22],"black":["*","*"],"white":[95,93],"asian":[85,"*"],"latinx":[92,95],"other":[78,86],"totals":[93,94]},"sanBernardino":{"ranks":[44,49],"black":[88,88],"white":[94,94],"asian":[93,93],"latinx":[93,93],"other":[90,89],"totals":[93,93]},"sanDiego":{"ranks":[24,26],"black":[89,90],"white":[95,94],"asian":[92,92],"latinx":[94,94],"other":[92,91],"totals":[94,93]},"sanFrancisco":{"ranks":[37,44],"black":[88,88],"white":[94,94],"asian":[92,92],"latinx":[94,92],"other":[91,94],"totals":[93,93]},"sanJoaquin":{"ranks":[42,52],"black":[85,85],"white":[93,94],"asian":[92,91],"latinx":[94,94],"other":[94,91],"totals":[93,92]},"sanLuisObispo":{"ranks":[19,21],"black":[88,75],"white":[94,94],"asian":[80,90],"latinx":[94,94],"other":[86,89],"totals":[94,94]},"sanMateo":{"ranks":[48,22],"black":[84,87],"white":[94,95],"asian":[91,93],"latinx":[93,93],"other":[90,93],"totals":[93,94]},"santaBarbara":{"ranks":[19,35],"black":[86,70],"white":[94,94],"asian":[94,92],"latinx":[94,93],"other":[85,90],"totals":[94,93]},"santaClara":{"ranks":[40,41],"black":[90,92],"white":[94,94],"asian":[92,92],"latinx":[94,93],"other":[92,92],"totals":[93,93]},"santaCruz":{"ranks":[35,5],"black":[79,87],"white":[94,96],"asian":[93,85],"latinx":[93,95],"other":[86,96],"totals":[93,95]},"shasta":{"ranks":[8,45],"black":[94,96],"white":[96,93],"asian":[88,82],"latinx":[92,92],"other":[83,91],"totals":[94,93]},"sierra":{"ranks":[57,57],"black":["",""],"white":[74,87],"asian":["",""],"latinx":["*","*"],"other":["*","*"],"totals":[81,88]},"siskiyou":{"ranks":[53,50],"black":["*","*"],"white":[92,94],"asian":["*",83],"latinx":[80,84],"other":[86,87],"totals":[91,93]},"solano":{"ranks":[18,25],"black":[90,91],"white":[95,95],"asian":[95,92],"latinx":[94,94],"other":[93,93],"totals":[94,93]},"sonoma":{"ranks":[8,19],"black":[82,83],"white":[95,95],"asian":[90,91],"latinx":[94,94],"other":[95,93],"totals":[94,94]},"stanislaus":{"ranks":[23,35],"black":[89,94],"white":[94,94],"asian":[89,91],"latinx":[95,93],"other":[92,91],"totals":[94,93]},"sutter":{"ranks":[24,33],"black":[96,79],"white":[93,94],"asian":[92,90],"latinx":[94,94],"other":[82,86],"totals":[94,93]},"tehama":{"ranks":[24,7],"black":["*","*"],"white":[93,95],"asian":[93,77],"latinx":[94,94],"other":[81,94],"totals":[94,95]},"trinity":{"ranks":[1,1],"black":["",""],"white":[88,100],"asian":["*","*"],"latinx":["*","*"],"other":["*","*"],"totals":[97,98]},"tulare":{"ranks":[36,28],"black":[74,80],"white":[95,93],"asian":[88,89],"latinx":[93,93],"other":[88,91],"totals":[93,93]},"tuolumne":{"ranks":[37,53],"black":["*","*"],"white":[94,92],"asian":["*","*"],"latinx":[89,85],"other":[73,85],"totals":[93,92]},"ventura":{"ranks":[17,9],"black":[82,90],"white":[94,95],"asian":[92,91],"latinx":[94,95],"other":[94,91],"totals":[94,95]},"yolo":{"ranks":[7,20],"black":[91,83],"white":[95,94],"asian":[95,90],"latinx":[94,95],"other":[92,93],"totals":[95,94]},"yuba":{"ranks":[32,35],"black":[86,79],"white":[94,94],"asian":[81,86],"latinx":[93,95],"other":[86,77],"totals":[93,93]}}}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {"indicator":"notObese","semantics":{"who":"7th-graders","what":"were not overweight or obese","label":"7th-graders who were not overweight or obese","shorthand":"7th grade overweight / obesity"},"keywords":["obese","obesity","7th","grade","overweight","weight"],"years":["2016","2017"],"categories":["hasRace","health"],"counties":{"california":{"ranks":["",""],"black":[60,59],"white":[72,72],"asian":[65,64],"latinx":[54,53],"other":[61,63],"totals":[62,61]},"alameda":{"ranks":[12,18],"black":[56,55],"white":[76,75],"asian":[64,60],"latinx":[53,54],"other":[61,68],"totals":[66,66]},"alpine":{"ranks":["",""],"black":[0,0],"white":["*",0],"asian":[0,0],"latinx":[0,0],"other":["",0],"totals":["*","*"]},"amador":{"ranks":[18,12],"black":["*","*"],"white":[69,70],"asian":[0,""],"latinx":[52,62],"other":["",79],"totals":[64,69]},"butte":{"ranks":[21,30],"black":[62,53],"white":[70,65],"asian":[78,62],"latinx":[54,51],"other":[49,64],"totals":[64,62]},"calaveras":{"ranks":[29,27],"black":["*","*"],"white":[66,67],"asian":[0,""],"latinx":[52,49],"other":["",60],"totals":[62,62]},"colusa":{"ranks":[48,54],"black":["*",0],"white":[70,62],"asian":[0,0],"latinx":[52,50],"other":[0,""],"totals":[55,52]},"contraCosta":{"ranks":[14,20],"black":[55,55],"white":[75,76],"asian":[66,62],"latinx":[53,52],"other":[66,60],"totals":[66,65]},"delNorte":{"ranks":[55,57],"black":["*","*"],"white":[54,56],"asian":[18,28],"latinx":[55,34],"other":[55,44],"totals":[53,47]},"elDorado":{"ranks":[2,4],"black":[56,58],"white":[79,77],"asian":[83,79],"latinx":[65,66],"other":[71,64],"totals":[75,74]},"fresno":{"ranks":[43,48],"black":[59,57],"white":[66,66],"asian":[67,62],"latinx":[53,51],"other":[62,55],"totals":[57,56]},"glenn":{"ranks":[52,47],"black":[0,"*"],"white":[58,61],"asian":[55,33],"latinx":[54,54],"other":[32,53],"totals":[54,56]},"humboldt":{"ranks":[41,45],"black":[63,50],"white":[61,59],"asian":[62,39],"latinx":[52,52],"other":[52,55],"totals":[58,56]},"imperial":{"ranks":[53,52],"black":[44,44],"white":[59,63],"asian":[55,34],"latinx":[54,53],"other":[42,48],"totals":[54,53]},"inyo":{"ranks":[37,37],"black":["*","*"],"white":[67,72],"asian":[0,0],"latinx":[70,54],"other":[48,50],"totals":[60,59]},"kern":{"ranks":[49,51],"black":[54,58],"white":[63,65],"asian":[62,64],"latinx":[51,50],"other":[64,60],"totals":[55,54]},"kings":{"ranks":[47,56],"black":[64,56],"white":[57,63],"asian":[69,54],"latinx":[53,51],"other":[56,37],"totals":[55,52]},"lake":{"ranks":[33,26],"black":[46,50],"white":[65,61],"asian":["",""],"latinx":[60,56],"other":[47,68],"totals":[61,63]},"lassen":{"ranks":[22,24],"black":["*","*"],"white":[67,65],"asian":["",""],"latinx":[59,67],"other":[36,53],"totals":[63,63]},"losAngeles":{"ranks":[40,40],"black":[61,60],"white":[70,72],"asian":[63,64],"latinx":[53,52],"other":[59,66],"totals":[59,58]},"madera":{"ranks":[38,16],"black":[51,63],"white":[66,70],"asian":[52,34],"latinx":[55,65],"other":[62,74],"totals":[59,67]},"marin":{"ranks":[1,1],"black":[64,68],"white":[83,83],"asian":[76,73],"latinx":[60,65],"other":[73,72],"totals":[77,77]},"mariposa":{"ranks":[31,3],"black":["*","*"],"white":[65,76],"asian":[0,0],"latinx":[54,42],"other":["",78],"totals":[62,74]},"mendocino":{"ranks":[50,44],"black":["*",57],"white":[63,68],"asian":[92,""],"latinx":[48,48],"other":[49,48],"totals":[55,57]},"merced":{"ranks":[44,50],"black":[65,55],"white":[61,60],"asian":[46,64],"latinx":[55,54],"other":[53,65],"totals":[57,55]},"modoc":{"ranks":[46,8],"black":[0,0],"white":[73,73],"asian":[0,0],"latinx":[50,67],"other":[0,""],"totals":[56,70]},"mono":{"ranks":[24,10],"black":[0,0],"white":[83,78],"asian":["",0],"latinx":[57,62],"other":["",""],"totals":[63,69]},"monterey":{"ranks":[54,55],"black":[62,56],"white":[65,72],"asian":[61,58],"latinx":[49,47],"other":[62,50],"totals":[53,52]},"napa":{"ranks":[57,49],"black":[17,53],"white":[61,67],"asian":[17,59],"latinx":[40,47],"other":[38,72],"totals":[43,55]},"nevada":{"ranks":[6,5],"black":["*","*"],"white":[74,74],"asian":["",""],"latinx":[59,72],"other":[68,70],"totals":[69,74]},"orange":{"ranks":[8,16],"black":[66,64],"white":[78,78],"asian":[66,65],"latinx":[55,55],"other":[76,67],"totals":[67,67]},"placer":{"ranks":[3,6],"black":[71,67],"white":[76,76],"asian":[74,70],"latinx":[67,65],"other":[64,72],"totals":[73,73]},"plumas":{"ranks":[8,2],"black":[0,"*"],"white":[69,81],"asian":[0,0],"latinx":[70,60],"other":["",55],"totals":[67,75]},"riverside":{"ranks":[34,33],"black":[63,63],"white":[71,70],"asian":[65,61],"latinx":[56,56],"other":[60,62],"totals":[61,61]},"sacramento":{"ranks":[17,23],"black":[60,58],"white":[70,70],"asian":[67,66],"latinx":[58,56],"other":[63,61],"totals":[65,64]},"sanBenito":{"ranks":[51,45],"black":["*","*"],"white":[64,67],"asian":[86,""],"latinx":[50,53],"other":[63,64],"totals":[55,56]},"sanBernardino":{"ranks":[35,42],"black":[64,63],"white":[69,68],"asian":[62,62],"latinx":[56,53],"other":[66,64],"totals":[60,58]},"sanDiego":{"ranks":[11,19],"black":[63,63],"white":[76,76],"asian":[67,66],"latinx":[58,56],"other":[64,66],"totals":[66,65]},"sanFrancisco":{"ranks":[7,15],"black":[55,50],"white":[80,82],"asian":[60,60],"latinx":[54,45],"other":[55,65],"totals":[68,67]},"sanJoaquin":{"ranks":[36,39],"black":[61,57],"white":[67,66],"asian":[64,65],"latinx":[54,53],"other":[57,54],"totals":[60,59]},"sanLuisObispo":{"ranks":[16,21],"black":[61,57],"white":[70,71],"asian":[67,66],"latinx":[58,55],"other":[74,61],"totals":[65,65]},"sanMateo":{"ranks":[4,13],"black":[56,55],"white":[79,80],"asian":[67,62],"latinx":[59,53],"other":[60,69],"totals":[71,68]},"santaBarbara":{"ranks":[26,31],"black":[57,65],"white":[76,76],"asian":[74,67],"latinx":[58,56],"other":[64,61],"totals":[63,61]},"santaClara":{"ranks":[5,10],"black":[65,62],"white":[78,78],"asian":[67,64],"latinx":[57,53],"other":[66,68],"totals":[70,69]},"santaCruz":{"ranks":[29,27],"black":[48,68],"white":[77,79],"asian":[89,80],"latinx":[50,49],"other":[78,60],"totals":[62,62]},"shasta":{"ranks":[12,9],"black":[57,53],"white":[68,71],"asian":[62,72],"latinx":[58,61],"other":[62,68],"totals":[66,69]},"sierra":{"ranks":[19,24],"black":[0,"*"],"white":[76,62],"asian":[0,0],"latinx":["*","*"],"other":[0,0],"totals":[64,63]},"siskiyou":{"ranks":[10,14],"black":["*","*"],"white":[66,72],"asian":[0,0],"latinx":[55,69],"other":[66,63],"totals":[66,67]},"solano":{"ranks":[39,40],"black":[58,54],"white":[66,67],"asian":[63,60],"latinx":[51,50],"other":[63,64],"totals":[59,58]},"sonoma":{"ranks":[28,29],"black":[58,67],"white":[71,70],"asian":[68,67],"latinx":[53,53],"other":[58,60],"totals":[63,62]},"stanislaus":{"ranks":[45,38],"black":[55,62],"white":[63,66],"asian":[62,59],"latinx":[53,55],"other":[53,55],"totals":[57,59]},"sutter":{"ranks":[24,43],"black":[65,70],"white":[66,64],"asian":[70,62],"latinx":[53,43],"other":[71,67],"totals":[63,57]},"tehama":{"ranks":[42,34],"black":["*",46],"white":[63,64],"asian":["",0],"latinx":[50,54],"other":[52,47],"totals":[58,60]},"trinity":{"ranks":[20,36],"black":["*","*"],"white":[56,67],"asian":[0,0],"latinx":["*","*"],"other":[70,46],"totals":[64,59]},"tulare":{"ranks":[56,53],"black":[50,48],"white":[57,63],"asian":[59,66],"latinx":[50,51],"other":[49,56],"totals":[51,53]},"tuolumne":{"ranks":[14,7],"black":["*","*"],"white":[69,74],"asian":["",""],"latinx":[55,49],"other":[46,91],"totals":[66,71]},"ventura":{"ranks":[22,32],"black":[66,65],"white":[76,74],"asian":[71,62],"latinx":[55,52],"other":[72,69],"totals":[63,61]},"yolo":{"ranks":[27,21],"black":[60,62],"white":[70,72],"asian":[61,80],"latinx":[55,55],"other":[59,60],"totals":[63,65]},"yuba":{"ranks":[32,35],"black":[58,56],"white":[65,69],"asian":[68,58],"latinx":[56,51],"other":[63,53],"totals":[61,60]}}}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = {"indicator":"permanency","semantics":{"who":"children","shortWho":"children","what":"in the child welfare system exited to permanency within one year","label":"Children in the child welfare system who exited to permanency within one year","shorthand":"Child welfare exits to permanency"},"keywords":["permanency","welfare","exited","year","children"],"years":["2015","2016"],"categories":["hasRace","welfare"],"counties":{"california":{"ranks":["",""],"black":[32,32],"white":[37,38],"asian":[49,47],"latinx":[38,37],"other":[26,25],"totals":[36,36]},"alameda":{"ranks":[48,44],"black":[31,26],"white":[38,31],"asian":[40,59],"latinx":[20,36],"other":[14,15],"totals":[29,32]},"alpine":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"amador":{"ranks":[9,11],"black":["",33],"white":[49,57],"asian":["",""],"latinx":[75,33],"other":["",100],"totals":[50,52]},"butte":{"ranks":[44,15],"black":[50,54],"white":[33,40],"asian":[38,33],"latinx":["",59],"other":["",74],"totals":[32,47]},"calaveras":{"ranks":[5,12],"black":["",100],"white":[45,47],"asian":["",""],"latinx":[80,60],"other":["",""],"totals":[54,50]},"colusa":{"ranks":[3,46],"black":["",""],"white":[50,50],"asian":["",""],"latinx":[65,9],"other":[38,75],"totals":[55,32]},"contraCosta":{"ranks":[47,43],"black":[26,26],"white":[32,39],"asian":[41,35],"latinx":[28,33],"other":[60,43],"totals":[29,33]},"delNorte":{"ranks":[9,41],"black":["",""],"white":[35,19],"asian":[67,""],"latinx":[43,33],"other":[68,71],"totals":[50,33]},"elDorado":{"ranks":[40,51],"black":[33,""],"white":[31,31],"asian":["",""],"latinx":[47,33],"other":[43,""],"totals":[34,28]},"fresno":{"ranks":[42,45],"black":[32,23],"white":[37,35],"asian":[47,24],"latinx":[31,33],"other":[30,50],"totals":[33,32]},"glenn":{"ranks":[46,32],"black":[100,""],"white":[10,44],"asian":["",""],"latinx":[36,25],"other":["",""],"totals":[31,39]},"humboldt":{"ranks":[52,38],"black":[33,56],"white":[25,37],"asian":["",50],"latinx":[28,25],"other":[12,33],"totals":[23,36]},"imperial":{"ranks":[4,29],"black":[29,29],"white":[50,68],"asian":["",""],"latinx":[57,38],"other":[100,17],"totals":[55,41]},"inyo":{"ranks":[55,22],"black":["",""],"white":[13,75],"asian":["",""],"latinx":["",""],"other":[50,""],"totals":[15,43]},"kern":{"ranks":[35,30],"black":[46,42],"white":[33,36],"asian":[67,50],"latinx":[39,43],"other":[33,33],"totals":[38,40]},"kings":{"ranks":[8,23],"black":[31,10],"white":[62,45],"asian":["",""],"latinx":[48,44],"other":[14,100],"totals":[50,43]},"lake":{"ranks":[56,57],"black":[33,""],"white":[14,10],"asian":[50,""],"latinx":["",""],"other":["",25],"totals":[15,8]},"lassen":{"ranks":[18,3],"black":["",""],"white":[59,70],"asian":["",""],"latinx":["",100],"other":["",""],"totals":[45,69]},"losAngeles":{"ranks":[39,39],"black":[30,32],"white":[34,34],"asian":[48,50],"latinx":[38,38],"other":[14,16],"totals":[35,35]},"madera":{"ranks":[7,9],"black":[22,50],"white":[41,59],"asian":["",""],"latinx":[61,50],"other":[40,100],"totals":[54,53]},"marin":{"ranks":[43,53],"black":["",100],"white":[33,33],"asian":[100,100],"latinx":[31,12],"other":["",""],"totals":[32,28]},"mariposa":{"ranks":[33,41],"black":["",""],"white":[22,42],"asian":["",""],"latinx":[100,""],"other":[50,""],"totals":[39,33]},"mendocino":{"ranks":[27,36],"black":[40,""],"white":[42,36],"asian":["",""],"latinx":[25,36],"other":[48,44],"totals":[40,37]},"merced":{"ranks":[24,40],"black":[42,12],"white":[53,31],"asian":[100,40],"latinx":[34,39],"other":[33,100],"totals":[40,34]},"modoc":{"ranks":[9,1],"black":["",""],"white":[50,100],"asian":["",""],"latinx":["",""],"other":[100,""],"totals":[50,100]},"mono":{"ranks":[54,12],"black":["",""],"white":[100,50],"asian":["",""],"latinx":["",""],"other":["",""],"totals":[17,50]},"monterey":{"ranks":[57,56],"black":[14,10],"white":[7,55],"asian":[100,100],"latinx":[11,9],"other":[100,""],"totals":[13,15]},"napa":{"ranks":[9,18],"black":["",100],"white":[50,43],"asian":["",""],"latinx":[48,46],"other":[67,""],"totals":[50,44]},"nevada":{"ranks":[28,5],"black":["",""],"white":[37,65],"asian":["",""],"latinx":[67,50],"other":["",""],"totals":[39,64]},"orange":{"ranks":[36,36],"black":[36,37],"white":[36,33],"asian":[32,44],"latinx":[38,37],"other":[43,67],"totals":[37,37]},"placer":{"ranks":[22,6],"black":[46,83],"white":[43,64],"asian":[100,67],"latinx":[47,44],"other":[20,""],"totals":[44,61]},"plumas":{"ranks":[1,4],"black":["",""],"white":[62,75],"asian":["",""],"latinx":[50,80],"other":[86,43],"totals":[65,68]},"riverside":{"ranks":[26,34],"black":[34,33],"white":[43,42],"asian":[48,11],"latinx":[40,36],"other":[31,33],"totals":[40,37]},"sacramento":{"ranks":[16,20],"black":[43,45],"white":[44,46],"asian":[61,66],"latinx":[45,36],"other":[49,38],"totals":[45,44]},"sanBenito":{"ranks":[25,21],"black":["",""],"white":[50,33],"asian":["",""],"latinx":[41,64],"other":["",""],"totals":[40,44]},"sanBernardino":{"ranks":[45,48],"black":[29,31],"white":[34,28],"asian":[47,60],"latinx":[31,30],"other":[20,""],"totals":[31,30]},"sanDiego":{"ranks":[28,31],"black":[41,34],"white":[35,37],"asian":[64,39],"latinx":[40,41],"other":[42,42],"totals":[39,39]},"sanFrancisco":{"ranks":[37,35],"black":[33,42],"white":[41,25],"asian":[38,55],"latinx":[36,26],"other":[50,67],"totals":[36,37]},"sanJoaquin":{"ranks":[53,55],"black":[18,12],"white":[17,17],"asian":[13,32],"latinx":[19,25],"other":["",29],"totals":[18,20]},"sanLuisObispo":{"ranks":[49,28],"black":[50,67],"white":[25,40],"asian":["",67],"latinx":[33,43],"other":["",18],"totals":[29,41]},"sanMateo":{"ranks":[2,7],"black":[40,50],"white":[65,50],"asian":[53,70],"latinx":[58,61],"other":[100,100],"totals":[57,59]},"santaBarbara":{"ranks":[30,23],"black":[71,80],"white":[34,39],"asian":["",""],"latinx":[39,43],"other":[100,50],"totals":[39,43]},"santaClara":{"ranks":[16,14],"black":[35,28],"white":[48,67],"asian":[71,44],"latinx":[42,45],"other":[75,60],"totals":[45,49]},"santaCruz":{"ranks":[34,16],"black":[14,100],"white":[55,58],"asian":[50,""],"latinx":[31,38],"other":[100,100],"totals":[38,46]},"shasta":{"ranks":[51,52],"black":["",20],"white":[29,31],"asian":["",""],"latinx":[30,28],"other":[11,""],"totals":[27,28]},"sierra":{"ranks":[9,1],"black":["",""],"white":[50,100],"asian":["",""],"latinx":["",100],"other":["",""],"totals":[50,100]},"siskiyou":{"ranks":[20,8],"black":["",100],"white":[45,49],"asian":["",100],"latinx":[67,100],"other":[38,40],"totals":[44,54]},"solano":{"ranks":[50,49],"black":[22,24],"white":[21,44],"asian":[33,17],"latinx":[47,28],"other":[25,""],"totals":[28,30]},"sonoma":{"ranks":[32,26],"black":[67,32],"white":[40,40],"asian":[100,67],"latinx":[32,46],"other":[63,43],"totals":[39,42]},"stanislaus":{"ranks":[23,27],"black":[50,46],"white":[35,44],"asian":[60,29],"latinx":[43,38],"other":[50,50],"totals":[41,41]},"sutter":{"ranks":[19,47],"black":[67,50],"white":[52,35],"asian":["",""],"latinx":[33,25],"other":[50,""],"totals":[45,32]},"tehama":{"ranks":[14,10],"black":[100,100],"white":[49,40],"asian":["",100],"latinx":[38,71],"other":[64,55],"totals":[49,53]},"trinity":{"ranks":[5,17],"black":["",""],"white":[52,47],"asian":["",""],"latinx":[100,""],"other":[50,""],"totals":[54,45]},"tulare":{"ranks":[20,19],"black":[39,10],"white":[43,44],"asian":[100,""],"latinx":[44,46],"other":["",40],"totals":[44,44]},"tuolumne":{"ranks":[41,50],"black":["",""],"white":[34,25],"asian":["",""],"latinx":[43,50],"other":["",100],"totals":[34,30]},"ventura":{"ranks":[31,25],"black":[50,33],"white":[32,51],"asian":[60,""],"latinx":[40,39],"other":[50,67],"totals":[39,42]},"yolo":{"ranks":[38,54],"black":[29,""],"white":[34,30],"asian":["",67],"latinx":[39,27],"other":[33,""],"totals":[36,27]},"yuba":{"ranks":[15,32],"black":[63,13],"white":[48,40],"asian":["",80],"latinx":[36,42],"other":["",14],"totals":[46,39]}}}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = {"indicator":"placementStability","semantics":{"who":"children","shortWho":"children","what":"in the child welfare system were in stable (2+ years) placements","label":"Children in the child welfare system who had been in one placement after 24 months in care","shorthand":"Child welfare placement stability"},"keywords":["placement","welfare","care","child","welfare","out-of-home","home","foster","neglect","orphan"],"years":["2014","2015"],"categories":["hasRace","welfare"],"counties":{"california":{"ranks":["",""],"black":[20,26],"white":[21,24],"asian":[22,24],"latinx":[25,28],"other":[20,32],"totals":[23,27]},"alameda":{"ranks":[14,13],"black":[20,25],"white":[11,27],"asian":[17,67],"latinx":[31,27],"other":[100,75],"totals":[21,27]},"alpine":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"amador":{"ranks":["",3],"black":["",""],"white":["",25],"asian":["",""],"latinx":["",100],"other":["",""],"totals":["",63]},"butte":{"ranks":[42,25],"black":["",""],"white":[5,13],"asian":["",75],"latinx":[13,22],"other":["",100],"totals":[5,19]},"calaveras":{"ranks":[1,1],"black":["",""],"white":[33,75],"asian":["",""],"latinx":[80,""],"other":["",""],"totals":[63,75]},"colusa":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"contraCosta":{"ranks":[31,33],"black":[11,17],"white":[10,11],"asian":["",33],"latinx":[15,15],"other":["",100],"totals":[13,15]},"delNorte":{"ranks":[7,6],"black":["",""],"white":[50,100],"asian":["",""],"latinx":["",""],"other":["",""],"totals":[29,40]},"elDorado":{"ranks":[32,21],"black":["",58],"white":[16,16],"asian":["",""],"latinx":[14,""],"other":["",""],"totals":[12,22]},"fresno":{"ranks":[19,45],"black":[12,8],"white":[16,""],"asian":["",33],"latinx":[20,10],"other":[100,""],"totals":[20,8]},"glenn":{"ranks":[27,35],"black":["",""],"white":[17,""],"asian":["",""],"latinx":["",50],"other":["",""],"totals":[14,14]},"humboldt":{"ranks":[16,10],"black":[100,""],"white":[38,33],"asian":["",""],"latinx":["",33],"other":[20,29],"totals":[21,31]},"imperial":{"ranks":[41,47],"black":["",""],"white":["",""],"asian":["",""],"latinx":[7,8],"other":["",""],"totals":[5,6]},"inyo":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"kern":{"ranks":[28,39],"black":[31,19],"white":[15,6],"asian":[67,""],"latinx":[10,17],"other":["",""],"totals":[14,13]},"kings":{"ranks":[23,29],"black":["",38],"white":[30,10],"asian":["",""],"latinx":[8,11],"other":["",""],"totals":[17,16]},"lake":{"ranks":[36,31],"black":["",""],"white":[14,17],"asian":["",""],"latinx":[100,""],"other":["",""],"totals":[10,16]},"lassen":{"ranks":["",5],"black":["",""],"white":["",100],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",50]},"losAngeles":{"ranks":[5,7],"black":[26,36],"white":[38,46],"asian":[30,27],"latinx":[33,39],"other":[24,39],"totals":[31,39]},"madera":{"ranks":[9,41],"black":["",100],"white":[25,14],"asian":["",""],"latinx":[32,23],"other":["",""],"totals":[26,12]},"marin":{"ranks":[6,4],"black":["",""],"white":[100,100],"asian":["",""],"latinx":[50,50],"other":[100,""],"totals":[29,60]},"mariposa":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"mendocino":{"ranks":[39,40],"black":["",""],"white":[13,14],"asian":["",""],"latinx":["",""],"other":["",""],"totals":[6,13]},"merced":{"ranks":[34,43],"black":[50,25],"white":["",""],"asian":["",""],"latinx":[14,12],"other":["",""],"totals":[11,11]},"modoc":{"ranks":["",1],"black":["",""],"white":["",100],"asian":["",""],"latinx":["",50],"other":["",""],"totals":["",75]},"mono":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"monterey":{"ranks":[37,19],"black":["",50],"white":["",33],"asian":["",""],"latinx":[9,19],"other":["",""],"totals":[8,23]},"napa":{"ranks":["",8],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",40],"other":["",""],"totals":["",33]},"nevada":{"ranks":["",8],"black":["",""],"white":["",33],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",33]},"orange":{"ranks":[11,14],"black":[24,17],"white":[25,18],"asian":[43,57],"latinx":[21,30],"other":["",""],"totals":[23,26]},"placer":{"ranks":[38,26],"black":["",75],"white":[12,30],"asian":["",""],"latinx":["",33],"other":["",""],"totals":[8,19]},"plumas":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"riverside":{"ranks":[17,24],"black":[19,13],"white":[22,19],"asian":[18,""],"latinx":[19,24],"other":[50,""],"totals":[20,20]},"sacramento":{"ranks":[25,37],"black":[11,10],"white":[18,14],"asian":[50,33],"latinx":[18,17],"other":[50,""],"totals":[16,14]},"sanBenito":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"sanBernardino":{"ranks":[15,15],"black":[22,22],"white":[19,29],"asian":[57,""],"latinx":[22,26],"other":[50,50],"totals":[21,26]},"sanDiego":{"ranks":[20,20],"black":[12,21],"white":[22,29],"asian":[20,20],"latinx":[21,21],"other":["",""],"totals":[19,23]},"sanFrancisco":{"ranks":[21,16],"black":[18,22],"white":[29,52],"asian":["",60],"latinx":[18,15],"other":["",""],"totals":[18,25]},"sanJoaquin":{"ranks":[18,17],"black":[26,19],"white":[16,24],"asian":[17,""],"latinx":[18,30],"other":[17,""],"totals":[20,25]},"sanLuisObispo":{"ranks":[12,12],"black":["",""],"white":[30,31],"asian":[100,100],"latinx":[9,48],"other":["",""],"totals":[22,27]},"sanMateo":{"ranks":[33,28],"black":["",""],"white":["",""],"asian":["",""],"latinx":[19,29],"other":["",""],"totals":[11,17]},"santaBarbara":{"ranks":[22,46],"black":[25,""],"white":[19,""],"asian":["",""],"latinx":[17,16],"other":["",""],"totals":[17,8]},"santaClara":{"ranks":[10,27],"black":[18,11],"white":[30,29],"asian":[20,""],"latinx":[24,19],"other":["",""],"totals":[24,19]},"santaCruz":{"ranks":[24,22],"black":["",100],"white":[17,33],"asian":["",""],"latinx":[22,43],"other":["",""],"totals":[16,22]},"shasta":{"ranks":[40,48],"black":["",""],"white":[7,4],"asian":["",""],"latinx":["",16],"other":["",""],"totals":[6,6]},"sierra":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"siskiyou":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"solano":{"ranks":[13,30],"black":[17,18],"white":[27,11],"asian":["",80],"latinx":[26,50],"other":["",""],"totals":[22,16]},"sonoma":{"ranks":[30,34],"black":["",""],"white":[8,33],"asian":["",""],"latinx":[20,21],"other":["",""],"totals":[13,15]},"stanislaus":{"ranks":[35,32],"black":["",75],"white":[25,16],"asian":["",""],"latinx":[9,20],"other":["",""],"totals":[10,16]},"sutter":{"ranks":[2,23],"black":["",""],"white":["",""],"asian":["",""],"latinx":[50,25],"other":["",""],"totals":[40,20]},"tehama":{"ranks":[29,11],"black":["",""],"white":["",33],"asian":["",""],"latinx":[25,50],"other":["",""],"totals":[13,27]},"trinity":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",""]},"tulare":{"ranks":[26,36],"black":[50,40],"white":[24,22],"asian":["",""],"latinx":[13,10],"other":["",100],"totals":[15,14]},"tuolumne":{"ranks":["",44],"black":["",100],"white":["",""],"asian":["",""],"latinx":["",""],"other":["",""],"totals":["",9]},"ventura":{"ranks":[8,18],"black":["",""],"white":[7,20],"asian":[50,100],"latinx":[37,23],"other":["",100],"totals":[27,24]},"yolo":{"ranks":[4,42],"black":["",25],"white":[46,17],"asian":["",""],"latinx":[35,22],"other":["",""],"totals":[37,11]},"yuba":{"ranks":[3,38],"black":["",""],"white":[73,14],"asian":["",""],"latinx":[100,""],"other":["",""],"totals":[38,13]}}}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = {"indicator":"readingStandards","semantics":{"who":"3rd-graders","what":"read near or above grade-level standards","label":"3rd-graders who read near or above grade-level standards","shorthand":"3rd-grade reading standards"},"keywords":["book","read","reading","standards","3rd","grade"],"years":["2016","2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":["",""],"black":[50,46],"white":[78,76],"asian":[73,73],"latinx":[54,52],"other":[66,63],"totals":[63,61]},"alameda":{"ranks":[13,15],"black":[44,43],"white":[85,82],"asian":[72,68],"latinx":[52,47],"other":[67,70],"totals":[68,66]},"alpine":{"ranks":[7,58],"black":["",""],"white":["*","*"],"asian":["",""],"latinx":["",""],"other":["*","*"],"totals":[72,33]},"amador":{"ranks":[24,10],"black":["*","*"],"white":[67,71],"asian":["*","*"],"latinx":[52,53],"other":[65,61],"totals":[63,67]},"butte":{"ranks":[24,25],"black":[49,39],"white":[68,66],"asian":[63,50],"latinx":[55,51],"other":[54,55],"totals":[63,60]},"calaveras":{"ranks":[21,16],"black":["","*"],"white":[63,67],"asian":["*","*"],"latinx":[67,46],"other":[62,69],"totals":[64,63]},"colusa":{"ranks":[50,39],"black":["*","*"],"white":[67,80],"asian":["*","*"],"latinx":[50,51],"other":["*",64],"totals":[53,55]},"contraCosta":{"ranks":[10,12],"black":[48,41],"white":[83,82],"asian":[77,72],"latinx":[54,51],"other":[77,69],"totals":[69,66]},"delNorte":{"ranks":[48,53],"black":["*","*"],"white":[60,58],"asian":["*",62],"latinx":[41,42],"other":[55,37],"totals":[54,48]},"elDorado":{"ranks":[4,3],"black":[65,"*"],"white":[79,78],"asian":[79,75],"latinx":[60,62],"other":[62,63],"totals":[75,74]},"fresno":{"ranks":[43,29],"black":[45,43],"white":[78,77],"asian":[67,71],"latinx":[54,54],"other":[63,60],"totals":[58,59]},"glenn":{"ranks":[55,57],"black":["*","*"],"white":[67,49],"asian":["*",27],"latinx":[40,42],"other":[50,"*"],"totals":[51,44]},"humboldt":{"ranks":[20,30],"black":[60,56],"white":[72,70],"asian":[52,67],"latinx":[57,42],"other":[58,44],"totals":[65,59]},"imperial":{"ranks":[54,40],"black":[43,40],"white":[77,88],"asian":[72,85],"latinx":[51,53],"other":[50,40],"totals":[52,55]},"inyo":{"ranks":[18,48],"black":["*",""],"white":[81,72],"asian":["","*"],"latinx":[53,38],"other":[66,37],"totals":[66,53]},"kern":{"ranks":[46,41],"black":[46,42],"white":[67,65],"asian":[65,75],"latinx":[50,52],"other":[67,59],"totals":[56,55]},"kings":{"ranks":[32,37],"black":[60,51],"white":[75,74],"asian":[80,67],"latinx":[54,51],"other":[66,55],"totals":[61,57]},"lake":{"ranks":[56,52],"black":[16,"*"],"white":[57,56],"asian":["*","*"],"latinx":[42,42],"other":[48,48],"totals":[50,49]},"lassen":{"ranks":[38,50],"black":["*","*"],"white":[65,56],"asian":["*","*"],"latinx":[50,56],"other":[43,42],"totals":[60,52]},"losAngeles":{"ranks":[32,22],"black":[50,46],"white":[81,79],"asian":[78,76],"latinx":[56,54],"other":[71,71],"totals":[61,60]},"madera":{"ranks":[56,49],"black":[54,49],"white":[67,68],"asian":[64,70],"latinx":[45,48],"other":[52,61],"totals":[50,53]},"marin":{"ranks":[1,2],"black":[46,48],"white":[90,88],"asian":[96,87],"latinx":[55,49],"other":[87,81],"totals":[79,75]},"mariposa":{"ranks":[48,20],"black":["*","*"],"white":[59,60],"asian":["*","*"],"latinx":[30,65],"other":["*","*"],"totals":[54,61]},"mendocino":{"ranks":[50,54],"black":["*","*"],"white":[64,53],"asian":["*","*"],"latinx":[42,41],"other":[53,52],"totals":[53,47]},"merced":{"ranks":[50,44],"black":[49,43],"white":[66,68],"asian":[71,68],"latinx":[50,50],"other":[51,62],"totals":[53,54]},"modoc":{"ranks":[32,42],"black":["*","*"],"white":[67,59],"asian":["*",59],"latinx":[58,50],"other":["*","*"],"totals":[61,55]},"mono":{"ranks":[28,26],"black":["*","*"],"white":[86,83],"asian":["*","*"],"latinx":[49,45],"other":["*","*"],"totals":[62,60]},"monterey":{"ranks":[56,56],"black":[56,49],"white":[76,73],"asian":[66,64],"latinx":[43,41],"other":[62,63],"totals":[50,47]},"napa":{"ranks":[24,35],"black":[60,54],"white":[81,76],"asian":[74,77],"latinx":[51,42],"other":[65,81],"totals":[63,57]},"nevada":{"ranks":[5,6],"black":["*","*"],"white":[77,71],"asian":["*",64],"latinx":[57,58],"other":[80,74],"totals":[74,69]},"orange":{"ranks":[10,9],"black":[63,62],"white":[83,83],"asian":[80,79],"latinx":[55,53],"other":[76,71],"totals":[69,68]},"placer":{"ranks":[3,1],"black":[72,64],"white":[80,80],"asian":[77,80],"latinx":[63,61],"other":[78,75],"totals":[77,76]},"plumas":{"ranks":[40,31],"black":["*","*"],"white":[61,62],"asian":["*",59],"latinx":[52,45],"other":["*","*"],"totals":[59,59]},"riverside":{"ranks":[28,23],"black":[53,50],"white":[76,74],"asian":[75,82],"latinx":[56,54],"other":[66,62],"totals":[62,60]},"sacramento":{"ranks":[32,24],"black":[46,44],"white":[72,68],"asian":[66,65],"latinx":[52,52],"other":[58,57],"totals":[61,60]},"sanBenito":{"ranks":[13,14],"black":["*","*"],"white":[85,72],"asian":["*","*"],"latinx":[62,63],"other":["*","*"],"totals":[68,66]},"sanBernardino":{"ranks":[40,36],"black":[48,44],"white":[72,69],"asian":[74,75],"latinx":[55,53],"other":[60,60],"totals":[59,57]},"sanDiego":{"ranks":[9,8],"black":[60,55],"white":[83,80],"asian":[77,78],"latinx":[60,57],"other":[73,64],"totals":[70,68]},"sanFrancisco":{"ranks":[18,11],"black":[38,35],"white":[85,86],"asian":[66,65],"latinx":[51,50],"other":[71,76],"totals":[66,67]},"sanJoaquin":{"ranks":[47,46],"black":[42,41],"white":[69,68],"asian":[63,67],"latinx":[49,46],"other":[56,52],"totals":[55,53]},"sanLuisObispo":{"ranks":[10,13],"black":[68,55],"white":[78,77],"asian":[80,88],"latinx":[56,52],"other":[74,71],"totals":[69,66]},"sanMateo":{"ranks":[7,5],"black":[54,54],"white":[85,85],"asian":[71,68],"latinx":[53,50],"other":[81,82],"totals":[72,70]},"santaBarbara":{"ranks":[40,38],"black":[60,59],"white":[83,79],"asian":[78,72],"latinx":[49,46],"other":[73,57],"totals":[59,55]},"santaClara":{"ranks":[6,4],"black":[63,58],"white":[86,84],"asian":[70,74],"latinx":[55,52],"other":[72,69],"totals":[73,72]},"santaCruz":{"ranks":[43,43],"black":[55,60],"white":[78,75],"asian":[69,77],"latinx":[44,41],"other":[80,70],"totals":[58,54]},"shasta":{"ranks":[17,19],"black":[51,48],"white":[69,64],"asian":[67,72],"latinx":[67,56],"other":[57,56],"totals":[67,62]},"sierra":{"ranks":[2,55],"black":["","*"],"white":[80,43],"asian":["","*"],"latinx":["*","*"],"other":["","*"],"totals":[78,47]},"siskiyou":{"ranks":[21,32],"black":["*","*"],"white":[71,61],"asian":["*","*"],"latinx":[45,51],"other":[54,58],"totals":[64,58]},"solano":{"ranks":[38,34],"black":[48,45],"white":[71,71],"asian":[61,66],"latinx":[54,48],"other":[68,67],"totals":[60,57]},"sonoma":{"ranks":[13,17],"black":[55,59],"white":[80,76],"asian":[66,74],"latinx":[57,50],"other":[70,63],"totals":[68,63]},"stanislaus":{"ranks":[45,45],"black":[48,43],"white":[67,65],"asian":[68,74],"latinx":[50,47],"other":[60,59],"totals":[57,53]},"sutter":{"ranks":[32,28],"black":[41,43],"white":[66,66],"asian":[70,76],"latinx":[54,49],"other":[60,63],"totals":[61,59]},"tehama":{"ranks":[28,47],"black":[64,"*"],"white":[69,59],"asian":[54,"*"],"latinx":[52,44],"other":[59,66],"totals":[62,53]},"trinity":{"ranks":[13,7],"black":["",""],"white":[69,74],"asian":["*","*"],"latinx":[69,73],"other":["*","*"],"totals":[68,69]},"tulare":{"ranks":[50,51],"black":[49,39],"white":[68,62],"asian":[57,69],"latinx":[50,49],"other":[60,58],"totals":[53,51]},"tuolumne":{"ranks":[28,33],"black":["*","*"],"white":[63,61],"asian":["*","*"],"latinx":[52,53],"other":[70,44],"totals":[62,58]},"ventura":{"ranks":[32,21],"black":[58,67],"white":[81,80],"asian":[73,84],"latinx":[49,48],"other":[83,62],"totals":[61,60]},"yolo":{"ranks":[21,27],"black":[53,46],"white":[76,72],"asian":[74,71],"latinx":[53,47],"other":[79,78],"totals":[64,59]},"yuba":{"ranks":[24,18],"black":[60,58],"white":[66,66],"asian":[59,58],"latinx":[59,59],"other":[64,57],"totals":[63,62]}}}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = {"indicator":"suspension","semantics":{"who":"student suspensions","shortWho":"students","what":"were not due to \"defiance/disruption\"","label":"Student suspensions not due to \"defiance/disruption\"","shorthand":"Suspensions not due to defiance/disruption"},"keywords":["suspension","student","trouble","defiance","disruption"],"years":["2016","2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":["",""],"black":[76,81],"white":[76,80],"asian":[76,83],"latinx":[75,79],"other":[77,79],"totals":[76,80]},"alameda":{"ranks":[25,21],"black":[79,86],"white":[79,83],"asian":[78,82],"latinx":[75,79],"other":[80,86],"totals":[78,83]},"alpine":{"ranks":["",""],"black":["",""],"white":["",""],"asian":["",""],"latinx":["*",""],"other":["*",""],"totals":["*",""]},"amador":{"ranks":[24,7],"black":[86,79],"white":[79,89],"asian":[100,50],"latinx":[80,77],"other":[65,96],"totals":[78,87]},"butte":{"ranks":[51,41],"black":[57,55],"white":[67,76],"asian":[59,64],"latinx":[61,71],"other":[64,71],"totals":[65,73]},"calaveras":{"ranks":[14,54],"black":[67,80],"white":[85,65],"asian":[83,56],"latinx":[72,40],"other":[86,71],"totals":[81,56]},"colusa":{"ranks":[57,56],"black":[71,100],"white":[43,42],"asian":[50,33],"latinx":[38,49],"other":[52,61],"totals":[39,49]},"contraCosta":{"ranks":[41,43],"black":[67,69],"white":[76,80],"asian":[77,81],"latinx":[69,72],"other":[73,72],"totals":[70,73]},"delNorte":{"ranks":[4,9],"black":[80,83],"white":[86,88],"asian":[100,100],"latinx":[86,81],"other":[92,89],"totals":[87,87]},"elDorado":{"ranks":[43,44],"black":[83,82],"white":[69,71],"asian":[81,93],"latinx":[70,74],"other":[79,65],"totals":[69,72]},"fresno":{"ranks":[22,17],"black":[79,84],"white":[81,89],"asian":[81,95],"latinx":[77,83],"other":[77,87],"totals":[78,84]},"glenn":{"ranks":[38,47],"black":[100,63],"white":[70,69],"asian":[25,50],"latinx":[76,74],"other":[72,72],"totals":[72,71]},"humboldt":{"ranks":[6,34],"black":[86,81],"white":[85,77],"asian":[97,59],"latinx":[84,73],"other":[81,76],"totals":[84,76]},"imperial":{"ranks":[49,51],"black":[63,67],"white":[58,61],"asian":[67,23],"latinx":[68,64],"other":[60,69],"totals":[65,63]},"inyo":{"ranks":[5,3],"black":[100,100],"white":[90,94],"asian":[100,100],"latinx":[84,89],"other":[91,95],"totals":[87,93]},"kern":{"ranks":[31,27],"black":[76,84],"white":[78,78],"asian":[77,75],"latinx":[75,76],"other":[78,79],"totals":[76,78]},"kings":{"ranks":[34,28],"black":[72,83],"white":[73,82],"asian":[91,59],"latinx":[75,78],"other":[72,78],"totals":[74,78]},"lake":{"ranks":[8,23],"black":[73,80],"white":[84,81],"asian":[71,83],"latinx":[82,81],"other":[86,75],"totals":[83,80]},"lassen":{"ranks":[3,40],"black":[94,67],"white":[91,73],"asian":[93,60],"latinx":[79,80],"other":[88,81],"totals":[89,73]},"losAngeles":{"ranks":[7,12],"black":[83,84],"white":[84,86],"asian":[85,89],"latinx":[84,86],"other":[84,85],"totals":[84,86]},"madera":{"ranks":[50,39],"black":[70,80],"white":[71,83],"asian":[85,71],"latinx":[63,72],"other":[82,82],"totals":[65,74]},"marin":{"ranks":[16,25],"black":[83,70],"white":[79,84],"asian":[88,90],"latinx":[80,78],"other":[79,85],"totals":[80,79]},"mariposa":{"ranks":[33,4],"black":["*",67],"white":[74,89],"asian":[60,""],"latinx":[70,100],"other":[82,91],"totals":[74,90]},"mendocino":{"ranks":[47,50],"black":[74,79],"white":[68,64],"asian":[25,88],"latinx":[66,65],"other":[64,62],"totals":[67,65]},"merced":{"ranks":[37,32],"black":[71,76],"white":[73,80],"asian":[68,69],"latinx":[73,77],"other":[78,82],"totals":[73,77]},"modoc":{"ranks":[52,55],"black":[68,71],"white":[64,55],"asian":["*",""],"latinx":[59,65],"other":[57,23],"totals":[62,54]},"mono":{"ranks":[2,20],"black":["",100],"white":[91,85],"asian":["",100],"latinx":[96,85],"other":[83,25],"totals":[92,83]},"monterey":{"ranks":[15,31],"black":[79,77],"white":[84,83],"asian":[90,93],"latinx":[80,77],"other":[91,73],"totals":[81,78]},"napa":{"ranks":[19,14],"black":[80,96],"white":[79,82],"asian":[93,95],"latinx":[78,83],"other":[71,88],"totals":[79,84]},"nevada":{"ranks":[28,30],"black":[100,100],"white":[77,79],"asian":[67,83],"latinx":[77,79],"other":[76,44],"totals":[77,78]},"orange":{"ranks":[21,16],"black":[81,83],"white":[79,84],"asian":[85,90],"latinx":[78,84],"other":[79,84],"totals":[78,84]},"placer":{"ranks":[23,22],"black":[74,76],"white":[79,81],"asian":[78,85],"latinx":[77,80],"other":[82,85],"totals":[78,81]},"plumas":{"ranks":[26,15],"black":[80,88],"white":[76,86],"asian":[50,100],"latinx":[89,67],"other":[63,87],"totals":[78,84]},"riverside":{"ranks":[11,13],"black":[81,85],"white":[84,87],"asian":[83,88],"latinx":[82,84],"other":[86,87],"totals":[82,85]},"sacramento":{"ranks":[42,37],"black":[72,77],"white":[63,72],"asian":[74,80],"latinx":[70,73],"other":[76,76],"totals":[70,75]},"sanBenito":{"ranks":[12,8],"black":[100,100],"white":[81,88],"asian":[58,100],"latinx":[83,86],"other":[72,95],"totals":[82,87]},"sanBernardino":{"ranks":[20,19],"black":[80,85],"white":[82,82],"asian":[81,84],"latinx":[77,82],"other":[80,85],"totals":[79,83]},"sanDiego":{"ranks":[30,24],"black":[74,80],"white":[80,83],"asian":[78,87],"latinx":[75,78],"other":[79,82],"totals":[76,80]},"sanFrancisco":{"ranks":[1,1],"black":[95,97],"white":[99,97],"asian":[98,98],"latinx":[96,98],"other":[95,99],"totals":[96,97]},"sanJoaquin":{"ranks":[55,48],"black":[65,74],"white":[60,66],"asian":[55,72],"latinx":[58,67],"other":[74,76],"totals":[61,69]},"sanLuisObispo":{"ranks":[10,5],"black":[84,88],"white":[85,89],"asian":[100,84],"latinx":[79,89],"other":[80,89],"totals":[83,89]},"sanMateo":{"ranks":[29,46],"black":[79,76],"white":[79,80],"asian":[81,79],"latinx":[74,67],"other":[79,65],"totals":[76,71]},"santaBarbara":{"ranks":[32,10],"black":[68,92],"white":[84,89],"asian":[81,89],"latinx":[74,86],"other":[92,91],"totals":[76,86]},"santaClara":{"ranks":[27,26],"black":[80,79],"white":[86,86],"asian":[74,81],"latinx":[75,77],"other":[88,80],"totals":[78,79]},"santaCruz":{"ranks":[9,2],"black":[63,100],"white":[88,90],"asian":[57,100],"latinx":[80,96],"other":[73,89],"totals":[83,93]},"shasta":{"ranks":[35,36],"black":[80,76],"white":[75,75],"asian":[86,68],"latinx":[71,76],"other":[72,84],"totals":[74,76]},"sierra":{"ranks":[56,""],"black":["*",""],"white":[50,""],"asian":["*",""],"latinx":[100,""],"other":["*",""],"totals":[60,""]},"siskiyou":{"ranks":[40,35],"black":[89,94],"white":[72,74],"asian":[80,100],"latinx":[71,74],"other":[75,68],"totals":[70,76]},"solano":{"ranks":[39,33],"black":[72,81],"white":[70,75],"asian":[76,86],"latinx":[68,73],"other":[74,76],"totals":[71,77]},"sonoma":{"ranks":[53,45],"black":[72,75],"white":[62,74],"asian":[72,70],"latinx":[59,70],"other":[60,77],"totals":[61,72]},"stanislaus":{"ranks":[48,52],"black":[71,73],"white":[71,70],"asian":[73,74],"latinx":[63,58],"other":[77,69],"totals":[66,63]},"sutter":{"ranks":[46,49],"black":[64,64],"white":[68,78],"asian":[89,85],"latinx":[66,64],"other":[65,64],"totals":[67,69]},"tehama":{"ranks":[45,42],"black":[71,82],"white":[73,80],"asian":[50,100],"latinx":[59,61],"other":[74,64],"totals":[68,73]},"trinity":{"ranks":[54,53],"black":["*",""],"white":[58,64],"asian":["*",""],"latinx":[40,52],"other":[75,53],"totals":[61,62]},"tulare":{"ranks":[18,18],"black":[84,89],"white":[84,88],"asian":[62,81],"latinx":[78,83],"other":[81,87],"totals":[79,84]},"tuolumne":{"ranks":[17,11],"black":[71,67],"white":[81,86],"asian":[90,83],"latinx":[68,85],"other":[88,89],"totals":[79,86]},"ventura":{"ranks":[13,6],"black":[80,87],"white":[82,88],"asian":[94,96],"latinx":[82,87],"other":[85,85],"totals":[82,87]},"yolo":{"ranks":[44,38],"black":[71,83],"white":[75,82],"asian":[75,73],"latinx":[66,70],"other":[90,83],"totals":[69,75]},"yuba":{"ranks":[36,29],"black":[72,69],"white":[72,79],"asian":[91,79],"latinx":[77,78],"other":[68,80],"totals":[73,78]}}}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = {"indicator":"connected","semantics":{"who":"students","what":"reported feeling connected to their school","label":"Students who reported feeling connected to their school","shorthand":"Feeling connected to school"},"keywords":["students","connected","school","feeling"],"years":["2016","2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":["",""],"black":[39,39],"white":[60,58],"asian":[53,52],"latinx":[47,48],"other":[49,48],"totals":[51,50]},"alameda":{"ranks":[34,32],"black":[37,41],"white":[62,58],"asian":[49,47],"latinx":[43,42],"other":[49,53],"totals":[48,48]},"alpine":{"ranks":[14,43],"black":["",""],"white":[0,""],"asian":["",""],"latinx":[100,100],"other":[100,46],"totals":[55,45]},"amador":{"ranks":["",33],"black":["",0],"white":["",51],"asian":["",73],"latinx":["",45],"other":["",40],"totals":["",48]},"butte":{"ranks":[20,19],"black":[40,0],"white":[55,46],"asian":[50,50],"latinx":[51,57],"other":[46,50],"totals":[52,52]},"calaveras":{"ranks":[7,10],"black":[83,25],"white":[58,63],"asian":[56,45],"latinx":[54,47],"other":[49,56],"totals":[57,57]},"colusa":{"ranks":[8,14],"black":[50,""],"white":[60,67],"asian":[21,25],"latinx":[55,52],"other":[58,54],"totals":[56,55]},"contraCosta":{"ranks":[27,29],"black":[31,31],"white":[61,62],"asian":[51,50],"latinx":[42,42],"other":[52,54],"totals":[50,49]},"delNorte":{"ranks":[49,""],"black":[56,""],"white":[40,""],"asian":[25,""],"latinx":[39,""],"other":[32,""],"totals":[38,""]},"elDorado":{"ranks":[4,14],"black":[37,59],"white":[62,58],"asian":[67,57],"latinx":[54,49],"other":[52,49],"totals":[59,55]},"fresno":{"ranks":[29,46],"black":[36,40],"white":[56,48],"asian":[42,41],"latinx":[48,43],"other":[54,45],"totals":[50,44]},"glenn":{"ranks":[28,""],"black":[57,""],"white":[57,""],"asian":[54,""],"latinx":[46,""],"other":[50,""],"totals":[50,""]},"humboldt":{"ranks":[24,40],"black":[37,42],"white":[55,51],"asian":[43,48],"latinx":[51,43],"other":[42,34],"totals":[51,47]},"imperial":{"ranks":["",24],"black":["",28],"white":["",48],"asian":["",47],"latinx":["",51],"other":["",46],"totals":["",51]},"inyo":{"ranks":["",7],"black":["",""],"white":["",65],"asian":["",50],"latinx":["",58],"other":["",55],"totals":["",59]},"kern":{"ranks":[17,45],"black":[42,35],"white":[58,50],"asian":[56,44],"latinx":[53,44],"other":[53,43],"totals":[54,44]},"kings":{"ranks":[36,21],"black":[44,48],"white":[54,58],"asian":[48,45],"latinx":[46,52],"other":[48,42],"totals":[48,51]},"lake":{"ranks":[31,37],"black":[52,46],"white":[50,50],"asian":[53,41],"latinx":[47,45],"other":[49,44],"totals":[49,47]},"lassen":{"ranks":["",44],"black":["",30],"white":["",48],"asian":["",47],"latinx":["",43],"other":["",36],"totals":["",44]},"losAngeles":{"ranks":[34,31],"black":[36,37],"white":[58,60],"asian":[53,52],"latinx":[46,47],"other":[45,44],"totals":[48,49]},"madera":{"ranks":[41,16],"black":[48,0],"white":[56,62],"asian":[52,55],"latinx":[40,46],"other":[41,38],"totals":[45,55]},"marin":{"ranks":[1,2],"black":[43,0],"white":[70,74],"asian":[51,83],"latinx":[53,55],"other":[65,61],"totals":[64,66]},"mariposa":{"ranks":[11,""],"black":[0,""],"white":[60,""],"asian":[78,""],"latinx":[49,""],"other":[49,""],"totals":[55,""]},"mendocino":{"ranks":[45,42],"black":[33,73],"white":[48,48],"asian":[21,45],"latinx":[43,45],"other":[32,38],"totals":[42,45]},"merced":{"ranks":[44,37],"black":[44,34],"white":[49,55],"asian":[49,48],"latinx":[42,45],"other":[50,50],"totals":[43,47]},"modoc":{"ranks":[42,""],"black":[100,""],"white":[51,""],"asian":[100,""],"latinx":[33,""],"other":[48,""],"totals":[45,""]},"mono":{"ranks":[2,""],"black":[0,""],"white":[70,""],"asian":[17,""],"latinx":[58,""],"other":[58,""],"totals":[62,""]},"monterey":{"ranks":[47,35],"black":[42,40],"white":[50,56],"asian":[47,55],"latinx":[36,45],"other":[38,47],"totals":[40,47]},"napa":{"ranks":[6,5],"black":[55,48],"white":[64,62],"asian":[63,68],"latinx":[57,57],"other":[55,55],"totals":[59,59]},"nevada":{"ranks":[18,8],"black":[40,48],"white":[54,58],"asian":[63,67],"latinx":[48,56],"other":[49,56],"totals":[53,57]},"orange":{"ranks":[9,21],"black":[49,39],"white":[64,55],"asian":[58,52],"latinx":[50,51],"other":[55,50],"totals":[56,51]},"placer":{"ranks":[4,3],"black":[48,64],"white":[62,68],"asian":[59,67],"latinx":[54,61],"other":[56,62],"totals":[59,65]},"plumas":{"ranks":[24,""],"black":[0,""],"white":[50,""],"asian":[25,""],"latinx":[49,""],"other":[59,""],"totals":[51,""]},"riverside":{"ranks":[30,20],"black":[43,44],"white":[57,58],"asian":[51,52],"latinx":[47,50],"other":[46,48],"totals":[49,52]},"sacramento":{"ranks":[36,47],"black":[40,36],"white":[54,48],"asian":[51,44],"latinx":[45,42],"other":[47,42],"totals":[48,43]},"sanBenito":{"ranks":[46,1],"black":[22,""],"white":[47,76],"asian":[37,67],"latinx":[40,74],"other":[31,75],"totals":[41,75]},"sanBernardino":{"ranks":[39,49],"black":[37,35],"white":[51,45],"asian":[52,47],"latinx":[46,43],"other":[47,37],"totals":[47,42]},"sanDiego":{"ranks":[21,18],"black":[44,45],"white":[59,62],"asian":[52,57],"latinx":[48,50],"other":[48,50],"totals":[52,54]},"sanFrancisco":{"ranks":[22,23],"black":[43,27],"white":[62,53],"asian":[48,67],"latinx":[50,52],"other":[45,46],"totals":[52,51]},"sanJoaquin":{"ranks":[31,50],"black":[40,38],"white":[55,40],"asian":[50,45],"latinx":[47,43],"other":[47,33],"totals":[49,42]},"sanLuisObispo":{"ranks":[11,27],"black":[47,23],"white":[59,57],"asian":[53,50],"latinx":[52,44],"other":[50,46],"totals":[55,50]},"sanMateo":{"ranks":[3,4],"black":[49,49],"white":[69,65],"asian":[58,58],"latinx":[53,52],"other":[60,54],"totals":[60,60]},"santaBarbara":{"ranks":[15,9],"black":[45,46],"white":[59,65],"asian":[49,56],"latinx":[51,54],"other":[47,58],"totals":[54,57]},"santaClara":{"ranks":[16,12],"black":[43,52],"white":[63,58],"asian":[54,59],"latinx":[47,50],"other":[58,61],"totals":[54,55]},"santaCruz":{"ranks":["",11],"black":["",42],"white":["",64],"asian":["",53],"latinx":["",52],"other":["",63],"totals":["",56]},"shasta":{"ranks":[40,36],"black":[39,100],"white":[52,55],"asian":[41,40],"latinx":[39,40],"other":[37,39],"totals":[46,47]},"sierra":{"ranks":[19,""],"black":["",""],"white":[55,""],"asian":["",""],"latinx":[50,""],"other":[35,""],"totals":[53,""]},"siskiyou":{"ranks":[43,13],"black":[27,""],"white":[47,53],"asian":[63,""],"latinx":[42,71],"other":[38,25],"totals":[44,55]},"solano":{"ranks":[48,48],"black":[29,34],"white":[47,47],"asian":[39,36],"latinx":[37,43],"other":[40,41],"totals":[39,43]},"sonoma":{"ranks":[13,16],"black":[49,73],"white":[62,63],"asian":[54,60],"latinx":[51,47],"other":[50,39],"totals":[55,55]},"stanislaus":{"ranks":[50,28],"black":[50,43],"white":[41,56],"asian":[13,49],"latinx":[36,48],"other":[18,51],"totals":[34,50]},"sutter":{"ranks":["",34],"black":["",41],"white":["",52],"asian":["",45],"latinx":["",44],"other":["",52],"totals":["",48]},"tehama":{"ranks":[23,""],"black":[56,""],"white":[57,""],"asian":[42,""],"latinx":[48,""],"other":[47,""],"totals":[52,""]},"trinity":{"ranks":["",39],"black":["",50],"white":["",52],"asian":["",36],"latinx":["",33],"other":["",38],"totals":["",47]},"tulare":{"ranks":[31,25],"black":[36,37],"white":[55,47],"asian":[52,49],"latinx":[48,51],"other":[51,51],"totals":[49,50]},"tuolumne":{"ranks":[38,6],"black":[33,25],"white":[51,63],"asian":[54,75],"latinx":[42,52],"other":[46,53],"totals":[48,59]},"ventura":{"ranks":[26,29],"black":[42,39],"white":[63,45],"asian":[54,56],"latinx":[45,50],"other":[47,52],"totals":[51,49]},"yolo":{"ranks":[9,26],"black":[50,43],"white":[62,58],"asian":[50,47],"latinx":[54,47],"other":[48,45],"totals":[56,50]},"yuba":{"ranks":["",41],"black":["",45],"white":["",48],"asian":["",48],"latinx":["",44],"other":["",47],"totals":["",46]}}}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = {"indicator":"difference","semantics":{"who":"students","what":"reported feeling like they did things at school that made a difference","label":"Students who reported feeling like they do things at school that make a difference","shorthand":"Feeling school makes a difference"},"keywords":["feelings","school","makes","difference","students"],"years":["2016","2017"],"categories":["hasRace","education"],"counties":{"california":{"ranks":["",""],"black":[39,39],"white":[41,39],"asian":[38,36],"latinx":[32,31],"other":[39,37],"totals":[36,34]},"alameda":{"ranks":[24,33],"black":[41,36],"white":[41,36],"asian":[38,33],"latinx":[31,29],"other":[40,41],"totals":[36,33]},"alpine":{"ranks":[50,1],"black":["",""],"white":[0,33],"asian":["",""],"latinx":[0,67],"other":[50,46],"totals":[20,50]},"amador":{"ranks":["",17],"black":["",25],"white":["",37],"asian":["",71],"latinx":["",36],"other":["",32],"totals":["",37]},"butte":{"ranks":[11,35],"black":[42,33],"white":[41,31],"asian":[35,10],"latinx":[36,32],"other":[37,60],"totals":[39,33]},"calaveras":{"ranks":[31,19],"black":[67,50],"white":[36,38],"asian":[36,40],"latinx":[34,33],"other":[40,36],"totals":[36,37]},"colusa":{"ranks":[21,9],"black":[38,""],"white":[40,45],"asian":[6,25],"latinx":[36,38],"other":[30,36],"totals":[37,40]},"contraCosta":{"ranks":[22,25],"black":[35,34],"white":[42,41],"asian":[36,39],"latinx":[30,29],"other":[42,40],"totals":[37,35]},"delNorte":{"ranks":[47,""],"black":[38,""],"white":[32,""],"asian":[28,""],"latinx":[30,""],"other":[30,""],"totals":[31,""]},"elDorado":{"ranks":[2,13],"black":[26,49],"white":[47,40],"asian":[49,31],"latinx":[43,34],"other":[36,37],"totals":[45,38]},"fresno":{"ranks":[28,48],"black":[44,38],"white":[45,36],"asian":[32,37],"latinx":[35,29],"other":[36,32],"totals":[36,31]},"glenn":{"ranks":[17,""],"black":[43,""],"white":[46,""],"asian":[20,""],"latinx":[32,""],"other":[41,""],"totals":[37,""]},"humboldt":{"ranks":[33,31],"black":[37,40],"white":[37,37],"asian":[30,31],"latinx":[33,29],"other":[33,29],"totals":[35,34]},"imperial":{"ranks":["",49],"black":["",36],"white":["",32],"asian":["",30],"latinx":["",30],"other":["",33],"totals":["",31]},"inyo":{"ranks":["",20],"black":["",""],"white":["",41],"asian":["",25],"latinx":["",27],"other":["",43],"totals":["",37]},"kern":{"ranks":[14,44],"black":[46,38],"white":[42,37],"asian":[40,38],"latinx":[35,30],"other":[43,34],"totals":[38,32]},"kings":{"ranks":[37,11],"black":[41,42],"white":[41,44],"asian":[40,38],"latinx":[33,38],"other":[28,36],"totals":[35,39]},"lake":{"ranks":[40,38],"black":[30,38],"white":[34,34],"asian":[59,33],"latinx":[32,31],"other":[34,31],"totals":[34,33]},"lassen":{"ranks":["",15],"black":["",40],"white":["",40],"asian":["",30],"latinx":["",36],"other":["",33],"totals":["",37]},"losAngeles":{"ranks":[37,28],"black":[38,39],"white":[41,39],"asian":[36,34],"latinx":[32,32],"other":[38,37],"totals":[35,34]},"madera":{"ranks":[16,6],"black":[62,0],"white":[44,45],"asian":[46,79],"latinx":[34,38],"other":[29,38],"totals":[38,43]},"marin":{"ranks":[4,2],"black":[31,0],"white":[47,56],"asian":[38,67],"latinx":[31,36],"other":[42,57],"totals":[42,49]},"mariposa":{"ranks":[6,""],"black":[33,""],"white":[42,""],"asian":[67,""],"latinx":[36,""],"other":[39,""],"totals":[40,""]},"mendocino":{"ranks":[42,50],"black":[67,45],"white":[37,34],"asian":[61,28],"latinx":[30,26],"other":[27,22],"totals":[33,29]},"merced":{"ranks":[44,40],"black":[38,38],"white":[37,40],"asian":[31,28],"latinx":[30,30],"other":[43,37],"totals":[32,32]},"modoc":{"ranks":[9,""],"black":[100,""],"white":[43,""],"asian":[100,""],"latinx":[33,""],"other":[46,""],"totals":[39,""]},"mono":{"ranks":[3,""],"black":[0,""],"white":[55,""],"asian":[0,""],"latinx":[36,""],"other":[30,""],"totals":[42,""]},"monterey":{"ranks":[43,44],"black":[41,35],"white":[41,38],"asian":[35,37],"latinx":[29,30],"other":[42,40],"totals":[33,32]},"napa":{"ranks":[12,17],"black":[36,31],"white":[43,42],"asian":[41,39],"latinx":[35,33],"other":[41,42],"totals":[38,37]},"nevada":{"ranks":[13,14],"black":[29,43],"white":[38,36],"asian":[42,42],"latinx":[38,38],"other":[39,44],"totals":[38,37]},"orange":{"ranks":[15,40],"black":[43,37],"white":[44,37],"asian":[40,33],"latinx":[33,32],"other":[42,36],"totals":[38,32]},"placer":{"ranks":[7,7],"black":[40,54],"white":[41,42],"asian":[40,44],"latinx":[33,40],"other":[42,44],"totals":[39,42]},"plumas":{"ranks":[8,""],"black":[0,""],"white":[38,""],"asian":[75,""],"latinx":[38,""],"other":[42,""],"totals":[39,""]},"riverside":{"ranks":[25,22],"black":[42,41],"white":[42,40],"asian":[41,38],"latinx":[33,33],"other":[41,38],"totals":[36,36]},"sacramento":{"ranks":[25,33],"black":[40,39],"white":[39,33],"asian":[39,34],"latinx":[32,31],"other":[39,37],"totals":[36,33]},"sanBenito":{"ranks":[48,5],"black":[50,""],"white":[33,50],"asian":[25,100],"latinx":[29,30],"other":[34,50],"totals":[30,44]},"sanBernardino":{"ranks":[20,32],"black":[39,39],"white":[42,39],"asian":[38,46],"latinx":[34,31],"other":[39,36],"totals":[37,33]},"sanDiego":{"ranks":[32,23],"black":[41,40],"white":[39,41],"asian":[35,37],"latinx":[32,31],"other":[40,37],"totals":[36,36]},"sanFrancisco":{"ranks":[25,3],"black":[45,38],"white":[44,44],"asian":[36,39],"latinx":[35,50],"other":[41,36],"totals":[36,46]},"sanJoaquin":{"ranks":[29,37],"black":[40,36],"white":[40,33],"asian":[39,35],"latinx":[33,32],"other":[40,36],"totals":[36,33]},"sanLuisObispo":{"ranks":[19,8],"black":[38,44],"white":[41,48],"asian":[39,32],"latinx":[31,35],"other":[37,36],"totals":[37,41]},"sanMateo":{"ranks":[10,12],"black":[40,42],"white":[46,45],"asian":[38,30],"latinx":[33,31],"other":[42,42],"totals":[39,38]},"santaBarbara":{"ranks":[29,27],"black":[40,33],"white":[42,43],"asian":[40,38],"latinx":[32,31],"other":[36,40],"totals":[36,35]},"santaClara":{"ranks":[35,42],"black":[34,40],"white":[39,32],"asian":[38,36],"latinx":[28,29],"other":[40,36],"totals":[35,32]},"santaCruz":{"ranks":["",29],"black":["",42],"white":["",40],"asian":["",33],"latinx":["",30],"other":["",41],"totals":["",34]},"shasta":{"ranks":[22,16],"black":[26,50],"white":[37,42],"asian":[38,48],"latinx":[33,43],"other":[38,20],"totals":[37,37]},"sierra":{"ranks":[1,""],"black":["",""],"white":[53,""],"asian":["",""],"latinx":[37,""],"other":[35,""],"totals":[49,""]},"siskiyou":{"ranks":[39,4],"black":[37,""],"white":[33,47],"asian":[55,""],"latinx":[33,43],"other":[34,25],"totals":[34,45]},"solano":{"ranks":[46,46],"black":[33,32],"white":[34,34],"asian":[31,27],"latinx":[27,31],"other":[34,33],"totals":[31,31]},"sonoma":{"ranks":[33,25],"black":[38,27],"white":[41,42],"asian":[42,46],"latinx":[30,27],"other":[38,42],"totals":[35,35]},"stanislaus":{"ranks":[45,35],"black":[100,38],"white":[33,36],"asian":[13,37],"latinx":[31,31],"other":[29,39],"totals":[31,33]},"sutter":{"ranks":["",39],"black":["",39],"white":["",34],"asian":["",43],"latinx":["",28],"other":["",39],"totals":["",32]},"tehama":{"ranks":[5,""],"black":[50,""],"white":[46,""],"asian":[38,""],"latinx":[36,""],"other":[43,""],"totals":[41,""]},"trinity":{"ranks":["",21],"black":["",33],"white":["",39],"asian":["",12],"latinx":["",41],"other":["",30],"totals":["",37]},"tulare":{"ranks":[18,10],"black":[35,52],"white":[46,38],"asian":[43,39],"latinx":[35,39],"other":[40,49],"totals":[37,39]},"tuolumne":{"ranks":[36,24],"black":[67,25],"white":[35,38],"asian":[49,25],"latinx":[33,32],"other":[28,34],"totals":[35,35]},"ventura":{"ranks":[41,42],"black":[40,27],"white":[42,39],"asian":[38,37],"latinx":[29,32],"other":[36,31],"totals":[34,32]},"yolo":{"ranks":[49,29],"black":[0,37],"white":[35,36],"asian":[100,38],"latinx":[23,32],"other":[44,37],"totals":[28,34]},"yuba":{"ranks":["",47],"black":["",47],"white":["",33],"asian":["",38],"latinx":["",29],"other":["",30],"totals":["",31]}}}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {function detect() {
  if (typeof navigator !== 'undefined') {
    return parseUserAgent(navigator.userAgent);
  }

  return getNodeVersion();
}

function detectOS(userAgentString) {
  var rules = getOperatingSystemRules();
  var detected = rules.filter(function (os) {
    return os.rule && os.rule.test(userAgentString);
  })[0];

  return detected ? detected.name : null;
}

function getNodeVersion() {
  var isNode = typeof process !== 'undefined' && process.version;
  return isNode && {
    name: 'node',
    version: process.version.slice(1),
    os: process.platform
  };
}

function parseUserAgent(userAgentString) {
  var browsers = getBrowserRules();
  if (!userAgentString) {
    return null;
  }

  var detected = browsers.map(function(browser) {
    var match = browser.rule.exec(userAgentString);
    var version = match && match[1].split(/[._]/).slice(0,3);

    if (version && version.length < 3) {
      version = version.concat(version.length == 1 ? [0, 0] : [0]);
    }

    return match && {
      name: browser.name,
      version: version.join('.')
    };
  }).filter(Boolean)[0] || null;

  if (detected) {
    detected.os = detectOS(userAgentString);
  }

  if (/alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/i.test(userAgentString)) {
    detected = detected || {};
    detected.bot = true;
  }

  return detected;
}

function getBrowserRules() {
  return buildRules([
    [ 'aol', /AOLShield\/([0-9\._]+)/ ],
    [ 'edge', /Edge\/([0-9\._]+)/ ],
    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
    [ 'samsung', /SamsungBrowser\/([0-9\.]+)/ ],
    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
    [ 'ie', /MSIE\s(7\.0)/ ],
    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
    [ 'android', /Android\s([0-9\.]+)/ ],
    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
    [ 'safari', /Version\/([0-9\._]+).*Safari/ ],
    [ 'facebook', /FBAV\/([0-9\.]+)/],
    [ 'instagram', /Instagram\s([0-9\.]+)/],
    [ 'ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/]
  ]);
}

function getOperatingSystemRules() {
  return buildRules([
    [ 'iOS', /iP(hone|od|ad)/ ],
    [ 'Android OS', /Android/ ],
    [ 'BlackBerry OS', /BlackBerry|BB10/ ],
    [ 'Windows Mobile', /IEMobile/ ],
    [ 'Amazon OS', /Kindle/ ],
    [ 'Windows 3.11', /Win16/ ],
    [ 'Windows 95', /(Windows 95)|(Win95)|(Windows_95)/ ],
    [ 'Windows 98', /(Windows 98)|(Win98)/ ],
    [ 'Windows 2000', /(Windows NT 5.0)|(Windows 2000)/ ],
    [ 'Windows XP', /(Windows NT 5.1)|(Windows XP)/ ],
    [ 'Windows Server 2003', /(Windows NT 5.2)/ ],
    [ 'Windows Vista', /(Windows NT 6.0)/ ],
    [ 'Windows 7', /(Windows NT 6.1)/ ],
    [ 'Windows 8', /(Windows NT 6.2)/ ],
    [ 'Windows 8.1', /(Windows NT 6.3)/ ],
    [ 'Windows 10', /(Windows NT 10.0)/ ],
    [ 'Windows ME', /Windows ME/ ],
    [ 'Open BSD', /OpenBSD/ ],
    [ 'Sun OS', /SunOS/ ],
    [ 'Linux', /(Linux)|(X11)/ ],
    [ 'Mac OS', /(Mac_PowerPC)|(Macintosh)/ ],
    [ 'QNX', /QNX/ ],
    [ 'BeOS', /BeOS/ ],
    [ 'OS/2', /OS\/2/ ],
    [ 'Search Bot', /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/ ]
  ]);
}

function buildRules(ruleTuples) {
  return ruleTuples.map(function(tuple) {
    return {
      name: tuple[0],
      rule: tuple[1]
    };
  });
}

module.exports = {
  detect: detect,
  detectOS: detectOS,
  getNodeVersion: getNodeVersion,
  parseUserAgent: parseUserAgent
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(128);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(42);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(44);
var isCallable = __webpack_require__(27);
var isDate = __webpack_require__(133);
var isSymbol = __webpack_require__(134);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (PreferredType === String) {
			hint = 'string';
		} else if (PreferredType === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') { return false; }
		return symStringRegex.test(symToStr.call(value));
	};
	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') { return true; }
		if (toStr.call(value) !== '[object Symbol]') { return false; }
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {
	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false;
	};
}


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(45);
var $isFinite = __webpack_require__(46);

var sign = __webpack_require__(47);
var mod = __webpack_require__(48);

var IsCallable = __webpack_require__(27);
var toPrimitive = __webpack_require__(137);

var has = __webpack_require__(21);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(44);

var isCallable = __webpack_require__(27);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(21);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(49);
var define = __webpack_require__(17);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_DECORATORS":"true;","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_SASS":"false;","REACT_APP_LESS":"false;","REACT_APP_STYLUS":"false;","REACT_APP_CSS_MODULES":"true;","REACT_APP_SASS_MODULES":"false;","REACT_APP_STYLUS_MODULES":"false;","REACT_APP_LESS_MODULES":"false;","REACT_APP_WEBPACK_DASHBOARD":"true;"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(141);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(142);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(18)))

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResponsiveNav; });
/* unused harmony export PickingWorkflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generic_Icon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CountyList__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_IndicatorList__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ExpandBox__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utilities_isValid__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_caret_svg__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_caret_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_caret_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_reset_svg__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_reset_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_reset_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utilities_stopwords__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utilities_stopwords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__utilities_stopwords__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_class4,_desc2,_value2,_class5,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17;var _templateObject=_taggedTemplateLiteral(['\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    position: relative;\n    @media ','{\n        /*width: 100%;*/\n        width: 1550px;\n\n    }\n    @media ','{\n        /*width: 100%;*/\n        width: 1300px;\n\n    }\n'],['\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    position: relative;\n    @media ','{\n        /*width: 100%;*/\n        width: 1550px;\n\n    }\n    @media ','{\n        /*width: 100%;*/\n        width: 1300px;\n\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: relative;\n    font-weight: ',';\n    box-shadow: ',';\n    @media ','{\n        padding: 12px 45px 12px 20px;\n    }\n    @media ','{\n        height: 44px;\n        padding: 10px 45px 10px 20px;\n    }\n    background: ',';\n    color: ',';\n    display: flex;\n    align-items: center;\n    /*outline: 1px solid var(--offwhitebg);*/\n    transition: box-shadow .25s, background-color .25s, transform .25s;\n    white-space: nowrap;\n    cursor: pointer;\n'],['\n    position: relative;\n    font-weight: ',';\n    box-shadow: ',';\n    @media ','{\n        padding: 12px 45px 12px 20px;\n    }\n    @media ','{\n        height: 44px;\n        padding: 10px 45px 10px 20px;\n    }\n    background: ',';\n    color: ',';\n    display: flex;\n    align-items: center;\n    /*outline: 1px solid var(--offwhitebg);*/\n    transition: box-shadow .25s, background-color .25s, transform .25s;\n    white-space: nowrap;\n    cursor: pointer;\n']),_templateObject3=_taggedTemplateLiteral(['\n    &::before{\n        content: \'\';\n        right: 18px;\n        margin-top: 4px;\n        width: 0px;\n        border: 7px solid transparent;\n        border-top-color: ',';\n        height: 0px;\n        position: absolute;\n    }\n    &::after{\n        content: \'\';\n        right: 18px;\n        margin-top: 4px;\n        width: 0px;\n        border: 7px solid transparent;\n        transform: scale(0.75);\n        transform-origin: 50% 20%;\n        border-top-color: white;\n        height: 0px;\n        position: absolute;\n        transition: transform .25s;\n        ','\n        ','\n    }\n'],['\n    &::before{\n        content: \'\';\n        right: 18px;\n        margin-top: 4px;\n        width: 0px;\n        border: 7px solid transparent;\n        border-top-color: ',';\n        height: 0px;\n        position: absolute;\n    }\n    &::after{\n        content: \'\';\n        right: 18px;\n        margin-top: 4px;\n        width: 0px;\n        border: 7px solid transparent;\n        transform: scale(0.75);\n        transform-origin: 50% 20%;\n        border-top-color: white;\n        height: 0px;\n        position: absolute;\n        transition: transform .25s;\n        ','\n        ','\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 395px;\n    transform: ',';\n\n'],['\n    width: 395px;\n    transform: ',';\n\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    /*outline: 1px solid black;*/\n    width: 30px;\n    height: 30px;\n    background-repeat: no-repeat;\n    margin-right: 10px;\n    flex-shrink: 0;\n    background-size: cover;\n'],['\n    position: absolute;\n    /*outline: 1px solid black;*/\n    width: 30px;\n    height: 30px;\n    background-repeat: no-repeat;\n    margin-right: 10px;\n    flex-shrink: 0;\n    background-size: cover;\n']),_templateObject6=_taggedTemplateLiteral(['\n    background-image: url(',');\n    background-position: ',';\n'],['\n    background-image: url(',');\n    background-position: ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n    display: flex;\n    max-width: 165px;\n    align-items: center;\n'],['\n    display: flex;\n    max-width: 165px;\n    align-items: center;\n']),_templateObject8=_taggedTemplateLiteral(['\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-left: 35px;\n    padding-left: 7px;\n    /*margin-left: -7px;*/\n    ','\n    &::after{\n        content: \'','\';\n        color: rgba(0,0,0,0);\n        position: absolute;\n        top: calc(50% - 1px);\n        left: -10px;\n        padding: 0 13px;\n        z-index: 5;\n        bottom: 0; \n        margin: auto;\n        border-top: 2px solid var(--strokepeach);\n        transform: scaleX(',');\n        transition: transform .2s;\n        pointer-events: none;\n        transform-origin: ',';\n\n    }\n'],['\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-left: 35px;\n    padding-left: 7px;\n    /*margin-left: -7px;*/\n    ','\n    &::after{\n        content: \'','\';\n        color: rgba(0,0,0,0);\n        position: absolute;\n        top: calc(50% - 1px);\n        left: -10px;\n        padding: 0 13px;\n        z-index: 5;\n        bottom: 0; \n        margin: auto;\n        border-top: 2px solid var(--strokepeach);\n        transform: scaleX(',');\n        transition: transform .2s;\n        pointer-events: none;\n        transform-origin: ',';\n\n    }\n']),_templateObject9=_taggedTemplateLiteral(['\n    width: 230px;\n    position: relative;\n    transform: ',';\n'],['\n    width: 230px;\n    position: relative;\n    transform: ',';\n']),_templateObject10=_taggedTemplateLiteral(['\n    font-size: 13px;\n'],['\n    font-size: 13px;\n']),_templateObject11=_taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding-right: 30px;\n'],['\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding-right: 30px;\n']),_templateObject12=_taggedTemplateLiteral(['\n    position: absolute;\n    right: -8px;\n    top: 0px; bottom: 0; margin: auto;\n    width: 30px;\n    height: 30px;\n    background-size: cover;\n    /*border: 1px solid white;*/\n    background-image: url(',');\n    background-repeat: no-repeat;\n    transform-origin: 50% 50%;\n    transition: transform .2s;\n'],['\n    position: absolute;\n    right: -8px;\n    top: 0px; bottom: 0; margin: auto;\n    width: 30px;\n    height: 30px;\n    background-size: cover;\n    /*border: 1px solid white;*/\n    background-image: url(',');\n    background-repeat: no-repeat;\n    transform-origin: 50% 50%;\n    transition: transform .2s;\n']),_templateObject13=_taggedTemplateLiteral(['\n    transform: translateX(','px);\n    transition: transform .25s;\n    z-index: 4;\n'],['\n    transform: translateX(','px);\n    transition: transform .25s;\n    z-index: 4;\n']),_templateObject14=_taggedTemplateLiteral(['\n    position: absolute;\n    right: 0;\n    transition: opacity .4s, transform .4s;\n    pointer-events: ',';\n    opacity: ',';\n    transform: translateX(','px);\n    &:hover{\n        figure{ \n            background-position: 100% 0; \n            transform: rotate(-90deg);\n        }\n    }\n'],['\n    position: absolute;\n    right: 0;\n    transition: opacity .4s, transform .4s;\n    pointer-events: ',';\n    opacity: ',';\n    transform: translateX(','px);\n    &:hover{\n        figure{ \n            background-position: 100% 0; \n            transform: rotate(-90deg);\n        }\n    }\n']),_templateObject15=_taggedTemplateLiteral(['\n    font-size: 13px;\n    width: 325px;\n    line-height: 21px;\n    white-space: normal;\n'],['\n    font-size: 13px;\n    width: 325px;\n    line-height: 21px;\n    white-space: normal;\n']),_templateObject16=_taggedTemplateLiteral(['\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    background-color: var(--fainttext);\n    background-position: center;\n    background-size: contain;\n'],['\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    background-color: var(--fainttext);\n    background-position: center;\n    background-size: contain;\n']),_templateObject17=_taggedTemplateLiteral(['\n     position: absolute;\n     right: 22px;\n     top: 22px;\n     width:25px;\n     height: 25px;\n     cursor: pointer;\n     z-index: 2;\n'],['\n     position: absolute;\n     right: 22px;\n     top: 22px;\n     width:25px;\n     height: 25px;\n     cursor: pointer;\n     z-index: 2;\n']),_templateObject18=_taggedTemplateLiteral(['\n    width: 15px; height: 15px;\n    margin-bottom: 0px;\n    margin-right: -5px;\n    margin-left: 8px;\n    flex-shrink: 0;\n\n'],['\n    width: 15px; height: 15px;\n    margin-bottom: 0px;\n    margin-right: -5px;\n    margin-left: 8px;\n    flex-shrink: 0;\n\n']),_templateObject19=_taggedTemplateLiteral(['\n    margin-left: 15px;\n    transition: transform ','s;\n    transform: translateX(','px);\n'],['\n    margin-left: 15px;\n    transition: transform ','s;\n    transform: translateX(','px);\n']),_templateObject20=_taggedTemplateLiteral(['\n    position: absolute;\n    z-index: 1000;\n    transition: transform ','; \n    @media ','{\n        transform: translate(',');\n    }\n    @media ','{\n        transform: translate(',');\n    }\n    &::after, &::before{\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n    }\n    &::after{\n        left: 1px;\n        top: -25px;\n        border: 13px solid transparent;\n        border-bottom: 12.5px white solid;\n    }\n    &::before{\n        left: 0;\n        top: -28px;\n        border: 14px solid transparent;\n        border-bottom: 13.5px var(--bordergrey) solid;\n    }\n\n'],['\n    position: absolute;\n    z-index: 1000;\n    transition: transform ','; \n    @media ','{\n        transform: translate(',');\n    }\n    @media ','{\n        transform: translate(',');\n    }\n    &::after, &::before{\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n    }\n    &::after{\n        left: 1px;\n        top: -25px;\n        border: 13px solid transparent;\n        border-bottom: 12.5px white solid;\n    }\n    &::before{\n        left: 0;\n        top: -28px;\n        border: 14px solid transparent;\n        border-bottom: 13.5px var(--bordergrey) solid;\n    }\n\n']),_templateObject21=_taggedTemplateLiteral(['\n    position: absolute;\n    /*border: 1px solid var(--bordergrey);*/\n    z-index: 3;\n    transform-origin: 0% 0%;\n    opacity: ',';\n    @media ','{\n        width: 950px;\n        height: 720px;\n        /*padding: 30px 45px;*/\n        top: 100px;\n    }\n    @media ','{\n        top: 90px;\n        width: 780px;\n        height: 575px;\n        /*padding: 20px 35px;*/\n    }\n'],['\n    position: absolute;\n    /*border: 1px solid var(--bordergrey);*/\n    z-index: 3;\n    transform-origin: 0% 0%;\n    opacity: ',';\n    @media ','{\n        width: 950px;\n        height: 720px;\n        /*padding: 30px 45px;*/\n        top: 100px;\n    }\n    @media ','{\n        top: 90px;\n        width: 780px;\n        height: 575px;\n        /*padding: 20px 35px;*/\n    }\n']),_templateObject22=_taggedTemplateLiteral(['\n    background: var(--offwhitefg);\n'],['\n    background: var(--offwhitefg);\n']),_templateObject23=_taggedTemplateLiteral(['\n    position: absolute;\n\n\n    top: 0; bottom: 0; margin: auto;\n    opacity: ',';\n    transition: transform .25s, opacity .25s;\n    transition-delay: ',';\n    width: 50px;\n    height: 95px;\n    z-index: 4;\n    display: flex; justify-content: center;\n    align-items: center;\n    background: white;\n    border: 1px solid var(--fainttext);\n    cursor: pointer;\n    background: var(--offwhitefg);\n    fill: var(--normtext);\n    &:hover{\n        fill: var(--strokepeach);\n    }\n    &::before, &::after{\n        content: \'\';\n        position: absolute;\n        height: 15px; \n        width: 3px; \n        background: var(--offwhitefg);\n    }\n    &::before{\n        top: -16px;\n    }\n    &::after{\n        bottom: -16px;\n    }\n\n'],['\n    position: absolute;\n\n\n    top: 0; bottom: 0; margin: auto;\n    opacity: ',';\n    transition: transform .25s, opacity .25s;\n    transition-delay: ',';\n    width: 50px;\n    height: 95px;\n    z-index: 4;\n    display: flex; justify-content: center;\n    align-items: center;\n    background: white;\n    border: 1px solid var(--fainttext);\n    cursor: pointer;\n    background: var(--offwhitefg);\n    fill: var(--normtext);\n    &:hover{\n        fill: var(--strokepeach);\n    }\n    &::before, &::after{\n        content: \'\';\n        position: absolute;\n        height: 15px; \n        width: 3px; \n        background: var(--offwhitefg);\n    }\n    &::before{\n        top: -16px;\n    }\n    &::after{\n        bottom: -16px;\n    }\n\n']),_templateObject24=_taggedTemplateLiteral(['\n    padding-right: 4px;\n    left: -32px;\n    transform: translateX(',');\n    &::after, &::before{\n        right: 15px;\n    }\n'],['\n    padding-right: 4px;\n    left: -32px;\n    transform: translateX(',');\n    &::after, &::before{\n        right: 15px;\n    }\n']),_templateObject25=_taggedTemplateLiteral(['\n    padding-left: 4px;\n    right: -32px;\n    transform: translateX(',');\n    &::after, &::before{\n        left: 16px;\n    }\n'],['\n    padding-left: 4px;\n    right: -32px;\n    transform: translateX(',');\n    &::after, &::before{\n        left: 16px;\n    }\n']),_templateObject26=_taggedTemplateLiteral(['\n    width: 35px;\n    height: 35px;\n'],['\n    width: 35px;\n    height: 35px;\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import semanticTitles from './assets/semanticTitles'
// import combo from '../src/utilities/trungCombo'
var Nav=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].compact);var Dropdown=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.hasValue&&!props.isOpen?500:400;},function(props){return props.isOpen?'inset 0px 0px 0px 1.5px var(--strokepeach)':'';},__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].compact,function(props){return props.hasValue&&!props.isOpen?'var(--faintpeach)':props.disabled?'var(--offwhitefg)':'white';},function(props){return props.hasValue&&props.isOpen?'var(--fainttext)':props.hasValue&&!props.isOpen||props.hovered?'var(--strokepeach)':props.disabled?'var(--fainttext)':'black';});var DropdownWorkflow=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Dropdown)(_templateObject3,function(props){return props.hasValue&&props.hovered?'var(--strokepeach)':props.hasValue&&!props.isOpen?'var(--peach)':props.isOpen||props.hovered?'var(--strokepeach)':'var(--normtext)';},function(props){return props.hovered||props.isOpen?'\n            transform: scale(0.65);    \n        ':'';},function(props){return props.hasValue&&!props.isOpen?'\n            transform: scale(0);    \n        ':'';});var IndicatorSelect=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(DropdownWorkflow)(_templateObject4,function(props){return props.offset?'translateX(-15px)':'';});var Ico=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5);var indicatorIco=__webpack_require__(169);var countyIco=__webpack_require__(170);var IndicatorIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Ico)(_templateObject6,indicatorIco,function(p){return p.hasValue&&p.hovered&&!p.isOpen?'100% 50%':p.hasValue&&!p.isOpen?'66.666% 50%':p.hovered&&!p.isOpen?'33.333% 50%':'0% 50%';});var CountyIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Ico)(_templateObject6,countyIco,function(p){return p.hasValue&&p.hovered&&!p.isOpen?'100% 50%':p.hasValue&&!p.isOpen?'66.666% 50%':p.hovered&&!p.isOpen?'33.333% 50%':'0% 50%';});var SelectionValueContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7);var SelectionValue=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject8,function(props){return props.muteAnyways?'color: var(--fainttext);':'';},function(props){return props.label;},function(props){return props.strikethrough?1:0;},function(p){return p.hasValue?'100% 50%':'0% 50%';});var CountySelect=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(DropdownWorkflow)(_templateObject9,function(props){return props.offset?'translateX(15px)':'translateX(1px)';});var countyIds=Object.keys(__WEBPACK_IMPORTED_MODULE_11__assets_countyLabels___default.a);var NoRaceTip=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject10);var ResponsiveNav=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(ResponsiveNav,_React$Component);function ResponsiveNav(){_classCallCheck(this,ResponsiveNav);var _this=_possibleConstructorReturn(this,(ResponsiveNav.__proto__||Object.getPrototypeOf(ResponsiveNav)).call(this));_initDefineProp(_this,'hoveredWorkflow',_descriptor,_this);_initDefineProp(_this,'onHoverWorkflow',_descriptor2,_this);_initDefineProp(_this,'raceDropdown',_descriptor3,_this);_initDefineProp(_this,'setRaceDropdown',_descriptor4,_this);_this.handleClickOutside=function(e){// if(this.props.open && this.nav.current){
if(!_this.nav.current.contains(e.target)&&!countyIds.includes(e.target.id)){console.log('clicked something outside the nav:',e.target);_this.props.openNav();if(_this.props.store.indicatorSearchString)_this.props.store.modifySearchString('indicator','');if(_this.props.store.countySearchString)_this.props.store.modifySearchString('county','');}// }
};_this.nav=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.dropdown=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ResponsiveNav,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillUpdate',value:function componentWillUpdate(){if(this.props.open){document.addEventListener('click',this.handleClickOutside);}else if(!this.props.open){document.removeEventListener('click',this.handleClickOutside);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,openNav=_props.openNav,open=_props.open,store=_props.store,closeInit=_props.closeInit,init=_props.init;var indicator=store.indicator,county=store.county,year=store.year,race=store.race;var ind=__WEBPACK_IMPORTED_MODULE_9__data_indicators__["a" /* default */][indicator];var noRace=indicator&&!ind.categories.includes('hasRace');var noall=indicator&&county&&!Object(__WEBPACK_IMPORTED_MODULE_16__utilities_isValid__["a" /* isValid */])(ind.counties[county].totals[year]);//rare case [i.e. glenn health insurance]
var noazn=!noRace&&indicator&&county&&(ind.counties[county].asian[year]===''||ind.counties[county].asian[year]==='*');var noblk=!noRace&&indicator&&county&&(ind.counties[county].black[year]===''||ind.counties[county].black[year]==='*');var noltx=!noRace&&indicator&&county&&(ind.counties[county].latinx[year]===''||ind.counties[county].latinx[year]==='*');var nowht=!noRace&&indicator&&county&&(ind.counties[county].white[year]===''||ind.counties[county].white[year]==='*');var nooth=!noRace&&indicator&&county&&(ind.counties[county].other[year]===''||ind.counties[county].other[year]==='*');var screen=Object(__WEBPACK_IMPORTED_MODULE_15__utilities_media__["b" /* getMedia */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Nav,{ref:this.nav},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorSelect,{onClick:open!=='indicator'?function(){return openNav('indicator');}:function(e){openNav();// e.stopPropagation()
},hovered:this.hoveredWorkflow==='indicator'&&this.props.open!=='indicator',hasValue:!init?indicator:'',isOpen:open==='indicator'&&!this.raceDropdown,onMouseEnter:function onMouseEnter(){_this2.onHoverWorkflow('indicator');},onMouseLeave:function onMouseLeave(){_this2.onHoverWorkflow(null);}// offset = {open==='county'}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorIcon,{hovered:this.hoveredWorkflow==='indicator',hasValue:!init?indicator:'',isOpen:open==='indicator'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectionValue,null,!init&&store.indicator?__WEBPACK_IMPORTED_MODULE_9__data_indicators__["a" /* default */][store.indicator].semantics.shorthand:'Indicator')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountySelect// disabled = {!indicator}
,{onClick:open!=='county'?function(){return openNav('county');}:function(){openNav();},hovered:this.hoveredWorkflow==='county'&&open!=='county',hasValue:county,isOpen:open==='county'&&!this.raceDropdown,onMouseEnter:function onMouseEnter(){_this2.onHoverWorkflow('county');},onMouseLeave:function onMouseLeave(){_this2.onHoverWorkflow(null);},offset:open},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountyIcon,{hovered:this.hoveredWorkflow==='county',hasValue:county,isOpen:open==='county'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectionValueContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectionValue,{hasValue:county,muteAnyways:!county&&open==='county',label:store.county?__WEBPACK_IMPORTED_MODULE_11__assets_countyLabels___default.a[store.county]:'California',strikethrough:county&&this.hoveredWorkflow==='countyStrikeout'},store.county?__WEBPACK_IMPORTED_MODULE_11__assets_countyLabels___default.a[store.county]:init||open?'County':'California'),county&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuickClear,{img:'x',color:'peach',hoverColor:'strokepeach',onMouseEnter:function onMouseEnter(){_this2.onHoverWorkflow('countyStrikeout');},onMouseLeave:function onMouseLeave(){_this2.onHoverWorkflow('county');},onClick:county?function(e){store.completeWorkflow('county',null);e.stopPropagation();// e.nativeEvent.stopImmediatePropagation()
}:function(){}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RaceDropdownToggle// dropdownOpen = {this.raceDropdown}
,{setDropdownState:this.setRaceDropdown,offset:open,selected:race,defaultWidth:140,disabled:!store.init&&noRace,openOther:store.init?function(){openNav('indicator');}:false,toggleMode:open&&!noRace&&screen==='optimal',options:[{label:init&&!this.raceDropdown?'Race':'All races',value:'',disabled:noall},{label:'Asian',value:'asian',disabled:noazn},{label:'Black',value:'black',disabled:noblk},{label:'Latinx',value:'latinx',disabled:noltx},{label:'White',value:'white',disabled:nowht},{label:'Other',value:'other',disabled:nooth}],select:function select(val){var valid=store.completeWorkflow('race',val);if(valid)return true;else return false;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearToggle,{init:init,store:store,offset:open&&noRace?1:open?2:0,onClick:function onClick(value){return store.completeWorkflow('year',value);},selected:store.year,bigscreen:screen==='optimal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickingWorkflow,{muted:this.raceDropdown,x:function x(){return openNav(false);},store:store,open:open?true:false,which:open,close:function close(){return openNav(false);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Reset,{className:'negativeOnDark',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BtnLabel,null,'Reset',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResetIcon,null)),visible:!init&&indicator,onClick:this.props.reset}));}}]);return ResponsiveNav;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'hoveredWorkflow',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'onHoverWorkflow',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(which){return _this3.hoveredWorkflow=which;};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'raceDropdown',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'setRaceDropdown',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(tf){_this4.raceDropdown=tf;};}})),_class2))||_class;var BtnLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject11);var ResetIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].figure(_templateObject12,__WEBPACK_IMPORTED_MODULE_19__assets_reset_svg___default.a);var RaceDropdownToggle=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_7__components_generic__["b" /* DropdownToggle */])(_templateObject13,function(props){return props.offset?30:3;});var Reset=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_7__components_generic__["a" /* Button */])(_templateObject14,function(props){return props.visible?'auto':'none';},function(props){return props.visible?1:0;},function(props){return props.visible?0:50;});var ForcedUnselectTip=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject15);var ShareIco=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject16);var X=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_8__components_generic_Icon__["b" /* default */])(_templateObject17);var QuickClear=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_8__components_generic_Icon__["b" /* default */])(_templateObject18);var YearToggle=function YearToggle(props){var init=props.init;var _props$store=props.store,indicator=_props$store.indicator,county=_props$store.county,race=_props$store.race;var years=!init&&indicator?__WEBPACK_IMPORTED_MODULE_9__data_indicators__["a" /* default */][indicator].years.map(function(yr,i){var val=__WEBPACK_IMPORTED_MODULE_9__data_indicators__["a" /* default */][indicator].counties[county||'california'][race||'totals'][i];var disabled=val!==0&&(!val||val==='*');return{label:yr,value:i,disabled:disabled};}):false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YrToggle,{offset:props.offset,hide:!years,bigscreen:props.bigscreen},years&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_generic__["d" /* Toggle */],{size:'big',theme:'negativeNoStroke',options:years,onClick:props.onClick,selected:Number(props.selected)}));};var YrToggle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject19,function(props){return props.bigscreen?.65:.25;},function(props){return props.offset===2&&props.bigscreen?468:props.offset===2&&!props.bigscreen||props.offset===1?25:0;});var Triangle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject20,function(props){return props.speed;},__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].optimal,function(props){return props.hide?'0, 2px':props.active==='indicator'?'35px, 2px':'440px, 2px';},__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].compact,function(props){return props.hide?'0, 2px':props.active==='indicator'?'40px, 2px':'450px, 2px';});var PickingWorkflow=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class4=(_class5=function(_React$Component2){_inherits(PickingWorkflow,_React$Component2);function PickingWorkflow(){var _ref;var _temp,_this5,_ret;_classCallCheck(this,PickingWorkflow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this5=_possibleConstructorReturn(this,(_ref=PickingWorkflow.__proto__||Object.getPrototypeOf(PickingWorkflow)).call.apply(_ref,[this].concat(args))),_this5),_initDefineProp(_this5,'pageAnimDirection',_descriptor5,_this5),_initDefineProp(_this5,'hoveredPageBtn',_descriptor6,_this5),_initDefineProp(_this5,'animationType',_descriptor7,_this5),_initDefineProp(_this5,'setSearchFocus',_descriptor8,_this5),_initDefineProp(_this5,'indicatorSearchFocus',_descriptor9,_this5),_initDefineProp(_this5,'countySearchFocus',_descriptor10,_this5),_this5.exit=function(){var store=_this5.props.store;if(store.indicatorSearchString)store.modifySearchString('indicator','');_this5.props.x();},_this5.keyHandler=function(e){var store=_this5.props.store;console.log(e.which);if(e.key==='Escape'||e.key==='Esc'){_this5.exit();}else if(e.key==='ArrowLeft'){var indicatorListPage=_this5.props.store.indicatorListPage;_this5.handlePageChange(null,indicatorListPage-1);}else if(e.key==='ArrowRight'){var _indicatorListPage=_this5.props.store.indicatorListPage;_this5.handlePageChange(null,_indicatorListPage+1);}else if(e.which>=65&&e.which<=90){//user typed letter
//searching indicator or county?
if(_this5.props.which==='indicator'&&!_this5.indicatorSearchFocus){//searchinput is not already focused: enter key and focus
if(!store.indicatorSearchString){store.modifySearchString('indicator',e.key);_this5.setSearchFocus('indicator',true);}}else if(_this5.props.which==='county'&&!_this5.countySearchFocus){if(!store.countySearchString){store.modifySearchString('county',e.key);_this5.setSearchFocus('county',true);}}}},_initDefineProp(_this5,'handlePageChange',_descriptor11,_this5),_initDefineProp(_this5,'onHoverPageBtn',_descriptor12,_this5),_initDefineProp(_this5,'display',_descriptor13,_this5),_initDefineProp(_this5,'setDisplay',_descriptor14,_this5),_initDefineProp(_this5,'lastListShown',_descriptor15,_this5),_initDefineProp(_this5,'setLastList',_descriptor16,_this5),_initDefineProp(_this5,'setAnimationMode',_descriptor17,_this5),_temp),_possibleConstructorReturn(_this5,_ret);}//mount or change
_createClass(PickingWorkflow,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){if(oldProps.which!==this.props.which){if(oldProps.which==='indicator'&&this.props.store.indicatorSearchString){this.props.store.modifySearchString('indicator','');}else if(oldProps.which==='county'&&this.props.store.countySearchString){this.props.store.modifySearchString('county','');}if(this.props.which)this.setLastList(this.props.which);}}},{key:'componentWillUpdate',value:function componentWillUpdate(newProps){if(this.props.open!==newProps.open){this.setAnimationMode('mount');console.log('setting mount/unmount animation, last list shown is',this.lastListShown);console.log(this.animationType);if(newProps.open){console.log('setting keyhandler');window.onkeyup=this.keyHandler;}else{window.onkeyup=function(){};}}else if(this.props.which!==newProps.which){this.setAnimationMode('change');}}},{key:'render',value:function render(){var _this6=this;var _props2=this.props,store=_props2.store,close=_props2.close,which=_props2.which,open=_props2.open;var indicatorListPage=store.indicatorListPage,setIndicatorListPage=store.setIndicatorListPage,indicatorPages=store.indicatorPages,screen=store.screen;var showInd=which==='indicator'||!open&&this.lastListShown==='indicator';var showCounty=which==='county'||!open&&this.lastListShown==='county';var modeSizes=screen==='optimal'?{closed:{width:95,height:72},open:{width:950,height:750}}:screen==='compact'?{closed:{width:78,height:57},open:{width:780,height:575}}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LargeWorkflow,{style:{opacity:open?1:0,transition:'opacity .3s',transitionDelay:open?'0s':'0.1s',pointerEvents:open?'auto':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(X,{img:'x_thin',color:'bordergrey',hoverColor:'strokepeach',onClick:this.exit}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Lists,{currentMode:open?'open':'closed',modes:modeSizes// duration = {.375}
,delay:open?'.125s':'0s',duration:.35},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_flip_move__["a" /* default */]// typeName = {null}
,{style:{position:'absolute',top:0,left:0,padding:screen==='optimal'?'35px 50px':'25px 35px',overflow:'hidden',width:modeSizes.open.width+'px',height:modeSizes.open.height+'px'},disableAllAnimations:this.animationType==='mount',enterAnimation:{from:{opacity:0,transform:'translateX('+(which==='indicator'?-150:150)+'px)'},to:{opacity:1,transform:'translateX(0px)'}},leaveAnimation:{from:{opacity:1,transform:'translateX(0px)'},to:{opacity:-1,transform:'translateX('+(which==='indicator'?150:-150)+'px)'}},maintainContainerHeight:true},showInd&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_IndicatorList__["a" /* default */],{muted:this.props.muted,store:store,closeNav:this.props.close,setNumPages:this.setNumPages,page:this.page,animDir:this.pageAnimDirection,prevOffset:this.hoveredPageBtn,searchString:store.indicatorSearchString,focusInput:this.indicatorSearchFocus,setSearchFocus:function setSearchFocus(tf){return _this6.setSearchFocus('indicator',tf);},onSearch:function onSearch(val){store.modifySearchString('indicator',val);}}),showCounty&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_CountyList__["a" /* default */],{muted:this.props.muted,store:store,closeNav:this.props.close// searchResults = {store.}
,searchString:store.countySearchString,focusInput:this.countySearchFocus,setSearchFocus:function setSearchFocus(tf){return _this6.setSearchFocus('county',tf);},onSearch:function onSearch(val){store.modifySearchString('county',val);}// muted = {this.props.muted}
}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PageNext,{show:which==='indicator'&&indicatorListPage<indicatorPages.length-1&&!store.sanityCheck.indicator,delay:this.animationType==='mount'&&open?'.5s':'0s',onClick:function onClick(e){_this6.setAnimationMode('page');_this6.handlePageChange(e,indicatorListPage+1);},onMouseEnter:function onMouseEnter(){_this6.onHoverPageBtn('next');},onMouseLeave:function onMouseLeave(){_this6.onHoverPageBtn(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChevIcon,{img:'chevright_thin',color:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PagePrev,{show:which==='indicator'&&indicatorListPage>0&&!store.sanityCheck.indicator,delay:this.animationType==='mount'&&open?'.5s':'0s',onClick:function onClick(e){_this6.setAnimationMode('page');_this6.handlePageChange(e,indicatorListPage-1);},onMouseEnter:function onMouseEnter(){_this6.onHoverPageBtn('prev');},onMouseLeave:function onMouseLeave(){_this6.onHoverPageBtn(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChevIcon,{img:'chevleft_thin',color:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Triangle,{hide:!open,active:which,speed:this.animationType==='mount'&&which==='county'?'0s':'.25s'}));}}]);return PickingWorkflow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor5=_applyDecoratedDescriptor(_class5.prototype,'pageAnimDirection',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'left';}}),_descriptor6=_applyDecoratedDescriptor(_class5.prototype,'hoveredPageBtn',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class5.prototype,'animationType',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'mount';}}),_descriptor8=_applyDecoratedDescriptor(_class5.prototype,'setSearchFocus',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(which,tf){console.log('nav set search focus');if(!tf)window.onkeyup=_this7.keyHandler;_this7[which+'SearchFocus']=tf;};}}),_descriptor9=_applyDecoratedDescriptor(_class5.prototype,'indicatorSearchFocus',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor10=_applyDecoratedDescriptor(_class5.prototype,'countySearchFocus',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class5.prototype,'handlePageChange',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(evt,goTo){var store=_this8.props.store;if(goTo>store.indicatorListPage)_this8.pageAnimDirection='left';else if(goTo<store.indicatorListPage)_this8.pageAnimDirection='right';if(goTo===-1||goTo>store.indicatorPages.length-1)return;else store.setIndicatorListPage(goTo);// evt.preventDefault()
// evt.stopPropagation()   
};}}),_descriptor12=_applyDecoratedDescriptor(_class5.prototype,'onHoverPageBtn',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(val){return _this9.hoveredPageBtn=val;};}}),_descriptor13=_applyDecoratedDescriptor(_class5.prototype,'display',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor14=_applyDecoratedDescriptor(_class5.prototype,'setDisplay',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this10=this;return function(tf){console.log('seting display to ',tf);_this10.display=tf;};}}),_descriptor15=_applyDecoratedDescriptor(_class5.prototype,'lastListShown',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor16=_applyDecoratedDescriptor(_class5.prototype,'setLastList',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this11=this;return function(list){return _this11.lastListShown=list;};}}),_descriptor17=_applyDecoratedDescriptor(_class5.prototype,'setAnimationMode',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this12=this;return function(mode){return _this12.animationType=mode;};}})),_class5))||_class4;var LargeWorkflow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject21,function(props){return props.muted?0.5:1;},__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_15__utilities_media__["a" /* default */].compact);var Lists=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_14__components_ExpandBox__["a" /* default */])(_templateObject22);var PageBtn=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject23,function(props){return props.show?1:0;},function(props){return props.delay;});var PagePrev=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(PageBtn)(_templateObject24,function(props){return props.show?0:'15px';});var PageNext=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(PageBtn)(_templateObject25,function(props){return props.show?0:'-15px';});var ChevIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_8__components_generic_Icon__["b" /* default */])(_templateObject26);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function makeHash(){var text="";var possible="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(var i=0;i<5;i++){text+=possible.charAt(Math.floor(Math.random()*possible.length));}return text;}/* harmony default export */ __webpack_exports__["a"] = (makeHash);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search.6e96e2cb.svg";

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/peach-x.5edcecac.svg";

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var sprites={chevsprite:{paths:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"17.6,22.8 5.4,10.6 5.4,11 5.4,13.2 17.6,25.4 30.6,13.1 30.6,10.6 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"269.6,13.2 257.4,25.4 257.4,25 257.4,22.8 269.6,10.6 282.6,22.9 282.6,25.4 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"53.6,22 41.4,11.4 41.4,11.9 41.4,14.1 53.6,24.6 66.6,14 66.6,11.4 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"233.6,14 221.4,24.6 221.4,24.1 221.4,21.9 233.6,11.4 246.6,22 246.6,24.6 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"89.6,20.7 77.4,12.7 77.4,13.2 77.4,15.4 89.6,23.3 102.6,15.3 102.6,12.7 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"197.6,15.3 185.4,23.3 185.4,22.8 185.4,20.6 197.6,12.7 210.6,20.7 210.6,23.3 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"125.6,18.7 113.4,14.7 113.4,15.1 113.4,17.4 125.6,21.3 138.6,17.3 138.6,14.7 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"161.6,17.3 149.4,21.3 149.4,20.9 149.4,18.6 161.6,14.7 174.6,18.7 174.6,21.3 "})),viewBox:'0 0 288 36',frames:8},caretx:{paths:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M13.9,6.4L9,11.3L4.1,6.4H13.9 M16,5.5H2l7,7L16,5.5L16,5.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"22.5,5.5 23.6,6.5 31.6,6.5 27,11.1 21.3,5.5 20,5.5 27,12.5 34,5.5 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"106.6,2.4 104.6,2.4 99,7.9 93.5,2.5 93.4,2.4 91.4,2.4 98,9 91.4,15.6 93.4,15.6 99,10.1 104.6,15.6 106.6,15.6  100,9 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"88.5,3.2 83.4,3.2 82.6,4.6 85.1,4.6 81,8.7 75.4,3.2 73.5,3.2 80,9.6 75.1,14.6 76.7,14.9 81,10.6 85.3,14.9  87,14.6 82,9.6 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"70.3,4 62.3,4 62.6,5.3 67.3,5.3 63,9.6 57.4,4.1 57.4,4 55.7,4 62.1,10.5 59,13.6 58.9,13.7 60,14.3 63,11.3  66,14.3 66.1,14.3 67.3,13.8 63.9,10.4 "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"52.1,4.7 42.2,4.7 42.9,5.8 49.5,5.8 45,10.3 39.4,4.7 39.3,4.7 37.9,4.7 44.2,11.1 43,12.3 42.9,12.4 43.7,13.2  45,11.8 46.4,13.1 47.1,12.4 47.1,12.3 45.8,11 52,4.8 "})),viewBox:'0 0 108 18',frames:6},ind:{paths:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"6",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M11.5,8.8v3.5h14.4V8.8H11.5z M24.9,11.3H12.5V9.8h12.4V11.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20,25.1v1.5h-7.5v-1.5H20 M21,24.1h-9.5v3.5H21V24.1L21,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M29.5,17.4v1.5h-17v-1.5H29.5 M30.5,16.4h-19v3.5h19V16.4L30.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"42",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M47.5,8.8v3.5h14.4V8.8H47.5z M60.9,11.3h-8.2V9.8h8.2V11.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M56,25.1v1.5h-7.5v-1.5H56 M57,24.1h-9.5v3.5H57V24.1L57,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M65.5,17.4v1.5H50.9v-1.5H65.5 M66.5,16.4h-19v3.5h19V16.4L66.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"78",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M83.5,8.8v3.5h14.4V8.8H83.5z M96.9,11.3h-4.7V9.8h4.7V11.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M92,25.1v1.5h-6.7v-1.5H92 M93,24.1h-9.5v3.5H93V24.1L93,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M101.5,17.4v1.5H90v-1.5H101.5 M102.5,16.4h-19v3.5h19V16.4L102.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"114",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M119.5,8.8v3.5h14.4V8.8H119.5z M132.9,11.3h-2.1V9.8h2.1V11.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M128,25.1v1.5h-5.5v-1.5H128 M129,24.1h-9.5v3.5h9.5V24.1L129,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M137.5,17.4v1.5H128v-1.5H137.5 M138.5,16.4h-19v3.5h19V16.4L138.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"150",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M155.5,8.8v3.5h14.4V8.8H155.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M164,25.1v1.5h-4.7v-1.5H164 M165,24.1h-9.5v3.5h9.5V24.1L165,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M173.5,17.4v1.5h-7.2v-1.5H173.5 M174.5,16.4h-19v3.5h19V16.4L174.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"186",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M191.5,8.8v3.5h14.4V8.8H191.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M200,25.1v1.5h-3.8v-1.5H200 M201,24.1h-9.5v3.5h9.5V24.1L201,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M209.5,17.4v1.5h-2.9v-1.5H209.5 M210.5,16.4h-19v3.5h19V16.4L210.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"222",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M227.5,8.8v3.5h14.4V8.8H227.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M236,25.1v1.5h-2.3v-1.5H236 M237,24.1h-9.5v3.5h9.5V24.1L237,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M245.5,17.4v1.5H244v-1.5H245.5 M246.5,16.4h-19v3.5h19V16.4L246.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"258",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M263.5,8.8v3.5h14.4V8.8H263.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M272,25.1v1.5h-0.9v-1.5H272 M273,24.1h-9.5v3.5h9.5V24.1L273,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M282.5,16.4h-19v3.5h19V16.4L282.5,16.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"294",y:"7.3",width:"2",height:"21.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M299.5,8.8v3.5h14.4V8.8H299.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M309,24.1h-9.5v3.5h9.5V24.1L309,24.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M318.5,16.4h-19v3.5h19V16.4L318.5,16.4z"})),viewBox:'0 0 324 36',frames:9},county:{paths:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S17.1,12.5,16,12.5z M16,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1 s1-0.5,1-1S16.5,9.5,16,9.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16,20.8l-0.4-0.5C15.4,20,10,13.6,10,10.5c0-3.3,2.7-6,6-6s6,2.7,6,6c0,3.1-5.4,9.6-5.6,9.8L16,20.8z M16,5.5 c-2.8,0-5,2.2-5,5c0,2.1,3.3,6.6,5,8.7c1.7-2.1,5-6.6,5-8.7C21,7.7,18.8,5.5,16,5.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"23.6,19 20.3,19 19.5,20 23.2,20 27.4,25 4.6,25 8.6,20 12.7,20 11.9,19 8.2,19 2.5,26 29.5,26    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"55.6,19 52.3,19 51.5,20 55.2,20 59.4,25 36.6,25 40.6,20 44.7,20 43.9,19 40.2,19 34.5,26 61.5,26     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"87.6,19 84.3,19 83.5,20 87.2,20 91.4,25 68.6,25 72.6,20 76.7,20 75.9,19 72.2,19 66.5,26 93.5,26     "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"119.6,19 116.3,19 115.5,20 119.2,20 123.4,25 100.6,25 104.6,20 108.7,20 107.9,19 104.2,19 98.5,26  125.5,26    "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"151.6,19 148.3,19 147.5,20 151.2,20 155.4,25 132.6,25 136.6,20 140.7,20 139.9,19 136.2,19  130.5,26 157.5,26   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"183.6,19 180.3,19 179.5,20 183.2,20 187.4,25 164.6,25 168.6,20 172.7,20 171.9,19 168.2,19  162.5,26 189.5,26   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"215.6,19 212.3,19 211.5,20 215.2,20 219.4,25 196.6,25 200.6,20 204.7,20 203.9,19 200.2,19  194.5,26 221.5,26   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"247.6,19 244.3,19 243.5,20 247.2,20 251.4,25 228.6,25 232.6,20 236.7,20 235.9,19 232.2,19  226.5,26 253.5,26   "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M48,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S49.1,12.5,48,12.5z M48,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1 s1-0.5,1-1S48.5,9.5,48,9.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M48,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8 C54,7.2,51.3,4.5,48,4.5z M48,5.5c2.8,0,5,2.2,5,5c0,1.6-2,4.7-3.6,7h-2.7c-1.7-2.3-3.7-5.4-3.7-7C43,7.7,45.2,5.5,48,5.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M80,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S81.1,12.5,80,12.5z M80,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1 s1-0.5,1-1S80.5,9.5,80,9.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M80,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8 C86,7.2,83.3,4.5,80,4.5z M80,5.5c2.8,0,5,2.2,5,5c0,1.1-0.9,2.9-2,4.6h-6c-1.1-1.7-2-3.5-2-4.6C75,7.7,77.2,5.5,80,5.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M112,12.5c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S113.1,12.5,112,12.5z M112,9.5c-0.5,0-1,0.5-1,1s0.5,1,1,1 s1-0.5,1-1S112.5,9.5,112,9.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M112,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8 C118,7.2,115.3,4.5,112,4.5z M112,5.5c2.8,0,5,2.2,5,5c0,0.7-0.3,1.5-0.8,2.5h-8.4c-0.5-1-0.8-1.8-0.8-2.5 C107,7.7,109.2,5.5,112,5.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M176,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8 C182,7.2,179.3,4.5,176,4.5z M176,5.5c1.9,0,3.5,1.1,4.4,2.7h-8.8C172.5,6.6,174.1,5.5,176,5.5z M176,11.6c-0.6,0-1.2-0.6-1.2-1.2 s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S176.6,11.6,176,11.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M208,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8 C214,7.2,211.3,4.5,208,4.5z M211.3,6.8h-6.7c0.9-0.8,2.1-1.3,3.3-1.3S210.5,6,211.3,6.8z M208,12.2c-0.9,0-1.7-0.8-1.7-1.7 s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S208.9,12.2,208,12.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M240,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8 C246,7.2,243.3,4.5,240,4.5z M240,12.5c-1,0-2-1-2-2s1-2,2-2s2,1,2,2S241,12.5,240,12.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M144,4.5c-3.3,0-6,2.7-6,6c0,3.1,5.4,9.6,5.6,9.8l0.4,0.5l0.4-0.5c0.2-0.3,5.6-6.7,5.6-9.8 C150,7.2,147.3,4.5,144,4.5z M144,11.4c-0.5,0-1-0.5-1-1s0.5-1,1-1s1,0.5,1,1S144.5,11.4,144,11.4z M144,8.4c-1.1,0-2,0.9-2,2h-3 c0.1-2.7,2.3-4.9,5-4.9s4.9,2.2,5,4.9h-3C146,9.3,145.1,8.4,144,8.4z"})),viewBox:'0 0 256 32',frames:8},book:{paths:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16,8.3c-1.1-1.1-4.6-3.4-13.5-3.4H2v15h0.5c10.6-0.1,13,3.4,13.1,3.5L16,24l0.5-0.7c0,0,2.5-3.6,13.1-3.6H30 V4.9h-0.5C20.6,4.9,17.1,7.2,16,8.3z M15.5,21.7c-1.5-1.2-5-3-12.4-3V5.9C12.2,6,15,8.7,15.5,9.3V21.7z M29,18.7 c-7.4,0.1-10.9,1.9-12.4,3.1V9.3C17,8.7,19.8,6,29,5.9V18.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M47.6,23.3l0.4,0.6l0.5-0.5c0,0,4.4-5,11.3-6.1l0.4-0.1V2.3l-0.6,0.1C52.4,3.7,49.1,7,48,8.3 c-1.1-1.1-4.6-3.4-13.5-3.4H34v15h0.5C45.1,19.7,47.5,23.3,47.6,23.3z M48.5,9.3C49.1,8.6,52,5,59.1,3.5v12.7 c-5.2,1-8.9,3.9-10.5,5.5L48.5,9.3L48.5,9.3z M48.1,22.1L48,22.2l-0.1-0.1H48.1z M35,5.9C44.1,6,47,8.7,47.5,9.3v12.5 c-1.5-1.2-5-3-12.4-3L35,5.9L35,5.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M79.6,23.3l0.5,0.9l0.4-0.9c0,0,2.1-4.9,9-6.7l0.4-0.1v-15l-0.7,0.2c-5.8,1.6-8.5,5.1-9.4,6.6 C78.7,7.2,75.1,5,66.5,5H66v15h0.5C77,19.7,79.5,23.2,79.6,23.3z M80.5,9.3c0.3-0.6,2.5-4.6,8.3-6.4v12.7c-4.6,1.3-7.1,3.8-8.3,5.5 V9.3z M67,18.9V6c9.1,0.1,12,2.8,12.4,3.4v12.4c-1.5-1.1-4.9-2.9-12.1-2.9C67.2,18.9,67.1,18.9,67,18.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M61,18.7c-0.4,0-3.6,0.4-6.7,1.7c2.1-0.5,4.5-0.7,7.2-0.7H62V4.9h-1V18.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M336,8.3c-1.1-1.3-4.5-4.6-11.5-5.9l-0.6-0.1v14.9l0.4,0.1c6.9,1.2,11.2,6.1,11.3,6.1l0.5,0.5l0.4-0.6 c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C340.7,4.9,337.2,7.2,336,8.3z M335.5,21.7c-1.6-1.5-5.3-4.5-10.5-5.5V3.5c7,1.5,10,5,10.5,5.7 V21.7z M336,22.2l-0.1-0.1h0.2L336,22.2z M349,18.8c-7.4,0-10.9,1.8-12.4,3V9.3C337.1,8.7,340,6,349,5.9V18.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M323,18.7V4.9h-1v14.8h0.5c2.7,0,5.1,0.2,7.2,0.7C326.6,19.1,323.4,18.7,323,18.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M91.5,5v1c0.1,0,0.8-0.1,1.5-0.1v12.7c-7.4,0.4-9.7,2.7-9.7,2.7c2-0.9,5.2-1.7,10.3-1.7H94V4.9h-0.5 C92.6,4.9,91.8,4.9,91.5,5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M304.1,8.3c-0.9-1.5-3.5-5-9.4-6.6L294,1.5v14.9l0.4,0.1c6.9,1.8,9,6.6,9,6.7l0.4,0.9l0.5-0.8 c0,0,2.5-3.5,13-3.4h0.5V5h-0.5C308.9,5,305.3,7.2,304.1,8.3z M303.5,21.1c-1.2-1.7-3.8-4.2-8.3-5.5V2.9c5.8,1.9,8,5.8,8.3,6.4V21.1 z M317,18.9c-0.1,0-0.2,0-0.3,0c-7.2,0-10.7,1.7-12.1,2.9V9.4c0.5-0.6,3.3-3.3,12.4-3.4V18.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M291,18.6V5.9c0.7,0,1.4,0.1,1.5,0.1V5c-0.3-0.1-1.1-0.1-2-0.1H290v14.7h0.4c5.1,0,8.3,0.8,10.3,1.7 C300.7,21.3,298.4,19,291,18.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M111.6,23.3l0.6,1l0.3-1.1c0-0.1,1.7-5.2,6.5-7.1l0.3-0.1V1l-0.7,0.3c-4.1,1.8-6,5.3-6.8,6.8 C110.5,7,107,4.9,98.5,4.9H98v15h0.5C109,19.7,111.5,23.2,111.6,23.3z M112.5,9.2c0.2-0.6,1.8-4.4,5.7-6.5v12.6 c-3,1.3-4.7,3.6-5.7,5.3V9.2z M99,5.9c9.2,0.1,12,2.8,12.4,3.4v12.5c-1.5-1.2-5-3-12.4-3V5.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M143.6,23.3l0.6,1l0.3-1.2c0,0,1.3-4.7,4.1-6.9l0.2-0.2V0.9L148,1.6c-2.4,2-3.7,5-4.2,6.5 c-1.3-1.1-4.9-3.2-13.3-3.2H130v15h0.5C141,19.7,143.5,23.2,143.6,23.3z M144.5,9.2c0.1-0.5,1.1-3.6,3.2-5.9v12.3 c-1.5,1.3-2.5,3.1-3.2,4.6V9.2z M131,5.9c9.2,0.1,12,2.8,12.4,3.4v12.5c-1.5-1.2-5-3-12.4-3V5.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M150.2,5.6v1.1c1.7-0.4,3.9-0.7,6.7-0.7v12.7c-4.6,0.1-7.7,0.8-9.7,1.6c-0.3,0.4-0.6,0.9-0.8,1.5 c1.8-1,5.2-2,11.1-2h0.5V4.9h-0.5C154.5,4.9,152.1,5.2,150.2,5.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M240.2,8.1c-0.5-1.5-1.8-4.5-4.2-6.5l-0.9-0.7v15.2l0.2,0.2c2.8,2.3,4.1,6.9,4.1,6.9l0.3,1.1l0.6-1 c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C245.1,4.9,241.6,7,240.2,8.1z M239.5,20.1c-0.7-1.5-1.7-3.3-3.2-4.6V3.2 c2.1,2.3,3.1,5.5,3.2,5.9V20.1z M253,18.8c-7.4,0-10.9,1.8-12.4,3V9.3c0.5-0.6,3.3-3.3,12.4-3.4V18.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M236.8,20.3c-2-0.8-5.1-1.5-9.7-1.6V6c2.8,0,5,0.3,6.7,0.7V5.6c-1.9-0.4-4.3-0.7-7.3-0.7H226v14.9h0.5 c5.9,0,9.3,1,11.1,2C237.4,21.2,237.1,20.7,236.8,20.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M175.6,23.3l0.6,0.9l2.8-7.8v-17l-3.1,8.7c-1.3-1.1-4.9-3.2-13.3-3.2h-0.5v15h0.5 C173,19.7,175.5,23.2,175.6,23.3z M176.5,9.2l1.3-3.7v10.7l-1.3,3.8V9.2z M163,5.9c9.2,0.1,12,2.8,12.4,3.4v12.5 c-1.5-1.2-5-3-12.4-3V5.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M124.7,4.9c-1.3,0-2.5,0.1-3.6,0.2v1.1c0.8-0.1,1.6-0.2,2.5-0.2c0.1,0,0.4,0,0.7-0.1c0.2,0,0.5,0,0.7,0v10.9 v1.9c-7.4,0.4-9.7,2.7-9.7,2.7c2-0.9,5.2-1.7,10.3-1.7h0.5v-2.9V4.9h-0.5C125.3,4.9,125,4.9,124.7,4.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M272.2,8.1c-0.7-1.5-2.7-5-6.8-6.8L264.7,1v15l0.3,0.1c4.8,1.9,6.5,7,6.5,7.1l0.3,1l0.6-0.9 c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C277,4.9,273.5,7,272.2,8.1z M271.5,20.6c-1-1.7-2.8-4.1-5.7-5.3V2.7c3.9,2.1,5.5,6,5.7,6.5V20.6 z M285,18.8c-7.5,0-11,1.8-12.4,3V9.3c0.5-0.6,3.3-3.3,12.4-3.4V18.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M259,18.7v-1.9V5.9c0.2,0,0.5,0,0.7,0C260,6,260.3,6,260.4,6c0.9,0,1.7,0.1,2.5,0.2V5.1 c-1.1-0.1-2.3-0.2-3.6-0.2c-0.3,0-0.6,0-0.9,0h-0.5v11.9v2.9h0.5c5.1,0,8.3,0.8,10.3,1.7C268.7,21.4,266.4,19.1,259,18.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M180.6,6v1.1c1.9-0.6,4.6-1.1,8.3-1.1v12.7c-4.6,0.1-7.7,0.8-9.7,1.6l-0.6,1.5c2-0.9,5.7-2,10.8-2h0.5V4.9h-0.5 C185.6,4.9,182.7,5.4,180.6,6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M208.2,8.1l-3.1-8.7v16.8l2.8,7.9l0.6-0.9c0,0,2.5-3.5,13.1-3.5h0.5v-15h-0.5C213.1,4.9,209.5,7,208.2,8.1z M207.5,19.9l-1.3-3.8V5.5l1.3,3.7V19.9z M221,18.8c-7.4,0-11,1.8-12.4,3V9.3c0.5-0.6,3.3-3.3,12.4-3.4V18.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M204.8,20.3c-2-0.8-5.1-1.5-9.7-1.6V6c3.7,0,6.4,0.5,8.3,1.1V6c-2.1-0.6-4.9-1.1-8.8-1.1h-0.5v14.9h0.5 c5.1,0,8.9,1.2,10.8,2L204.8,20.3z"})),viewBox:'0 0 352 32',frames:11},underbook:{paths:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M77.7,27.6c0,0.3,0.1,0.5,0.1,0.8H82c0.1-0.2,0.1-0.5,0.1-0.8c0-0.3-0.1-0.6-0.2-0.8v0.1h-4v-0.3 C77.8,26.8,77.7,27.2,77.7,27.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M114.7,27.6c0-0.7-0.3-1.4-0.7-1.9v1.1h-4v-1.2c-0.5,0.5-0.9,1.2-0.9,2c0,0.3,0.1,0.5,0.1,0.8h5.4 C114.7,28.1,114.7,27.9,114.7,27.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M147.6,28.4v-1.6l1.2-0.2c-0.1-0.5-0.3-1-0.6-1.5l-2.1,0.4v1.4h-4v-1.4l-2.1-0.4c-0.3,0.4-0.5,0.9-0.6,1.5 l1.2,0.2v1.6H147.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M46.8,28.4h2.2c0.2-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.6-0.3-0.8h-2.2c-0.2,0.2-0.3,0.5-0.3,0.8 C46.6,27.9,46.7,28.2,46.8,28.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M179.6,28.4v-1.6l3.8-0.8c-0.1-0.5-0.3-1-0.5-1.5l-4.9,1v1.4h-4v-1.4l-4.9-1c-0.2,0.5-0.4,1-0.5,1.5l3.8,0.8 v1.6H179.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M211.6,28.4v-1.6l5.9-1.3c-0.1-0.5-0.3-1-0.5-1.5l-7,1.5v1.4h-4v-1.4l-7-1.5c-0.2,0.5-0.3,1-0.5,1.5l5.9,1.3 v1.6H211.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M243.6,28.4v-1.6l7.7-1.6c-0.1-0.5-0.3-1-0.4-1.5l-8.8,1.9v1.4h-4v-1.4l-8.8-1.9c-0.2,0.5-0.3,1-0.4,1.5 l7.7,1.6v1.6H243.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"274,25.5 274,26.8 270,26.8 270,25.5 259.3,23.2 259.3,24.8 268.4,26.7 268.4,28.4 275.6,28.4  275.6,26.7 284.7,24.8 284.7,23.2 "})),viewBox:'0 0 288 32',frames:9}};/* harmony default export */ __webpack_exports__["a"] = (sprites);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__generic_SanityCheckTip__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__generic_Icon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_isValid__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor;var _templateObject=_taggedTemplateLiteral(['\n    flex-grow: 1;\n    transition: opacity .5s;\n    opacity: ',';\n    display: grid;\n    @media ','{\n        grid-template-columns: repeat(5, 1fr);\n        grid-template-rows: 48px;\n        grid-auto-rows: 48px;\n        grid-gap: 5px;\n        font-size: 16px;\n    }\n    @media ','{\n        grid-template-columns: repeat(5, 1fr);\n        grid-template-rows: 33px;\n        grid-auto-rows: 33px;\n        grid-gap: 5px;\n        font-size: 13px;\n\n    }\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    opacity: ',';\n\n'],['\n    flex-grow: 1;\n    transition: opacity .5s;\n    opacity: ',';\n    display: grid;\n    @media ','{\n        grid-template-columns: repeat(5, 1fr);\n        grid-template-rows: 48px;\n        grid-auto-rows: 48px;\n        grid-gap: 5px;\n        font-size: 16px;\n    }\n    @media ','{\n        grid-template-columns: repeat(5, 1fr);\n        grid-template-rows: 33px;\n        grid-auto-rows: 33px;\n        grid-gap: 5px;\n        font-size: 13px;\n\n    }\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    opacity: ',';\n\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: relative;\n    color: ',';\n    @media ','{\n        padding: 8px 13px;\n    }\n    @media ','{\n        padding: 6px 13px;    \n    }\n    ','\n    cursor: ',';\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    opacity: ',';\n    transition: opacity .5s, color .25s;\n    background: ',';\n    border: 1px solid ',';\n    &.allctys{\n        color: var(--strokepeach);\n    }\n'],['\n    position: relative;\n    color: ',';\n    @media ','{\n        padding: 8px 13px;\n    }\n    @media ','{\n        padding: 6px 13px;    \n    }\n    ','\n    cursor: ',';\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    opacity: ',';\n    transition: opacity .5s, color .25s;\n    background: ',';\n    border: 1px solid ',';\n    &.allctys{\n        color: var(--strokepeach);\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    opacity: ',';\n    transition: opacity .5s;\n    flex-shrink: 0; flex-grow: 0;\n    h1{\n        margin: 0;\n        font-weight: 400;\n        font-size: 24px;\n        margin-right: 10px;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @media ','{\n        margin-bottom: 15px;   \n    }\n    @media ','{\n        margin-bottom: 18px;\n    }\n'],['\n    opacity: ',';\n    transition: opacity .5s;\n    flex-shrink: 0; flex-grow: 0;\n    h1{\n        margin: 0;\n        font-weight: 400;\n        font-size: 24px;\n        margin-right: 10px;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @media ','{\n        margin-bottom: 15px;   \n    }\n    @media ','{\n        margin-bottom: 18px;\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    margin-right: 15px;\n    border: ',';\n    cursor: ',';\n    padding: 6px 15px;\n    display: inline-flex;\n    align-items: center;\n    font-size: 13px;\n'],['\n    margin-right: 15px;\n    border: ',';\n    cursor: ',';\n    padding: 6px 15px;\n    display: inline-flex;\n    align-items: center;\n    font-size: 13px;\n']),_templateObject5=_taggedTemplateLiteral(['\n    margin-left: 5px;\n    font-size: 13px;\n    color: var(--fainttext);\n'],['\n    margin-left: 5px;\n    font-size: 13px;\n    color: var(--fainttext);\n']),_templateObject6=_taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    position: relative;\n'],['\n    display: flex;\n    align-items: center;\n    position: relative;\n']),_templateObject7=_taggedTemplateLiteral(['\n    display: flex; flex-direction: column;\n    height: 100%;\n'],['\n    display: flex; flex-direction: column;\n    height: 100%;\n']),_templateObject8=_taggedTemplateLiteral(['\n    opacity: ',';\n    transform: translateX(','px);\n    transition: opacity .35s, transform .35s;\n    transition-delay: ','s;\n'],['\n    opacity: ',';\n    transform: translateX(','px);\n    transition: opacity .35s, transform .35s;\n    transition-delay: ','s;\n']),_templateObject9=_taggedTemplateLiteral(['\n    display: flex;\n    position: relative;\n    align-items: center;\n    font-size: 13px;\n    color: var(--fainttext);\n    fill: var(--bordergrey);\n    cursor: text;\n    position: absolute;\n    transition: transform .4s, fill .2s;\n    height: 36px;\n    &::after{\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid var(--bordergrey);\n        content: \'\';\n        transform-origin: 0% 50%;\n        transform: scaleX(',');\n        transition: transform .4s, border-color .2s;\n    }\n    ','\n    @media ','{\n        left: 175px;\n        width: 175px;\n        transform: translateX(','px);\n        &::after{ width: 175px; }\n    }\n    @media ','{\n        left: 175px;\n        width: 175px;\n        transform: translateX(','px);\n        &::after{ width: 175px; }\n    }\n\n'],['\n    display: flex;\n    position: relative;\n    align-items: center;\n    font-size: 13px;\n    color: var(--fainttext);\n    fill: var(--bordergrey);\n    cursor: text;\n    position: absolute;\n    transition: transform .4s, fill .2s;\n    height: 36px;\n    &::after{\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid var(--bordergrey);\n        content: \'\';\n        transform-origin: 0% 50%;\n        transform: scaleX(',');\n        transition: transform .4s, border-color .2s;\n    }\n    ','\n    @media ','{\n        left: 175px;\n        width: 175px;\n        transform: translateX(','px);\n        &::after{ width: 175px; }\n    }\n    @media ','{\n        left: 175px;\n        width: 175px;\n        transform: translateX(','px);\n        &::after{ width: 175px; }\n    }\n\n']),_templateObject10=_taggedTemplateLiteral(['\n    width: 18px; \n    height: 18px;\n    /*margin-right: 6px;*/\n'],['\n    width: 18px; \n    height: 18px;\n    /*margin-right: 6px;*/\n']),_templateObject11=_taggedTemplateLiteral(['\n    margin-left: 6px;\n'],['\n    margin-left: 6px;\n']),_templateObject12=_taggedTemplateLiteral(['\n    position: absolute;\n    border: none;\n    left: 20px;\n    appearance: none;\n    outline: none;\n    font-size: 16px;\n    background: none;\n    margin-left: 5px;\n    padding-left: 0px;\n    letter-spacing: 0.7px;\n    width: calc(100% - 20px);\n    /*padding: 10px;*/\n    /*border: 1px solid var(--fainttext);*/\n    /*opacity: 0;*/\n    /*pointer-events: none;*/\n'],['\n    position: absolute;\n    border: none;\n    left: 20px;\n    appearance: none;\n    outline: none;\n    font-size: 16px;\n    background: none;\n    margin-left: 5px;\n    padding-left: 0px;\n    letter-spacing: 0.7px;\n    width: calc(100% - 20px);\n    /*padding: 10px;*/\n    /*border: 1px solid var(--fainttext);*/\n    /*opacity: 0;*/\n    /*pointer-events: none;*/\n']),_templateObject13=_taggedTemplateLiteral(['\n    position: absolute;\n    right: -10px;\n    color: var(--strokepeach);\n    font-size: 13px;\n    letter-spacing: .5px;\n    margin-left: 20px;\n    transition: opacity .25s, transform .25s;\n    transform: ',';\n    transition-delay: ','s;\n    opacity: ',';\n    pointer-events: ',';\n    cursor: pointer;\n    z-index: 4;\n'],['\n    position: absolute;\n    right: -10px;\n    color: var(--strokepeach);\n    font-size: 13px;\n    letter-spacing: .5px;\n    margin-left: 20px;\n    transition: opacity .25s, transform .25s;\n    transform: ',';\n    transition-delay: ','s;\n    opacity: ',';\n    pointer-events: ',';\n    cursor: pointer;\n    z-index: 4;\n']),_templateObject14=_taggedTemplateLiteral(['\n    left: 0; \n    position: absolute;\n    text-align: center;\n    @media ','{\n        top: 275px;\n    }\n    @media ','{\n        top: 240px;\n    }\n    width: 100%;\n    height: 100%;\n    color: var(--fainttext);\n    h1{\n        font-weight: 500;\n        font-size: 24px;\n        letter-spacing: .92px;\n        margin: 0;\n        text-align: center;\n    }\n    margin-bottom: 25px;\n\n'],['\n    left: 0; \n    position: absolute;\n    text-align: center;\n    @media ','{\n        top: 275px;\n    }\n    @media ','{\n        top: 240px;\n    }\n    width: 100%;\n    height: 100%;\n    color: var(--fainttext);\n    h1{\n        font-weight: 500;\n        font-size: 24px;\n        letter-spacing: .92px;\n        margin: 0;\n        text-align: center;\n    }\n    margin-bottom: 25px;\n\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GridList=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].ul(_templateObject,function(p){return p.muted?0.4:1;},__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact,function(props){return props.raceDropdown?0.5:1;});var GridItem=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].li(_templateObject2,function(props){return props.sanityHighlight?'var(--normtext)':props.selected?'var(--strokepeach)':props.dataHasIssue?'var(--fainttext)':'black';},__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact,function(props){return props.invalid?'\n        &::after{\n            position: absolute;\n            content: \''+props.text+'\';\n            // width: '+(props.length*12+8)+'px;\n            color: rgba(0,0,0,0);\n            white-space: nowrap;\n            top: 0; bottom: 0; margin: auto;\n            left: 0;\n            padding: 0 16px;\n            height: 0px;\n            border-top: 1px solid var(--fainttext);\n        }\n    ':'';},function(props){return props.invalid?'auto':'pointer';},function(props){return props.muted?0.2:1;},function(props){return props.hovered&&!props.invalid&&!props.sanityHighlight?'#f3f3f5':props.selected?'var(--faintpeach)':'transparent';},function(props){return props.sanityHighlight?'var(--bordergrey)':props.selected?'var(--strokepeach)':'transparent';});var Titleblock=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.raceDropdown?0.4:props.muted?0.2:1;},__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact);var AllCountiesBtn=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.btnMode?'1px solid var(--bordergrey)':'';},function(props){return props.btnMode?'pointer':'';});var Faint=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject5);var TitleSide=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject6);var CountyList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(CountyList,_React$Component);function CountyList(){_classCallCheck(this,CountyList);var _this=_possibleConstructorReturn(this,(CountyList.__proto__||Object.getPrototypeOf(CountyList)).call(this));_initDefineProp(_this,'handleSelection',_descriptor,_this);_this.searchInput=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(CountyList,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.store.sanityCheck.county){this.props.store.clearSanityCheck('county');}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;if(this.props.focusInput){this.searchInput.current.focus();window.onkeyup=function(e){if(e.key==='Escape'||e.key==='Esc'){_this2.props.onSearch('');//clears string
_this2.searchInput.current.blur();}};}else{this.searchInput.current.blur();}}},{key:'render',value:function render(){var _this3=this;var store=this.props.store;var indicator=store.indicator,county=store.county,race=store.race,year=store.year,sanityCheck=store.sanityCheck;var ctyLabel=county?Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["find"])(__WEBPACK_IMPORTED_MODULE_7__assets_counties__["a" /* counties */],function(c){return c.id===county;}).label:'';var screen=Object(__WEBPACK_IMPORTED_MODULE_11__utilities_media__["b" /* getMedia */])();var sideChangeThreshold=screen==='optimal'?20:10;var searchActive=this.props.focusInput||this.props.searchString;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Workflow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Titleblock,{raceDropdown:this.props.muted,muted:sanityCheck.county},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleSide,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickPrompt,{hide:searchActive},'Pick a county.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Search,{active:searchActive,inputFocused:this.props.focusInput,onClick:function onClick(){return _this3.props.setSearchFocus(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchIcon,{img:'searchzoom'}),!this.props.searchString&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPrompt,null,'Type to search...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchInput,{ref:this.searchInput,onFocus:function onFocus(){return _this3.props.setSearchFocus(true);},onBlur:function onBlur(){return _this3.props.setSearchFocus(false);},value:this.props.searchString,onChange:function onChange(e){return _this3.props.onSearch(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CancelSearch,{hide:!this.props.searchString,onClick:function onClick(){return _this3.props.onSearch('');}},'Cancel')))),(store.countySearchResults.length!==0&&store.countySearchString||!store.countySearchString)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GridList,{raceDropdown:this.props.muted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GridItem,{className:'allctys',selected:!county,onClick:function onClick(){_this3.handleSelection();},muted:sanityCheck.county},'California'),__WEBPACK_IMPORTED_MODULE_7__assets_counties__["a" /* counties */].sort(function(a,b){if(a.id<b.id)return-1;else if(a.id>b.id)return 1;else return 0;}).filter(function(cty){return!store.countySearchString?true:store.countySearchResults.includes(cty.id);}).map(function(cty,i){var dataHasIssue=false;var straightUpNoData=false;var selected=cty.id===county;if(indicator){var arr=__WEBPACK_IMPORTED_MODULE_6__data_indicators__["a" /* default */][indicator].counties[cty.id];var allValues=Object.values(arr).flat();var value=__WEBPACK_IMPORTED_MODULE_6__data_indicators__["a" /* default */][indicator].counties[cty.id][race||'totals'][year];if(allValues.filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_12__utilities_isValid__["a" /* isValid */])(v);}).length===0){straightUpNoData=true;dataHasIssue=true;}else if(!Object(__WEBPACK_IMPORTED_MODULE_12__utilities_isValid__["a" /* isValid */])(value))dataHasIssue=true;}//brute force/static finding column and row numbers in order to position sanity check
var colNum=void 0,rowNum=void 0;if(i+2<6){//row 0
colNum=i+2;rowNum=0;}else if(i+2-5<=5){//row 1
colNum=i+2-5;rowNum=1;}else{//row 2+
for(var it=0;it*5<i+2;it++){rowNum=it;}colNum=i+2-5*rowNum;}var sanityChecking=sanityCheck.county&&sanityCheck.county===cty.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GridItem,{text:cty.label,selected:selected,sanityHighlight:sanityChecking,dataHasIssue:dataHasIssue,invalid:straightUpNoData,muted:sanityCheck.county&&sanityCheck.county!==cty.id,key:"countylist"+cty.id,onClick:!sanityChecking?function(){_this3.handleSelection(cty.id,colNum,rowNum);}:function(){},onMouseEnter:function onMouseEnter(){return _this3.props.store.setHover('county',cty.id);},onMouseLeave:function onMouseLeave(){return _this3.props.store.setHover('county',null);},hovered:_this3.props.store.hoveredCounty===cty.id},sanityChecking&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__generic_SanityCheckTip__["a" /* default */],{checkType:'county',direction:rowNum<7?'below':'above',pos:{x:colNum===3?50:0,y:rowNum<7?40:0},data:sanityCheck,index:i,store:_this3.props.store,needsCentering:colNum===3,horizontalAnchor:colNum<4?'left':'right',caretOffset:colNum<3?-180:colNum>3?125:0}),cty.label);})),store.countySearchResults.length===0&&store.countySearchString&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmptyPage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Your search for \u201C',store.countySearchString,'\u201D doesn\'t match any counties.')));}}]);return CountyList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'handleSelection',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(cty,column,row){if(_this4.props.store.sanityCheck.county)return;var sel=_this4.props.store.completeWorkflow('county',cty);if(sel)_this4.props.closeNav();else{// console.log('sanity check on county!')
// console.log(this.props.store.sanityCheck)
}};}})),_class2))||_class;var Workflow=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject7);var PickPrompt=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].h1(_templateObject8,function(props){return props.hide?0:1;},function(props){return props.hide?-20:0;},function(props){return props.hide?0:.125;});var Search=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject9,function(props){return props.active?1:0;},function(props){return props.inputFocused?'\n        fill: var(--fainttext);\n        &::after{\n            border-bottom-color: var(--fainttext);\n        }\n    ':!props.active?'\n        &:hover{\n            color: var(--strokepeach);\n            fill: var(--peach);\n        }\n    ':'';},__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,function(props){return props.active?-175:0;},__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact,function(props){return props.active?-175:0;});var SearchIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_10__generic_Icon__["b" /* default */])(_templateObject10);var SearchPrompt=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject11);var SearchInput=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].input(_templateObject12);var CancelSearch=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject13,function(props){return props.hide?'translateX(0)':'translateX(100%)';},function(props){return props.hide?0:0.25;},function(props){return props.hide?0:1;},function(props){return props.hide?'none':'auto';});var EmptyPage=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject14,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_11__utilities_media__["a" /* default */].compact);/* harmony default export */ __webpack_exports__["a"] = (CountyList);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SanityCheckTip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_media__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n    cursor: auto;\n    margin-top: ','px;\n    // transform-origin: ','; \n\n    transform-origin: ','% ','%;\n    &::after{\n        left: calc(50% - 9.5px);\n        ',': -19px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 9.5px solid transparent;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        ',': -21.5px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 10.5px solid transparent;\n    }\n        &::before { border-',': 10.5px var(--bordergrey) solid; }\n        &::after{ border-',': 9.5px var(--offwhitefg) solid;  }\n        animation: ',' .3s forwards;\n'],['\n    cursor: auto;\n    margin-top: ','px;\n    // transform-origin: ','; \n\n    transform-origin: ','% ','%;\n    &::after{\n        left: calc(50% - 9.5px);\n        ',': -19px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 9.5px solid transparent;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        ',': -21.5px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 10.5px solid transparent;\n    }\n        &::before { border-',': 10.5px var(--bordergrey) solid; }\n        &::after{ border-',': 9.5px var(--offwhitefg) solid;  }\n        animation: ',' .3s forwards;\n']),_templateObject2=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-60px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-60px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-100%) translateY(60px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(-100%) translateY(0);\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-100%) translateY(60px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(-100%) translateY(0);\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: translate(-50%, -60px) scale(0.8);\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, 0) scale(1);\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: translate(-50%, -60px) scale(0.8);\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, 0) scale(1);\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: translate(-50%,-100%) translateY(60px) scale(0.8) ;\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%,-100%) translateY(0) scale(1);\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: translate(-50%,-100%) translateY(60px) scale(0.8) ;\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%,-100%) translateY(0) scale(1);\n    }\n']),_templateObject6=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n'],['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n']),_templateObject7=_taggedTemplateLiteral(['\n    width: 480px;\n    line-height: 180%;\n    white-space: normal;\n    @media ','{\n        font-size: 16px;\n        padding: 30px;\n    }\n    @media ','{\n        font-size: 13px;\n        padding: 20px;\n    }\n'],['\n    width: 480px;\n    line-height: 180%;\n    white-space: normal;\n    @media ','{\n        font-size: 16px;\n        padding: 30px;\n    }\n    @media ','{\n        font-size: 13px;\n        padding: 20px;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SanityCheckTip=function(_React$Component){_inherits(SanityCheckTip,_React$Component);function SanityCheckTip(){_classCallCheck(this,SanityCheckTip);var _this=_possibleConstructorReturn(this,(SanityCheckTip.__proto__||Object.getPrototypeOf(SanityCheckTip)).call(this));_this.handleClick=function(e){// console.log(this.sanityCheck)
console.log(e);console.log(e.nativeEvent);if(_this.props.store.sanityCheck[_this.props.checkType]){if(!Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.sanityCheck.current).contains(e.target)){// e.nativeEvent.stopImmediatePropagation()
_this.props.store.clearSanityCheck(_this.props.checkType);}}};_this.sanityCheck=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(SanityCheckTip,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('click',this.handleClick);}},{key:'componentWillUnmount',value:function componentWillUnmount(){// console.log('unmounting sanitycheck')
document.removeEventListener('click',this.handleClick);}},{key:'render',value:function render(){var _props=this.props,pos=_props.pos,store=_props.store,direction=_props.direction,needsCentering=_props.needsCentering,checkType=_props.checkType,caretOffset=_props.caretOffset,horizontalAnchor=_props.horizontalAnchor;var data=store.sanityCheck;var screen=Object(__WEBPACK_IMPORTED_MODULE_4__utilities_media__["b" /* getMedia */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModTip,{ref:this.sanityCheck,pos:{x:pos.x,y:pos.y},direction:direction,horizontalAnchor:horizontalAnchor,duration:'.35s',className:'actionable',needsCentering:needsCentering,caretOffset:caretOffset},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Check,null,data.message,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SanityControls,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* Button */],{className:screen==='compact'?'compact':'',label:'Nevermind, back to list',style:{marginRight:'15px'},onClick:function onClick(e){e.nativeEvent.stopImmediatePropagation();store.clearSanityCheck(checkType);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__index__["a" /* Button */],{label:'Yes, continue',className:'dark '+screen,onClick:function onClick(){data.action();store.clearSanityCheck(checkType);}}))));}}]);return SanityCheckTip;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var ModTip=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* Tip */])(_templateObject,function(p){return p.direction==='above'?-20:20;},function(p){return p.direction==='above'?'50% 100%':'50% 0%';},function(p){return p.needsCentering?50:p.horizontalAnchor==='left'?0:100;},function(p){return p.direction==='above'?100:0;},function(p){return p.direction==='above'?'bottom':'top';},function(p){return p.direction==='above'?'bottom':'top';},function(p){return p.direction==='above'?'top':'bottom';},function(p){return p.direction==='above'?'top':'bottom';},function(p){return p.needsCentering&&p.direction==='above'?tooltipaboveCenter:p.needsCentering?tooltipanimCenter:p.direction==='above'?tooltipabove:tooltipanim;});var tooltipanim=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* keyframes */])(_templateObject2);var tooltipabove=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* keyframes */])(_templateObject3);var tooltipanimCenter=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* keyframes */])(_templateObject4);var tooltipaboveCenter=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* keyframes */])(_templateObject5);var SanityControls=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject6);var Check=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].compact);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndicatorList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_isValid__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__generic_Icon__ = __webpack_require__(13);
var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_class4;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    padding: 0; \n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    flex-grow: 1;\n    margin: 0;\n    @media ','{\n        margin-top: 10px;\n    }\n    @media ','{\n        margin-top: 5px;\n    }\n    opacity: ',';\n    transition: opacity .5s;\n'],['\n    position: relative;\n    padding: 0; \n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    flex-grow: 1;\n    margin: 0;\n    @media ','{\n        margin-top: 10px;\n    }\n    @media ','{\n        margin-top: 5px;\n    }\n    opacity: ',';\n    transition: opacity .5s;\n']),_templateObject2=_taggedTemplateLiteral(['\n    /*flex-grow: ',';*/\n    position: relative;\n    // width: 50%;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px 30px;\n    @media ','{\n        padding: 15px 30px;\n    }\n    @media ','{\n        padding: 10px 25px;\n    }\n    white-space: normal;\n    // margin: 10px;\n    list-style-type: none;\n    border: 1px solid ',';\n    color: ',';\n    background: ',';\n    transition: border-color .2s, background-color .2s ',';\n    /*transform: translateY(-','px);*/\n    /*margin-top: ','px;*/\n    margin-top: -1px;\n    z-index: ',';\n    pointer-events: ',';\n    cursor: pointer;\n    &:hover{\n        color: ',';\n        h4{\n            color: ',';\n        }\n    }\n\n    // box-shadow: var(--shadow);\n\n'],['\n    /*flex-grow: ',';*/\n    position: relative;\n    // width: 50%;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 15px 30px;\n    @media ','{\n        padding: 15px 30px;\n    }\n    @media ','{\n        padding: 10px 25px;\n    }\n    white-space: normal;\n    // margin: 10px;\n    list-style-type: none;\n    border: 1px solid ',';\n    color: ',';\n    background: ',';\n    transition: border-color .2s, background-color .2s ',';\n    /*transform: translateY(-','px);*/\n    /*margin-top: ','px;*/\n    margin-top: -1px;\n    z-index: ',';\n    pointer-events: ',';\n    cursor: pointer;\n    &:hover{\n        color: ',';\n        h4{\n            color: ',';\n        }\n    }\n\n    // box-shadow: var(--shadow);\n\n']),_templateObject3=_taggedTemplateLiteral(['\n    // font-size: 16px;\n    line-height: 150%;\n    transition: opacity .25s;\n    opacity: ',';\n'],['\n    // font-size: 16px;\n    line-height: 150%;\n    transition: opacity .25s;\n    opacity: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: inline;\n    font-weight: normal;\n    margin: 0;\n    margin-left: 8px;\n    margin-right: 7px;\n    font-size: 13px;\n    // color: var(--fainttext);\n'],['\n    display: inline;\n    font-weight: normal;\n    margin: 0;\n    margin-left: 8px;\n    margin-right: 7px;\n    font-size: 13px;\n    // color: var(--fainttext);\n']),_templateObject5=_taggedTemplateLiteral(['\n    /*margin-top: -2px;*/\n    transition: opacity .25s;\n    opacity: ',';\n    margin-left: 20px;\n    @media ','{\n        font-size: 24px;\n        font-weight: normal;\n        min-height: 35px;\n    }\n    @media ','{\n        font-weight: 500;\n        font-size: 16px;\n    }\n    letter-spacing: .0rem;\n    min-width: 45px;\n    display: flex;\n    justify-content: flex-end;\n    display: flex;\n    align-items: center;\n'],['\n    /*margin-top: -2px;*/\n    transition: opacity .25s;\n    opacity: ',';\n    margin-left: 20px;\n    @media ','{\n        font-size: 24px;\n        font-weight: normal;\n        min-height: 35px;\n    }\n    @media ','{\n        font-weight: 500;\n        font-size: 16px;\n    }\n    letter-spacing: .0rem;\n    min-width: 45px;\n    display: flex;\n    justify-content: flex-end;\n    display: flex;\n    align-items: center;\n']),_templateObject6=_taggedTemplateLiteral(['\n\n'],['\n\n']),_templateObject7=_taggedTemplateLiteral(['\n    color: var(--fainttext);\n    font-size: 13px;\n    margin-bottom: 2px;\n'],['\n    color: var(--fainttext);\n    font-size: 13px;\n    margin-bottom: 2px;\n']),_templateObject8=_taggedTemplateLiteral(['\n    /*height: 32px; flex-shrink: 0;*/\n    position: relative;\n    display: flex; align-items: center;\n    margin: 0 20px 0 0;\n        opacity: ',';\n    transition: opacity .5s;\n    font-weight: 400;\n    @media ','{\n        font-size: 24px;\n    }\n    @media ','{\n        font-size: 24px;\n    }\n'],['\n    /*height: 32px; flex-shrink: 0;*/\n    position: relative;\n    display: flex; align-items: center;\n    margin: 0 20px 0 0;\n        opacity: ',';\n    transition: opacity .5s;\n    font-weight: 400;\n    @media ','{\n        font-size: 24px;\n    }\n    @media ','{\n        font-size: 24px;\n    }\n']),_templateObject9=_taggedTemplateLiteral(['\n    opacity: ',';\n    transform: translateX(','px);\n    transition: opacity .35s, transform .35s;\n    transition-delay: ','s;\n\n'],['\n    opacity: ',';\n    transform: translateX(','px);\n    transition: opacity .35s, transform .35s;\n    transition-delay: ','s;\n\n']),_templateObject10=_taggedTemplateLiteral(['\n    display: flex;\n    position: relative;\n    align-items: center;\n    font-size: 13px;\n    color: var(--fainttext);\n    fill: var(--bordergrey);\n    cursor: text;\n    position: absolute;\n    transition: transform .5s, fill .2s;\n    height: 36px;\n    &::after{\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid var(--bordergrey);\n        content: \'\';\n        transform-origin: 0% 50%;\n        transform: scaleX(',');\n        transition: transform .5s, border-color .2s;\n    }\n    ','\n    @media ','{\n        left: 250px;\n        width: 400px;\n        transform: translateX(','px);\n        &::after{ width: 400px; }\n    }\n    @media ','{\n        left: 250px;\n        width: 375px;\n        transform: translateX(','px);\n        &::after{ width: 375px; }\n    }\n\n'],['\n    display: flex;\n    position: relative;\n    align-items: center;\n    font-size: 13px;\n    color: var(--fainttext);\n    fill: var(--bordergrey);\n    cursor: text;\n    position: absolute;\n    transition: transform .5s, fill .2s;\n    height: 36px;\n    &::after{\n        position: absolute;\n        bottom: 0;\n        border-bottom: 1px solid var(--bordergrey);\n        content: \'\';\n        transform-origin: 0% 50%;\n        transform: scaleX(',');\n        transition: transform .5s, border-color .2s;\n    }\n    ','\n    @media ','{\n        left: 250px;\n        width: 400px;\n        transform: translateX(','px);\n        &::after{ width: 400px; }\n    }\n    @media ','{\n        left: 250px;\n        width: 375px;\n        transform: translateX(','px);\n        &::after{ width: 375px; }\n    }\n\n']),_templateObject11=_taggedTemplateLiteral(['\n    width: 18px; \n    height: 18px;\n    /*margin-right: 6px;*/\n'],['\n    width: 18px; \n    height: 18px;\n    /*margin-right: 6px;*/\n']),_templateObject12=_taggedTemplateLiteral(['\n    margin-left: 6px;\n'],['\n    margin-left: 6px;\n']),_templateObject13=_taggedTemplateLiteral(['\n    position: absolute;\n    border: none;\n    left: 20px;\n    appearance: none;\n    outline: none;\n    font-size: 16px;\n    background: none;\n    margin-left: 5px;\n    padding-left: 0px;\n    letter-spacing: 0.7px;\n    width: calc(100% - 20px);\n\n'],['\n    position: absolute;\n    border: none;\n    left: 20px;\n    appearance: none;\n    outline: none;\n    font-size: 16px;\n    background: none;\n    margin-left: 5px;\n    padding-left: 0px;\n    letter-spacing: 0.7px;\n    width: calc(100% - 20px);\n\n']),_templateObject14=_taggedTemplateLiteral(['\n    position: absolute;\n    right: -10px;\n    color: var(--strokepeach);\n    font-size: 13px;\n    letter-spacing: .5px;\n    margin-left: 20px;\n    transition: opacity .25s, transform .25s;\n    transform: ',';\n    transition-delay: ','s;\n    opacity: ',';\n    pointer-events: ',';\n    cursor: pointer;\n'],['\n    position: absolute;\n    right: -10px;\n    color: var(--strokepeach);\n    font-size: 13px;\n    letter-spacing: .5px;\n    margin-left: 20px;\n    transition: opacity .25s, transform .25s;\n    transform: ',';\n    transition-delay: ','s;\n    opacity: ',';\n    pointer-events: ',';\n    cursor: pointer;\n']),_templateObject15=_taggedTemplateLiteral(['\n    font-size: 16px;\n\n'],['\n    font-size: 16px;\n\n']),_templateObject16=_taggedTemplateLiteral(['\n    position: absolute;\n    text-align: center;\n    @media ','{\n        top: 130px;\n    }\n    @media ','{\n        top: 130px;\n    }\n    width: 100%;\n    color: var(--fainttext);\n    align-items: center;\n    justify-content: center;\n    h1{\n        font-weight: 500;\n        font-size: 24px;\n        letter-spacing: .92px;\n        margin: 0;\n    }\n    h2{\n        margin: 10px;\n        font-weight: 400;\n        font-size: 16px;\n        letter-spacing: .7px;\n    }\n\n'],['\n    position: absolute;\n    text-align: center;\n    @media ','{\n        top: 130px;\n    }\n    @media ','{\n        top: 130px;\n    }\n    width: 100%;\n    color: var(--fainttext);\n    align-items: center;\n    justify-content: center;\n    h1{\n        font-weight: 500;\n        font-size: 24px;\n        letter-spacing: .92px;\n        margin: 0;\n    }\n    h2{\n        margin: 10px;\n        font-weight: 400;\n        font-size: 16px;\n        letter-spacing: .7px;\n    }\n\n']),_templateObject17=_taggedTemplateLiteral(['\n    cursor: auto;\n    margin-top: ','px;\n    transform-origin: ','; \n    &::after{\n        left: calc(50% - 9.5px);\n        ',': -19px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 9.5px solid transparent;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        ',': -21.5px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 10.5px solid transparent;\n    }\n        &::before { border-',': 10.5px var(--bordergrey) solid; }\n        &::after{ border-',': 9.5px var(--offwhitefg) solid;  }\n        animation: ',' .3s forwards;\n'],['\n    cursor: auto;\n    margin-top: ','px;\n    transform-origin: ','; \n    &::after{\n        left: calc(50% - 9.5px);\n        ',': -19px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 9.5px solid transparent;\n    }\n    &::before{\n        left: calc(50% - 10.5px);\n        ',': -21.5px;\n        position: absolute;\n        content: \'\';\n        width: 0; height: 0;\n        border: 10.5px solid transparent;\n    }\n        &::before { border-',': 10.5px var(--bordergrey) solid; }\n        &::after{ border-',': 9.5px var(--offwhitefg) solid;  }\n        animation: ',' .3s forwards;\n']),_templateObject18=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-60px);\n        /*clip-path: polygon(0% -10%, 100% -10%, 100% 0%, 0% 0%);*/\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n        /*clip-path: polygon(0% -10%, 100% -10%, 100% 100%, 0% 100%);*/\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-60px);\n        /*clip-path: polygon(0% -10%, 100% -10%, 100% 0%, 0% 0%);*/\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n        /*clip-path: polygon(0% -10%, 100% -10%, 100% 100%, 0% 100%);*/\n    }\n']),_templateObject19=_taggedTemplateLiteral(['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-100%) translateY(60px);\n        /*clip-path: polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%);*/\n    }\n    to {\n        opacity: 1;\n        transform: translateY(-100%) translateY(0);\n        /*clip-path: polygon(0% 0%, 100% 0%, 100% 110%, 0% 110%);*/\n    }\n'],['\n    from {\n        opacity: 0; \n        transform: scale(0.8) translateY(-100%) translateY(60px);\n        /*clip-path: polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%);*/\n    }\n    to {\n        opacity: 1;\n        transform: translateY(-100%) translateY(0);\n        /*clip-path: polygon(0% 0%, 100% 0%, 100% 110%, 0% 110%);*/\n    }\n']),_templateObject20=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n'],['\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n']),_templateObject21=_taggedTemplateLiteral(['\n    width: 480px;\n    line-height: 180%;\n    @media ','{\n        font-size: 16px;\n        padding: 30px;\n    }\n    @media ','{\n        font-size: 13px;\n        padding: 20px;\n    }\n'],['\n    width: 480px;\n    line-height: 180%;\n    @media ','{\n        font-size: 16px;\n        padding: 30px;\n    }\n    @media ','{\n        font-size: 13px;\n        padding: 20px;\n    }\n']),_templateObject22=_taggedTemplateLiteral(['\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    font-size: 16px;\n    align-items: flex-end;\n'],['\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    font-size: 16px;\n    align-items: flex-end;\n']),_templateObject23=_taggedTemplateLiteral(['\n'],['\n']),_templateObject24=_taggedTemplateLiteral(['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    opacity: ',';\n    transition: opacity .5s;\n    font-size: 13px;\n    height: 65px;\n    flex-shrink: 0;\n'],['\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    opacity: ',';\n    transition: opacity .5s;\n    font-size: 13px;\n    height: 65px;\n    flex-shrink: 0;\n']),_templateObject25=_taggedTemplateLiteral(['\n    text-align: right;\n    color: var(--fainttext);\n'],['\n    text-align: right;\n    color: var(--fainttext);\n']),_templateObject26=_taggedTemplateLiteral(['\n    color: var(--normtext);\n    font-weight: 500;\n'],['\n    color: var(--normtext);\n    font-weight: 500;\n']),_templateObject27=_taggedTemplateLiteral(['\n    \n    color: var(--normtext);\n    margin-bottom: 2px;\n'],['\n    \n    color: var(--normtext);\n    margin-bottom: 2px;\n']),_templateObject28=_taggedTemplateLiteral(['\n    margin-right: 7px;\n'],['\n    margin-right: 7px;\n']),_templateObject29=_taggedTemplateLiteral(['\n    color: ',';\n    /*border-bottom: 1px solid var(--bordergrey);*/\n    /*padding: 1.5px 7px;*/\n    /*margin-left: 7px;*/\n    display: inline-flex;\n    align-items: center;\n    font-size: 13px;\n    letter-spacing: 0.75px;\n'],['\n    color: ',';\n    /*border-bottom: 1px solid var(--bordergrey);*/\n    /*padding: 1.5px 7px;*/\n    /*margin-left: 7px;*/\n    display: inline-flex;\n    align-items: center;\n    font-size: 13px;\n    letter-spacing: 0.75px;\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import semanticTitles from '../assets/semanticTitles'
var IndRows=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].ul(_templateObject,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].compact,function(props){return props.raceDropdown?0.4:1;});var RowItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].li(_templateObject2,function(props){return props.lastPage||props.isolated?0:1;},__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].compact,function(props){return props.muted&&!props.disabled?'#DFDFDF':props.disabled&&!props.isolated?'transparent':props.selected?'var(--strokepeach)':'var(--bordergrey)';},function(props){return props.selected?'var(--strokepeach)':props.disabled&&!props.isolated?'var(--fainttext)':'black';},function(props){return props.muted||props.disabled&&!props.isolated?'transparent':props.selected?'var(--faintpeach)':'white';},function(props){return props.muted||props.disabled?', color .2s':'';},function(props){return props.index*1;},function(props){return props.isolated?10:-1;},function(props){return props.isolated?10:props.selected?2:1;},function(props){return props.muted?'none':'auto';},function(props){return props.isolated?'var(--normtext)':'var(--strokepeach)';},function(props){return props.disabled?'var(--fainttext)':'var(--peach)';});var Row=function(_React$Component){_inherits(Row,_React$Component);function Row(){_classCallCheck(this,Row);return _possibleConstructorReturn(this,(Row.__proto__||Object.getPrototypeOf(Row)).apply(this,arguments));}_createClass(Row,[{key:'render',value:function render(){var _props=this.props,children=_props.children,restOfProps=_objectWithoutProperties(_props,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowItem,Object.assign({className:'listitem'},restOfProps),' ',children,' ');}}]);return Row;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var IndLeft=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3,function(p){return p.muted?0.2:1;});var Years=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h4(_templateObject4);var Percentage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.muted?0.2:1;},__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].compact);var indicatorFilterOptions=[{label:Object(__WEBPACK_IMPORTED_MODULE_13__utilities_media__["b" /* getMedia */])()==='optimal'?'All topics':'All',value:'all'},{label:'Health',value:'health'},{label:'Education',value:'education'},{label:'Child Welfare',value:'welfare'},{label:'Early Childhood',value:'earlyChildhood'}];var ToggleBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject6);var Caption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h1(_templateObject8,function(props){return props.raceDropdown?0.4:props.muted?0.2:1;},__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].compact);var ChoosePrompt=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject9,function(props){return props.hide?0:1;},function(props){return props.hide?-20:0;},function(props){return props.hide?0:.15;});var Search=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject10,function(props){return props.active?1:0;},function(props){return props.inputFocused?'\n        fill: var(--fainttext);\n        &::after{\n            border-bottom-color: var(--fainttext);\n        }\n    ':!props.active?'\n        &:hover{\n            color: var(--strokepeach);\n            fill: var(--peach);\n        }\n    ':'';},__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].optimal,function(props){return props.active?-250:0;},__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].compact,function(props){return props.active?-250:0;});var SearchIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_14__generic_Icon__["b" /* default */])(_templateObject11);var SearchPrompt=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject12);var SearchInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].input(_templateObject13);var CancelSearch=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject14,function(props){return props.hide?'translateX(0)':'translateX(100%)';},function(props){return props.hide?0:0.25;},function(props){return props.hide?0:1;},function(props){return props.hide?'none':'auto';});var Label=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject15);var IndicatorList=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component2){_inherits(IndicatorList,_React$Component2);function IndicatorList(){_classCallCheck(this,IndicatorList);var _this2=_possibleConstructorReturn(this,(IndicatorList.__proto__||Object.getPrototypeOf(IndicatorList)).call(this));_initDefineProp(_this2,'isolated',_descriptor,_this2);_initDefineProp(_this2,'sanityCheckPosition',_descriptor2,_this2);_initDefineProp(_this2,'sanityCheckSide',_descriptor3,_this2);_initDefineProp(_this2,'animating',_descriptor4,_this2);_initDefineProp(_this2,'interrupt',_descriptor5,_this2);_initDefineProp(_this2,'setAnimating',_descriptor6,_this2);_initDefineProp(_this2,'setInterrupt',_descriptor7,_this2);_initDefineProp(_this2,'isolate',_descriptor8,_this2);_initDefineProp(_this2,'handleSelection',_descriptor9,_this2);_this2.list=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this2.searchInput=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this2;}_createClass(IndicatorList,[{key:'componentDidUpdate',value:function componentDidUpdate(){var _this3=this;if(this.props.focusInput){console.log('ind focus updated');this.searchInput.current.focus();window.onkeyup=function(e){if(e.key==='Escape'||e.key==='Esc'){_this3.props.onSearch('');//clears string
_this3.searchInput.current.blur();}};}else{this.searchInput.current.blur();}}},{key:'render',value:function render(){var _this4=this,_React$createElement;var _props2=this.props,store=_props2.store,animDir=_props2.animDir,prevOffset=_props2.prevOffset;var county=store.county,race=store.race,indicatorFilter=store.indicatorFilter;var page=store.indicatorPages[store.indicatorListPage];var indRangeEnd=(store.indicatorListPage+1)*store.indicatorPageSize;var numInds=Object.keys(__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */]).filter(function(ind){var cats=__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */][ind].categories;if(!store.indicatorSearchResults)return false;if(store.indicatorSearchString&&store.indicatorSearchResults.length===0)return false;if(store.indicatorSearchString&&store.indicatorFilter==='all'){return store.indicatorSearchResults.includes(ind);}else if(store.indicatorSearchString){return store.indicatorSearchResults.includes(ind)&&cats.includes(store.indicatorFilter);}else return store.indicatorFilter==='all'?true:cats.includes(store.indicatorFilter);}).length;var showSanityCheck=store.sanityCheck.indicator;// console.log('sanity', showSanityCheck)
var searchActive=this.props.focusInput||this.props.searchString;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Workflow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{muted:showSanityCheck,raceDropdown:this.props.muted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChoosePrompt,{hide:searchActive},'Choose an indicator.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Search,{active:searchActive,inputFocused:this.props.focusInput,onClick:function onClick(){return _this4.props.setSearchFocus(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchIcon,{img:'searchzoom'}),!this.props.searchString&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchPrompt,null,'Type to search...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchInput,{ref:this.searchInput,onFocus:function onFocus(){return _this4.props.setSearchFocus(true);},onBlur:function onBlur(){return _this4.props.setSearchFocus(false);},value:this.props.searchString,onChange:function onChange(e){return _this4.props.onSearch(e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CancelSearch,{hide:!this.props.searchString,onClick:function onClick(){return _this4.props.onSearch('');}},'Cancel'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListStatus,{muted:showSanityCheck,raceDropdown:this.props.muted,className:'caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__generic__["d" /* Toggle */],{options:indicatorFilterOptions,onClick:store.setIndicatorFilter,selected:Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["findIndex"])(indicatorFilterOptions,function(o){return o.value===store.indicatorFilter;})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Readout,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AboutPcts,null,(county?__WEBPACK_IMPORTED_MODULE_10__assets_countyLabels___default.a[county]:'Statewide')+' %\'s for '+(race==='other'?'other race':race?Object(__WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__["b" /* capitalize */])(race):'all race')+'s'),numInds>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'Viewing ',store.indicatorPageSize*store.indicatorListPage+1,'\u2014',indRangeEnd>numInds?numInds:indRangeEnd,'\xA0of ',numInds),numInds===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'No results'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndRows,{raceDropdown:this.props.muted,ref:this.list},!page&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmptyPage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'No indicators seem to match \u201C',store.indicatorSearchString,'\u201D.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,' Try different keywords or browsing by topic. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_flip_move__["a" /* default */],(_React$createElement={typeName:null,duration:300,staggerDelayBy:12,style:{display:'flex',flexDirection:'column',height:'100%'},maintainContainerHeight:true},_defineProperty(_React$createElement,'duration',250),_defineProperty(_React$createElement,'leaveAnimation',null),_defineProperty(_React$createElement,'enterAnimation',{from:{opacity:0,transform:'translateX('+(animDir==='left'?150:-150)+'px)'},to:{opacity:1,transform:'translateX(0px)'}}),_defineProperty(_React$createElement,'onStartAll',function onStartAll(){if(_this4.animating)_this4.setInterrupt(true);_this4.setAnimating(true);}),_defineProperty(_React$createElement,'onFinishAll',function onFinishAll(){_this4.setAnimating(false);if(_this4.interrupt)_this4.setInterrupt(false);}),_React$createElement),page&&page.map(function(ind,i,arr){var indicator=__WEBPACK_IMPORTED_MODULE_8__data_indicators__["a" /* default */][ind];var cats=indicator.categories;var selected=_this4.props.store.indicator===ind;var noRace=!cats.includes('hasRace');var noRaceNeedRace=noRace&&race;var valArr=void 0;var val=void 0;if(!noRaceNeedRace&&indicator.counties[county||'california'][race||'totals']){valArr=indicator.counties[county||'california'][race||'totals'].filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_12__utilities_isValid__["a" /* isValid */])(v);});}else{valArr=indicator.counties[county||'california'].totals.filter(function(v){return Object(__WEBPACK_IMPORTED_MODULE_12__utilities_isValid__["a" /* isValid */])(v);});}if(valArr.length>0){val=valArr[valArr.length-1];}else val='';// val = val && val!=='*'? val[val.length-1] : ''
var disabled=county&&!val||county&&val==='*'||noRaceNeedRace;var missingCounties=true;var isolated=ind===showSanityCheck;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{index:i,selected:selected,isolated:isolated,id:ind+'row',key:ind+'row'// noRaceNeedRace = {noRace && race}
,muted:showSanityCheck&&!isolated,disabled:disabled,lastPage:store.indicatorListPage===store.indicatorPages.length-1,onClick:function onClick(e){if(!isolated)_this4.handleSelection(e,ind,i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndLeft,{muted:showSanityCheck&&!isolated},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndLabel,null,indicator.semantics.label),noRace&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoRaceBadge,{needRace:noRaceNeedRace},' No Race Data ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Percentage,{muted:showSanityCheck&&!isolated},!disabled&&val+'%',disabled&&'\u2014\u2014'),isolated&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SanityCheck,{key:showSanityCheck+'sanitycheck',store:store,yPos:_this4.sanityCheckPosition,side:_this4.sanityCheckSide}));}))));}}]);return IndicatorList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'isolated',[__WEBPACK_IMPORTED_MODULE_3_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'sanityCheckPosition',[__WEBPACK_IMPORTED_MODULE_3_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'sanityCheckSide',[__WEBPACK_IMPORTED_MODULE_3_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'below';}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'animating',[__WEBPACK_IMPORTED_MODULE_3_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'interrupt',[__WEBPACK_IMPORTED_MODULE_3_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'setAnimating',[__WEBPACK_IMPORTED_MODULE_3_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(tf){// console.log('animating: ', tf)
_this5.animating=tf;};}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'setInterrupt',[__WEBPACK_IMPORTED_MODULE_3_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(tf){_this6.interrupt=tf;};}}),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'isolate',[__WEBPACK_IMPORTED_MODULE_3_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(val){_this7.isolated=val;};}}),_descriptor9=_applyDecoratedDescriptor(_class2.prototype,'handleSelection',[__WEBPACK_IMPORTED_MODULE_3_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(e,ind,i){var store=_this8.props.store;if(store.sanityCheck.indicator)return;var screen=Object(__WEBPACK_IMPORTED_MODULE_13__utilities_media__["b" /* getMedia */])();// console.log('attempting to select', ind)
// this.isolate(ind)
var select=_this8.props.store.completeWorkflow('indicator',ind);if(select)_this8.props.closeNav();//went through
else{var _target=document.getElementById(ind+'row');//e.target
if(i+1>store.indicatorPageSize/2){//bottom half of page, appear above
//container height minus top/y of selected item = differencte on bottom side
var containerHeight=_this8.list.current.getBoundingClientRect().height;_this8.sanityCheckSide='above';_this8.sanityCheckPosition=0;}else{//top half of page, appear below
// console.log('set pos', e.target.getBoundingClientRect().y)
_this8.sanityCheckSide='below';_this8.sanityCheckPosition=_target.offsetHeight;}}// this.props.closeNav()
};}})),_class2))||_class;var EmptyPage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject16,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].compact);var SanityCheck=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["a" /* observer */])(_class4=function(_React$Component3){_inherits(SanityCheck,_React$Component3);function SanityCheck(){_classCallCheck(this,SanityCheck);var _this9=_possibleConstructorReturn(this,(SanityCheck.__proto__||Object.getPrototypeOf(SanityCheck)).call(this));_this9.handleClick=function(e){// console.log(this.sanityCheck)
if(_this9.props.store.sanityCheck.indicator){if(!Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(_this9.sanityCheck.current).contains(e.target)){_this9.props.store.clearSanityCheck('indicator');}}};_this9.sanityCheck=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this9;}_createClass(SanityCheck,[{key:'componentDidMount',value:function componentDidMount(){document.addEventListener('click',this.handleClick);}},{key:'componentWillUnmount',value:function componentWillUnmount(){// console.log('unmounting sanitycheck')
document.removeEventListener('click',this.handleClick);}},{key:'render',value:function render(){var _props3=this.props,yPos=_props3.yPos,store=_props3.store,side=_props3.side;var data=store.sanityCheck;var screen=store.screen;var xPos=screen==='optimal'?464:300;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModTip,{ref:this.sanityCheck,pos:{x:screen==='optimal'?-15:-10,y:this.props.yPos},direction:side// verticalAnchor = {side==='above'?'bottom':'top'}
,horizontalAnchor:'right',duration:'.35s',className:'actionable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Check,null,data.message,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SanityControls,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__generic__["a" /* Button */],{className:screen==='compact'?'compact':'',label:'Nevermind, back to list',style:{marginRight:'15px'},onClick:function onClick(e){store.clearSanityCheck('indicator');e.nativeEvent.stopImmediatePropagation();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__generic__["a" /* Button */],{label:'Yes, continue',className:'dark '+screen,onClick:function onClick(){data.action();store.clearSanityCheck('indicator');}}))));}}]);return SanityCheck;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class4;var ModTip=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_7__generic__["c" /* Tip */])(_templateObject17,function(p){return p.direction==='above'?-20:20;},function(p){return p.direction==='above'?'50% 100%':'50% 0%';},function(p){return p.direction==='above'?'bottom':'top';},function(p){return p.direction==='above'?'bottom':'top';},function(p){return p.direction==='above'?'top':'bottom';},function(p){return p.direction==='above'?'top':'bottom';},function(p){return p.direction==='above'?tooltipabove:tooltipanim;});var tooltipanim=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject18);var tooltipabove=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* keyframes */])(_templateObject19);var SanityControls=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject20);var Check=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].optimal,__WEBPACK_IMPORTED_MODULE_13__utilities_media__["a" /* default */].compact);var Dashes=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject22);var Workflow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject23);var ListStatus=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject24,function(props){return props.raceDropdown?0.4:props.muted?0.2:1;});var Readout=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject25);var Strong=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject26);var AboutPcts=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject27);var IndLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject28);var NoRaceBadge=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject29,function(props){return props.needRace?'var(--normtext)':'var(--fainttext)';});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = __webpack_require__(152);

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = __webpack_require__(153);

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = __webpack_require__(52);

var _domCss2 = _interopRequireDefault(_domCss);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(25);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = __webpack_require__(160);

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__(161);

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__(162);

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__(163);

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__(164);

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__(165);

var _defaultRenderElements = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props,
                onScroll = _props5.onScroll,
                onScrollFrame = _props5.onScrollFrame,
                onScrollStart = _props5.onScrollStart,
                onScrollStop = _props5.onScrollStop,
                onUpdate = _props5.onUpdate,
                renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName,
                hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded,
                autoHide = _props5.autoHide,
                autoHideTimeout = _props5.autoHideTimeout,
                autoHideDuration = _props5.autoHideDuration,
                thumbSize = _props5.thumbSize,
                thumbMinSize = _props5.thumbMinSize,
                universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(154)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 155 */
/***/ (function(module, exports) {

var div = null
var prefixes = [ 'Webkit', 'Moz', 'O', 'ms' ]

module.exports = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div')
  }

  var style = div.style

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1)

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
}


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {


var space = __webpack_require__(157)

/**
 * Export.
 */

module.exports = toCamelCase

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


var clean = __webpack_require__(158)

/**
 * Export.
 */

module.exports = toSpaceCase

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}


/***/ }),
/* 158 */
/***/ (function(module, exports) {


/**
 * Export.
 */

module.exports = toNoCase

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/
var hasSeparator = /(_|-|\.|:)/
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}


/***/ }),
/* 159 */
/***/ (function(module, exports) {

/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__(52);

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
    height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
    userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
    userSelect: ''
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties(_ref, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties(_ref2, ['style']);

    var finalStyle = _extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties(_ref3, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties(_ref4, ['style']);

    var finalStyle = _extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends({ style: finalStyle }, props));
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/caret.587d601a.svg";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/reset.b94d2d59.svg";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/indicator-states.e2f6ddd6.svg";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/county-states.802b602b.svg";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(__webpack_require__(172));
var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var warning = _interopDefault(__webpack_require__(175));
var CountUp$1 = _interopDefault(__webpack_require__(176));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
      decimals = props.decimals,
      duration = props.duration,
      easingFn = props.easingFn,
      end = props.end,
      formattingFn = props.formattingFn,
      prefix = props.prefix,
      separator = props.separator,
      start = props.start,
      suffix = props.suffix,
      useEasing = props.useEasing;
  return new CountUp$1(el, start, end, decimals, duration, {
    decimal: decimal,
    easingFn: easingFn,
    formattingFn: formattingFn,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator
  });
};

var CountUp =
/*#__PURE__*/
function (_Component) {
  _inherits(CountUp, _Component);

  function CountUp() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CountUp);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CountUp)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "createInstance", function () {
      if (typeof _this.props.children === 'function') {
        // Warn when user didn't use containerRef at all
        warning(_this.containerRef.current && (_this.containerRef.current instanceof HTMLElement || _this.containerRef.current instanceof SVGTextElement || _this.containerRef.current instanceof SVGTSpanElement), "Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an HTMLElement, eg. <span ref={containerRef} />.");
      }

      return createCountUpInstance(_this.containerRef.current, _this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "pauseResume", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          reset = _assertThisInitialize.reset,
          start = _assertThisInitialize.restart,
          update = _assertThisInitialize.update;

      var onPauseResume = _this.props.onPauseResume;

      _this.instance.pauseResume();

      onPauseResume({
        reset: reset,
        start: start,
        update: update
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          pauseResume = _assertThisInitialize2.pauseResume,
          start = _assertThisInitialize2.restart,
          update = _assertThisInitialize2.update;

      var onReset = _this.props.onReset;

      _this.instance.reset();

      onReset({
        pauseResume: pauseResume,
        start: start,
        update: update
      });
    });

    _defineProperty(_assertThisInitialized(_this), "restart", function () {
      _this.reset();

      _this.start();
    });

    _defineProperty(_assertThisInitialized(_this), "start", function () {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          pauseResume = _assertThisInitialize3.pauseResume,
          reset = _assertThisInitialize3.reset,
          start = _assertThisInitialize3.restart,
          update = _assertThisInitialize3.update;

      var _this$props = _this.props,
          delay = _this$props.delay,
          onEnd = _this$props.onEnd,
          onStart = _this$props.onStart;

      var run = function run() {
        return _this.instance.start(function () {
          return onEnd({
            pauseResume: pauseResume,
            reset: reset,
            start: start,
            update: update
          });
        });
      }; // Delay start if delay prop is properly set


      if (delay > 0) {
        _this.timeoutId = setTimeout(run, delay * 1000);
      } else {
        run();
      }

      onStart({
        pauseResume: pauseResume,
        reset: reset,
        update: update
      });
    });

    _defineProperty(_assertThisInitialized(_this), "update", function (newEnd) {
      var _assertThisInitialize4 = _assertThisInitialized(_this),
          pauseResume = _assertThisInitialize4.pauseResume,
          reset = _assertThisInitialize4.reset,
          start = _assertThisInitialize4.restart;

      var onUpdate = _this.props.onUpdate;

      _this.instance.update(newEnd);

      onUpdate({
        pauseResume: pauseResume,
        reset: reset,
        start: start
      });
    });

    _defineProperty(_assertThisInitialized(_this), "containerRef", React__default.createRef());

    return _this;
  }

  _createClass(CountUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          delay = _this$props2.delay;
      this.instance = this.createInstance(); // Don't invoke start if component is used as a render prop

      if (typeof children === 'function' && delay !== 0) return; // Otherwise just start immediately

      this.start();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props3 = this.props,
          end = _this$props3.end,
          start = _this$props3.start,
          suffix = _this$props3.suffix,
          prefix = _this$props3.prefix,
          redraw = _this$props3.redraw,
          duration = _this$props3.duration,
          separator = _this$props3.separator,
          decimals = _this$props3.decimals,
          decimal = _this$props3.decimal;
      var hasCertainPropsChanged = duration !== nextProps.duration || end !== nextProps.end || start !== nextProps.start || suffix !== nextProps.suffix || prefix !== nextProps.prefix || separator !== nextProps.separator || decimals !== nextProps.decimals || decimal !== nextProps.decimal;
      return hasCertainPropsChanged || redraw;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If duration, suffix, prefix, separator or start has changed
      // there's no way to update the values.
      // So we need to re-create the CountUp instance in order to
      // restart it.
      var _this$props4 = this.props,
          end = _this$props4.end,
          start = _this$props4.start,
          suffix = _this$props4.suffix,
          prefix = _this$props4.prefix,
          duration = _this$props4.duration,
          separator = _this$props4.separator,
          decimals = _this$props4.decimals,
          decimal = _this$props4.decimal,
          preserveValue = _this$props4.preserveValue;

      if (duration !== prevProps.duration || start !== prevProps.start || suffix !== prevProps.suffix || prefix !== prevProps.prefix || separator !== prevProps.separator || decimals !== prevProps.decimals || decimal !== prevProps.decimal) {
        this.instance.reset();
        this.instance = this.createInstance();
        this.start();
      } // Only end value has changed, so reset and and re-animate with the updated
      // end value.


      if (end !== prevProps.end) {
        if (!preserveValue) {
          this.instance.reset();
        }

        this.instance.update(end);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      this.instance.reset();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          className = _this$props5.className,
          style = _this$props5.style;
      var containerRef = this.containerRef,
          pauseResume = this.pauseResume,
          reset = this.reset,
          restart = this.restart,
          update = this.update;

      if (typeof children === 'function') {
        return children({
          countUpRef: containerRef,
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      }

      return React__default.createElement("span", {
        className: className,
        ref: containerRef,
        style: style
      });
    }
  }]);

  return CountUp;
}(React.Component);

_defineProperty(CountUp, "propTypes", {
  decimal: PropTypes.string,
  decimals: PropTypes.number,
  delay: PropTypes.number,
  easingFn: PropTypes.func,
  end: PropTypes.number.isRequired,
  formattingFn: PropTypes.func,
  onEnd: PropTypes.func,
  onStart: PropTypes.func,
  prefix: PropTypes.string,
  redraw: PropTypes.bool,
  separator: PropTypes.string,
  start: PropTypes.number,
  startOnMount: PropTypes.bool,
  suffix: PropTypes.string,
  style: PropTypes.object,
  useEasing: PropTypes.bool,
  preserveValue: PropTypes.bool
});

_defineProperty(CountUp, "defaultProps", {
  decimal: '.',
  decimals: 0,
  delay: null,
  duration: null,
  easingFn: null,
  formattingFn: null,
  onEnd: function onEnd() {},
  onPauseResume: function onPauseResume() {},
  onReset: function onReset() {},
  onStart: function onStart() {},
  onUpdate: function onUpdate() {},
  prefix: '',
  redraw: false,
  separator: '',
  start: 0,
  startOnMount: true,
  suffix: '',
  style: undefined,
  useEasing: true,
  preserveValue: false
});

// and just sets the innerHTML of the element.

var MOCK_ELEMENT = {
  innerHTML: null
};

var useCountUp = function useCountUp(props) {
  var _props = _objectSpread2({}, CountUp.defaultProps, {}, props);

  var start = _props.start,
      formattingFn = _props.formattingFn;

  var _useState = React.useState(typeof formattingFn === 'function' ? formattingFn(start) : start),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var countUpRef = React.useRef(null);

  var createInstance = function createInstance() {
    var countUp = createCountUpInstance(MOCK_ELEMENT, _props);
    var formattingFnRef = countUp.options.formattingFn;

    countUp.options.formattingFn = function () {
      var result = formattingFnRef.apply(void 0, arguments);
      setCount(result);
    };

    return countUp;
  };

  var getCountUp = function getCountUp() {
    var countUp = countUpRef.current;

    if (countUp !== null) {
      return countUp;
    }

    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  };

  var reset = function reset() {
    var onReset = _props.onReset;
    getCountUp().reset();
    onReset({
      pauseResume: pauseResume,
      start: restart,
      update: update
    });
  };

  var restart = function restart() {
    var onStart = _props.onStart,
        onEnd = _props.onEnd;
    getCountUp().reset();
    getCountUp().start(function () {
      onEnd({
        pauseResume: pauseResume,
        reset: reset,
        start: restart,
        update: update
      });
    });
    onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  };

  var pauseResume = function pauseResume() {
    var onPauseResume = _props.onPauseResume;
    getCountUp().pauseResume();
    onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  };

  var update = function update(newEnd) {
    var onUpdate = _props.onUpdate;
    getCountUp().update(newEnd);
    onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  };

  React.useEffect(function () {
    var delay = _props.delay,
        onStart = _props.onStart,
        onEnd = _props.onEnd,
        startOnMount = _props.startOnMount;

    if (startOnMount) {
      var timeout = setTimeout(function () {
        onStart({
          pauseResume: pauseResume,
          reset: reset,
          update: update
        });
        getCountUp().start(function () {
          clearTimeout(timeout);
          onEnd({
            pauseResume: pauseResume,
            reset: reset,
            start: restart,
            update: update
          });
        });
      }, delay * 1000);
    }

    return reset;
  }, []);
  return {
    countUp: count,
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update
  };
};

exports.default = CountUp;
exports.useCountUp = useCountUp;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(173)();
}


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(174);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,n){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){var n,t,e,i,r,o,s=a<0;if(a=Math.abs(a).toFixed(l.decimals),a+="",n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),(s?"-":"")+l.options.prefix+t+e+l.options.suffix}function s(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}function u(a){return"number"==typeof a&&!isNaN(a)}var l=this;if(l.version=function(){return"1.9.3"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:s,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),u(l.startVal)&&u(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!u(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"absolute":"_2n4jf95wjupzzq26stq5np7m2hz7uvgk5xtk8nva6e8fmt41xu3mwyvw6zajc7w85zda25beszdb3jpb424abac259x5s3fzm1c9qn2-CountingNumber-module-absolute"};

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breakdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_commaNumber__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IndicatorByRaces__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IndicatorByCounties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Sources__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_media__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _templateObject=_taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    position: relative;\n'],['\n    width: 100%;\n    height: 100%;\n    position: relative;\n']),_templateObject2=_taggedTemplateLiteral(['\n    flex-grow: 1;\n'],['\n    flex-grow: 1;\n']),_templateObject3=_taggedTemplateLiteral(['\n    margin-top: 20px;\n'],['\n    margin-top: 20px;\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%;\n    top: -20px;\n    left: 0;\n    height: calc(100% + 40px);\n    overflow: hidden;\n    z-index: 2;\n    pointer-events: none;\n    &::after{\n        content: \'\';\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        right: -100%;\n        background: var(--offwhitefg);\n        transform: translateX(','%);\n        transition: transform .3s;\n    }\n'],['\n    position: absolute;\n    width: 100%;\n    top: -20px;\n    left: 0;\n    height: calc(100% + 40px);\n    overflow: hidden;\n    z-index: 2;\n    pointer-events: none;\n    &::after{\n        content: \'\';\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        right: -100%;\n        background: var(--offwhitefg);\n        transform: translateX(','%);\n        transition: transform .3s;\n    }\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var BreakdownBox=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2);var BottomTable=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3);var Breakdown=Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(Breakdown,_React$Component);function Breakdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Breakdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Breakdown.__proto__||Object.getPrototypeOf(Breakdown)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'allCounties',_descriptor,_this),_initDefineProp(_this,'expandCountyList',_descriptor2,_this),_initDefineProp(_this,'fixedMobileX',_descriptor3,_this),_initDefineProp(_this,'setMobileX',_descriptor4,_this),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Breakdown,[{key:'componentDidUpdate',value:function componentDidUpdate(oldProps){if(this.props.sources!==oldProps.sources){this.expandCountyList(false);}if(this.props.store.indicator!==oldProps.store.indicator){this.expandCountyList(false);}}},{key:'render',value:function render(){var _this2=this;var store=this.props.store;var indicator=store.indicator,county=store.county,race=store.race,year=store.year,screen=store.screen;//CALCULATE # ENTRIES FOR FIRST CHART FROM OFFSET + HASRACE
var hasRace=__WEBPACK_IMPORTED_MODULE_9__data_indicators__["a" /* default */][indicator].categories.includes('hasRace');var entryCount=0;if(indicator){if(screen==='optimal'){if(hasRace)entryCount=14;else entryCount=22;}if(screen==='compact'){if(hasRace)entryCount=9;else entryCount=17;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IndicatorByCounties__["a" /* default */],{entries:entryCount,store:store,onExpand:this.expandCountyList,hasRace:hasRace,expand:this.allCounties,toggleDistribute:function toggleDistribute(){console.log('toggling distribution...');_this2.expandCountyList(!_this2.allCounties?true:false);},sources:this.props.sources}),indicator&&hasRace&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__IndicatorByRaces__["a" /* default */],{store:store,expand:!this.allCounties,onClick:this.allCounties?function(){console.log('trying to collapse counties');_this2.expandCountyList(false);}:function(){},hideForSources:this.props.sources}),indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Sources__["b" /* default */],{screen:screen,indicator:indicator,expand:this.props.sources}));}}]);return Breakdown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'allCounties',[__WEBPACK_IMPORTED_MODULE_3_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'expandCountyList',[__WEBPACK_IMPORTED_MODULE_3_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(tf){return _this3.allCounties=tf;};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'fixedMobileX',[__WEBPACK_IMPORTED_MODULE_3_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'setMobileX',[__WEBPACK_IMPORTED_MODULE_3_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(tf){return _this4.fixedMobileX=tf;};}})),_class2))||_class;var InfoMask=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.on?-100:10;});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observer__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(32);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var observerOptions = ['root', 'rootMargin', 'threshold'];
var observerProps = ['disabled'].concat(observerOptions);
var objectProto = Object.prototype;

var IntersectionObserver = function (_React$Component) {
    _inherits(IntersectionObserver, _React$Component);

    function IntersectionObserver() {
        var _temp, _this, _ret;

        _classCallCheck(this, IntersectionObserver);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (event) {
            _this.props.onChange(event, _this.unobserve);

            if (_this.props.onlyOnce) {
                // eslint-disable-next-line no-undef
                if (false) {
                    invariant('isIntersecting' in event, "onlyOnce requires isIntersecting to exists in IntersectionObserverEntry's prototype. Either your browser or your polyfill lacks support.");
                }
                if (event.isIntersecting) {
                    _this.unobserve();
                }
            }
            // eslint-disable-next-line no-undef
            if (false) {
                warning(!_this.props.hasOwnProperty('onlyOnce'), 'ReactIntersectionObserver: [deprecation] Use the second argument of onChange to unobserve a target instead of onlyOnce. This prop will be removed in the next major version.');
            }
        }, _this.handleNode = function (target) {
            /**
             * Forward hijacked ref to user.
             */
            var nodeRef = _this.props.children.ref;
            if (nodeRef) {
                if (typeof nodeRef === 'function') {
                    nodeRef(target);
                } else if ((typeof nodeRef === 'undefined' ? 'undefined' : _typeof(nodeRef)) === 'object') {
                    nodeRef.current = target;
                }
            }

            /**
             * This is a bit ugly: would like to use getSnapshotBeforeUpdate(), but we do not want to depend on
             * react-lifecycles-compat to support React versions prior to 16.3 as this extra boolean gets the job done.
             */
            _this.targetChanged = (_this.renderedTarget && target) != null && _this.renderedTarget !== target;
            if (_this.targetChanged) {
                _this.unobserve();
            }
            _this.target = target;
        }, _this.observe = function () {
            _this.target = Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* isDOMTypeElement */])(_this.target) ? _this.target : Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.target);
            _this.observer = Object(__WEBPACK_IMPORTED_MODULE_5__observer__["a" /* createObserver */])(_this.options);
            Object(__WEBPACK_IMPORTED_MODULE_5__observer__["b" /* observeElement */])(_this);
        }, _this.unobserve = function () {
            if (_this.target != null) {
                Object(__WEBPACK_IMPORTED_MODULE_5__observer__["c" /* unobserveElement */])(_this);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    IntersectionObserver.prototype.componentDidMount = function componentDidMount() {
        // eslint-disable-next-line no-undef
        if (false) {
            invariant(this.target, 'Stateless function components cannot be given refs. Attempts to access this ref will fail.');
        }
        if (!this.props.disabled) {
            this.observe();
        }
    };

    IntersectionObserver.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this2 = this;

        var propsChanged = observerProps.some(function (prop) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* shallowCompare */])(_this2.props[prop], prevProps[prop]);
        });

        if (propsChanged) {
            this.unobserve();
        }

        if (this.targetChanged || propsChanged) {
            if (!this.props.disabled) {
                this.observe();
            }
        }
    };

    IntersectionObserver.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unobserve();
    };

    IntersectionObserver.prototype.render = function render() {
        this.renderedTarget = this.target; // this value is null on the first render

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children), {
            ref: this.handleNode
        });
    };

    _createClass(IntersectionObserver, [{
        key: 'options',
        get: function get() {
            var _this3 = this;

            return observerOptions.reduce(function (options, key) {
                if (objectProto.hasOwnProperty.call(_this3.props, key)) {
                    var useQuery = key === 'root' && objectProto.toString.call(_this3.props[key]) === '[object String]';
                    options[key] = useQuery ? document.querySelector(_this3.props[key]) : _this3.props[key];
                }
                return options;
            }, {});
        }
    }]);

    return IntersectionObserver;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

IntersectionObserver.displayName = 'IntersectionObserver';
/* harmony default export */ __webpack_exports__["a"] = (IntersectionObserver);
 false ? IntersectionObserver.propTypes = {
    /**
     * The element that is used as the target to observe.
     */
    children: PropTypes.element.isRequired,

    /**
     * The element that is used as the viewport for checking visibility of the target.
     * Can be specified as string for selector matching within the document.
     * Defaults to the browser viewport if not specified or if null.
     */
    root: PropTypes.oneOfType([PropTypes.string].concat(typeof HTMLElement === 'undefined' ? [] : PropTypes.instanceOf(HTMLElement))),

    /**
     * Margin around the root. Can have values similar to the CSS margin property,
     * e.g. "10px 20px 30px 40px" (top, right, bottom, left).
     * If the root element is specified, the values can be percentages.
     * This set of values serves to grow or shrink each side of the root element's
     * bounding box before computing intersections.
     * Defaults to all zeros.
     */
    rootMargin: PropTypes.string,

    /**
     * Either a single number or an array of numbers which indicate at what percentage
     * of the target's visibility the observer's callback should be executed.
     * If you only want to detect when visibility passes the 50% mark, you can use a value of 0.5.
     * If you want the callback run every time visibility passes another 25%,
     * you would specify the array [0, 0.25, 0.5, 0.75, 1].
     * The default is 0 (meaning as soon as even one pixel is visible, the callback will be run).
     * A value of 1.0 means that the threshold isn't considered passed until every pixel is visible.
     */
    threshold: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

    /**
     * When true indicate that events fire only until the element is intersecting.
     * Different browsers behave differently towards the isIntersecting property, make sure
     * you polyfill and/or override the IntersectionObserverEntry object's prototype to your needs.
     * Defaults to false.
     */
    onlyOnce: PropTypes.bool,

    /**
     * Controls whether the element should stop being observed by its IntersectionObserver instance.
     * Defaults to false.
     */
    disabled: PropTypes.bool,

    /**
     * Function that will be invoked whenever the intersection value for this element changes.
     */
    onChange: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export observerElementsMap */
/* unused harmony export getPooled */
/* unused harmony export findObserverElement */
/* unused harmony export callback */
/* harmony export (immutable) */ __webpack_exports__["a"] = createObserver;
/* harmony export (immutable) */ __webpack_exports__["b"] = observeElement;
/* harmony export (immutable) */ __webpack_exports__["c"] = unobserveElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);


var observerElementsMap = new Map();

function getPooled() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var root = options.root || null;
    var rootMargin = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* parseRootMargin */])(options.rootMargin);
    var threshold = Array.isArray(options.threshold) ? options.threshold : [options.threshold != null ? options.threshold : 0];
    var observers = observerElementsMap.keys();
    var observer = void 0;
    while (observer = observers.next().value) {
        var unmatched = root !== observer.root || rootMargin !== observer.rootMargin || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* shallowCompare */])(threshold, observer.thresholds);

        if (!unmatched) {
            return observer;
        }
    }
    return null;
}

function findObserverElement(observer, entry) {
    var elements = observerElementsMap.get(observer);
    if (elements) {
        var values = elements.values();
        var element = void 0;
        while (element = values.next().value) {
            if (element.target === entry.target) {
                return element;
            }
        }
    }
    return null;
}

/**
 * The Intersection Observer API callback that is called whenever one element,
 * called the target, intersects either the device viewport or a specified element.
 * Also will get caled whenever the visibility of the target element changes and
 * crosses desired amounts of intersection with the root.
 * @param {array} changes
 * @param {IntersectionObserver} observer
 */
function callback(changes, observer) {
    for (var i = 0; i < changes.length; i++) {
        var element = findObserverElement(observer, changes[i]);
        if (element) {
            element.handleChange(changes[i]);
        }
    }
}

function createObserver(options) {
    return getPooled(options) || new IntersectionObserver(callback, options);
}

function observeElement(element) {
    if (!observerElementsMap.has(element.observer)) {
        observerElementsMap.set(element.observer, new Set());
    }
    observerElementsMap.get(element.observer).add(element);
    element.observer.observe(element.target);
}

function unobserveElement(element) {
    if (observerElementsMap.has(element.observer)) {
        var targets = observerElementsMap.get(element.observer);
        if (targets.delete(element)) {
            if (targets.size > 0) {
                element.observer.unobserve(element.target);
            } else {
                element.observer.disconnect();
                observerElementsMap.delete(element.observer);
            }
        }
    }
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var indicator = __webpack_require__(184)

function ordinal (i) {
  if (typeof i !== 'number') throw new TypeError('Expected Number, got ' + (typeof i) + ' ' + i)

  if (!Number.isFinite(i)) return i
  return i + indicator(i)
}

ordinal.indicator = indicator
module.exports = ordinal


/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = function indicator (i) {
  i = Math.abs(i)
  var cent = i % 100
  if (cent >= 10 && cent <= 20) return 'th'
  var dec = i % 10
  if (dec === 1) return 'st'
  if (dec === 2) return 'nd'
  if (dec === 3) return 'rd'
  return 'th'
}


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sources=[{"indicator":"breastFeeding","url":"https://www.cdph.ca.gov/Programs/CFH/DMCAH/Breastfeeding/Pages/Data.aspx","source":"California Department of Public Health (n.d.). In-Hospital Breastfeeding Initiation Data. Retrieved July 2018.","notes":"An asterisk (*) appears for fewer than 10 events in the numerator. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian and Pacific Islander. The Other category includes American Indian, Other, and Multiple Races.","redirect":"For more information on this indicator’s methodology, please contact the California Department of Public Health.","methoURL":"https://www.cdph.ca.gov/Programs/CFH/DMCAH/Pages/Contact-Us.aspx"},{"indicator":"childCareSlots","url":"https://www.rrnetwork.org/california_child_care_portfolio","source":"California Child Care Resource & Referral Network (2018). 2015 & 2017 California Child Care Portfolio. Retrieved July 2018.","notes":"Data retrieved from the California Child Care Portfolio Report.","redirect":"For more information on this indicator’s methodology, please contact the California Child Care Resource & Referral Network.","methoURL":"https://www.rrnetwork.org/rr_research_in_action"},{"indicator":"collegeCareerReady","url":"https://www6.cde.ca.gov/californiamodel/?indicator=cci","source":"California Department of Education (n.d.). California Accountably Model & School Dashboard – College/Career Indicator Reports & Data. Retrieved August 2018.","notes":"An asterisk (*) appears where there are 10 or fewer students to protect student privacy. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Pacific Islander, and Filipino. The Other category includes American Indian or Alaska Native, Two or More Races, and Not Reported.","redirect":"For more information on this indicator’s methodology, please contact the California Accountably Model and School Dashboard.","methoURL":"https://www.cde.ca.gov/ta/ac/cm/cci.asp"},{"indicator":"collegeLevelMath","url":"https://caaspp.cde.ca.gov/sb2017/default","source":"California Department of Education (n.d.). California Assessment of Student Performance and Progress 2015-16 & 2016-17 Results. Retrieved August 2018.","notes":"In order to protect student privacy an asterisk (*) is displayed instead of a number on test results where 10 or fewer students had tested. Numbers and Percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Filipino, and Native Hawaiian or Pacific Islander. The Other category includes American-Indian or Alaska Native and Two Races.","redirect":"To learn more about the Assessment results please contact the California Assessment of Students Performance and Progress.","methoURL":"https://caaspp.cde.ca.gov/sb2016/UnderstandingCAASPPReports"},{"indicator":"connected","url":"","source":"California School Climate, Health, and Learning Surveys (n.d). Elementary & Secondary Student Survey 2015-16 & 2016-17.","notes":"Data provided and prepared by CalSCHLS Staff through a special request. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, and Native Hawaiian or Pacific Islander. The Other category includes American-Indian or Alaska Native and Mixed (two or more) Races.","redirect":"For information on this indicator’s methodology, please contact the California Health Interview Survey.","methoURL":"https://calschls.org/contact/"},{"indicator":"difference","url":"","source":"California School Climate, Health, and Learning Surveys (n.d). Elementary & Secondary Student Survey 2015-16 & 2016-17.","notes":"Data provided and prepared by CalSCHLS Staff through a special request. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, and Native Hawaiian or Pacific Islander. The Other category includes American-Indian or Alaska Native and Mixed (two or more) Races.","redirect":"For information on this indicator’s methodology, please contact the California Health Interview Survey.","methoURL":"https://calschls.org/contact/"},{"indicator":"earlyPrenatalCare","url":"","source":"California Department of Public Health, Maternal Child and Adolescent Health Division (n.d.). 2015 Birth Statistical Master File.","notes":"Data provided and prepared by the California Department of Public Health, Epidemiology, Surveillance and Federal Reporting Branch through a special request. An asterisk (*) appears for fewer than 10 events in the numerator. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Other category includes Other, Multiple Race, American Indian, and Unknown.","redirect":"For more information on this indicator’s methodology, please contact the California Department of Public Health, Maternal Child and Adolescent Health Division.","methoURL":"https://www.cdph.ca.gov/Programs/CFH/DMCAH/Pages/Contact-Us.aspx"},{"indicator":"englishLearners","url":"https://data1.cde.ca.gov/dataquest/","source":"California Department of Education, DataQuest (n.d.). Student Demographics – English Learners data 2016-17 & 2017-18. Retrieved August 2018.","notes":"Numbers and percentages are rounded to the nearest whole number.","redirect":"For more information on this indicator’s methodology, please contact DataQuest.","methoURL":"https://www.cde.ca.gov/ta/tg/el/"},{"indicator":"enrolled34","url":"","source":"United States Census Bureau / American FactFinder (n.d.). “Enrolled in School” 2007-2011 and 2012-2016 American Community Survey.","notes":"Data provided by the Population Reference Bureau through a special request, representing the Population Reference Bureau’s analysis of the 2007-2011 and 2012-2016 American Community Survey for 3-and 4-year-olds enrolled in school. Numbers and percentages are rounded to the nearest whole number. For more information on this indicator’s methodology, please contact the American Community Survey.","notes2":"An asterisk (*) appears for data suppressed under the following conditions 1) The margin of error is 5 or more percentage points (plus or minus) 2) The margin of error exceeds the point estimate (percent) 3) The weighted universe is zero. Estimates are based on a survey of the population and are subject to both sampling and nonsampling error. Margins of error are based on unrounded point estimates.","redirect":"For more information on this indicator’s methodology, please contact the American Community Survey.","methoURL":"https://www.census.gov/programs-surveys/acs/methodology.html"},{"indicator":"familyLike","url":"http://cssr.berkeley.edu/ucb_childwelfare","source":"Webster, D., Lee, S., Dawson, W., Magruder, J., Exel, M., Cuccaro-Alamin, S., ...& Lee, H. (2018). CCWIP reports, University of California at Berkeley California Child Welfare Indicators Project. Retrieved August 2018.","notes":"Children Now used CCWIP data – Point-in-time/in care (Entry Cohort) for 2016 & 2017. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian and Pacific Islander. The Other category includes Native American and Missing.","redirect":"For more information on this indicator’s methodology, please contact CCWIP.","methoURL":"http://cssr.berkeley.edu/cwscmsreports/methodologies/default.aspx?report=Siblings"},{"indicator":"fosterYouthGraduation","url":"https://data1.cde.ca.gov/dataquest/","source":"California Department of Education, DataQuest (n.d.). Student Demographic – Four-Year Cohort Graduation Rate & Outcome data, subgroup Foster Youth, 2015-16 & 2016-17. Retrieved August 2018.","notes":"Children Now used graduation rates from the cohort outcome data for Foster Youth. Due to changes in the methodology for calculating the 2016-17 Adjusted Cohort Graduation Rate and subsequent years, the California Department of Education strongly discourages against comparing the 2016-17 Adjusted Cohort Graduation Rate with the cohort data from prior years. An asterisk (*) appears where there are ten or fewer students to protect student privacy. Numbers and percentages are rounded to the nearest whole number.","redirect":"For more information on this indicator’s methodology, please contact DataQuest.","methoURL":"https://www.cde.ca.gov/ds/sd/sd/acgrinfo.asp"},{"indicator":"FRPMSchoolYear","url":"https://cfpa.net/sowa-2017/","url2":"https://www.cde.ca.gov/ds/sd/sd/filessp.asp","source":"California Food Policy Advocates (2018). “School’s Out…Who Ate?” 2017 Report. Retrieved August 2018.","source2":"California Department of Education, Public Files (n.d.). Free and Reduced Price Meal Count (K-12) data 2016. Retrieved August 2018.","notes":"Children Now’s analysis of California Food Policy Advocates’ Average Daily Participation School Year Count and Total Count of students eligible for free and reduced-price meals. Numbers and percentages are rounded to the nearest whole number.","redirect":"","methoURL":""},{"indicator":"FRPMSummer","url":"https://cfpa.net/sowa-2017/","url2":"https://www.cde.ca.gov/ds/sd/sd/filessp.asp","source":"California Food Policy Advocates (2018). “School’s Out…Who Ate?” 2017 Report. Retrieved August 2018.","source2":"California Department of Education, Public Files (n.d.). Free and Reduced Price Meal Count (K-12) data 2016. Retrieved August 2018.","notes":"Children Now’s analysis of the California Food Policy Advocates’ Average Daily Participation Summer Count and Total Count of students eligible for free and reduced price meals. Numbers and percentages are rounded to the nearest whole number.","redirect":"","methoURL":""},{"indicator":"FYTimelyDental","url":"http://cssr.berkeley.edu/ucb_childwelfare","source":"Webster, D., Lee, S., Dawson, W., Magruder, J., Exel, M., Cuccaro-Alamin, S., ...& Lee, H. (2018). CCWIP reports, University of California at Berkeley California Child Welfare Indicators Project. Retrieved August 2018.","notes":"Children Now used CCWIP data – Timely Health/Dental Exams for 2016 & 2017. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian and Pacific Islander. The Other category includes Native American and Missing.","redirect":"For more information on this indicator’s methodology, please contact CCWIP.","methoURL":"http://cssr.berkeley.edu/cwscmsreports/methodologies/default.aspx?report=Siblings"},{"indicator":"FYTimelyMedical","url":"http://cssr.berkeley.edu/ucb_childwelfare","source":"Webster, D., Lee, S., Dawson, W., Magruder, J., Exel, M., Cuccaro-Alamin, S., ...& Lee, H. (2018). CCWIP reports, University of California at Berkeley California Child Welfare Indicators Project. Retrieved August 2018.","notes":"Children Now used CCWIP data – Timely Health/Dental Exams for 2016 & 2017. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian and Pacific Islander. The Other category includes Native American and Missing.","redirect":"For more information on this indicator’s methodology, please contact CCWIP.","methoURL":"http://cssr.berkeley.edu/cwscmsreports/methodologies/default.aspx?report=Siblings"},{"indicator":"graduation","url":"https://data1.cde.ca.gov/dataquest/","source":"California Department of Education, DataQuest (n.d.). Student Demographic – Four-Year Cohort Graduation Rate & Outcome data 2015-16 & 2016-17. Retrieved August 2018.","notes":"Children Now used graduation rates from the cohort outcome data. Due to changes in the methodology for calculating the 2016-17 Adjusted Cohort Graduation Rate and subsequent years, the California Department of Education strongly discourages against comparing the 2016-17 Adjusted Cohort Graduation Rate with the cohort data from prior years. An asterisk (*) appears where there are ten or fewer students to protect student privacy. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Pacific Islander, and Filipino. The Other category includes American Indian or Alaska Native, Two or More Races, and Not Reported.","redirect":"For more information on this indicator’s methodology, please contact DataQuest.","methoURL":"https://www.cde.ca.gov/ds/sd/sd/acgrinfo.asp"},{"indicator":"healthInsurance","url":"","source":"United States Census Bureau / American FactFinder (n.d.). “Health Insurance”  2007-2011 and 2012-2016 American Community Survey.","notes":"Data provided by the Population Reference Bureau through a special request, representing the Population Reference Bureau’s analysis of the 2008-2012 and 2012-2016 American Community Survey for children 0-17 with health insurance.","notes2":"An asterisk (*) appears for data suppressed under the following conditions: 1) The margin of error is 5 or more percentage points (plus or minus) 2) The margin of error exceeds the point estimate (percent) 3) The weighted universe is zero. Estimates are based on a survey of the population and are subject to both sampling and nonsampling error. Margins of error are based on unrounded point estimates.","redirect":"For more information on this indicator’s methodology, please contact the American Community Survey.","methoURL":"https://www.census.gov/programs-surveys/acs/methodology.html"},{"indicator":"homelessness","url":"https://data1.cde.ca.gov/dataquest/","source":"California Department of Education, DataQuest (n.d.). Student Demographics – Enrollment 2017-18. Retrieved August 2018.","redirect":"For more information on this indicator’s methodology, please contact DataQuest.","methoURL":"https://www.cde.ca.gov/sp/hs/homelessdef.asp"},{"indicator":"immigrantFamilies","url":"https://factfinder.census.gov/faces/nav/jsf/pages/index.xhtml","source":"United States Census Bureau / American FactFinder (n.d.). Table B05009, 2012 – 2016  American Community Survey. Retrieved September 2018.","notes":"The number of children living with one or more immigrant parents is from table B05009 from the American Community Survey. To get the total count of children living with one or more immigrant parents Children Now combined the following categories: 1) both parents foreign-born 2) one of two parents foreign-born 3) single parent foreign-born.","redirect":"For more information on this indicator’s methodology, please contact the American Community Survey.","methoURL":"https://www.census.gov/programs-surveys/acs/methodology.html"},{"indicator":"lowIncomeDental","url":"","source":"California Health and Human Services Open Data Portal (2018). Dental Utilization Measures and Sealant data by County, Ethnicity, & Age 2015 & 2016. Retrieved August 2018.","notes":"Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Native Hawaiian, or Pacific Islander. The Other category includes Alaskan Native or American Indian, Other, and Invalid/Unknown.","redirect":"For more information on this indicator’s methodology, please contact the Department of Health Care Services, Medi-Cal Dental Services Division.","methoURL":"https://www.dhcs.ca.gov/services/Pages/DentalReports.aspx"},{"indicator":"mathStandards8","url":"https://caaspp.cde.ca.gov/sb2017/default","source":"California Department of Education (n.d.). California Assessment of Student Performance and Progress 2015-16 & 2016-17 Results. Retrieved August 2018.","notes":"In order to protect student privacy an asterisk (*) is displayed instead of a number on test results where 10 or fewer students had tested. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Filipino, and Native Hawaiian or Pacific Islander. The Other category includes American-Indian or Alaska Native and Two Races.","redirect":"To learn about the Assessment results please contact the California Assessment of Students Performance and Progress website.","methoURL":"https://caaspp.cde.ca.gov/sb2016/UnderstandingCAASPPReports"},{"indicator":"notAbsent","url":"https://data1.cde.ca.gov/dataquest/","source":"California Department of Education, DataQuest (n.d.). Absenteeism, Student Misconduct, and Intervention – Absenteeism data 2015-16 & 2016-17. Retrieved August 2018.","notes":"Children Now used the inverse percentage of the Chronic Absenteeism Rate from the California Department of Education, DataQuest. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Pacific Islander, and Filipino. The Other category includes American Indian or Alaska Native, Two or More Races, and Not Reported.","redirect":"For more information on this indicator’s methodology, please contact DataQuest.","methoURL":"https://www.cde.ca.gov/ds/sd/sd/fsabd.asp"},{"indicator":"notFoodInsecure","url":"http://map.feedingamerica.org/","source":"Feeding America (2018). Map The Meal Gap: Child Food Insecurity in California by County in 2015 & 2016. Retrieved July 2018.","notes":"Data received from Feeding America’s “Map The Meal Gap” report. Numbers and percentages are rounded to the nearest whole number.","redirect":"For more information on this indicator’s methodology, please contact Feeding America.","methoURL":"http://map.feedingamerica.org/"},{"indicator":"notLowBirthWeight","url":"","source":"California Department of Public Health, Maternal Child and Adolescent Health Division (n.d.). 2015 Birth Statistical Master File.","notes":"Data provided and prepared by the California Department of Public Health, Epidemiology, Surveillance and Federal Reporting Branch through a special request. An asterisk (*) appears for fewer than 10 events in the numerator. To calculate “not low birthweight,” Children Now combined intermediate and high birthweights, which includes births that were greater than or equal to 2,500 grams. Numbers and percentages are rounded to the nearest whole number","notes2":"The Other category includes Other, Multiple Race, American Indian, and Unknown.","redirect":"For more information on this indicator’s methodology, please contact the California Department of Public Health, Maternal Child and Adolescent Health Division.","methoURL":"https://www.cdph.ca.gov/Programs/CFH/DMCAH/Pages/Contact-Us.aspx"},{"indicator":"notObese","url":"https://data1.cde.ca.gov/dataquest/","source":"California Department of Education, DataQuest (n.d.). Test Scores – Physical Fitness Test data 2015-16 & 2016-17. Retrieved August 2018.","notes":"An asterisk (*) appears where there are 10 or fewer students to protect student privacy. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Pacific Islander, and Filipino. The Other category includes American Indian or Alaska Native, Two or More Races, and Not Reported.","redirect":"For more information on this indicator’s methodology, please contact DataQuest.","methoURL":"https://www.cde.ca.gov/ta/tg/pf/healthfitzones.asp"},{"indicator":"permanency","url":"http://cssr.berkeley.edu/ucb_childwelfare","source":"Webster, D., Lee, S., Dawson, W., Magruder, J., Exel, M., Cuccaro-Alamin, S., ...& Lee, H. (2018). CCWIP reports, University of California at Berkeley California Child Welfare Indicators Project. Retrieved August 2018.","notes":"Children Now used CCWIP data – Entry Cohorts Over Time for 2015 & 2016. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian and Pacific Islander. The Other category includes Native American and Missing.","redirect":"For more information on this indicator’s methodology, please contact CCWIP.","methoURL":"http://cssr.berkeley.edu/cwscmsreports/methodologies/default.aspx?report=Siblings"},{"indicator":"placementStability","url":"http://cssr.berkeley.edu/ucb_childwelfare","source":"Webster, D., Lee, S., Dawson, W., Magruder, J., Exel, M., Cuccaro-Alamin, S., ...& Lee, H. (2018). CCWIP reports, University of California at Berkeley California Child Welfare Indicators Project. Retrieved August 2018.","notes":"Children Now used CCWIP data – Placement Stability (Entry Cohort) for 2015 & 2016. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian and Pacific Islander. The Other category includes Native American and Missing.","redirect":"For more information on this indicator’s methodology, please contact CCWIP.","methoURL":"http://cssr.berkeley.edu/cwscmsreports/methodologies/default.aspx?report=Siblings"},{"indicator":"population","url":"http://www.dof.ca.gov/Forecasting/Demographics/Projections/","source":"State of California Department of Finance (n.d.). County and State Population Projections (2010-2060) by Age. Retrieved September 2018.","redirect":"For more information on this indicator’s methodology, please contact the Department of Finance.","methoURL":"http://www.dof.ca.gov/Forecasting/Demographics/Projections/"},{"indicator":"poverty","url":"https://factfinder.census.gov/faces/nav/jsf/pages/index.xhtml","source":"United States Census Bureau / American FactFinder (n.d.). Table B17024, “Percent Below 200% of Poverty” 2012 – 2016 American Community Survey. Retrieved September 2018.","redirect":"For more information on this indicator’s methodology, please contact the American Community Survey.","methoURL":"https://www.census.gov/programs-surveys/acs/methodology.html"},{"indicator":"raceBreakdown","url":"http://www.dof.ca.gov/Forecasting/Demographics/Projections/","source":"State of California Department of Finance (n.d.). County and State Population Projections (2010-2060) by Age and Race/Ethnicity. Retrieved September 2018.","notes":"Numbers and percentages are rounded to the nearest whole number.","redirect":"For more information on this indicator’s methodology, please contact the Department of Finance.","methoURL":"http://www.dof.ca.gov/Forecasting/Demographics/Projections/"},{"indicator":"readingStandards","url":"https://caaspp.cde.ca.gov/sb2017/default","source":"California Department of Education (n.d.). California Assessment of Student Performance and Progress 2015-16 & 2016-17 Results. Retrieved August 2018.","notes":"In order to protect student privacy an asterisk (*) is displayed instead of a number on test results where 10 or fewer students had tested. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Filipino, and Native Hawaiian or Pacific Islander. The Other category includes American-Indian or Alaska Native and Two Races.","redirect":"To learn about the Assessment results please contact the California Assessment of Students Performance and Progress website.","methoURL":"https://caaspp.cde.ca.gov/sb2016/UnderstandingCAASPPReports"},{"indicator":"readToEveryday","url":"https://healthpolicy.ucla.edu/Pages/AskCHIS.aspx","source":"UCLA Center for Health Policy Research (n.d.). California Health Interview Survey. Retrieved August 2018.","notes":"Data should be interpreted with caution due to statistically unstable data. Children Now pooled two years of data for each reported year. Numbers and percentages are rounded to the nearest whole number. All data points should be considered statistically unstable (due to small sample sizes) except for the following:","notes2":"Report year 2013 & 2014: California categories: Total, Latino, White, and Asian. Colusa categories: Total and Latino. Fresno category: Latino. Glenn categories: Total and Latino. Kings category: Latino. Los Angeles categories: Total, Latino, and Asian. Marin category: Total. Monterey category: Total. Orange category: Total. Riverside categories: Total and Latino. San Bernardino categories: Total, Latino, and White. San Diego categories: Total and Latino. San Joaquin category: Total. Santa Clara category: Total. Sonoma categories: Total and Latino. Stanislaus category: Total. Tehama categories: Total and Latino. Ventura category: Total. Yuba category: Latino.","notes3":"Report year 2015 & 2016: California categories: Total, Latino, White, Asian, and Other. Kern category: Latino. Los Angeles categories: Total and Latino. Riverside categories: Total and Latino. San Bernardino categories: Total and Latino. San Diego categories: Total and Latino. Stanislaus category: Total. Sutter category: Latino.","notes4":"The Asian category includes Asian and Native Hawaiian/Pacific Islander. The Other category includes American-Indian/Alaska Native and Two or More Races.","redirect":"For more information on this indicator’s methodology, please contact the California Health Interview Survey.","methoURL":"http://healthpolicy.ucla.edu/chis/design/Pages/methodology.aspx"},{"indicator":"registeredToVote","url":"http://www.sos.ca.gov/elections/voter-registration/voter-registration-statistics/","url2":"http://www.dof.ca.gov/Forecasting/Demographics/Projections/","source":"The California Secretary of State (n.d.). Voter Registration Statistics – June 5, 2018 Statewide Direct Primary Election. Retrieved September 2018.","source2":"State of California Department of Finance (n.d.). County and State Population Projections (2010-2060) by Age. Retrieved September 2018.","notes":"Children Now’s analysis of the Secretary of State’s count of registered voters aged 18-25 in 2018, with 2018 population estimates for 18-25-year-olds from the Department of Finance. Numbers and percentages are rounded to the nearest whole number.","redirect":"","methoURL":""},{"indicator":"suspension","url":"https://data1.cde.ca.gov/dataquest/","source":"California Department of Education, DataQuest (n.d.). Absenteeism, Student Misconduct, and Intervention – Expulsion and Suspension data 2015-16 & 2016-17. Retrieved August 2018.","notes":"An asterisk (*) appears where there are 10 or fewer students to protect student privacy. Numbers and percentages are rounded to the nearest whole number.","notes2":"The Asian category includes Asian, Pacific Islander, and Filipino. The Other category includes American Indian or Alaska Native, Two or More Races, and Not Reported.","redirect":"For more information on this indicator’s methodology, please contact DataQuest.","methoURL":"https://www.cde.ca.gov/ds/sd/sd/fssd.asp"},{"indicator":"upToDateImmunizations","url":"http://www.shotsforschool.org/","source":"California Department of Public Heath, Immunizations Branch (2018). School Immunizations in Kindergarten 2016-17 & 2017-18. Retrieved August 2018.","notes":"An asterisk (*) appears for county reporting fewer than 20 children in kindergarten. Numbers and percentages are rounded to the nearest whole number.","redirect":"For more information on this indicator’s methodology, please contact the California Department of Public Health, Immunizations Branch.","methoURL":"http://www.shotsforschool.org/k-12/reporting-data/"}];/* harmony default export */ __webpack_exports__["a"] = (sources);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hatch1-2.cc080e60.svg";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hatch2-4.301df1ff.svg";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hatch3-2.4b61c798.svg";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hatch4-2.e86c886a.svg";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hatch5-2.0627765e.svg";

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var copy={firstpara:'Welcome! This tool aims to provide a comprehensive look at how children are doing in California’s 58 counties, with data viewable by year and race/ethnicity.',secondpara:'Some data is unreported, incomplete or unavailable due to small sample size and/or a high margin of error.',title:'2018-19 California County Scorecard of Children’s Well-Being',compatibility:'This tool supports recent versions of Chrome, Safari, and Firefox on Android, iOS, Mac OS, and Windows.'};/* harmony default export */ __webpack_exports__["a"] = (copy);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/getstarted.e99ba6b8.svg";

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileScorecard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__researchgate_react_intersection_observer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intersection_observer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_generic_Icon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ExpandBox__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Styles__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MobileNav__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_components_IndicatorByCounties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_components_IndicatorByRaces__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_components_Readout__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_components_ZoomableMap__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_components_DemoBox__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_components_Sources__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_components_InitBox__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_requestidlecallback__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_requestidlecallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_requestidlecallback__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18,_descriptor19,_class4,_desc2,_value2,_class5,_descriptor20,_descriptor21,_class7;var _templateObject=_taggedTemplateLiteral(['\n    margin-top: 55px;\n    margin-bottom: 67px;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0; left: 0;\n    padding: 10px 20px 60px 20px;\n    transform: translateX(','%);\n    transition: ',';\n    overflow-x: hidden;\n    overflow-y: scroll;\n    // background: var(--offwhitefg);\n    visibility: ',';\n\n'],['\n    margin-top: 55px;\n    margin-bottom: 67px;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0; left: 0;\n    padding: 10px 20px 60px 20px;\n    transform: translateX(','%);\n    transition: ',';\n    overflow-x: hidden;\n    overflow-y: scroll;\n    // background: var(--offwhitefg);\n    visibility: ',';\n\n']),_templateObject2=_taggedTemplateLiteral(['\n    font-weight: normal; font-size: 18px;\n    margin: 12px 0 17px 15px;\n'],['\n    font-weight: normal; font-size: 18px;\n    margin: 12px 0 17px 15px;\n']),_templateObject3=_taggedTemplateLiteral(['\n    transition: fill .35s;\n'],['\n    transition: fill .35s;\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: relative;\n    margin-top: 6px;\n    width: 41px;\n    height: 41px;\n    transform: translateY(',');\n    transition: transform .2s;\n'],['\n    position: relative;\n    margin-top: 6px;\n    width: 41px;\n    height: 41px;\n    transform: translateY(',');\n    transition: transform .2s;\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n'],['\n    position: absolute;\n    top: 0; left: 0;\n']),_templateObject6=_taggedTemplateLiteral(['\n    position: relative;\n    top: 0;\n    height: 100vh;\n    width: 100%;\n    min-width: 100vw;\n    overflow: hidden;\n    background: ',';\n    z-index: 1;\n    transform: translateY(','px);\n    transition: transform .45s cubic-bezier(0.215, 0.61, 0.355, 1);\n'],['\n    position: relative;\n    top: 0;\n    height: 100vh;\n    width: 100%;\n    min-width: 100vw;\n    overflow: hidden;\n    background: ',';\n    z-index: 1;\n    transform: translateY(','px);\n    transition: transform .45s cubic-bezier(0.215, 0.61, 0.355, 1);\n']),_templateObject7=_taggedTemplateLiteral(['\n    height: 1000px;\n'],['\n    height: 1000px;\n']),_templateObject8=_taggedTemplateLiteral(['\n    // padding: 0 10px;\n    position: fixed;\n    height: 67px;\n    border-top: 1px solid var(--fainttext);\n    background: white;\n    width: 100%;\n    bottom: 0;\n    z-index: 1;\n    display: flex; \n    align-items: center;\n    justify-content: space-around;\n    transform: translateY(','%);\n    transition: transform .35s;\n'],['\n    // padding: 0 10px;\n    position: fixed;\n    height: 67px;\n    border-top: 1px solid var(--fainttext);\n    background: white;\n    width: 100%;\n    bottom: 0;\n    z-index: 1;\n    display: flex; \n    align-items: center;\n    justify-content: space-around;\n    transform: translateY(','%);\n    transition: transform .35s;\n']),_templateObject9=_taggedTemplateLiteral(['\n    position: relative;\n    width: 33%; height: 100%;\n    // border: 1px solid black;\n\n    :first-of-type{\n        padding-left: 10px;\n    }\n    :last-of-type{\n        padding-right: 10px;\n    }\n\n    display: flex; align-items: center; justify-content: center;\n'],['\n    position: relative;\n    width: 33%; height: 100%;\n    // border: 1px solid black;\n\n    :first-of-type{\n        padding-left: 10px;\n    }\n    :last-of-type{\n        padding-right: 10px;\n    }\n\n    display: flex; align-items: center; justify-content: center;\n']),_templateObject10=_taggedTemplateLiteral(['\n'],['\n']),_templateObject11=_taggedTemplateLiteral(['\n    padding-top: 2px;\n'],['\n    padding-top: 2px;\n']),_templateObject12=_taggedTemplateLiteral(['\n    \n'],['\n    \n']),_templateObject13=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%;\n    height: calc(100% + 1px);\n    background: var(--faintpeach);\n    top: -1px; left: 0; z-index: -1;\n    transform: scaleX(',');\n    transform-origin: ',' 50%;\n    border-top: 1px solid var(--',');\n\n    transition: transform .25s;\n'],['\n    position: absolute;\n    width: 100%;\n    height: calc(100% + 1px);\n    background: var(--faintpeach);\n    top: -1px; left: 0; z-index: -1;\n    transform: scaleX(',');\n    transform-origin: ',' 50%;\n    border-top: 1px solid var(--',');\n\n    transition: transform .25s;\n']),_templateObject14=_taggedTemplateLiteral(['\n    position: relative;\n    margin-top: 25px;\n    padding-bottom: 15px;\n    width: ','px;\n    height: ','px;\n'],['\n    position: relative;\n    margin-top: 25px;\n    padding-bottom: 15px;\n    width: ','px;\n    height: ','px;\n']),_templateObject15=_taggedTemplateLiteral(['\n    position: relative;\n    margin-top: 5px;\n    z-index: 3;\n    height: 105px; display: flex;\n    align-items: center;\n'],['\n    position: relative;\n    margin-top: 5px;\n    z-index: 3;\n    height: 105px; display: flex;\n    align-items: center;\n']),_templateObject16=_taggedTemplateLiteral(['\n    position: relative;\n    margin-top: 15px;\n    margin-left: -20px;\n    /*left: 0;*/\n    height: ','px;\n    transform: translateY(','px);\n    transition: transform .5s ;\n    z-index: 2;\n'],['\n    position: relative;\n    margin-top: 15px;\n    margin-left: -20px;\n    /*left: 0;*/\n    height: ','px;\n    transform: translateY(','px);\n    transition: transform .5s ;\n    z-index: 2;\n']),_templateObject17=_taggedTemplateLiteral(['\n    position: relative;\n    z-index: 3;\n    margin-top: 25px;\n    transform: translateY(','px);\n    transition: transform .5s ;\n'],['\n    position: relative;\n    z-index: 3;\n    margin-top: 25px;\n    transform: translateY(','px);\n    transition: transform .5s ;\n']),_templateObject18=_taggedTemplateLiteral(['\n    position: absolute;\n    bottom: -35px; right: 140px;\n    transform: translateX(',');\n    @media ','{\n        right:120px;\n        transform: translateX(',');\n    }    \n    opacity: ',';\n    transition: opacity .1s ',', transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    &::before{\n        content: \'\';\n        position: absolute;\n        width: 150px;\n        top: 18px;\n        left: -15px;\n        height: 8px;\n        background: var(--offwhitefg);\n    }\n'],['\n    position: absolute;\n    bottom: -35px; right: 140px;\n    transform: translateX(',');\n    @media ','{\n        right:120px;\n        transform: translateX(',');\n    }    \n    opacity: ',';\n    transition: opacity .1s ',', transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    &::before{\n        content: \'\';\n        position: absolute;\n        width: 150px;\n        top: 18px;\n        left: -15px;\n        height: 8px;\n        background: var(--offwhitefg);\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var MobileScorecard=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(MobileScorecard,_React$Component);function MobileScorecard(){_classCallCheck(this,MobileScorecard);var _this=_possibleConstructorReturn(this,(MobileScorecard.__proto__||Object.getPrototypeOf(MobileScorecard)).call(this));_initDefineProp(_this,'navOpen',_descriptor,_this);_initDefineProp(_this,'showShorthand',_descriptor2,_this);_initDefineProp(_this,'init',_descriptor3,_this);_initDefineProp(_this,'setInit',_descriptor4,_this);_initDefineProp(_this,'toggleHeaderInfo',_descriptor5,_this);_initDefineProp(_this,'setNavStatus',_descriptor6,_this);_initDefineProp(_this,'allowBodyOverflow',_descriptor7,_this);_initDefineProp(_this,'currentSection',_descriptor8,_this);_initDefineProp(_this,'lastSection',_descriptor9,_this);_initDefineProp(_this,'goToSection',_descriptor10,_this);_initDefineProp(_this,'showFAH',_descriptor11,_this);_initDefineProp(_this,'fixedXAction',_descriptor12,_this);_initDefineProp(_this,'setFAH',_descriptor13,_this);_initDefineProp(_this,'forceCA',_descriptor14,_this);_initDefineProp(_this,'setForceCA',_descriptor15,_this);_initDefineProp(_this,'init',_descriptor16,_this);_initDefineProp(_this,'setInit',_descriptor17,_this);_initDefineProp(_this,'sectionVisibility',_descriptor18,_this);_initDefineProp(_this,'setSectionVisibility',_descriptor19,_this);_this.breakdown=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.breakdownSection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.sourcesSection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.demographicSection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(MobileScorecard,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.store.indicator)this.setInit(false);}},{key:'render',value:function render(){var _this2=this;var store=this.props.store;var indicator=store.indicator;var current=this.currentSection;var last=this.lastSection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Styles__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__MobileNav__["a" /* default */],{hide:this.init,store:store,showShorthand:this.showShorthand,setNavStatus:this.setNavStatus,showFAH:this.showFAH,fixedXAction:this.fixedXAction,allowBodyOverflow:this.allowBodyOverflow,setForceCA:this.setForceCA,init:this.init}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{offsetForNav:this.navOpen&&current==='breakdown'?150:this.navOpen&&current==='demographic'?80:0,hide:!indicator},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_flip_move__["a" /* default */],{typeName:null,enterAnimation:{from:{opacity:0,transform:'translateY(-70px)'},to:{opacity:1,transform:'translateY(0)'}},leaveAnimation:{from:{opacity:1,transform:'translateY(0px)'},to:{opacity:0,transform:'translateY(70px)'}}},this.init&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__src_components_InitBox__["a" /* default */],{store:store,closeSplash:function closeSplash(){return _this2.setInit(false);}})),indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{ref:this.breakdownSection,active:current==='breakdown',isLast:last==='breakdown',origin:-100,onTransitionEnd:current!=='breakdown'?function(){_this2.setSectionVisibility('breakdown',false);}:function(){},visible:this.sectionVisibility.breakdown},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Breakdown,{ref:this.breakdown,store:store,onScrollPastReadout:current==='breakdown'?this.toggleHeaderInfo:function(){},toggleFixedX:this.setFAH,showFAH:this.showFAH,isActive:current==='breakdown'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{ref:this.demographicSection,active:current==='demographic',isLast:last==='demographic',origin:last==='sources'&&current==='demographic'?-100:last==='breakdown'&&current==='demographic'?100:last==='demographic'&&current==='breakdown'?100:last==='demographic'&&current==='sources'?-100:current==='sources'&&last==='breakdown'?-100:100,onTransitionEnd:current!=='demographic'?function(){_this2.setSectionVisibility('demographic',false);}:function(){},visible:this.sectionVisibility.demographic},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Demographics,{forceCA:this.forceCA,setForceCA:this.setForceCA,store:store,onScrollPastReadout:current==='demographic'?this.toggleHeaderInfo:function(){}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{ref:this.sourcesSection,active:current==='sources',isLast:last==='sources',origin:100,onTransitionEnd:current!=='sources'?function(){_this2.setSectionVisibility('sources',false);}:function(){},visible:this.sectionVisibility.sources},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourceNoteTitle,null,'Sources & notes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__src_components_Sources__["a" /* MobileSources */],{expand:true,indicator:indicator})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SectionChooser,{visible:!this.navOpen&&indicator},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BreakdownBtn,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecSprite,{img:'ind',width:42,height:42,state:current==='breakdown'?'up':'down',color:current==='breakdown'?'strokepeach':'fainttext',onClick:function onClick(){return _this2.goToSection('breakdown');},duration:.2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecAccent,{active:current==='breakdown',origin:last==='sources'&&current==='breakdown'||last==='breakdown'&&current==='sources'?'0%':last==='breakdown'&&current==='demographic'||last==='demographic'&&current==='breakdown'?'100%':''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoBtn,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecSprite,{img:'county',width:44,height:44,state:current==='demographic'?'up':'down',color:current==='demographic'?'strokepeach':'fainttext',onClick:function onClick(){return _this2.goToSection('demographic');},duration:.2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecAccent,{active:current==='demographic',origin:last==='breakdown'&&current==='demographic'||last==='demographic'&&current==='breakdown'?'0%':last==='demographic'&&current==='sources'||last==='sources'&&current==='demographic'?'100%':''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SourcesBtn,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bookwrap,{active:current==='sources'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecSprite,{img:'book',width:41,height:41,state:current==='sources'?'up':'down',color:current==='sources'?'strokepeach':'fainttext',onClick:function onClick(){return _this2.goToSection('sources');},duration:.275,fillMode:'none'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnderSprite,{img:'underbook',width:41,height:41,state:current==='sources'?'up':'down',color:current==='sources'?'strokepeach':'fainttext',onClick:function onClick(){return _this2.goToSection('sources');},duration:.2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SecAccent,{active:current==='sources',origin:last==='sources'&&current==='demographic'||last==='demographic'&&current==='sources'?'0%':last==='breakdown'&&current==='sources'||last==='sources'&&current==='breakdown'?'100%':''}))));}}]);return MobileScorecard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'navOpen',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'showShorthand',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'init',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'setInit',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(tf){return _this3.init=tf;};}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'toggleHeaderInfo',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(tf){console.log('toggling sharthand');_this4.showShorthand=tf;};}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'setNavStatus',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(tf){_this5.navOpen=tf;if(tf){_this5.setFAH(false);_this5.allowBodyOverflow(false);}else _this5.allowBodyOverflow(true);};}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'allowBodyOverflow',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){return function(tf){document.body.style.overflow=tf?'auto':'hidden';};}}),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'currentSection',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'breakdown';}}),_descriptor9=_applyDecoratedDescriptor(_class2.prototype,'lastSection',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'';}}),_descriptor10=_applyDecoratedDescriptor(_class2.prototype,'goToSection',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(sec){_this6.lastSection=_this6.currentSection;_this6.currentSection=sec;console.log(_this6.currentSection,_this6.lastSection);if(sec==='demographic'||sec==='sources'){_this6.setFAH(false);if(sec==='sources')_this6.showShorthand=true;}_this6[sec+'Section'].current.scrollTop=0;_this6.sectionVisibility[sec]=true;};}}),_descriptor11=_applyDecoratedDescriptor(_class2.prototype,'showFAH',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor12=_applyDecoratedDescriptor(_class2.prototype,'fixedXAction',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor13=_applyDecoratedDescriptor(_class2.prototype,'setFAH',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(tf){console.log('FAH from body scroll actions: ',tf);_this7.showFAH=tf;if(tf){_this7.fixedXAction=function(){_this7.breakdown.current.expandCountyList(false);};}else _this7.fixedXAction=null;};}}),_descriptor14=_applyDecoratedDescriptor(_class2.prototype,'forceCA',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor15=_applyDecoratedDescriptor(_class2.prototype,'setForceCA',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(tf){_this8.forceCA=tf;console.log('forceCA:',tf);};}}),_descriptor16=_applyDecoratedDescriptor(_class2.prototype,'init',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor17=_applyDecoratedDescriptor(_class2.prototype,'setInit',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(tf){_this9.init=tf;};}}),_descriptor18=_applyDecoratedDescriptor(_class2.prototype,'sectionVisibility',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{breakdown:true,demographic:false,sources:false};}}),_descriptor19=_applyDecoratedDescriptor(_class2.prototype,'setSectionVisibility',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this10=this;return function(which,tf){console.log('setting',which,'to',tf);_this10.sectionVisibility[which]=tf;};}})),_class2))||_class;var Section=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].section(_templateObject,function(props){return props.active?0:props.origin;},function(props){return props.active||props.isLast?'transform .5s':'';},function(props){return props.visible?'visible':'hidden';});var SourceNoteTitle=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].h1(_templateObject2);var SecSprite=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_11__components_generic_Icon__["a" /* Sprite */])(_templateObject3);var Bookwrap=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject4,function(props){return props.active?'-3px':'0';});var UnderSprite=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(SecSprite)(_templateObject5);var Content=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject6,function(props){return props.hide?'transparent':'var(--offwhitefg)';},function(props){return props.offsetForNav;});var Spacer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject7);var SectionChooser=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject8,function(props){return props.visible?0:100;});var SectionBtn=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject9);var BreakdownBtn=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(SectionBtn)(_templateObject10);var DemoBtn=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(SectionBtn)(_templateObject11);var SourcesBtn=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(SectionBtn)(_templateObject12);var SecAccent=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject13,function(props){return props.active?1:0;},function(props){return props.origin;},function(props){return props.active?'strokepeach':'bordergrey';});var Breakdown=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class4=(_class5=function(_React$Component2){_inherits(Breakdown,_React$Component2);function Breakdown(){var _ref;var _temp,_this11,_ret;_classCallCheck(this,Breakdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this11=_possibleConstructorReturn(this,(_ref=Breakdown.__proto__||Object.getPrototypeOf(Breakdown)).call.apply(_ref,[this].concat(args))),_this11),_initDefineProp(_this11,'allCounties',_descriptor20,_this11),_initDefineProp(_this11,'expandCountyList',_descriptor21,_this11),_temp),_possibleConstructorReturn(_this11,_ret);}_createClass(Breakdown,[{key:'render',value:function render(){var _this12=this;var _props=this.props,store=_props.store,toggleFixedX=_props.toggleFixedX,showFAH=_props.showFAH,isActive=_props.isActive;var indicator=store.indicator,race=store.race,county=store.county,year=store.year;var hasRace=__WEBPACK_IMPORTED_MODULE_9__data_indicators__["a" /* default */][indicator].categories.includes('hasRace');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__researchgate_react_intersection_observer__["a" /* default */],{onChange:function onChange(wat){return requestIdleCallback(function(){return _this12.props.onScrollPastReadout(!wat.isIntersecting);});},rootMargin:'-75px 0% 0% 0%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__src_components_Readout__["a" /* default */],{store:store})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tables,{expanded:this.allCounties,devicewidth:store.mobileDeviceWidth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__src_components_IndicatorByCounties__["a" /* default */],{entries:hasRace?9:12,store:store,hasRace:hasRace,onExpand:this.expandCountyList,expand:this.allCounties,toggleDistribute:function toggleDistribute(){console.log('toggling distribution...');_this12.expandCountyList(!_this12.allCounties?true:false);},sources:this.props.sources,toggleFixedX:this.allCounties&&isActive?toggleFixedX:function(){}}),hasRace&&!this.allCounties&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__src_components_IndicatorByRaces__["a" /* default */],{store:store,expand:true,mobile:true})));}}]);return Breakdown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor20=_applyDecoratedDescriptor(_class5.prototype,'allCounties',[__WEBPACK_IMPORTED_MODULE_2_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor21=_applyDecoratedDescriptor(_class5.prototype,'expandCountyList',[__WEBPACK_IMPORTED_MODULE_2_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this13=this;return function(tf){if(!tf)_this13.props.toggleFixedX(false);_this13.allCounties=tf;};}})),_class5))||_class4;var Tables=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject14,function(props){return props.devicewidth;},function(props){return props.expanded?1600:600;});var Demographics=Object(__WEBPACK_IMPORTED_MODULE_3_mobx_react__["a" /* observer */])(_class7=function(_React$Component3){_inherits(Demographics,_React$Component3);function Demographics(){_classCallCheck(this,Demographics);return _possibleConstructorReturn(this,(Demographics.__proto__||Object.getPrototypeOf(Demographics)).apply(this,arguments));}_createClass(Demographics,[{key:'render',value:function render(){var _this15=this;var store=this.props.store;var indicator=store.indicator,race=store.race,county=store.county,year=store.year;var dataForMap=indicator?Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapValues"])(__WEBPACK_IMPORTED_MODULE_9__data_indicators__["a" /* default */][indicator].counties,function(county){return county[race||'totals'][year];}):'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReadoutWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__researchgate_react_intersection_observer__["a" /* default */],{onChange:function onChange(wat){return requestIdleCallback(function(){return _this15.props.onScrollPastReadout(!wat.isIntersecting);});},rootMargin:'-75px 0% 0% 0%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__src_components_Readout__["a" /* default */],{tiny:true,store:store,forceCA:this.props.forceCA})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoToggleWrap,{currentMode:county?'show':'hide',modes:{hide:{width:5,height:38},show:{width:120,height:38}},borderColor:'transparent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_generic__["d" /* Toggle */],{options:[{label:'County',value:'county'},{label:'CA',value:'ca'}],onClick:function onClick(val){if(val==='ca')_this15.props.setForceCA(true);else _this15.props.setForceCA(false);},selected:this.props.forceCA?1:0}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MapContainer,{devicewidth:store.mobileDeviceWidth,zoomedOutOffset:county&&this.props.forceCA||!county},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__src_components_ZoomableMap__["a" /* default */],{data:dataForMap,store:store,zoomTo:this.props.forceCA?'':county,unforceCA:function unforceCA(){if(_this15.props.forceCA)_this15.props.setForceCA(false);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoWrap,{devicewidth:store.mobileDeviceWidth,zoomedOutOffset:county&&this.props.forceCA||!county},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__src_components_DemoBox__["a" /* default */],{store:store,hasCountyOptionality:county,show:true,forceCA:this.props.forceCA})));}}]);return Demographics;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class7;var ReadoutWrapper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject15);var MapContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject16,function(p){return p.devicewidth*1.15;},function(props){return props.zoomedOutOffset?0:40;});var DemoWrap=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject17,function(props){return props.zoomedOutOffset?0:-(props.devicewidth*.75)/2.75;});var DemoToggleWrap=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_ExpandBox__["a" /* default */])(_templateObject18,function(props){return props.currentMode==='hide'?'150px':0;},__WEBPACK_IMPORTED_MODULE_10__utilities_media__["a" /* default */].smallphone,function(props){return props.currentMode==='hide'?'130px':0;},function(props){return props.currentMode==='hide'?0:1;},function(props){return props.currentMode==='hide'?'.25s':'0s';});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileNav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__researchgate_react_intersection_observer__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_intersection_observer__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_flip_move__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_indicators__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_counties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utilities_sigFig__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_generic__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ExpandBox__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_FixedActionsHelper__ = __webpack_require__(195);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_class4,_desc2,_value2,_class5,_descriptor12,_descriptor13,_descriptor14,_class7,_desc3,_value3,_class8,_descriptor15,_descriptor16,_class10;var _templateObject=_taggedTemplateLiteral(['\n    from{\n        background-color: var(--faintestpeach);\n    }\n    to{ background-color: white; }\n'],['\n    from{\n        background-color: var(--faintestpeach);\n    }\n    to{ background-color: white; }\n']),_templateObject2=_taggedTemplateLiteral(['\n    0% { color: var(--strokepeach);}\n    100% { color: var(--normtext);}\n'],['\n    0% { color: var(--strokepeach);}\n    100% { color: var(--normtext);}\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 25px; \n    right: 0;\n    z-index: 20;\n    transform: translateX(','px);    \n    opacity: ',';\n    transition: transform .425s cubic-bezier(0.215, 0.61, 0.355, 1), opacity .025s ',';\n'],['\n    position: absolute;\n    top: 25px; \n    right: 0;\n    z-index: 20;\n    transform: translateX(','px);    \n    opacity: ',';\n    transition: transform .425s cubic-bezier(0.215, 0.61, 0.355, 1), opacity .025s ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 24px; height: 24px;\n    position: absolute;\n    right: 15px; top: 19px;\n'],['\n    width: 24px; height: 24px;\n    position: absolute;\n    right: 15px; top: 19px;\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    top: -18vh; left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 19;\n    background: var(--offwhitefg);\n    opacity: 0.4;\n'],['\n    position: absolute;\n    top: -18vh; left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 19;\n    background: var(--offwhitefg);\n    opacity: 0.4;\n']),_templateObject6=_taggedTemplateLiteral(['\n    width: 24px; height: 24px;\n    position: absolute;\n    top: 17px;\n    right: 15px;\n    z-index: 30;\n    &::before{\n        content: \'\';\n        position: absolute;\n        background: var(--offwhitefg);\n        width: 35px;\n        height: 35px;\n        top: -5px; right: -5px;\n    }\n'],['\n    width: 24px; height: 24px;\n    position: absolute;\n    top: 17px;\n    right: 15px;\n    z-index: 30;\n    &::before{\n        content: \'\';\n        position: absolute;\n        background: var(--offwhitefg);\n        width: 35px;\n        height: 35px;\n        top: -5px; right: -5px;\n    }\n']),_templateObject7=_taggedTemplateLiteral(['\n    width: 100%; margin: 0; padding: 0;\n    list-style-type: none;\n'],['\n    width: 100%; margin: 0; padding: 0;\n    list-style-type: none;\n']),_templateObject8=_taggedTemplateLiteral(['\n    border: 1px solid var(--bordergrey);\n    border-left: none; border-right: none;\n    padding: 15px;\n    &:not(:first-of-type){\n        margin-top: -1px;\n    }\n    display: flex; align-items: center;\n    justify-content: flex-end;\n'],['\n    border: 1px solid var(--bordergrey);\n    border-left: none; border-right: none;\n    padding: 15px;\n    &:not(:first-of-type){\n        margin-top: -1px;\n    }\n    display: flex; align-items: center;\n    justify-content: flex-end;\n']),_templateObject9=_taggedTemplateLiteral(['\n    width: 28px; height: 28px;\n    margin-left: 7px;\n    fill: none;\n    stroke: var(--normtext);\n    stroke-width: 1.5px;\n'],['\n    width: 28px; height: 28px;\n    margin-left: 7px;\n    fill: none;\n    stroke: var(--normtext);\n    stroke-width: 1.5px;\n']),_templateObject10=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n    z-index: 0;\n    background: var(--offwhitefg);\n    width: 100vw;\n    height: 55px; \n'],['\n    position: absolute;\n    top: 0; left: 0;\n    z-index: 0;\n    background: var(--offwhitefg);\n    width: 100vw;\n    height: 55px; \n']),_templateObject11=_taggedTemplateLiteral(['\n    position: absolute; top: 0; left: 0;\n    height: 55px; width: 100%;\n    z-index: 13;\n\n    transform: translate(',');\n    transition: transform .425s cubic-bezier(0.215, 0.61, 0.355, 1);\n'],['\n    position: absolute; top: 0; left: 0;\n    height: 55px; width: 100%;\n    z-index: 13;\n\n    transform: translate(',');\n    transition: transform .425s cubic-bezier(0.215, 0.61, 0.355, 1);\n']),_templateObject12=_taggedTemplateLiteral(['\n    position: absolute;\n    z-index: 1;\n    top: 1px;\n    left: -128px;\n    background: white;\n    border: 1px solid var(--fainttext);\n    width: 115px; height: 55px;\n    transform: translateX(','px);\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-delay: ','s;\n    opacity: ',';\n    display: flex; align-items: center;\n    justify-content: center;\n'],['\n    position: absolute;\n    z-index: 1;\n    top: 1px;\n    left: -128px;\n    background: white;\n    border: 1px solid var(--fainttext);\n    width: 115px; height: 55px;\n    transform: translateX(','px);\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transition-delay: ','s;\n    opacity: ',';\n    display: flex; align-items: center;\n    justify-content: center;\n']),_templateObject13=_taggedTemplateLiteral(['\n    width: 18px; height: 18px;\n    margin-left: 8px;\n'],['\n    width: 18px; height: 18px;\n    margin-left: 8px;\n']),_templateObject14=_taggedTemplateLiteral(['\n    width: 100vw;\n    height: calc(100vh + 2px);\n    background: linear-gradient(180deg, var(--offwhitefg) 300px, rgba(252, 253, 255, 0.725) 100%);\n    pointer-events: ',';\n    /*background: var(--offwhitefg);*/\n    /*background: linear-gradient(180deg, var(--offwhitebg) 53%, rgba(0, 0, 0, 0.5) 100%);*/\n    opacity: ',';\n    transition: opacity .475s;\n    position: absolute;\n    z-index: 0;\n'],['\n    width: 100vw;\n    height: calc(100vh + 2px);\n    background: linear-gradient(180deg, var(--offwhitefg) 300px, rgba(252, 253, 255, 0.725) 100%);\n    pointer-events: ',';\n    /*background: var(--offwhitefg);*/\n    /*background: linear-gradient(180deg, var(--offwhitebg) 53%, rgba(0, 0, 0, 0.5) 100%);*/\n    opacity: ',';\n    transition: opacity .475s;\n    position: absolute;\n    z-index: 0;\n']),_templateObject15=_taggedTemplateLiteral(['\n    position: absolute;\n    bottom: -45px;\n    right: -32px;\n'],['\n    position: absolute;\n    bottom: -45px;\n    right: -32px;\n']),_templateObject16=_taggedTemplateLiteral(['\n    padding: 0 25px;\n    display: flex;\n    width: ','px;\n    height: ',';\n    ','\n    justify-content: space-between;\n    background: ',';\n    animation-name: ',';\n    animation-fill-mode: forwards;\n    animation-duration: 1.25s;\n    animation-delay: 1.5s;\n\n'],['\n    padding: 0 25px;\n    display: flex;\n    width: ','px;\n    height: ',';\n    ','\n    justify-content: space-between;\n    background: ',';\n    animation-name: ',';\n    animation-fill-mode: forwards;\n    animation-duration: 1.25s;\n    animation-delay: 1.5s;\n\n']),_templateObject17=_taggedTemplateLiteral(['\n    font-size: 12px;\n    flex-shrink: 0;\n    position: relative;\n    opacity: ',';\n    ','\n'],['\n    font-size: 12px;\n    flex-shrink: 0;\n    position: relative;\n    opacity: ',';\n    ','\n']),_templateObject18=_taggedTemplateLiteral(['\n    position: absolute;\n    margin-top: 2px;\n    opacity: ',';\n    transition: opacity .35s;\n    pointer-events: none;\n'],['\n    position: absolute;\n    margin-top: 2px;\n    opacity: ',';\n    transition: opacity .35s;\n    pointer-events: none;\n']),_templateObject19=_taggedTemplateLiteral(['\n    position: relative;\n    font-size: 16px;\n    color: var(--fainttext);\n    margin-left: 20px; \n    max-width: calc(88% - 80px);\n    margin-right: ',';\n'],['\n    position: relative;\n    font-size: 16px;\n    color: var(--fainttext);\n    margin-left: 20px; \n    max-width: calc(88% - 80px);\n    margin-right: ',';\n']),_templateObject20=_taggedTemplateLiteral(['\n    right: 12px; top: 2px;\n    position: absolute;\n    transform: translateX(','px);\n    width: 18px; height: 18px;\n    transition: opacity .35s, transform .35s;\n    opacity: ',';\n    pointer-events: ',';\n'],['\n    right: 12px; top: 2px;\n    position: absolute;\n    transform: translateX(','px);\n    width: 18px; height: 18px;\n    transition: opacity .35s, transform .35s;\n    opacity: ',';\n    pointer-events: ',';\n']),_templateObject21=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 9.5px; left: 53px; \n    display: flex; align-items: center;\n    z-index: 20;\n    opacity: ',';\n    transition: opacity .35s ',';\n    pointer-events: ',';\n'],['\n    position: absolute;\n    top: 9.5px; left: 53px; \n    display: flex; align-items: center;\n    z-index: 20;\n    opacity: ',';\n    transition: opacity .35s ',';\n    pointer-events: ',';\n']),_templateObject22=_taggedTemplateLiteral(['\n    /*position: absolute; top: 9px;*/\n    border: none;\n    appearance: none; outline: none; background: transparent;\n    width: calc(100vw - 160px);\n    height: 32px;\n    font-size: 14px; letter-spacing: 0.5px;\n\n'],['\n    /*position: absolute; top: 9px;*/\n    border: none;\n    appearance: none; outline: none; background: transparent;\n    width: calc(100vw - 160px);\n    height: 32px;\n    font-size: 14px; letter-spacing: 0.5px;\n\n']),_templateObject23=_taggedTemplateLiteral(['\n    /*position: absolute;*/\n    /*left: 210px;*/\n    color: var(--strokepeach);\n    font-size: 14px; letter-spacing: 0.5px;\n'],['\n    /*position: absolute;*/\n    /*left: 210px;*/\n    color: var(--strokepeach);\n    font-size: 14px; letter-spacing: 0.5px;\n']),_templateObject24=_taggedTemplateLiteral(['\n    font-size: 14px;\n    flex-shrink: 1;\n    white-space: ',';\n    overflow: ',';\n    text-overflow: ellipsis;\n    text-align: right;\n    opacity: ',';\n    transition: opacity .35s;\n    transition-delay: ',';\n    color: ',';\n    animation-name: ',';\n    animation-fill-mode: forwards;\n    animation-duration: 1.25s;\n    animation-delay: 1.5s;\n    ','\n    position: relative;\n'],['\n    font-size: 14px;\n    flex-shrink: 1;\n    white-space: ',';\n    overflow: ',';\n    text-overflow: ellipsis;\n    text-align: right;\n    opacity: ',';\n    transition: opacity .35s;\n    transition-delay: ',';\n    color: ',';\n    animation-name: ',';\n    animation-fill-mode: forwards;\n    animation-duration: 1.25s;\n    animation-delay: 1.5s;\n    ','\n    position: relative;\n']),_templateObject25=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 2px; right: -30px;\n    width: 18px; height: 18px;\n    /*border: 1px solid black;*/\n    flex-shrink: 0;\n'],['\n    position: absolute;\n    top: 2px; right: -30px;\n    width: 18px; height: 18px;\n    /*border: 1px solid black;*/\n    flex-shrink: 0;\n']),_templateObject26=_taggedTemplateLiteral(['\n    position: fixed;\n    top: -1px; left: -1px;\n    z-index: 10;\n    width: calc(100% + 1px);\n\n    transform: translateY(',');\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);   \n'],['\n    position: fixed;\n    top: -1px; left: -1px;\n    z-index: 10;\n    width: calc(100% + 1px);\n\n    transform: translateY(',');\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);   \n']),_templateObject27=_taggedTemplateLiteral(['\n    border: 1px solid red;\n    height: 83px;\n\n'],['\n    border: 1px solid red;\n    height: 83px;\n\n']),_templateObject28=_taggedTemplateLiteral(['\n    position: absolute;\n    top: -1px; left: -1px;\n    // height: 83px;\n    z-index: 1;\n    transform: translateY(','px);\n    transition: transform .35s;\n'],['\n    position: absolute;\n    top: -1px; left: -1px;\n    // height: 83px;\n    z-index: 1;\n    transform: translateY(','px);\n    transition: transform .35s;\n']),_templateObject29=_taggedTemplateLiteral(['\n    z-index: 3;\n    top: 0; left: 0;\n'],['\n    z-index: 3;\n    top: 0; left: 0;\n']),_templateObject30=_taggedTemplateLiteral(['\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    color: ',';\n    width: 100%;\n    height: 55px;\n    cursor: pointer;\n'],['\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    color: ',';\n    width: 100%;\n    height: 55px;\n    cursor: pointer;\n']),_templateObject31=_taggedTemplateLiteral(['\n    position: absolute; top: 0; left: 0;\n    display: flex; align-items: center;\n    padding-left: 25px;\n    // white-space: nowrap;\n    height: 55px;\n    opacity: ',';\n    transition: transform .425s, opacity .275s ',';\n    width: 100%;\n'],['\n    position: absolute; top: 0; left: 0;\n    display: flex; align-items: center;\n    padding-left: 25px;\n    // white-space: nowrap;\n    height: 55px;\n    opacity: ',';\n    transition: transform .425s, opacity .275s ',';\n    width: 100%;\n']),_templateObject32=_taggedTemplateLiteral(['\n    transform: translateX(','px);\n'],['\n    transform: translateX(','px);\n']),_templateObject33=_taggedTemplateLiteral(['\n    padding: 0 25px;\n    justify-content: center;\n    width: ','px;\n    transform: translateX(','px);\n'],['\n    padding: 0 25px;\n    justify-content: center;\n    width: ','px;\n    transform: translateX(','px);\n']),_templateObject34=_taggedTemplateLiteral(['\n    position: absolute;\n    left: 55px;\n    transition: transform .35s, opacity .35s;\n    opacity: ',';\n'],['\n    position: absolute;\n    left: 55px;\n    transition: transform .35s, opacity .35s;\n    opacity: ',';\n']),_templateObject35=_taggedTemplateLiteral(['\n    transform: translateY(','%);\n'],['\n    transform: translateY(','%);\n']),_templateObject36=_taggedTemplateLiteral(['\n    transform: translateY(','%);\n    max-width: calc(100% - 75px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n'],['\n    transform: translateY(','%);\n    max-width: calc(100% - 75px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n']),_templateObject37=_taggedTemplateLiteral(['\n    width: 18px; height: 18px;\n    margin-right: 15px;\n    flex-shrink: 0;\n'],['\n    width: 18px; height: 18px;\n    margin-right: 15px;\n    flex-shrink: 0;\n']),_templateObject38=_taggedTemplateLiteral(['\n    from {opacity: 0;} to {opacity: 1;}\n'],['\n    from {opacity: 0;} to {opacity: 1;}\n']),_templateObject39=_taggedTemplateLiteral(['\n    width: 100%;\n    white-space: normal;\n    margin: 15px 0 0 0;\n    padding: 0 25px 150px 25px;\n    overscroll-behavior: contain;\n'],['\n    width: 100%;\n    white-space: normal;\n    margin: 15px 0 0 0;\n    padding: 0 25px 150px 25px;\n    overscroll-behavior: contain;\n']),_templateObject40=_taggedTemplateLiteral(['\n    position: relative;\n    list-style-type: none;    \n    font-size: 14px;\n    line-height: 21px;\n    padding: 15px 15px;\n    background: white;\n    border: 1px solid var(--bordergrey);\n    &:not(:first-of-type){\n        margin-top: -1px;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    &.selected{\n        background: var(--faintestpeach);\n        border-color: var(--peach);\n        z-index: 3;\n    }\n    &.invalid{\n        background: var(--offwhitefg);\n        color: var(--fainttext);\n        border-bottom-color: var(--inactivegrey);\n        border-left-color: transparent;\n        border-top-color: transparent;\n        border-right-color: transparent;\n        margin-top: 0;\n    }\n'],['\n    position: relative;\n    list-style-type: none;    \n    font-size: 14px;\n    line-height: 21px;\n    padding: 15px 15px;\n    background: white;\n    border: 1px solid var(--bordergrey);\n    &:not(:first-of-type){\n        margin-top: -1px;\n    }\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    &.selected{\n        background: var(--faintestpeach);\n        border-color: var(--peach);\n        z-index: 3;\n    }\n    &.invalid{\n        background: var(--offwhitefg);\n        color: var(--fainttext);\n        border-bottom-color: var(--inactivegrey);\n        border-left-color: transparent;\n        border-top-color: transparent;\n        border-right-color: transparent;\n        margin-top: 0;\n    }\n']),_templateObject41=_taggedTemplateLiteral(['\n    font-family: \'Heebo\', sans-serif;\n    font-size: 14px;\n    height: 44px;\n    padding: 10px 15px;\n    margin-left: 25px;\n    margin-top: 2px;\n    width: 190px;\n    letter-spacing: 0.7px;\n    appearance: none;\n    color: var(--normtext);\n    background: white;\n'],['\n    font-family: \'Heebo\', sans-serif;\n    font-size: 14px;\n    height: 44px;\n    padding: 10px 15px;\n    margin-left: 25px;\n    margin-top: 2px;\n    width: 190px;\n    letter-spacing: 0.7px;\n    appearance: none;\n    color: var(--normtext);\n    background: white;\n']),_templateObject42=_taggedTemplateLiteral(['\n    display: inline-flex;\n    position: relative;\n    &::after{\n        position: absolute;\n        top: 21px; right: 15px;\n        content: \'\';\n        border: 6px solid transparent;\n        border-top-color: var(--fainttext);\n    }\n'],['\n    display: inline-flex;\n    position: relative;\n    &::after{\n        position: absolute;\n        top: 21px; right: 15px;\n        content: \'\';\n        border: 6px solid transparent;\n        border-top-color: var(--fainttext);\n    }\n']),_templateObject43=_taggedTemplateLiteral(['\n    margin-bottom: 15px;\n'],['\n    margin-bottom: 15px;\n']),_templateObject44=_taggedTemplateLiteral(['\n    font-size: 12px;\n    color: var(--fainttext);\n'],['\n    font-size: 12px;\n    color: var(--fainttext);\n']),_templateObject45=_taggedTemplateLiteral(['\n    width: 18px; height: 18px;\n    margin-left: 8px;\n    flex-shrink: 0;\n'],['\n    width: 18px; height: 18px;\n    margin-left: 8px;\n    flex-shrink: 0;\n']),_templateObject46=_taggedTemplateLiteral(['\n    // width: 25px; height: 25px;\n'],['\n    // width: 25px; height: 25px;\n']),_templateObject47=_taggedTemplateLiteral([''],['']),_templateObject48=_taggedTemplateLiteral(['\n    background-color: ',';\n    animation-name: ',';\n    animation-fill-mode: forwards;\n    animation-duration: 1.25s;\n    animation-delay: 1.5s;\n'],['\n    background-color: ',';\n    animation-name: ',';\n    animation-fill-mode: forwards;\n    animation-duration: 1.25s;\n    animation-delay: 1.5s;\n']);function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import semanticTitles from './assets/semanticTitles'
var peachBGAnim=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* keyframes */])(_templateObject);var textPeachToBlack=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* keyframes */])(_templateObject2);var MobileNav=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(MobileNav,_React$Component);// compact, county, race, indicator
function MobileNav(){_classCallCheck(this,MobileNav);var _this=_possibleConstructorReturn(this,(MobileNav.__proto__||Object.getPrototypeOf(MobileNav)).call(this));_initDefineProp(_this,'mode',_descriptor,_this);_initDefineProp(_this,'setMode',_descriptor2,_this);_initDefineProp(_this,'justComplete',_descriptor3,_this);_initDefineProp(_this,'justCompleted',_descriptor4,_this);_initDefineProp(_this,'workflowScrollPos',_descriptor5,_this);_initDefineProp(_this,'userScrolledDownInWorkflow',_descriptor6,_this);_initDefineProp(_this,'setWorkflowScrollPos',_descriptor7,_this);_initDefineProp(_this,'openWorkflowHeaderVisible',_descriptor8,_this);_initDefineProp(_this,'setWorkflowHeaderVisibility',_descriptor9,_this);_initDefineProp(_this,'links',_descriptor10,_this);_initDefineProp(_this,'setInfo',_descriptor11,_this);_this.countyList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.indList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.ctyListHeaderBlock=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.indListHeaderBlock=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(MobileNav,[{key:'componentWillUpdate',value:function componentWillUpdate(newProps){if(this.props.hide&&!newProps.hide){this.setMode('compact');}}},{key:'render',value:function render(){var _this2=this;var props=this.props;var open=props.open,store=props.store;var indicator=store.indicator,county=store.county,race=store.race,year=store.year;var ind=__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][indicator];var sem=indicator?ind.semantics:'';var yearOptions=indicator?ind.years.map(function(yr,i){var val=ind.counties[county||'california'][race||'totals'][i];var disabled=val!==0&&(!val||val==='*');return{label:yr,value:i,disabled:disabled};}):false;var NavItems=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'county',style:{height:'50px',marginLeft:'-1px',zIndex:this.mode==='county'?0:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ExpandBox__["a" /* default */],{ref:this.countyList,duration:this.mode==='county'?.5:0,currentMode:this.mode==='county'?'fullscreen':'compact',modes:{compact:{width:store.mobileDeviceWidth+1,height:50},fullscreen:{width:store.mobileDeviceWidth+1,height:store.mobileDeviceHeight+100}},backgroundColor:this.mode==='county'?'var(--offwhitefg)':'white',noBorderTop:this.mode==='compact'||!this.mode,withScroll:true,hideScroll:this.mode!=='county',noFade:true,onScroll:this.mode==='county'?function(e){_this2.setWorkflowScrollPos(e.top);}:function(){}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__researchgate_react_intersection_observer__["a" /* default */],{onChange:this.mode==='county'?function(wat){_this2.setWorkflowHeaderVisibility(wat.isIntersecting);}:function(){}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuSelectBlock,{width:store.mobileDeviceWidth,left:'County',right:county?__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[county]:'California (all)',onClick:function onClick(){return _this2.setMode('county');},open:this.mode==='county',prompt:'Pick a county.','return':function _return(){return _this2.setMode('compact');},justComplete:this.justComplete.county,ref:this.ctyListHeaderBlock,placeholder:'Type county name...',searchString:store.countySearchString,onSearch:function onSearch(val){return store.modifySearchString('county',val);}})),this.mode==='county'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CountyList,{store:store,onComplete:function onComplete(which,hasNewVal){_this2.setMode('compact');if(hasNewVal){_this2.justCompleted(which);_this2.props.setForceCA(false);//unforce CA zoom when picking new county
}}// onHeaderScrollChange = {this.setWorkflowHeaderVisibility}
})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'race',style:{height:'50px',marginLeft:'-1px',zIndex:this.mode==='race'?0:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_ExpandBox__["a" /* default */],{duration:this.mode==='race'?.5:0,currentMode:this.mode==='race'?'fullscreen':'compact',modes:{compact:{width:store.mobileDeviceWidth+1,height:50},fullscreen:{width:store.mobileDeviceWidth+1,height:store.mobileDeviceHeight+100}},backgroundColor:this.mode==='race'?'var(--offwhitefg)':'white'// hideScroll = {this.mode!=='race'}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuSelectBlock,{width:store.mobileDeviceWidth,left:'Race',right:race?Object(__WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__["b" /* capitalize */])(race):'All races',disabled:ind&&!ind.categories.includes('hasRace'),onClick:ind&&ind.categories.includes('hasRace')||!ind?function(){return _this2.setMode('race');}:function(){alert('The indicator you picked doesn\'t have any race-specific data.');},open:this.mode==='race',prompt:'Select a race.','return':function _return(){return _this2.setMode('compact');},noSearch:true,justComplete:this.justComplete.race}),this.mode==='race'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RaceList,{store:store,onComplete:function onComplete(which,hasNewVal){_this2.setMode('compact');if(hasNewVal)_this2.justCompleted(which);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'indicator',style:{height:this.mode==='compact'?'117px':'50px',marginLeft:'-1px',zIndex:this.mode==='indicator'?0:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndExpandBox,{ref:this.indList,withScroll:true,hideScroll:this.mode!=='indicator',noFade:true,duration:this.mode==='indicator'?.5:0,currentMode:this.mode==='indicator'?'fullscreen':this.mode==='county'||this.mode==='race'?'compactTruncated':'compact',modes:{compact:{width:store.mobileDeviceWidth+1,height:117},compactTruncated:{width:store.mobileDeviceWidth+1,height:50},fullscreen:{width:store.mobileDeviceWidth+1,height:store.mobileDeviceHeight+100}},backgroundColor:this.mode==='indicator'?'var(--offwhitefg)':this.mode==='compact'&&this.justComplete.indicator?'transparent':'white',onScroll:this.mode==='indicator'?function(e){_this2.setWorkflowScrollPos(e.top);}:function(){},justComplete:this.justComplete.indicator},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__researchgate_react_intersection_observer__["a" /* default */],{onChange:this.mode==='indicator'?function(wat){return _this2.setWorkflowHeaderVisibility(wat.isIntersecting);}:function(){}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuSelectBlock,{width:store.mobileDeviceWidth,left:'Indicator',right:indicator?sem.shorthand:'Browse / search...',multiline:true,onClick:function onClick(){return _this2.setMode('indicator');},open:this.mode==='indicator',prompt:'Choose an indicator.','return':function _return(){return _this2.setMode('compact');},truncateValue:this.mode==='county'||this.mode==='race',justComplete:this.mode==='compact'&&this.justComplete.indicator,yearToggle:this.mode!=='race'&&this.mode!=='county'&&indicator?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(YearToggle,{visible:this.mode==='compact',options:yearOptions,onClick:function onClick(yr){return store.completeWorkflow('year',yr);},selected:Number(year),stopPropagation:true,muted:true,theme:'muted'}):null,ref:this.indListHeaderBlock,placeholder:'Find indicators...',searchString:store.indicatorSearchString,onSearch:function onSearch(val){return store.modifySearchString('indicator',val);}})),this.mode==='indicator'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorList,{store:store,onComplete:function onComplete(which,hasNewVal){_this2.setMode('compact');if(hasNewVal)_this2.justCompleted(which);}// onHeaderScrollChange = {this.setWorkflowHeaderVisibility}
}))))].sort(function(a,b){if(a.key===_this2.mode)return 1;if(b.key===_this2.mode)return-1;});var indListRef=this.indList;var ctyListRef=this.countyList;var indListHeaderBlockRef=this.indListHeaderBlock;var ctyListHeaderBlockRef=this.ctyListHeaderBlock;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FixWrap,{mid:!this.props.hide&&!indicator&&this.mode==='compact',hide:this.props.hide},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Info,{duration:.425,currentMode:this.links?'expanded':'collapsed',modes:{collapsed:{width:1,height:1},expanded:{width:210,height:222}},borderColor:this.links?'var(--bordergrey)':'transparent',backgroundColor:this.links?'white':'transparent',offset:this.links?-235:-25},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Links,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{onClick:function onClick(){return window.location.href='https://www.childrennow.org/';}},'Children Now'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{onClick:function onClick(){return window.location.href='https://www.childrennow.org/about';}},'About us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{onClick:function onClick(){return window.location.href='http://ccnstaging.childrennow.webfactional.com/portfolio-posts/2018scorecard/';}},'Acknowledgments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{onClick:function onClick(){return window.location.href='mailto:research@childrennow.org?subject=Scorecard%20Feedback';}},'Provide feedback ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeedbackIcon,{img:'strokefeedback'})))),this.links&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoMask,{onClick:function onClick(){return _this2.setInfo(false);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseInfo,{onClick:function onClick(){return _this2.setInfo(false);},img:'x_thin',color:'normtext'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickMenu,{currentMode:!this.mode?'closed':this.mode==='compact'&&!indicator?'openNoInd':this.mode==='compact'?'open':'fullsize',modes:{closed:{width:store.mobileDeviceWidth+1,height:25},fullsize:{width:store.mobileDeviceWidth+1,height:store.mobileDeviceHeight+100},openNoInd:{width:store.mobileDeviceWidth+1,height:200},open:{width:store.mobileDeviceWidth+1,height:267}},workflowScrollOffset:this.userScrolledDownInWorkflow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_flip_move__["a" /* default */],{style:{width:'100%'},easing:'cubic-bezier(0.215, 0.61, 0.355, 1)',duration:350,enterAnimation:{from:{transform:'translateY(-100%)'},to:{transform:'translateY(0%)'}},leaveAnimation:{from:{transform:'translateY(0)'},to:{transform:'translateY(-100%)'}}},(!this.mode||this.mode==='compact')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'relative',zIndex:5,display:'flex',alignItems:'center',padding:'12px 25px 0px 25px',height:'50px',width:'100%',background:'white'}},'What data do you want to see?',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIcon,{img:'info',onClick:function onClick(){_this2.setInfo(true);}})),NavItems.map(function(item){return item;}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderGroup,{offset:this.mode==='compact'&&!indicator?store.mobileDeviceWidth-230+'px,215px':this.mode&&this.mode!=='compact'&&!indicator?store.mobileDeviceWidth-230+'px,'+(store.mobileDeviceHeight+25)+'px':!this.mode?'0,0':this.mode==='compact'&&!indicator?store.mobileDeviceWidth-175+'px,215px':this.mode==='compact'&&indicator?store.mobileDeviceWidth-175+'px,282px':store.mobileDeviceWidth-175+'px,'+(store.mobileDeviceHeight+125)+'px',duration:.425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{currentMode:this.mode&&!indicator?'noIndicator':!this.mode?'bar':this.mode==='compact'||this.props.hide?'button':'offscreen',modes:{bar:{width:store.mobileDeviceWidth,height:55},button:{width:160,height:55},offscreen:{width:160,height:55},noIndicator:{width:215,height:55}},backgroundColor:this.props.hide||this.mode&&!indicator?'var(--offwhitefg)':'var(--offwhitebg)',borderColor:this.mode&&!indicator?'var(--bordergrey)':'var(--offwhitebg)',duration:.425},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderContent,{whitetext:!(this.mode&&!indicator),onClick:function onClick(){_this2.setMode(_this2.mode==='compact'&&!indicator?'indicator':_this2.mode==='compact'?false:'compact');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BarContent,{active:!this.mode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchIcon,{img:'searchzoom',color:'white'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Prompt,{visible:!this.props.showShorthand},'Search data...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Shorthand,{visible:this.props.showShorthand},indicator&&sem.shorthand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Btn,{active:this.mode,superwide:this.mode&&!indicator},!indicator&&'Choose an indicator.',!this.justComplete.county&&!this.justComplete.race&&!this.justComplete.indicator&&indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'Cancel',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CollapseHeaderIcon,{img:'chevup',color:'white'})),(this.justComplete.county||this.justComplete.race||this.justComplete.indicator)&&indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'See results',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SaveHeaderIcon,{img:'check',color:'peach'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResetButton,{show:this.mode==='compact'&&indicator},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',height:'55px',width:'100px',justifyContent:'center',cursor:'pointer'},onClick:function onClick(){store.completeWorkflow('race',null);store.completeWorkflow('county',null);store.completeWorkflow('indicator',null);}},'Reset ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResetIcon,{img:'reset',color:'normtext'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MaskGapBlocker,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Mask,{visible:this.mode&&indicator,onClick:function onClick(){return _this2.setMode(false);}}),(this.mode==='county'||this.mode==='indicator'||!this.mode)&&//eventually, indbycty table expanded...
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_FixedActionsHelper__["a" /* default */],{id:'fixedactions',mode:this.props.showFAH?'xOnly':this.openWorkflowHeaderVisible||!this.mode?'collapsed':'expanded',offsetFromTop:!this.mode||this.props.showFAH?50:this.userScrolledDownInWorkflow?0:100,onSearch:function onSearch(){if(_this2.mode==='county'){ctyListRef.current.forceScrollToTop();ctyListHeaderBlockRef.current.setSearching(true);}else if(_this2.mode==='indicator'){indListRef.current.forceScrollToTop();indListHeaderBlockRef.current.setSearching(true);}},onX:!this.props.fixedXAction?function(){_this2.setWorkflowScrollPos(0);_this2.setWorkflowHeaderVisibility(true);_this2.setMode('compact');}:this.props.fixedXAction}));}}]);return MobileNav;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'mode',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'setMode',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(val){if(_this3.links)_this3.setInfo(false);if(val==='compact'){_this3.props.setNavStatus(true);_this3.props.allowBodyOverflow(false);_this3.setWorkflowScrollPos(0);// this.userScrolledDownInWorkflow = false
}else if(!val){_this3.props.setNavStatus(false);_this3.justComplete.county=_this3.justComplete.race=_this3.justComplete.indicator=false;}else if(val==='race')_this3.props.allowBodyOverflow(false);//racelist doesnt need scroll
else{//indicator and county actually do need smooth scroll
_this3.props.allowBodyOverflow(true);}_this3.mode=val;};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'justComplete',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{county:false,race:false,indicator:false};}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'justCompleted',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(what){_this4.workflowScrollPos=0;_this4.userScrolledDownInWorkflow=false;Object.keys(_this4.justComplete).map(function(wat){if(wat!==what)_this4.justComplete[wat]=false;});_this4.justComplete[what]=true;};}}),_descriptor5=_applyDecoratedDescriptor(_class2.prototype,'workflowScrollPos',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor6=_applyDecoratedDescriptor(_class2.prototype,'userScrolledDownInWorkflow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor7=_applyDecoratedDescriptor(_class2.prototype,'setWorkflowScrollPos',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(val){if(val>_this5.workflowScrollPos)_this5.userScrolledDownInWorkflow=true;else _this5.userScrolledDownInWorkflow=false;_this5.workflowScrollPos=val;};}}),_descriptor8=_applyDecoratedDescriptor(_class2.prototype,'openWorkflowHeaderVisible',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return true;}}),_descriptor9=_applyDecoratedDescriptor(_class2.prototype,'setWorkflowHeaderVisibility',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(tf){_this6.openWorkflowHeaderVisible=tf;};}}),_descriptor10=_applyDecoratedDescriptor(_class2.prototype,'links',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor11=_applyDecoratedDescriptor(_class2.prototype,'setInfo',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(tf){if(_this7.mode!=='compact')return;_this7.links=tf;};}})),_class2))||_class;var Info=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_15__components_ExpandBox__["a" /* default */])(_templateObject3,function(props){return props.offset;},function(props){return props.currentMode==='expanded'?1:0;},function(props){return props.currentMode==='expanded'?'0s':'.4s';});var InfoIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["b" /* default */])(_templateObject4);var InfoMask=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject5);var CloseInfo=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["b" /* default */])(_templateObject6);var Links=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].ul(_templateObject7);var Link=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].li(_templateObject8);var FeedbackIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["b" /* default */])(_templateObject9);var MaskGapBlocker=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject10);var HeaderGroup=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject11,function(props){return props.offset;});var ResetButton=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject12,function(props){return props.show?0:129;},function(props){return props.show?.425:0;},function(props){return props.show?1:0;});var ResetIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["b" /* default */])(_templateObject13);var Mask=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject14,function(props){return props.visible?'auto':'none';},function(props){return props.visible?1:0;});var YearToggle=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_14__components_generic__["d" /* Toggle */])(_templateObject15);var MenuSelectBlock=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class4=(_class5=function(_React$Component2){_inherits(MenuSelectBlock,_React$Component2);function MenuSelectBlock(){_classCallCheck(this,MenuSelectBlock);var _this8=_possibleConstructorReturn(this,(MenuSelectBlock.__proto__||Object.getPrototypeOf(MenuSelectBlock)).call(this));_initDefineProp(_this8,'searching',_descriptor12,_this8);_initDefineProp(_this8,'setSearching',_descriptor13,_this8);_initDefineProp(_this8,'setSearchString',_descriptor14,_this8);_this8.searchInput=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this8;}// @observable searchstring = ''
_createClass(MenuSelectBlock,[{key:'componentWillUpdate',value:function componentWillUpdate(newProps){if(!newProps.open&&this.props.open&&!this.props.noSearch){this.setSearching(false);}}},{key:'render',value:function render(){var _this9=this;var props=this.props;var searchstring=this.props.searchString;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MSB,{devicewidth:props.width,height:props.height,disabled:props.disabled,multiline:props.multiline&&!props.truncateValue,onClick:!props.open?props.onClick:function(){},justComplete:props.justComplete},!props.noSearch&&props.open&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavSearchBlock,{active:this.searching},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavSearchInput,{ref:this.searchInput,placeholder:props.placeholder,onChange:function onChange(e){return _this9.setSearchString(e.target.value);},onBlur:function onBlur(e){e.stopPropagation();if(!searchstring)_this9.setSearching(false);},value:searchstring,onKeyUp:function onKeyUp(e){if(e.key==='Enter'){if(searchstring)_this9.searchInput.current.blur();else _this9.setSearching(false);}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearCancelSearch,{onClick:function onClick(){_this9.setSearching(false);}},searchstring&&'Clear',!searchstring&&'Cancel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MSBPrompt,{visible:props.open&&!this.searching},props.prompt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MSBLabel,{visible:!props.open,multiline:props.multiline&&!props.truncateValue},props.left),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MSBValue,{noCaret:props.noCaret},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Val,{truncate:props.truncateValue// multiline = {props.multiline && !props.truncateValue} 
,visible:!props.open,justComplete:props.justComplete},props.right,props.yearToggle),!props.noSearch&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavSearch,{devicewidth:props.width,img:'searchzoom',color:'normtext',visible:props.open,active:this.searching,onClick:function onClick(){return _this9.setSearching(true);}}),!props.noCaret&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(XCaret,{duration:.2,img:'caretx',state:props.open?'up':'down',color:props.justComplete?'fainttext':'normtext',disabled:props.disabled,onClick:props.open?props.return:function(){}})));}}]);return MenuSelectBlock;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor12=_applyDecoratedDescriptor(_class5.prototype,'searching',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor13=_applyDecoratedDescriptor(_class5.prototype,'setSearching',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this10=this;return function(tf){if(tf)_this10.searchInput.current.focus();else{_this10.searchInput.current.blur();// this.searchstring = ''
_this10.setSearchString('');}_this10.searching=tf;};}}),_descriptor14=_applyDecoratedDescriptor(_class5.prototype,'setSearchString',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this11=this;return function(val){console.log(val);// this.searchstring = val
_this11.props.onSearch(val);};}})),_class5))||_class4;var MSB=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject16,function(props){return props.devicewidth;},function(props){return props.height?props.height:'50px';},function(props){return props.multiline?'\n        padding-top: 14px;\n        ':'align-items: center;';},function(props){return props.justComplete?'var(--faintestpeach)':props.disabled?'var(--disabledgrey)':'transparent';},function(props){return props.justComplete?peachBGAnim:'';});var MSBLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject17,function(props){return props.visible?1:0;},function(props){return props.multiline?'margin-top: 2px;':'';});var MSBPrompt=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject18,function(props){return props.visible?1:0;});var MSBValue=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject19,function(props){return props.noCaret?'0':'30px';});var NavSearch=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["b" /* default */])(_templateObject20,function(props){return props.active?-(props.devicewidth-110):0;},function(props){return props.visible?1:0;},function(props){return props.visible?'auto':'none';});var NavSearchBlock=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject21,function(props){return props.active?1:0;},function(props){return props.active?'.35s':'';},function(props){return props.active?'auto':'none';});var NavSearchInput=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].input(_templateObject22);var ClearCancelSearch=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject23);var Val=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject24,function(props){return props.truncate?'nowrap':'normal';},function(props){return props.truncate?'hidden':'visible';},function(props){return props.visible?1:0;},function(props){return props.visible&&props.justComplete?'.425s':'0s';},function(props){return props.justComplete?'var(--strokepeach)':'var(--fainttext)';},function(props){return props.justComplete?textPeachToBlack:'';},function(props){return props.multiline?'\n        // height: 21px;\n    ':'';});var XCaret=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["a" /* Sprite */])(_templateObject25);var FixWrap=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject26,function(props){return props.mid?'18vh':props.hide?'-75px':0;});var WorkflowWrap=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject27);var PickMenu=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_15__components_ExpandBox__["a" /* default */])(_templateObject28,function(props){return props.workflowScrollOffset?-100:0;});var Header=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_15__components_ExpandBox__["a" /* default */])(_templateObject29);var HeaderContent=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject30,function(props){return props.whitetext?'white':'var(--fainttext)';});var HeaderSection=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject31,function(props){return props.active?1:0;},function(props){return props.active?'.3s':'';});var BarContent=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(HeaderSection)(_templateObject32,function(props){return props.active?0:-25;});var Btn=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(HeaderSection)(_templateObject33,function(props){return props.superwide?215:160;},function(props){return props.active?0:25;});var BarInfo=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject34,function(props){return props.visible?1:0;});var Prompt=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(BarInfo)(_templateObject35,function(props){return props.visible?0:-100;});var Shorthand=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(BarInfo)(_templateObject36,function(props){return props.visible?0:100;});var SearchIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["b" /* default */])(_templateObject37);var IndicatorList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class7=(_class8=function(_React$Component3){_inherits(IndicatorList,_React$Component3);function IndicatorList(){var _ref;var _temp,_this12,_ret;_classCallCheck(this,IndicatorList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this12=_possibleConstructorReturn(this,(_ref=IndicatorList.__proto__||Object.getPrototypeOf(IndicatorList)).call.apply(_ref,[this].concat(args))),_this12),_initDefineProp(_this12,'filter',_descriptor15,_this12),_initDefineProp(_this12,'setFilter',_descriptor16,_this12),_temp),_possibleConstructorReturn(_this12,_ret);}_createClass(IndicatorList,[{key:'render',value:function render(){var _this13=this;var store=this.props.store;var race=store.race,year=store.year,county=store.county;var inds=store.indicatorSearchString?store.indicatorSearchResults:Object.keys(__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */]);var numHealth=0;var numEd=0;var numWelf=0;var numEC=0;inds.forEach(function(ind,i,arr){if(__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].categories.includes('health'))numHealth++;if(__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].categories.includes('education'))numEd++;if(__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].categories.includes('welfare'))numWelf++;if(__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].categories.includes('earlyChildhood'))numEC++;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndCats,{onChange:function onChange(e){return _this13.setFilter(e.target.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'all'},' All topics (',inds.length,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'health'},' Health (',numHealth,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'education'},' Education (',numEd,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'welfare'},' Child Welfare (',numWelf,')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'earlyChildhood'},' Early Childhood (',numEC,')'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkflowList,null,inds.filter(function(ind){if(_this13.filter==='all')return true;else return __WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].categories.includes(_this13.filter);}).map(function(ind){var v=__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].counties[county||'california'];var needsRaceHasRace=race&&__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].categories.includes('hasRace')||!race;var invalid=!needsRaceHasRace?true:v[race||'totals'][year]==='*'||v[race||'totals'][year]==='';var sem=__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][ind].semantics;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListRow,{className:store.indicator===ind?'selected':invalid?'invalid':'',key:ind,onClick:function onClick(){var isNewVal=ind!==store.indicator;var completion=store.completeWorkflow('indicator',ind);if(!completion){if(window.confirm(store.sanityCheck.message)){store.sanityCheck.action();_this13.props.onComplete('indicator',true);}}else _this13.props.onComplete('indicator',isNewVal);}},sem.label);})));}}]);return IndicatorList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor15=_applyDecoratedDescriptor(_class8.prototype,'filter',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return'all';}}),_descriptor16=_applyDecoratedDescriptor(_class8.prototype,'setFilter',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this14=this;return function(v){console.log('filter set to ',_this14.filter);_this14.filter=v;};}})),_class8))||_class7;var FadeInWorkflow=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* keyframes */])(_templateObject38);var WorkflowList=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].ul(_templateObject39);var ListRow=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].li(_templateObject40);var IndCats=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].select(_templateObject41);var SelectWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject42);var RaceList=function RaceList(props){var races=['asian','black','latinx','white','other'];var store=props.store;var indicator=store.indicator,county=store.county,year=store.year;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkflowList,{className:'notIndicator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpecialRow,{className:!store.race?'selected':'',onClick:function onClick(){store.completeWorkflow('race','');props.onComplete('race');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'All races'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemInfo,null,Object(__WEBPACK_IMPORTED_MODULE_12__utilities_sigFig__["c" /* truncateNum */])(__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a[store.county||'california'].population),' children in ',store.county?'county':'CA')),races.map(function(r){var popPct=__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a[store.county||'california'][r];var ind=!indicator?'':__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][indicator];var invalid=!indicator?false:!ind.categories.includes('hasRace')||ind.counties[county||'california'][r][year]==='*'||ind.counties[county||'california'][r][year]==='';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListRow,{key:r,className:store.race===r?'selected':invalid?'invalid':'',onClick:function onClick(){var isNewVal=r!==store.race;var completion=store.completeWorkflow('race',r);if(completion)props.onComplete('race',isNewVal);else if(window.confirm(store.sanityCheck.message)){store.sanityCheck.action();props.onComplete('race',true);}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,r!=='other'&&Object(__WEBPACK_IMPORTED_MODULE_11__utilities_toLowerCase__["b" /* capitalize */])(r),r==='other'&&'Other races'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemInfo,null,popPct,'% of',!store.county&&' CA\'s children',store.county&&' county\'s kids'));}));};var CountyList=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class10=function(_React$Component4){_inherits(CountyList,_React$Component4);function CountyList(){_classCallCheck(this,CountyList);return _possibleConstructorReturn(this,(CountyList.__proto__||Object.getPrototypeOf(CountyList)).apply(this,arguments));}_createClass(CountyList,[{key:'render',value:function render(){var props=this.props;var store=props.store;var indicator=store.indicator,race=store.race,year=store.year;var cties=store.countySearchString?store.countySearchResults:Object.keys(__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkflowList,{className:'notIndicator'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpecialRow,{className:!store.county?'selected':'',onClick:function onClick(){store.completeWorkflow('county','');props.onComplete('county');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'California '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemInfo,null,Object(__WEBPACK_IMPORTED_MODULE_12__utilities_sigFig__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a.california.population),' children')),cties.sort(function(a,b){if(a<b)return-1;else if(a>b)return 1;else return 0;}).map(function(cty){var v=!indicator?'':__WEBPACK_IMPORTED_MODULE_7__data_indicators__["a" /* default */][indicator].counties[cty][race||'totals'][year];var invalid=!indicator?false:v==='*'||v==='';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListRow,{key:cty,className:store.county===cty?'selected':invalid?'invalid':'',onClick:function onClick(){var isNewVal=cty!==store.county;var completion=store.completeWorkflow('county',cty);if(completion)props.onComplete('county',isNewVal);else if(window.confirm(store.sanityCheck.message)){if(store.sanityCheck.action){store.sanityCheck.action();props.onComplete('county',true);}}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_9__assets_countyLabels___default.a[cty]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemInfo,null,Object(__WEBPACK_IMPORTED_MODULE_12__utilities_sigFig__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__data_demographicsAndPopulation___default.a[cty].population),' children'));}));}}]);return CountyList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component))||_class10;var SpecialRow=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(ListRow)(_templateObject43);var ItemInfo=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject44);var HeaderBtnIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_13__components_generic_Icon__["b" /* default */])(_templateObject45);var CollapseHeaderIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(HeaderBtnIcon)(_templateObject46);var SaveHeaderIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(HeaderBtnIcon)(_templateObject47);var IndExpandBox=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_15__components_ExpandBox__["a" /* default */])(_templateObject48,function(props){return props.justComplete?'var(--faintestpeach)':'transparent';},function(props){return props.justComplete?peachBGAnim:'';});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExpandBox__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generic_Icon__ = __webpack_require__(13);
var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    right: 15px; top: 20px;\n    transform: translate(0px, ','px);\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    z-index: 20;\n    pointer-events: ',';\n'],['\n    position: absolute;\n    right: 15px; top: 20px;\n    transform: translate(0px, ','px);\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n    z-index: 20;\n    pointer-events: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; \n    width: 48px; height: 100px;\n    display: flex; flex-direction: column;\n    justify-content: center; align-items: center;\n    transform: translateY(','px);\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n'],['\n    position: absolute;\n    top: 0; \n    width: 48px; height: 100px;\n    display: flex; flex-direction: column;\n    justify-content: center; align-items: center;\n    transform: translateY(','px);\n    transition: transform .35s cubic-bezier(0.215, 0.61, 0.355, 1);\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: 45px;\n    display: flex;\n    align-items: center;\n    &:first-of-type{\n        border-bottom: 1px solid ',';\n    }\n'],['\n    height: 45px;\n    display: flex;\n    align-items: center;\n    &:first-of-type{\n        border-bottom: 1px solid ',';\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    width: 18px; height: 18px;\n'],['\n    width: 18px; height: 18px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FixedActionsHelper=function FixedActionsHelper(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fah,{currentMode:props.mode,modes:{collapsed:{width:48,height:5},expanded:{width:48,height:100},xOnly:{width:48,height:48}},borderColor:props.mode==='collapsed'?'transparent':'var(--fainttext)',backgroundColor:props.mode==='collapsed'?'transparent':'white',offsetFromTop:props.offsetFromTop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icons,{mode:props.mode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Btn,{mode:props.mode,onClick:props.onX},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(XIcon,{img:'x_thin',color:'normtext'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Btn,{mode:props.mode,onClick:props.onSearch},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SearchIcon,{img:'searchzoom',color:props.mode==='searching'?'fainttext':'normtext'}))));};var Fah=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__ExpandBox__["a" /* default */])(_templateObject,function(props){return props.offsetFromTop;},function(props){return props.currentMode==='collapsed'?'none':'auto';});var Icons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.mode==='searching'?-50:props.mode==='xOnly'?-2:0;});var Btn=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.mode==='xOnly'?'transparent':'var(--bordergrey)';});var XIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3__generic_Icon__["b" /* default */])(_templateObject4);var SearchIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3__generic_Icon__["b" /* default */])(_templateObject4);/* harmony default export */ __webpack_exports__["a"] = (FixedActionsHelper);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZoomableMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_media__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExpandBox__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InteractiveMap__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Legend__ = __webpack_require__(57);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_desc,_value,_class2,_descriptor,_descriptor2,_descriptor3,_descriptor4;var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    // left: -2px;\n    left: -1px;\n\n\n'],['\n    position: absolute;\n    // left: -2px;\n    left: -1px;\n\n\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0; left: 0;\n    background-image: url(',');\n    width: 100%;\n    height: 100vh;\n    background-size: 20px;\n    background-position: 17px 17px;\n    @media ','{\n        background-position: 8px 10px;\n    }\n'],['\n    position: absolute;\n    top: 0; left: 0;\n    background-image: url(',');\n    width: 100%;\n    height: 100vh;\n    background-size: 20px;\n    background-position: 17px 17px;\n    @media ','{\n        background-position: 8px 10px;\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: absolute;\n    width: ','px;\n    height: ','px;\n    transform-origin: 50% 50%;\n    transition: transform .5s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate(','px, ','px) scale(',');\n    z-index: 2;\n'],['\n    position: absolute;\n    width: ','px;\n    height: ','px;\n    transform-origin: 50% 50%;\n    transition: transform .5s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate(','px, ','px) scale(',');\n    z-index: 2;\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: none;\n    position: absolute;\n    color: var(--fainttext);\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    left: 37px; \n    bottom: 15px;\n'],['\n    display: none;\n    position: absolute;\n    color: var(--fainttext);\n    font-size: 12px;\n    letter-spacing: 0.5px;\n    left: 37px; \n    bottom: 15px;\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 35px; right: 45px;\n    transition: transform .5s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate(',');\n    \n    @media ','{\n        right: 26px;\n        top: 32px;\n    }\n    /*width: 120px;*/\n    /*height: 140px;*/\n    /*border: 1px solid var(--bordergrey);*/\n'],['\n    position: absolute;\n    top: 35px; right: 45px;\n    transition: transform .5s cubic-bezier(0.215, 0.61, 0.355, 1);\n    transform: translate(',');\n    \n    @media ','{\n        right: 26px;\n        top: 32px;\n    }\n    /*width: 120px;*/\n    /*height: 140px;*/\n    /*border: 1px solid var(--bordergrey);*/\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var ZoomableMap=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["a" /* observer */])(_class=(_class2=function(_React$Component){_inherits(ZoomableMap,_React$Component);function ZoomableMap(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ZoomableMap);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ZoomableMap.__proto__||Object.getPrototypeOf(ZoomableMap)).call.apply(_ref,[this].concat(args))),_this),_initDefineProp(_this,'zoomLevel',_descriptor,_this),_initDefineProp(_this,'setZoom',_descriptor2,_this),_initDefineProp(_this,'containerTranslation',_descriptor3,_this),_initDefineProp(_this,'translateContainer',_descriptor4,_this),_this.calcTransform=function(zoomTo){var store=_this.props.store;console.log('going to zoomTo',zoomTo);if(!zoomTo){_this.setZoom(.875);return{x:0,y:0};}var map=document.getElementById('svgMap').getBoundingClientRect();var county=document.getElementById(zoomTo).getBoundingClientRect();var countySize=county.width/_this.zoomLevel*(county.height/_this.zoomLevel);var scaleAdjust=countySize<2000?(4000-countySize*2)/2000:countySize>9000?-.3:0;var zoomLevel=1.5+scaleAdjust;var zoomDifferential=(zoomLevel/_this.zoomLevel).toFixed(1);var mapbox={left:map.left*zoomDifferential,top:map.top*zoomDifferential,width:map.width*zoomDifferential,height:map.height*zoomDifferential};var countybox={left:county.left*zoomDifferential,top:county.top*zoomDifferential,width:county.width*zoomDifferential,height:county.height*zoomDifferential//relative
};var countyCenter={x:countybox.left+countybox.width/2,y:countybox.top+countybox.height/2};var deviationFromContainerCenter={x:mapbox.left+mapbox.width/2-countyCenter.x,y:mapbox.top+mapbox.height/2-countyCenter.y};_this.setZoom(zoomLevel);console.log(deviationFromContainerCenter.y);return{x:deviationFromContainerCenter.x,y:deviationFromContainerCenter.y-store.mobileDeviceWidth*.75/3};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ZoomableMap,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.zoomTo){console.log('map mounting with zoom:',this.props.zoomTo);this.translateContainer(this.calcTransform(this.props.zoomTo));}else{console.log('map mounting unzoomed');}}},{key:'componentWillUpdate',value:function componentWillUpdate(newProps){if(newProps.zoomTo!==this.props.zoomTo){if(!newProps.zoomTo){console.log('map updated: unzooming');this.translateContainer(this.calcTransform());}else{console.log('map updated: zooming to',newProps.zoomTo);this.translateContainer(this.calcTransform(newProps.zoomTo));}}}},{key:'render',value:function render(){var props=this.props;var store=props.store;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container// zooming = {props.zoomTo}
,{currentMode:props.zoomTo?'zoomed':'tall',modes:{tall:{width:store.mobileDeviceWidth-1,height:store.mobileDeviceWidth*1.15},zoomed:{width:store.mobileDeviceWidth-1,height:store.mobileDeviceWidth*.75}}// borderColor = 'red'
,duration:.5,dontAlignContentsToCenter:true// noSideBorders
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DotGrid,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LegendContainer,{currentMode:!props.zoomTo?'expanded':'collapsed',modes:{collapsed:{width:10,height:10},expanded:{width:119,height:140}},backgroundColor:'var(--offwhitefg)',duration:.5,offset:!props.store.county&&!props.zoomTo?'-109px, -8px':!props.zoomTo?'-109px, 0':'0, -50px'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Legend__["a" /* default */],{store:props.store})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransformWrapper,{offset:this.containerTranslation,zoom:this.zoomLevel,devicewidth:store.mobileDeviceWidth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InteractiveMap__["a" /* default */],{garbMask:!props.zoomTo,data:props.data,store:props.store,hoveredCounty:props.zoomTo,selected:!props.zoomTo&&props.store.county?props.store.county:'',onSelect:function onSelect(a,b){props.unforceCA();props.store.completeWorkflow(a,b);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TipText,null,!props.zoomTo&&!props.store.county&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'Tap a county to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'view its demographics.'),props.store.county&&!props.zoomTo&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,'Select \'county\' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'below to zoom back in.')));}}]);return ZoomableMap;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),(_descriptor=_applyDecoratedDescriptor(_class2.prototype,'zoomLevel',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return .875;}}),_descriptor2=_applyDecoratedDescriptor(_class2.prototype,'setZoom',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return function(val){return _this2.zoomLevel=val;};}}),_descriptor3=_applyDecoratedDescriptor(_class2.prototype,'containerTranslation',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{x:0,y:0};}}),_descriptor4=_applyDecoratedDescriptor(_class2.prototype,'translateContainer',[__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(coords){// console.log('translating container: ', coords)
_this3.containerTranslation.x=coords.x;_this3.containerTranslation.y=coords.y;};}})),_class2))||_class;var Container=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5__ExpandBox__["a" /* default */])(_templateObject);var dots=__webpack_require__(29);var DotGrid=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2,dots,__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].smallphone);var TransformWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3,function(p){return p.devicewidth;},function(p){return p.devicewidth*1.15;},function(props){return props.offset.x;},function(props){return props.offset.y;},function(props){return props.zoom;});var TipText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4);var LegendContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5__ExpandBox__["a" /* default */])(_templateObject5,function(props){return props.offset;},__WEBPACK_IMPORTED_MODULE_4__utilities_media__["a" /* default */].smallphone);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory();
	} else {
		window.idleCallbackShim = factory();
	}
}(function(){
	'use strict';
	var scheduleStart, throttleDelay, lazytimer, lazyraf;
	var root = typeof window != 'undefined' ?
		window :
		typeof global != undefined ?
			global :
			this || {};
	var requestAnimationFrame = root.cancelRequestAnimationFrame && root.requestAnimationFrame || setTimeout;
	var cancelRequestAnimationFrame = root.cancelRequestAnimationFrame || clearTimeout;
	var tasks = [];
	var runAttempts = 0;
	var isRunning = false;
	var remainingTime = 7;
	var minThrottle = 35;
	var throttle = 125;
	var index = 0;
	var taskStart = 0;
	var tasklength = 0;
	var IdleDeadline = {
		get didTimeout(){
			return false;
		},
		timeRemaining: function(){
			var timeRemaining = remainingTime - (Date.now() - taskStart);
			return timeRemaining < 0 ? 0 : timeRemaining;
		},
	};
	var setInactive = debounce(function(){
		remainingTime = 22;
		throttle = 66;
		minThrottle = 0;
	});

	function debounce(fn){
		var id, timestamp;
		var wait = 99;
		var check = function(){
			var last = (Date.now()) - timestamp;

			if (last < wait) {
				id = setTimeout(check, wait - last);
			} else {
				id = null;
				fn();
			}
		};
		return function(){
			timestamp = Date.now();
			if(!id){
				id = setTimeout(check, wait);
			}
		};
	}

	function abortRunning(){
		if(isRunning){
			if(lazyraf){
				cancelRequestAnimationFrame(lazyraf);
			}
			if(lazytimer){
				clearTimeout(lazytimer);
			}
			isRunning = false;
		}
	}

	function onInputorMutation(){
		if(throttle != 125){
			remainingTime = 7;
			throttle = 125;
			minThrottle = 35;

			if(isRunning) {
				abortRunning();
				scheduleLazy();
			}
		}
		setInactive();
	}

	function scheduleAfterRaf() {
		lazyraf = null;
		lazytimer = setTimeout(runTasks, 0);
	}

	function scheduleRaf(){
		lazytimer = null;
		requestAnimationFrame(scheduleAfterRaf);
	}

	function scheduleLazy(){

		if(isRunning){return;}
		throttleDelay = throttle - (Date.now() - taskStart);

		scheduleStart = Date.now();

		isRunning = true;

		if(minThrottle && throttleDelay < minThrottle){
			throttleDelay = minThrottle;
		}

		if(throttleDelay > 9){
			lazytimer = setTimeout(scheduleRaf, throttleDelay);
		} else {
			throttleDelay = 0;
			scheduleRaf();
		}
	}

	function runTasks(){
		var task, i, len;
		var timeThreshold = remainingTime > 9 ?
			9 :
			1
		;

		taskStart = Date.now();
		isRunning = false;

		lazytimer = null;

		if(runAttempts > 2 || taskStart - throttleDelay - 50 < scheduleStart){
			for(i = 0, len = tasks.length; i < len && IdleDeadline.timeRemaining() > timeThreshold; i++){
				task = tasks.shift();
				tasklength++;
				if(task){
					task(IdleDeadline);
				}
			}
		}

		if(tasks.length){
			scheduleLazy();
		} else {
			runAttempts = 0;
		}
	}

	function requestIdleCallbackShim(task){
		index++;
		tasks.push(task);
		scheduleLazy();
		return index;
	}

	function cancelIdleCallbackShim(id){
		var index = id - 1 - tasklength;
		if(tasks[index]){
			tasks[index] = null;
		}
	}

	if(!root.requestIdleCallback || !root.cancelIdleCallback){
		root.requestIdleCallback = requestIdleCallbackShim;
		root.cancelIdleCallback = cancelIdleCallbackShim;

		if(root.document && document.addEventListener){
			root.addEventListener('scroll', onInputorMutation, true);
			root.addEventListener('resize', onInputorMutation);

			document.addEventListener('focus', onInputorMutation, true);
			document.addEventListener('mouseover', onInputorMutation, true);
			['click', 'keypress', 'touchstart', 'mousedown'].forEach(function(name){
				document.addEventListener(name, onInputorMutation, {capture: true, passive: true});
			});

			if(root.MutationObserver){
				new MutationObserver( onInputorMutation ).observe( document.documentElement, {childList: true, subtree: true, attributes: true} );
			}
		}
	} else {
		try{
			root.requestIdleCallback(function(){}, {timeout: 0});
		} catch(e){
			(function(rIC){
				var timeRemainingProto, timeRemaining;
				root.requestIdleCallback = function(fn, timeout){
					if(timeout && typeof timeout.timeout == 'number'){
						return rIC(fn, timeout.timeout);
					}
					return rIC(fn);
				};
				if(root.IdleCallbackDeadline && (timeRemainingProto = IdleCallbackDeadline.prototype)){
					timeRemaining = Object.getOwnPropertyDescriptor(timeRemainingProto, 'timeRemaining');
					if(!timeRemaining || !timeRemaining.configurable || !timeRemaining.get){return;}
					Object.defineProperty(timeRemainingProto, 'timeRemaining', {
						value:  function(){
							return timeRemaining.get.call(this);
						},
						enumerable: true,
						configurable: true,
					});
				}
			})(root.requestIdleCallback)
		}
	}

	return {
		request: requestIdleCallbackShim,
		cancel: cancelIdleCallbackShim,
	};
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pdfManifest={alameda:'https://www.dropbox.com/s/dvn377lr71b9y4j/Alameda%20County.pdf?dl=1',alpine:'https://www.dropbox.com/s/6tw96ov6v8eiy6c/Alpine%20County.pdf?dl=1',amador:'https://www.dropbox.com/s/ixlcpnqherszuqv/Amador%20County.pdf?dl=1',butte:'https://www.dropbox.com/s/26357owl7ssqmak/Butte%20County.pdf?dl=1',calaveras:'https://www.dropbox.com/s/d0h8tj3l6nsk616/Calaveras%20County.pdf?dl=1',california:'https://www.dropbox.com/s/gn1efzdp4s3sqow/California.pdf?dl=1',colusa:'https://www.dropbox.com/s/7qpjb11mn9lb5hi/Colusa%20County.pdf?dl=1',contraCosta:'https://www.dropbox.com/s/cxqc0luchkx8o12/Contra%20Costa%20County.pdf?dl=1',delNorte:'https://www.dropbox.com/s/4nuvod0drmptdpj/Del%20Norte%20County.pdf?dl=1',elDorado:'https://www.dropbox.com/s/renglmud315crzn/El%20Dorado%20County.pdf?dl=1',fresno:'https://www.dropbox.com/s/25t7fsb707w6sbd/Fresno%20County.pdf?dl=1',glenn:'https://www.dropbox.com/s/ziaa91ag8udwp0i/Glenn%20County.pdf?dl=1',humboldt:'https://www.dropbox.com/s/tllmdpwbw622m55/Humboldt%20County.pdf?dl=1',imperial:'https://www.dropbox.com/s/irokkgzhkdozhjw/Imperial%20County.pdf?dl=1',inyo:'https://www.dropbox.com/s/rtwsqkbafmlpfvw/Inyo%20County.pdf?dl=1',kern:'https://www.dropbox.com/s/4scb3mvaxei9i29/Kern%20County.pdf?dl=1',kings:'https://www.dropbox.com/s/8ln7hgpetnlvbxx/Kings%20County.pdf?dl=1',lake:'https://www.dropbox.com/s/cgdbd1m4503122v/Lake%20County.pdf?dl=1',lassen:'https://www.dropbox.com/s/c7z9vsr5hxwla8q/Lassen%20County.pdf?dl=1',losAngeles:'https://www.dropbox.com/s/tqfdi7njxbb7504/Los%20Angeles%20County.pdf?dl=1',madera:'https://www.dropbox.com/s/mi3eo6sx35542m8/Madera%20County.pdf?dl=1',marin:'https://www.dropbox.com/s/zgaswfrhaz6s9qs/Marin%20County.pdf?dl=1',mariposa:'https://www.dropbox.com/s/ow07fm71r7oxawl/Mariposa%20County.pdf?dl=1',mendocino:'https://www.dropbox.com/s/51ohx8620pdlgbk/Mendocino%20County.pdf?dl=1',merced:'https://www.dropbox.com/s/759g4ihdr0za4f0/Merced%20County.pdf?dl=1',modoc:'https://www.dropbox.com/s/ozpmt34b2ehnlw8/Modoc%20County.pdf?dl=1',mono:'https://www.dropbox.com/s/fcjrburxlo186xb/Mono%20County.pdf?dl=1',monterey:'https://www.dropbox.com/s/2cdxfheyrthkgf6/Monterey%20County.pdf?dl=1',napa:'https://www.dropbox.com/s/yvscekep7nvyggo/Napa%20County.pdf?dl=1',nevada:'https://www.dropbox.com/s/587owohb4wznvh5/Nevada%20County.pdf?dl=1',orange:'https://www.dropbox.com/s/95i50fcwg2icynf/Orange%20County.pdf?dl=1',placer:'https://www.dropbox.com/s/639aun6ulj61o1z/Placer%20County.pdf?dl=1',plumas:'https://www.dropbox.com/s/x9wkle3qryrgrs5/Plumas%20County.pdf?dl=1',riverside:'https://www.dropbox.com/s/gw4enaroygylw1p/Riverside%20County.pdf?dl=1',sacramento:'https://www.dropbox.com/s/q0aesbrspsy5j98/Sacramento%20County.pdf?dl=1',sanBenito:'https://www.dropbox.com/s/xsf3im8s7znodmt/San%20Benito%20County.pdf?dl=1',sanBernardino:'https://www.dropbox.com/s/t36wees59w5ya9q/San%20Bernardino%20County.pdf?dl=1',sanDiego:'https://www.dropbox.com/s/odh5adsxcvl5fqj/San%20Diego%20County.pdf?dl=1',sanFrancisco:'https://www.dropbox.com/s/9juyfsiihka7pyj/San%20Francisco%20County.pdf?dl=1',sanJoaquin:'https://www.dropbox.com/s/1qtrja3i874xytp/San%20Joaquin%20County.pdf?dl=1',sanLuisObispo:'https://www.dropbox.com/s/e668w6rqq993qan/San%20Luis%20Obispo%20County.pdf?dl=1',sanMateo:'https://www.dropbox.com/s/x79zvohgemj6u10/San%20Mateo%20County.pdf?dl=1',santaBarbara:'https://www.dropbox.com/s/zrsj5ybcv5id3dt/Santa%20Barbara%20County.pdf?dl=1',santaClara:'https://www.dropbox.com/s/713no675xorn1lx/Santa%20Clara%20County.pdf?dl=1',shasta:'https://www.dropbox.com/s/wzhm1bipfgmbj6q/Shasta%20County.pdf?dl=1',sierra:'https://www.dropbox.com/s/cxdigfvu2zm81rq/Sierra%20County.pdf?dl=1',siskiyou:'https://www.dropbox.com/s/7pwkq109jtcycht/Siskiyou%20County.pdf?dl=1',solano:'https://www.dropbox.com/s/7c4ygfw9xq9o09m/Solano%20County.pdf?dl=1',sonoma:'https://www.dropbox.com/s/yo5aac4o8ltemgi/Sonoma%20County.pdf?dl=1',stanislaus:'https://www.dropbox.com/s/jqh7lajdvgy60ym/Stanislaus%20County.pdf?dl=1',sutter:'https://www.dropbox.com/s/tg5pyup4hmzpvpf/Sutter%20County.pdf?dl=1',tehama:'https://www.dropbox.com/s/wxk1gpjewp0u3fj/Tehama%20County.pdf?dl=1',trinity:'https://www.dropbox.com/s/ybd4gxs0dnixod8/Trinity%20County.pdf?dl=1',tulare:'https://www.dropbox.com/s/eu6orpgmfyx8gc9/Tulare%20County.pdf?dl=1',tuolumne:'https://www.dropbox.com/s/f2d7018eblsmmo0/Tuolumne%20County.pdf?dl=1',ventura:'https://www.dropbox.com/s/n6rji0amwhj1wg0/Ventura%20County.pdf?dl=1',yolo:'https://www.dropbox.com/s/b8vuhj6o31qqz7j/Yolo%20County.pdf?dl=1',yuba:'https://www.dropbox.com/s/usxw3jif69o96ev/Yuba%20County.pdf?dl=1'};/* harmony default export */ __webpack_exports__["a"] = (pdfManifest);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cnlogo-long.648f40ff.svg";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mask2.5c68a9a3.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(17);
var bind = __webpack_require__(22);

var implementation = __webpack_require__(63);
var getPolyfill = __webpack_require__(64);
var polyfill = getPolyfill();
var shim = __webpack_require__(203);

var boundFlat = bind.call(Function.call, polyfill);

define(boundFlat, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundFlat;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES2016 = __webpack_require__(42);
var assign = __webpack_require__(28);

var ES2017 = assign(assign({}, ES2016), {
	ToIndex: function ToIndex(value) {
		if (typeof value === 'undefined') {
			return 0;
		}
		var integerIndex = this.ToInteger(value);
		if (integerIndex < 0) {
			throw new RangeError('index must be >= 0');
		}
		var index = this.ToLength(integerIndex);
		if (!this.SameValueZero(integerIndex, index)) {
			throw new RangeError('index must be >= 0 and < 2 ** 53 - 1');
		}
		return index;
	}
});

delete ES2017.EnumerableOwnNames; // replaced with EnumerableOwnProperties

module.exports = ES2017;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(17);
var getPolyfill = __webpack_require__(64);

module.exports = function shimFlat() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ flat: polyfill },
		{ flat: function () { return Array.prototype.flat !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(17);
var ES = __webpack_require__(65);

var implementation = __webpack_require__(66);
var getPolyfill = __webpack_require__(67);
var polyfill = getPolyfill();
var shim = __webpack_require__(205);

var slice = Array.prototype.slice;

/* eslint-disable no-unused-vars */
var boundIncludesShim = function includes(array, searchElement) {
/* eslint-enable no-unused-vars */
	ES.RequireObjectCoercible(array);
	return polyfill.apply(array, slice.call(arguments, 1));
};
define(boundIncludesShim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundIncludesShim;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(17);
var getPolyfill = __webpack_require__(67);

module.exports = function shimArrayPrototypeIncludes() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ includes: polyfill },
		{ includes: function () { return Array.prototype.includes !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/feedback.6a5929d6.svg";

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.a3b18e93.js